var gT = Object.defineProperty, RT = Object.defineProperties;
var DT = Object.getOwnPropertyDescriptors;
var Wm = Object.getOwnPropertySymbols;
var AT = Object.prototype.hasOwnProperty, TT = Object.prototype.propertyIsEnumerable;
var vo = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), OT = (e) => {
  throw TypeError(e);
};
var Ym = (e, r, t) => r in e ? gT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ke = (e, r) => {
  for (var t in r || (r = {}))
    AT.call(r, t) && Ym(e, t, r[t]);
  if (Wm)
    for (var t of Wm(r))
      TT.call(r, t) && Ym(e, t, r[t]);
  return e;
}, go = (e, r) => RT(e, DT(r));
var Oe = (e, r, t) => new Promise((a, o) => {
  var l = (p) => {
    try {
      u(t.next(p));
    } catch (f) {
      o(f);
    }
  }, c = (p) => {
    try {
      u(t.throw(p));
    } catch (f) {
      o(f);
    }
  }, u = (p) => p.done ? a(p.value) : Promise.resolve(p.value).then(l, c);
  u((t = t.apply(e, r)).next());
}), Oa = function(e, r) {
  this[0] = e, this[1] = r;
}, Qu = (e, r, t) => {
  var a = (c, u, p, f) => {
    try {
      var h = t[c](u), C = (u = h.value) instanceof Oa, E = h.done;
      Promise.resolve(C ? u[0] : u).then((m) => C ? a(c === "return" ? c : "next", u[1] ? { done: m.done, value: m.value } : m, p, f) : p({ value: m, done: E })).catch((m) => a("throw", m, p, f));
    } catch (m) {
      f(m);
    }
  }, o = (c) => l[c] = (u) => new Promise((p, f) => a(c, u, p, f)), l = {};
  return t = t.apply(e, r), l[vo("asyncIterator")] = () => l, o("next"), o("throw"), o("return"), l;
}, Ju = (e) => {
  var r = e[vo("asyncIterator")], t = !1, a, o = {};
  return r == null ? (r = e[vo("iterator")](), a = (l) => o[l] = (c) => r[l](c)) : (r = r.call(e), a = (l) => o[l] = (c) => {
    if (t) {
      if (t = !1, l === "throw") throw c;
      return c;
    }
    return t = !0, {
      done: !1,
      value: new Oa(new Promise((u) => {
        var p = r[l](c);
        p instanceof Object || OT("Object expected"), u(p);
      }), 1)
    };
  }), o[vo("iterator")] = () => o, a("next"), "throw" in r ? a("throw") : o.throw = (l) => {
    throw l;
  }, "return" in r && a("return"), o;
}, Km = (e, r, t) => (r = e[vo("asyncIterator")]) ? r.call(e) : (e = e[vo("iterator")](), r = {}, t = (a, o) => (o = e[a]) && (r[a] = (l) => new Promise((c, u, p) => (l = o.call(e, l), p = l.done, Promise.resolve(l.value).then((f) => c({ value: f, done: p }), u)))), t("next"), t("return"), r);
var Oo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Gs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xm = {}, Rs, Qm;
function Et() {
  if (Qm) return Rs;
  Qm = 1;
  var e = function(r) {
    return r && r.Math === Math && r;
  };
  return Rs = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof Oo == "object" && Oo) || e(typeof Rs == "object" && Rs) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")(), Rs;
}
var e0, Jm;
function yT() {
  return Jm || (Jm = 1, e0 = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), e0;
}
var t0, eE;
function Xt() {
  if (eE) return t0;
  eE = 1;
  var e = typeof document == "object" && document.all;
  return t0 = typeof e == "undefined" && e !== void 0 ? function(r) {
    return typeof r == "function" || r === e;
  } : function(r) {
    return typeof r == "function";
  }, t0;
}
var r0, tE;
function wr() {
  if (tE) return r0;
  tE = 1;
  var e = Xt();
  return r0 = function(r) {
    return typeof r == "object" ? r !== null : e(r);
  }, r0;
}
var n0, rE;
function Fp() {
  if (rE) return n0;
  rE = 1;
  var e = Et(), r = wr(), t = e.document, a = r(t) && r(t.createElement);
  return n0 = function(o) {
    return a ? t.createElement(o) : {};
  }, n0;
}
var i0, nE;
function NT() {
  if (nE) return i0;
  nE = 1;
  var e = Fp(), r = e("span").classList, t = r && r.constructor && r.constructor.prototype;
  return i0 = t === Object.prototype ? void 0 : t, i0;
}
var a0, iE;
function vt() {
  return iE || (iE = 1, a0 = function(e) {
    try {
      return !!e();
    } catch (r) {
      return !0;
    }
  }), a0;
}
var o0, aE;
function W2() {
  if (aE) return o0;
  aE = 1;
  var e = vt();
  return o0 = !e(function() {
    var r = function() {
    }.bind();
    return typeof r != "function" || r.hasOwnProperty("prototype");
  }), o0;
}
var s0, oE;
function It() {
  if (oE) return s0;
  oE = 1;
  var e = W2(), r = Function.prototype, t = r.call, a = e && r.bind.bind(t, t);
  return s0 = e ? a : function(o) {
    return function() {
      return t.apply(o, arguments);
    };
  }, s0;
}
var l0, sE;
function na() {
  if (sE) return l0;
  sE = 1;
  var e = It(), r = e({}.toString), t = e("".slice);
  return l0 = function(a) {
    return t(r(a), 8, -1);
  }, l0;
}
var c0, lE;
function Y2() {
  if (lE) return c0;
  lE = 1;
  var e = It(), r = vt(), t = na(), a = Object, o = e("".split);
  return c0 = r(function() {
    return !a("z").propertyIsEnumerable(0);
  }) ? function(l) {
    return t(l) === "String" ? o(l, "") : a(l);
  } : a, c0;
}
var u0, cE;
function Up() {
  return cE || (cE = 1, u0 = function(e) {
    return e == null;
  }), u0;
}
var f0, uE;
function Ho() {
  if (uE) return f0;
  uE = 1;
  var e = Up(), r = TypeError;
  return f0 = function(t) {
    if (e(t)) throw new r("Can't call method on " + t);
    return t;
  }, f0;
}
var d0, fE;
function Zs() {
  if (fE) return d0;
  fE = 1;
  var e = Y2(), r = Ho();
  return d0 = function(t) {
    return e(r(t));
  }, d0;
}
var p0 = { exports: {} }, h0, dE;
function Pi() {
  return dE || (dE = 1, h0 = !1), h0;
}
var _0, pE;
function xp() {
  if (pE) return _0;
  pE = 1;
  var e = Et(), r = Object.defineProperty;
  return _0 = function(t, a) {
    try {
      r(e, t, { value: a, configurable: !0, writable: !0 });
    } catch (o) {
      e[t] = a;
    }
    return a;
  }, _0;
}
var hE;
function Bp() {
  if (hE) return p0.exports;
  hE = 1;
  var e = Pi(), r = Et(), t = xp(), a = "__core-js_shared__", o = p0.exports = r[a] || t(a, {});
  return (o.versions || (o.versions = [])).push({
    version: "3.45.0",
    mode: e ? "pure" : "global",
    copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.45.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), p0.exports;
}
var m0, _E;
function $p() {
  if (_E) return m0;
  _E = 1;
  var e = Bp();
  return m0 = function(r, t) {
    return e[r] || (e[r] = t || {});
  }, m0;
}
var E0, mE;
function Tn() {
  if (mE) return E0;
  mE = 1;
  var e = Ho(), r = Object;
  return E0 = function(t) {
    return r(e(t));
  }, E0;
}
var C0, EE;
function Hr() {
  if (EE) return C0;
  EE = 1;
  var e = It(), r = Tn(), t = e({}.hasOwnProperty);
  return C0 = Object.hasOwn || function(o, l) {
    return t(r(o), l);
  }, C0;
}
var S0, CE;
function Gp() {
  if (CE) return S0;
  CE = 1;
  var e = It(), r = 0, t = Math.random(), a = e(1.1.toString);
  return S0 = function(o) {
    return "Symbol(" + (o === void 0 ? "" : o) + ")_" + a(++r + t, 36);
  }, S0;
}
var I0, SE;
function js() {
  if (SE) return I0;
  SE = 1;
  var e = Et(), r = e.navigator, t = r && r.userAgent;
  return I0 = t ? String(t) : "", I0;
}
var v0, IE;
function K2() {
  if (IE) return v0;
  IE = 1;
  var e = Et(), r = js(), t = e.process, a = e.Deno, o = t && t.versions || a && a.version, l = o && o.v8, c, u;
  return l && (c = l.split("."), u = c[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !u && r && (c = r.match(/Edge\/(\d+)/), (!c || c[1] >= 74) && (c = r.match(/Chrome\/(\d+)/), c && (u = +c[1]))), v0 = u, v0;
}
var g0, vE;
function Zp() {
  if (vE) return g0;
  vE = 1;
  var e = K2(), r = vt(), t = Et(), a = t.String;
  return g0 = !!Object.getOwnPropertySymbols && !r(function() {
    var o = Symbol("symbol detection");
    return !a(o) || !(Object(o) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), g0;
}
var R0, gE;
function Ug() {
  if (gE) return R0;
  gE = 1;
  var e = Zp();
  return R0 = e && !Symbol.sham && typeof Symbol.iterator == "symbol", R0;
}
var D0, RE;
function cr() {
  if (RE) return D0;
  RE = 1;
  var e = Et(), r = $p(), t = Hr(), a = Gp(), o = Zp(), l = Ug(), c = e.Symbol, u = r("wks"), p = l ? c.for || c : c && c.withoutSetter || a;
  return D0 = function(f) {
    return t(u, f) || (u[f] = o && t(c, f) ? c[f] : p("Symbol." + f)), u[f];
  }, D0;
}
var A0, DE;
function ar() {
  if (DE) return A0;
  DE = 1;
  var e = wr(), r = String, t = TypeError;
  return A0 = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not an object");
  }, A0;
}
var T0 = {}, O0, AE;
function jt() {
  if (AE) return O0;
  AE = 1;
  var e = vt();
  return O0 = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), O0;
}
var y0, TE;
function xg() {
  if (TE) return y0;
  TE = 1;
  var e = jt(), r = vt();
  return y0 = e && r(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), y0;
}
var N0 = {}, L0, OE;
function Bg() {
  if (OE) return L0;
  OE = 1;
  var e = jt(), r = vt(), t = Fp();
  return L0 = !e && !r(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), L0;
}
var M0, yE;
function Mt() {
  if (yE) return M0;
  yE = 1;
  var e = W2(), r = Function.prototype.call;
  return M0 = e ? r.bind(r) : function() {
    return r.apply(r, arguments);
  }, M0;
}
var P0, NE;
function ia() {
  if (NE) return P0;
  NE = 1;
  var e = Et(), r = Xt(), t = function(a) {
    return r(a) ? a : void 0;
  };
  return P0 = function(a, o) {
    return arguments.length < 2 ? t(e[a]) : e[a] && e[a][o];
  }, P0;
}
var b0, LE;
function ka() {
  if (LE) return b0;
  LE = 1;
  var e = It();
  return b0 = e({}.isPrototypeOf), b0;
}
var w0, ME;
function X2() {
  if (ME) return w0;
  ME = 1;
  var e = ia(), r = Xt(), t = ka(), a = Ug(), o = Object;
  return w0 = a ? function(l) {
    return typeof l == "symbol";
  } : function(l) {
    var c = e("Symbol");
    return r(c) && t(c.prototype, o(l));
  }, w0;
}
var H0, PE;
function Vo() {
  if (PE) return H0;
  PE = 1;
  var e = String;
  return H0 = function(r) {
    try {
      return e(r);
    } catch (t) {
      return "Object";
    }
  }, H0;
}
var V0, bE;
function Qr() {
  if (bE) return V0;
  bE = 1;
  var e = Xt(), r = Vo(), t = TypeError;
  return V0 = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not a function");
  }, V0;
}
var k0, wE;
function zs() {
  if (wE) return k0;
  wE = 1;
  var e = Qr(), r = Up();
  return k0 = function(t, a) {
    var o = t[a];
    return r(o) ? void 0 : e(o);
  }, k0;
}
var F0, HE;
function LT() {
  if (HE) return F0;
  HE = 1;
  var e = Mt(), r = Xt(), t = wr(), a = TypeError;
  return F0 = function(o, l) {
    var c, u;
    if (l === "string" && r(c = o.toString) && !t(u = e(c, o)) || r(c = o.valueOf) && !t(u = e(c, o)) || l !== "string" && r(c = o.toString) && !t(u = e(c, o))) return u;
    throw new a("Can't convert object to primitive value");
  }, F0;
}
var U0, VE;
function $g() {
  if (VE) return U0;
  VE = 1;
  var e = Mt(), r = wr(), t = X2(), a = zs(), o = LT(), l = cr(), c = TypeError, u = l("toPrimitive");
  return U0 = function(p, f) {
    if (!r(p) || t(p)) return p;
    var h = a(p, u), C;
    if (h) {
      if (f === void 0 && (f = "default"), C = e(h, p, f), !r(C) || t(C)) return C;
      throw new c("Can't convert object to primitive value");
    }
    return f === void 0 && (f = "number"), o(p, f);
  }, U0;
}
var x0, kE;
function jp() {
  if (kE) return x0;
  kE = 1;
  var e = $g(), r = X2();
  return x0 = function(t) {
    var a = e(t, "string");
    return r(a) ? a : a + "";
  }, x0;
}
var FE;
function Gn() {
  if (FE) return N0;
  FE = 1;
  var e = jt(), r = Bg(), t = xg(), a = ar(), o = jp(), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor, p = "enumerable", f = "configurable", h = "writable";
  return N0.f = e ? t ? function(E, m, S) {
    if (a(E), m = o(m), a(S), typeof E == "function" && m === "prototype" && "value" in S && h in S && !S[h]) {
      var v = u(E, m);
      v && v[h] && (E[m] = S.value, S = {
        configurable: f in S ? S[f] : v[f],
        enumerable: p in S ? S[p] : v[p],
        writable: !1
      });
    }
    return c(E, m, S);
  } : c : function(E, m, S) {
    if (a(E), m = o(m), a(S), r) try {
      return c(E, m, S);
    } catch (v) {
    }
    if ("get" in S || "set" in S) throw new l("Accessors not supported");
    return "value" in S && (E[m] = S.value), E;
  }, N0;
}
var B0, UE;
function MT() {
  if (UE) return B0;
  UE = 1;
  var e = Math.ceil, r = Math.floor;
  return B0 = Math.trunc || function(a) {
    var o = +a;
    return (o > 0 ? r : e)(o);
  }, B0;
}
var $0, xE;
function fi() {
  if (xE) return $0;
  xE = 1;
  var e = MT();
  return $0 = function(r) {
    var t = +r;
    return t !== t || t === 0 ? 0 : e(t);
  }, $0;
}
var G0, BE;
function Q2() {
  if (BE) return G0;
  BE = 1;
  var e = fi(), r = Math.max, t = Math.min;
  return G0 = function(a, o) {
    var l = e(a);
    return l < 0 ? r(l + o, 0) : t(l, o);
  }, G0;
}
var Z0, $E;
function ko() {
  if ($E) return Z0;
  $E = 1;
  var e = fi(), r = Math.min;
  return Z0 = function(t) {
    var a = e(t);
    return a > 0 ? r(a, 9007199254740991) : 0;
  }, Z0;
}
var j0, GE;
function Jr() {
  if (GE) return j0;
  GE = 1;
  var e = ko();
  return j0 = function(r) {
    return e(r.length);
  }, j0;
}
var z0, ZE;
function PT() {
  if (ZE) return z0;
  ZE = 1;
  var e = Zs(), r = Q2(), t = Jr(), a = function(o) {
    return function(l, c, u) {
      var p = e(l), f = t(p);
      if (f === 0) return !o && -1;
      var h = r(u, f), C;
      if (o && c !== c) {
        for (; f > h; )
          if (C = p[h++], C !== C) return !0;
      } else for (; f > h; h++)
        if ((o || h in p) && p[h] === c) return o || h || 0;
      return !o && -1;
    };
  };
  return z0 = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: a(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: a(!1)
  }, z0;
}
var q0, jE;
function zp() {
  return jE || (jE = 1, q0 = {}), q0;
}
var W0, zE;
function Gg() {
  if (zE) return W0;
  zE = 1;
  var e = It(), r = Hr(), t = Zs(), a = PT().indexOf, o = zp(), l = e([].push);
  return W0 = function(c, u) {
    var p = t(c), f = 0, h = [], C;
    for (C in p) !r(o, C) && r(p, C) && l(h, C);
    for (; u.length > f; ) r(p, C = u[f++]) && (~a(h, C) || l(h, C));
    return h;
  }, W0;
}
var Y0, qE;
function qp() {
  return qE || (qE = 1, Y0 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), Y0;
}
var K0, WE;
function Zg() {
  if (WE) return K0;
  WE = 1;
  var e = Gg(), r = qp();
  return K0 = Object.keys || function(a) {
    return e(a, r);
  }, K0;
}
var YE;
function bT() {
  if (YE) return T0;
  YE = 1;
  var e = jt(), r = xg(), t = Gn(), a = ar(), o = Zs(), l = Zg();
  return T0.f = e && !r ? Object.defineProperties : function(u, p) {
    a(u);
    for (var f = o(p), h = l(p), C = h.length, E = 0, m; C > E; ) t.f(u, m = h[E++], f[m]);
    return u;
  }, T0;
}
var X0, KE;
function wT() {
  if (KE) return X0;
  KE = 1;
  var e = ia();
  return X0 = e("document", "documentElement"), X0;
}
var Q0, XE;
function Wp() {
  if (XE) return Q0;
  XE = 1;
  var e = $p(), r = Gp(), t = e("keys");
  return Q0 = function(a) {
    return t[a] || (t[a] = r(a));
  }, Q0;
}
var J0, QE;
function Fa() {
  if (QE) return J0;
  QE = 1;
  var e = ar(), r = bT(), t = qp(), a = zp(), o = wT(), l = Fp(), c = Wp(), u = ">", p = "<", f = "prototype", h = "script", C = c("IE_PROTO"), E = function() {
  }, m = function(D) {
    return p + h + u + D + p + "/" + h + u;
  }, S = function(D) {
    D.write(m("")), D.close();
    var R = D.parentWindow.Object;
    return D = null, R;
  }, v = function() {
    var D = l("iframe"), R = "java" + h + ":", T;
    return D.style.display = "none", o.appendChild(D), D.src = String(R), T = D.contentWindow.document, T.open(), T.write(m("document.F=Object")), T.close(), T.F;
  }, g, O = function() {
    try {
      g = new ActiveXObject("htmlfile");
    } catch (R) {
    }
    O = typeof document != "undefined" ? document.domain && g ? S(g) : v() : S(g);
    for (var D = t.length; D--; ) delete O[f][t[D]];
    return O();
  };
  return a[C] = !0, J0 = Object.create || function(R, T) {
    var N;
    return R !== null ? (E[f] = e(R), N = new E(), E[f] = null, N[C] = R) : N = O(), T === void 0 ? N : r.f(N, T);
  }, J0;
}
var e3, JE;
function HT() {
  if (JE) return e3;
  JE = 1;
  var e = cr(), r = Fa(), t = Gn().f, a = e("unscopables"), o = Array.prototype;
  return o[a] === void 0 && t(o, a, {
    configurable: !0,
    value: r(null)
  }), e3 = function(l) {
    o[a][l] = !0;
  }, e3;
}
var t3, e4;
function qs() {
  return e4 || (e4 = 1, t3 = {}), t3;
}
var r3, t4;
function VT() {
  if (t4) return r3;
  t4 = 1;
  var e = Et(), r = Xt(), t = e.WeakMap;
  return r3 = r(t) && /native code/.test(String(t)), r3;
}
var n3, r4;
function Ua() {
  return r4 || (r4 = 1, n3 = function(e, r) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: r
    };
  }), n3;
}
var i3, n4;
function On() {
  if (n4) return i3;
  n4 = 1;
  var e = jt(), r = Gn(), t = Ua();
  return i3 = e ? function(a, o, l) {
    return r.f(a, o, t(1, l));
  } : function(a, o, l) {
    return a[o] = l, a;
  }, i3;
}
var a3, i4;
function di() {
  if (i4) return a3;
  i4 = 1;
  var e = VT(), r = Et(), t = wr(), a = On(), o = Hr(), l = Bp(), c = Wp(), u = zp(), p = "Object already initialized", f = r.TypeError, h = r.WeakMap, C, E, m, S = function(D) {
    return m(D) ? E(D) : C(D, {});
  }, v = function(D) {
    return function(R) {
      var T;
      if (!t(R) || (T = E(R)).type !== D)
        throw new f("Incompatible receiver, " + D + " required");
      return T;
    };
  };
  if (e || l.state) {
    var g = l.state || (l.state = new h());
    g.get = g.get, g.has = g.has, g.set = g.set, C = function(D, R) {
      if (g.has(D)) throw new f(p);
      return R.facade = D, g.set(D, R), R;
    }, E = function(D) {
      return g.get(D) || {};
    }, m = function(D) {
      return g.has(D);
    };
  } else {
    var O = c("state");
    u[O] = !0, C = function(D, R) {
      if (o(D, O)) throw new f(p);
      return R.facade = D, a(D, O, R), R;
    }, E = function(D) {
      return o(D, O) ? D[O] : {};
    }, m = function(D) {
      return o(D, O);
    };
  }
  return a3 = {
    set: C,
    get: E,
    has: m,
    enforce: S,
    getterFor: v
  }, a3;
}
var o3 = {}, s3 = {}, a4;
function jg() {
  if (a4) return s3;
  a4 = 1;
  var e = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, t = r && !e.call({ 1: 2 }, 1);
  return s3.f = t ? function(o) {
    var l = r(this, o);
    return !!l && l.enumerable;
  } : e, s3;
}
var o4;
function Yp() {
  if (o4) return o3;
  o4 = 1;
  var e = jt(), r = Mt(), t = jg(), a = Ua(), o = Zs(), l = jp(), c = Hr(), u = Bg(), p = Object.getOwnPropertyDescriptor;
  return o3.f = e ? p : function(h, C) {
    if (h = o(h), C = l(C), u) try {
      return p(h, C);
    } catch (E) {
    }
    if (c(h, C)) return a(!r(t.f, h, C), h[C]);
  }, o3;
}
var l3 = { exports: {} }, c3, s4;
function J2() {
  if (s4) return c3;
  s4 = 1;
  var e = jt(), r = Hr(), t = Function.prototype, a = e && Object.getOwnPropertyDescriptor, o = r(t, "name"), l = o && function() {
  }.name === "something", c = o && (!e || e && a(t, "name").configurable);
  return c3 = {
    EXISTS: o,
    PROPER: l,
    CONFIGURABLE: c
  }, c3;
}
var u3, l4;
function zg() {
  if (l4) return u3;
  l4 = 1;
  var e = It(), r = Xt(), t = Bp(), a = e(Function.toString);
  return r(t.inspectSource) || (t.inspectSource = function(o) {
    return a(o);
  }), u3 = t.inspectSource, u3;
}
var c4;
function qg() {
  if (c4) return l3.exports;
  c4 = 1;
  var e = It(), r = vt(), t = Xt(), a = Hr(), o = jt(), l = J2().CONFIGURABLE, c = zg(), u = di(), p = u.enforce, f = u.get, h = String, C = Object.defineProperty, E = e("".slice), m = e("".replace), S = e([].join), v = o && !r(function() {
    return C(function() {
    }, "length", { value: 8 }).length !== 8;
  }), g = String(String).split("String"), O = l3.exports = function(D, R, T) {
    E(h(R), 0, 7) === "Symbol(" && (R = "[" + m(h(R), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), T && T.getter && (R = "get " + R), T && T.setter && (R = "set " + R), (!a(D, "name") || l && D.name !== R) && (o ? C(D, "name", { value: R, configurable: !0 }) : D.name = R), v && T && a(T, "arity") && D.length !== T.arity && C(D, "length", { value: T.arity });
    try {
      T && a(T, "constructor") && T.constructor ? o && C(D, "prototype", { writable: !1 }) : D.prototype && (D.prototype = void 0);
    } catch (b) {
    }
    var N = p(D);
    return a(N, "source") || (N.source = S(g, typeof R == "string" ? R : "")), D;
  };
  return Function.prototype.toString = O(function() {
    return t(this) && f(this).source || c(this);
  }, "toString"), l3.exports;
}
var f3, u4;
function pi() {
  if (u4) return f3;
  u4 = 1;
  var e = Xt(), r = Gn(), t = qg(), a = xp();
  return f3 = function(o, l, c, u) {
    u || (u = {});
    var p = u.enumerable, f = u.name !== void 0 ? u.name : l;
    if (e(c) && t(c, f, u), u.global)
      p ? o[l] = c : a(l, c);
    else {
      try {
        u.unsafe ? o[l] && (p = !0) : delete o[l];
      } catch (h) {
      }
      p ? o[l] = c : r.f(o, l, {
        value: c,
        enumerable: !1,
        configurable: !u.nonConfigurable,
        writable: !u.nonWritable
      });
    }
    return o;
  }, f3;
}
var d3 = {}, f4;
function Wg() {
  if (f4) return d3;
  f4 = 1;
  var e = Gg(), r = qp(), t = r.concat("length", "prototype");
  return d3.f = Object.getOwnPropertyNames || function(o) {
    return e(o, t);
  }, d3;
}
var p3 = {}, d4;
function Yg() {
  return d4 || (d4 = 1, p3.f = Object.getOwnPropertySymbols), p3;
}
var h3, p4;
function kT() {
  if (p4) return h3;
  p4 = 1;
  var e = ia(), r = It(), t = Wg(), a = Yg(), o = ar(), l = r([].concat);
  return h3 = e("Reflect", "ownKeys") || function(u) {
    var p = t.f(o(u)), f = a.f;
    return f ? l(p, f(u)) : p;
  }, h3;
}
var _3, h4;
function Kp() {
  if (h4) return _3;
  h4 = 1;
  var e = Hr(), r = kT(), t = Yp(), a = Gn();
  return _3 = function(o, l, c) {
    for (var u = r(l), p = a.f, f = t.f, h = 0; h < u.length; h++) {
      var C = u[h];
      !e(o, C) && !(c && e(c, C)) && p(o, C, f(l, C));
    }
  }, _3;
}
var m3, _4;
function FT() {
  if (_4) return m3;
  _4 = 1;
  var e = vt(), r = Xt(), t = /#|\.prototype\./, a = function(p, f) {
    var h = l[o(p)];
    return h === u ? !0 : h === c ? !1 : r(f) ? e(f) : !!f;
  }, o = a.normalize = function(p) {
    return String(p).replace(t, ".").toLowerCase();
  }, l = a.data = {}, c = a.NATIVE = "N", u = a.POLYFILL = "P";
  return m3 = a, m3;
}
var E3, m4;
function zt() {
  if (m4) return E3;
  m4 = 1;
  var e = Et(), r = Yp().f, t = On(), a = pi(), o = xp(), l = Kp(), c = FT();
  return E3 = function(u, p) {
    var f = u.target, h = u.global, C = u.stat, E, m, S, v, g, O;
    if (h ? m = e : C ? m = e[f] || o(f, {}) : m = e[f] && e[f].prototype, m) for (S in p) {
      if (g = p[S], u.dontCallGetSet ? (O = r(m, S), v = O && O.value) : v = m[S], E = c(h ? S : f + (C ? "." : "#") + S, u.forced), !E && v !== void 0) {
        if (typeof g == typeof v) continue;
        l(g, v);
      }
      (u.sham || v && v.sham) && t(g, "sham", !0), a(m, S, g, u);
    }
  }, E3;
}
var C3, E4;
function UT() {
  if (E4) return C3;
  E4 = 1;
  var e = vt();
  return C3 = !e(function() {
    function r() {
    }
    return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
  }), C3;
}
var S3, C4;
function Ws() {
  if (C4) return S3;
  C4 = 1;
  var e = Hr(), r = Xt(), t = Tn(), a = Wp(), o = UT(), l = a("IE_PROTO"), c = Object, u = c.prototype;
  return S3 = o ? c.getPrototypeOf : function(p) {
    var f = t(p);
    if (e(f, l)) return f[l];
    var h = f.constructor;
    return r(h) && f instanceof h ? h.prototype : f instanceof c ? u : null;
  }, S3;
}
var I3, S4;
function ec() {
  if (S4) return I3;
  S4 = 1;
  var e = vt(), r = Xt(), t = wr(), a = Fa(), o = Ws(), l = pi(), c = cr(), u = Pi(), p = c("iterator"), f = !1, h, C, E;
  [].keys && (E = [].keys(), "next" in E ? (C = o(o(E)), C !== Object.prototype && (h = C)) : f = !0);
  var m = !t(h) || e(function() {
    var S = {};
    return h[p].call(S) !== S;
  });
  return m ? h = {} : u && (h = a(h)), r(h[p]) || l(h, p, function() {
    return this;
  }), I3 = {
    IteratorPrototype: h,
    BUGGY_SAFARI_ITERATORS: f
  }, I3;
}
var v3, I4;
function Fo() {
  if (I4) return v3;
  I4 = 1;
  var e = Gn().f, r = Hr(), t = cr(), a = t("toStringTag");
  return v3 = function(o, l, c) {
    o && !c && (o = o.prototype), o && !r(o, a) && e(o, a, { configurable: !0, value: l });
  }, v3;
}
var g3, v4;
function Kg() {
  if (v4) return g3;
  v4 = 1;
  var e = ec().IteratorPrototype, r = Fa(), t = Ua(), a = Fo(), o = qs(), l = function() {
    return this;
  };
  return g3 = function(c, u, p, f) {
    var h = u + " Iterator";
    return c.prototype = r(e, { next: t(+!f, p) }), a(c, h, !1, !0), o[h] = l, c;
  }, g3;
}
var R3, g4;
function Xp() {
  if (g4) return R3;
  g4 = 1;
  var e = It(), r = Qr();
  return R3 = function(t, a, o) {
    try {
      return e(r(Object.getOwnPropertyDescriptor(t, a)[o]));
    } catch (l) {
    }
  }, R3;
}
var D3, R4;
function xT() {
  if (R4) return D3;
  R4 = 1;
  var e = wr();
  return D3 = function(r) {
    return e(r) || r === null;
  }, D3;
}
var A3, D4;
function BT() {
  if (D4) return A3;
  D4 = 1;
  var e = xT(), r = String, t = TypeError;
  return A3 = function(a) {
    if (e(a)) return a;
    throw new t("Can't set " + r(a) + " as a prototype");
  }, A3;
}
var T3, A4;
function Uo() {
  if (A4) return T3;
  A4 = 1;
  var e = Xp(), r = wr(), t = Ho(), a = BT();
  return T3 = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var o = !1, l = {}, c;
    try {
      c = e(Object.prototype, "__proto__", "set"), c(l, []), o = l instanceof Array;
    } catch (u) {
    }
    return function(p, f) {
      return t(p), a(f), r(p) && (o ? c(p, f) : p.__proto__ = f), p;
    };
  }() : void 0), T3;
}
var O3, T4;
function Xg() {
  if (T4) return O3;
  T4 = 1;
  var e = zt(), r = Mt(), t = Pi(), a = J2(), o = Xt(), l = Kg(), c = Ws(), u = Uo(), p = Fo(), f = On(), h = pi(), C = cr(), E = qs(), m = ec(), S = a.PROPER, v = a.CONFIGURABLE, g = m.IteratorPrototype, O = m.BUGGY_SAFARI_ITERATORS, D = C("iterator"), R = "keys", T = "values", N = "entries", b = function() {
    return this;
  };
  return O3 = function(L, k, w, V, U, z, q) {
    l(w, k, V);
    var W = function(ue) {
      if (ue === U && J) return J;
      if (!O && ue && ue in le) return le[ue];
      switch (ue) {
        case R:
          return function() {
            return new w(this, ue);
          };
        case T:
          return function() {
            return new w(this, ue);
          };
        case N:
          return function() {
            return new w(this, ue);
          };
      }
      return function() {
        return new w(this);
      };
    }, te = k + " Iterator", se = !1, le = L.prototype, B = le[D] || le["@@iterator"] || U && le[U], J = !O && B || W(U), Q = k === "Array" && le.entries || B, P, $, ce;
    if (Q && (P = c(Q.call(new L())), P !== Object.prototype && P.next && (!t && c(P) !== g && (u ? u(P, g) : o(P[D]) || h(P, D, b)), p(P, te, !0, !0), t && (E[te] = b))), S && U === T && B && B.name !== T && (!t && v ? f(le, "name", T) : (se = !0, J = function() {
      return r(B, this);
    })), U)
      if ($ = {
        values: W(T),
        keys: z ? J : W(R),
        entries: W(N)
      }, q) for (ce in $)
        (O || se || !(ce in le)) && h(le, ce, $[ce]);
      else e({ target: k, proto: !0, forced: O || se }, $);
    return (!t || q) && le[D] !== J && h(le, D, J, { name: U }), E[k] = J, $;
  }, O3;
}
var y3, O4;
function tc() {
  return O4 || (O4 = 1, y3 = function(e, r) {
    return { value: e, done: r };
  }), y3;
}
var N3, y4;
function Qg() {
  if (y4) return N3;
  y4 = 1;
  var e = Zs(), r = HT(), t = qs(), a = di(), o = Gn().f, l = Xg(), c = tc(), u = Pi(), p = jt(), f = "Array Iterator", h = a.set, C = a.getterFor(f);
  N3 = l(Array, "Array", function(m, S) {
    h(this, {
      type: f,
      target: e(m),
      // target
      index: 0,
      // next index
      kind: S
      // kind
    });
  }, function() {
    var m = C(this), S = m.target, v = m.index++;
    if (!S || v >= S.length)
      return m.target = null, c(void 0, !0);
    switch (m.kind) {
      case "keys":
        return c(v, !1);
      case "values":
        return c(S[v], !1);
    }
    return c([v, S[v]], !1);
  }, "values");
  var E = t.Arguments = t.Array;
  if (r("keys"), r("values"), r("entries"), !u && p && E.name !== "values") try {
    o(E, "name", { value: "values" });
  } catch (m) {
  }
  return N3;
}
var N4;
function $T() {
  if (N4) return Xm;
  N4 = 1;
  var e = Et(), r = yT(), t = NT(), a = Qg(), o = On(), l = Fo(), c = cr(), u = c("iterator"), p = a.values, f = function(C, E) {
    if (C) {
      if (C[u] !== p) try {
        o(C, u, p);
      } catch (S) {
        C[u] = p;
      }
      if (l(C, E, !0), r[E]) {
        for (var m in a)
          if (C[m] !== a[m]) try {
            o(C, m, a[m]);
          } catch (S) {
            C[m] = a[m];
          }
      }
    }
  };
  for (var h in r)
    f(e[h] && e[h].prototype, h);
  return f(t, "DOMTokenList"), Xm;
}
$T();
var L3 = { exports: {} }, Ds = {}, M3 = { exports: {} }, ft = {}, L4;
function GT() {
  if (L4) return ft;
  L4 = 1;
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), C = Symbol.iterator;
  function E(P) {
    return P === null || typeof P != "object" ? null : (P = C && P[C] || P["@@iterator"], typeof P == "function" ? P : null);
  }
  var m = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, S = Object.assign, v = {};
  function g(P, $, ce) {
    this.props = P, this.context = $, this.refs = v, this.updater = ce || m;
  }
  g.prototype.isReactComponent = {}, g.prototype.setState = function(P, $) {
    if (typeof P != "object" && typeof P != "function" && P != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, P, $, "setState");
  }, g.prototype.forceUpdate = function(P) {
    this.updater.enqueueForceUpdate(this, P, "forceUpdate");
  };
  function O() {
  }
  O.prototype = g.prototype;
  function D(P, $, ce) {
    this.props = P, this.context = $, this.refs = v, this.updater = ce || m;
  }
  var R = D.prototype = new O();
  R.constructor = D, S(R, g.prototype), R.isPureReactComponent = !0;
  var T = Array.isArray, N = Object.prototype.hasOwnProperty, b = { current: null }, L = { key: !0, ref: !0, __self: !0, __source: !0 };
  function k(P, $, ce) {
    var ue, ie = {}, Re = null, Ae = null;
    if ($ != null) for (ue in $.ref !== void 0 && (Ae = $.ref), $.key !== void 0 && (Re = "" + $.key), $) N.call($, ue) && !L.hasOwnProperty(ue) && (ie[ue] = $[ue]);
    var Ce = arguments.length - 2;
    if (Ce === 1) ie.children = ce;
    else if (1 < Ce) {
      for (var Le = Array(Ce), Ze = 0; Ze < Ce; Ze++) Le[Ze] = arguments[Ze + 2];
      ie.children = Le;
    }
    if (P && P.defaultProps) for (ue in Ce = P.defaultProps, Ce) ie[ue] === void 0 && (ie[ue] = Ce[ue]);
    return { $$typeof: e, type: P, key: Re, ref: Ae, props: ie, _owner: b.current };
  }
  function w(P, $) {
    return { $$typeof: e, type: P.type, key: $, ref: P.ref, props: P.props, _owner: P._owner };
  }
  function V(P) {
    return typeof P == "object" && P !== null && P.$$typeof === e;
  }
  function U(P) {
    var $ = { "=": "=0", ":": "=2" };
    return "$" + P.replace(/[=:]/g, function(ce) {
      return $[ce];
    });
  }
  var z = /\/+/g;
  function q(P, $) {
    return typeof P == "object" && P !== null && P.key != null ? U("" + P.key) : $.toString(36);
  }
  function W(P, $, ce, ue, ie) {
    var Re = typeof P;
    (Re === "undefined" || Re === "boolean") && (P = null);
    var Ae = !1;
    if (P === null) Ae = !0;
    else switch (Re) {
      case "string":
      case "number":
        Ae = !0;
        break;
      case "object":
        switch (P.$$typeof) {
          case e:
          case r:
            Ae = !0;
        }
    }
    if (Ae) return Ae = P, ie = ie(Ae), P = ue === "" ? "." + q(Ae, 0) : ue, T(ie) ? (ce = "", P != null && (ce = P.replace(z, "$&/") + "/"), W(ie, $, ce, "", function(Ze) {
      return Ze;
    })) : ie != null && (V(ie) && (ie = w(ie, ce + (!ie.key || Ae && Ae.key === ie.key ? "" : ("" + ie.key).replace(z, "$&/") + "/") + P)), $.push(ie)), 1;
    if (Ae = 0, ue = ue === "" ? "." : ue + ":", T(P)) for (var Ce = 0; Ce < P.length; Ce++) {
      Re = P[Ce];
      var Le = ue + q(Re, Ce);
      Ae += W(Re, $, ce, Le, ie);
    }
    else if (Le = E(P), typeof Le == "function") for (P = Le.call(P), Ce = 0; !(Re = P.next()).done; ) Re = Re.value, Le = ue + q(Re, Ce++), Ae += W(Re, $, ce, Le, ie);
    else if (Re === "object") throw $ = String(P), Error("Objects are not valid as a React child (found: " + ($ === "[object Object]" ? "object with keys {" + Object.keys(P).join(", ") + "}" : $) + "). If you meant to render a collection of children, use an array instead.");
    return Ae;
  }
  function te(P, $, ce) {
    if (P == null) return P;
    var ue = [], ie = 0;
    return W(P, ue, "", "", function(Re) {
      return $.call(ce, Re, ie++);
    }), ue;
  }
  function se(P) {
    if (P._status === -1) {
      var $ = P._result;
      $ = $(), $.then(function(ce) {
        (P._status === 0 || P._status === -1) && (P._status = 1, P._result = ce);
      }, function(ce) {
        (P._status === 0 || P._status === -1) && (P._status = 2, P._result = ce);
      }), P._status === -1 && (P._status = 0, P._result = $);
    }
    if (P._status === 1) return P._result.default;
    throw P._result;
  }
  var le = { current: null }, B = { transition: null }, J = { ReactCurrentDispatcher: le, ReactCurrentBatchConfig: B, ReactCurrentOwner: b };
  function Q() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return ft.Children = { map: te, forEach: function(P, $, ce) {
    te(P, function() {
      $.apply(this, arguments);
    }, ce);
  }, count: function(P) {
    var $ = 0;
    return te(P, function() {
      $++;
    }), $;
  }, toArray: function(P) {
    return te(P, function($) {
      return $;
    }) || [];
  }, only: function(P) {
    if (!V(P)) throw Error("React.Children.only expected to receive a single React element child.");
    return P;
  } }, ft.Component = g, ft.Fragment = t, ft.Profiler = o, ft.PureComponent = D, ft.StrictMode = a, ft.Suspense = p, ft.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = J, ft.act = Q, ft.cloneElement = function(P, $, ce) {
    if (P == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + P + ".");
    var ue = S({}, P.props), ie = P.key, Re = P.ref, Ae = P._owner;
    if ($ != null) {
      if ($.ref !== void 0 && (Re = $.ref, Ae = b.current), $.key !== void 0 && (ie = "" + $.key), P.type && P.type.defaultProps) var Ce = P.type.defaultProps;
      for (Le in $) N.call($, Le) && !L.hasOwnProperty(Le) && (ue[Le] = $[Le] === void 0 && Ce !== void 0 ? Ce[Le] : $[Le]);
    }
    var Le = arguments.length - 2;
    if (Le === 1) ue.children = ce;
    else if (1 < Le) {
      Ce = Array(Le);
      for (var Ze = 0; Ze < Le; Ze++) Ce[Ze] = arguments[Ze + 2];
      ue.children = Ce;
    }
    return { $$typeof: e, type: P.type, key: ie, ref: Re, props: ue, _owner: Ae };
  }, ft.createContext = function(P) {
    return P = { $$typeof: c, _currentValue: P, _currentValue2: P, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, P.Provider = { $$typeof: l, _context: P }, P.Consumer = P;
  }, ft.createElement = k, ft.createFactory = function(P) {
    var $ = k.bind(null, P);
    return $.type = P, $;
  }, ft.createRef = function() {
    return { current: null };
  }, ft.forwardRef = function(P) {
    return { $$typeof: u, render: P };
  }, ft.isValidElement = V, ft.lazy = function(P) {
    return { $$typeof: h, _payload: { _status: -1, _result: P }, _init: se };
  }, ft.memo = function(P, $) {
    return { $$typeof: f, type: P, compare: $ === void 0 ? null : $ };
  }, ft.startTransition = function(P) {
    var $ = B.transition;
    B.transition = {};
    try {
      P();
    } finally {
      B.transition = $;
    }
  }, ft.unstable_act = Q, ft.useCallback = function(P, $) {
    return le.current.useCallback(P, $);
  }, ft.useContext = function(P) {
    return le.current.useContext(P);
  }, ft.useDebugValue = function() {
  }, ft.useDeferredValue = function(P) {
    return le.current.useDeferredValue(P);
  }, ft.useEffect = function(P, $) {
    return le.current.useEffect(P, $);
  }, ft.useId = function() {
    return le.current.useId();
  }, ft.useImperativeHandle = function(P, $, ce) {
    return le.current.useImperativeHandle(P, $, ce);
  }, ft.useInsertionEffect = function(P, $) {
    return le.current.useInsertionEffect(P, $);
  }, ft.useLayoutEffect = function(P, $) {
    return le.current.useLayoutEffect(P, $);
  }, ft.useMemo = function(P, $) {
    return le.current.useMemo(P, $);
  }, ft.useReducer = function(P, $, ce) {
    return le.current.useReducer(P, $, ce);
  }, ft.useRef = function(P) {
    return le.current.useRef(P);
  }, ft.useState = function(P) {
    return le.current.useState(P);
  }, ft.useSyncExternalStore = function(P, $, ce) {
    return le.current.useSyncExternalStore(P, $, ce);
  }, ft.useTransition = function() {
    return le.current.useTransition();
  }, ft.version = "18.3.1", ft;
}
var M4;
function Ys() {
  return M4 || (M4 = 1, M3.exports = GT()), M3.exports;
}
var P4;
function ZT() {
  if (P4) return Ds;
  P4 = 1;
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Ys(), r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, p, f) {
    var h, C = {}, E = null, m = null;
    f !== void 0 && (E = "" + f), p.key !== void 0 && (E = "" + p.key), p.ref !== void 0 && (m = p.ref);
    for (h in p) a.call(p, h) && !l.hasOwnProperty(h) && (C[h] = p[h]);
    if (u && u.defaultProps) for (h in p = u.defaultProps, p) C[h] === void 0 && (C[h] = p[h]);
    return { $$typeof: r, type: u, key: E, ref: m, props: C, _owner: o.current };
  }
  return Ds.Fragment = t, Ds.jsx = c, Ds.jsxs = c, Ds;
}
var b4;
function jT() {
  return b4 || (b4 = 1, L3.exports = ZT()), L3.exports;
}
var Y = jT(), w4 = {}, P3, H4;
function rc() {
  if (H4) return P3;
  H4 = 1;
  var e = W2(), r = Function.prototype, t = r.apply, a = r.call;
  return P3 = typeof Reflect == "object" && Reflect.apply || (e ? a.bind(t) : function() {
    return a.apply(t, arguments);
  }), P3;
}
var b3, V4;
function zT() {
  if (V4) return b3;
  V4 = 1;
  var e = Gn().f;
  return b3 = function(r, t, a) {
    a in r || e(r, a, {
      configurable: !0,
      get: function() {
        return t[a];
      },
      set: function(o) {
        t[a] = o;
      }
    });
  }, b3;
}
var w3, k4;
function Qp() {
  if (k4) return w3;
  k4 = 1;
  var e = Xt(), r = wr(), t = Uo();
  return w3 = function(a, o, l) {
    var c, u;
    return (
      // it can work only with native `setPrototypeOf`
      t && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
      e(c = o.constructor) && c !== l && r(u = c.prototype) && u !== l.prototype && t(a, u), a
    );
  }, w3;
}
var H3, F4;
function qT() {
  if (F4) return H3;
  F4 = 1;
  var e = cr(), r = e("toStringTag"), t = {};
  return t[r] = "z", H3 = String(t) === "[object z]", H3;
}
var V3, U4;
function aa() {
  if (U4) return V3;
  U4 = 1;
  var e = qT(), r = Xt(), t = na(), a = cr(), o = a("toStringTag"), l = Object, c = t(/* @__PURE__ */ function() {
    return arguments;
  }()) === "Arguments", u = function(p, f) {
    try {
      return p[f];
    } catch (h) {
    }
  };
  return V3 = e ? t : function(p) {
    var f, h, C;
    return p === void 0 ? "Undefined" : p === null ? "Null" : typeof (h = u(f = l(p), o)) == "string" ? h : c ? t(f) : (C = t(f)) === "Object" && r(f.callee) ? "Arguments" : C;
  }, V3;
}
var k3, x4;
function yn() {
  if (x4) return k3;
  x4 = 1;
  var e = aa(), r = String;
  return k3 = function(t) {
    if (e(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return r(t);
  }, k3;
}
var F3, B4;
function WT() {
  if (B4) return F3;
  B4 = 1;
  var e = yn();
  return F3 = function(r, t) {
    return r === void 0 ? arguments.length < 2 ? "" : t : e(r);
  }, F3;
}
var U3, $4;
function YT() {
  if ($4) return U3;
  $4 = 1;
  var e = wr(), r = On();
  return U3 = function(t, a) {
    e(a) && "cause" in a && r(t, "cause", a.cause);
  }, U3;
}
var x3, G4;
function KT() {
  if (G4) return x3;
  G4 = 1;
  var e = It(), r = Error, t = e("".replace), a = function(c) {
    return String(new r(c).stack);
  }("zxcasd"), o = /\n\s*at [^:]*:[^\n]*/, l = o.test(a);
  return x3 = function(c, u) {
    if (l && typeof c == "string" && !r.prepareStackTrace)
      for (; u--; ) c = t(c, o, "");
    return c;
  }, x3;
}
var B3, Z4;
function XT() {
  if (Z4) return B3;
  Z4 = 1;
  var e = vt(), r = Ua();
  return B3 = !e(function() {
    var t = new Error("a");
    return "stack" in t ? (Object.defineProperty(t, "stack", r(1, 7)), t.stack !== 7) : !0;
  }), B3;
}
var $3, j4;
function QT() {
  if (j4) return $3;
  j4 = 1;
  var e = On(), r = KT(), t = XT(), a = Error.captureStackTrace;
  return $3 = function(o, l, c, u) {
    t && (a ? a(o, l) : e(o, "stack", r(c, u)));
  }, $3;
}
var G3, z4;
function JT() {
  if (z4) return G3;
  z4 = 1;
  var e = ia(), r = Hr(), t = On(), a = ka(), o = Uo(), l = Kp(), c = zT(), u = Qp(), p = WT(), f = YT(), h = QT(), C = jt(), E = Pi();
  return G3 = function(m, S, v, g) {
    var O = "stackTraceLimit", D = g ? 2 : 1, R = m.split("."), T = R[R.length - 1], N = e.apply(null, R);
    if (N) {
      var b = N.prototype;
      if (!E && r(b, "cause") && delete b.cause, !v) return N;
      var L = e("Error"), k = S(function(w, V) {
        var U = p(g ? V : w, void 0), z = g ? new N(w) : new N();
        return U !== void 0 && t(z, "message", U), h(z, k, z.stack, 2), this && a(b, this) && u(z, this, k), arguments.length > D && f(z, arguments[D]), z;
      });
      if (k.prototype = b, T !== "Error" ? o ? o(k, L) : l(k, L, { name: !0 }) : C && O in N && (c(k, N, O), c(k, N, "prepareStackTrace")), l(k, N), !E) try {
        b.name !== T && t(b, "name", T), b.constructor = k;
      } catch (w) {
      }
      return k;
    }
  }, G3;
}
var q4;
function eO() {
  if (q4) return w4;
  q4 = 1;
  var e = zt(), r = Et(), t = rc(), a = JT(), o = "WebAssembly", l = r[o], c = new Error("e", { cause: 7 }).cause !== 7, u = function(f, h) {
    var C = {};
    C[f] = a(f, h, c), e({ global: !0, constructor: !0, arity: 1, forced: c }, C);
  }, p = function(f, h) {
    if (l && l[f]) {
      var C = {};
      C[f] = a(o + "." + f, h, c), e({ target: o, stat: !0, constructor: !0, arity: 1, forced: c }, C);
    }
  };
  return u("Error", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("EvalError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("RangeError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("ReferenceError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("SyntaxError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("TypeError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), u("URIError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), p("CompileError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), p("LinkError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), p("RuntimeError", function(f) {
    return function(C) {
      return t(f, this, arguments);
    };
  }), w4;
}
eO();
var W4 = {}, Z3, Y4;
function nc() {
  if (Y4) return Z3;
  Y4 = 1;
  var e = It();
  return Z3 = e([].slice), Z3;
}
var j3, K4;
function Jp() {
  if (K4) return j3;
  K4 = 1;
  var e = na();
  return j3 = Array.isArray || function(t) {
    return e(t) === "Array";
  }, j3;
}
var z3, X4;
function tO() {
  if (X4) return z3;
  X4 = 1;
  var e = It(), r = Jp(), t = Xt(), a = na(), o = yn(), l = e([].push);
  return z3 = function(c) {
    if (t(c)) return c;
    if (r(c)) {
      for (var u = c.length, p = [], f = 0; f < u; f++) {
        var h = c[f];
        typeof h == "string" ? l(p, h) : (typeof h == "number" || a(h) === "Number" || a(h) === "String") && l(p, o(h));
      }
      var C = p.length, E = !0;
      return function(m, S) {
        if (E)
          return E = !1, S;
        if (r(this)) return S;
        for (var v = 0; v < C; v++) if (p[v] === m) return S;
      };
    }
  }, z3;
}
var Q4;
function rO() {
  if (Q4) return W4;
  Q4 = 1;
  var e = zt(), r = ia(), t = rc(), a = Mt(), o = It(), l = vt(), c = Xt(), u = X2(), p = nc(), f = tO(), h = Zp(), C = String, E = r("JSON", "stringify"), m = o(/./.exec), S = o("".charAt), v = o("".charCodeAt), g = o("".replace), O = o(1.1.toString), D = /[\uD800-\uDFFF]/g, R = /^[\uD800-\uDBFF]$/, T = /^[\uDC00-\uDFFF]$/, N = !h || l(function() {
    var w = r("Symbol")("stringify detection");
    return E([w]) !== "[null]" || E({ a: w }) !== "{}" || E(Object(w)) !== "{}";
  }), b = l(function() {
    return E("\uDF06\uD834") !== '"\\udf06\\ud834"' || E("\uDEAD") !== '"\\udead"';
  }), L = function(w, V) {
    var U = p(arguments), z = f(V);
    if (!(!c(z) && (w === void 0 || u(w))))
      return U[1] = function(q, W) {
        if (c(z) && (W = a(z, this, C(q), W)), !u(W)) return W;
      }, t(E, null, U);
  }, k = function(w, V, U) {
    var z = S(U, V - 1), q = S(U, V + 1);
    return m(R, w) && !m(T, q) || m(T, w) && !m(R, z) ? "\\u" + O(v(w, 0), 16) : w;
  };
  return E && e({ target: "JSON", stat: !0, arity: 3, forced: N || b }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function(V, U, z) {
      var q = p(arguments), W = t(N ? L : E, null, q);
      return b && typeof W == "string" ? g(W, D, k) : W;
    }
  }), W4;
}
rO();
var h2 = {}, q3 = { exports: {} }, Yr = {}, W3 = { exports: {} }, Y3 = {}, J4;
function nO() {
  return J4 || (J4 = 1, function(e) {
    /**
     * @license React
     * scheduler.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    function r(B, J) {
      var Q = B.length;
      B.push(J);
      e: for (; 0 < Q; ) {
        var P = Q - 1 >>> 1, $ = B[P];
        if (0 < o($, J)) B[P] = J, B[Q] = $, Q = P;
        else break e;
      }
    }
    function t(B) {
      return B.length === 0 ? null : B[0];
    }
    function a(B) {
      if (B.length === 0) return null;
      var J = B[0], Q = B.pop();
      if (Q !== J) {
        B[0] = Q;
        e: for (var P = 0, $ = B.length, ce = $ >>> 1; P < ce; ) {
          var ue = 2 * (P + 1) - 1, ie = B[ue], Re = ue + 1, Ae = B[Re];
          if (0 > o(ie, Q)) Re < $ && 0 > o(Ae, ie) ? (B[P] = Ae, B[Re] = Q, P = Re) : (B[P] = ie, B[ue] = Q, P = ue);
          else if (Re < $ && 0 > o(Ae, Q)) B[P] = Ae, B[Re] = Q, P = Re;
          else break e;
        }
      }
      return J;
    }
    function o(B, J) {
      var Q = B.sortIndex - J.sortIndex;
      return Q !== 0 ? Q : B.id - J.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var l = performance;
      e.unstable_now = function() {
        return l.now();
      };
    } else {
      var c = Date, u = c.now();
      e.unstable_now = function() {
        return c.now() - u;
      };
    }
    var p = [], f = [], h = 1, C = null, E = 3, m = !1, S = !1, v = !1, g = typeof setTimeout == "function" ? setTimeout : null, O = typeof clearTimeout == "function" ? clearTimeout : null, D = typeof setImmediate != "undefined" ? setImmediate : null;
    typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function R(B) {
      for (var J = t(f); J !== null; ) {
        if (J.callback === null) a(f);
        else if (J.startTime <= B) a(f), J.sortIndex = J.expirationTime, r(p, J);
        else break;
        J = t(f);
      }
    }
    function T(B) {
      if (v = !1, R(B), !S) if (t(p) !== null) S = !0, se(N);
      else {
        var J = t(f);
        J !== null && le(T, J.startTime - B);
      }
    }
    function N(B, J) {
      S = !1, v && (v = !1, O(k), k = -1), m = !0;
      var Q = E;
      try {
        for (R(J), C = t(p); C !== null && (!(C.expirationTime > J) || B && !U()); ) {
          var P = C.callback;
          if (typeof P == "function") {
            C.callback = null, E = C.priorityLevel;
            var $ = P(C.expirationTime <= J);
            J = e.unstable_now(), typeof $ == "function" ? C.callback = $ : C === t(p) && a(p), R(J);
          } else a(p);
          C = t(p);
        }
        if (C !== null) var ce = !0;
        else {
          var ue = t(f);
          ue !== null && le(T, ue.startTime - J), ce = !1;
        }
        return ce;
      } finally {
        C = null, E = Q, m = !1;
      }
    }
    var b = !1, L = null, k = -1, w = 5, V = -1;
    function U() {
      return !(e.unstable_now() - V < w);
    }
    function z() {
      if (L !== null) {
        var B = e.unstable_now();
        V = B;
        var J = !0;
        try {
          J = L(!0, B);
        } finally {
          J ? q() : (b = !1, L = null);
        }
      } else b = !1;
    }
    var q;
    if (typeof D == "function") q = function() {
      D(z);
    };
    else if (typeof MessageChannel != "undefined") {
      var W = new MessageChannel(), te = W.port2;
      W.port1.onmessage = z, q = function() {
        te.postMessage(null);
      };
    } else q = function() {
      g(z, 0);
    };
    function se(B) {
      L = B, b || (b = !0, q());
    }
    function le(B, J) {
      k = g(function() {
        B(e.unstable_now());
      }, J);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(B) {
      B.callback = null;
    }, e.unstable_continueExecution = function() {
      S || m || (S = !0, se(N));
    }, e.unstable_forceFrameRate = function(B) {
      0 > B || 125 < B ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < B ? Math.floor(1e3 / B) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return E;
    }, e.unstable_getFirstCallbackNode = function() {
      return t(p);
    }, e.unstable_next = function(B) {
      switch (E) {
        case 1:
        case 2:
        case 3:
          var J = 3;
          break;
        default:
          J = E;
      }
      var Q = E;
      E = J;
      try {
        return B();
      } finally {
        E = Q;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(B, J) {
      switch (B) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          B = 3;
      }
      var Q = E;
      E = B;
      try {
        return J();
      } finally {
        E = Q;
      }
    }, e.unstable_scheduleCallback = function(B, J, Q) {
      var P = e.unstable_now();
      switch (typeof Q == "object" && Q !== null ? (Q = Q.delay, Q = typeof Q == "number" && 0 < Q ? P + Q : P) : Q = P, B) {
        case 1:
          var $ = -1;
          break;
        case 2:
          $ = 250;
          break;
        case 5:
          $ = 1073741823;
          break;
        case 4:
          $ = 1e4;
          break;
        default:
          $ = 5e3;
      }
      return $ = Q + $, B = { id: h++, callback: J, priorityLevel: B, startTime: Q, expirationTime: $, sortIndex: -1 }, Q > P ? (B.sortIndex = Q, r(f, B), t(p) === null && B === t(f) && (v ? (O(k), k = -1) : v = !0, le(T, Q - P))) : (B.sortIndex = $, r(p, B), S || m || (S = !0, se(N))), B;
    }, e.unstable_shouldYield = U, e.unstable_wrapCallback = function(B) {
      var J = E;
      return function() {
        var Q = E;
        E = J;
        try {
          return B.apply(this, arguments);
        } finally {
          E = Q;
        }
      };
    };
  }(Y3)), Y3;
}
var eC;
function iO() {
  return eC || (eC = 1, W3.exports = nO()), W3.exports;
}
var tC;
function aO() {
  if (tC) return Yr;
  tC = 1;
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Ys(), r = iO();
  function t(n) {
    for (var i = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, s = 1; s < arguments.length; s++) i += "&args[]=" + encodeURIComponent(arguments[s]);
    return "Minified React error #" + n + "; visit " + i + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var a = /* @__PURE__ */ new Set(), o = {};
  function l(n, i) {
    c(n, i), c(n + "Capture", i);
  }
  function c(n, i) {
    for (o[n] = i, n = 0; n < i.length; n++) a.add(i[n]);
  }
  var u = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined"), p = Object.prototype.hasOwnProperty, f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, h = {}, C = {};
  function E(n) {
    return p.call(C, n) ? !0 : p.call(h, n) ? !1 : f.test(n) ? C[n] = !0 : (h[n] = !0, !1);
  }
  function m(n, i, s, d) {
    if (s !== null && s.type === 0) return !1;
    switch (typeof i) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return d ? !1 : s !== null ? !s.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function S(n, i, s, d) {
    if (i === null || typeof i == "undefined" || m(n, i, s, d)) return !0;
    if (d) return !1;
    if (s !== null) switch (s.type) {
      case 3:
        return !i;
      case 4:
        return i === !1;
      case 5:
        return isNaN(i);
      case 6:
        return isNaN(i) || 1 > i;
    }
    return !1;
  }
  function v(n, i, s, d, _, I, A) {
    this.acceptsBooleans = i === 2 || i === 3 || i === 4, this.attributeName = d, this.attributeNamespace = _, this.mustUseProperty = s, this.propertyName = n, this.type = i, this.sanitizeURL = I, this.removeEmptyString = A;
  }
  var g = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    g[n] = new v(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var i = n[0];
    g[i] = new v(i, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    g[n] = new v(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    g[n] = new v(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    g[n] = new v(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    g[n] = new v(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    g[n] = new v(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    g[n] = new v(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    g[n] = new v(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var O = /[\-:]([a-z])/g;
  function D(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var i = n.replace(
      O,
      D
    );
    g[i] = new v(i, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var i = n.replace(O, D);
    g[i] = new v(i, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var i = n.replace(O, D);
    g[i] = new v(i, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    g[n] = new v(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), g.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    g[n] = new v(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function R(n, i, s, d) {
    var _ = g.hasOwnProperty(i) ? g[i] : null;
    (_ !== null ? _.type !== 0 : d || !(2 < i.length) || i[0] !== "o" && i[0] !== "O" || i[1] !== "n" && i[1] !== "N") && (S(i, s, _, d) && (s = null), d || _ === null ? E(i) && (s === null ? n.removeAttribute(i) : n.setAttribute(i, "" + s)) : _.mustUseProperty ? n[_.propertyName] = s === null ? _.type === 3 ? !1 : "" : s : (i = _.attributeName, d = _.attributeNamespace, s === null ? n.removeAttribute(i) : (_ = _.type, s = _ === 3 || _ === 4 && s === !0 ? "" : "" + s, d ? n.setAttributeNS(d, i, s) : n.setAttribute(i, s))));
  }
  var T = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, N = Symbol.for("react.element"), b = Symbol.for("react.portal"), L = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), V = Symbol.for("react.provider"), U = Symbol.for("react.context"), z = Symbol.for("react.forward_ref"), q = Symbol.for("react.suspense"), W = Symbol.for("react.suspense_list"), te = Symbol.for("react.memo"), se = Symbol.for("react.lazy"), le = Symbol.for("react.offscreen"), B = Symbol.iterator;
  function J(n) {
    return n === null || typeof n != "object" ? null : (n = B && n[B] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var Q = Object.assign, P;
  function $(n) {
    if (P === void 0) try {
      throw Error();
    } catch (s) {
      var i = s.stack.trim().match(/\n( *(at )?)/);
      P = i && i[1] || "";
    }
    return `
` + P + n;
  }
  var ce = !1;
  function ue(n, i) {
    if (!n || ce) return "";
    ce = !0;
    var s = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (i) if (i = function() {
        throw Error();
      }, Object.defineProperty(i.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(i, []);
        } catch (ee) {
          var d = ee;
        }
        Reflect.construct(n, [], i);
      } else {
        try {
          i.call();
        } catch (ee) {
          d = ee;
        }
        n.call(i.prototype);
      }
      else {
        try {
          throw Error();
        } catch (ee) {
          d = ee;
        }
        n();
      }
    } catch (ee) {
      if (ee && d && typeof ee.stack == "string") {
        for (var _ = ee.stack.split(`
`), I = d.stack.split(`
`), A = _.length - 1, M = I.length - 1; 1 <= A && 0 <= M && _[A] !== I[M]; ) M--;
        for (; 1 <= A && 0 <= M; A--, M--) if (_[A] !== I[M]) {
          if (A !== 1 || M !== 1)
            do
              if (A--, M--, 0 > M || _[A] !== I[M]) {
                var F = `
` + _[A].replace(" at new ", " at ");
                return n.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", n.displayName)), F;
              }
            while (1 <= A && 0 <= M);
          break;
        }
      }
    } finally {
      ce = !1, Error.prepareStackTrace = s;
    }
    return (n = n ? n.displayName || n.name : "") ? $(n) : "";
  }
  function ie(n) {
    switch (n.tag) {
      case 5:
        return $(n.type);
      case 16:
        return $("Lazy");
      case 13:
        return $("Suspense");
      case 19:
        return $("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = ue(n.type, !1), n;
      case 11:
        return n = ue(n.type.render, !1), n;
      case 1:
        return n = ue(n.type, !0), n;
      default:
        return "";
    }
  }
  function Re(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case L:
        return "Fragment";
      case b:
        return "Portal";
      case w:
        return "Profiler";
      case k:
        return "StrictMode";
      case q:
        return "Suspense";
      case W:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case U:
        return (n.displayName || "Context") + ".Consumer";
      case V:
        return (n._context.displayName || "Context") + ".Provider";
      case z:
        var i = n.render;
        return n = n.displayName, n || (n = i.displayName || i.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case te:
        return i = n.displayName || null, i !== null ? i : Re(n.type) || "Memo";
      case se:
        i = n._payload, n = n._init;
        try {
          return Re(n(i));
        } catch (s) {
        }
    }
    return null;
  }
  function Ae(n) {
    var i = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (i.displayName || "Context") + ".Consumer";
      case 10:
        return (i._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = i.render, n = n.displayName || n.name || "", i.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return i;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Re(i);
      case 8:
        return i === k ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof i == "function") return i.displayName || i.name || null;
        if (typeof i == "string") return i;
    }
    return null;
  }
  function Ce(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function Le(n) {
    var i = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (i === "checkbox" || i === "radio");
  }
  function Ze(n) {
    var i = Le(n) ? "checked" : "value", s = Object.getOwnPropertyDescriptor(n.constructor.prototype, i), d = "" + n[i];
    if (!n.hasOwnProperty(i) && typeof s != "undefined" && typeof s.get == "function" && typeof s.set == "function") {
      var _ = s.get, I = s.set;
      return Object.defineProperty(n, i, { configurable: !0, get: function() {
        return _.call(this);
      }, set: function(A) {
        d = "" + A, I.call(this, A);
      } }), Object.defineProperty(n, i, { enumerable: s.enumerable }), { getValue: function() {
        return d;
      }, setValue: function(A) {
        d = "" + A;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[i];
      } };
    }
  }
  function at(n) {
    n._valueTracker || (n._valueTracker = Ze(n));
  }
  function ot(n) {
    if (!n) return !1;
    var i = n._valueTracker;
    if (!i) return !0;
    var s = i.getValue(), d = "";
    return n && (d = Le(n) ? n.checked ? "true" : "false" : n.value), n = d, n !== s ? (i.setValue(n), !0) : !1;
  }
  function ct(n) {
    if (n = n || (typeof document != "undefined" ? document : void 0), typeof n == "undefined") return null;
    try {
      return n.activeElement || n.body;
    } catch (i) {
      return n.body;
    }
  }
  function lt(n, i) {
    var s = i.checked;
    return Q({}, i, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: s != null ? s : n._wrapperState.initialChecked });
  }
  function Ct(n, i) {
    var s = i.defaultValue == null ? "" : i.defaultValue, d = i.checked != null ? i.checked : i.defaultChecked;
    s = Ce(i.value != null ? i.value : s), n._wrapperState = { initialChecked: d, initialValue: s, controlled: i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null };
  }
  function yt(n, i) {
    i = i.checked, i != null && R(n, "checked", i, !1);
  }
  function St(n, i) {
    yt(n, i);
    var s = Ce(i.value), d = i.type;
    if (s != null) d === "number" ? (s === 0 && n.value === "" || n.value != s) && (n.value = "" + s) : n.value !== "" + s && (n.value = "" + s);
    else if (d === "submit" || d === "reset") {
      n.removeAttribute("value");
      return;
    }
    i.hasOwnProperty("value") ? ze(n, i.type, s) : i.hasOwnProperty("defaultValue") && ze(n, i.type, Ce(i.defaultValue)), i.checked == null && i.defaultChecked != null && (n.defaultChecked = !!i.defaultChecked);
  }
  function st(n, i, s) {
    if (i.hasOwnProperty("value") || i.hasOwnProperty("defaultValue")) {
      var d = i.type;
      if (!(d !== "submit" && d !== "reset" || i.value !== void 0 && i.value !== null)) return;
      i = "" + n._wrapperState.initialValue, s || i === n.value || (n.value = i), n.defaultValue = i;
    }
    s = n.name, s !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, s !== "" && (n.name = s);
  }
  function ze(n, i, s) {
    (i !== "number" || ct(n.ownerDocument) !== n) && (s == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + s && (n.defaultValue = "" + s));
  }
  var ht = Array.isArray;
  function me(n, i, s, d) {
    if (n = n.options, i) {
      i = {};
      for (var _ = 0; _ < s.length; _++) i["$" + s[_]] = !0;
      for (s = 0; s < n.length; s++) _ = i.hasOwnProperty("$" + n[s].value), n[s].selected !== _ && (n[s].selected = _), _ && d && (n[s].defaultSelected = !0);
    } else {
      for (s = "" + Ce(s), i = null, _ = 0; _ < n.length; _++) {
        if (n[_].value === s) {
          n[_].selected = !0, d && (n[_].defaultSelected = !0);
          return;
        }
        i !== null || n[_].disabled || (i = n[_]);
      }
      i !== null && (i.selected = !0);
    }
  }
  function ye(n, i) {
    if (i.dangerouslySetInnerHTML != null) throw Error(t(91));
    return Q({}, i, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function xe(n, i) {
    var s = i.value;
    if (s == null) {
      if (s = i.children, i = i.defaultValue, s != null) {
        if (i != null) throw Error(t(92));
        if (ht(s)) {
          if (1 < s.length) throw Error(t(93));
          s = s[0];
        }
        i = s;
      }
      i == null && (i = ""), s = i;
    }
    n._wrapperState = { initialValue: Ce(s) };
  }
  function Lt(n, i) {
    var s = Ce(i.value), d = Ce(i.defaultValue);
    s != null && (s = "" + s, s !== n.value && (n.value = s), i.defaultValue == null && n.defaultValue !== s && (n.defaultValue = s)), d != null && (n.defaultValue = "" + d);
  }
  function _t(n) {
    var i = n.textContent;
    i === n._wrapperState.initialValue && i !== "" && i !== null && (n.value = i);
  }
  function De(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function He(n, i) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? De(i) : n === "http://www.w3.org/2000/svg" && i === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var Be, Je = function(n) {
    return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(i, s, d, _) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(i, s, d, _);
      });
    } : n;
  }(function(n, i) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = i;
    else {
      for (Be = Be || document.createElement("div"), Be.innerHTML = "<svg>" + i.valueOf().toString() + "</svg>", i = Be.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; i.firstChild; ) n.appendChild(i.firstChild);
    }
  });
  function ut(n, i) {
    if (i) {
      var s = n.firstChild;
      if (s && s === n.lastChild && s.nodeType === 3) {
        s.nodeValue = i;
        return;
      }
    }
    n.textContent = i;
  }
  var Tt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Ye = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Tt).forEach(function(n) {
    Ye.forEach(function(i) {
      i = i + n.charAt(0).toUpperCase() + n.substring(1), Tt[i] = Tt[n];
    });
  });
  function ge(n, i, s) {
    return i == null || typeof i == "boolean" || i === "" ? "" : s || typeof i != "number" || i === 0 || Tt.hasOwnProperty(n) && Tt[n] ? ("" + i).trim() : i + "px";
  }
  function Xe(n, i) {
    n = n.style;
    for (var s in i) if (i.hasOwnProperty(s)) {
      var d = s.indexOf("--") === 0, _ = ge(s, i[s], d);
      s === "float" && (s = "cssFloat"), d ? n.setProperty(s, _) : n[s] = _;
    }
  }
  var bt = Q({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Pt(n, i) {
    if (i) {
      if (bt[n] && (i.children != null || i.dangerouslySetInnerHTML != null)) throw Error(t(137, n));
      if (i.dangerouslySetInnerHTML != null) {
        if (i.children != null) throw Error(t(60));
        if (typeof i.dangerouslySetInnerHTML != "object" || !("__html" in i.dangerouslySetInnerHTML)) throw Error(t(61));
      }
      if (i.style != null && typeof i.style != "object") throw Error(t(62));
    }
  }
  function Ar(n, i) {
    if (n.indexOf("-") === -1) return typeof i.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ie = null;
  function Me(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var Te = null, Pe = null, je = null;
  function rt(n) {
    if (n = ls(n)) {
      if (typeof Te != "function") throw Error(t(280));
      var i = n.stateNode;
      i && (i = Nl(i), Te(n.stateNode, n.type, i));
    }
  }
  function Rt(n) {
    Pe ? je ? je.push(n) : je = [n] : Pe = n;
  }
  function Nt() {
    if (Pe) {
      var n = Pe, i = je;
      if (je = Pe = null, rt(n), i) for (n = 0; n < i.length; n++) rt(i[n]);
    }
  }
  function wt(n, i) {
    return n(i);
  }
  function Qt() {
  }
  var Ir = !1;
  function hi(n, i, s) {
    if (Ir) return n(i, s);
    Ir = !0;
    try {
      return wt(n, i, s);
    } finally {
      Ir = !1, (Pe !== null || je !== null) && (Qt(), Nt());
    }
  }
  function Vr(n, i) {
    var s = n.stateNode;
    if (s === null) return null;
    var d = Nl(s);
    if (d === null) return null;
    s = d[i];
    e: switch (i) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (n = n.type, d = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !d;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (s && typeof s != "function") throw Error(t(231, i, typeof s));
    return s;
  }
  var zn = !1;
  if (u) try {
    var qt = {};
    Object.defineProperty(qt, "passive", { get: function() {
      zn = !0;
    } }), window.addEventListener("test", qt, qt), window.removeEventListener("test", qt, qt);
  } catch (n) {
    zn = !1;
  }
  function kr(n, i, s, d, _, I, A, M, F) {
    var ee = Array.prototype.slice.call(arguments, 3);
    try {
      i.apply(s, ee);
    } catch (he) {
      this.onError(he);
    }
  }
  var Ln = !1, Fr = null, vr = !1, qn = null, Mn = { onError: function(n) {
    Ln = !0, Fr = n;
  } };
  function or(n, i, s, d, _, I, A, M, F) {
    Ln = !1, Fr = null, kr.apply(Mn, arguments);
  }
  function Tr(n, i, s, d, _, I, A, M, F) {
    if (or.apply(this, arguments), Ln) {
      if (Ln) {
        var ee = Fr;
        Ln = !1, Fr = null;
      } else throw Error(t(198));
      vr || (vr = !0, qn = ee);
    }
  }
  function dn(n) {
    var i = n, s = n;
    if (n.alternate) for (; i.return; ) i = i.return;
    else {
      n = i;
      do
        i = n, (i.flags & 4098) !== 0 && (s = i.return), n = i.return;
      while (n);
    }
    return i.tag === 3 ? s : null;
  }
  function la(n) {
    if (n.tag === 13) {
      var i = n.memoizedState;
      if (i === null && (n = n.alternate, n !== null && (i = n.memoizedState)), i !== null) return i.dehydrated;
    }
    return null;
  }
  function X(n) {
    if (dn(n) !== n) throw Error(t(188));
  }
  function Ee(n) {
    var i = n.alternate;
    if (!i) {
      if (i = dn(n), i === null) throw Error(t(188));
      return i !== n ? null : n;
    }
    for (var s = n, d = i; ; ) {
      var _ = s.return;
      if (_ === null) break;
      var I = _.alternate;
      if (I === null) {
        if (d = _.return, d !== null) {
          s = d;
          continue;
        }
        break;
      }
      if (_.child === I.child) {
        for (I = _.child; I; ) {
          if (I === s) return X(_), n;
          if (I === d) return X(_), i;
          I = I.sibling;
        }
        throw Error(t(188));
      }
      if (s.return !== d.return) s = _, d = I;
      else {
        for (var A = !1, M = _.child; M; ) {
          if (M === s) {
            A = !0, s = _, d = I;
            break;
          }
          if (M === d) {
            A = !0, d = _, s = I;
            break;
          }
          M = M.sibling;
        }
        if (!A) {
          for (M = I.child; M; ) {
            if (M === s) {
              A = !0, s = I, d = _;
              break;
            }
            if (M === d) {
              A = !0, d = I, s = _;
              break;
            }
            M = M.sibling;
          }
          if (!A) throw Error(t(189));
        }
      }
      if (s.alternate !== d) throw Error(t(190));
    }
    if (s.tag !== 3) throw Error(t(188));
    return s.stateNode.current === s ? n : i;
  }
  function ne(n) {
    return n = Ee(n), n !== null ? G(n) : null;
  }
  function G(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var i = G(n);
      if (i !== null) return i;
      n = n.sibling;
    }
    return null;
  }
  var fe = r.unstable_scheduleCallback, Ke = r.unstable_cancelCallback, Ve = r.unstable_shouldYield, Ht = r.unstable_requestPaint, tt = r.unstable_now, nr = r.unstable_getCurrentPriorityLevel, _r = r.unstable_ImmediatePriority, _e = r.unstable_UserBlockingPriority, Vt = r.unstable_NormalPriority, en = r.unstable_LowPriority, Vi = r.unstable_IdlePriority, _i = null, Ur = null;
  function ca(n) {
    if (Ur && typeof Ur.onCommitFiberRoot == "function") try {
      Ur.onCommitFiberRoot(_i, n, void 0, (n.current.flags & 128) === 128);
    } catch (i) {
    }
  }
  var tn = Math.clz32 ? Math.clz32 : gc, Ic = Math.log, vc = Math.LN2;
  function gc(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (Ic(n) / vc | 0) | 0;
  }
  var ja = 64, za = 4194304;
  function ua(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function qa(n, i) {
    var s = n.pendingLanes;
    if (s === 0) return 0;
    var d = 0, _ = n.suspendedLanes, I = n.pingedLanes, A = s & 268435455;
    if (A !== 0) {
      var M = A & ~_;
      M !== 0 ? d = ua(M) : (I &= A, I !== 0 && (d = ua(I)));
    } else A = s & ~_, A !== 0 ? d = ua(A) : I !== 0 && (d = ua(I));
    if (d === 0) return 0;
    if (i !== 0 && i !== d && (i & _) === 0 && (_ = d & -d, I = i & -i, _ >= I || _ === 16 && (I & 4194240) !== 0)) return i;
    if ((d & 4) !== 0 && (d |= s & 16), i = n.entangledLanes, i !== 0) for (n = n.entanglements, i &= d; 0 < i; ) s = 31 - tn(i), _ = 1 << s, d |= n[s], i &= ~_;
    return d;
  }
  function Rc(n, i) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return i + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Dc(n, i) {
    for (var s = n.suspendedLanes, d = n.pingedLanes, _ = n.expirationTimes, I = n.pendingLanes; 0 < I; ) {
      var A = 31 - tn(I), M = 1 << A, F = _[A];
      F === -1 ? ((M & s) === 0 || (M & d) !== 0) && (_[A] = Rc(M, i)) : F <= i && (n.expiredLanes |= M), I &= ~M;
    }
  }
  function Zo(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function cl() {
    var n = ja;
    return ja <<= 1, (ja & 4194240) === 0 && (ja = 64), n;
  }
  function jo(n) {
    for (var i = [], s = 0; 31 > s; s++) i.push(n);
    return i;
  }
  function fa(n, i, s) {
    n.pendingLanes |= i, i !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, i = 31 - tn(i), n[i] = s;
  }
  function Ac(n, i) {
    var s = n.pendingLanes & ~i;
    n.pendingLanes = i, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= i, n.mutableReadLanes &= i, n.entangledLanes &= i, i = n.entanglements;
    var d = n.eventTimes;
    for (n = n.expirationTimes; 0 < s; ) {
      var _ = 31 - tn(s), I = 1 << _;
      i[_] = 0, d[_] = -1, n[_] = -1, s &= ~I;
    }
  }
  function zo(n, i) {
    var s = n.entangledLanes |= i;
    for (n = n.entanglements; s; ) {
      var d = 31 - tn(s), _ = 1 << d;
      _ & i | n[d] & i && (n[d] |= i), s &= ~_;
    }
  }
  var Ot = 0;
  function ul(n) {
    return n &= -n, 1 < n ? 4 < n ? (n & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var fl, qo, dl, pl, hl, Wo = !1, Wa = [], Wn = null, Yn = null, Kn = null, da = /* @__PURE__ */ new Map(), pa = /* @__PURE__ */ new Map(), Xn = [], Tc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function _l(n, i) {
    switch (n) {
      case "focusin":
      case "focusout":
        Wn = null;
        break;
      case "dragenter":
      case "dragleave":
        Yn = null;
        break;
      case "mouseover":
      case "mouseout":
        Kn = null;
        break;
      case "pointerover":
      case "pointerout":
        da.delete(i.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        pa.delete(i.pointerId);
    }
  }
  function ha(n, i, s, d, _, I) {
    return n === null || n.nativeEvent !== I ? (n = { blockedOn: i, domEventName: s, eventSystemFlags: d, nativeEvent: I, targetContainers: [_] }, i !== null && (i = ls(i), i !== null && qo(i)), n) : (n.eventSystemFlags |= d, i = n.targetContainers, _ !== null && i.indexOf(_) === -1 && i.push(_), n);
  }
  function ml(n, i, s, d, _) {
    switch (i) {
      case "focusin":
        return Wn = ha(Wn, n, i, s, d, _), !0;
      case "dragenter":
        return Yn = ha(Yn, n, i, s, d, _), !0;
      case "mouseover":
        return Kn = ha(Kn, n, i, s, d, _), !0;
      case "pointerover":
        var I = _.pointerId;
        return da.set(I, ha(da.get(I) || null, n, i, s, d, _)), !0;
      case "gotpointercapture":
        return I = _.pointerId, pa.set(I, ha(pa.get(I) || null, n, i, s, d, _)), !0;
    }
    return !1;
  }
  function El(n) {
    var i = _a(n.target);
    if (i !== null) {
      var s = dn(i);
      if (s !== null) {
        if (i = s.tag, i === 13) {
          if (i = la(s), i !== null) {
            n.blockedOn = i, hl(n.priority, function() {
              dl(s);
            });
            return;
          }
        } else if (i === 3 && s.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = s.tag === 3 ? s.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function Z(n) {
    if (n.blockedOn !== null) return !1;
    for (var i = n.targetContainers; 0 < i.length; ) {
      var s = Xa(n.domEventName, n.eventSystemFlags, i[0], n.nativeEvent);
      if (s === null) {
        s = n.nativeEvent;
        var d = new s.constructor(s.type, s);
        Ie = d, s.target.dispatchEvent(d), Ie = null;
      } else return i = ls(s), i !== null && qo(i), n.blockedOn = s, !1;
      i.shift();
    }
    return !0;
  }
  function y(n, i, s) {
    Z(n) && s.delete(i);
  }
  function H() {
    Wo = !1, Wn !== null && Z(Wn) && (Wn = null), Yn !== null && Z(Yn) && (Yn = null), Kn !== null && Z(Kn) && (Kn = null), da.forEach(y), pa.forEach(y);
  }
  function ae(n, i) {
    n.blockedOn === i && (n.blockedOn = null, Wo || (Wo = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, H)));
  }
  function de(n) {
    function i(_) {
      return ae(_, n);
    }
    if (0 < Wa.length) {
      ae(Wa[0], n);
      for (var s = 1; s < Wa.length; s++) {
        var d = Wa[s];
        d.blockedOn === n && (d.blockedOn = null);
      }
    }
    for (Wn !== null && ae(Wn, n), Yn !== null && ae(Yn, n), Kn !== null && ae(Kn, n), da.forEach(i), pa.forEach(i), s = 0; s < Xn.length; s++) d = Xn[s], d.blockedOn === n && (d.blockedOn = null);
    for (; 0 < Xn.length && (s = Xn[0], s.blockedOn === null); ) El(s), s.blockedOn === null && Xn.shift();
  }
  var et = T.ReactCurrentBatchConfig, Ut = !0;
  function Or(n, i, s, d) {
    var _ = Ot, I = et.transition;
    et.transition = null;
    try {
      Ot = 1, Yo(n, i, s, d);
    } finally {
      Ot = _, et.transition = I;
    }
  }
  function Ya(n, i, s, d) {
    var _ = Ot, I = et.transition;
    et.transition = null;
    try {
      Ot = 4, Yo(n, i, s, d);
    } finally {
      Ot = _, et.transition = I;
    }
  }
  function Yo(n, i, s, d) {
    if (Ut) {
      var _ = Xa(n, i, s, d);
      if (_ === null) $c(n, i, d, Ka, s), _l(n, d);
      else if (ml(_, n, i, s, d)) d.stopPropagation();
      else if (_l(n, d), i & 4 && -1 < Tc.indexOf(n)) {
        for (; _ !== null; ) {
          var I = ls(_);
          if (I !== null && fl(I), I = Xa(n, i, s, d), I === null && $c(n, i, d, Ka, s), I === _) break;
          _ = I;
        }
        _ !== null && d.stopPropagation();
      } else $c(n, i, d, null, s);
    }
  }
  var Ka = null;
  function Xa(n, i, s, d) {
    if (Ka = null, n = Me(d), n = _a(n), n !== null) if (i = dn(n), i === null) n = null;
    else if (s = i.tag, s === 13) {
      if (n = la(i), n !== null) return n;
      n = null;
    } else if (s === 3) {
      if (i.stateNode.current.memoizedState.isDehydrated) return i.tag === 3 ? i.stateNode.containerInfo : null;
      n = null;
    } else i !== n && (n = null);
    return Ka = n, null;
  }
  function Ko(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (nr()) {
          case _r:
            return 1;
          case _e:
            return 4;
          case Vt:
          case en:
            return 16;
          case Vi:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Pn = null, Qa = null, Cl = null;
  function Hh() {
    if (Cl) return Cl;
    var n, i = Qa, s = i.length, d, _ = "value" in Pn ? Pn.value : Pn.textContent, I = _.length;
    for (n = 0; n < s && i[n] === _[n]; n++) ;
    var A = s - n;
    for (d = 1; d <= A && i[s - d] === _[I - d]; d++) ;
    return Cl = _.slice(n, 1 < d ? 1 - d : void 0);
  }
  function Sl(n) {
    var i = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && i === 13 && (n = 13)) : n = i, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function Il() {
    return !0;
  }
  function Vh() {
    return !1;
  }
  function rn(n) {
    function i(s, d, _, I, A) {
      this._reactName = s, this._targetInst = _, this.type = d, this.nativeEvent = I, this.target = A, this.currentTarget = null;
      for (var M in n) n.hasOwnProperty(M) && (s = n[M], this[M] = s ? s(I) : I[M]);
      return this.isDefaultPrevented = (I.defaultPrevented != null ? I.defaultPrevented : I.returnValue === !1) ? Il : Vh, this.isPropagationStopped = Vh, this;
    }
    return Q(i.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var s = this.nativeEvent;
      s && (s.preventDefault ? s.preventDefault() : typeof s.returnValue != "unknown" && (s.returnValue = !1), this.isDefaultPrevented = Il);
    }, stopPropagation: function() {
      var s = this.nativeEvent;
      s && (s.stopPropagation ? s.stopPropagation() : typeof s.cancelBubble != "unknown" && (s.cancelBubble = !0), this.isPropagationStopped = Il);
    }, persist: function() {
    }, isPersistent: Il }), i;
  }
  var Ja = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Oc = rn(Ja), Xo = Q({}, Ja, { view: 0, detail: 0 }), Y8 = rn(Xo), yc, Nc, Qo, vl = Q({}, Xo, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Mc, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== Qo && (Qo && n.type === "mousemove" ? (yc = n.screenX - Qo.screenX, Nc = n.screenY - Qo.screenY) : Nc = yc = 0, Qo = n), yc);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : Nc;
  } }), kh = rn(vl), K8 = Q({}, vl, { dataTransfer: 0 }), X8 = rn(K8), Q8 = Q({}, Xo, { relatedTarget: 0 }), Lc = rn(Q8), J8 = Q({}, Ja, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), eA = rn(J8), tA = Q({}, Ja, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), rA = rn(tA), nA = Q({}, Ja, { data: 0 }), Fh = rn(nA), iA = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, aA = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, oA = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function sA(n) {
    var i = this.nativeEvent;
    return i.getModifierState ? i.getModifierState(n) : (n = oA[n]) ? !!i[n] : !1;
  }
  function Mc() {
    return sA;
  }
  var lA = Q({}, Xo, { key: function(n) {
    if (n.key) {
      var i = iA[n.key] || n.key;
      if (i !== "Unidentified") return i;
    }
    return n.type === "keypress" ? (n = Sl(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? aA[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Mc, charCode: function(n) {
    return n.type === "keypress" ? Sl(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? Sl(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), cA = rn(lA), uA = Q({}, vl, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Uh = rn(uA), fA = Q({}, Xo, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Mc }), dA = rn(fA), pA = Q({}, Ja, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), hA = rn(pA), _A = Q({}, vl, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), mA = rn(_A), EA = [9, 13, 27, 32], Pc = u && "CompositionEvent" in window, Jo = null;
  u && "documentMode" in document && (Jo = document.documentMode);
  var CA = u && "TextEvent" in window && !Jo, xh = u && (!Pc || Jo && 8 < Jo && 11 >= Jo), Bh = " ", $h = !1;
  function Gh(n, i) {
    switch (n) {
      case "keyup":
        return EA.indexOf(i.keyCode) !== -1;
      case "keydown":
        return i.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Zh(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var eo = !1;
  function SA(n, i) {
    switch (n) {
      case "compositionend":
        return Zh(i);
      case "keypress":
        return i.which !== 32 ? null : ($h = !0, Bh);
      case "textInput":
        return n = i.data, n === Bh && $h ? null : n;
      default:
        return null;
    }
  }
  function IA(n, i) {
    if (eo) return n === "compositionend" || !Pc && Gh(n, i) ? (n = Hh(), Cl = Qa = Pn = null, eo = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(i.ctrlKey || i.altKey || i.metaKey) || i.ctrlKey && i.altKey) {
          if (i.char && 1 < i.char.length) return i.char;
          if (i.which) return String.fromCharCode(i.which);
        }
        return null;
      case "compositionend":
        return xh && i.locale !== "ko" ? null : i.data;
      default:
        return null;
    }
  }
  var vA = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function jh(n) {
    var i = n && n.nodeName && n.nodeName.toLowerCase();
    return i === "input" ? !!vA[n.type] : i === "textarea";
  }
  function zh(n, i, s, d) {
    Rt(d), i = Tl(i, "onChange"), 0 < i.length && (s = new Oc("onChange", "change", null, s, d), n.push({ event: s, listeners: i }));
  }
  var es = null, ts = null;
  function gA(n) {
    u_(n, 0);
  }
  function gl(n) {
    var i = ao(n);
    if (ot(i)) return n;
  }
  function RA(n, i) {
    if (n === "change") return i;
  }
  var qh = !1;
  if (u) {
    var bc;
    if (u) {
      var wc = "oninput" in document;
      if (!wc) {
        var Wh = document.createElement("div");
        Wh.setAttribute("oninput", "return;"), wc = typeof Wh.oninput == "function";
      }
      bc = wc;
    } else bc = !1;
    qh = bc && (!document.documentMode || 9 < document.documentMode);
  }
  function Yh() {
    es && (es.detachEvent("onpropertychange", Kh), ts = es = null);
  }
  function Kh(n) {
    if (n.propertyName === "value" && gl(ts)) {
      var i = [];
      zh(i, ts, n, Me(n)), hi(gA, i);
    }
  }
  function DA(n, i, s) {
    n === "focusin" ? (Yh(), es = i, ts = s, es.attachEvent("onpropertychange", Kh)) : n === "focusout" && Yh();
  }
  function AA(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return gl(ts);
  }
  function TA(n, i) {
    if (n === "click") return gl(i);
  }
  function OA(n, i) {
    if (n === "input" || n === "change") return gl(i);
  }
  function yA(n, i) {
    return n === i && (n !== 0 || 1 / n === 1 / i) || n !== n && i !== i;
  }
  var bn = typeof Object.is == "function" ? Object.is : yA;
  function rs(n, i) {
    if (bn(n, i)) return !0;
    if (typeof n != "object" || n === null || typeof i != "object" || i === null) return !1;
    var s = Object.keys(n), d = Object.keys(i);
    if (s.length !== d.length) return !1;
    for (d = 0; d < s.length; d++) {
      var _ = s[d];
      if (!p.call(i, _) || !bn(n[_], i[_])) return !1;
    }
    return !0;
  }
  function Xh(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function Qh(n, i) {
    var s = Xh(n);
    n = 0;
    for (var d; s; ) {
      if (s.nodeType === 3) {
        if (d = n + s.textContent.length, n <= i && d >= i) return { node: s, offset: i - n };
        n = d;
      }
      e: {
        for (; s; ) {
          if (s.nextSibling) {
            s = s.nextSibling;
            break e;
          }
          s = s.parentNode;
        }
        s = void 0;
      }
      s = Xh(s);
    }
  }
  function Jh(n, i) {
    return n && i ? n === i ? !0 : n && n.nodeType === 3 ? !1 : i && i.nodeType === 3 ? Jh(n, i.parentNode) : "contains" in n ? n.contains(i) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(i) & 16) : !1 : !1;
  }
  function e_() {
    for (var n = window, i = ct(); i instanceof n.HTMLIFrameElement; ) {
      try {
        var s = typeof i.contentWindow.location.href == "string";
      } catch (d) {
        s = !1;
      }
      if (s) n = i.contentWindow;
      else break;
      i = ct(n.document);
    }
    return i;
  }
  function Hc(n) {
    var i = n && n.nodeName && n.nodeName.toLowerCase();
    return i && (i === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || i === "textarea" || n.contentEditable === "true");
  }
  function NA(n) {
    var i = e_(), s = n.focusedElem, d = n.selectionRange;
    if (i !== s && s && s.ownerDocument && Jh(s.ownerDocument.documentElement, s)) {
      if (d !== null && Hc(s)) {
        if (i = d.start, n = d.end, n === void 0 && (n = i), "selectionStart" in s) s.selectionStart = i, s.selectionEnd = Math.min(n, s.value.length);
        else if (n = (i = s.ownerDocument || document) && i.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var _ = s.textContent.length, I = Math.min(d.start, _);
          d = d.end === void 0 ? I : Math.min(d.end, _), !n.extend && I > d && (_ = d, d = I, I = _), _ = Qh(s, I);
          var A = Qh(
            s,
            d
          );
          _ && A && (n.rangeCount !== 1 || n.anchorNode !== _.node || n.anchorOffset !== _.offset || n.focusNode !== A.node || n.focusOffset !== A.offset) && (i = i.createRange(), i.setStart(_.node, _.offset), n.removeAllRanges(), I > d ? (n.addRange(i), n.extend(A.node, A.offset)) : (i.setEnd(A.node, A.offset), n.addRange(i)));
        }
      }
      for (i = [], n = s; n = n.parentNode; ) n.nodeType === 1 && i.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof s.focus == "function" && s.focus(), s = 0; s < i.length; s++) n = i[s], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var LA = u && "documentMode" in document && 11 >= document.documentMode, to = null, Vc = null, ns = null, kc = !1;
  function t_(n, i, s) {
    var d = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
    kc || to == null || to !== ct(d) || (d = to, "selectionStart" in d && Hc(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), ns && rs(ns, d) || (ns = d, d = Tl(Vc, "onSelect"), 0 < d.length && (i = new Oc("onSelect", "select", null, i, s), n.push({ event: i, listeners: d }), i.target = to)));
  }
  function Rl(n, i) {
    var s = {};
    return s[n.toLowerCase()] = i.toLowerCase(), s["Webkit" + n] = "webkit" + i, s["Moz" + n] = "moz" + i, s;
  }
  var ro = { animationend: Rl("Animation", "AnimationEnd"), animationiteration: Rl("Animation", "AnimationIteration"), animationstart: Rl("Animation", "AnimationStart"), transitionend: Rl("Transition", "TransitionEnd") }, Fc = {}, r_ = {};
  u && (r_ = document.createElement("div").style, "AnimationEvent" in window || (delete ro.animationend.animation, delete ro.animationiteration.animation, delete ro.animationstart.animation), "TransitionEvent" in window || delete ro.transitionend.transition);
  function Dl(n) {
    if (Fc[n]) return Fc[n];
    if (!ro[n]) return n;
    var i = ro[n], s;
    for (s in i) if (i.hasOwnProperty(s) && s in r_) return Fc[n] = i[s];
    return n;
  }
  var n_ = Dl("animationend"), i_ = Dl("animationiteration"), a_ = Dl("animationstart"), o_ = Dl("transitionend"), s_ = /* @__PURE__ */ new Map(), l_ = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ki(n, i) {
    s_.set(n, i), l(i, [n]);
  }
  for (var Uc = 0; Uc < l_.length; Uc++) {
    var xc = l_[Uc], MA = xc.toLowerCase(), PA = xc[0].toUpperCase() + xc.slice(1);
    ki(MA, "on" + PA);
  }
  ki(n_, "onAnimationEnd"), ki(i_, "onAnimationIteration"), ki(a_, "onAnimationStart"), ki("dblclick", "onDoubleClick"), ki("focusin", "onFocus"), ki("focusout", "onBlur"), ki(o_, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var is = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bA = new Set("cancel close invalid load scroll toggle".split(" ").concat(is));
  function c_(n, i, s) {
    var d = n.type || "unknown-event";
    n.currentTarget = s, Tr(d, i, void 0, n), n.currentTarget = null;
  }
  function u_(n, i) {
    i = (i & 4) !== 0;
    for (var s = 0; s < n.length; s++) {
      var d = n[s], _ = d.event;
      d = d.listeners;
      e: {
        var I = void 0;
        if (i) for (var A = d.length - 1; 0 <= A; A--) {
          var M = d[A], F = M.instance, ee = M.currentTarget;
          if (M = M.listener, F !== I && _.isPropagationStopped()) break e;
          c_(_, M, ee), I = F;
        }
        else for (A = 0; A < d.length; A++) {
          if (M = d[A], F = M.instance, ee = M.currentTarget, M = M.listener, F !== I && _.isPropagationStopped()) break e;
          c_(_, M, ee), I = F;
        }
      }
    }
    if (vr) throw n = qn, vr = !1, qn = null, n;
  }
  function xt(n, i) {
    var s = i[Wc];
    s === void 0 && (s = i[Wc] = /* @__PURE__ */ new Set());
    var d = n + "__bubble";
    s.has(d) || (f_(i, n, 2, !1), s.add(d));
  }
  function Bc(n, i, s) {
    var d = 0;
    i && (d |= 4), f_(s, n, d, i);
  }
  var Al = "_reactListening" + Math.random().toString(36).slice(2);
  function as(n) {
    if (!n[Al]) {
      n[Al] = !0, a.forEach(function(s) {
        s !== "selectionchange" && (bA.has(s) || Bc(s, !1, n), Bc(s, !0, n));
      });
      var i = n.nodeType === 9 ? n : n.ownerDocument;
      i === null || i[Al] || (i[Al] = !0, Bc("selectionchange", !1, i));
    }
  }
  function f_(n, i, s, d) {
    switch (Ko(i)) {
      case 1:
        var _ = Or;
        break;
      case 4:
        _ = Ya;
        break;
      default:
        _ = Yo;
    }
    s = _.bind(null, i, s, n), _ = void 0, !zn || i !== "touchstart" && i !== "touchmove" && i !== "wheel" || (_ = !0), d ? _ !== void 0 ? n.addEventListener(i, s, { capture: !0, passive: _ }) : n.addEventListener(i, s, !0) : _ !== void 0 ? n.addEventListener(i, s, { passive: _ }) : n.addEventListener(i, s, !1);
  }
  function $c(n, i, s, d, _) {
    var I = d;
    if ((i & 1) === 0 && (i & 2) === 0 && d !== null) e: for (; ; ) {
      if (d === null) return;
      var A = d.tag;
      if (A === 3 || A === 4) {
        var M = d.stateNode.containerInfo;
        if (M === _ || M.nodeType === 8 && M.parentNode === _) break;
        if (A === 4) for (A = d.return; A !== null; ) {
          var F = A.tag;
          if ((F === 3 || F === 4) && (F = A.stateNode.containerInfo, F === _ || F.nodeType === 8 && F.parentNode === _))
            return;
          A = A.return;
        }
        for (; M !== null; ) {
          if (A = _a(M), A === null) return;
          if (F = A.tag, F === 5 || F === 6) {
            d = I = A;
            continue e;
          }
          M = M.parentNode;
        }
      }
      d = d.return;
    }
    hi(function() {
      var ee = I, he = Me(s), Se = [];
      e: {
        var pe = s_.get(n);
        if (pe !== void 0) {
          var be = Oc, Ue = n;
          switch (n) {
            case "keypress":
              if (Sl(s) === 0) break e;
            case "keydown":
            case "keyup":
              be = cA;
              break;
            case "focusin":
              Ue = "focus", be = Lc;
              break;
            case "focusout":
              Ue = "blur", be = Lc;
              break;
            case "beforeblur":
            case "afterblur":
              be = Lc;
              break;
            case "click":
              if (s.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              be = kh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              be = X8;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              be = dA;
              break;
            case n_:
            case i_:
            case a_:
              be = eA;
              break;
            case o_:
              be = hA;
              break;
            case "scroll":
              be = Y8;
              break;
            case "wheel":
              be = mA;
              break;
            case "copy":
            case "cut":
            case "paste":
              be = rA;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              be = Uh;
          }
          var $e = (i & 4) !== 0, ir = !$e && n === "scroll", j = $e ? pe !== null ? pe + "Capture" : null : pe;
          $e = [];
          for (var x = ee, K; x !== null; ) {
            K = x;
            var ve = K.stateNode;
            if (K.tag === 5 && ve !== null && (K = ve, j !== null && (ve = Vr(x, j), ve != null && $e.push(os(x, ve, K)))), ir) break;
            x = x.return;
          }
          0 < $e.length && (pe = new be(pe, Ue, null, s, he), Se.push({ event: pe, listeners: $e }));
        }
      }
      if ((i & 7) === 0) {
        e: {
          if (pe = n === "mouseover" || n === "pointerover", be = n === "mouseout" || n === "pointerout", pe && s !== Ie && (Ue = s.relatedTarget || s.fromElement) && (_a(Ue) || Ue[mi])) break e;
          if ((be || pe) && (pe = he.window === he ? he : (pe = he.ownerDocument) ? pe.defaultView || pe.parentWindow : window, be ? (Ue = s.relatedTarget || s.toElement, be = ee, Ue = Ue ? _a(Ue) : null, Ue !== null && (ir = dn(Ue), Ue !== ir || Ue.tag !== 5 && Ue.tag !== 6) && (Ue = null)) : (be = null, Ue = ee), be !== Ue)) {
            if ($e = kh, ve = "onMouseLeave", j = "onMouseEnter", x = "mouse", (n === "pointerout" || n === "pointerover") && ($e = Uh, ve = "onPointerLeave", j = "onPointerEnter", x = "pointer"), ir = be == null ? pe : ao(be), K = Ue == null ? pe : ao(Ue), pe = new $e(ve, x + "leave", be, s, he), pe.target = ir, pe.relatedTarget = K, ve = null, _a(he) === ee && ($e = new $e(j, x + "enter", Ue, s, he), $e.target = K, $e.relatedTarget = ir, ve = $e), ir = ve, be && Ue) t: {
              for ($e = be, j = Ue, x = 0, K = $e; K; K = no(K)) x++;
              for (K = 0, ve = j; ve; ve = no(ve)) K++;
              for (; 0 < x - K; ) $e = no($e), x--;
              for (; 0 < K - x; ) j = no(j), K--;
              for (; x--; ) {
                if ($e === j || j !== null && $e === j.alternate) break t;
                $e = no($e), j = no(j);
              }
              $e = null;
            }
            else $e = null;
            be !== null && d_(Se, pe, be, $e, !1), Ue !== null && ir !== null && d_(Se, ir, Ue, $e, !0);
          }
        }
        e: {
          if (pe = ee ? ao(ee) : window, be = pe.nodeName && pe.nodeName.toLowerCase(), be === "select" || be === "input" && pe.type === "file") var Ge = RA;
          else if (jh(pe)) if (qh) Ge = OA;
          else {
            Ge = AA;
            var qe = DA;
          }
          else (be = pe.nodeName) && be.toLowerCase() === "input" && (pe.type === "checkbox" || pe.type === "radio") && (Ge = TA);
          if (Ge && (Ge = Ge(n, ee))) {
            zh(Se, Ge, s, he);
            break e;
          }
          qe && qe(n, pe, ee), n === "focusout" && (qe = pe._wrapperState) && qe.controlled && pe.type === "number" && ze(pe, "number", pe.value);
        }
        switch (qe = ee ? ao(ee) : window, n) {
          case "focusin":
            (jh(qe) || qe.contentEditable === "true") && (to = qe, Vc = ee, ns = null);
            break;
          case "focusout":
            ns = Vc = to = null;
            break;
          case "mousedown":
            kc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            kc = !1, t_(Se, s, he);
            break;
          case "selectionchange":
            if (LA) break;
          case "keydown":
          case "keyup":
            t_(Se, s, he);
        }
        var We;
        if (Pc) e: {
          switch (n) {
            case "compositionstart":
              var Qe = "onCompositionStart";
              break e;
            case "compositionend":
              Qe = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Qe = "onCompositionUpdate";
              break e;
          }
          Qe = void 0;
        }
        else eo ? Gh(n, s) && (Qe = "onCompositionEnd") : n === "keydown" && s.keyCode === 229 && (Qe = "onCompositionStart");
        Qe && (xh && s.locale !== "ko" && (eo || Qe !== "onCompositionStart" ? Qe === "onCompositionEnd" && eo && (We = Hh()) : (Pn = he, Qa = "value" in Pn ? Pn.value : Pn.textContent, eo = !0)), qe = Tl(ee, Qe), 0 < qe.length && (Qe = new Fh(Qe, n, null, s, he), Se.push({ event: Qe, listeners: qe }), We ? Qe.data = We : (We = Zh(s), We !== null && (Qe.data = We)))), (We = CA ? SA(n, s) : IA(n, s)) && (ee = Tl(ee, "onBeforeInput"), 0 < ee.length && (he = new Fh("onBeforeInput", "beforeinput", null, s, he), Se.push({ event: he, listeners: ee }), he.data = We));
      }
      u_(Se, i);
    });
  }
  function os(n, i, s) {
    return { instance: n, listener: i, currentTarget: s };
  }
  function Tl(n, i) {
    for (var s = i + "Capture", d = []; n !== null; ) {
      var _ = n, I = _.stateNode;
      _.tag === 5 && I !== null && (_ = I, I = Vr(n, s), I != null && d.unshift(os(n, I, _)), I = Vr(n, i), I != null && d.push(os(n, I, _))), n = n.return;
    }
    return d;
  }
  function no(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function d_(n, i, s, d, _) {
    for (var I = i._reactName, A = []; s !== null && s !== d; ) {
      var M = s, F = M.alternate, ee = M.stateNode;
      if (F !== null && F === d) break;
      M.tag === 5 && ee !== null && (M = ee, _ ? (F = Vr(s, I), F != null && A.unshift(os(s, F, M))) : _ || (F = Vr(s, I), F != null && A.push(os(s, F, M)))), s = s.return;
    }
    A.length !== 0 && n.push({ event: i, listeners: A });
  }
  var wA = /\r\n?/g, HA = /\u0000|\uFFFD/g;
  function p_(n) {
    return (typeof n == "string" ? n : "" + n).replace(wA, `
`).replace(HA, "");
  }
  function Ol(n, i, s) {
    if (i = p_(i), p_(n) !== i && s) throw Error(t(425));
  }
  function yl() {
  }
  var Gc = null, Zc = null;
  function jc(n, i) {
    return n === "textarea" || n === "noscript" || typeof i.children == "string" || typeof i.children == "number" || typeof i.dangerouslySetInnerHTML == "object" && i.dangerouslySetInnerHTML !== null && i.dangerouslySetInnerHTML.__html != null;
  }
  var zc = typeof setTimeout == "function" ? setTimeout : void 0, VA = typeof clearTimeout == "function" ? clearTimeout : void 0, h_ = typeof Promise == "function" ? Promise : void 0, kA = typeof queueMicrotask == "function" ? queueMicrotask : typeof h_ != "undefined" ? function(n) {
    return h_.resolve(null).then(n).catch(FA);
  } : zc;
  function FA(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function qc(n, i) {
    var s = i, d = 0;
    do {
      var _ = s.nextSibling;
      if (n.removeChild(s), _ && _.nodeType === 8) if (s = _.data, s === "/$") {
        if (d === 0) {
          n.removeChild(_), de(i);
          return;
        }
        d--;
      } else s !== "$" && s !== "$?" && s !== "$!" || d++;
      s = _;
    } while (s);
    de(i);
  }
  function Fi(n) {
    for (; n != null; n = n.nextSibling) {
      var i = n.nodeType;
      if (i === 1 || i === 3) break;
      if (i === 8) {
        if (i = n.data, i === "$" || i === "$!" || i === "$?") break;
        if (i === "/$") return null;
      }
    }
    return n;
  }
  function __(n) {
    n = n.previousSibling;
    for (var i = 0; n; ) {
      if (n.nodeType === 8) {
        var s = n.data;
        if (s === "$" || s === "$!" || s === "$?") {
          if (i === 0) return n;
          i--;
        } else s === "/$" && i++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var io = Math.random().toString(36).slice(2), Qn = "__reactFiber$" + io, ss = "__reactProps$" + io, mi = "__reactContainer$" + io, Wc = "__reactEvents$" + io, UA = "__reactListeners$" + io, xA = "__reactHandles$" + io;
  function _a(n) {
    var i = n[Qn];
    if (i) return i;
    for (var s = n.parentNode; s; ) {
      if (i = s[mi] || s[Qn]) {
        if (s = i.alternate, i.child !== null || s !== null && s.child !== null) for (n = __(n); n !== null; ) {
          if (s = n[Qn]) return s;
          n = __(n);
        }
        return i;
      }
      n = s, s = n.parentNode;
    }
    return null;
  }
  function ls(n) {
    return n = n[Qn] || n[mi], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function ao(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(t(33));
  }
  function Nl(n) {
    return n[ss] || null;
  }
  var Yc = [], oo = -1;
  function Ui(n) {
    return { current: n };
  }
  function Bt(n) {
    0 > oo || (n.current = Yc[oo], Yc[oo] = null, oo--);
  }
  function kt(n, i) {
    oo++, Yc[oo] = n.current, n.current = i;
  }
  var xi = {}, yr = Ui(xi), Zr = Ui(!1), ma = xi;
  function so(n, i) {
    var s = n.type.contextTypes;
    if (!s) return xi;
    var d = n.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === i) return d.__reactInternalMemoizedMaskedChildContext;
    var _ = {}, I;
    for (I in s) _[I] = i[I];
    return d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = i, n.__reactInternalMemoizedMaskedChildContext = _), _;
  }
  function jr(n) {
    return n = n.childContextTypes, n != null;
  }
  function Ll() {
    Bt(Zr), Bt(yr);
  }
  function m_(n, i, s) {
    if (yr.current !== xi) throw Error(t(168));
    kt(yr, i), kt(Zr, s);
  }
  function E_(n, i, s) {
    var d = n.stateNode;
    if (i = i.childContextTypes, typeof d.getChildContext != "function") return s;
    d = d.getChildContext();
    for (var _ in d) if (!(_ in i)) throw Error(t(108, Ae(n) || "Unknown", _));
    return Q({}, s, d);
  }
  function Ml(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || xi, ma = yr.current, kt(yr, n), kt(Zr, Zr.current), !0;
  }
  function C_(n, i, s) {
    var d = n.stateNode;
    if (!d) throw Error(t(169));
    s ? (n = E_(n, i, ma), d.__reactInternalMemoizedMergedChildContext = n, Bt(Zr), Bt(yr), kt(yr, n)) : Bt(Zr), kt(Zr, s);
  }
  var Ei = null, Pl = !1, Kc = !1;
  function S_(n) {
    Ei === null ? Ei = [n] : Ei.push(n);
  }
  function BA(n) {
    Pl = !0, S_(n);
  }
  function Bi() {
    if (!Kc && Ei !== null) {
      Kc = !0;
      var n = 0, i = Ot;
      try {
        var s = Ei;
        for (Ot = 1; n < s.length; n++) {
          var d = s[n];
          do
            d = d(!0);
          while (d !== null);
        }
        Ei = null, Pl = !1;
      } catch (_) {
        throw Ei !== null && (Ei = Ei.slice(n + 1)), fe(_r, Bi), _;
      } finally {
        Ot = i, Kc = !1;
      }
    }
    return null;
  }
  var lo = [], co = 0, bl = null, wl = 0, pn = [], hn = 0, Ea = null, Ci = 1, Si = "";
  function Ca(n, i) {
    lo[co++] = wl, lo[co++] = bl, bl = n, wl = i;
  }
  function I_(n, i, s) {
    pn[hn++] = Ci, pn[hn++] = Si, pn[hn++] = Ea, Ea = n;
    var d = Ci;
    n = Si;
    var _ = 32 - tn(d) - 1;
    d &= ~(1 << _), s += 1;
    var I = 32 - tn(i) + _;
    if (30 < I) {
      var A = _ - _ % 5;
      I = (d & (1 << A) - 1).toString(32), d >>= A, _ -= A, Ci = 1 << 32 - tn(i) + _ | s << _ | d, Si = I + n;
    } else Ci = 1 << I | s << _ | d, Si = n;
  }
  function Xc(n) {
    n.return !== null && (Ca(n, 1), I_(n, 1, 0));
  }
  function Qc(n) {
    for (; n === bl; ) bl = lo[--co], lo[co] = null, wl = lo[--co], lo[co] = null;
    for (; n === Ea; ) Ea = pn[--hn], pn[hn] = null, Si = pn[--hn], pn[hn] = null, Ci = pn[--hn], pn[hn] = null;
  }
  var nn = null, an = null, Gt = !1, wn = null;
  function v_(n, i) {
    var s = Cn(5, null, null, 0);
    s.elementType = "DELETED", s.stateNode = i, s.return = n, i = n.deletions, i === null ? (n.deletions = [s], n.flags |= 16) : i.push(s);
  }
  function g_(n, i) {
    switch (n.tag) {
      case 5:
        var s = n.type;
        return i = i.nodeType !== 1 || s.toLowerCase() !== i.nodeName.toLowerCase() ? null : i, i !== null ? (n.stateNode = i, nn = n, an = Fi(i.firstChild), !0) : !1;
      case 6:
        return i = n.pendingProps === "" || i.nodeType !== 3 ? null : i, i !== null ? (n.stateNode = i, nn = n, an = null, !0) : !1;
      case 13:
        return i = i.nodeType !== 8 ? null : i, i !== null ? (s = Ea !== null ? { id: Ci, overflow: Si } : null, n.memoizedState = { dehydrated: i, treeContext: s, retryLane: 1073741824 }, s = Cn(18, null, null, 0), s.stateNode = i, s.return = n, n.child = s, nn = n, an = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Jc(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function eu(n) {
    if (Gt) {
      var i = an;
      if (i) {
        var s = i;
        if (!g_(n, i)) {
          if (Jc(n)) throw Error(t(418));
          i = Fi(s.nextSibling);
          var d = nn;
          i && g_(n, i) ? v_(d, s) : (n.flags = n.flags & -4097 | 2, Gt = !1, nn = n);
        }
      } else {
        if (Jc(n)) throw Error(t(418));
        n.flags = n.flags & -4097 | 2, Gt = !1, nn = n;
      }
    }
  }
  function R_(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    nn = n;
  }
  function Hl(n) {
    if (n !== nn) return !1;
    if (!Gt) return R_(n), Gt = !0, !1;
    var i;
    if ((i = n.tag !== 3) && !(i = n.tag !== 5) && (i = n.type, i = i !== "head" && i !== "body" && !jc(n.type, n.memoizedProps)), i && (i = an)) {
      if (Jc(n)) throw D_(), Error(t(418));
      for (; i; ) v_(n, i), i = Fi(i.nextSibling);
    }
    if (R_(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(t(317));
      e: {
        for (n = n.nextSibling, i = 0; n; ) {
          if (n.nodeType === 8) {
            var s = n.data;
            if (s === "/$") {
              if (i === 0) {
                an = Fi(n.nextSibling);
                break e;
              }
              i--;
            } else s !== "$" && s !== "$!" && s !== "$?" || i++;
          }
          n = n.nextSibling;
        }
        an = null;
      }
    } else an = nn ? Fi(n.stateNode.nextSibling) : null;
    return !0;
  }
  function D_() {
    for (var n = an; n; ) n = Fi(n.nextSibling);
  }
  function uo() {
    an = nn = null, Gt = !1;
  }
  function tu(n) {
    wn === null ? wn = [n] : wn.push(n);
  }
  var $A = T.ReactCurrentBatchConfig;
  function cs(n, i, s) {
    if (n = s.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (s._owner) {
        if (s = s._owner, s) {
          if (s.tag !== 1) throw Error(t(309));
          var d = s.stateNode;
        }
        if (!d) throw Error(t(147, n));
        var _ = d, I = "" + n;
        return i !== null && i.ref !== null && typeof i.ref == "function" && i.ref._stringRef === I ? i.ref : (i = function(A) {
          var M = _.refs;
          A === null ? delete M[I] : M[I] = A;
        }, i._stringRef = I, i);
      }
      if (typeof n != "string") throw Error(t(284));
      if (!s._owner) throw Error(t(290, n));
    }
    return n;
  }
  function Vl(n, i) {
    throw n = Object.prototype.toString.call(i), Error(t(31, n === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : n));
  }
  function A_(n) {
    var i = n._init;
    return i(n._payload);
  }
  function T_(n) {
    function i(j, x) {
      if (n) {
        var K = j.deletions;
        K === null ? (j.deletions = [x], j.flags |= 16) : K.push(x);
      }
    }
    function s(j, x) {
      if (!n) return null;
      for (; x !== null; ) i(j, x), x = x.sibling;
      return null;
    }
    function d(j, x) {
      for (j = /* @__PURE__ */ new Map(); x !== null; ) x.key !== null ? j.set(x.key, x) : j.set(x.index, x), x = x.sibling;
      return j;
    }
    function _(j, x) {
      return j = Yi(j, x), j.index = 0, j.sibling = null, j;
    }
    function I(j, x, K) {
      return j.index = K, n ? (K = j.alternate, K !== null ? (K = K.index, K < x ? (j.flags |= 2, x) : K) : (j.flags |= 2, x)) : (j.flags |= 1048576, x);
    }
    function A(j) {
      return n && j.alternate === null && (j.flags |= 2), j;
    }
    function M(j, x, K, ve) {
      return x === null || x.tag !== 6 ? (x = zu(K, j.mode, ve), x.return = j, x) : (x = _(x, K), x.return = j, x);
    }
    function F(j, x, K, ve) {
      var Ge = K.type;
      return Ge === L ? he(j, x, K.props.children, ve, K.key) : x !== null && (x.elementType === Ge || typeof Ge == "object" && Ge !== null && Ge.$$typeof === se && A_(Ge) === x.type) ? (ve = _(x, K.props), ve.ref = cs(j, x, K), ve.return = j, ve) : (ve = o2(K.type, K.key, K.props, null, j.mode, ve), ve.ref = cs(j, x, K), ve.return = j, ve);
    }
    function ee(j, x, K, ve) {
      return x === null || x.tag !== 4 || x.stateNode.containerInfo !== K.containerInfo || x.stateNode.implementation !== K.implementation ? (x = qu(K, j.mode, ve), x.return = j, x) : (x = _(x, K.children || []), x.return = j, x);
    }
    function he(j, x, K, ve, Ge) {
      return x === null || x.tag !== 7 ? (x = Ta(K, j.mode, ve, Ge), x.return = j, x) : (x = _(x, K), x.return = j, x);
    }
    function Se(j, x, K) {
      if (typeof x == "string" && x !== "" || typeof x == "number") return x = zu("" + x, j.mode, K), x.return = j, x;
      if (typeof x == "object" && x !== null) {
        switch (x.$$typeof) {
          case N:
            return K = o2(x.type, x.key, x.props, null, j.mode, K), K.ref = cs(j, null, x), K.return = j, K;
          case b:
            return x = qu(x, j.mode, K), x.return = j, x;
          case se:
            var ve = x._init;
            return Se(j, ve(x._payload), K);
        }
        if (ht(x) || J(x)) return x = Ta(x, j.mode, K, null), x.return = j, x;
        Vl(j, x);
      }
      return null;
    }
    function pe(j, x, K, ve) {
      var Ge = x !== null ? x.key : null;
      if (typeof K == "string" && K !== "" || typeof K == "number") return Ge !== null ? null : M(j, x, "" + K, ve);
      if (typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case N:
            return K.key === Ge ? F(j, x, K, ve) : null;
          case b:
            return K.key === Ge ? ee(j, x, K, ve) : null;
          case se:
            return Ge = K._init, pe(
              j,
              x,
              Ge(K._payload),
              ve
            );
        }
        if (ht(K) || J(K)) return Ge !== null ? null : he(j, x, K, ve, null);
        Vl(j, K);
      }
      return null;
    }
    function be(j, x, K, ve, Ge) {
      if (typeof ve == "string" && ve !== "" || typeof ve == "number") return j = j.get(K) || null, M(x, j, "" + ve, Ge);
      if (typeof ve == "object" && ve !== null) {
        switch (ve.$$typeof) {
          case N:
            return j = j.get(ve.key === null ? K : ve.key) || null, F(x, j, ve, Ge);
          case b:
            return j = j.get(ve.key === null ? K : ve.key) || null, ee(x, j, ve, Ge);
          case se:
            var qe = ve._init;
            return be(j, x, K, qe(ve._payload), Ge);
        }
        if (ht(ve) || J(ve)) return j = j.get(K) || null, he(x, j, ve, Ge, null);
        Vl(x, ve);
      }
      return null;
    }
    function Ue(j, x, K, ve) {
      for (var Ge = null, qe = null, We = x, Qe = x = 0, Cr = null; We !== null && Qe < K.length; Qe++) {
        We.index > Qe ? (Cr = We, We = null) : Cr = We.sibling;
        var Dt = pe(j, We, K[Qe], ve);
        if (Dt === null) {
          We === null && (We = Cr);
          break;
        }
        n && We && Dt.alternate === null && i(j, We), x = I(Dt, x, Qe), qe === null ? Ge = Dt : qe.sibling = Dt, qe = Dt, We = Cr;
      }
      if (Qe === K.length) return s(j, We), Gt && Ca(j, Qe), Ge;
      if (We === null) {
        for (; Qe < K.length; Qe++) We = Se(j, K[Qe], ve), We !== null && (x = I(We, x, Qe), qe === null ? Ge = We : qe.sibling = We, qe = We);
        return Gt && Ca(j, Qe), Ge;
      }
      for (We = d(j, We); Qe < K.length; Qe++) Cr = be(We, j, Qe, K[Qe], ve), Cr !== null && (n && Cr.alternate !== null && We.delete(Cr.key === null ? Qe : Cr.key), x = I(Cr, x, Qe), qe === null ? Ge = Cr : qe.sibling = Cr, qe = Cr);
      return n && We.forEach(function(Ki) {
        return i(j, Ki);
      }), Gt && Ca(j, Qe), Ge;
    }
    function $e(j, x, K, ve) {
      var Ge = J(K);
      if (typeof Ge != "function") throw Error(t(150));
      if (K = Ge.call(K), K == null) throw Error(t(151));
      for (var qe = Ge = null, We = x, Qe = x = 0, Cr = null, Dt = K.next(); We !== null && !Dt.done; Qe++, Dt = K.next()) {
        We.index > Qe ? (Cr = We, We = null) : Cr = We.sibling;
        var Ki = pe(j, We, Dt.value, ve);
        if (Ki === null) {
          We === null && (We = Cr);
          break;
        }
        n && We && Ki.alternate === null && i(j, We), x = I(Ki, x, Qe), qe === null ? Ge = Ki : qe.sibling = Ki, qe = Ki, We = Cr;
      }
      if (Dt.done) return s(
        j,
        We
      ), Gt && Ca(j, Qe), Ge;
      if (We === null) {
        for (; !Dt.done; Qe++, Dt = K.next()) Dt = Se(j, Dt.value, ve), Dt !== null && (x = I(Dt, x, Qe), qe === null ? Ge = Dt : qe.sibling = Dt, qe = Dt);
        return Gt && Ca(j, Qe), Ge;
      }
      for (We = d(j, We); !Dt.done; Qe++, Dt = K.next()) Dt = be(We, j, Qe, Dt.value, ve), Dt !== null && (n && Dt.alternate !== null && We.delete(Dt.key === null ? Qe : Dt.key), x = I(Dt, x, Qe), qe === null ? Ge = Dt : qe.sibling = Dt, qe = Dt);
      return n && We.forEach(function(vT) {
        return i(j, vT);
      }), Gt && Ca(j, Qe), Ge;
    }
    function ir(j, x, K, ve) {
      if (typeof K == "object" && K !== null && K.type === L && K.key === null && (K = K.props.children), typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case N:
            e: {
              for (var Ge = K.key, qe = x; qe !== null; ) {
                if (qe.key === Ge) {
                  if (Ge = K.type, Ge === L) {
                    if (qe.tag === 7) {
                      s(j, qe.sibling), x = _(qe, K.props.children), x.return = j, j = x;
                      break e;
                    }
                  } else if (qe.elementType === Ge || typeof Ge == "object" && Ge !== null && Ge.$$typeof === se && A_(Ge) === qe.type) {
                    s(j, qe.sibling), x = _(qe, K.props), x.ref = cs(j, qe, K), x.return = j, j = x;
                    break e;
                  }
                  s(j, qe);
                  break;
                } else i(j, qe);
                qe = qe.sibling;
              }
              K.type === L ? (x = Ta(K.props.children, j.mode, ve, K.key), x.return = j, j = x) : (ve = o2(K.type, K.key, K.props, null, j.mode, ve), ve.ref = cs(j, x, K), ve.return = j, j = ve);
            }
            return A(j);
          case b:
            e: {
              for (qe = K.key; x !== null; ) {
                if (x.key === qe) if (x.tag === 4 && x.stateNode.containerInfo === K.containerInfo && x.stateNode.implementation === K.implementation) {
                  s(j, x.sibling), x = _(x, K.children || []), x.return = j, j = x;
                  break e;
                } else {
                  s(j, x);
                  break;
                }
                else i(j, x);
                x = x.sibling;
              }
              x = qu(K, j.mode, ve), x.return = j, j = x;
            }
            return A(j);
          case se:
            return qe = K._init, ir(j, x, qe(K._payload), ve);
        }
        if (ht(K)) return Ue(j, x, K, ve);
        if (J(K)) return $e(j, x, K, ve);
        Vl(j, K);
      }
      return typeof K == "string" && K !== "" || typeof K == "number" ? (K = "" + K, x !== null && x.tag === 6 ? (s(j, x.sibling), x = _(x, K), x.return = j, j = x) : (s(j, x), x = zu(K, j.mode, ve), x.return = j, j = x), A(j)) : s(j, x);
    }
    return ir;
  }
  var fo = T_(!0), O_ = T_(!1), kl = Ui(null), Fl = null, po = null, ru = null;
  function nu() {
    ru = po = Fl = null;
  }
  function iu(n) {
    var i = kl.current;
    Bt(kl), n._currentValue = i;
  }
  function au(n, i, s) {
    for (; n !== null; ) {
      var d = n.alternate;
      if ((n.childLanes & i) !== i ? (n.childLanes |= i, d !== null && (d.childLanes |= i)) : d !== null && (d.childLanes & i) !== i && (d.childLanes |= i), n === s) break;
      n = n.return;
    }
  }
  function ho(n, i) {
    Fl = n, ru = po = null, n = n.dependencies, n !== null && n.firstContext !== null && ((n.lanes & i) !== 0 && (zr = !0), n.firstContext = null);
  }
  function _n(n) {
    var i = n._currentValue;
    if (ru !== n) if (n = { context: n, memoizedValue: i, next: null }, po === null) {
      if (Fl === null) throw Error(t(308));
      po = n, Fl.dependencies = { lanes: 0, firstContext: n };
    } else po = po.next = n;
    return i;
  }
  var Sa = null;
  function ou(n) {
    Sa === null ? Sa = [n] : Sa.push(n);
  }
  function y_(n, i, s, d) {
    var _ = i.interleaved;
    return _ === null ? (s.next = s, ou(i)) : (s.next = _.next, _.next = s), i.interleaved = s, Ii(n, d);
  }
  function Ii(n, i) {
    n.lanes |= i;
    var s = n.alternate;
    for (s !== null && (s.lanes |= i), s = n, n = n.return; n !== null; ) n.childLanes |= i, s = n.alternate, s !== null && (s.childLanes |= i), s = n, n = n.return;
    return s.tag === 3 ? s.stateNode : null;
  }
  var $i = !1;
  function su(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function N_(n, i) {
    n = n.updateQueue, i.updateQueue === n && (i.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function vi(n, i) {
    return { eventTime: n, lane: i, tag: 0, payload: null, callback: null, next: null };
  }
  function Gi(n, i, s) {
    var d = n.updateQueue;
    if (d === null) return null;
    if (d = d.shared, (gt & 2) !== 0) {
      var _ = d.pending;
      return _ === null ? i.next = i : (i.next = _.next, _.next = i), d.pending = i, Ii(n, s);
    }
    return _ = d.interleaved, _ === null ? (i.next = i, ou(d)) : (i.next = _.next, _.next = i), d.interleaved = i, Ii(n, s);
  }
  function Ul(n, i, s) {
    if (i = i.updateQueue, i !== null && (i = i.shared, (s & 4194240) !== 0)) {
      var d = i.lanes;
      d &= n.pendingLanes, s |= d, i.lanes = s, zo(n, s);
    }
  }
  function L_(n, i) {
    var s = n.updateQueue, d = n.alternate;
    if (d !== null && (d = d.updateQueue, s === d)) {
      var _ = null, I = null;
      if (s = s.firstBaseUpdate, s !== null) {
        do {
          var A = { eventTime: s.eventTime, lane: s.lane, tag: s.tag, payload: s.payload, callback: s.callback, next: null };
          I === null ? _ = I = A : I = I.next = A, s = s.next;
        } while (s !== null);
        I === null ? _ = I = i : I = I.next = i;
      } else _ = I = i;
      s = { baseState: d.baseState, firstBaseUpdate: _, lastBaseUpdate: I, shared: d.shared, effects: d.effects }, n.updateQueue = s;
      return;
    }
    n = s.lastBaseUpdate, n === null ? s.firstBaseUpdate = i : n.next = i, s.lastBaseUpdate = i;
  }
  function xl(n, i, s, d) {
    var _ = n.updateQueue;
    $i = !1;
    var I = _.firstBaseUpdate, A = _.lastBaseUpdate, M = _.shared.pending;
    if (M !== null) {
      _.shared.pending = null;
      var F = M, ee = F.next;
      F.next = null, A === null ? I = ee : A.next = ee, A = F;
      var he = n.alternate;
      he !== null && (he = he.updateQueue, M = he.lastBaseUpdate, M !== A && (M === null ? he.firstBaseUpdate = ee : M.next = ee, he.lastBaseUpdate = F));
    }
    if (I !== null) {
      var Se = _.baseState;
      A = 0, he = ee = F = null, M = I;
      do {
        var pe = M.lane, be = M.eventTime;
        if ((d & pe) === pe) {
          he !== null && (he = he.next = {
            eventTime: be,
            lane: 0,
            tag: M.tag,
            payload: M.payload,
            callback: M.callback,
            next: null
          });
          e: {
            var Ue = n, $e = M;
            switch (pe = i, be = s, $e.tag) {
              case 1:
                if (Ue = $e.payload, typeof Ue == "function") {
                  Se = Ue.call(be, Se, pe);
                  break e;
                }
                Se = Ue;
                break e;
              case 3:
                Ue.flags = Ue.flags & -65537 | 128;
              case 0:
                if (Ue = $e.payload, pe = typeof Ue == "function" ? Ue.call(be, Se, pe) : Ue, pe == null) break e;
                Se = Q({}, Se, pe);
                break e;
              case 2:
                $i = !0;
            }
          }
          M.callback !== null && M.lane !== 0 && (n.flags |= 64, pe = _.effects, pe === null ? _.effects = [M] : pe.push(M));
        } else be = { eventTime: be, lane: pe, tag: M.tag, payload: M.payload, callback: M.callback, next: null }, he === null ? (ee = he = be, F = Se) : he = he.next = be, A |= pe;
        if (M = M.next, M === null) {
          if (M = _.shared.pending, M === null) break;
          pe = M, M = pe.next, pe.next = null, _.lastBaseUpdate = pe, _.shared.pending = null;
        }
      } while (!0);
      if (he === null && (F = Se), _.baseState = F, _.firstBaseUpdate = ee, _.lastBaseUpdate = he, i = _.shared.interleaved, i !== null) {
        _ = i;
        do
          A |= _.lane, _ = _.next;
        while (_ !== i);
      } else I === null && (_.shared.lanes = 0);
      ga |= A, n.lanes = A, n.memoizedState = Se;
    }
  }
  function M_(n, i, s) {
    if (n = i.effects, i.effects = null, n !== null) for (i = 0; i < n.length; i++) {
      var d = n[i], _ = d.callback;
      if (_ !== null) {
        if (d.callback = null, d = s, typeof _ != "function") throw Error(t(191, _));
        _.call(d);
      }
    }
  }
  var us = {}, Jn = Ui(us), fs = Ui(us), ds = Ui(us);
  function Ia(n) {
    if (n === us) throw Error(t(174));
    return n;
  }
  function lu(n, i) {
    switch (kt(ds, i), kt(fs, n), kt(Jn, us), n = i.nodeType, n) {
      case 9:
      case 11:
        i = (i = i.documentElement) ? i.namespaceURI : He(null, "");
        break;
      default:
        n = n === 8 ? i.parentNode : i, i = n.namespaceURI || null, n = n.tagName, i = He(i, n);
    }
    Bt(Jn), kt(Jn, i);
  }
  function _o() {
    Bt(Jn), Bt(fs), Bt(ds);
  }
  function P_(n) {
    Ia(ds.current);
    var i = Ia(Jn.current), s = He(i, n.type);
    i !== s && (kt(fs, n), kt(Jn, s));
  }
  function cu(n) {
    fs.current === n && (Bt(Jn), Bt(fs));
  }
  var Wt = Ui(0);
  function Bl(n) {
    for (var i = n; i !== null; ) {
      if (i.tag === 13) {
        var s = i.memoizedState;
        if (s !== null && (s = s.dehydrated, s === null || s.data === "$?" || s.data === "$!")) return i;
      } else if (i.tag === 19 && i.memoizedProps.revealOrder !== void 0) {
        if ((i.flags & 128) !== 0) return i;
      } else if (i.child !== null) {
        i.child.return = i, i = i.child;
        continue;
      }
      if (i === n) break;
      for (; i.sibling === null; ) {
        if (i.return === null || i.return === n) return null;
        i = i.return;
      }
      i.sibling.return = i.return, i = i.sibling;
    }
    return null;
  }
  var uu = [];
  function fu() {
    for (var n = 0; n < uu.length; n++) uu[n]._workInProgressVersionPrimary = null;
    uu.length = 0;
  }
  var $l = T.ReactCurrentDispatcher, du = T.ReactCurrentBatchConfig, va = 0, Yt = null, fr = null, mr = null, Gl = !1, ps = !1, hs = 0, GA = 0;
  function Nr() {
    throw Error(t(321));
  }
  function pu(n, i) {
    if (i === null) return !1;
    for (var s = 0; s < i.length && s < n.length; s++) if (!bn(n[s], i[s])) return !1;
    return !0;
  }
  function hu(n, i, s, d, _, I) {
    if (va = I, Yt = i, i.memoizedState = null, i.updateQueue = null, i.lanes = 0, $l.current = n === null || n.memoizedState === null ? qA : WA, n = s(d, _), ps) {
      I = 0;
      do {
        if (ps = !1, hs = 0, 25 <= I) throw Error(t(301));
        I += 1, mr = fr = null, i.updateQueue = null, $l.current = YA, n = s(d, _);
      } while (ps);
    }
    if ($l.current = zl, i = fr !== null && fr.next !== null, va = 0, mr = fr = Yt = null, Gl = !1, i) throw Error(t(300));
    return n;
  }
  function _u() {
    var n = hs !== 0;
    return hs = 0, n;
  }
  function ei() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return mr === null ? Yt.memoizedState = mr = n : mr = mr.next = n, mr;
  }
  function mn() {
    if (fr === null) {
      var n = Yt.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = fr.next;
    var i = mr === null ? Yt.memoizedState : mr.next;
    if (i !== null) mr = i, fr = n;
    else {
      if (n === null) throw Error(t(310));
      fr = n, n = { memoizedState: fr.memoizedState, baseState: fr.baseState, baseQueue: fr.baseQueue, queue: fr.queue, next: null }, mr === null ? Yt.memoizedState = mr = n : mr = mr.next = n;
    }
    return mr;
  }
  function _s(n, i) {
    return typeof i == "function" ? i(n) : i;
  }
  function mu(n) {
    var i = mn(), s = i.queue;
    if (s === null) throw Error(t(311));
    s.lastRenderedReducer = n;
    var d = fr, _ = d.baseQueue, I = s.pending;
    if (I !== null) {
      if (_ !== null) {
        var A = _.next;
        _.next = I.next, I.next = A;
      }
      d.baseQueue = _ = I, s.pending = null;
    }
    if (_ !== null) {
      I = _.next, d = d.baseState;
      var M = A = null, F = null, ee = I;
      do {
        var he = ee.lane;
        if ((va & he) === he) F !== null && (F = F.next = { lane: 0, action: ee.action, hasEagerState: ee.hasEagerState, eagerState: ee.eagerState, next: null }), d = ee.hasEagerState ? ee.eagerState : n(d, ee.action);
        else {
          var Se = {
            lane: he,
            action: ee.action,
            hasEagerState: ee.hasEagerState,
            eagerState: ee.eagerState,
            next: null
          };
          F === null ? (M = F = Se, A = d) : F = F.next = Se, Yt.lanes |= he, ga |= he;
        }
        ee = ee.next;
      } while (ee !== null && ee !== I);
      F === null ? A = d : F.next = M, bn(d, i.memoizedState) || (zr = !0), i.memoizedState = d, i.baseState = A, i.baseQueue = F, s.lastRenderedState = d;
    }
    if (n = s.interleaved, n !== null) {
      _ = n;
      do
        I = _.lane, Yt.lanes |= I, ga |= I, _ = _.next;
      while (_ !== n);
    } else _ === null && (s.lanes = 0);
    return [i.memoizedState, s.dispatch];
  }
  function Eu(n) {
    var i = mn(), s = i.queue;
    if (s === null) throw Error(t(311));
    s.lastRenderedReducer = n;
    var d = s.dispatch, _ = s.pending, I = i.memoizedState;
    if (_ !== null) {
      s.pending = null;
      var A = _ = _.next;
      do
        I = n(I, A.action), A = A.next;
      while (A !== _);
      bn(I, i.memoizedState) || (zr = !0), i.memoizedState = I, i.baseQueue === null && (i.baseState = I), s.lastRenderedState = I;
    }
    return [I, d];
  }
  function b_() {
  }
  function w_(n, i) {
    var s = Yt, d = mn(), _ = i(), I = !bn(d.memoizedState, _);
    if (I && (d.memoizedState = _, zr = !0), d = d.queue, Cu(k_.bind(null, s, d, n), [n]), d.getSnapshot !== i || I || mr !== null && mr.memoizedState.tag & 1) {
      if (s.flags |= 2048, ms(9, V_.bind(null, s, d, _, i), void 0, null), Er === null) throw Error(t(349));
      (va & 30) !== 0 || H_(s, i, _);
    }
    return _;
  }
  function H_(n, i, s) {
    n.flags |= 16384, n = { getSnapshot: i, value: s }, i = Yt.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Yt.updateQueue = i, i.stores = [n]) : (s = i.stores, s === null ? i.stores = [n] : s.push(n));
  }
  function V_(n, i, s, d) {
    i.value = s, i.getSnapshot = d, F_(i) && U_(n);
  }
  function k_(n, i, s) {
    return s(function() {
      F_(i) && U_(n);
    });
  }
  function F_(n) {
    var i = n.getSnapshot;
    n = n.value;
    try {
      var s = i();
      return !bn(n, s);
    } catch (d) {
      return !0;
    }
  }
  function U_(n) {
    var i = Ii(n, 1);
    i !== null && Fn(i, n, 1, -1);
  }
  function x_(n) {
    var i = ei();
    return typeof n == "function" && (n = n()), i.memoizedState = i.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: _s, lastRenderedState: n }, i.queue = n, n = n.dispatch = zA.bind(null, Yt, n), [i.memoizedState, n];
  }
  function ms(n, i, s, d) {
    return n = { tag: n, create: i, destroy: s, deps: d, next: null }, i = Yt.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Yt.updateQueue = i, i.lastEffect = n.next = n) : (s = i.lastEffect, s === null ? i.lastEffect = n.next = n : (d = s.next, s.next = n, n.next = d, i.lastEffect = n)), n;
  }
  function B_() {
    return mn().memoizedState;
  }
  function Zl(n, i, s, d) {
    var _ = ei();
    Yt.flags |= n, _.memoizedState = ms(1 | i, s, void 0, d === void 0 ? null : d);
  }
  function jl(n, i, s, d) {
    var _ = mn();
    d = d === void 0 ? null : d;
    var I = void 0;
    if (fr !== null) {
      var A = fr.memoizedState;
      if (I = A.destroy, d !== null && pu(d, A.deps)) {
        _.memoizedState = ms(i, s, I, d);
        return;
      }
    }
    Yt.flags |= n, _.memoizedState = ms(1 | i, s, I, d);
  }
  function $_(n, i) {
    return Zl(8390656, 8, n, i);
  }
  function Cu(n, i) {
    return jl(2048, 8, n, i);
  }
  function G_(n, i) {
    return jl(4, 2, n, i);
  }
  function Z_(n, i) {
    return jl(4, 4, n, i);
  }
  function j_(n, i) {
    if (typeof i == "function") return n = n(), i(n), function() {
      i(null);
    };
    if (i != null) return n = n(), i.current = n, function() {
      i.current = null;
    };
  }
  function z_(n, i, s) {
    return s = s != null ? s.concat([n]) : null, jl(4, 4, j_.bind(null, i, n), s);
  }
  function Su() {
  }
  function q_(n, i) {
    var s = mn();
    i = i === void 0 ? null : i;
    var d = s.memoizedState;
    return d !== null && i !== null && pu(i, d[1]) ? d[0] : (s.memoizedState = [n, i], n);
  }
  function W_(n, i) {
    var s = mn();
    i = i === void 0 ? null : i;
    var d = s.memoizedState;
    return d !== null && i !== null && pu(i, d[1]) ? d[0] : (n = n(), s.memoizedState = [n, i], n);
  }
  function Y_(n, i, s) {
    return (va & 21) === 0 ? (n.baseState && (n.baseState = !1, zr = !0), n.memoizedState = s) : (bn(s, i) || (s = cl(), Yt.lanes |= s, ga |= s, n.baseState = !0), i);
  }
  function ZA(n, i) {
    var s = Ot;
    Ot = s !== 0 && 4 > s ? s : 4, n(!0);
    var d = du.transition;
    du.transition = {};
    try {
      n(!1), i();
    } finally {
      Ot = s, du.transition = d;
    }
  }
  function K_() {
    return mn().memoizedState;
  }
  function jA(n, i, s) {
    var d = qi(n);
    if (s = { lane: d, action: s, hasEagerState: !1, eagerState: null, next: null }, X_(n)) Q_(i, s);
    else if (s = y_(n, i, s, d), s !== null) {
      var _ = Br();
      Fn(s, n, d, _), J_(s, i, d);
    }
  }
  function zA(n, i, s) {
    var d = qi(n), _ = { lane: d, action: s, hasEagerState: !1, eagerState: null, next: null };
    if (X_(n)) Q_(i, _);
    else {
      var I = n.alternate;
      if (n.lanes === 0 && (I === null || I.lanes === 0) && (I = i.lastRenderedReducer, I !== null)) try {
        var A = i.lastRenderedState, M = I(A, s);
        if (_.hasEagerState = !0, _.eagerState = M, bn(M, A)) {
          var F = i.interleaved;
          F === null ? (_.next = _, ou(i)) : (_.next = F.next, F.next = _), i.interleaved = _;
          return;
        }
      } catch (ee) {
      } finally {
      }
      s = y_(n, i, _, d), s !== null && (_ = Br(), Fn(s, n, d, _), J_(s, i, d));
    }
  }
  function X_(n) {
    var i = n.alternate;
    return n === Yt || i !== null && i === Yt;
  }
  function Q_(n, i) {
    ps = Gl = !0;
    var s = n.pending;
    s === null ? i.next = i : (i.next = s.next, s.next = i), n.pending = i;
  }
  function J_(n, i, s) {
    if ((s & 4194240) !== 0) {
      var d = i.lanes;
      d &= n.pendingLanes, s |= d, i.lanes = s, zo(n, s);
    }
  }
  var zl = { readContext: _n, useCallback: Nr, useContext: Nr, useEffect: Nr, useImperativeHandle: Nr, useInsertionEffect: Nr, useLayoutEffect: Nr, useMemo: Nr, useReducer: Nr, useRef: Nr, useState: Nr, useDebugValue: Nr, useDeferredValue: Nr, useTransition: Nr, useMutableSource: Nr, useSyncExternalStore: Nr, useId: Nr, unstable_isNewReconciler: !1 }, qA = { readContext: _n, useCallback: function(n, i) {
    return ei().memoizedState = [n, i === void 0 ? null : i], n;
  }, useContext: _n, useEffect: $_, useImperativeHandle: function(n, i, s) {
    return s = s != null ? s.concat([n]) : null, Zl(
      4194308,
      4,
      j_.bind(null, i, n),
      s
    );
  }, useLayoutEffect: function(n, i) {
    return Zl(4194308, 4, n, i);
  }, useInsertionEffect: function(n, i) {
    return Zl(4, 2, n, i);
  }, useMemo: function(n, i) {
    var s = ei();
    return i = i === void 0 ? null : i, n = n(), s.memoizedState = [n, i], n;
  }, useReducer: function(n, i, s) {
    var d = ei();
    return i = s !== void 0 ? s(i) : i, d.memoizedState = d.baseState = i, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: i }, d.queue = n, n = n.dispatch = jA.bind(null, Yt, n), [d.memoizedState, n];
  }, useRef: function(n) {
    var i = ei();
    return n = { current: n }, i.memoizedState = n;
  }, useState: x_, useDebugValue: Su, useDeferredValue: function(n) {
    return ei().memoizedState = n;
  }, useTransition: function() {
    var n = x_(!1), i = n[0];
    return n = ZA.bind(null, n[1]), ei().memoizedState = n, [i, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, i, s) {
    var d = Yt, _ = ei();
    if (Gt) {
      if (s === void 0) throw Error(t(407));
      s = s();
    } else {
      if (s = i(), Er === null) throw Error(t(349));
      (va & 30) !== 0 || H_(d, i, s);
    }
    _.memoizedState = s;
    var I = { value: s, getSnapshot: i };
    return _.queue = I, $_(k_.bind(
      null,
      d,
      I,
      n
    ), [n]), d.flags |= 2048, ms(9, V_.bind(null, d, I, s, i), void 0, null), s;
  }, useId: function() {
    var n = ei(), i = Er.identifierPrefix;
    if (Gt) {
      var s = Si, d = Ci;
      s = (d & ~(1 << 32 - tn(d) - 1)).toString(32) + s, i = ":" + i + "R" + s, s = hs++, 0 < s && (i += "H" + s.toString(32)), i += ":";
    } else s = GA++, i = ":" + i + "r" + s.toString(32) + ":";
    return n.memoizedState = i;
  }, unstable_isNewReconciler: !1 }, WA = {
    readContext: _n,
    useCallback: q_,
    useContext: _n,
    useEffect: Cu,
    useImperativeHandle: z_,
    useInsertionEffect: G_,
    useLayoutEffect: Z_,
    useMemo: W_,
    useReducer: mu,
    useRef: B_,
    useState: function() {
      return mu(_s);
    },
    useDebugValue: Su,
    useDeferredValue: function(n) {
      var i = mn();
      return Y_(i, fr.memoizedState, n);
    },
    useTransition: function() {
      var n = mu(_s)[0], i = mn().memoizedState;
      return [n, i];
    },
    useMutableSource: b_,
    useSyncExternalStore: w_,
    useId: K_,
    unstable_isNewReconciler: !1
  }, YA = { readContext: _n, useCallback: q_, useContext: _n, useEffect: Cu, useImperativeHandle: z_, useInsertionEffect: G_, useLayoutEffect: Z_, useMemo: W_, useReducer: Eu, useRef: B_, useState: function() {
    return Eu(_s);
  }, useDebugValue: Su, useDeferredValue: function(n) {
    var i = mn();
    return fr === null ? i.memoizedState = n : Y_(i, fr.memoizedState, n);
  }, useTransition: function() {
    var n = Eu(_s)[0], i = mn().memoizedState;
    return [n, i];
  }, useMutableSource: b_, useSyncExternalStore: w_, useId: K_, unstable_isNewReconciler: !1 };
  function Hn(n, i) {
    if (n && n.defaultProps) {
      i = Q({}, i), n = n.defaultProps;
      for (var s in n) i[s] === void 0 && (i[s] = n[s]);
      return i;
    }
    return i;
  }
  function Iu(n, i, s, d) {
    i = n.memoizedState, s = s(d, i), s = s == null ? i : Q({}, i, s), n.memoizedState = s, n.lanes === 0 && (n.updateQueue.baseState = s);
  }
  var ql = { isMounted: function(n) {
    return (n = n._reactInternals) ? dn(n) === n : !1;
  }, enqueueSetState: function(n, i, s) {
    n = n._reactInternals;
    var d = Br(), _ = qi(n), I = vi(d, _);
    I.payload = i, s != null && (I.callback = s), i = Gi(n, I, _), i !== null && (Fn(i, n, _, d), Ul(i, n, _));
  }, enqueueReplaceState: function(n, i, s) {
    n = n._reactInternals;
    var d = Br(), _ = qi(n), I = vi(d, _);
    I.tag = 1, I.payload = i, s != null && (I.callback = s), i = Gi(n, I, _), i !== null && (Fn(i, n, _, d), Ul(i, n, _));
  }, enqueueForceUpdate: function(n, i) {
    n = n._reactInternals;
    var s = Br(), d = qi(n), _ = vi(s, d);
    _.tag = 2, i != null && (_.callback = i), i = Gi(n, _, d), i !== null && (Fn(i, n, d, s), Ul(i, n, d));
  } };
  function em(n, i, s, d, _, I, A) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(d, I, A) : i.prototype && i.prototype.isPureReactComponent ? !rs(s, d) || !rs(_, I) : !0;
  }
  function tm(n, i, s) {
    var d = !1, _ = xi, I = i.contextType;
    return typeof I == "object" && I !== null ? I = _n(I) : (_ = jr(i) ? ma : yr.current, d = i.contextTypes, I = (d = d != null) ? so(n, _) : xi), i = new i(s, I), n.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, i.updater = ql, n.stateNode = i, i._reactInternals = n, d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = _, n.__reactInternalMemoizedMaskedChildContext = I), i;
  }
  function rm(n, i, s, d) {
    n = i.state, typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps(s, d), typeof i.UNSAFE_componentWillReceiveProps == "function" && i.UNSAFE_componentWillReceiveProps(s, d), i.state !== n && ql.enqueueReplaceState(i, i.state, null);
  }
  function vu(n, i, s, d) {
    var _ = n.stateNode;
    _.props = s, _.state = n.memoizedState, _.refs = {}, su(n);
    var I = i.contextType;
    typeof I == "object" && I !== null ? _.context = _n(I) : (I = jr(i) ? ma : yr.current, _.context = so(n, I)), _.state = n.memoizedState, I = i.getDerivedStateFromProps, typeof I == "function" && (Iu(n, i, I, s), _.state = n.memoizedState), typeof i.getDerivedStateFromProps == "function" || typeof _.getSnapshotBeforeUpdate == "function" || typeof _.UNSAFE_componentWillMount != "function" && typeof _.componentWillMount != "function" || (i = _.state, typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount(), i !== _.state && ql.enqueueReplaceState(_, _.state, null), xl(n, s, _, d), _.state = n.memoizedState), typeof _.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function mo(n, i) {
    try {
      var s = "", d = i;
      do
        s += ie(d), d = d.return;
      while (d);
      var _ = s;
    } catch (I) {
      _ = `
Error generating stack: ` + I.message + `
` + I.stack;
    }
    return { value: n, source: i, stack: _, digest: null };
  }
  function gu(n, i, s) {
    return { value: n, source: null, stack: s != null ? s : null, digest: i != null ? i : null };
  }
  function Ru(n, i) {
    try {
      console.error(i.value);
    } catch (s) {
      setTimeout(function() {
        throw s;
      });
    }
  }
  var KA = typeof WeakMap == "function" ? WeakMap : Map;
  function nm(n, i, s) {
    s = vi(-1, s), s.tag = 3, s.payload = { element: null };
    var d = i.value;
    return s.callback = function() {
      e2 || (e2 = !0, Fu = d), Ru(n, i);
    }, s;
  }
  function im(n, i, s) {
    s = vi(-1, s), s.tag = 3;
    var d = n.type.getDerivedStateFromError;
    if (typeof d == "function") {
      var _ = i.value;
      s.payload = function() {
        return d(_);
      }, s.callback = function() {
        Ru(n, i);
      };
    }
    var I = n.stateNode;
    return I !== null && typeof I.componentDidCatch == "function" && (s.callback = function() {
      Ru(n, i), typeof d != "function" && (ji === null ? ji = /* @__PURE__ */ new Set([this]) : ji.add(this));
      var A = i.stack;
      this.componentDidCatch(i.value, { componentStack: A !== null ? A : "" });
    }), s;
  }
  function am(n, i, s) {
    var d = n.pingCache;
    if (d === null) {
      d = n.pingCache = new KA();
      var _ = /* @__PURE__ */ new Set();
      d.set(i, _);
    } else _ = d.get(i), _ === void 0 && (_ = /* @__PURE__ */ new Set(), d.set(i, _));
    _.has(s) || (_.add(s), n = uT.bind(null, n, i, s), i.then(n, n));
  }
  function om(n) {
    do {
      var i;
      if ((i = n.tag === 13) && (i = n.memoizedState, i = i !== null ? i.dehydrated !== null : !0), i) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function sm(n, i, s, d, _) {
    return (n.mode & 1) === 0 ? (n === i ? n.flags |= 65536 : (n.flags |= 128, s.flags |= 131072, s.flags &= -52805, s.tag === 1 && (s.alternate === null ? s.tag = 17 : (i = vi(-1, 1), i.tag = 2, Gi(s, i, 1))), s.lanes |= 1), n) : (n.flags |= 65536, n.lanes = _, n);
  }
  var XA = T.ReactCurrentOwner, zr = !1;
  function xr(n, i, s, d) {
    i.child = n === null ? O_(i, null, s, d) : fo(i, n.child, s, d);
  }
  function lm(n, i, s, d, _) {
    s = s.render;
    var I = i.ref;
    return ho(i, _), d = hu(n, i, s, d, I, _), s = _u(), n !== null && !zr ? (i.updateQueue = n.updateQueue, i.flags &= -2053, n.lanes &= ~_, gi(n, i, _)) : (Gt && s && Xc(i), i.flags |= 1, xr(n, i, d, _), i.child);
  }
  function cm(n, i, s, d, _) {
    if (n === null) {
      var I = s.type;
      return typeof I == "function" && !ju(I) && I.defaultProps === void 0 && s.compare === null && s.defaultProps === void 0 ? (i.tag = 15, i.type = I, um(n, i, I, d, _)) : (n = o2(s.type, null, d, i, i.mode, _), n.ref = i.ref, n.return = i, i.child = n);
    }
    if (I = n.child, (n.lanes & _) === 0) {
      var A = I.memoizedProps;
      if (s = s.compare, s = s !== null ? s : rs, s(A, d) && n.ref === i.ref) return gi(n, i, _);
    }
    return i.flags |= 1, n = Yi(I, d), n.ref = i.ref, n.return = i, i.child = n;
  }
  function um(n, i, s, d, _) {
    if (n !== null) {
      var I = n.memoizedProps;
      if (rs(I, d) && n.ref === i.ref) if (zr = !1, i.pendingProps = d = I, (n.lanes & _) !== 0) (n.flags & 131072) !== 0 && (zr = !0);
      else return i.lanes = n.lanes, gi(n, i, _);
    }
    return Du(n, i, s, d, _);
  }
  function fm(n, i, s) {
    var d = i.pendingProps, _ = d.children, I = n !== null ? n.memoizedState : null;
    if (d.mode === "hidden") if ((i.mode & 1) === 0) i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, kt(Co, on), on |= s;
    else {
      if ((s & 1073741824) === 0) return n = I !== null ? I.baseLanes | s : s, i.lanes = i.childLanes = 1073741824, i.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, i.updateQueue = null, kt(Co, on), on |= n, null;
      i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, d = I !== null ? I.baseLanes : s, kt(Co, on), on |= d;
    }
    else I !== null ? (d = I.baseLanes | s, i.memoizedState = null) : d = s, kt(Co, on), on |= d;
    return xr(n, i, _, s), i.child;
  }
  function dm(n, i) {
    var s = i.ref;
    (n === null && s !== null || n !== null && n.ref !== s) && (i.flags |= 512, i.flags |= 2097152);
  }
  function Du(n, i, s, d, _) {
    var I = jr(s) ? ma : yr.current;
    return I = so(i, I), ho(i, _), s = hu(n, i, s, d, I, _), d = _u(), n !== null && !zr ? (i.updateQueue = n.updateQueue, i.flags &= -2053, n.lanes &= ~_, gi(n, i, _)) : (Gt && d && Xc(i), i.flags |= 1, xr(n, i, s, _), i.child);
  }
  function pm(n, i, s, d, _) {
    if (jr(s)) {
      var I = !0;
      Ml(i);
    } else I = !1;
    if (ho(i, _), i.stateNode === null) Yl(n, i), tm(i, s, d), vu(i, s, d, _), d = !0;
    else if (n === null) {
      var A = i.stateNode, M = i.memoizedProps;
      A.props = M;
      var F = A.context, ee = s.contextType;
      typeof ee == "object" && ee !== null ? ee = _n(ee) : (ee = jr(s) ? ma : yr.current, ee = so(i, ee));
      var he = s.getDerivedStateFromProps, Se = typeof he == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      Se || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (M !== d || F !== ee) && rm(i, A, d, ee), $i = !1;
      var pe = i.memoizedState;
      A.state = pe, xl(i, d, A, _), F = i.memoizedState, M !== d || pe !== F || Zr.current || $i ? (typeof he == "function" && (Iu(i, s, he, d), F = i.memoizedState), (M = $i || em(i, s, M, d, pe, F, ee)) ? (Se || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (i.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (i.flags |= 4194308), i.memoizedProps = d, i.memoizedState = F), A.props = d, A.state = F, A.context = ee, d = M) : (typeof A.componentDidMount == "function" && (i.flags |= 4194308), d = !1);
    } else {
      A = i.stateNode, N_(n, i), M = i.memoizedProps, ee = i.type === i.elementType ? M : Hn(i.type, M), A.props = ee, Se = i.pendingProps, pe = A.context, F = s.contextType, typeof F == "object" && F !== null ? F = _n(F) : (F = jr(s) ? ma : yr.current, F = so(i, F));
      var be = s.getDerivedStateFromProps;
      (he = typeof be == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (M !== Se || pe !== F) && rm(i, A, d, F), $i = !1, pe = i.memoizedState, A.state = pe, xl(i, d, A, _);
      var Ue = i.memoizedState;
      M !== Se || pe !== Ue || Zr.current || $i ? (typeof be == "function" && (Iu(i, s, be, d), Ue = i.memoizedState), (ee = $i || em(i, s, ee, d, pe, Ue, F) || !1) ? (he || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(d, Ue, F), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(d, Ue, F)), typeof A.componentDidUpdate == "function" && (i.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (i.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || M === n.memoizedProps && pe === n.memoizedState || (i.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || M === n.memoizedProps && pe === n.memoizedState || (i.flags |= 1024), i.memoizedProps = d, i.memoizedState = Ue), A.props = d, A.state = Ue, A.context = F, d = ee) : (typeof A.componentDidUpdate != "function" || M === n.memoizedProps && pe === n.memoizedState || (i.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || M === n.memoizedProps && pe === n.memoizedState || (i.flags |= 1024), d = !1);
    }
    return Au(n, i, s, d, I, _);
  }
  function Au(n, i, s, d, _, I) {
    dm(n, i);
    var A = (i.flags & 128) !== 0;
    if (!d && !A) return _ && C_(i, s, !1), gi(n, i, I);
    d = i.stateNode, XA.current = i;
    var M = A && typeof s.getDerivedStateFromError != "function" ? null : d.render();
    return i.flags |= 1, n !== null && A ? (i.child = fo(i, n.child, null, I), i.child = fo(i, null, M, I)) : xr(n, i, M, I), i.memoizedState = d.state, _ && C_(i, s, !0), i.child;
  }
  function hm(n) {
    var i = n.stateNode;
    i.pendingContext ? m_(n, i.pendingContext, i.pendingContext !== i.context) : i.context && m_(n, i.context, !1), lu(n, i.containerInfo);
  }
  function _m(n, i, s, d, _) {
    return uo(), tu(_), i.flags |= 256, xr(n, i, s, d), i.child;
  }
  var Tu = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Ou(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function mm(n, i, s) {
    var d = i.pendingProps, _ = Wt.current, I = !1, A = (i.flags & 128) !== 0, M;
    if ((M = A) || (M = n !== null && n.memoizedState === null ? !1 : (_ & 2) !== 0), M ? (I = !0, i.flags &= -129) : (n === null || n.memoizedState !== null) && (_ |= 1), kt(Wt, _ & 1), n === null)
      return eu(i), n = i.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? ((i.mode & 1) === 0 ? i.lanes = 1 : n.data === "$!" ? i.lanes = 8 : i.lanes = 1073741824, null) : (A = d.children, n = d.fallback, I ? (d = i.mode, I = i.child, A = { mode: "hidden", children: A }, (d & 1) === 0 && I !== null ? (I.childLanes = 0, I.pendingProps = A) : I = s2(A, d, 0, null), n = Ta(n, d, s, null), I.return = i, n.return = i, I.sibling = n, i.child = I, i.child.memoizedState = Ou(s), i.memoizedState = Tu, n) : yu(i, A));
    if (_ = n.memoizedState, _ !== null && (M = _.dehydrated, M !== null)) return QA(n, i, A, d, M, _, s);
    if (I) {
      I = d.fallback, A = i.mode, _ = n.child, M = _.sibling;
      var F = { mode: "hidden", children: d.children };
      return (A & 1) === 0 && i.child !== _ ? (d = i.child, d.childLanes = 0, d.pendingProps = F, i.deletions = null) : (d = Yi(_, F), d.subtreeFlags = _.subtreeFlags & 14680064), M !== null ? I = Yi(M, I) : (I = Ta(I, A, s, null), I.flags |= 2), I.return = i, d.return = i, d.sibling = I, i.child = d, d = I, I = i.child, A = n.child.memoizedState, A = A === null ? Ou(s) : { baseLanes: A.baseLanes | s, cachePool: null, transitions: A.transitions }, I.memoizedState = A, I.childLanes = n.childLanes & ~s, i.memoizedState = Tu, d;
    }
    return I = n.child, n = I.sibling, d = Yi(I, { mode: "visible", children: d.children }), (i.mode & 1) === 0 && (d.lanes = s), d.return = i, d.sibling = null, n !== null && (s = i.deletions, s === null ? (i.deletions = [n], i.flags |= 16) : s.push(n)), i.child = d, i.memoizedState = null, d;
  }
  function yu(n, i) {
    return i = s2({ mode: "visible", children: i }, n.mode, 0, null), i.return = n, n.child = i;
  }
  function Wl(n, i, s, d) {
    return d !== null && tu(d), fo(i, n.child, null, s), n = yu(i, i.pendingProps.children), n.flags |= 2, i.memoizedState = null, n;
  }
  function QA(n, i, s, d, _, I, A) {
    if (s)
      return i.flags & 256 ? (i.flags &= -257, d = gu(Error(t(422))), Wl(n, i, A, d)) : i.memoizedState !== null ? (i.child = n.child, i.flags |= 128, null) : (I = d.fallback, _ = i.mode, d = s2({ mode: "visible", children: d.children }, _, 0, null), I = Ta(I, _, A, null), I.flags |= 2, d.return = i, I.return = i, d.sibling = I, i.child = d, (i.mode & 1) !== 0 && fo(i, n.child, null, A), i.child.memoizedState = Ou(A), i.memoizedState = Tu, I);
    if ((i.mode & 1) === 0) return Wl(n, i, A, null);
    if (_.data === "$!") {
      if (d = _.nextSibling && _.nextSibling.dataset, d) var M = d.dgst;
      return d = M, I = Error(t(419)), d = gu(I, d, void 0), Wl(n, i, A, d);
    }
    if (M = (A & n.childLanes) !== 0, zr || M) {
      if (d = Er, d !== null) {
        switch (A & -A) {
          case 4:
            _ = 2;
            break;
          case 16:
            _ = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            _ = 32;
            break;
          case 536870912:
            _ = 268435456;
            break;
          default:
            _ = 0;
        }
        _ = (_ & (d.suspendedLanes | A)) !== 0 ? 0 : _, _ !== 0 && _ !== I.retryLane && (I.retryLane = _, Ii(n, _), Fn(d, n, _, -1));
      }
      return Zu(), d = gu(Error(t(421))), Wl(n, i, A, d);
    }
    return _.data === "$?" ? (i.flags |= 128, i.child = n.child, i = fT.bind(null, n), _._reactRetry = i, null) : (n = I.treeContext, an = Fi(_.nextSibling), nn = i, Gt = !0, wn = null, n !== null && (pn[hn++] = Ci, pn[hn++] = Si, pn[hn++] = Ea, Ci = n.id, Si = n.overflow, Ea = i), i = yu(i, d.children), i.flags |= 4096, i);
  }
  function Em(n, i, s) {
    n.lanes |= i;
    var d = n.alternate;
    d !== null && (d.lanes |= i), au(n.return, i, s);
  }
  function Nu(n, i, s, d, _) {
    var I = n.memoizedState;
    I === null ? n.memoizedState = { isBackwards: i, rendering: null, renderingStartTime: 0, last: d, tail: s, tailMode: _ } : (I.isBackwards = i, I.rendering = null, I.renderingStartTime = 0, I.last = d, I.tail = s, I.tailMode = _);
  }
  function Cm(n, i, s) {
    var d = i.pendingProps, _ = d.revealOrder, I = d.tail;
    if (xr(n, i, d.children, s), d = Wt.current, (d & 2) !== 0) d = d & 1 | 2, i.flags |= 128;
    else {
      if (n !== null && (n.flags & 128) !== 0) e: for (n = i.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && Em(n, s, i);
        else if (n.tag === 19) Em(n, s, i);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === i) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === i) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      d &= 1;
    }
    if (kt(Wt, d), (i.mode & 1) === 0) i.memoizedState = null;
    else switch (_) {
      case "forwards":
        for (s = i.child, _ = null; s !== null; ) n = s.alternate, n !== null && Bl(n) === null && (_ = s), s = s.sibling;
        s = _, s === null ? (_ = i.child, i.child = null) : (_ = s.sibling, s.sibling = null), Nu(i, !1, _, s, I);
        break;
      case "backwards":
        for (s = null, _ = i.child, i.child = null; _ !== null; ) {
          if (n = _.alternate, n !== null && Bl(n) === null) {
            i.child = _;
            break;
          }
          n = _.sibling, _.sibling = s, s = _, _ = n;
        }
        Nu(i, !0, s, null, I);
        break;
      case "together":
        Nu(i, !1, null, null, void 0);
        break;
      default:
        i.memoizedState = null;
    }
    return i.child;
  }
  function Yl(n, i) {
    (i.mode & 1) === 0 && n !== null && (n.alternate = null, i.alternate = null, i.flags |= 2);
  }
  function gi(n, i, s) {
    if (n !== null && (i.dependencies = n.dependencies), ga |= i.lanes, (s & i.childLanes) === 0) return null;
    if (n !== null && i.child !== n.child) throw Error(t(153));
    if (i.child !== null) {
      for (n = i.child, s = Yi(n, n.pendingProps), i.child = s, s.return = i; n.sibling !== null; ) n = n.sibling, s = s.sibling = Yi(n, n.pendingProps), s.return = i;
      s.sibling = null;
    }
    return i.child;
  }
  function JA(n, i, s) {
    switch (i.tag) {
      case 3:
        hm(i), uo();
        break;
      case 5:
        P_(i);
        break;
      case 1:
        jr(i.type) && Ml(i);
        break;
      case 4:
        lu(i, i.stateNode.containerInfo);
        break;
      case 10:
        var d = i.type._context, _ = i.memoizedProps.value;
        kt(kl, d._currentValue), d._currentValue = _;
        break;
      case 13:
        if (d = i.memoizedState, d !== null)
          return d.dehydrated !== null ? (kt(Wt, Wt.current & 1), i.flags |= 128, null) : (s & i.child.childLanes) !== 0 ? mm(n, i, s) : (kt(Wt, Wt.current & 1), n = gi(n, i, s), n !== null ? n.sibling : null);
        kt(Wt, Wt.current & 1);
        break;
      case 19:
        if (d = (s & i.childLanes) !== 0, (n.flags & 128) !== 0) {
          if (d) return Cm(n, i, s);
          i.flags |= 128;
        }
        if (_ = i.memoizedState, _ !== null && (_.rendering = null, _.tail = null, _.lastEffect = null), kt(Wt, Wt.current), d) break;
        return null;
      case 22:
      case 23:
        return i.lanes = 0, fm(n, i, s);
    }
    return gi(n, i, s);
  }
  var Sm, Lu, Im, vm;
  Sm = function(n, i) {
    for (var s = i.child; s !== null; ) {
      if (s.tag === 5 || s.tag === 6) n.appendChild(s.stateNode);
      else if (s.tag !== 4 && s.child !== null) {
        s.child.return = s, s = s.child;
        continue;
      }
      if (s === i) break;
      for (; s.sibling === null; ) {
        if (s.return === null || s.return === i) return;
        s = s.return;
      }
      s.sibling.return = s.return, s = s.sibling;
    }
  }, Lu = function() {
  }, Im = function(n, i, s, d) {
    var _ = n.memoizedProps;
    if (_ !== d) {
      n = i.stateNode, Ia(Jn.current);
      var I = null;
      switch (s) {
        case "input":
          _ = lt(n, _), d = lt(n, d), I = [];
          break;
        case "select":
          _ = Q({}, _, { value: void 0 }), d = Q({}, d, { value: void 0 }), I = [];
          break;
        case "textarea":
          _ = ye(n, _), d = ye(n, d), I = [];
          break;
        default:
          typeof _.onClick != "function" && typeof d.onClick == "function" && (n.onclick = yl);
      }
      Pt(s, d);
      var A;
      s = null;
      for (ee in _) if (!d.hasOwnProperty(ee) && _.hasOwnProperty(ee) && _[ee] != null) if (ee === "style") {
        var M = _[ee];
        for (A in M) M.hasOwnProperty(A) && (s || (s = {}), s[A] = "");
      } else ee !== "dangerouslySetInnerHTML" && ee !== "children" && ee !== "suppressContentEditableWarning" && ee !== "suppressHydrationWarning" && ee !== "autoFocus" && (o.hasOwnProperty(ee) ? I || (I = []) : (I = I || []).push(ee, null));
      for (ee in d) {
        var F = d[ee];
        if (M = _ != null ? _[ee] : void 0, d.hasOwnProperty(ee) && F !== M && (F != null || M != null)) if (ee === "style") if (M) {
          for (A in M) !M.hasOwnProperty(A) || F && F.hasOwnProperty(A) || (s || (s = {}), s[A] = "");
          for (A in F) F.hasOwnProperty(A) && M[A] !== F[A] && (s || (s = {}), s[A] = F[A]);
        } else s || (I || (I = []), I.push(
          ee,
          s
        )), s = F;
        else ee === "dangerouslySetInnerHTML" ? (F = F ? F.__html : void 0, M = M ? M.__html : void 0, F != null && M !== F && (I = I || []).push(ee, F)) : ee === "children" ? typeof F != "string" && typeof F != "number" || (I = I || []).push(ee, "" + F) : ee !== "suppressContentEditableWarning" && ee !== "suppressHydrationWarning" && (o.hasOwnProperty(ee) ? (F != null && ee === "onScroll" && xt("scroll", n), I || M === F || (I = [])) : (I = I || []).push(ee, F));
      }
      s && (I = I || []).push("style", s);
      var ee = I;
      (i.updateQueue = ee) && (i.flags |= 4);
    }
  }, vm = function(n, i, s, d) {
    s !== d && (i.flags |= 4);
  };
  function Es(n, i) {
    if (!Gt) switch (n.tailMode) {
      case "hidden":
        i = n.tail;
        for (var s = null; i !== null; ) i.alternate !== null && (s = i), i = i.sibling;
        s === null ? n.tail = null : s.sibling = null;
        break;
      case "collapsed":
        s = n.tail;
        for (var d = null; s !== null; ) s.alternate !== null && (d = s), s = s.sibling;
        d === null ? i || n.tail === null ? n.tail = null : n.tail.sibling = null : d.sibling = null;
    }
  }
  function Lr(n) {
    var i = n.alternate !== null && n.alternate.child === n.child, s = 0, d = 0;
    if (i) for (var _ = n.child; _ !== null; ) s |= _.lanes | _.childLanes, d |= _.subtreeFlags & 14680064, d |= _.flags & 14680064, _.return = n, _ = _.sibling;
    else for (_ = n.child; _ !== null; ) s |= _.lanes | _.childLanes, d |= _.subtreeFlags, d |= _.flags, _.return = n, _ = _.sibling;
    return n.subtreeFlags |= d, n.childLanes = s, i;
  }
  function eT(n, i, s) {
    var d = i.pendingProps;
    switch (Qc(i), i.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Lr(i), null;
      case 1:
        return jr(i.type) && Ll(), Lr(i), null;
      case 3:
        return d = i.stateNode, _o(), Bt(Zr), Bt(yr), fu(), d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null), (n === null || n.child === null) && (Hl(i) ? i.flags |= 4 : n === null || n.memoizedState.isDehydrated && (i.flags & 256) === 0 || (i.flags |= 1024, wn !== null && (Bu(wn), wn = null))), Lu(n, i), Lr(i), null;
      case 5:
        cu(i);
        var _ = Ia(ds.current);
        if (s = i.type, n !== null && i.stateNode != null) Im(n, i, s, d, _), n.ref !== i.ref && (i.flags |= 512, i.flags |= 2097152);
        else {
          if (!d) {
            if (i.stateNode === null) throw Error(t(166));
            return Lr(i), null;
          }
          if (n = Ia(Jn.current), Hl(i)) {
            d = i.stateNode, s = i.type;
            var I = i.memoizedProps;
            switch (d[Qn] = i, d[ss] = I, n = (i.mode & 1) !== 0, s) {
              case "dialog":
                xt("cancel", d), xt("close", d);
                break;
              case "iframe":
              case "object":
              case "embed":
                xt("load", d);
                break;
              case "video":
              case "audio":
                for (_ = 0; _ < is.length; _++) xt(is[_], d);
                break;
              case "source":
                xt("error", d);
                break;
              case "img":
              case "image":
              case "link":
                xt(
                  "error",
                  d
                ), xt("load", d);
                break;
              case "details":
                xt("toggle", d);
                break;
              case "input":
                Ct(d, I), xt("invalid", d);
                break;
              case "select":
                d._wrapperState = { wasMultiple: !!I.multiple }, xt("invalid", d);
                break;
              case "textarea":
                xe(d, I), xt("invalid", d);
            }
            Pt(s, I), _ = null;
            for (var A in I) if (I.hasOwnProperty(A)) {
              var M = I[A];
              A === "children" ? typeof M == "string" ? d.textContent !== M && (I.suppressHydrationWarning !== !0 && Ol(d.textContent, M, n), _ = ["children", M]) : typeof M == "number" && d.textContent !== "" + M && (I.suppressHydrationWarning !== !0 && Ol(
                d.textContent,
                M,
                n
              ), _ = ["children", "" + M]) : o.hasOwnProperty(A) && M != null && A === "onScroll" && xt("scroll", d);
            }
            switch (s) {
              case "input":
                at(d), st(d, I, !0);
                break;
              case "textarea":
                at(d), _t(d);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof I.onClick == "function" && (d.onclick = yl);
            }
            d = _, i.updateQueue = d, d !== null && (i.flags |= 4);
          } else {
            A = _.nodeType === 9 ? _ : _.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = De(s)), n === "http://www.w3.org/1999/xhtml" ? s === "script" ? (n = A.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof d.is == "string" ? n = A.createElement(s, { is: d.is }) : (n = A.createElement(s), s === "select" && (A = n, d.multiple ? A.multiple = !0 : d.size && (A.size = d.size))) : n = A.createElementNS(n, s), n[Qn] = i, n[ss] = d, Sm(n, i, !1, !1), i.stateNode = n;
            e: {
              switch (A = Ar(s, d), s) {
                case "dialog":
                  xt("cancel", n), xt("close", n), _ = d;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  xt("load", n), _ = d;
                  break;
                case "video":
                case "audio":
                  for (_ = 0; _ < is.length; _++) xt(is[_], n);
                  _ = d;
                  break;
                case "source":
                  xt("error", n), _ = d;
                  break;
                case "img":
                case "image":
                case "link":
                  xt(
                    "error",
                    n
                  ), xt("load", n), _ = d;
                  break;
                case "details":
                  xt("toggle", n), _ = d;
                  break;
                case "input":
                  Ct(n, d), _ = lt(n, d), xt("invalid", n);
                  break;
                case "option":
                  _ = d;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!d.multiple }, _ = Q({}, d, { value: void 0 }), xt("invalid", n);
                  break;
                case "textarea":
                  xe(n, d), _ = ye(n, d), xt("invalid", n);
                  break;
                default:
                  _ = d;
              }
              Pt(s, _), M = _;
              for (I in M) if (M.hasOwnProperty(I)) {
                var F = M[I];
                I === "style" ? Xe(n, F) : I === "dangerouslySetInnerHTML" ? (F = F ? F.__html : void 0, F != null && Je(n, F)) : I === "children" ? typeof F == "string" ? (s !== "textarea" || F !== "") && ut(n, F) : typeof F == "number" && ut(n, "" + F) : I !== "suppressContentEditableWarning" && I !== "suppressHydrationWarning" && I !== "autoFocus" && (o.hasOwnProperty(I) ? F != null && I === "onScroll" && xt("scroll", n) : F != null && R(n, I, F, A));
              }
              switch (s) {
                case "input":
                  at(n), st(n, d, !1);
                  break;
                case "textarea":
                  at(n), _t(n);
                  break;
                case "option":
                  d.value != null && n.setAttribute("value", "" + Ce(d.value));
                  break;
                case "select":
                  n.multiple = !!d.multiple, I = d.value, I != null ? me(n, !!d.multiple, I, !1) : d.defaultValue != null && me(
                    n,
                    !!d.multiple,
                    d.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof _.onClick == "function" && (n.onclick = yl);
              }
              switch (s) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d = !!d.autoFocus;
                  break e;
                case "img":
                  d = !0;
                  break e;
                default:
                  d = !1;
              }
            }
            d && (i.flags |= 4);
          }
          i.ref !== null && (i.flags |= 512, i.flags |= 2097152);
        }
        return Lr(i), null;
      case 6:
        if (n && i.stateNode != null) vm(n, i, n.memoizedProps, d);
        else {
          if (typeof d != "string" && i.stateNode === null) throw Error(t(166));
          if (s = Ia(ds.current), Ia(Jn.current), Hl(i)) {
            if (d = i.stateNode, s = i.memoizedProps, d[Qn] = i, (I = d.nodeValue !== s) && (n = nn, n !== null))
              switch (n.tag) {
                case 3:
                  Ol(d.nodeValue, s, (n.mode & 1) !== 0);
                  break;
                case 5:
                  n.memoizedProps.suppressHydrationWarning !== !0 && Ol(d.nodeValue, s, (n.mode & 1) !== 0);
              }
            I && (i.flags |= 4);
          } else d = (s.nodeType === 9 ? s : s.ownerDocument).createTextNode(d), d[Qn] = i, i.stateNode = d;
        }
        return Lr(i), null;
      case 13:
        if (Bt(Wt), d = i.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (Gt && an !== null && (i.mode & 1) !== 0 && (i.flags & 128) === 0) D_(), uo(), i.flags |= 98560, I = !1;
          else if (I = Hl(i), d !== null && d.dehydrated !== null) {
            if (n === null) {
              if (!I) throw Error(t(318));
              if (I = i.memoizedState, I = I !== null ? I.dehydrated : null, !I) throw Error(t(317));
              I[Qn] = i;
            } else uo(), (i.flags & 128) === 0 && (i.memoizedState = null), i.flags |= 4;
            Lr(i), I = !1;
          } else wn !== null && (Bu(wn), wn = null), I = !0;
          if (!I) return i.flags & 65536 ? i : null;
        }
        return (i.flags & 128) !== 0 ? (i.lanes = s, i) : (d = d !== null, d !== (n !== null && n.memoizedState !== null) && d && (i.child.flags |= 8192, (i.mode & 1) !== 0 && (n === null || (Wt.current & 1) !== 0 ? dr === 0 && (dr = 3) : Zu())), i.updateQueue !== null && (i.flags |= 4), Lr(i), null);
      case 4:
        return _o(), Lu(n, i), n === null && as(i.stateNode.containerInfo), Lr(i), null;
      case 10:
        return iu(i.type._context), Lr(i), null;
      case 17:
        return jr(i.type) && Ll(), Lr(i), null;
      case 19:
        if (Bt(Wt), I = i.memoizedState, I === null) return Lr(i), null;
        if (d = (i.flags & 128) !== 0, A = I.rendering, A === null) if (d) Es(I, !1);
        else {
          if (dr !== 0 || n !== null && (n.flags & 128) !== 0) for (n = i.child; n !== null; ) {
            if (A = Bl(n), A !== null) {
              for (i.flags |= 128, Es(I, !1), d = A.updateQueue, d !== null && (i.updateQueue = d, i.flags |= 4), i.subtreeFlags = 0, d = s, s = i.child; s !== null; ) I = s, n = d, I.flags &= 14680066, A = I.alternate, A === null ? (I.childLanes = 0, I.lanes = n, I.child = null, I.subtreeFlags = 0, I.memoizedProps = null, I.memoizedState = null, I.updateQueue = null, I.dependencies = null, I.stateNode = null) : (I.childLanes = A.childLanes, I.lanes = A.lanes, I.child = A.child, I.subtreeFlags = 0, I.deletions = null, I.memoizedProps = A.memoizedProps, I.memoizedState = A.memoizedState, I.updateQueue = A.updateQueue, I.type = A.type, n = A.dependencies, I.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), s = s.sibling;
              return kt(Wt, Wt.current & 1 | 2), i.child;
            }
            n = n.sibling;
          }
          I.tail !== null && tt() > So && (i.flags |= 128, d = !0, Es(I, !1), i.lanes = 4194304);
        }
        else {
          if (!d) if (n = Bl(A), n !== null) {
            if (i.flags |= 128, d = !0, s = n.updateQueue, s !== null && (i.updateQueue = s, i.flags |= 4), Es(I, !0), I.tail === null && I.tailMode === "hidden" && !A.alternate && !Gt) return Lr(i), null;
          } else 2 * tt() - I.renderingStartTime > So && s !== 1073741824 && (i.flags |= 128, d = !0, Es(I, !1), i.lanes = 4194304);
          I.isBackwards ? (A.sibling = i.child, i.child = A) : (s = I.last, s !== null ? s.sibling = A : i.child = A, I.last = A);
        }
        return I.tail !== null ? (i = I.tail, I.rendering = i, I.tail = i.sibling, I.renderingStartTime = tt(), i.sibling = null, s = Wt.current, kt(Wt, d ? s & 1 | 2 : s & 1), i) : (Lr(i), null);
      case 22:
      case 23:
        return Gu(), d = i.memoizedState !== null, n !== null && n.memoizedState !== null !== d && (i.flags |= 8192), d && (i.mode & 1) !== 0 ? (on & 1073741824) !== 0 && (Lr(i), i.subtreeFlags & 6 && (i.flags |= 8192)) : Lr(i), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(t(156, i.tag));
  }
  function tT(n, i) {
    switch (Qc(i), i.tag) {
      case 1:
        return jr(i.type) && Ll(), n = i.flags, n & 65536 ? (i.flags = n & -65537 | 128, i) : null;
      case 3:
        return _o(), Bt(Zr), Bt(yr), fu(), n = i.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (i.flags = n & -65537 | 128, i) : null;
      case 5:
        return cu(i), null;
      case 13:
        if (Bt(Wt), n = i.memoizedState, n !== null && n.dehydrated !== null) {
          if (i.alternate === null) throw Error(t(340));
          uo();
        }
        return n = i.flags, n & 65536 ? (i.flags = n & -65537 | 128, i) : null;
      case 19:
        return Bt(Wt), null;
      case 4:
        return _o(), null;
      case 10:
        return iu(i.type._context), null;
      case 22:
      case 23:
        return Gu(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Kl = !1, Mr = !1, rT = typeof WeakSet == "function" ? WeakSet : Set, Fe = null;
  function Eo(n, i) {
    var s = n.ref;
    if (s !== null) if (typeof s == "function") try {
      s(null);
    } catch (d) {
      Jt(n, i, d);
    }
    else s.current = null;
  }
  function Mu(n, i, s) {
    try {
      s();
    } catch (d) {
      Jt(n, i, d);
    }
  }
  var gm = !1;
  function nT(n, i) {
    if (Gc = Ut, n = e_(), Hc(n)) {
      if ("selectionStart" in n) var s = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        s = (s = n.ownerDocument) && s.defaultView || window;
        var d = s.getSelection && s.getSelection();
        if (d && d.rangeCount !== 0) {
          s = d.anchorNode;
          var _ = d.anchorOffset, I = d.focusNode;
          d = d.focusOffset;
          try {
            s.nodeType, I.nodeType;
          } catch (ve) {
            s = null;
            break e;
          }
          var A = 0, M = -1, F = -1, ee = 0, he = 0, Se = n, pe = null;
          t: for (; ; ) {
            for (var be; Se !== s || _ !== 0 && Se.nodeType !== 3 || (M = A + _), Se !== I || d !== 0 && Se.nodeType !== 3 || (F = A + d), Se.nodeType === 3 && (A += Se.nodeValue.length), (be = Se.firstChild) !== null; )
              pe = Se, Se = be;
            for (; ; ) {
              if (Se === n) break t;
              if (pe === s && ++ee === _ && (M = A), pe === I && ++he === d && (F = A), (be = Se.nextSibling) !== null) break;
              Se = pe, pe = Se.parentNode;
            }
            Se = be;
          }
          s = M === -1 || F === -1 ? null : { start: M, end: F };
        } else s = null;
      }
      s = s || { start: 0, end: 0 };
    } else s = null;
    for (Zc = { focusedElem: n, selectionRange: s }, Ut = !1, Fe = i; Fe !== null; ) if (i = Fe, n = i.child, (i.subtreeFlags & 1028) !== 0 && n !== null) n.return = i, Fe = n;
    else for (; Fe !== null; ) {
      i = Fe;
      try {
        var Ue = i.alternate;
        if ((i.flags & 1024) !== 0) switch (i.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Ue !== null) {
              var $e = Ue.memoizedProps, ir = Ue.memoizedState, j = i.stateNode, x = j.getSnapshotBeforeUpdate(i.elementType === i.type ? $e : Hn(i.type, $e), ir);
              j.__reactInternalSnapshotBeforeUpdate = x;
            }
            break;
          case 3:
            var K = i.stateNode.containerInfo;
            K.nodeType === 1 ? K.textContent = "" : K.nodeType === 9 && K.documentElement && K.removeChild(K.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(t(163));
        }
      } catch (ve) {
        Jt(i, i.return, ve);
      }
      if (n = i.sibling, n !== null) {
        n.return = i.return, Fe = n;
        break;
      }
      Fe = i.return;
    }
    return Ue = gm, gm = !1, Ue;
  }
  function Cs(n, i, s) {
    var d = i.updateQueue;
    if (d = d !== null ? d.lastEffect : null, d !== null) {
      var _ = d = d.next;
      do {
        if ((_.tag & n) === n) {
          var I = _.destroy;
          _.destroy = void 0, I !== void 0 && Mu(i, s, I);
        }
        _ = _.next;
      } while (_ !== d);
    }
  }
  function Xl(n, i) {
    if (i = i.updateQueue, i = i !== null ? i.lastEffect : null, i !== null) {
      var s = i = i.next;
      do {
        if ((s.tag & n) === n) {
          var d = s.create;
          s.destroy = d();
        }
        s = s.next;
      } while (s !== i);
    }
  }
  function Pu(n) {
    var i = n.ref;
    if (i !== null) {
      var s = n.stateNode;
      switch (n.tag) {
        case 5:
          n = s;
          break;
        default:
          n = s;
      }
      typeof i == "function" ? i(n) : i.current = n;
    }
  }
  function Rm(n) {
    var i = n.alternate;
    i !== null && (n.alternate = null, Rm(i)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (i = n.stateNode, i !== null && (delete i[Qn], delete i[ss], delete i[Wc], delete i[UA], delete i[xA])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Dm(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function Am(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Dm(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function bu(n, i, s) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, i ? s.nodeType === 8 ? s.parentNode.insertBefore(n, i) : s.insertBefore(n, i) : (s.nodeType === 8 ? (i = s.parentNode, i.insertBefore(n, s)) : (i = s, i.appendChild(n)), s = s._reactRootContainer, s != null || i.onclick !== null || (i.onclick = yl));
    else if (d !== 4 && (n = n.child, n !== null)) for (bu(n, i, s), n = n.sibling; n !== null; ) bu(n, i, s), n = n.sibling;
  }
  function wu(n, i, s) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, i ? s.insertBefore(n, i) : s.appendChild(n);
    else if (d !== 4 && (n = n.child, n !== null)) for (wu(n, i, s), n = n.sibling; n !== null; ) wu(n, i, s), n = n.sibling;
  }
  var gr = null, Vn = !1;
  function Zi(n, i, s) {
    for (s = s.child; s !== null; ) Tm(n, i, s), s = s.sibling;
  }
  function Tm(n, i, s) {
    if (Ur && typeof Ur.onCommitFiberUnmount == "function") try {
      Ur.onCommitFiberUnmount(_i, s);
    } catch (M) {
    }
    switch (s.tag) {
      case 5:
        Mr || Eo(s, i);
      case 6:
        var d = gr, _ = Vn;
        gr = null, Zi(n, i, s), gr = d, Vn = _, gr !== null && (Vn ? (n = gr, s = s.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(s) : n.removeChild(s)) : gr.removeChild(s.stateNode));
        break;
      case 18:
        gr !== null && (Vn ? (n = gr, s = s.stateNode, n.nodeType === 8 ? qc(n.parentNode, s) : n.nodeType === 1 && qc(n, s), de(n)) : qc(gr, s.stateNode));
        break;
      case 4:
        d = gr, _ = Vn, gr = s.stateNode.containerInfo, Vn = !0, Zi(n, i, s), gr = d, Vn = _;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Mr && (d = s.updateQueue, d !== null && (d = d.lastEffect, d !== null))) {
          _ = d = d.next;
          do {
            var I = _, A = I.destroy;
            I = I.tag, A !== void 0 && ((I & 2) !== 0 || (I & 4) !== 0) && Mu(s, i, A), _ = _.next;
          } while (_ !== d);
        }
        Zi(n, i, s);
        break;
      case 1:
        if (!Mr && (Eo(s, i), d = s.stateNode, typeof d.componentWillUnmount == "function")) try {
          d.props = s.memoizedProps, d.state = s.memoizedState, d.componentWillUnmount();
        } catch (M) {
          Jt(s, i, M);
        }
        Zi(n, i, s);
        break;
      case 21:
        Zi(n, i, s);
        break;
      case 22:
        s.mode & 1 ? (Mr = (d = Mr) || s.memoizedState !== null, Zi(n, i, s), Mr = d) : Zi(n, i, s);
        break;
      default:
        Zi(n, i, s);
    }
  }
  function Om(n) {
    var i = n.updateQueue;
    if (i !== null) {
      n.updateQueue = null;
      var s = n.stateNode;
      s === null && (s = n.stateNode = new rT()), i.forEach(function(d) {
        var _ = dT.bind(null, n, d);
        s.has(d) || (s.add(d), d.then(_, _));
      });
    }
  }
  function kn(n, i) {
    var s = i.deletions;
    if (s !== null) for (var d = 0; d < s.length; d++) {
      var _ = s[d];
      try {
        var I = n, A = i, M = A;
        e: for (; M !== null; ) {
          switch (M.tag) {
            case 5:
              gr = M.stateNode, Vn = !1;
              break e;
            case 3:
              gr = M.stateNode.containerInfo, Vn = !0;
              break e;
            case 4:
              gr = M.stateNode.containerInfo, Vn = !0;
              break e;
          }
          M = M.return;
        }
        if (gr === null) throw Error(t(160));
        Tm(I, A, _), gr = null, Vn = !1;
        var F = _.alternate;
        F !== null && (F.return = null), _.return = null;
      } catch (ee) {
        Jt(_, i, ee);
      }
    }
    if (i.subtreeFlags & 12854) for (i = i.child; i !== null; ) ym(i, n), i = i.sibling;
  }
  function ym(n, i) {
    var s = n.alternate, d = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (kn(i, n), ti(n), d & 4) {
          try {
            Cs(3, n, n.return), Xl(3, n);
          } catch ($e) {
            Jt(n, n.return, $e);
          }
          try {
            Cs(5, n, n.return);
          } catch ($e) {
            Jt(n, n.return, $e);
          }
        }
        break;
      case 1:
        kn(i, n), ti(n), d & 512 && s !== null && Eo(s, s.return);
        break;
      case 5:
        if (kn(i, n), ti(n), d & 512 && s !== null && Eo(s, s.return), n.flags & 32) {
          var _ = n.stateNode;
          try {
            ut(_, "");
          } catch ($e) {
            Jt(n, n.return, $e);
          }
        }
        if (d & 4 && (_ = n.stateNode, _ != null)) {
          var I = n.memoizedProps, A = s !== null ? s.memoizedProps : I, M = n.type, F = n.updateQueue;
          if (n.updateQueue = null, F !== null) try {
            M === "input" && I.type === "radio" && I.name != null && yt(_, I), Ar(M, A);
            var ee = Ar(M, I);
            for (A = 0; A < F.length; A += 2) {
              var he = F[A], Se = F[A + 1];
              he === "style" ? Xe(_, Se) : he === "dangerouslySetInnerHTML" ? Je(_, Se) : he === "children" ? ut(_, Se) : R(_, he, Se, ee);
            }
            switch (M) {
              case "input":
                St(_, I);
                break;
              case "textarea":
                Lt(_, I);
                break;
              case "select":
                var pe = _._wrapperState.wasMultiple;
                _._wrapperState.wasMultiple = !!I.multiple;
                var be = I.value;
                be != null ? me(_, !!I.multiple, be, !1) : pe !== !!I.multiple && (I.defaultValue != null ? me(
                  _,
                  !!I.multiple,
                  I.defaultValue,
                  !0
                ) : me(_, !!I.multiple, I.multiple ? [] : "", !1));
            }
            _[ss] = I;
          } catch ($e) {
            Jt(n, n.return, $e);
          }
        }
        break;
      case 6:
        if (kn(i, n), ti(n), d & 4) {
          if (n.stateNode === null) throw Error(t(162));
          _ = n.stateNode, I = n.memoizedProps;
          try {
            _.nodeValue = I;
          } catch ($e) {
            Jt(n, n.return, $e);
          }
        }
        break;
      case 3:
        if (kn(i, n), ti(n), d & 4 && s !== null && s.memoizedState.isDehydrated) try {
          de(i.containerInfo);
        } catch ($e) {
          Jt(n, n.return, $e);
        }
        break;
      case 4:
        kn(i, n), ti(n);
        break;
      case 13:
        kn(i, n), ti(n), _ = n.child, _.flags & 8192 && (I = _.memoizedState !== null, _.stateNode.isHidden = I, !I || _.alternate !== null && _.alternate.memoizedState !== null || (ku = tt())), d & 4 && Om(n);
        break;
      case 22:
        if (he = s !== null && s.memoizedState !== null, n.mode & 1 ? (Mr = (ee = Mr) || he, kn(i, n), Mr = ee) : kn(i, n), ti(n), d & 8192) {
          if (ee = n.memoizedState !== null, (n.stateNode.isHidden = ee) && !he && (n.mode & 1) !== 0) for (Fe = n, he = n.child; he !== null; ) {
            for (Se = Fe = he; Fe !== null; ) {
              switch (pe = Fe, be = pe.child, pe.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Cs(4, pe, pe.return);
                  break;
                case 1:
                  Eo(pe, pe.return);
                  var Ue = pe.stateNode;
                  if (typeof Ue.componentWillUnmount == "function") {
                    d = pe, s = pe.return;
                    try {
                      i = d, Ue.props = i.memoizedProps, Ue.state = i.memoizedState, Ue.componentWillUnmount();
                    } catch ($e) {
                      Jt(d, s, $e);
                    }
                  }
                  break;
                case 5:
                  Eo(pe, pe.return);
                  break;
                case 22:
                  if (pe.memoizedState !== null) {
                    Mm(Se);
                    continue;
                  }
              }
              be !== null ? (be.return = pe, Fe = be) : Mm(Se);
            }
            he = he.sibling;
          }
          e: for (he = null, Se = n; ; ) {
            if (Se.tag === 5) {
              if (he === null) {
                he = Se;
                try {
                  _ = Se.stateNode, ee ? (I = _.style, typeof I.setProperty == "function" ? I.setProperty("display", "none", "important") : I.display = "none") : (M = Se.stateNode, F = Se.memoizedProps.style, A = F != null && F.hasOwnProperty("display") ? F.display : null, M.style.display = ge("display", A));
                } catch ($e) {
                  Jt(n, n.return, $e);
                }
              }
            } else if (Se.tag === 6) {
              if (he === null) try {
                Se.stateNode.nodeValue = ee ? "" : Se.memoizedProps;
              } catch ($e) {
                Jt(n, n.return, $e);
              }
            } else if ((Se.tag !== 22 && Se.tag !== 23 || Se.memoizedState === null || Se === n) && Se.child !== null) {
              Se.child.return = Se, Se = Se.child;
              continue;
            }
            if (Se === n) break e;
            for (; Se.sibling === null; ) {
              if (Se.return === null || Se.return === n) break e;
              he === Se && (he = null), Se = Se.return;
            }
            he === Se && (he = null), Se.sibling.return = Se.return, Se = Se.sibling;
          }
        }
        break;
      case 19:
        kn(i, n), ti(n), d & 4 && Om(n);
        break;
      case 21:
        break;
      default:
        kn(
          i,
          n
        ), ti(n);
    }
  }
  function ti(n) {
    var i = n.flags;
    if (i & 2) {
      try {
        e: {
          for (var s = n.return; s !== null; ) {
            if (Dm(s)) {
              var d = s;
              break e;
            }
            s = s.return;
          }
          throw Error(t(160));
        }
        switch (d.tag) {
          case 5:
            var _ = d.stateNode;
            d.flags & 32 && (ut(_, ""), d.flags &= -33);
            var I = Am(n);
            wu(n, I, _);
            break;
          case 3:
          case 4:
            var A = d.stateNode.containerInfo, M = Am(n);
            bu(n, M, A);
            break;
          default:
            throw Error(t(161));
        }
      } catch (F) {
        Jt(n, n.return, F);
      }
      n.flags &= -3;
    }
    i & 4096 && (n.flags &= -4097);
  }
  function iT(n, i, s) {
    Fe = n, Nm(n);
  }
  function Nm(n, i, s) {
    for (var d = (n.mode & 1) !== 0; Fe !== null; ) {
      var _ = Fe, I = _.child;
      if (_.tag === 22 && d) {
        var A = _.memoizedState !== null || Kl;
        if (!A) {
          var M = _.alternate, F = M !== null && M.memoizedState !== null || Mr;
          M = Kl;
          var ee = Mr;
          if (Kl = A, (Mr = F) && !ee) for (Fe = _; Fe !== null; ) A = Fe, F = A.child, A.tag === 22 && A.memoizedState !== null ? Pm(_) : F !== null ? (F.return = A, Fe = F) : Pm(_);
          for (; I !== null; ) Fe = I, Nm(I), I = I.sibling;
          Fe = _, Kl = M, Mr = ee;
        }
        Lm(n);
      } else (_.subtreeFlags & 8772) !== 0 && I !== null ? (I.return = _, Fe = I) : Lm(n);
    }
  }
  function Lm(n) {
    for (; Fe !== null; ) {
      var i = Fe;
      if ((i.flags & 8772) !== 0) {
        var s = i.alternate;
        try {
          if ((i.flags & 8772) !== 0) switch (i.tag) {
            case 0:
            case 11:
            case 15:
              Mr || Xl(5, i);
              break;
            case 1:
              var d = i.stateNode;
              if (i.flags & 4 && !Mr) if (s === null) d.componentDidMount();
              else {
                var _ = i.elementType === i.type ? s.memoizedProps : Hn(i.type, s.memoizedProps);
                d.componentDidUpdate(_, s.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
              }
              var I = i.updateQueue;
              I !== null && M_(i, I, d);
              break;
            case 3:
              var A = i.updateQueue;
              if (A !== null) {
                if (s = null, i.child !== null) switch (i.child.tag) {
                  case 5:
                    s = i.child.stateNode;
                    break;
                  case 1:
                    s = i.child.stateNode;
                }
                M_(i, A, s);
              }
              break;
            case 5:
              var M = i.stateNode;
              if (s === null && i.flags & 4) {
                s = M;
                var F = i.memoizedProps;
                switch (i.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    F.autoFocus && s.focus();
                    break;
                  case "img":
                    F.src && (s.src = F.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (i.memoizedState === null) {
                var ee = i.alternate;
                if (ee !== null) {
                  var he = ee.memoizedState;
                  if (he !== null) {
                    var Se = he.dehydrated;
                    Se !== null && de(Se);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(t(163));
          }
          Mr || i.flags & 512 && Pu(i);
        } catch (pe) {
          Jt(i, i.return, pe);
        }
      }
      if (i === n) {
        Fe = null;
        break;
      }
      if (s = i.sibling, s !== null) {
        s.return = i.return, Fe = s;
        break;
      }
      Fe = i.return;
    }
  }
  function Mm(n) {
    for (; Fe !== null; ) {
      var i = Fe;
      if (i === n) {
        Fe = null;
        break;
      }
      var s = i.sibling;
      if (s !== null) {
        s.return = i.return, Fe = s;
        break;
      }
      Fe = i.return;
    }
  }
  function Pm(n) {
    for (; Fe !== null; ) {
      var i = Fe;
      try {
        switch (i.tag) {
          case 0:
          case 11:
          case 15:
            var s = i.return;
            try {
              Xl(4, i);
            } catch (F) {
              Jt(i, s, F);
            }
            break;
          case 1:
            var d = i.stateNode;
            if (typeof d.componentDidMount == "function") {
              var _ = i.return;
              try {
                d.componentDidMount();
              } catch (F) {
                Jt(i, _, F);
              }
            }
            var I = i.return;
            try {
              Pu(i);
            } catch (F) {
              Jt(i, I, F);
            }
            break;
          case 5:
            var A = i.return;
            try {
              Pu(i);
            } catch (F) {
              Jt(i, A, F);
            }
        }
      } catch (F) {
        Jt(i, i.return, F);
      }
      if (i === n) {
        Fe = null;
        break;
      }
      var M = i.sibling;
      if (M !== null) {
        M.return = i.return, Fe = M;
        break;
      }
      Fe = i.return;
    }
  }
  var aT = Math.ceil, Ql = T.ReactCurrentDispatcher, Hu = T.ReactCurrentOwner, En = T.ReactCurrentBatchConfig, gt = 0, Er = null, sr = null, Rr = 0, on = 0, Co = Ui(0), dr = 0, Ss = null, ga = 0, Jl = 0, Vu = 0, Is = null, qr = null, ku = 0, So = 1 / 0, Ri = null, e2 = !1, Fu = null, ji = null, t2 = !1, zi = null, r2 = 0, vs = 0, Uu = null, n2 = -1, i2 = 0;
  function Br() {
    return (gt & 6) !== 0 ? tt() : n2 !== -1 ? n2 : n2 = tt();
  }
  function qi(n) {
    return (n.mode & 1) === 0 ? 1 : (gt & 2) !== 0 && Rr !== 0 ? Rr & -Rr : $A.transition !== null ? (i2 === 0 && (i2 = cl()), i2) : (n = Ot, n !== 0 || (n = window.event, n = n === void 0 ? 16 : Ko(n.type)), n);
  }
  function Fn(n, i, s, d) {
    if (50 < vs) throw vs = 0, Uu = null, Error(t(185));
    fa(n, s, d), ((gt & 2) === 0 || n !== Er) && (n === Er && ((gt & 2) === 0 && (Jl |= s), dr === 4 && Wi(n, Rr)), Wr(n, d), s === 1 && gt === 0 && (i.mode & 1) === 0 && (So = tt() + 500, Pl && Bi()));
  }
  function Wr(n, i) {
    var s = n.callbackNode;
    Dc(n, i);
    var d = qa(n, n === Er ? Rr : 0);
    if (d === 0) s !== null && Ke(s), n.callbackNode = null, n.callbackPriority = 0;
    else if (i = d & -d, n.callbackPriority !== i) {
      if (s != null && Ke(s), i === 1) n.tag === 0 ? BA(wm.bind(null, n)) : S_(wm.bind(null, n)), kA(function() {
        (gt & 6) === 0 && Bi();
      }), s = null;
      else {
        switch (ul(d)) {
          case 1:
            s = _r;
            break;
          case 4:
            s = _e;
            break;
          case 16:
            s = Vt;
            break;
          case 536870912:
            s = Vi;
            break;
          default:
            s = Vt;
        }
        s = $m(s, bm.bind(null, n));
      }
      n.callbackPriority = i, n.callbackNode = s;
    }
  }
  function bm(n, i) {
    if (n2 = -1, i2 = 0, (gt & 6) !== 0) throw Error(t(327));
    var s = n.callbackNode;
    if (Io() && n.callbackNode !== s) return null;
    var d = qa(n, n === Er ? Rr : 0);
    if (d === 0) return null;
    if ((d & 30) !== 0 || (d & n.expiredLanes) !== 0 || i) i = a2(n, d);
    else {
      i = d;
      var _ = gt;
      gt |= 2;
      var I = Vm();
      (Er !== n || Rr !== i) && (Ri = null, So = tt() + 500, Da(n, i));
      do
        try {
          lT();
          break;
        } catch (M) {
          Hm(n, M);
        }
      while (!0);
      nu(), Ql.current = I, gt = _, sr !== null ? i = 0 : (Er = null, Rr = 0, i = dr);
    }
    if (i !== 0) {
      if (i === 2 && (_ = Zo(n), _ !== 0 && (d = _, i = xu(n, _))), i === 1) throw s = Ss, Da(n, 0), Wi(n, d), Wr(n, tt()), s;
      if (i === 6) Wi(n, d);
      else {
        if (_ = n.current.alternate, (d & 30) === 0 && !oT(_) && (i = a2(n, d), i === 2 && (I = Zo(n), I !== 0 && (d = I, i = xu(n, I))), i === 1)) throw s = Ss, Da(n, 0), Wi(n, d), Wr(n, tt()), s;
        switch (n.finishedWork = _, n.finishedLanes = d, i) {
          case 0:
          case 1:
            throw Error(t(345));
          case 2:
            Aa(n, qr, Ri);
            break;
          case 3:
            if (Wi(n, d), (d & 130023424) === d && (i = ku + 500 - tt(), 10 < i)) {
              if (qa(n, 0) !== 0) break;
              if (_ = n.suspendedLanes, (_ & d) !== d) {
                Br(), n.pingedLanes |= n.suspendedLanes & _;
                break;
              }
              n.timeoutHandle = zc(Aa.bind(null, n, qr, Ri), i);
              break;
            }
            Aa(n, qr, Ri);
            break;
          case 4:
            if (Wi(n, d), (d & 4194240) === d) break;
            for (i = n.eventTimes, _ = -1; 0 < d; ) {
              var A = 31 - tn(d);
              I = 1 << A, A = i[A], A > _ && (_ = A), d &= ~I;
            }
            if (d = _, d = tt() - d, d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * aT(d / 1960)) - d, 10 < d) {
              n.timeoutHandle = zc(Aa.bind(null, n, qr, Ri), d);
              break;
            }
            Aa(n, qr, Ri);
            break;
          case 5:
            Aa(n, qr, Ri);
            break;
          default:
            throw Error(t(329));
        }
      }
    }
    return Wr(n, tt()), n.callbackNode === s ? bm.bind(null, n) : null;
  }
  function xu(n, i) {
    var s = Is;
    return n.current.memoizedState.isDehydrated && (Da(n, i).flags |= 256), n = a2(n, i), n !== 2 && (i = qr, qr = s, i !== null && Bu(i)), n;
  }
  function Bu(n) {
    qr === null ? qr = n : qr.push.apply(qr, n);
  }
  function oT(n) {
    for (var i = n; ; ) {
      if (i.flags & 16384) {
        var s = i.updateQueue;
        if (s !== null && (s = s.stores, s !== null)) for (var d = 0; d < s.length; d++) {
          var _ = s[d], I = _.getSnapshot;
          _ = _.value;
          try {
            if (!bn(I(), _)) return !1;
          } catch (A) {
            return !1;
          }
        }
      }
      if (s = i.child, i.subtreeFlags & 16384 && s !== null) s.return = i, i = s;
      else {
        if (i === n) break;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === n) return !0;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    return !0;
  }
  function Wi(n, i) {
    for (i &= ~Vu, i &= ~Jl, n.suspendedLanes |= i, n.pingedLanes &= ~i, n = n.expirationTimes; 0 < i; ) {
      var s = 31 - tn(i), d = 1 << s;
      n[s] = -1, i &= ~d;
    }
  }
  function wm(n) {
    if ((gt & 6) !== 0) throw Error(t(327));
    Io();
    var i = qa(n, 0);
    if ((i & 1) === 0) return Wr(n, tt()), null;
    var s = a2(n, i);
    if (n.tag !== 0 && s === 2) {
      var d = Zo(n);
      d !== 0 && (i = d, s = xu(n, d));
    }
    if (s === 1) throw s = Ss, Da(n, 0), Wi(n, i), Wr(n, tt()), s;
    if (s === 6) throw Error(t(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = i, Aa(n, qr, Ri), Wr(n, tt()), null;
  }
  function $u(n, i) {
    var s = gt;
    gt |= 1;
    try {
      return n(i);
    } finally {
      gt = s, gt === 0 && (So = tt() + 500, Pl && Bi());
    }
  }
  function Ra(n) {
    zi !== null && zi.tag === 0 && (gt & 6) === 0 && Io();
    var i = gt;
    gt |= 1;
    var s = En.transition, d = Ot;
    try {
      if (En.transition = null, Ot = 1, n) return n();
    } finally {
      Ot = d, En.transition = s, gt = i, (gt & 6) === 0 && Bi();
    }
  }
  function Gu() {
    on = Co.current, Bt(Co);
  }
  function Da(n, i) {
    n.finishedWork = null, n.finishedLanes = 0;
    var s = n.timeoutHandle;
    if (s !== -1 && (n.timeoutHandle = -1, VA(s)), sr !== null) for (s = sr.return; s !== null; ) {
      var d = s;
      switch (Qc(d), d.tag) {
        case 1:
          d = d.type.childContextTypes, d != null && Ll();
          break;
        case 3:
          _o(), Bt(Zr), Bt(yr), fu();
          break;
        case 5:
          cu(d);
          break;
        case 4:
          _o();
          break;
        case 13:
          Bt(Wt);
          break;
        case 19:
          Bt(Wt);
          break;
        case 10:
          iu(d.type._context);
          break;
        case 22:
        case 23:
          Gu();
      }
      s = s.return;
    }
    if (Er = n, sr = n = Yi(n.current, null), Rr = on = i, dr = 0, Ss = null, Vu = Jl = ga = 0, qr = Is = null, Sa !== null) {
      for (i = 0; i < Sa.length; i++) if (s = Sa[i], d = s.interleaved, d !== null) {
        s.interleaved = null;
        var _ = d.next, I = s.pending;
        if (I !== null) {
          var A = I.next;
          I.next = _, d.next = A;
        }
        s.pending = d;
      }
      Sa = null;
    }
    return n;
  }
  function Hm(n, i) {
    do {
      var s = sr;
      try {
        if (nu(), $l.current = zl, Gl) {
          for (var d = Yt.memoizedState; d !== null; ) {
            var _ = d.queue;
            _ !== null && (_.pending = null), d = d.next;
          }
          Gl = !1;
        }
        if (va = 0, mr = fr = Yt = null, ps = !1, hs = 0, Hu.current = null, s === null || s.return === null) {
          dr = 1, Ss = i, sr = null;
          break;
        }
        e: {
          var I = n, A = s.return, M = s, F = i;
          if (i = Rr, M.flags |= 32768, F !== null && typeof F == "object" && typeof F.then == "function") {
            var ee = F, he = M, Se = he.tag;
            if ((he.mode & 1) === 0 && (Se === 0 || Se === 11 || Se === 15)) {
              var pe = he.alternate;
              pe ? (he.updateQueue = pe.updateQueue, he.memoizedState = pe.memoizedState, he.lanes = pe.lanes) : (he.updateQueue = null, he.memoizedState = null);
            }
            var be = om(A);
            if (be !== null) {
              be.flags &= -257, sm(be, A, M, I, i), be.mode & 1 && am(I, ee, i), i = be, F = ee;
              var Ue = i.updateQueue;
              if (Ue === null) {
                var $e = /* @__PURE__ */ new Set();
                $e.add(F), i.updateQueue = $e;
              } else Ue.add(F);
              break e;
            } else {
              if ((i & 1) === 0) {
                am(I, ee, i), Zu();
                break e;
              }
              F = Error(t(426));
            }
          } else if (Gt && M.mode & 1) {
            var ir = om(A);
            if (ir !== null) {
              (ir.flags & 65536) === 0 && (ir.flags |= 256), sm(ir, A, M, I, i), tu(mo(F, M));
              break e;
            }
          }
          I = F = mo(F, M), dr !== 4 && (dr = 2), Is === null ? Is = [I] : Is.push(I), I = A;
          do {
            switch (I.tag) {
              case 3:
                I.flags |= 65536, i &= -i, I.lanes |= i;
                var j = nm(I, F, i);
                L_(I, j);
                break e;
              case 1:
                M = F;
                var x = I.type, K = I.stateNode;
                if ((I.flags & 128) === 0 && (typeof x.getDerivedStateFromError == "function" || K !== null && typeof K.componentDidCatch == "function" && (ji === null || !ji.has(K)))) {
                  I.flags |= 65536, i &= -i, I.lanes |= i;
                  var ve = im(I, M, i);
                  L_(I, ve);
                  break e;
                }
            }
            I = I.return;
          } while (I !== null);
        }
        Fm(s);
      } catch (Ge) {
        i = Ge, sr === s && s !== null && (sr = s = s.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Vm() {
    var n = Ql.current;
    return Ql.current = zl, n === null ? zl : n;
  }
  function Zu() {
    (dr === 0 || dr === 3 || dr === 2) && (dr = 4), Er === null || (ga & 268435455) === 0 && (Jl & 268435455) === 0 || Wi(Er, Rr);
  }
  function a2(n, i) {
    var s = gt;
    gt |= 2;
    var d = Vm();
    (Er !== n || Rr !== i) && (Ri = null, Da(n, i));
    do
      try {
        sT();
        break;
      } catch (_) {
        Hm(n, _);
      }
    while (!0);
    if (nu(), gt = s, Ql.current = d, sr !== null) throw Error(t(261));
    return Er = null, Rr = 0, dr;
  }
  function sT() {
    for (; sr !== null; ) km(sr);
  }
  function lT() {
    for (; sr !== null && !Ve(); ) km(sr);
  }
  function km(n) {
    var i = Bm(n.alternate, n, on);
    n.memoizedProps = n.pendingProps, i === null ? Fm(n) : sr = i, Hu.current = null;
  }
  function Fm(n) {
    var i = n;
    do {
      var s = i.alternate;
      if (n = i.return, (i.flags & 32768) === 0) {
        if (s = eT(s, i, on), s !== null) {
          sr = s;
          return;
        }
      } else {
        if (s = tT(s, i), s !== null) {
          s.flags &= 32767, sr = s;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          dr = 6, sr = null;
          return;
        }
      }
      if (i = i.sibling, i !== null) {
        sr = i;
        return;
      }
      sr = i = n;
    } while (i !== null);
    dr === 0 && (dr = 5);
  }
  function Aa(n, i, s) {
    var d = Ot, _ = En.transition;
    try {
      En.transition = null, Ot = 1, cT(n, i, s, d);
    } finally {
      En.transition = _, Ot = d;
    }
    return null;
  }
  function cT(n, i, s, d) {
    do
      Io();
    while (zi !== null);
    if ((gt & 6) !== 0) throw Error(t(327));
    s = n.finishedWork;
    var _ = n.finishedLanes;
    if (s === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, s === n.current) throw Error(t(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var I = s.lanes | s.childLanes;
    if (Ac(n, I), n === Er && (sr = Er = null, Rr = 0), (s.subtreeFlags & 2064) === 0 && (s.flags & 2064) === 0 || t2 || (t2 = !0, $m(Vt, function() {
      return Io(), null;
    })), I = (s.flags & 15990) !== 0, (s.subtreeFlags & 15990) !== 0 || I) {
      I = En.transition, En.transition = null;
      var A = Ot;
      Ot = 1;
      var M = gt;
      gt |= 4, Hu.current = null, nT(n, s), ym(s, n), NA(Zc), Ut = !!Gc, Zc = Gc = null, n.current = s, iT(s), Ht(), gt = M, Ot = A, En.transition = I;
    } else n.current = s;
    if (t2 && (t2 = !1, zi = n, r2 = _), I = n.pendingLanes, I === 0 && (ji = null), ca(s.stateNode), Wr(n, tt()), i !== null) for (d = n.onRecoverableError, s = 0; s < i.length; s++) _ = i[s], d(_.value, { componentStack: _.stack, digest: _.digest });
    if (e2) throw e2 = !1, n = Fu, Fu = null, n;
    return (r2 & 1) !== 0 && n.tag !== 0 && Io(), I = n.pendingLanes, (I & 1) !== 0 ? n === Uu ? vs++ : (vs = 0, Uu = n) : vs = 0, Bi(), null;
  }
  function Io() {
    if (zi !== null) {
      var n = ul(r2), i = En.transition, s = Ot;
      try {
        if (En.transition = null, Ot = 16 > n ? 16 : n, zi === null) var d = !1;
        else {
          if (n = zi, zi = null, r2 = 0, (gt & 6) !== 0) throw Error(t(331));
          var _ = gt;
          for (gt |= 4, Fe = n.current; Fe !== null; ) {
            var I = Fe, A = I.child;
            if ((Fe.flags & 16) !== 0) {
              var M = I.deletions;
              if (M !== null) {
                for (var F = 0; F < M.length; F++) {
                  var ee = M[F];
                  for (Fe = ee; Fe !== null; ) {
                    var he = Fe;
                    switch (he.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Cs(8, he, I);
                    }
                    var Se = he.child;
                    if (Se !== null) Se.return = he, Fe = Se;
                    else for (; Fe !== null; ) {
                      he = Fe;
                      var pe = he.sibling, be = he.return;
                      if (Rm(he), he === ee) {
                        Fe = null;
                        break;
                      }
                      if (pe !== null) {
                        pe.return = be, Fe = pe;
                        break;
                      }
                      Fe = be;
                    }
                  }
                }
                var Ue = I.alternate;
                if (Ue !== null) {
                  var $e = Ue.child;
                  if ($e !== null) {
                    Ue.child = null;
                    do {
                      var ir = $e.sibling;
                      $e.sibling = null, $e = ir;
                    } while ($e !== null);
                  }
                }
                Fe = I;
              }
            }
            if ((I.subtreeFlags & 2064) !== 0 && A !== null) A.return = I, Fe = A;
            else e: for (; Fe !== null; ) {
              if (I = Fe, (I.flags & 2048) !== 0) switch (I.tag) {
                case 0:
                case 11:
                case 15:
                  Cs(9, I, I.return);
              }
              var j = I.sibling;
              if (j !== null) {
                j.return = I.return, Fe = j;
                break e;
              }
              Fe = I.return;
            }
          }
          var x = n.current;
          for (Fe = x; Fe !== null; ) {
            A = Fe;
            var K = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && K !== null) K.return = A, Fe = K;
            else e: for (A = x; Fe !== null; ) {
              if (M = Fe, (M.flags & 2048) !== 0) try {
                switch (M.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Xl(9, M);
                }
              } catch (Ge) {
                Jt(M, M.return, Ge);
              }
              if (M === A) {
                Fe = null;
                break e;
              }
              var ve = M.sibling;
              if (ve !== null) {
                ve.return = M.return, Fe = ve;
                break e;
              }
              Fe = M.return;
            }
          }
          if (gt = _, Bi(), Ur && typeof Ur.onPostCommitFiberRoot == "function") try {
            Ur.onPostCommitFiberRoot(_i, n);
          } catch (Ge) {
          }
          d = !0;
        }
        return d;
      } finally {
        Ot = s, En.transition = i;
      }
    }
    return !1;
  }
  function Um(n, i, s) {
    i = mo(s, i), i = nm(n, i, 1), n = Gi(n, i, 1), i = Br(), n !== null && (fa(n, 1, i), Wr(n, i));
  }
  function Jt(n, i, s) {
    if (n.tag === 3) Um(n, n, s);
    else for (; i !== null; ) {
      if (i.tag === 3) {
        Um(i, n, s);
        break;
      } else if (i.tag === 1) {
        var d = i.stateNode;
        if (typeof i.type.getDerivedStateFromError == "function" || typeof d.componentDidCatch == "function" && (ji === null || !ji.has(d))) {
          n = mo(s, n), n = im(i, n, 1), i = Gi(i, n, 1), n = Br(), i !== null && (fa(i, 1, n), Wr(i, n));
          break;
        }
      }
      i = i.return;
    }
  }
  function uT(n, i, s) {
    var d = n.pingCache;
    d !== null && d.delete(i), i = Br(), n.pingedLanes |= n.suspendedLanes & s, Er === n && (Rr & s) === s && (dr === 4 || dr === 3 && (Rr & 130023424) === Rr && 500 > tt() - ku ? Da(n, 0) : Vu |= s), Wr(n, i);
  }
  function xm(n, i) {
    i === 0 && ((n.mode & 1) === 0 ? i = 1 : (i = za, za <<= 1, (za & 130023424) === 0 && (za = 4194304)));
    var s = Br();
    n = Ii(n, i), n !== null && (fa(n, i, s), Wr(n, s));
  }
  function fT(n) {
    var i = n.memoizedState, s = 0;
    i !== null && (s = i.retryLane), xm(n, s);
  }
  function dT(n, i) {
    var s = 0;
    switch (n.tag) {
      case 13:
        var d = n.stateNode, _ = n.memoizedState;
        _ !== null && (s = _.retryLane);
        break;
      case 19:
        d = n.stateNode;
        break;
      default:
        throw Error(t(314));
    }
    d !== null && d.delete(i), xm(n, s);
  }
  var Bm;
  Bm = function(n, i, s) {
    if (n !== null) if (n.memoizedProps !== i.pendingProps || Zr.current) zr = !0;
    else {
      if ((n.lanes & s) === 0 && (i.flags & 128) === 0) return zr = !1, JA(n, i, s);
      zr = (n.flags & 131072) !== 0;
    }
    else zr = !1, Gt && (i.flags & 1048576) !== 0 && I_(i, wl, i.index);
    switch (i.lanes = 0, i.tag) {
      case 2:
        var d = i.type;
        Yl(n, i), n = i.pendingProps;
        var _ = so(i, yr.current);
        ho(i, s), _ = hu(null, i, d, n, _, s);
        var I = _u();
        return i.flags |= 1, typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0 ? (i.tag = 1, i.memoizedState = null, i.updateQueue = null, jr(d) ? (I = !0, Ml(i)) : I = !1, i.memoizedState = _.state !== null && _.state !== void 0 ? _.state : null, su(i), _.updater = ql, i.stateNode = _, _._reactInternals = i, vu(i, d, n, s), i = Au(null, i, d, !0, I, s)) : (i.tag = 0, Gt && I && Xc(i), xr(null, i, _, s), i = i.child), i;
      case 16:
        d = i.elementType;
        e: {
          switch (Yl(n, i), n = i.pendingProps, _ = d._init, d = _(d._payload), i.type = d, _ = i.tag = hT(d), n = Hn(d, n), _) {
            case 0:
              i = Du(null, i, d, n, s);
              break e;
            case 1:
              i = pm(null, i, d, n, s);
              break e;
            case 11:
              i = lm(null, i, d, n, s);
              break e;
            case 14:
              i = cm(null, i, d, Hn(d.type, n), s);
              break e;
          }
          throw Error(t(
            306,
            d,
            ""
          ));
        }
        return i;
      case 0:
        return d = i.type, _ = i.pendingProps, _ = i.elementType === d ? _ : Hn(d, _), Du(n, i, d, _, s);
      case 1:
        return d = i.type, _ = i.pendingProps, _ = i.elementType === d ? _ : Hn(d, _), pm(n, i, d, _, s);
      case 3:
        e: {
          if (hm(i), n === null) throw Error(t(387));
          d = i.pendingProps, I = i.memoizedState, _ = I.element, N_(n, i), xl(i, d, null, s);
          var A = i.memoizedState;
          if (d = A.element, I.isDehydrated) if (I = { element: d, isDehydrated: !1, cache: A.cache, pendingSuspenseBoundaries: A.pendingSuspenseBoundaries, transitions: A.transitions }, i.updateQueue.baseState = I, i.memoizedState = I, i.flags & 256) {
            _ = mo(Error(t(423)), i), i = _m(n, i, d, s, _);
            break e;
          } else if (d !== _) {
            _ = mo(Error(t(424)), i), i = _m(n, i, d, s, _);
            break e;
          } else for (an = Fi(i.stateNode.containerInfo.firstChild), nn = i, Gt = !0, wn = null, s = O_(i, null, d, s), i.child = s; s; ) s.flags = s.flags & -3 | 4096, s = s.sibling;
          else {
            if (uo(), d === _) {
              i = gi(n, i, s);
              break e;
            }
            xr(n, i, d, s);
          }
          i = i.child;
        }
        return i;
      case 5:
        return P_(i), n === null && eu(i), d = i.type, _ = i.pendingProps, I = n !== null ? n.memoizedProps : null, A = _.children, jc(d, _) ? A = null : I !== null && jc(d, I) && (i.flags |= 32), dm(n, i), xr(n, i, A, s), i.child;
      case 6:
        return n === null && eu(i), null;
      case 13:
        return mm(n, i, s);
      case 4:
        return lu(i, i.stateNode.containerInfo), d = i.pendingProps, n === null ? i.child = fo(i, null, d, s) : xr(n, i, d, s), i.child;
      case 11:
        return d = i.type, _ = i.pendingProps, _ = i.elementType === d ? _ : Hn(d, _), lm(n, i, d, _, s);
      case 7:
        return xr(n, i, i.pendingProps, s), i.child;
      case 8:
        return xr(n, i, i.pendingProps.children, s), i.child;
      case 12:
        return xr(n, i, i.pendingProps.children, s), i.child;
      case 10:
        e: {
          if (d = i.type._context, _ = i.pendingProps, I = i.memoizedProps, A = _.value, kt(kl, d._currentValue), d._currentValue = A, I !== null) if (bn(I.value, A)) {
            if (I.children === _.children && !Zr.current) {
              i = gi(n, i, s);
              break e;
            }
          } else for (I = i.child, I !== null && (I.return = i); I !== null; ) {
            var M = I.dependencies;
            if (M !== null) {
              A = I.child;
              for (var F = M.firstContext; F !== null; ) {
                if (F.context === d) {
                  if (I.tag === 1) {
                    F = vi(-1, s & -s), F.tag = 2;
                    var ee = I.updateQueue;
                    if (ee !== null) {
                      ee = ee.shared;
                      var he = ee.pending;
                      he === null ? F.next = F : (F.next = he.next, he.next = F), ee.pending = F;
                    }
                  }
                  I.lanes |= s, F = I.alternate, F !== null && (F.lanes |= s), au(
                    I.return,
                    s,
                    i
                  ), M.lanes |= s;
                  break;
                }
                F = F.next;
              }
            } else if (I.tag === 10) A = I.type === i.type ? null : I.child;
            else if (I.tag === 18) {
              if (A = I.return, A === null) throw Error(t(341));
              A.lanes |= s, M = A.alternate, M !== null && (M.lanes |= s), au(A, s, i), A = I.sibling;
            } else A = I.child;
            if (A !== null) A.return = I;
            else for (A = I; A !== null; ) {
              if (A === i) {
                A = null;
                break;
              }
              if (I = A.sibling, I !== null) {
                I.return = A.return, A = I;
                break;
              }
              A = A.return;
            }
            I = A;
          }
          xr(n, i, _.children, s), i = i.child;
        }
        return i;
      case 9:
        return _ = i.type, d = i.pendingProps.children, ho(i, s), _ = _n(_), d = d(_), i.flags |= 1, xr(n, i, d, s), i.child;
      case 14:
        return d = i.type, _ = Hn(d, i.pendingProps), _ = Hn(d.type, _), cm(n, i, d, _, s);
      case 15:
        return um(n, i, i.type, i.pendingProps, s);
      case 17:
        return d = i.type, _ = i.pendingProps, _ = i.elementType === d ? _ : Hn(d, _), Yl(n, i), i.tag = 1, jr(d) ? (n = !0, Ml(i)) : n = !1, ho(i, s), tm(i, d, _), vu(i, d, _, s), Au(null, i, d, !0, n, s);
      case 19:
        return Cm(n, i, s);
      case 22:
        return fm(n, i, s);
    }
    throw Error(t(156, i.tag));
  };
  function $m(n, i) {
    return fe(n, i);
  }
  function pT(n, i, s, d) {
    this.tag = n, this.key = s, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = i, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = d, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Cn(n, i, s, d) {
    return new pT(n, i, s, d);
  }
  function ju(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function hT(n) {
    if (typeof n == "function") return ju(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === z) return 11;
      if (n === te) return 14;
    }
    return 2;
  }
  function Yi(n, i) {
    var s = n.alternate;
    return s === null ? (s = Cn(n.tag, i, n.key, n.mode), s.elementType = n.elementType, s.type = n.type, s.stateNode = n.stateNode, s.alternate = n, n.alternate = s) : (s.pendingProps = i, s.type = n.type, s.flags = 0, s.subtreeFlags = 0, s.deletions = null), s.flags = n.flags & 14680064, s.childLanes = n.childLanes, s.lanes = n.lanes, s.child = n.child, s.memoizedProps = n.memoizedProps, s.memoizedState = n.memoizedState, s.updateQueue = n.updateQueue, i = n.dependencies, s.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }, s.sibling = n.sibling, s.index = n.index, s.ref = n.ref, s;
  }
  function o2(n, i, s, d, _, I) {
    var A = 2;
    if (d = n, typeof n == "function") ju(n) && (A = 1);
    else if (typeof n == "string") A = 5;
    else e: switch (n) {
      case L:
        return Ta(s.children, _, I, i);
      case k:
        A = 8, _ |= 8;
        break;
      case w:
        return n = Cn(12, s, i, _ | 2), n.elementType = w, n.lanes = I, n;
      case q:
        return n = Cn(13, s, i, _), n.elementType = q, n.lanes = I, n;
      case W:
        return n = Cn(19, s, i, _), n.elementType = W, n.lanes = I, n;
      case le:
        return s2(s, _, I, i);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case V:
            A = 10;
            break e;
          case U:
            A = 9;
            break e;
          case z:
            A = 11;
            break e;
          case te:
            A = 14;
            break e;
          case se:
            A = 16, d = null;
            break e;
        }
        throw Error(t(130, n == null ? n : typeof n, ""));
    }
    return i = Cn(A, s, i, _), i.elementType = n, i.type = d, i.lanes = I, i;
  }
  function Ta(n, i, s, d) {
    return n = Cn(7, n, d, i), n.lanes = s, n;
  }
  function s2(n, i, s, d) {
    return n = Cn(22, n, d, i), n.elementType = le, n.lanes = s, n.stateNode = { isHidden: !1 }, n;
  }
  function zu(n, i, s) {
    return n = Cn(6, n, null, i), n.lanes = s, n;
  }
  function qu(n, i, s) {
    return i = Cn(4, n.children !== null ? n.children : [], n.key, i), i.lanes = s, i.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, i;
  }
  function _T(n, i, s, d, _) {
    this.tag = i, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = jo(0), this.expirationTimes = jo(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = jo(0), this.identifierPrefix = d, this.onRecoverableError = _, this.mutableSourceEagerHydrationData = null;
  }
  function Wu(n, i, s, d, _, I, A, M, F) {
    return n = new _T(n, i, s, M, F), i === 1 ? (i = 1, I === !0 && (i |= 8)) : i = 0, I = Cn(3, null, null, i), n.current = I, I.stateNode = n, I.memoizedState = { element: d, isDehydrated: s, cache: null, transitions: null, pendingSuspenseBoundaries: null }, su(I), n;
  }
  function mT(n, i, s) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: b, key: d == null ? null : "" + d, children: n, containerInfo: i, implementation: s };
  }
  function Gm(n) {
    if (!n) return xi;
    n = n._reactInternals;
    e: {
      if (dn(n) !== n || n.tag !== 1) throw Error(t(170));
      var i = n;
      do {
        switch (i.tag) {
          case 3:
            i = i.stateNode.context;
            break e;
          case 1:
            if (jr(i.type)) {
              i = i.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        i = i.return;
      } while (i !== null);
      throw Error(t(171));
    }
    if (n.tag === 1) {
      var s = n.type;
      if (jr(s)) return E_(n, s, i);
    }
    return i;
  }
  function Zm(n, i, s, d, _, I, A, M, F) {
    return n = Wu(s, d, !0, n, _, I, A, M, F), n.context = Gm(null), s = n.current, d = Br(), _ = qi(s), I = vi(d, _), I.callback = i != null ? i : null, Gi(s, I, _), n.current.lanes = _, fa(n, _, d), Wr(n, d), n;
  }
  function l2(n, i, s, d) {
    var _ = i.current, I = Br(), A = qi(_);
    return s = Gm(s), i.context === null ? i.context = s : i.pendingContext = s, i = vi(I, A), i.payload = { element: n }, d = d === void 0 ? null : d, d !== null && (i.callback = d), n = Gi(_, i, A), n !== null && (Fn(n, _, A, I), Ul(n, _, A)), A;
  }
  function c2(n) {
    if (n = n.current, !n.child) return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function jm(n, i) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var s = n.retryLane;
      n.retryLane = s !== 0 && s < i ? s : i;
    }
  }
  function Yu(n, i) {
    jm(n, i), (n = n.alternate) && jm(n, i);
  }
  function ET() {
    return null;
  }
  var zm = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function Ku(n) {
    this._internalRoot = n;
  }
  u2.prototype.render = Ku.prototype.render = function(n) {
    var i = this._internalRoot;
    if (i === null) throw Error(t(409));
    l2(n, i, null, null);
  }, u2.prototype.unmount = Ku.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var i = n.containerInfo;
      Ra(function() {
        l2(null, n, null, null);
      }), i[mi] = null;
    }
  };
  function u2(n) {
    this._internalRoot = n;
  }
  u2.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var i = pl();
      n = { blockedOn: null, target: n, priority: i };
      for (var s = 0; s < Xn.length && i !== 0 && i < Xn[s].priority; s++) ;
      Xn.splice(s, 0, n), s === 0 && El(n);
    }
  };
  function Xu(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function f2(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function qm() {
  }
  function CT(n, i, s, d, _) {
    if (_) {
      if (typeof d == "function") {
        var I = d;
        d = function() {
          var ee = c2(A);
          I.call(ee);
        };
      }
      var A = Zm(i, d, n, 0, null, !1, !1, "", qm);
      return n._reactRootContainer = A, n[mi] = A.current, as(n.nodeType === 8 ? n.parentNode : n), Ra(), A;
    }
    for (; _ = n.lastChild; ) n.removeChild(_);
    if (typeof d == "function") {
      var M = d;
      d = function() {
        var ee = c2(F);
        M.call(ee);
      };
    }
    var F = Wu(n, 0, !1, null, null, !1, !1, "", qm);
    return n._reactRootContainer = F, n[mi] = F.current, as(n.nodeType === 8 ? n.parentNode : n), Ra(function() {
      l2(i, F, s, d);
    }), F;
  }
  function d2(n, i, s, d, _) {
    var I = s._reactRootContainer;
    if (I) {
      var A = I;
      if (typeof _ == "function") {
        var M = _;
        _ = function() {
          var F = c2(A);
          M.call(F);
        };
      }
      l2(i, A, n, _);
    } else A = CT(s, i, n, _, d);
    return c2(A);
  }
  fl = function(n) {
    switch (n.tag) {
      case 3:
        var i = n.stateNode;
        if (i.current.memoizedState.isDehydrated) {
          var s = ua(i.pendingLanes);
          s !== 0 && (zo(i, s | 1), Wr(i, tt()), (gt & 6) === 0 && (So = tt() + 500, Bi()));
        }
        break;
      case 13:
        Ra(function() {
          var d = Ii(n, 1);
          if (d !== null) {
            var _ = Br();
            Fn(d, n, 1, _);
          }
        }), Yu(n, 1);
    }
  }, qo = function(n) {
    if (n.tag === 13) {
      var i = Ii(n, 134217728);
      if (i !== null) {
        var s = Br();
        Fn(i, n, 134217728, s);
      }
      Yu(n, 134217728);
    }
  }, dl = function(n) {
    if (n.tag === 13) {
      var i = qi(n), s = Ii(n, i);
      if (s !== null) {
        var d = Br();
        Fn(s, n, i, d);
      }
      Yu(n, i);
    }
  }, pl = function() {
    return Ot;
  }, hl = function(n, i) {
    var s = Ot;
    try {
      return Ot = n, i();
    } finally {
      Ot = s;
    }
  }, Te = function(n, i, s) {
    switch (i) {
      case "input":
        if (St(n, s), i = s.name, s.type === "radio" && i != null) {
          for (s = n; s.parentNode; ) s = s.parentNode;
          for (s = s.querySelectorAll("input[name=" + JSON.stringify("" + i) + '][type="radio"]'), i = 0; i < s.length; i++) {
            var d = s[i];
            if (d !== n && d.form === n.form) {
              var _ = Nl(d);
              if (!_) throw Error(t(90));
              ot(d), St(d, _);
            }
          }
        }
        break;
      case "textarea":
        Lt(n, s);
        break;
      case "select":
        i = s.value, i != null && me(n, !!s.multiple, i, !1);
    }
  }, wt = $u, Qt = Ra;
  var ST = { usingClientEntryPoint: !1, Events: [ls, ao, Nl, Rt, Nt, $u] }, gs = { findFiberByHostInstance: _a, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, IT = { bundleType: gs.bundleType, version: gs.version, rendererPackageName: gs.rendererPackageName, rendererConfig: gs.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: T.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = ne(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: gs.findFiberByHostInstance || ET, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
    var p2 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!p2.isDisabled && p2.supportsFiber) try {
      _i = p2.inject(IT), Ur = p2;
    } catch (n) {
    }
  }
  return Yr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ST, Yr.createPortal = function(n, i) {
    var s = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Xu(i)) throw Error(t(200));
    return mT(n, i, null, s);
  }, Yr.createRoot = function(n, i) {
    if (!Xu(n)) throw Error(t(299));
    var s = !1, d = "", _ = zm;
    return i != null && (i.unstable_strictMode === !0 && (s = !0), i.identifierPrefix !== void 0 && (d = i.identifierPrefix), i.onRecoverableError !== void 0 && (_ = i.onRecoverableError)), i = Wu(n, 1, !1, null, null, s, !1, d, _), n[mi] = i.current, as(n.nodeType === 8 ? n.parentNode : n), new Ku(i);
  }, Yr.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var i = n._reactInternals;
    if (i === void 0)
      throw typeof n.render == "function" ? Error(t(188)) : (n = Object.keys(n).join(","), Error(t(268, n)));
    return n = ne(i), n = n === null ? null : n.stateNode, n;
  }, Yr.flushSync = function(n) {
    return Ra(n);
  }, Yr.hydrate = function(n, i, s) {
    if (!f2(i)) throw Error(t(200));
    return d2(null, n, i, !0, s);
  }, Yr.hydrateRoot = function(n, i, s) {
    if (!Xu(n)) throw Error(t(405));
    var d = s != null && s.hydratedSources || null, _ = !1, I = "", A = zm;
    if (s != null && (s.unstable_strictMode === !0 && (_ = !0), s.identifierPrefix !== void 0 && (I = s.identifierPrefix), s.onRecoverableError !== void 0 && (A = s.onRecoverableError)), i = Zm(i, null, n, 1, s != null ? s : null, _, !1, I, A), n[mi] = i.current, as(n), d) for (n = 0; n < d.length; n++) s = d[n], _ = s._getVersion, _ = _(s._source), i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [s, _] : i.mutableSourceEagerHydrationData.push(
      s,
      _
    );
    return new u2(i);
  }, Yr.render = function(n, i, s) {
    if (!f2(i)) throw Error(t(200));
    return d2(null, n, i, !1, s);
  }, Yr.unmountComponentAtNode = function(n) {
    if (!f2(n)) throw Error(t(40));
    return n._reactRootContainer ? (Ra(function() {
      d2(null, null, n, !1, function() {
        n._reactRootContainer = null, n[mi] = null;
      });
    }), !0) : !1;
  }, Yr.unstable_batchedUpdates = $u, Yr.unstable_renderSubtreeIntoContainer = function(n, i, s, d) {
    if (!f2(s)) throw Error(t(200));
    if (n == null || n._reactInternals === void 0) throw Error(t(38));
    return d2(n, i, s, !1, d);
  }, Yr.version = "18.3.1-next-f1338f8080-20240426", Yr;
}
var rC;
function Jg() {
  if (rC) return q3.exports;
  rC = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (r) {
        console.error(r);
      }
  }
  return e(), q3.exports = aO(), q3.exports;
}
var nC;
function oO() {
  if (nC) return h2;
  nC = 1;
  var e = Jg();
  return h2.createRoot = e.createRoot, h2.hydrateRoot = e.hydrateRoot, h2;
}
var eR = oO(), iC = {}, K3, aC;
function eh() {
  return aC || (aC = 1, K3 = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined"), K3;
}
var X3, oC;
function bi() {
  if (oC) return X3;
  oC = 1;
  var e = qg(), r = Gn();
  return X3 = function(t, a, o) {
    return o.get && e(o.get, a, { getter: !0 }), o.set && e(o.set, a, { setter: !0 }), r.f(t, a, o);
  }, X3;
}
var Q3, sC;
function th() {
  if (sC) return Q3;
  sC = 1;
  var e = pi();
  return Q3 = function(r, t, a) {
    for (var o in t) e(r, o, t[o], a);
    return r;
  }, Q3;
}
var J3, lC;
function Ks() {
  if (lC) return J3;
  lC = 1;
  var e = ka(), r = TypeError;
  return J3 = function(t, a) {
    if (e(a, t)) return t;
    throw new r("Incorrect invocation");
  }, J3;
}
var ef, cC;
function rh() {
  if (cC) return ef;
  cC = 1;
  var e = fi(), r = ko(), t = RangeError;
  return ef = function(a) {
    if (a === void 0) return 0;
    var o = e(a), l = r(o);
    if (o !== l) throw new t("Wrong length or index");
    return l;
  }, ef;
}
var tf, uC;
function sO() {
  return uC || (uC = 1, tf = Math.sign || function(r) {
    var t = +r;
    return t === 0 || t !== t ? t : t < 0 ? -1 : 1;
  }), tf;
}
var rf, fC;
function lO() {
  if (fC) return rf;
  fC = 1;
  var e = 2220446049250313e-31, r = 1 / e;
  return rf = function(t) {
    return t + r - r;
  }, rf;
}
var nf, dC;
function cO() {
  if (dC) return nf;
  dC = 1;
  var e = sO(), r = lO(), t = Math.abs, a = 2220446049250313e-31;
  return nf = function(o, l, c, u) {
    var p = +o, f = t(p), h = e(p);
    if (f < u) return h * r(f / u / l) * u * l;
    var C = (1 + l / a) * f, E = C - (C - f);
    return E > c || E !== E ? h * (1 / 0) : h * E;
  }, nf;
}
var af, pC;
function uO() {
  if (pC) return af;
  pC = 1;
  var e = cO(), r = 11920928955078125e-23, t = 34028234663852886e22, a = 11754943508222875e-54;
  return af = Math.fround || function(l) {
    return e(l, r, t, a);
  }, af;
}
var of, hC;
function fO() {
  if (hC) return of;
  hC = 1;
  var e = Array, r = Math.abs, t = Math.pow, a = Math.floor, o = Math.log, l = Math.LN2, c = function(p, f, h) {
    var C = e(h), E = h * 8 - f - 1, m = (1 << E) - 1, S = m >> 1, v = f === 23 ? t(2, -24) - t(2, -77) : 0, g = p < 0 || p === 0 && 1 / p < 0 ? 1 : 0, O = 0, D, R, T;
    for (p = r(p), p !== p || p === 1 / 0 ? (R = p !== p ? 1 : 0, D = m) : (D = a(o(p) / l), T = t(2, -D), p * T < 1 && (D--, T *= 2), D + S >= 1 ? p += v / T : p += v * t(2, 1 - S), p * T >= 2 && (D++, T /= 2), D + S >= m ? (R = 0, D = m) : D + S >= 1 ? (R = (p * T - 1) * t(2, f), D += S) : (R = p * t(2, S - 1) * t(2, f), D = 0)); f >= 8; )
      C[O++] = R & 255, R /= 256, f -= 8;
    for (D = D << f | R, E += f; E > 0; )
      C[O++] = D & 255, D /= 256, E -= 8;
    return C[O - 1] |= g * 128, C;
  }, u = function(p, f) {
    var h = p.length, C = h * 8 - f - 1, E = (1 << C) - 1, m = E >> 1, S = C - 7, v = h - 1, g = p[v--], O = g & 127, D;
    for (g >>= 7; S > 0; )
      O = O * 256 + p[v--], S -= 8;
    for (D = O & (1 << -S) - 1, O >>= -S, S += f; S > 0; )
      D = D * 256 + p[v--], S -= 8;
    if (O === 0)
      O = 1 - m;
    else {
      if (O === E)
        return D ? NaN : g ? -1 / 0 : 1 / 0;
      D += t(2, f), O -= m;
    }
    return (g ? -1 : 1) * D * t(2, O - f);
  };
  return of = {
    pack: c,
    unpack: u
  }, of;
}
var sf, _C;
function tR() {
  if (_C) return sf;
  _C = 1;
  var e = Tn(), r = Q2(), t = Jr();
  return sf = function(o) {
    for (var l = e(this), c = t(l), u = arguments.length, p = r(u > 1 ? arguments[1] : void 0, c), f = u > 2 ? arguments[2] : void 0, h = f === void 0 ? c : r(f, c); h > p; ) l[p++] = o;
    return l;
  }, sf;
}
var lf, mC;
function nh() {
  if (mC) return lf;
  mC = 1;
  var e = Et(), r = It(), t = jt(), a = eh(), o = J2(), l = On(), c = bi(), u = th(), p = vt(), f = Ks(), h = fi(), C = ko(), E = rh(), m = uO(), S = fO(), v = Ws(), g = Uo(), O = tR(), D = nc(), R = Qp(), T = Kp(), N = Fo(), b = di(), L = o.PROPER, k = o.CONFIGURABLE, w = "ArrayBuffer", V = "DataView", U = "prototype", z = "Wrong length", q = "Wrong index", W = b.getterFor(w), te = b.getterFor(V), se = b.set, le = e[w], B = le, J = B && B[U], Q = e[V], P = Q && Q[U], $ = Object.prototype, ce = e.Array, ue = e.RangeError, ie = r(O), Re = r([].reverse), Ae = S.pack, Ce = S.unpack, Le = function(me) {
    return [me & 255];
  }, Ze = function(me) {
    return [me & 255, me >> 8 & 255];
  }, at = function(me) {
    return [me & 255, me >> 8 & 255, me >> 16 & 255, me >> 24 & 255];
  }, ot = function(me) {
    return me[3] << 24 | me[2] << 16 | me[1] << 8 | me[0];
  }, ct = function(me) {
    return Ae(m(me), 23, 4);
  }, lt = function(me) {
    return Ae(me, 52, 8);
  }, Ct = function(me, ye, xe) {
    c(me[U], ye, {
      configurable: !0,
      get: function() {
        return xe(this)[ye];
      }
    });
  }, yt = function(me, ye, xe, Lt) {
    var _t = te(me), De = E(xe), He = !!Lt;
    if (De + ye > _t.byteLength) throw new ue(q);
    var Be = _t.bytes, Je = De + _t.byteOffset, ut = D(Be, Je, Je + ye);
    return He ? ut : Re(ut);
  }, St = function(me, ye, xe, Lt, _t, De) {
    var He = te(me), Be = E(xe), Je = Lt(+_t), ut = !!De;
    if (Be + ye > He.byteLength) throw new ue(q);
    for (var Tt = He.bytes, Ye = Be + He.byteOffset, ge = 0; ge < ye; ge++) Tt[Ye + ge] = Je[ut ? ge : ye - ge - 1];
  };
  if (!a)
    B = function(ye) {
      f(this, J);
      var xe = E(ye);
      se(this, {
        type: w,
        bytes: ie(ce(xe), 0),
        byteLength: xe
      }), t || (this.byteLength = xe, this.detached = !1);
    }, J = B[U], Q = function(ye, xe, Lt) {
      f(this, P), f(ye, J);
      var _t = W(ye), De = _t.byteLength, He = h(xe);
      if (He < 0 || He > De) throw new ue("Wrong offset");
      if (Lt = Lt === void 0 ? De - He : C(Lt), He + Lt > De) throw new ue(z);
      se(this, {
        type: V,
        buffer: ye,
        byteLength: Lt,
        byteOffset: He,
        bytes: _t.bytes
      }), t || (this.buffer = ye, this.byteLength = Lt, this.byteOffset = He);
    }, P = Q[U], t && (Ct(B, "byteLength", W), Ct(Q, "buffer", te), Ct(Q, "byteLength", te), Ct(Q, "byteOffset", te)), u(P, {
      getInt8: function(ye) {
        return yt(this, 1, ye)[0] << 24 >> 24;
      },
      getUint8: function(ye) {
        return yt(this, 1, ye)[0];
      },
      getInt16: function(ye) {
        var xe = yt(this, 2, ye, arguments.length > 1 ? arguments[1] : !1);
        return (xe[1] << 8 | xe[0]) << 16 >> 16;
      },
      getUint16: function(ye) {
        var xe = yt(this, 2, ye, arguments.length > 1 ? arguments[1] : !1);
        return xe[1] << 8 | xe[0];
      },
      getInt32: function(ye) {
        return ot(yt(this, 4, ye, arguments.length > 1 ? arguments[1] : !1));
      },
      getUint32: function(ye) {
        return ot(yt(this, 4, ye, arguments.length > 1 ? arguments[1] : !1)) >>> 0;
      },
      getFloat32: function(ye) {
        return Ce(yt(this, 4, ye, arguments.length > 1 ? arguments[1] : !1), 23);
      },
      getFloat64: function(ye) {
        return Ce(yt(this, 8, ye, arguments.length > 1 ? arguments[1] : !1), 52);
      },
      setInt8: function(ye, xe) {
        St(this, 1, ye, Le, xe);
      },
      setUint8: function(ye, xe) {
        St(this, 1, ye, Le, xe);
      },
      setInt16: function(ye, xe) {
        St(this, 2, ye, Ze, xe, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint16: function(ye, xe) {
        St(this, 2, ye, Ze, xe, arguments.length > 2 ? arguments[2] : !1);
      },
      setInt32: function(ye, xe) {
        St(this, 4, ye, at, xe, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint32: function(ye, xe) {
        St(this, 4, ye, at, xe, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat32: function(ye, xe) {
        St(this, 4, ye, ct, xe, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat64: function(ye, xe) {
        St(this, 8, ye, lt, xe, arguments.length > 2 ? arguments[2] : !1);
      }
    });
  else {
    var st = L && le.name !== w;
    !p(function() {
      le(1);
    }) || !p(function() {
      new le(-1);
    }) || p(function() {
      return new le(), new le(1.5), new le(NaN), le.length !== 1 || st && !k;
    }) ? (B = function(ye) {
      return f(this, J), R(new le(E(ye)), this, B);
    }, B[U] = J, J.constructor = B, T(B, le)) : st && k && l(le, "name", w), g && v(P) !== $ && g(P, $);
    var ze = new Q(new B(2)), ht = r(P.setInt8);
    ze.setInt8(0, 2147483648), ze.setInt8(1, 2147483649), (ze.getInt8(0) || !ze.getInt8(1)) && u(P, {
      setInt8: function(ye, xe) {
        ht(this, ye, xe << 24 >> 24);
      },
      setUint8: function(ye, xe) {
        ht(this, ye, xe << 24 >> 24);
      }
    }, { unsafe: !0 });
  }
  return N(B, w), N(Q, V), lf = {
    ArrayBuffer: B,
    DataView: Q
  }, lf;
}
var cf, EC;
function rR() {
  if (EC) return cf;
  EC = 1;
  var e = ia(), r = bi(), t = cr(), a = jt(), o = t("species");
  return cf = function(l) {
    var c = e(l);
    a && c && !c[o] && r(c, o, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, cf;
}
var CC;
function dO() {
  if (CC) return iC;
  CC = 1;
  var e = zt(), r = Et(), t = nh(), a = rR(), o = "ArrayBuffer", l = t[o], c = r[o];
  return e({ global: !0, constructor: !0, forced: c !== l }, {
    ArrayBuffer: l
  }), a(o), iC;
}
dO();
var SC = {}, uf, IC;
function ih() {
  if (IC) return uf;
  IC = 1;
  var e = na(), r = It();
  return uf = function(t) {
    if (e(t) === "Function") return r(t);
  }, uf;
}
var vC;
function pO() {
  if (vC) return SC;
  vC = 1;
  var e = zt(), r = ih(), t = vt(), a = nh(), o = ar(), l = Q2(), c = ko(), u = a.ArrayBuffer, p = a.DataView, f = p.prototype, h = r(u.prototype.slice), C = r(f.getUint8), E = r(f.setUint8), m = t(function() {
    return !new u(2).slice(1, void 0).byteLength;
  });
  return e({ target: "ArrayBuffer", proto: !0, unsafe: !0, forced: m }, {
    slice: function(v, g) {
      if (h && g === void 0)
        return h(o(this), v);
      for (var O = o(this).byteLength, D = l(v, O), R = l(g === void 0 ? O : g, O), T = new u(c(R - D)), N = new p(this), b = new p(T), L = 0; D < R; )
        E(b, L++, C(N, D++));
      return T;
    }
  }), SC;
}
pO();
var gC = {}, ff, RC;
function nR() {
  if (RC) return ff;
  RC = 1;
  var e = Et(), r = Xp(), t = na(), a = e.ArrayBuffer, o = e.TypeError;
  return ff = a && r(a.prototype, "byteLength", "get") || function(l) {
    if (t(l) !== "ArrayBuffer") throw new o("ArrayBuffer expected");
    return l.byteLength;
  }, ff;
}
var df, DC;
function iR() {
  if (DC) return df;
  DC = 1;
  var e = Et(), r = eh(), t = nR(), a = e.DataView;
  return df = function(o) {
    if (!r || t(o) !== 0) return !1;
    try {
      return new a(o), !1;
    } catch (l) {
      return !0;
    }
  }, df;
}
var AC;
function hO() {
  if (AC) return gC;
  AC = 1;
  var e = jt(), r = bi(), t = iR(), a = ArrayBuffer.prototype;
  return e && !("detached" in a) && r(a, "detached", {
    configurable: !0,
    get: function() {
      return t(this);
    }
  }), gC;
}
hO();
var TC = {}, pf, OC;
function _O() {
  if (OC) return pf;
  OC = 1;
  var e = iR(), r = TypeError;
  return pf = function(t) {
    if (e(t)) throw new r("ArrayBuffer is detached");
    return t;
  }, pf;
}
var hf, yC;
function aR() {
  if (yC) return hf;
  yC = 1;
  var e = Et(), r = js(), t = na(), a = function(o) {
    return r.slice(0, o.length) === o;
  };
  return hf = function() {
    return a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : e.Bun && typeof Bun.version == "string" ? "BUN" : e.Deno && typeof Deno.version == "object" ? "DENO" : t(e.process) === "process" ? "NODE" : e.window && e.document ? "BROWSER" : "REST";
  }(), hf;
}
var _f, NC;
function mO() {
  if (NC) return _f;
  NC = 1;
  var e = aR();
  return _f = e === "NODE", _f;
}
var mf, LC;
function EO() {
  if (LC) return mf;
  LC = 1;
  var e = Et(), r = mO();
  return mf = function(t) {
    if (r) {
      try {
        return e.process.getBuiltinModule(t);
      } catch (a) {
      }
      try {
        return Function('return require("' + t + '")')();
      } catch (a) {
      }
    }
  }, mf;
}
var Ef, MC;
function oR() {
  if (MC) return Ef;
  MC = 1;
  var e = Et(), r = vt(), t = K2(), a = aR(), o = e.structuredClone;
  return Ef = !!o && !r(function() {
    if (a === "DENO" && t > 92 || a === "NODE" && t > 94 || a === "BROWSER" && t > 97) return !1;
    var l = new ArrayBuffer(8), c = o(l, { transfer: [l] });
    return l.byteLength !== 0 || c.byteLength !== 8;
  }), Ef;
}
var Cf, PC;
function CO() {
  if (PC) return Cf;
  PC = 1;
  var e = Et(), r = EO(), t = oR(), a = e.structuredClone, o = e.ArrayBuffer, l = e.MessageChannel, c = !1, u, p, f, h;
  if (t)
    c = function(C) {
      a(C, { transfer: [C] });
    };
  else if (o) try {
    l || (u = r("worker_threads"), u && (l = u.MessageChannel)), l && (p = new l(), f = new o(2), h = function(C) {
      p.port1.postMessage(null, [C]);
    }, f.byteLength === 2 && (h(f), f.byteLength === 0 && (c = h)));
  } catch (C) {
  }
  return Cf = c, Cf;
}
var Sf, bC;
function sR() {
  if (bC) return Sf;
  bC = 1;
  var e = Et(), r = It(), t = Xp(), a = rh(), o = _O(), l = nR(), c = CO(), u = oR(), p = e.structuredClone, f = e.ArrayBuffer, h = e.DataView, C = Math.min, E = f.prototype, m = h.prototype, S = r(E.slice), v = t(E, "resizable", "get"), g = t(E, "maxByteLength", "get"), O = r(m.getInt8), D = r(m.setInt8);
  return Sf = (u || c) && function(R, T, N) {
    var b = l(R), L = T === void 0 ? b : a(T), k = !v || !v(R), w;
    if (o(R), u && (R = p(R, { transfer: [R] }), b === L && (N || k)))
      return R;
    if (b >= L && (!N || k))
      w = S(R, 0, L);
    else {
      var V = N && !k && g ? { maxByteLength: g(R) } : void 0;
      w = new f(L, V);
      for (var U = new h(R), z = new h(w), q = C(L, b), W = 0; W < q; W++) D(z, W, O(U, W));
    }
    return u || c(R), w;
  }, Sf;
}
var wC;
function SO() {
  if (wC) return TC;
  wC = 1;
  var e = zt(), r = sR();
  return r && e({ target: "ArrayBuffer", proto: !0 }, {
    transfer: function() {
      return r(this, arguments.length ? arguments[0] : void 0, !0);
    }
  }), TC;
}
SO();
var HC = {}, VC;
function IO() {
  if (VC) return HC;
  VC = 1;
  var e = zt(), r = sR();
  return r && e({ target: "ArrayBuffer", proto: !0 }, {
    transferToFixedLength: function() {
      return r(this, arguments.length ? arguments[0] : void 0, !1);
    }
  }), HC;
}
IO();
var kC = {}, _2 = { exports: {} }, If, FC;
function vO() {
  if (FC) return If;
  FC = 1;
  var e = cr(), r = e("iterator"), t = !1;
  try {
    var a = 0, o = {
      next: function() {
        return { done: !!a++ };
      },
      return: function() {
        t = !0;
      }
    };
    o[r] = function() {
      return this;
    }, Array.from(o, function() {
      throw 2;
    });
  } catch (l) {
  }
  return If = function(l, c) {
    try {
      if (!c && !t) return !1;
    } catch (f) {
      return !1;
    }
    var u = !1;
    try {
      var p = {};
      p[r] = function() {
        return {
          next: function() {
            return { done: u = !0 };
          }
        };
      }, l(p);
    } catch (f) {
    }
    return u;
  }, If;
}
var vf, UC;
function Nn() {
  if (UC) return vf;
  UC = 1;
  var e = eh(), r = jt(), t = Et(), a = Xt(), o = wr(), l = Hr(), c = aa(), u = Vo(), p = On(), f = pi(), h = bi(), C = ka(), E = Ws(), m = Uo(), S = cr(), v = Gp(), g = di(), O = g.enforce, D = g.get, R = t.Int8Array, T = R && R.prototype, N = t.Uint8ClampedArray, b = N && N.prototype, L = R && E(R), k = T && E(T), w = Object.prototype, V = t.TypeError, U = S("toStringTag"), z = v("TYPED_ARRAY_TAG"), q = "TypedArrayConstructor", W = e && !!m && c(t.opera) !== "Opera", te = !1, se, le, B, J = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  }, Q = {
    BigInt64Array: 8,
    BigUint64Array: 8
  }, P = function(Le) {
    if (!o(Le)) return !1;
    var Ze = c(Le);
    return Ze === "DataView" || l(J, Ze) || l(Q, Ze);
  }, $ = function(Ce) {
    var Le = E(Ce);
    if (o(Le)) {
      var Ze = D(Le);
      return Ze && l(Ze, q) ? Ze[q] : $(Le);
    }
  }, ce = function(Ce) {
    if (!o(Ce)) return !1;
    var Le = c(Ce);
    return l(J, Le) || l(Q, Le);
  }, ue = function(Ce) {
    if (ce(Ce)) return Ce;
    throw new V("Target is not a typed array");
  }, ie = function(Ce) {
    if (a(Ce) && (!m || C(L, Ce))) return Ce;
    throw new V(u(Ce) + " is not a typed array constructor");
  }, Re = function(Ce, Le, Ze, at) {
    if (r) {
      if (Ze) for (var ot in J) {
        var ct = t[ot];
        if (ct && l(ct.prototype, Ce)) try {
          delete ct.prototype[Ce];
        } catch (lt) {
          try {
            ct.prototype[Ce] = Le;
          } catch (Ct) {
          }
        }
      }
      (!k[Ce] || Ze) && f(k, Ce, Ze ? Le : W && T[Ce] || Le, at);
    }
  }, Ae = function(Ce, Le, Ze) {
    var at, ot;
    if (r) {
      if (m) {
        if (Ze) {
          for (at in J)
            if (ot = t[at], ot && l(ot, Ce)) try {
              delete ot[Ce];
            } catch (ct) {
            }
        }
        if (!L[Ce] || Ze)
          try {
            return f(L, Ce, Ze ? Le : W && L[Ce] || Le);
          } catch (ct) {
          }
        else return;
      }
      for (at in J)
        ot = t[at], ot && (!ot[Ce] || Ze) && f(ot, Ce, Le);
    }
  };
  for (se in J)
    le = t[se], B = le && le.prototype, B ? O(B)[q] = le : W = !1;
  for (se in Q)
    le = t[se], B = le && le.prototype, B && (O(B)[q] = le);
  if ((!W || !a(L) || L === Function.prototype) && (L = function() {
    throw new V("Incorrect invocation");
  }, W))
    for (se in J)
      t[se] && m(t[se], L);
  if ((!W || !k || k === w) && (k = L.prototype, W))
    for (se in J)
      t[se] && m(t[se].prototype, k);
  if (W && E(b) !== k && m(b, k), r && !l(k, U)) {
    te = !0, h(k, U, {
      configurable: !0,
      get: function() {
        return o(this) ? this[z] : void 0;
      }
    });
    for (se in J) t[se] && p(t[se], z, se);
  }
  return vf = {
    NATIVE_ARRAY_BUFFER_VIEWS: W,
    TYPED_ARRAY_TAG: te && z,
    aTypedArray: ue,
    aTypedArrayConstructor: ie,
    exportTypedArrayMethod: Re,
    exportTypedArrayStaticMethod: Ae,
    getTypedArrayConstructor: $,
    isView: P,
    isTypedArray: ce,
    TypedArray: L,
    TypedArrayPrototype: k
  }, vf;
}
var gf, xC;
function gO() {
  if (xC) return gf;
  xC = 1;
  var e = Et(), r = vt(), t = vO(), a = Nn().NATIVE_ARRAY_BUFFER_VIEWS, o = e.ArrayBuffer, l = e.Int8Array;
  return gf = !a || !r(function() {
    l(1);
  }) || !r(function() {
    new l(-1);
  }) || !t(function(c) {
    new l(), new l(null), new l(1.5), new l(c);
  }, !0) || r(function() {
    return new l(new o(2), 1, void 0).length !== 1;
  }), gf;
}
var Rf, BC;
function RO() {
  if (BC) return Rf;
  BC = 1;
  var e = wr(), r = Math.floor;
  return Rf = Number.isInteger || function(a) {
    return !e(a) && isFinite(a) && r(a) === a;
  }, Rf;
}
var Df, $C;
function DO() {
  if ($C) return Df;
  $C = 1;
  var e = fi(), r = RangeError;
  return Df = function(t) {
    var a = e(t);
    if (a < 0) throw new r("The argument can't be less than 0");
    return a;
  }, Df;
}
var Af, GC;
function lR() {
  if (GC) return Af;
  GC = 1;
  var e = DO(), r = RangeError;
  return Af = function(t, a) {
    var o = e(t);
    if (o % a) throw new r("Wrong offset");
    return o;
  }, Af;
}
var Tf, ZC;
function AO() {
  if (ZC) return Tf;
  ZC = 1;
  var e = Math.round;
  return Tf = function(r) {
    var t = e(r);
    return t < 0 ? 0 : t > 255 ? 255 : t & 255;
  }, Tf;
}
var Of, jC;
function xa() {
  if (jC) return Of;
  jC = 1;
  var e = ih(), r = Qr(), t = W2(), a = e(e.bind);
  return Of = function(o, l) {
    return r(o), l === void 0 ? o : t ? a(o, l) : function() {
      return o.apply(l, arguments);
    };
  }, Of;
}
var yf, zC;
function ah() {
  if (zC) return yf;
  zC = 1;
  var e = It(), r = vt(), t = Xt(), a = aa(), o = ia(), l = zg(), c = function() {
  }, u = o("Reflect", "construct"), p = /^\s*(?:class|function)\b/, f = e(p.exec), h = !p.test(c), C = function(S) {
    if (!t(S)) return !1;
    try {
      return u(c, [], S), !0;
    } catch (v) {
      return !1;
    }
  }, E = function(S) {
    if (!t(S)) return !1;
    switch (a(S)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return h || !!f(p, l(S));
    } catch (v) {
      return !0;
    }
  };
  return E.sham = !0, yf = !u || r(function() {
    var m;
    return C(C.call) || !C(Object) || !C(function() {
      m = !0;
    }) || m;
  }) ? E : C, yf;
}
var Nf, qC;
function TO() {
  if (qC) return Nf;
  qC = 1;
  var e = ah(), r = Vo(), t = TypeError;
  return Nf = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not a constructor");
  }, Nf;
}
var Lf, WC;
function Xs() {
  if (WC) return Lf;
  WC = 1;
  var e = aa(), r = zs(), t = Up(), a = qs(), o = cr(), l = o("iterator");
  return Lf = function(c) {
    if (!t(c)) return r(c, l) || r(c, "@@iterator") || a[e(c)];
  }, Lf;
}
var Mf, YC;
function ic() {
  if (YC) return Mf;
  YC = 1;
  var e = Mt(), r = Qr(), t = ar(), a = Vo(), o = Xs(), l = TypeError;
  return Mf = function(c, u) {
    var p = arguments.length < 2 ? o(c) : u;
    if (r(p)) return t(e(p, c));
    throw new l(a(c) + " is not iterable");
  }, Mf;
}
var Pf, KC;
function oh() {
  if (KC) return Pf;
  KC = 1;
  var e = cr(), r = qs(), t = e("iterator"), a = Array.prototype;
  return Pf = function(o) {
    return o !== void 0 && (r.Array === o || a[t] === o);
  }, Pf;
}
var bf, XC;
function cR() {
  if (XC) return bf;
  XC = 1;
  var e = aa();
  return bf = function(r) {
    var t = e(r);
    return t === "BigInt64Array" || t === "BigUint64Array";
  }, bf;
}
var wf, QC;
function sh() {
  if (QC) return wf;
  QC = 1;
  var e = $g(), r = TypeError;
  return wf = function(t) {
    var a = e(t, "number");
    if (typeof a == "number") throw new r("Can't convert number to bigint");
    return BigInt(a);
  }, wf;
}
var Hf, JC;
function OO() {
  if (JC) return Hf;
  JC = 1;
  var e = xa(), r = Mt(), t = TO(), a = Tn(), o = Jr(), l = ic(), c = Xs(), u = oh(), p = cR(), f = Nn().aTypedArrayConstructor, h = sh();
  return Hf = function(E) {
    var m = t(this), S = a(E), v = arguments.length, g = v > 1 ? arguments[1] : void 0, O = g !== void 0, D = c(S), R, T, N, b, L, k, w, V;
    if (D && !u(D))
      for (w = l(S, D), V = w.next, S = []; !(k = r(V, w)).done; )
        S.push(k.value);
    for (O && v > 2 && (g = e(g, arguments[2])), T = o(S), N = new (f(m))(T), b = p(N), R = 0; T > R; R++)
      L = O ? g(S[R], R) : S[R], N[R] = b ? h(L) : +L;
    return N;
  }, Hf;
}
var Vf, eS;
function yO() {
  if (eS) return Vf;
  eS = 1;
  var e = Jp(), r = ah(), t = wr(), a = cr(), o = a("species"), l = Array;
  return Vf = function(c) {
    var u;
    return e(c) && (u = c.constructor, r(u) && (u === l || e(u.prototype)) ? u = void 0 : t(u) && (u = u[o], u === null && (u = void 0))), u === void 0 ? l : u;
  }, Vf;
}
var kf, tS;
function NO() {
  if (tS) return kf;
  tS = 1;
  var e = yO();
  return kf = function(r, t) {
    return new (e(r))(t === 0 ? 0 : t);
  }, kf;
}
var Ff, rS;
function LO() {
  if (rS) return Ff;
  rS = 1;
  var e = xa(), r = It(), t = Y2(), a = Tn(), o = Jr(), l = NO(), c = r([].push), u = function(p) {
    var f = p === 1, h = p === 2, C = p === 3, E = p === 4, m = p === 6, S = p === 7, v = p === 5 || m;
    return function(g, O, D, R) {
      for (var T = a(g), N = t(T), b = o(N), L = e(O, D), k = 0, w = R || l, V = f ? w(g, b) : h || S ? w(g, 0) : void 0, U, z; b > k; k++) if ((v || k in N) && (U = N[k], z = L(U, k, T), p))
        if (f) V[k] = z;
        else if (z) switch (p) {
          case 3:
            return !0;
          // some
          case 5:
            return U;
          // find
          case 6:
            return k;
          // findIndex
          case 2:
            c(V, U);
        }
        else switch (p) {
          case 4:
            return !1;
          // every
          case 7:
            c(V, U);
        }
      return m ? -1 : C || E ? E : V;
    };
  };
  return Ff = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: u(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: u(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: u(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: u(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: u(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: u(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: u(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: u(7)
  }, Ff;
}
var Uf, nS;
function uR() {
  if (nS) return Uf;
  nS = 1;
  var e = Jr();
  return Uf = function(r, t, a) {
    for (var o = 0, l = arguments.length > 2 ? a : e(t), c = new r(l); l > o; ) c[o] = t[o++];
    return c;
  }, Uf;
}
var iS;
function MO() {
  if (iS) return _2.exports;
  iS = 1;
  var e = zt(), r = Et(), t = Mt(), a = jt(), o = gO(), l = Nn(), c = nh(), u = Ks(), p = Ua(), f = On(), h = RO(), C = ko(), E = rh(), m = lR(), S = AO(), v = jp(), g = Hr(), O = aa(), D = wr(), R = X2(), T = Fa(), N = ka(), b = Uo(), L = Wg().f, k = OO(), w = LO().forEach, V = rR(), U = bi(), z = Gn(), q = Yp(), W = uR(), te = di(), se = Qp(), le = te.get, B = te.set, J = te.enforce, Q = z.f, P = q.f, $ = r.RangeError, ce = c.ArrayBuffer, ue = ce.prototype, ie = c.DataView, Re = l.NATIVE_ARRAY_BUFFER_VIEWS, Ae = l.TYPED_ARRAY_TAG, Ce = l.TypedArray, Le = l.TypedArrayPrototype, Ze = l.isTypedArray, at = "BYTES_PER_ELEMENT", ot = "Wrong length", ct = function(st, ze) {
    U(st, ze, {
      configurable: !0,
      get: function() {
        return le(this)[ze];
      }
    });
  }, lt = function(st) {
    var ze;
    return N(ue, st) || (ze = O(st)) === "ArrayBuffer" || ze === "SharedArrayBuffer";
  }, Ct = function(st, ze) {
    return Ze(st) && !R(ze) && ze in st && h(+ze) && ze >= 0;
  }, yt = function(ze, ht) {
    return ht = v(ht), Ct(ze, ht) ? p(2, ze[ht]) : P(ze, ht);
  }, St = function(ze, ht, me) {
    return ht = v(ht), Ct(ze, ht) && D(me) && g(me, "value") && !g(me, "get") && !g(me, "set") && !me.configurable && (!g(me, "writable") || me.writable) && (!g(me, "enumerable") || me.enumerable) ? (ze[ht] = me.value, ze) : Q(ze, ht, me);
  };
  return a ? (Re || (q.f = yt, z.f = St, ct(Le, "buffer"), ct(Le, "byteOffset"), ct(Le, "byteLength"), ct(Le, "length")), e({ target: "Object", stat: !0, forced: !Re }, {
    getOwnPropertyDescriptor: yt,
    defineProperty: St
  }), _2.exports = function(st, ze, ht) {
    var me = st.match(/\d+/)[0] / 8, ye = st + (ht ? "Clamped" : "") + "Array", xe = "get" + st, Lt = "set" + st, _t = r[ye], De = _t, He = De && De.prototype, Be = {}, Je = function(ge, Xe) {
      var bt = le(ge);
      return bt.view[xe](Xe * me + bt.byteOffset, !0);
    }, ut = function(ge, Xe, bt) {
      var Pt = le(ge);
      Pt.view[Lt](Xe * me + Pt.byteOffset, ht ? S(bt) : bt, !0);
    }, Tt = function(ge, Xe) {
      Q(ge, Xe, {
        get: function() {
          return Je(this, Xe);
        },
        set: function(bt) {
          return ut(this, Xe, bt);
        },
        enumerable: !0
      });
    };
    Re ? o && (De = ze(function(ge, Xe, bt, Pt) {
      return u(ge, He), se(function() {
        return D(Xe) ? lt(Xe) ? Pt !== void 0 ? new _t(Xe, m(bt, me), Pt) : bt !== void 0 ? new _t(Xe, m(bt, me)) : new _t(Xe) : Ze(Xe) ? W(De, Xe) : t(k, De, Xe) : new _t(E(Xe));
      }(), ge, De);
    }), b && b(De, Ce), w(L(_t), function(ge) {
      ge in De || f(De, ge, _t[ge]);
    }), De.prototype = He) : (De = ze(function(ge, Xe, bt, Pt) {
      u(ge, He);
      var Ar = 0, Ie = 0, Me, Te, Pe;
      if (!D(Xe))
        Pe = E(Xe), Te = Pe * me, Me = new ce(Te);
      else if (lt(Xe)) {
        Me = Xe, Ie = m(bt, me);
        var je = Xe.byteLength;
        if (Pt === void 0) {
          if (je % me) throw new $(ot);
          if (Te = je - Ie, Te < 0) throw new $(ot);
        } else if (Te = C(Pt) * me, Te + Ie > je) throw new $(ot);
        Pe = Te / me;
      } else return Ze(Xe) ? W(De, Xe) : t(k, De, Xe);
      for (B(ge, {
        buffer: Me,
        byteOffset: Ie,
        byteLength: Te,
        length: Pe,
        view: new ie(Me)
      }); Ar < Pe; ) Tt(ge, Ar++);
    }), b && b(De, Ce), He = De.prototype = T(Le)), He.constructor !== De && f(He, "constructor", De), J(He).TypedArrayConstructor = De, Ae && f(He, Ae, ye);
    var Ye = De !== _t;
    Be[ye] = De, e({ global: !0, constructor: !0, forced: Ye, sham: !Re }, Be), at in De || f(De, at, me), at in He || f(He, at, me), V(ye);
  }) : _2.exports = function() {
  }, _2.exports;
}
var aS;
function PO() {
  if (aS) return kC;
  aS = 1;
  var e = MO();
  return e("Uint8", function(r) {
    return function(a, o, l) {
      return r(this, a, o, l);
    };
  }, !0), kC;
}
PO();
var oS = {}, sS;
function bO() {
  if (sS) return oS;
  sS = 1;
  var e = Nn(), r = Jr(), t = fi(), a = e.aTypedArray, o = e.exportTypedArrayMethod;
  return o("at", function(c) {
    var u = a(this), p = r(u), f = t(c), h = f >= 0 ? f : p + f;
    return h < 0 || h >= p ? void 0 : u[h];
  }), oS;
}
bO();
var lS = {}, cS;
function wO() {
  if (cS) return lS;
  cS = 1;
  var e = Nn(), r = tR(), t = sh(), a = aa(), o = Mt(), l = It(), c = vt(), u = e.aTypedArray, p = e.exportTypedArrayMethod, f = l("".slice), h = c(function() {
    var C = 0;
    return new Int8Array(2).fill({ valueOf: function() {
      return C++;
    } }), C !== 1;
  });
  return p("fill", function(E) {
    var m = arguments.length;
    u(this);
    var S = f(a(this), 0, 3) === "Big" ? t(E) : +E;
    return o(r, this, S, m > 1 ? arguments[1] : void 0, m > 2 ? arguments[2] : void 0);
  }, h), lS;
}
wO();
var uS = {}, xf, fS;
function fR() {
  if (fS) return xf;
  fS = 1;
  var e = xa(), r = Y2(), t = Tn(), a = Jr(), o = function(l) {
    var c = l === 1;
    return function(u, p, f) {
      for (var h = t(u), C = r(h), E = a(C), m = e(p, f), S, v; E-- > 0; )
        if (S = C[E], v = m(S, E, h), v) switch (l) {
          case 0:
            return S;
          // findLast
          case 1:
            return E;
        }
      return c ? -1 : void 0;
    };
  };
  return xf = {
    // `Array.prototype.findLast` method
    // https://github.com/tc39/proposal-array-find-from-last
    findLast: o(0),
    // `Array.prototype.findLastIndex` method
    // https://github.com/tc39/proposal-array-find-from-last
    findLastIndex: o(1)
  }, xf;
}
var dS;
function HO() {
  if (dS) return uS;
  dS = 1;
  var e = Nn(), r = fR().findLast, t = e.aTypedArray, a = e.exportTypedArrayMethod;
  return a("findLast", function(l) {
    return r(t(this), l, arguments.length > 1 ? arguments[1] : void 0);
  }), uS;
}
HO();
var pS = {}, hS;
function VO() {
  if (hS) return pS;
  hS = 1;
  var e = Nn(), r = fR().findLastIndex, t = e.aTypedArray, a = e.exportTypedArrayMethod;
  return a("findLastIndex", function(l) {
    return r(t(this), l, arguments.length > 1 ? arguments[1] : void 0);
  }), pS;
}
VO();
var _S = {}, mS;
function kO() {
  if (mS) return _S;
  mS = 1;
  var e = Et(), r = Mt(), t = Nn(), a = Jr(), o = lR(), l = Tn(), c = vt(), u = e.RangeError, p = e.Int8Array, f = p && p.prototype, h = f && f.set, C = t.aTypedArray, E = t.exportTypedArrayMethod, m = !c(function() {
    var v = new Uint8ClampedArray(2);
    return r(h, v, { length: 1, 0: 3 }, 1), v[1] !== 3;
  }), S = m && t.NATIVE_ARRAY_BUFFER_VIEWS && c(function() {
    var v = new p(2);
    return v.set(1), v.set("2", 1), v[0] !== 0 || v[1] !== 2;
  });
  return E("set", function(g) {
    C(this);
    var O = o(arguments.length > 1 ? arguments[1] : void 0, 1), D = l(g);
    if (m) return r(h, this, D, O);
    var R = this.length, T = a(D), N = 0;
    if (T + O > R) throw new u("Wrong length");
    for (; N < T; ) this[O + N] = D[N++];
  }, !m || S), _S;
}
kO();
var ES = {}, Bf, CS;
function lh() {
  if (CS) return Bf;
  CS = 1;
  var e = nc(), r = Math.floor, t = function(a, o) {
    var l = a.length;
    if (l < 8)
      for (var c = 1, u, p; c < l; ) {
        for (p = c, u = a[c]; p && o(a[p - 1], u) > 0; )
          a[p] = a[--p];
        p !== c++ && (a[p] = u);
      }
    else
      for (var f = r(l / 2), h = t(e(a, 0, f), o), C = t(e(a, f), o), E = h.length, m = C.length, S = 0, v = 0; S < E || v < m; )
        a[S + v] = S < E && v < m ? o(h[S], C[v]) <= 0 ? h[S++] : C[v++] : S < E ? h[S++] : C[v++];
    return a;
  };
  return Bf = t, Bf;
}
var $f, SS;
function dR() {
  if (SS) return $f;
  SS = 1;
  var e = js(), r = e.match(/firefox\/(\d+)/i);
  return $f = !!r && +r[1], $f;
}
var Gf, IS;
function pR() {
  if (IS) return Gf;
  IS = 1;
  var e = js();
  return Gf = /MSIE|Trident/.test(e), Gf;
}
var Zf, vS;
function hR() {
  if (vS) return Zf;
  vS = 1;
  var e = js(), r = e.match(/AppleWebKit\/(\d+)\./);
  return Zf = !!r && +r[1], Zf;
}
var gS;
function FO() {
  if (gS) return ES;
  gS = 1;
  var e = Et(), r = ih(), t = vt(), a = Qr(), o = lh(), l = Nn(), c = dR(), u = pR(), p = K2(), f = hR(), h = l.aTypedArray, C = l.exportTypedArrayMethod, E = e.Uint16Array, m = E && r(E.prototype.sort), S = !!m && !(t(function() {
    m(new E(2), null);
  }) && t(function() {
    m(new E(2), {});
  })), v = !!m && !t(function() {
    if (p) return p < 74;
    if (c) return c < 67;
    if (u) return !0;
    if (f) return f < 602;
    var O = new E(516), D = Array(516), R, T;
    for (R = 0; R < 516; R++)
      T = R % 4, O[R] = 515 - R, D[R] = R - 2 * T + 3;
    for (m(O, function(N, b) {
      return (N / 4 | 0) - (b / 4 | 0);
    }), R = 0; R < 516; R++)
      if (O[R] !== D[R]) return !0;
  }), g = function(O) {
    return function(D, R) {
      return O !== void 0 ? +O(D, R) || 0 : R !== R ? -1 : D !== D ? 1 : D === 0 && R === 0 ? 1 / D > 0 && 1 / R < 0 ? 1 : -1 : D > R;
    };
  };
  return C("sort", function(D) {
    return D !== void 0 && a(D), v ? m(this, D) : o(h(this), g(D));
  }, !v || S), ES;
}
FO();
var RS = {}, jf, DS;
function UO() {
  if (DS) return jf;
  DS = 1;
  var e = Jr();
  return jf = function(r, t) {
    for (var a = e(r), o = new t(a), l = 0; l < a; l++) o[l] = r[a - l - 1];
    return o;
  }, jf;
}
var AS;
function xO() {
  if (AS) return RS;
  AS = 1;
  var e = UO(), r = Nn(), t = r.aTypedArray, a = r.exportTypedArrayMethod, o = r.getTypedArrayConstructor;
  return a("toReversed", function() {
    return e(t(this), o(this));
  }), RS;
}
xO();
var TS = {}, OS;
function BO() {
  if (OS) return TS;
  OS = 1;
  var e = Nn(), r = It(), t = Qr(), a = uR(), o = e.aTypedArray, l = e.getTypedArrayConstructor, c = e.exportTypedArrayMethod, u = r(e.TypedArrayPrototype.sort);
  return c("toSorted", function(f) {
    f !== void 0 && t(f);
    var h = o(this), C = a(l(h), h);
    return u(C, f);
  }), TS;
}
BO();
var yS = {}, zf, NS;
function $O() {
  if (NS) return zf;
  NS = 1;
  var e = Jr(), r = fi(), t = RangeError;
  return zf = function(a, o, l, c) {
    var u = e(a), p = r(l), f = p < 0 ? u + p : p;
    if (f >= u || f < 0) throw new t("Incorrect index");
    for (var h = new o(u), C = 0; C < u; C++) h[C] = C === f ? c : a[C];
    return h;
  }, zf;
}
var LS;
function GO() {
  if (LS) return yS;
  LS = 1;
  var e = $O(), r = Nn(), t = cR(), a = fi(), o = sh(), l = r.aTypedArray, c = r.getTypedArrayConstructor, u = r.exportTypedArrayMethod, p = function() {
    try {
      new Int8Array(1).with(2, { valueOf: function() {
        throw 8;
      } });
    } catch (h) {
      return h === 8;
    }
  }(), f = p && function() {
    try {
      new Int8Array(1).with(-0.5, 1);
    } catch (h) {
      return !0;
    }
  }();
  return u("with", function(h, C) {
    var E = l(this), m = a(h), S = t(E) ? o(C) : +C;
    return e(E, c(E), m, S);
  }, !p || f), yS;
}
GO();
var rr = /* @__PURE__ */ ((e) => (e.WASM_ERROR = "WASM_ERROR", e.WASM_LICENSE = "WASM_LICENSE", e.FILE_SIZE = "FILE_SIZE", e.INCORRECT_FILE = "INCORRECT_FILE", e.INCORRECT_SCENARIO = "INCORRECT_SCENARIO", e.MISSING_SCENARIO = "MISSING_SCENARIO", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_SUPPORTED = "NOT_SUPPORTED", e.CAMERA_UNKNOWN_ERROR = "CAMERA_UNKNOWN_ERROR", e.CAMERA_PERMISSION_DENIED = "CAMERA_PERMISSION_DENIED", e.NO_CAMERA = "NO_CAMERA", e.INCORRECT_CAMERA_ID = "INCORRECT_CAMERA_ID", e.CONNECTION_ERROR = "CONNECTION_ERROR", e.HTTP_NOT_SUPPORTED = "HTTP_NOT_SUPPORTED", e.INSECURE_PAGE_CONTEXT = "INSECURE_PAGE_CONTEXT", e.BAD_CONFIGURATION = "BAD_CONFIGURATION", e))(rr || {}), pt = /* @__PURE__ */ ((e) => (e.ELEMENT_VISIBLE = "ELEMENT_VISIBLE", e.PRESS_CAMERA_BUTTON = "PRESS_CAMERA_BUTTON", e.PRESS_FILE_BUTTON = "PRESS_FILE_BUTTON", e.PRESS_RETRY_BUTTON = "PRESS_RETRY_BUTTON", e.PRESS_SKIP_BUTTON = "PRESS_SKIP_BUTTON", e.PRESS_CAPTURE_BUTTON = "PRESS_CAPTURE_BUTTON", e.PRESS_CHANGE_CAMERA_BUTTON = "PRESS_CHANGE_CAMERA_BUTTON", e.PRESS_REMOTE_DEVICE_BUTTON = "PRESS_REMOTE_DEVICE_BUTTON", e.PRESS_MIRRORING_BUTTON = "PRESS_MIRRORING_BUTTON", e.NEW_PAGE_AVAILABLE = "NEW_PAGE_AVAILABLE", e.NEW_PAGE_STARTED = "NEW_PAGE_STARTED", e.CLOSE = "CLOSE", e.CAMERA_PROCESS_CLOSED = "CAMERA_PROCESS_CLOSED", e.CAMERA_PROCESS_STARTED = "CAMERA_PROCESS_STARTED", e.VIDEO_STARTED = "VIDEO_STARTED", e.VIDEO_STOPPED = "VIDEO_STOPPED", e.FILE_PROCESS_STARTED = "FILE_PROCESS_STARTED", e.PROCESS_FINISHED = "PROCESS_FINISHED", e.SERVICE_INITIALIZED = "SERVICE_INITIALIZED", e.REMOTE_TRANSACTION_UPLOADED = "REMOTE_TRANSACTION_UPLOADED", e.REMOTE_PROCESS_FINISHED = "REMOTE_PROCESS_FINISHED", e))(pt || {}), it = /* @__PURE__ */ ((e) => (e.FINDING = "FINDING", e.PROCESSING = "PROCESSING", e.SUCCESS = "SUCCESS", e.FAILED = "FAILED", e.RESOLUTION = "RESOLUTION", e.GLARE = "GLARE", e.FOCUS = "FOCUS", e.SHAKING = "SHAKING", e.HOLD = "HOLD", e.SERVICE_PREPARING = "SERVICE_PREPARING", e.START_NEXT_PAGE = "START_NEXT_PAGE", e.SNAPSHOT = "SNAPSHOT", e.TIMEOUT = "TIMEOUT", e))(it || {}), ra = /* @__PURE__ */ ((e) => (e.auto = "auto", e.captureVideo = "captureVideo", e.captureFrame = "captureFrame", e))(ra || {}), Ne = /* @__PURE__ */ ((e) => (e.CHOOSE_INPUT_SOURCE = "CHOOSE_INPUT_SOURCE", e.CAMERA_PROCESSING = "CAMERA_PROCESSING", e.FILE_PROCESSING = "FILE_PROCESSING", e.API_PROCESSING = "API_PROCESSING", e.REMOTE_SCANNER = "REMOTE_SCANNER", e.PROCESSING = "PROCESSING", e.SUCCESS = "SUCCESS", e.DELEGATE_SUCCESS = "DELEGATE_SUCCESS", e.FAILED = "FAILED", e.FILE_SIZE_ERROR = "FILE_SIZE_ERROR", e.WASM_DEFAULT_ERROR = "WASM_DEFAULT_ERROR", e.NOT_SUPPORTED_ERROR = "NOT_SUPPORTED_ERROR", e.WASM_LICENSE_ERROR = "WASM_LICENSE_ERROR", e.INCORRECT_FILE_ERROR = "INCORRECT_FILE_ERROR", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.TIMEOUT = "TIMEOUT", e.CAMERA_PERMISSION_DENIED_ERROR = "CAMERA_PERMISSION_DENIED_ERROR", e.HTTP_NOT_SUPPORTED_ERROR = "HTTP_NOT_SUPPORTED_ERROR", e.INSECURE_PAGE_CONTEXT_ERROR = "INSECURE_PAGE_CONTEXT_ERROR", e.NO_CAMERA_ERROR = "NO_CAMERA_ERROR", e.INCORRECT_CAMERA_ID_ERROR = "INCORRECT_CAMERA_ID_ERROR", e.CONFIGURATION_ERROR = "CONFIGURATION_ERROR", e))(Ne || {}), Ni = /* @__PURE__ */ ((e) => (e.CHECKING = "CHECKING", e.AVAILABLE = "AVAILABLE", e.NOT_AVAILABLE = "NOT_AVAILABLE", e.ERROR = "ERROR", e))(Ni || {}), vn = /* @__PURE__ */ ((e) => (e.locale = "locale", e.multiple = "multiple", e.copyright = "copyright", e.startScreen = "start-screen", e.internalScenario = "internal-scenario", e.multipageProcessing = "multipage-processing", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.closeButton = "close-button", e.captureButton = "capture-button", e))(vn || {}), Ti = /* @__PURE__ */ ((e) => (e.locale = "locale", e.multiple = "multiple", e.copyright = "copyright", e.startScreen = "start-screen", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.closeButton = "close-button", e))(Ti || {}), ZO = /* @__PURE__ */ ((e) => (e.MrzAndLocate = "MrzAndLocate", e.MrzOrLocate = "MrzOrLocate", e.Mrz = "Mrz", e.Locate = "Locate", e.Barcode = "Barcode", e.MrzOrBarcode = "MrzOrBarcode", e.BarcodeAndLocate = "BarcodeAndLocate", e))(ZO || {}), gn = /* @__PURE__ */ ((e) => (e[e.prepare = 12e3] = "prepare", e[e.initialize = 12100] = "initialize", e[e.process = 12101] = "process", e[e.processImage = 12104] = "processImage", e[e.startNewPage = 12106] = "startNewPage", e[e.startNewDocument = 12105] = "startNewDocument", e[e.createBackendTransaction = 12125] = "createBackendTransaction", e[e.finalizePackage = 12122] = "finalizePackage", e[e.addDataToPackage = 12121] = "addDataToPackage", e))(gn || {}), Ns = /* @__PURE__ */ ((e) => (e.line = "line", e.corners = "corners", e))(Ns || {}), _R = /* @__PURE__ */ ((e) => (e.butt = "butt", e.round = "round", e.square = "square", e))(_R || {}), up = /* @__PURE__ */ ((e) => (e[e.ok = 0] = "ok", e[e.unsupportedCommand = 1] = "unsupportedCommand", e[e.badInputData = 2] = "badInputData", e[e.finished = 3] = "finished", e[e.currentlyUnavailable = 4] = "currentlyUnavailable", e[e.badLicense = 5] = "badLicense", e[e.alreadyDone = 6] = "alreadyDone", e))(up || {}), jO = /* @__PURE__ */ ((e) => (e.Glares = "glaresCheck", e.Focus = "focusCheck", e.Resolution = "dpiThreshold", e.Perspective = "perspectiveCheck", e.Bounds = "documentPosition", e.Portrait = "portraitCheck", e.Brightness = "brightnessCheck", e))(jO || {}), x2 = /* @__PURE__ */ ((e) => (e[e.STARTED = 0] = "STARTED", e[e.UPLOADED = 1] = "UPLOADED", e[e.PROCESSED = 2] = "PROCESSED", e))(x2 || {}), yo = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.Horizontal = 1] = "Horizontal", e[e.Vertical = 2] = "Vertical", e[e.LeftBottomRightTop = 4] = "LeftBottomRightTop", e[e.RightBottomLeftTop = 8] = "RightBottomLeftTop", e))(yo || {}), ks = /* @__PURE__ */ ((e) => (e.Flip = "flip", e.Tilt = "tilt", e))(ks || {}), lr = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.PassportSinglePage = 1] = "PassportSinglePage", e[e.PassportTwoPages = 2] = "PassportTwoPages", e[e.IDFront = 3] = "IDFront", e[e.IDFrontMRZ = 4] = "IDFrontMRZ", e[e.IDBack = 5] = "IDBack", e[e.IDBackMrz = 6] = "IDBackMrz", e[e.IDBackBarcode = 7] = "IDBackBarcode", e[e.IDBackBarcodeMRZ = 8] = "IDBackBarcodeMRZ", e[e.BankCardFront = 9] = "BankCardFront", e[e.BankCardBack = 10] = "BankCardBack", e[e.DocumentFront = 11] = "DocumentFront", e[e.DocumentBack = 12] = "DocumentBack", e))(lr || {}), P2 = /* @__PURE__ */ ((e) => (e.BarcodeMRZ = "BarcodeMRZ", e.BoundsLite = "BoundsLite", e))(P2 || {});
const zO = "document-reader", qO = "camera-snapshot", WO = 2.5, YO = 1, mR = 25e6, KO = 536870912, XO = 5, QO = 15, JO = 5, ey = "rgba(255, 255, 255, 0.9)", ty = "rgba(30, 130, 76, 0.9)", ry = "Capture", ER = 1500, CR = 1500, ny = 1500, iy = "ProcMgr.worker.js", SR = {
  FILE_SIZE: "FILE_SIZE_ERROR",
  WASM_ERROR: "WASM_DEFAULT_ERROR",
  NOT_SUPPORTED: "NOT_SUPPORTED_ERROR",
  WASM_LICENSE: "WASM_LICENSE_ERROR",
  INCORRECT_FILE: "INCORRECT_FILE_ERROR",
  CAMERA_PERMISSION_DENIED: "CAMERA_PERMISSION_DENIED_ERROR",
  HTTP_NOT_SUPPORTED: "HTTP_NOT_SUPPORTED_ERROR",
  INSECURE_PAGE_CONTEXT: "INSECURE_PAGE_CONTEXT_ERROR",
  NO_CAMERA: "NO_CAMERA_ERROR",
  INCORRECT_CAMERA_ID: "INCORRECT_CAMERA_ID_ERROR"
  /* INCORRECT_CAMERA_ID_ERROR */
}, ch = {
  SUCCESS: "SUCCESS",
  TIMEOUT: "TIMEOUT",
  FAILED: "FAILED"
  /* FAILED */
}, ay = {
  1: "Command not supported.",
  2: "Bad input data.",
  3: "Command already done.",
  4: "Command can not be processed at this moment, bad initial state.",
  5: "Bad license.",
  6: "The command has already been executed."
}, IR = {
  iOS: {
    Chrome: 99,
    Firefox: 99,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  Android: {
    Chrome: 66,
    Firefox: 61,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  desktop: {
    Chrome: 61,
    Firefox: 60,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  }
}, oy = {
  processParam: {
    returnUncroppedImage: !0,
    multipageProcessing: !1,
    timeoutFromFirstDetect: 0,
    timeoutFromFirstDocType: 0,
    imageQa: {
      expectedPass: [
        "dpiThreshold",
        "glaresCheck",
        "focusCheck"
        /* Focus */
      ],
      dpiThreshold: 130,
      glaresCheck: !0,
      glaresCheckParams: {
        imgMarginPart: 0.05,
        maxGlaringPart: 0.01
      }
    }
  }
}, sy = {
  processParam: {
    returnUncroppedImage: !0
  }
}, ly = {
  processParam: {
    returnUncroppedImage: !0,
    timeoutFromFirstDetect: 0,
    timeoutFromFirstDocType: 0
  }
}, cy = {
  processParam: {
    returnUncroppedImage: !0
  }
}, uy = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/bmp"];
var ba = /* @__PURE__ */ ((e) => (e.UINT = "UINT", e.BASE64 = "BASE64", e.UINT_AND_BASE64 = "UINT_AND_BASE64", e))(ba || {}), Li = /* @__PURE__ */ ((e) => (e[e.EMPTY = -1] = "EMPTY", e[e.ERROR = 0] = "ERROR", e[e.OK = 1] = "OK", e[e.TIMEOUT = 2] = "TIMEOUT", e))(Li || {}), Ft = /* @__PURE__ */ ((e) => (e.PREPARING = "StreamStatus.PREPARING", e.REQUESTING = "StreamStatus.REQUESTING", e.READY = "StreamStatus.READY", e.PLAY = "StreamStatus.PLAY", e.UNKNOWN_ERROR = "StreamStatus.UNKNOWN_ERROR", e.NOT_SUPPORTED = "StreamStatus.NOT_SUPPORTED", e.HTTP_NOT_SUPPORTED = "StreamStatus.HTTP_NOT_SUPPORTED", e.INSECURE_PAGE_CONTEXT = "StreamStatus.INSECURE_PAGE_CONTEXT", e.PERMISSION_DENIED = "StreamStatus.PERMISSION_DENIED", e.NO_CAMERA = "StreamStatus.NO_CAMERA", e.INCORRECT_CAMERA_ID = "StreamStatus.INCORRECT_CAMERA_ID", e))(Ft || {}), fn = /* @__PURE__ */ ((e) => (e.user = "user", e.environment = "environment", e))(fn || {}), B2 = /* @__PURE__ */ ((e) => (e.contain = "contain", e.cover = "cover", e))(B2 || {}), vR = /* @__PURE__ */ ((e) => (e[e.HAVE_NOTHING = 0] = "HAVE_NOTHING", e[e.HAVE_METADATA = 1] = "HAVE_METADATA", e[e.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", e[e.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", e[e.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA", e))(vR || {}), un = /* @__PURE__ */ ((e) => (e.stdout = "stdout", e.stderr = "stderr", e.custom = "custom", e.gl = "gl", e.init = "worker-init", e))(un || {}), fp = /* @__PURE__ */ ((e) => (e.Rtl = "rtl", e.Ltr = "ltr", e))(fp || {}), dp = /* @__PURE__ */ ((e) => (e.mirror = "mirror", e.noMirror = "noMirror", e))(dp || {});
const gR = "NotAllowedError", fy = "en", dy = ["ar", "he"], py = 1, RR = 500, hy = 1500, MS = 1e4, ui = {
  VGA: {
    width: 640,
    height: 480
  },
  HD: {
    width: 1280,
    height: 720
  },
  FULL_HD: {
    width: 1920,
    height: 1080
  },
  SQUARE: {
    width: 720,
    height: 720
  }
}, _y = ["rear", "back", "rück", "arrière", "trasera", "trás", "traseira", "posteriore", "posterior", "后面", "後面", "背面", "后置", "後置", "背置", "задней", "الخلفية", "خلفية", "후", "arka", "achterzijde", "หลัง", "baksidan", "bagside", "sau", "bak", "tylny", "takakamera", "belakang", "אחורית", "πίσω", "spate", "hátsó", "zadní", "darrere", "zadná", "задня", "задна", "birou", "артқы", "stražnja", "belakang", "बैक"], DR = {
  "StreamStatus.UNKNOWN_ERROR": "CAMERA_UNKNOWN_ERROR",
  "StreamStatus.PERMISSION_DENIED": "CAMERA_PERMISSION_DENIED",
  "StreamStatus.NO_CAMERA": "NO_CAMERA",
  "StreamStatus.INCORRECT_CAMERA_ID": "INCORRECT_CAMERA_ID",
  "StreamStatus.NOT_SUPPORTED": "NOT_SUPPORTED",
  "StreamStatus.HTTP_NOT_SUPPORTED": "HTTP_NOT_SUPPORTED",
  "StreamStatus.INSECURE_PAGE_CONTEXT": "INSECURE_PAGE_CONTEXT"
  /* INSECURE_PAGE_CONTEXT */
}, AR = "rgl-uid";
var PS = {}, qf, bS;
function my() {
  if (bS) return qf;
  bS = 1;
  var e = jt(), r = Jp(), t = TypeError, a = Object.getOwnPropertyDescriptor, o = e && !function() {
    if (this !== void 0) return !0;
    try {
      Object.defineProperty([], "length", { writable: !1 }).length = 1;
    } catch (l) {
      return l instanceof TypeError;
    }
  }();
  return qf = o ? function(l, c) {
    if (r(l) && !a(l, "length").writable)
      throw new t("Cannot set read only .length");
    return l.length = c;
  } : function(l, c) {
    return l.length = c;
  }, qf;
}
var Wf, wS;
function Ey() {
  if (wS) return Wf;
  wS = 1;
  var e = TypeError, r = 9007199254740991;
  return Wf = function(t) {
    if (t > r) throw e("Maximum allowed index exceeded");
    return t;
  }, Wf;
}
var HS;
function Cy() {
  if (HS) return PS;
  HS = 1;
  var e = zt(), r = Tn(), t = Jr(), a = my(), o = Ey(), l = vt(), c = l(function() {
    return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
  }), u = function() {
    try {
      Object.defineProperty([], "length", { writable: !1 }).push();
    } catch (f) {
      return f instanceof TypeError;
    }
  }, p = c || !u();
  return e({ target: "Array", proto: !0, arity: 1, forced: p }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function(h) {
      var C = r(this), E = t(C), m = arguments.length;
      o(E + m);
      for (var S = 0; S < m; S++)
        C[E] = arguments[S], E++;
      return a(C, E), E;
    }
  }), PS;
}
Cy();
var VS = {}, Yf, kS;
function TR() {
  if (kS) return Yf;
  kS = 1;
  var e = jt(), r = Gn(), t = Ua();
  return Yf = function(a, o, l) {
    e ? r.f(a, o, t(0, l)) : a[o] = l;
  }, Yf;
}
var FS;
function Sy() {
  if (FS) return VS;
  FS = 1;
  var e = zt(), r = Et(), t = Ks(), a = ar(), o = Xt(), l = Ws(), c = bi(), u = TR(), p = vt(), f = Hr(), h = cr(), C = ec().IteratorPrototype, E = jt(), m = Pi(), S = "constructor", v = "Iterator", g = h("toStringTag"), O = TypeError, D = r[v], R = m || !o(D) || D.prototype !== C || !p(function() {
    D({});
  }), T = function() {
    if (t(this, C), l(this) === C) throw new O("Abstract class Iterator not directly constructable");
  }, N = function(b, L) {
    E ? c(C, b, {
      configurable: !0,
      get: function() {
        return L;
      },
      set: function(k) {
        if (a(this), this === C) throw new O("You can't redefine this property");
        f(this, b) ? this[b] = k : u(this, b, k);
      }
    }) : C[b] = L;
  };
  return f(C, g) || N(g, v), (R || !f(C, S) || C[S] === Object) && N(S, T), T.prototype = C, e({ global: !0, constructor: !0, forced: R }, {
    Iterator: T
  }), VS;
}
Sy();
var US = {}, Kf, xS;
function Ba() {
  return xS || (xS = 1, Kf = function(e) {
    return {
      iterator: e,
      next: e.next,
      done: !1
    };
  }), Kf;
}
var Xf, BS;
function Zn() {
  if (BS) return Xf;
  BS = 1;
  var e = Mt(), r = ar(), t = zs();
  return Xf = function(a, o, l) {
    var c, u;
    r(a);
    try {
      if (c = t(a, "return"), !c) {
        if (o === "throw") throw l;
        return l;
      }
      c = e(c, a);
    } catch (p) {
      u = !0, c = p;
    }
    if (o === "throw") throw l;
    if (u) throw c;
    return r(c), l;
  }, Xf;
}
var Qf, $S;
function Iy() {
  if ($S) return Qf;
  $S = 1;
  var e = Zn();
  return Qf = function(r, t, a) {
    for (var o = r.length - 1; o >= 0; o--)
      if (r[o] !== void 0)
        try {
          a = e(r[o].iterator, t, a);
        } catch (l) {
          t = "throw", a = l;
        }
    if (t === "throw") throw a;
    return a;
  }, Qf;
}
var Jf, GS;
function OR() {
  if (GS) return Jf;
  GS = 1;
  var e = Mt(), r = Fa(), t = On(), a = th(), o = cr(), l = di(), c = zs(), u = ec().IteratorPrototype, p = tc(), f = Zn(), h = Iy(), C = o("toStringTag"), E = "IteratorHelper", m = "WrapForValidIterator", S = "normal", v = "throw", g = l.set, O = function(T) {
    var N = l.getterFor(T ? m : E);
    return a(r(u), {
      next: function() {
        var L = N(this);
        if (T) return L.nextHandler();
        if (L.done) return p(void 0, !0);
        try {
          var k = L.nextHandler();
          return L.returnHandlerResult ? k : p(k, L.done);
        } catch (w) {
          throw L.done = !0, w;
        }
      },
      return: function() {
        var b = N(this), L = b.iterator;
        if (b.done = !0, T) {
          var k = c(L, "return");
          return k ? e(k, L) : p(void 0, !0);
        }
        if (b.inner) try {
          f(b.inner.iterator, S);
        } catch (w) {
          return f(L, v, w);
        }
        if (b.openIters) try {
          h(b.openIters, S);
        } catch (w) {
          return f(L, v, w);
        }
        return L && f(L, S), p(void 0, !0);
      }
    });
  }, D = O(!0), R = O(!1);
  return t(R, C, "Iterator Helper"), Jf = function(T, N, b) {
    var L = function(w, V) {
      V ? (V.iterator = w.iterator, V.next = w.next) : V = w, V.type = N ? m : E, V.returnHandlerResult = !!b, V.nextHandler = T, V.counter = 0, V.done = !1, g(this, V);
    };
    return L.prototype = N ? D : R, L;
  }, Jf;
}
var e1, ZS;
function uh() {
  if (ZS) return e1;
  ZS = 1;
  var e = ar(), r = Zn();
  return e1 = function(t, a, o, l) {
    try {
      return l ? a(e(o)[0], o[1]) : a(o);
    } catch (c) {
      r(t, "throw", c);
    }
  }, e1;
}
var t1, jS;
function yR() {
  return jS || (jS = 1, t1 = function(e, r) {
    var t = typeof Iterator == "function" && Iterator.prototype[e];
    if (t) try {
      t.call({ next: null }, r).next();
    } catch (a) {
      return !0;
    }
  }), t1;
}
var r1, zS;
function $a() {
  if (zS) return r1;
  zS = 1;
  var e = Et();
  return r1 = function(r, t) {
    var a = e.Iterator, o = a && a.prototype, l = o && o[r], c = !1;
    if (l) try {
      l.call({
        next: function() {
          return { done: !0 };
        },
        return: function() {
          c = !0;
        }
      }, -1);
    } catch (u) {
      u instanceof t || (c = !1);
    }
    if (!c) return l;
  }, r1;
}
var qS;
function vy() {
  if (qS) return US;
  qS = 1;
  var e = zt(), r = Mt(), t = Qr(), a = ar(), o = Ba(), l = OR(), c = uh(), u = Pi(), p = Zn(), f = yR(), h = $a(), C = !u && !f("filter", function() {
  }), E = !u && !C && h("filter", TypeError), m = u || C || E, S = l(function() {
    for (var v = this.iterator, g = this.predicate, O = this.next, D, R, T; ; ) {
      if (D = a(r(O, v)), R = this.done = !!D.done, R) return;
      if (T = D.value, c(v, g, [T, this.counter++], !0)) return T;
    }
  });
  return e({ target: "Iterator", proto: !0, real: !0, forced: m }, {
    filter: function(g) {
      a(this);
      try {
        t(g);
      } catch (O) {
        p(this, "throw", O);
      }
      return E ? r(E, this, g) : new S(o(this), {
        predicate: g
      });
    }
  }), US;
}
vy();
var WS = {}, n1, YS;
function Qs() {
  if (YS) return n1;
  YS = 1;
  var e = xa(), r = Mt(), t = ar(), a = Vo(), o = oh(), l = Jr(), c = ka(), u = ic(), p = Xs(), f = Zn(), h = TypeError, C = function(m, S) {
    this.stopped = m, this.result = S;
  }, E = C.prototype;
  return n1 = function(m, S, v) {
    var g = v && v.that, O = !!(v && v.AS_ENTRIES), D = !!(v && v.IS_RECORD), R = !!(v && v.IS_ITERATOR), T = !!(v && v.INTERRUPTED), N = e(S, g), b, L, k, w, V, U, z, q = function(te) {
      return b && f(b, "normal"), new C(!0, te);
    }, W = function(te) {
      return O ? (t(te), T ? N(te[0], te[1], q) : N(te[0], te[1])) : T ? N(te, q) : N(te);
    };
    if (D)
      b = m.iterator;
    else if (R)
      b = m;
    else {
      if (L = p(m), !L) throw new h(a(m) + " is not iterable");
      if (o(L)) {
        for (k = 0, w = l(m); w > k; k++)
          if (V = W(m[k]), V && c(E, V)) return V;
        return new C(!1);
      }
      b = u(m, L);
    }
    for (U = D ? m.next : b.next; !(z = r(U, b)).done; ) {
      try {
        V = W(z.value);
      } catch (te) {
        f(b, "throw", te);
      }
      if (typeof V == "object" && V && c(E, V)) return V;
    }
    return new C(!1);
  }, n1;
}
var KS;
function gy() {
  if (KS) return WS;
  KS = 1;
  var e = zt(), r = Mt(), t = Qs(), a = Qr(), o = ar(), l = Ba(), c = Zn(), u = $a(), p = u("forEach", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    forEach: function(h) {
      o(this);
      try {
        a(h);
      } catch (m) {
        c(this, "throw", m);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      t(C, function(m) {
        h(m, E++);
      }, { IS_RECORD: !0 });
    }
  }), WS;
}
gy();
var XS = {}, i1, QS;
function Ry() {
  if (QS) return i1;
  QS = 1;
  var e = Vo(), r = TypeError;
  return i1 = function(t, a) {
    if (!delete t[a]) throw new r("Cannot delete property " + e(a) + " of " + e(t));
  }, i1;
}
var a1, JS;
function Dy() {
  if (JS) return a1;
  JS = 1;
  var e = vt();
  return a1 = function(r, t) {
    var a = [][r];
    return !!a && e(function() {
      a.call(null, t || function() {
        return 1;
      }, 1);
    });
  }, a1;
}
var eI;
function Ay() {
  if (eI) return XS;
  eI = 1;
  var e = zt(), r = It(), t = Qr(), a = Tn(), o = Jr(), l = Ry(), c = yn(), u = vt(), p = lh(), f = Dy(), h = dR(), C = pR(), E = K2(), m = hR(), S = [], v = r(S.sort), g = r(S.push), O = u(function() {
    S.sort(void 0);
  }), D = u(function() {
    S.sort(null);
  }), R = f("sort"), T = !u(function() {
    if (E) return E < 70;
    if (!(h && h > 3)) {
      if (C) return !0;
      if (m) return m < 603;
      var L = "", k, w, V, U;
      for (k = 65; k < 76; k++) {
        switch (w = String.fromCharCode(k), k) {
          case 66:
          case 69:
          case 70:
          case 72:
            V = 3;
            break;
          case 68:
          case 71:
            V = 4;
            break;
          default:
            V = 2;
        }
        for (U = 0; U < 47; U++)
          S.push({ k: w + U, v: V });
      }
      for (S.sort(function(z, q) {
        return q.v - z.v;
      }), U = 0; U < S.length; U++)
        w = S[U].k.charAt(0), L.charAt(L.length - 1) !== w && (L += w);
      return L !== "DGBEFHACIJK";
    }
  }), N = O || !D || !R || !T, b = function(L) {
    return function(k, w) {
      return w === void 0 ? -1 : k === void 0 ? 1 : L !== void 0 ? +L(k, w) || 0 : c(k) > c(w) ? 1 : -1;
    };
  };
  return e({ target: "Array", proto: !0, forced: N }, {
    sort: function(k) {
      k !== void 0 && t(k);
      var w = a(this);
      if (T) return k === void 0 ? v(w) : v(w, k);
      var V = [], U = o(w), z, q;
      for (q = 0; q < U; q++)
        q in w && g(V, w[q]);
      for (p(V, b(k)), z = o(V), q = 0; q < z; ) w[q] = V[q++];
      for (; q < U; ) l(w, q++);
      return w;
    }
  }), XS;
}
Ay();
var tI = {}, rI;
function Ty() {
  if (rI) return tI;
  rI = 1;
  var e = zt(), r = Mt(), t = Qs(), a = Qr(), o = ar(), l = Ba(), c = Zn(), u = $a(), p = u("every", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    every: function(h) {
      o(this);
      try {
        a(h);
      } catch (m) {
        c(this, "throw", m);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return !t(C, function(m, S) {
        if (!h(m, E++)) return S();
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).stopped;
    }
  }), tI;
}
Ty();
var nI = {}, iI;
function Oy() {
  if (iI) return nI;
  iI = 1;
  var e = zt(), r = Mt(), t = Qr(), a = ar(), o = Ba(), l = OR(), c = uh(), u = Zn(), p = yR(), f = $a(), h = Pi(), C = !h && !p("map", function() {
  }), E = !h && !C && f("map", TypeError), m = h || C || E, S = l(function() {
    var v = this.iterator, g = a(r(this.next, v)), O = this.done = !!g.done;
    if (!O) return c(v, this.mapper, [g.value, this.counter++], !0);
  });
  return e({ target: "Iterator", proto: !0, real: !0, forced: m }, {
    map: function(g) {
      a(this);
      try {
        t(g);
      } catch (O) {
        u(this, "throw", O);
      }
      return E ? r(E, this, g) : new S(o(this), {
        mapper: g
      });
    }
  }), nI;
}
Oy();
var aI = {}, oI;
function yy() {
  if (oI) return aI;
  oI = 1;
  var e = zt(), r = Mt(), t = Qs(), a = Qr(), o = ar(), l = Ba(), c = Zn(), u = $a(), p = u("some", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    some: function(h) {
      o(this);
      try {
        a(h);
      } catch (m) {
        c(this, "throw", m);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return t(C, function(m, S) {
        if (h(m, E++)) return S();
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).stopped;
    }
  }), aI;
}
yy();
var sI = {}, o1, lI;
function NR() {
  if (lI) return o1;
  lI = 1;
  var e = ar();
  return o1 = function() {
    var r = e(this), t = "";
    return r.hasIndices && (t += "d"), r.global && (t += "g"), r.ignoreCase && (t += "i"), r.multiline && (t += "m"), r.dotAll && (t += "s"), r.unicode && (t += "u"), r.unicodeSets && (t += "v"), r.sticky && (t += "y"), t;
  }, o1;
}
var s1, cI;
function Ny() {
  if (cI) return s1;
  cI = 1;
  var e = vt(), r = Et(), t = r.RegExp, a = e(function() {
    var c = t("a", "y");
    return c.lastIndex = 2, c.exec("abcd") !== null;
  }), o = a || e(function() {
    return !t("a", "y").sticky;
  }), l = a || e(function() {
    var c = t("^r", "gy");
    return c.lastIndex = 2, c.exec("str") !== null;
  });
  return s1 = {
    BROKEN_CARET: l,
    MISSED_STICKY: o,
    UNSUPPORTED_Y: a
  }, s1;
}
var l1, uI;
function Ly() {
  if (uI) return l1;
  uI = 1;
  var e = vt(), r = Et(), t = r.RegExp;
  return l1 = e(function() {
    var a = t(".", "s");
    return !(a.dotAll && a.test(`
`) && a.flags === "s");
  }), l1;
}
var c1, fI;
function My() {
  if (fI) return c1;
  fI = 1;
  var e = vt(), r = Et(), t = r.RegExp;
  return c1 = e(function() {
    var a = t("(?<a>b)", "g");
    return a.exec("b").groups.a !== "b" || "b".replace(a, "$<a>c") !== "bc";
  }), c1;
}
var u1, dI;
function fh() {
  if (dI) return u1;
  dI = 1;
  var e = Mt(), r = It(), t = yn(), a = NR(), o = Ny(), l = $p(), c = Fa(), u = di().get, p = Ly(), f = My(), h = l("native-string-replace", String.prototype.replace), C = RegExp.prototype.exec, E = C, m = r("".charAt), S = r("".indexOf), v = r("".replace), g = r("".slice), O = function() {
    var N = /a/, b = /b*/g;
    return e(C, N, "a"), e(C, b, "a"), N.lastIndex !== 0 || b.lastIndex !== 0;
  }(), D = o.BROKEN_CARET, R = /()??/.exec("")[1] !== void 0, T = O || R || D || p || f;
  return T && (E = function(b) {
    var L = this, k = u(L), w = t(b), V = k.raw, U, z, q, W, te, se, le;
    if (V)
      return V.lastIndex = L.lastIndex, U = e(E, V, w), L.lastIndex = V.lastIndex, U;
    var B = k.groups, J = D && L.sticky, Q = e(a, L), P = L.source, $ = 0, ce = w;
    if (J && (Q = v(Q, "y", ""), S(Q, "g") === -1 && (Q += "g"), ce = g(w, L.lastIndex), L.lastIndex > 0 && (!L.multiline || L.multiline && m(w, L.lastIndex - 1) !== `
`) && (P = "(?: " + P + ")", ce = " " + ce, $++), z = new RegExp("^(?:" + P + ")", Q)), R && (z = new RegExp("^" + P + "$(?!\\s)", Q)), O && (q = L.lastIndex), W = e(C, J ? z : L, ce), J ? W ? (W.input = g(W.input, $), W[0] = g(W[0], $), W.index = L.lastIndex, L.lastIndex += W[0].length) : L.lastIndex = 0 : O && W && (L.lastIndex = L.global ? W.index + W[0].length : q), R && W && W.length > 1 && e(h, W[0], z, function() {
      for (te = 1; te < arguments.length - 2; te++)
        arguments[te] === void 0 && (W[te] = void 0);
    }), W && B)
      for (W.groups = se = c(null), te = 0; te < B.length; te++)
        le = B[te], se[le[0]] = W[le[1]];
    return W;
  }), u1 = E, u1;
}
var pI;
function LR() {
  if (pI) return sI;
  pI = 1;
  var e = zt(), r = fh();
  return e({ target: "RegExp", proto: !0, forced: /./.exec !== r }, {
    exec: r
  }), sI;
}
LR();
var hI = {}, f1, _I;
function Py() {
  if (_I) return f1;
  _I = 1, LR();
  var e = Mt(), r = pi(), t = fh(), a = vt(), o = cr(), l = On(), c = o("species"), u = RegExp.prototype;
  return f1 = function(p, f, h, C) {
    var E = o(p), m = !a(function() {
      var O = {};
      return O[E] = function() {
        return 7;
      }, ""[p](O) !== 7;
    }), S = m && !a(function() {
      var O = !1, D = /a/;
      return p === "split" && (D = {}, D.constructor = {}, D.constructor[c] = function() {
        return D;
      }, D.flags = "", D[E] = /./[E]), D.exec = function() {
        return O = !0, null;
      }, D[E](""), !O;
    });
    if (!m || !S || h) {
      var v = /./[E], g = f(E, ""[p], function(O, D, R, T, N) {
        var b = D.exec;
        return b === t || b === u.exec ? m && !N ? { done: !0, value: e(v, D, R, T) } : { done: !0, value: e(O, R, D, T) } : { done: !1 };
      });
      r(String.prototype, p, g[0]), r(u, E, g[1]);
    }
    C && l(u[E], "sham", !0);
  }, f1;
}
var d1, mI;
function dh() {
  if (mI) return d1;
  mI = 1;
  var e = It(), r = fi(), t = yn(), a = Ho(), o = e("".charAt), l = e("".charCodeAt), c = e("".slice), u = function(p) {
    return function(f, h) {
      var C = t(a(f)), E = r(h), m = C.length, S, v;
      return E < 0 || E >= m ? p ? "" : void 0 : (S = l(C, E), S < 55296 || S > 56319 || E + 1 === m || (v = l(C, E + 1)) < 56320 || v > 57343 ? p ? o(C, E) : S : p ? c(C, E, E + 2) : (S - 55296 << 10) + (v - 56320) + 65536);
    };
  };
  return d1 = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: u(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: u(!0)
  }, d1;
}
var p1, EI;
function by() {
  if (EI) return p1;
  EI = 1;
  var e = dh().charAt;
  return p1 = function(r, t, a) {
    return t + (a ? e(r, t).length : 1);
  }, p1;
}
var h1, CI;
function wy() {
  if (CI) return h1;
  CI = 1;
  var e = It(), r = Tn(), t = Math.floor, a = e("".charAt), o = e("".replace), l = e("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, u = /\$([$&'`]|\d{1,2})/g;
  return h1 = function(p, f, h, C, E, m) {
    var S = h + p.length, v = C.length, g = u;
    return E !== void 0 && (E = r(E), g = c), o(m, g, function(O, D) {
      var R;
      switch (a(D, 0)) {
        case "$":
          return "$";
        case "&":
          return p;
        case "`":
          return l(f, 0, h);
        case "'":
          return l(f, S);
        case "<":
          R = E[l(D, 1, -1)];
          break;
        default:
          var T = +D;
          if (T === 0) return O;
          if (T > v) {
            var N = t(T / 10);
            return N === 0 ? O : N <= v ? C[N - 1] === void 0 ? a(D, 1) : C[N - 1] + a(D, 1) : O;
          }
          R = C[T - 1];
      }
      return R === void 0 ? "" : R;
    });
  }, h1;
}
var _1, SI;
function Hy() {
  if (SI) return _1;
  SI = 1;
  var e = Et(), r = vt(), t = e.RegExp, a = !r(function() {
    var o = !0;
    try {
      t(".", "d");
    } catch (E) {
      o = !1;
    }
    var l = {}, c = "", u = o ? "dgimsy" : "gimsy", p = function(E, m) {
      Object.defineProperty(l, E, { get: function() {
        return c += m, !0;
      } });
    }, f = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
    o && (f.hasIndices = "d");
    for (var h in f) p(h, f[h]);
    var C = Object.getOwnPropertyDescriptor(t.prototype, "flags").get.call(l);
    return C !== u || c !== u;
  });
  return _1 = { correct: a }, _1;
}
var m1, II;
function Vy() {
  if (II) return m1;
  II = 1;
  var e = Mt(), r = Hr(), t = ka(), a = Hy(), o = NR(), l = RegExp.prototype;
  return m1 = a.correct ? function(c) {
    return c.flags;
  } : function(c) {
    return !a.correct && t(l, c) && !r(c, "flags") ? e(o, c) : c.flags;
  }, m1;
}
var E1, vI;
function ky() {
  if (vI) return E1;
  vI = 1;
  var e = Mt(), r = ar(), t = Xt(), a = na(), o = fh(), l = TypeError;
  return E1 = function(c, u) {
    var p = c.exec;
    if (t(p)) {
      var f = e(p, c, u);
      return f !== null && r(f), f;
    }
    if (a(c) === "RegExp") return e(o, c, u);
    throw new l("RegExp#exec called on incompatible receiver");
  }, E1;
}
var gI;
function Fy() {
  if (gI) return hI;
  gI = 1;
  var e = rc(), r = Mt(), t = It(), a = Py(), o = vt(), l = ar(), c = Xt(), u = wr(), p = fi(), f = ko(), h = yn(), C = Ho(), E = by(), m = zs(), S = wy(), v = Vy(), g = ky(), O = cr(), D = O("replace"), R = Math.max, T = Math.min, N = t([].concat), b = t([].push), L = t("".indexOf), k = t("".slice), w = function(q) {
    return q === void 0 ? q : String(q);
  }, V = function() {
    return "a".replace(/./, "$0") === "$0";
  }(), U = function() {
    return /./[D] ? /./[D]("a", "$0") === "" : !1;
  }(), z = !o(function() {
    var q = /./;
    return q.exec = function() {
      var W = [];
      return W.groups = { a: "7" }, W;
    }, "".replace(q, "$<a>") !== "7";
  });
  return a("replace", function(q, W, te) {
    var se = U ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(B, J) {
        var Q = C(this), P = u(B) ? m(B, D) : void 0;
        return P ? r(P, B, Q, J) : r(W, h(Q), B, J);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(le, B) {
        var J = l(this), Q = h(le);
        if (typeof B == "string" && L(B, se) === -1 && L(B, "$<") === -1) {
          var P = te(W, J, Q, B);
          if (P.done) return P.value;
        }
        var $ = c(B);
        $ || (B = h(B));
        var ce = h(v(J)), ue = L(ce, "g") !== -1, ie;
        ue && (ie = L(ce, "u") !== -1, J.lastIndex = 0);
        for (var Re = [], Ae; Ae = g(J, Q), !(Ae === null || (b(Re, Ae), !ue)); ) {
          var Ce = h(Ae[0]);
          Ce === "" && (J.lastIndex = E(Q, f(J.lastIndex), ie));
        }
        for (var Le = "", Ze = 0, at = 0; at < Re.length; at++) {
          Ae = Re[at];
          for (var ot = h(Ae[0]), ct = R(T(p(Ae.index), Q.length), 0), lt = [], Ct, yt = 1; yt < Ae.length; yt++) b(lt, w(Ae[yt]));
          var St = Ae.groups;
          if ($) {
            var st = N([ot], lt, ct, Q);
            St !== void 0 && b(st, St), Ct = h(e(B, void 0, st));
          } else
            Ct = S(ot, Q, ct, lt, St, B);
          ct >= Ze && (Le += k(Q, Ze, ct) + Ct, Ze = ct + ot.length);
        }
        return Le + k(Q, Ze);
      }
    ];
  }, !z || !V || U), hI;
}
Fy();
var RI = {}, DI = {}, AI = {}, TI;
function Uy() {
  if (TI) return AI;
  TI = 1;
  var e = dh().charAt, r = yn(), t = di(), a = Xg(), o = tc(), l = "String Iterator", c = t.set, u = t.getterFor(l);
  return a(String, "String", function(p) {
    c(this, {
      type: l,
      string: r(p),
      index: 0
    });
  }, function() {
    var f = u(this), h = f.string, C = f.index, E;
    return C >= h.length ? o(void 0, !0) : (E = e(h, C), f.index += E.length, o(E, !1));
  }), AI;
}
var C1, OI;
function MR() {
  if (OI) return C1;
  OI = 1;
  var e = vt(), r = cr(), t = jt(), a = Pi(), o = r("iterator");
  return C1 = !e(function() {
    var l = new URL("b?a=1&b=2&c=3", "https://a"), c = l.searchParams, u = new URLSearchParams("a=1&a=2&b=3"), p = "";
    return l.pathname = "c%20d", c.forEach(function(f, h) {
      c.delete("b"), p += h + f;
    }), u.delete("a", 2), u.delete("b", void 0), a && (!l.toJSON || !u.has("a", 1) || u.has("a", 2) || !u.has("a", void 0) || u.has("b")) || !c.size && (a || !t) || !c.sort || l.href !== "https://a/c%20d?a=1&c=3" || c.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !c[o] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || p !== "a1c3" || new URL("https://x", void 0).host !== "x";
  }), C1;
}
var S1, yI;
function xy() {
  if (yI) return S1;
  yI = 1;
  var e = jt(), r = It(), t = Mt(), a = vt(), o = Zg(), l = Yg(), c = jg(), u = Tn(), p = Y2(), f = Object.assign, h = Object.defineProperty, C = r([].concat);
  return S1 = !f || a(function() {
    if (e && f({ b: 1 }, f(h({}, "a", {
      enumerable: !0,
      get: function() {
        h(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), { b: 2 })).b !== 1) return !0;
    var E = {}, m = {}, S = Symbol("assign detection"), v = "abcdefghijklmnopqrst";
    return E[S] = 7, v.split("").forEach(function(g) {
      m[g] = g;
    }), f({}, E)[S] !== 7 || o(f({}, m)).join("") !== v;
  }) ? function(m, S) {
    for (var v = u(m), g = arguments.length, O = 1, D = l.f, R = c.f; g > O; )
      for (var T = p(arguments[O++]), N = D ? C(o(T), D(T)) : o(T), b = N.length, L = 0, k; b > L; )
        k = N[L++], (!e || t(R, T, k)) && (v[k] = T[k]);
    return v;
  } : f, S1;
}
var I1, NI;
function By() {
  if (NI) return I1;
  NI = 1;
  var e = xa(), r = Mt(), t = Tn(), a = uh(), o = oh(), l = ah(), c = Jr(), u = TR(), p = ic(), f = Xs(), h = Array;
  return I1 = function(E) {
    var m = t(E), S = l(this), v = arguments.length, g = v > 1 ? arguments[1] : void 0, O = g !== void 0;
    O && (g = e(g, v > 2 ? arguments[2] : void 0));
    var D = f(m), R = 0, T, N, b, L, k, w;
    if (D && !(this === h && o(D)))
      for (N = S ? new this() : [], L = p(m, D), k = L.next; !(b = r(k, L)).done; R++)
        w = O ? a(L, g, [b.value, R], !0) : b.value, u(N, R, w);
    else
      for (T = c(m), N = S ? new this(T) : h(T); T > R; R++)
        w = O ? g(m[R], R) : m[R], u(N, R, w);
    return N.length = R, N;
  }, I1;
}
var v1, LI;
function $y() {
  if (LI) return v1;
  LI = 1;
  var e = It(), r = 2147483647, t = 36, a = 1, o = 26, l = 38, c = 700, u = 72, p = 128, f = "-", h = /[^\0-\u007E]/, C = /[.\u3002\uFF0E\uFF61]/g, E = "Overflow: input needs wider integers to process", m = t - a, S = RangeError, v = e(C.exec), g = Math.floor, O = String.fromCharCode, D = e("".charCodeAt), R = e([].join), T = e([].push), N = e("".replace), b = e("".split), L = e("".toLowerCase), k = function(z) {
    for (var q = [], W = 0, te = z.length; W < te; ) {
      var se = D(z, W++);
      if (se >= 55296 && se <= 56319 && W < te) {
        var le = D(z, W++);
        (le & 64512) === 56320 ? T(q, ((se & 1023) << 10) + (le & 1023) + 65536) : (T(q, se), W--);
      } else
        T(q, se);
    }
    return q;
  }, w = function(z) {
    return z + 22 + 75 * (z < 26);
  }, V = function(z, q, W) {
    var te = 0;
    for (z = W ? g(z / c) : z >> 1, z += g(z / q); z > m * o >> 1; )
      z = g(z / m), te += t;
    return g(te + (m + 1) * z / (z + l));
  }, U = function(z) {
    var q = [];
    z = k(z);
    var W = z.length, te = p, se = 0, le = u, B, J;
    for (B = 0; B < z.length; B++)
      J = z[B], J < 128 && T(q, O(J));
    var Q = q.length, P = Q;
    for (Q && T(q, f); P < W; ) {
      var $ = r;
      for (B = 0; B < z.length; B++)
        J = z[B], J >= te && J < $ && ($ = J);
      var ce = P + 1;
      if ($ - te > g((r - se) / ce))
        throw new S(E);
      for (se += ($ - te) * ce, te = $, B = 0; B < z.length; B++) {
        if (J = z[B], J < te && ++se > r)
          throw new S(E);
        if (J === te) {
          for (var ue = se, ie = t; ; ) {
            var Re = ie <= le ? a : ie >= le + o ? o : ie - le;
            if (ue < Re) break;
            var Ae = ue - Re, Ce = t - Re;
            T(q, O(w(Re + Ae % Ce))), ue = g(Ae / Ce), ie += t;
          }
          T(q, O(w(ue))), le = V(se, ce, P === Q), se = 0, P++;
        }
      }
      se++, te++;
    }
    return R(q, "");
  };
  return v1 = function(z) {
    var q = [], W = b(N(L(z), C, "."), "."), te, se;
    for (te = 0; te < W.length; te++)
      se = W[te], T(q, v(h, se) ? "xn--" + U(se) : se);
    return R(q, ".");
  }, v1;
}
var g1, MI;
function ac() {
  if (MI) return g1;
  MI = 1;
  var e = TypeError;
  return g1 = function(r, t) {
    if (r < t) throw new e("Not enough arguments");
    return r;
  }, g1;
}
var PI = {}, bI;
function Gy() {
  if (bI) return PI;
  bI = 1;
  var e = zt(), r = It(), t = Q2(), a = RangeError, o = String.fromCharCode, l = String.fromCodePoint, c = r([].join), u = !!l && l.length !== 1;
  return e({ target: "String", stat: !0, arity: 1, forced: u }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function(f) {
      for (var h = [], C = arguments.length, E = 0, m; C > E; ) {
        if (m = +arguments[E++], t(m, 1114111) !== m) throw new a(m + " is not a valid code point");
        h[E] = m < 65536 ? o(m) : o(((m -= 65536) >> 10) + 55296, m % 1024 + 56320);
      }
      return c(h, "");
    }
  }), PI;
}
var R1, wI;
function Zy() {
  if (wI) return R1;
  wI = 1;
  var e = Et(), r = jt(), t = Object.getOwnPropertyDescriptor;
  return R1 = function(a) {
    if (!r) return e[a];
    var o = t(e, a);
    return o && o.value;
  }, R1;
}
var D1, HI;
function PR() {
  if (HI) return D1;
  HI = 1, Qg(), Gy();
  var e = zt(), r = Et(), t = Zy(), a = ia(), o = Mt(), l = It(), c = jt(), u = MR(), p = pi(), f = bi(), h = th(), C = Fo(), E = Kg(), m = di(), S = Ks(), v = Xt(), g = Hr(), O = xa(), D = aa(), R = ar(), T = wr(), N = yn(), b = Fa(), L = Ua(), k = ic(), w = Xs(), V = tc(), U = ac(), z = cr(), q = lh(), W = z("iterator"), te = "URLSearchParams", se = te + "Iterator", le = m.set, B = m.getterFor(te), J = m.getterFor(se), Q = t("fetch"), P = t("Request"), $ = t("Headers"), ce = P && P.prototype, ue = $ && $.prototype, ie = r.TypeError, Re = r.encodeURIComponent, Ae = String.fromCharCode, Ce = a("String", "fromCodePoint"), Le = parseInt, Ze = l("".charAt), at = l([].join), ot = l([].push), ct = l("".replace), lt = l([].shift), Ct = l([].splice), yt = l("".split), St = l("".slice), st = l(/./.exec), ze = /\+/g, ht = "�", me = /^[0-9a-f]+$/i, ye = function(Ie, Me) {
    var Te = St(Ie, Me, Me + 2);
    return st(me, Te) ? Le(Te, 16) : NaN;
  }, xe = function(Ie) {
    for (var Me = 0, Te = 128; Te > 0 && (Ie & Te) !== 0; Te >>= 1)
      Me++;
    return Me;
  }, Lt = function(Ie) {
    var Me = null;
    switch (Ie.length) {
      case 1:
        Me = Ie[0];
        break;
      case 2:
        Me = (Ie[0] & 31) << 6 | Ie[1] & 63;
        break;
      case 3:
        Me = (Ie[0] & 15) << 12 | (Ie[1] & 63) << 6 | Ie[2] & 63;
        break;
      case 4:
        Me = (Ie[0] & 7) << 18 | (Ie[1] & 63) << 12 | (Ie[2] & 63) << 6 | Ie[3] & 63;
        break;
    }
    return Me > 1114111 ? null : Me;
  }, _t = function(Ie) {
    Ie = ct(Ie, ze, " ");
    for (var Me = Ie.length, Te = "", Pe = 0; Pe < Me; ) {
      var je = Ze(Ie, Pe);
      if (je === "%") {
        if (Ze(Ie, Pe + 1) === "%" || Pe + 3 > Me) {
          Te += "%", Pe++;
          continue;
        }
        var rt = ye(Ie, Pe + 1);
        if (rt !== rt) {
          Te += je, Pe++;
          continue;
        }
        Pe += 2;
        var Rt = xe(rt);
        if (Rt === 0)
          je = Ae(rt);
        else {
          if (Rt === 1 || Rt > 4) {
            Te += ht, Pe++;
            continue;
          }
          for (var Nt = [rt], wt = 1; wt < Rt && (Pe++, !(Pe + 3 > Me || Ze(Ie, Pe) !== "%")); ) {
            var Qt = ye(Ie, Pe + 1);
            if (Qt !== Qt) {
              Pe += 3;
              break;
            }
            if (Qt > 191 || Qt < 128) break;
            ot(Nt, Qt), Pe += 2, wt++;
          }
          if (Nt.length !== Rt) {
            Te += ht;
            continue;
          }
          var Ir = Lt(Nt);
          Ir === null ? Te += ht : je = Ce(Ir);
        }
      }
      Te += je, Pe++;
    }
    return Te;
  }, De = /[!'()~]|%20/g, He = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  }, Be = function(Ie) {
    return He[Ie];
  }, Je = function(Ie) {
    return ct(Re(Ie), De, Be);
  }, ut = E(function(Me, Te) {
    le(this, {
      type: se,
      target: B(Me).entries,
      index: 0,
      kind: Te
    });
  }, te, function() {
    var Me = J(this), Te = Me.target, Pe = Me.index++;
    if (!Te || Pe >= Te.length)
      return Me.target = null, V(void 0, !0);
    var je = Te[Pe];
    switch (Me.kind) {
      case "keys":
        return V(je.key, !1);
      case "values":
        return V(je.value, !1);
    }
    return V([je.key, je.value], !1);
  }, !0), Tt = function(Ie) {
    this.entries = [], this.url = null, Ie !== void 0 && (T(Ie) ? this.parseObject(Ie) : this.parseQuery(typeof Ie == "string" ? Ze(Ie, 0) === "?" ? St(Ie, 1) : Ie : N(Ie)));
  };
  Tt.prototype = {
    type: te,
    bindURL: function(Ie) {
      this.url = Ie, this.update();
    },
    parseObject: function(Ie) {
      var Me = this.entries, Te = w(Ie), Pe, je, rt, Rt, Nt, wt, Qt;
      if (Te)
        for (Pe = k(Ie, Te), je = Pe.next; !(rt = o(je, Pe)).done; ) {
          if (Rt = k(R(rt.value)), Nt = Rt.next, (wt = o(Nt, Rt)).done || (Qt = o(Nt, Rt)).done || !o(Nt, Rt).done) throw new ie("Expected sequence with length 2");
          ot(Me, { key: N(wt.value), value: N(Qt.value) });
        }
      else for (var Ir in Ie) g(Ie, Ir) && ot(Me, { key: Ir, value: N(Ie[Ir]) });
    },
    parseQuery: function(Ie) {
      if (Ie)
        for (var Me = this.entries, Te = yt(Ie, "&"), Pe = 0, je, rt; Pe < Te.length; )
          je = Te[Pe++], je.length && (rt = yt(je, "="), ot(Me, {
            key: _t(lt(rt)),
            value: _t(at(rt, "="))
          }));
    },
    serialize: function() {
      for (var Ie = this.entries, Me = [], Te = 0, Pe; Te < Ie.length; )
        Pe = Ie[Te++], ot(Me, Je(Pe.key) + "=" + Je(Pe.value));
      return at(Me, "&");
    },
    update: function() {
      this.entries.length = 0, this.parseQuery(this.url.query);
    },
    updateURL: function() {
      this.url && this.url.update();
    }
  };
  var Ye = function() {
    S(this, ge);
    var Me = arguments.length > 0 ? arguments[0] : void 0, Te = le(this, new Tt(Me));
    c || (this.size = Te.entries.length);
  }, ge = Ye.prototype;
  if (h(ge, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function(Me, Te) {
      var Pe = B(this);
      U(arguments.length, 2), ot(Pe.entries, { key: N(Me), value: N(Te) }), c || this.length++, Pe.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    delete: function(Ie) {
      for (var Me = B(this), Te = U(arguments.length, 1), Pe = Me.entries, je = N(Ie), rt = Te < 2 ? void 0 : arguments[1], Rt = rt === void 0 ? rt : N(rt), Nt = 0; Nt < Pe.length; ) {
        var wt = Pe[Nt];
        if (wt.key === je && (Rt === void 0 || wt.value === Rt)) {
          if (Ct(Pe, Nt, 1), Rt !== void 0) break;
        } else Nt++;
      }
      c || (this.size = Pe.length), Me.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function(Me) {
      var Te = B(this).entries;
      U(arguments.length, 1);
      for (var Pe = N(Me), je = 0; je < Te.length; je++)
        if (Te[je].key === Pe) return Te[je].value;
      return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function(Me) {
      var Te = B(this).entries;
      U(arguments.length, 1);
      for (var Pe = N(Me), je = [], rt = 0; rt < Te.length; rt++)
        Te[rt].key === Pe && ot(je, Te[rt].value);
      return je;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function(Me) {
      for (var Te = B(this).entries, Pe = U(arguments.length, 1), je = N(Me), rt = Pe < 2 ? void 0 : arguments[1], Rt = rt === void 0 ? rt : N(rt), Nt = 0; Nt < Te.length; ) {
        var wt = Te[Nt++];
        if (wt.key === je && (Rt === void 0 || wt.value === Rt)) return !0;
      }
      return !1;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function(Me, Te) {
      var Pe = B(this);
      U(arguments.length, 1);
      for (var je = Pe.entries, rt = !1, Rt = N(Me), Nt = N(Te), wt = 0, Qt; wt < je.length; wt++)
        Qt = je[wt], Qt.key === Rt && (rt ? Ct(je, wt--, 1) : (rt = !0, Qt.value = Nt));
      rt || ot(je, { key: Rt, value: Nt }), c || (this.size = je.length), Pe.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function() {
      var Me = B(this);
      q(Me.entries, function(Te, Pe) {
        return Te.key > Pe.key ? 1 : -1;
      }), Me.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function(Me) {
      for (var Te = B(this).entries, Pe = O(Me, arguments.length > 1 ? arguments[1] : void 0), je = 0, rt; je < Te.length; )
        rt = Te[je++], Pe(rt.value, rt.key, this);
    },
    // `URLSearchParams.prototype.keys` method
    keys: function() {
      return new ut(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function() {
      return new ut(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function() {
      return new ut(this, "entries");
    }
  }, { enumerable: !0 }), p(ge, W, ge.entries, { name: "entries" }), p(ge, "toString", function() {
    return B(this).serialize();
  }, { enumerable: !0 }), c && f(ge, "size", {
    get: function() {
      return B(this).entries.length;
    },
    configurable: !0,
    enumerable: !0
  }), C(Ye, te), e({ global: !0, constructor: !0, forced: !u }, {
    URLSearchParams: Ye
  }), !u && v($)) {
    var Xe = l(ue.has), bt = l(ue.set), Pt = function(Ie) {
      if (T(Ie)) {
        var Me = Ie.body, Te;
        if (D(Me) === te)
          return Te = Ie.headers ? new $(Ie.headers) : new $(), Xe(Te, "content-type") || bt(Te, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), b(Ie, {
            body: L(0, N(Me)),
            headers: L(0, Te)
          });
      }
      return Ie;
    };
    if (v(Q) && e({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
      fetch: function(Me) {
        return Q(Me, arguments.length > 1 ? Pt(arguments[1]) : {});
      }
    }), v(P)) {
      var Ar = function(Me) {
        return S(this, ce), new P(Me, arguments.length > 1 ? Pt(arguments[1]) : {});
      };
      ce.constructor = Ar, Ar.prototype = ce, e({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
        Request: Ar
      });
    }
  }
  return D1 = {
    URLSearchParams: Ye,
    getState: B
  }, D1;
}
var VI;
function jy() {
  if (VI) return DI;
  VI = 1, Uy();
  var e = zt(), r = jt(), t = MR(), a = Et(), o = xa(), l = It(), c = pi(), u = bi(), p = Ks(), f = Hr(), h = xy(), C = By(), E = nc(), m = dh().codeAt, S = $y(), v = yn(), g = Fo(), O = ac(), D = PR(), R = di(), T = R.set, N = R.getterFor("URL"), b = D.URLSearchParams, L = D.getState, k = a.URL, w = a.TypeError, V = a.parseInt, U = Math.floor, z = Math.pow, q = l("".charAt), W = l(/./.exec), te = l([].join), se = l(1.1.toString), le = l([].pop), B = l([].push), J = l("".replace), Q = l([].shift), P = l("".split), $ = l("".slice), ce = l("".toLowerCase), ue = l([].unshift), ie = "Invalid authority", Re = "Invalid scheme", Ae = "Invalid host", Ce = "Invalid port", Le = /[a-z]/i, Ze = /[\d+-.a-z]/i, at = /\d/, ot = /^0x/i, ct = /^[0-7]+$/, lt = /^\d+$/, Ct = /^[\da-f]+$/i, yt = /[\0\t\n\r #%/:<>?@[\\\]^|]/, St = /[\0\t\n\r #/:<>?@[\\\]^|]/, st = /^[\u0000-\u0020]+/, ze = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, ht = /[\t\n\r]/g, me, ye = function(X) {
    var Ee = P(X, "."), ne, G, fe, Ke, Ve, Ht, tt;
    if (Ee.length && Ee[Ee.length - 1] === "" && Ee.length--, ne = Ee.length, ne > 4) return X;
    for (G = [], fe = 0; fe < ne; fe++) {
      if (Ke = Ee[fe], Ke === "") return X;
      if (Ve = 10, Ke.length > 1 && q(Ke, 0) === "0" && (Ve = W(ot, Ke) ? 16 : 8, Ke = $(Ke, Ve === 8 ? 1 : 2)), Ke === "")
        Ht = 0;
      else {
        if (!W(Ve === 10 ? lt : Ve === 8 ? ct : Ct, Ke)) return X;
        Ht = V(Ke, Ve);
      }
      B(G, Ht);
    }
    for (fe = 0; fe < ne; fe++)
      if (Ht = G[fe], fe === ne - 1) {
        if (Ht >= z(256, 5 - ne)) return null;
      } else if (Ht > 255) return null;
    for (tt = le(G), fe = 0; fe < G.length; fe++)
      tt += G[fe] * z(256, 3 - fe);
    return tt;
  }, xe = function(X) {
    var Ee = [0, 0, 0, 0, 0, 0, 0, 0], ne = 0, G = null, fe = 0, Ke, Ve, Ht, tt, nr, _r, _e, Vt = function() {
      return q(X, fe);
    };
    if (Vt() === ":") {
      if (q(X, 1) !== ":") return;
      fe += 2, ne++, G = ne;
    }
    for (; Vt(); ) {
      if (ne === 8) return;
      if (Vt() === ":") {
        if (G !== null) return;
        fe++, ne++, G = ne;
        continue;
      }
      for (Ke = Ve = 0; Ve < 4 && W(Ct, Vt()); )
        Ke = Ke * 16 + V(Vt(), 16), fe++, Ve++;
      if (Vt() === ".") {
        if (Ve === 0 || (fe -= Ve, ne > 6)) return;
        for (Ht = 0; Vt(); ) {
          if (tt = null, Ht > 0)
            if (Vt() === "." && Ht < 4) fe++;
            else return;
          if (!W(at, Vt())) return;
          for (; W(at, Vt()); ) {
            if (nr = V(Vt(), 10), tt === null) tt = nr;
            else {
              if (tt === 0) return;
              tt = tt * 10 + nr;
            }
            if (tt > 255) return;
            fe++;
          }
          Ee[ne] = Ee[ne] * 256 + tt, Ht++, (Ht === 2 || Ht === 4) && ne++;
        }
        if (Ht !== 4) return;
        break;
      } else if (Vt() === ":") {
        if (fe++, !Vt()) return;
      } else if (Vt()) return;
      Ee[ne++] = Ke;
    }
    if (G !== null)
      for (_r = ne - G, ne = 7; ne !== 0 && _r > 0; )
        _e = Ee[ne], Ee[ne--] = Ee[G + _r - 1], Ee[G + --_r] = _e;
    else if (ne !== 8) return;
    return Ee;
  }, Lt = function(X) {
    for (var Ee = null, ne = 1, G = null, fe = 0, Ke = 0; Ke < 8; Ke++)
      X[Ke] !== 0 ? (fe > ne && (Ee = G, ne = fe), G = null, fe = 0) : (G === null && (G = Ke), ++fe);
    return fe > ne ? G : Ee;
  }, _t = function(X) {
    var Ee, ne, G, fe;
    if (typeof X == "number") {
      for (Ee = [], ne = 0; ne < 4; ne++)
        ue(Ee, X % 256), X = U(X / 256);
      return te(Ee, ".");
    }
    if (typeof X == "object") {
      for (Ee = "", G = Lt(X), ne = 0; ne < 8; ne++)
        fe && X[ne] === 0 || (fe && (fe = !1), G === ne ? (Ee += ne ? ":" : "::", fe = !0) : (Ee += se(X[ne], 16), ne < 7 && (Ee += ":")));
      return "[" + Ee + "]";
    }
    return X;
  }, De = {}, He = h({}, De, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
  }), Be = h({}, He, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
  }), Je = h({}, Be, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
  }), ut = function(X, Ee) {
    var ne = m(X, 0);
    return ne > 32 && ne < 127 && !f(Ee, X) ? X : encodeURIComponent(X);
  }, Tt = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
  }, Ye = function(X, Ee) {
    var ne;
    return X.length === 2 && W(Le, q(X, 0)) && ((ne = q(X, 1)) === ":" || !Ee && ne === "|");
  }, ge = function(X) {
    var Ee;
    return X.length > 1 && Ye($(X, 0, 2)) && (X.length === 2 || (Ee = q(X, 2)) === "/" || Ee === "\\" || Ee === "?" || Ee === "#");
  }, Xe = function(X) {
    return X === "." || ce(X) === "%2e";
  }, bt = function(X) {
    return X = ce(X), X === ".." || X === "%2e." || X === ".%2e" || X === "%2e%2e";
  }, Pt = {}, Ar = {}, Ie = {}, Me = {}, Te = {}, Pe = {}, je = {}, rt = {}, Rt = {}, Nt = {}, wt = {}, Qt = {}, Ir = {}, hi = {}, Vr = {}, zn = {}, qt = {}, kr = {}, Ln = {}, Fr = {}, vr = {}, qn = function(X, Ee, ne) {
    var G = v(X), fe, Ke, Ve;
    if (Ee) {
      if (Ke = this.parse(G), Ke) throw new w(Ke);
      this.searchParams = null;
    } else {
      if (ne !== void 0 && (fe = new qn(ne, !0)), Ke = this.parse(G, null, fe), Ke) throw new w(Ke);
      Ve = L(new b()), Ve.bindURL(this), this.searchParams = Ve;
    }
  };
  qn.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(X, Ee, ne) {
      var G = this, fe = Ee || Pt, Ke = 0, Ve = "", Ht = !1, tt = !1, nr = !1, _r, _e, Vt, en;
      for (X = v(X), Ee || (G.scheme = "", G.username = "", G.password = "", G.host = null, G.port = null, G.path = [], G.query = null, G.fragment = null, G.cannotBeABaseURL = !1, X = J(X, st, ""), X = J(X, ze, "$1")), X = J(X, ht, ""), _r = C(X); Ke <= _r.length; ) {
        switch (_e = _r[Ke], fe) {
          case Pt:
            if (_e && W(Le, _e))
              Ve += ce(_e), fe = Ar;
            else {
              if (Ee)
                return Re;
              fe = Ie;
              continue;
            }
            break;
          case Ar:
            if (_e && (W(Ze, _e) || _e === "+" || _e === "-" || _e === "."))
              Ve += ce(_e);
            else if (_e === ":") {
              if (Ee && (G.isSpecial() !== f(Tt, Ve) || Ve === "file" && (G.includesCredentials() || G.port !== null) || G.scheme === "file" && !G.host)) return;
              if (G.scheme = Ve, Ee) {
                G.isSpecial() && Tt[G.scheme] === G.port && (G.port = null);
                return;
              }
              Ve = "", G.scheme === "file" ? fe = hi : G.isSpecial() && ne && ne.scheme === G.scheme ? fe = Me : G.isSpecial() ? fe = rt : _r[Ke + 1] === "/" ? (fe = Te, Ke++) : (G.cannotBeABaseURL = !0, B(G.path, ""), fe = Ln);
            } else {
              if (Ee)
                return Re;
              Ve = "", fe = Ie, Ke = 0;
              continue;
            }
            break;
          case Ie:
            if (!ne || ne.cannotBeABaseURL && _e !== "#") return Re;
            if (ne.cannotBeABaseURL && _e === "#") {
              G.scheme = ne.scheme, G.path = E(ne.path), G.query = ne.query, G.fragment = "", G.cannotBeABaseURL = !0, fe = vr;
              break;
            }
            fe = ne.scheme === "file" ? hi : Pe;
            continue;
          case Me:
            if (_e === "/" && _r[Ke + 1] === "/")
              fe = Rt, Ke++;
            else {
              fe = Pe;
              continue;
            }
            break;
          case Te:
            if (_e === "/") {
              fe = Nt;
              break;
            } else {
              fe = kr;
              continue;
            }
          case Pe:
            if (G.scheme = ne.scheme, _e === me)
              G.username = ne.username, G.password = ne.password, G.host = ne.host, G.port = ne.port, G.path = E(ne.path), G.query = ne.query;
            else if (_e === "/" || _e === "\\" && G.isSpecial())
              fe = je;
            else if (_e === "?")
              G.username = ne.username, G.password = ne.password, G.host = ne.host, G.port = ne.port, G.path = E(ne.path), G.query = "", fe = Fr;
            else if (_e === "#")
              G.username = ne.username, G.password = ne.password, G.host = ne.host, G.port = ne.port, G.path = E(ne.path), G.query = ne.query, G.fragment = "", fe = vr;
            else {
              G.username = ne.username, G.password = ne.password, G.host = ne.host, G.port = ne.port, G.path = E(ne.path), G.path.length--, fe = kr;
              continue;
            }
            break;
          case je:
            if (G.isSpecial() && (_e === "/" || _e === "\\"))
              fe = Rt;
            else if (_e === "/")
              fe = Nt;
            else {
              G.username = ne.username, G.password = ne.password, G.host = ne.host, G.port = ne.port, fe = kr;
              continue;
            }
            break;
          case rt:
            if (fe = Rt, _e !== "/" || q(Ve, Ke + 1) !== "/") continue;
            Ke++;
            break;
          case Rt:
            if (_e !== "/" && _e !== "\\") {
              fe = Nt;
              continue;
            }
            break;
          case Nt:
            if (_e === "@") {
              Ht && (Ve = "%40" + Ve), Ht = !0, Vt = C(Ve);
              for (var Vi = 0; Vi < Vt.length; Vi++) {
                var _i = Vt[Vi];
                if (_i === ":" && !nr) {
                  nr = !0;
                  continue;
                }
                var Ur = ut(_i, Je);
                nr ? G.password += Ur : G.username += Ur;
              }
              Ve = "";
            } else if (_e === me || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && G.isSpecial()) {
              if (Ht && Ve === "") return ie;
              Ke -= C(Ve).length + 1, Ve = "", fe = wt;
            } else Ve += _e;
            break;
          case wt:
          case Qt:
            if (Ee && G.scheme === "file") {
              fe = zn;
              continue;
            } else if (_e === ":" && !tt) {
              if (Ve === "") return Ae;
              if (en = G.parseHost(Ve), en) return en;
              if (Ve = "", fe = Ir, Ee === Qt) return;
            } else if (_e === me || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && G.isSpecial()) {
              if (G.isSpecial() && Ve === "") return Ae;
              if (Ee && Ve === "" && (G.includesCredentials() || G.port !== null)) return;
              if (en = G.parseHost(Ve), en) return en;
              if (Ve = "", fe = qt, Ee) return;
              continue;
            } else
              _e === "[" ? tt = !0 : _e === "]" && (tt = !1), Ve += _e;
            break;
          case Ir:
            if (W(at, _e))
              Ve += _e;
            else if (_e === me || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && G.isSpecial() || Ee) {
              if (Ve !== "") {
                var ca = V(Ve, 10);
                if (ca > 65535) return Ce;
                G.port = G.isSpecial() && ca === Tt[G.scheme] ? null : ca, Ve = "";
              }
              if (Ee) return;
              fe = qt;
              continue;
            } else return Ce;
            break;
          case hi:
            if (G.scheme = "file", _e === "/" || _e === "\\") fe = Vr;
            else if (ne && ne.scheme === "file")
              switch (_e) {
                case me:
                  G.host = ne.host, G.path = E(ne.path), G.query = ne.query;
                  break;
                case "?":
                  G.host = ne.host, G.path = E(ne.path), G.query = "", fe = Fr;
                  break;
                case "#":
                  G.host = ne.host, G.path = E(ne.path), G.query = ne.query, G.fragment = "", fe = vr;
                  break;
                default:
                  ge(te(E(_r, Ke), "")) || (G.host = ne.host, G.path = E(ne.path), G.shortenPath()), fe = kr;
                  continue;
              }
            else {
              fe = kr;
              continue;
            }
            break;
          case Vr:
            if (_e === "/" || _e === "\\") {
              fe = zn;
              break;
            }
            ne && ne.scheme === "file" && !ge(te(E(_r, Ke), "")) && (Ye(ne.path[0], !0) ? B(G.path, ne.path[0]) : G.host = ne.host), fe = kr;
            continue;
          case zn:
            if (_e === me || _e === "/" || _e === "\\" || _e === "?" || _e === "#") {
              if (!Ee && Ye(Ve))
                fe = kr;
              else if (Ve === "") {
                if (G.host = "", Ee) return;
                fe = qt;
              } else {
                if (en = G.parseHost(Ve), en) return en;
                if (G.host === "localhost" && (G.host = ""), Ee) return;
                Ve = "", fe = qt;
              }
              continue;
            } else Ve += _e;
            break;
          case qt:
            if (G.isSpecial()) {
              if (fe = kr, _e !== "/" && _e !== "\\") continue;
            } else if (!Ee && _e === "?")
              G.query = "", fe = Fr;
            else if (!Ee && _e === "#")
              G.fragment = "", fe = vr;
            else if (_e !== me && (fe = kr, _e !== "/"))
              continue;
            break;
          case kr:
            if (_e === me || _e === "/" || _e === "\\" && G.isSpecial() || !Ee && (_e === "?" || _e === "#")) {
              if (bt(Ve) ? (G.shortenPath(), _e !== "/" && !(_e === "\\" && G.isSpecial()) && B(G.path, "")) : Xe(Ve) ? _e !== "/" && !(_e === "\\" && G.isSpecial()) && B(G.path, "") : (G.scheme === "file" && !G.path.length && Ye(Ve) && (G.host && (G.host = ""), Ve = q(Ve, 0) + ":"), B(G.path, Ve)), Ve = "", G.scheme === "file" && (_e === me || _e === "?" || _e === "#"))
                for (; G.path.length > 1 && G.path[0] === ""; )
                  Q(G.path);
              _e === "?" ? (G.query = "", fe = Fr) : _e === "#" && (G.fragment = "", fe = vr);
            } else
              Ve += ut(_e, Be);
            break;
          case Ln:
            _e === "?" ? (G.query = "", fe = Fr) : _e === "#" ? (G.fragment = "", fe = vr) : _e !== me && (G.path[0] += ut(_e, De));
            break;
          case Fr:
            !Ee && _e === "#" ? (G.fragment = "", fe = vr) : _e !== me && (_e === "'" && G.isSpecial() ? G.query += "%27" : _e === "#" ? G.query += "%23" : G.query += ut(_e, De));
            break;
          case vr:
            _e !== me && (G.fragment += ut(_e, He));
            break;
        }
        Ke++;
      }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(X) {
      var Ee, ne, G;
      if (q(X, 0) === "[") {
        if (q(X, X.length - 1) !== "]" || (Ee = xe($(X, 1, -1)), !Ee)) return Ae;
        this.host = Ee;
      } else if (this.isSpecial()) {
        if (X = S(X), W(yt, X) || (Ee = ye(X), Ee === null)) return Ae;
        this.host = Ee;
      } else {
        if (W(St, X)) return Ae;
        for (Ee = "", ne = C(X), G = 0; G < ne.length; G++)
          Ee += ut(ne[G], De);
        this.host = Ee;
      }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
      return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
      return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
      return f(Tt, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
      var X = this.path, Ee = X.length;
      Ee && (this.scheme !== "file" || Ee !== 1 || !Ye(X[0], !0)) && X.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
      var X = this, Ee = X.scheme, ne = X.username, G = X.password, fe = X.host, Ke = X.port, Ve = X.path, Ht = X.query, tt = X.fragment, nr = Ee + ":";
      return fe !== null ? (nr += "//", X.includesCredentials() && (nr += ne + (G ? ":" + G : "") + "@"), nr += _t(fe), Ke !== null && (nr += ":" + Ke)) : Ee === "file" && (nr += "//"), nr += X.cannotBeABaseURL ? Ve[0] : Ve.length ? "/" + te(Ve, "/") : "", Ht !== null && (nr += "?" + Ht), tt !== null && (nr += "#" + tt), nr;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(X) {
      var Ee = this.parse(X);
      if (Ee) throw new w(Ee);
      this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
      var X = this.scheme, Ee = this.port;
      if (X === "blob") try {
        return new Mn(X.path[0]).origin;
      } catch (ne) {
        return "null";
      }
      return X === "file" || !this.isSpecial() ? "null" : X + "://" + _t(this.host) + (Ee !== null ? ":" + Ee : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
      return this.scheme + ":";
    },
    setProtocol: function(X) {
      this.parse(v(X) + ":", Pt);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
      return this.username;
    },
    setUsername: function(X) {
      var Ee = C(v(X));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.username = "";
        for (var ne = 0; ne < Ee.length; ne++)
          this.username += ut(Ee[ne], Je);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
      return this.password;
    },
    setPassword: function(X) {
      var Ee = C(v(X));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.password = "";
        for (var ne = 0; ne < Ee.length; ne++)
          this.password += ut(Ee[ne], Je);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
      var X = this.host, Ee = this.port;
      return X === null ? "" : Ee === null ? _t(X) : _t(X) + ":" + Ee;
    },
    setHost: function(X) {
      this.cannotBeABaseURL || this.parse(X, wt);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
      var X = this.host;
      return X === null ? "" : _t(X);
    },
    setHostname: function(X) {
      this.cannotBeABaseURL || this.parse(X, Qt);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
      var X = this.port;
      return X === null ? "" : v(X);
    },
    setPort: function(X) {
      this.cannotHaveUsernamePasswordPort() || (X = v(X), X === "" ? this.port = null : this.parse(X, Ir));
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
      var X = this.path;
      return this.cannotBeABaseURL ? X[0] : X.length ? "/" + te(X, "/") : "";
    },
    setPathname: function(X) {
      this.cannotBeABaseURL || (this.path = [], this.parse(X, qt));
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
      var X = this.query;
      return X ? "?" + X : "";
    },
    setSearch: function(X) {
      X = v(X), X === "" ? this.query = null : (q(X, 0) === "?" && (X = $(X, 1)), this.query = "", this.parse(X, Fr)), this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
      return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
      var X = this.fragment;
      return X ? "#" + X : "";
    },
    setHash: function(X) {
      if (X = v(X), X === "") {
        this.fragment = null;
        return;
      }
      q(X, 0) === "#" && (X = $(X, 1)), this.fragment = "", this.parse(X, vr);
    },
    update: function() {
      this.query = this.searchParams.serialize() || null;
    }
  };
  var Mn = function(Ee) {
    var ne = p(this, or), G = O(arguments.length, 1) > 1 ? arguments[1] : void 0, fe = T(ne, new qn(Ee, !1, G));
    r || (ne.href = fe.serialize(), ne.origin = fe.getOrigin(), ne.protocol = fe.getProtocol(), ne.username = fe.getUsername(), ne.password = fe.getPassword(), ne.host = fe.getHost(), ne.hostname = fe.getHostname(), ne.port = fe.getPort(), ne.pathname = fe.getPathname(), ne.search = fe.getSearch(), ne.searchParams = fe.getSearchParams(), ne.hash = fe.getHash());
  }, or = Mn.prototype, Tr = function(X, Ee) {
    return {
      get: function() {
        return N(this)[X]();
      },
      set: Ee && function(ne) {
        return N(this)[Ee](ne);
      },
      configurable: !0,
      enumerable: !0
    };
  };
  if (r && (u(or, "href", Tr("serialize", "setHref")), u(or, "origin", Tr("getOrigin")), u(or, "protocol", Tr("getProtocol", "setProtocol")), u(or, "username", Tr("getUsername", "setUsername")), u(or, "password", Tr("getPassword", "setPassword")), u(or, "host", Tr("getHost", "setHost")), u(or, "hostname", Tr("getHostname", "setHostname")), u(or, "port", Tr("getPort", "setPort")), u(or, "pathname", Tr("getPathname", "setPathname")), u(or, "search", Tr("getSearch", "setSearch")), u(or, "searchParams", Tr("getSearchParams")), u(or, "hash", Tr("getHash", "setHash"))), c(or, "toJSON", function() {
    return N(this).serialize();
  }, { enumerable: !0 }), c(or, "toString", function() {
    return N(this).serialize();
  }, { enumerable: !0 }), k) {
    var dn = k.createObjectURL, la = k.revokeObjectURL;
    dn && c(Mn, "createObjectURL", o(dn, k)), la && c(Mn, "revokeObjectURL", o(la, k));
  }
  return g(Mn, "URL"), e({ global: !0, constructor: !0, forced: !t, sham: !r }, {
    URL: Mn
  }), DI;
}
var kI;
function zy() {
  return kI || (kI = 1, jy()), RI;
}
zy();
var FI = {}, UI;
function qy() {
  if (UI) return FI;
  UI = 1;
  var e = zt(), r = Mt();
  return e({ target: "URL", proto: !0, enumerable: !0 }, {
    toJSON: function() {
      return r(URL.prototype.toString, this);
    }
  }), FI;
}
qy();
var xI = {}, BI;
function Wy() {
  return BI || (BI = 1, PR()), xI;
}
Wy();
var $I = {}, GI;
function Yy() {
  if (GI) return $I;
  GI = 1;
  var e = pi(), r = It(), t = yn(), a = ac(), o = URLSearchParams, l = o.prototype, c = r(l.append), u = r(l.delete), p = r(l.forEach), f = r([].push), h = new o("a=1&a=2&b=3");
  return h.delete("a", 1), h.delete("b", void 0), h + "" != "a=2" && e(l, "delete", function(C) {
    var E = arguments.length, m = E < 2 ? void 0 : arguments[1];
    if (E && m === void 0) return u(this, C);
    var S = [];
    p(this, function(b, L) {
      f(S, { key: L, value: b });
    }), a(E, 1);
    for (var v = t(C), g = t(m), O = 0, D = 0, R = !1, T = S.length, N; O < T; )
      N = S[O++], R || N.key === v ? (R = !0, u(this, N.key)) : D++;
    for (; D < T; )
      N = S[D++], N.key === v && N.value === g || c(this, N.key, N.value);
  }, { enumerable: !0, unsafe: !0 }), $I;
}
Yy();
var ZI = {}, jI;
function Ky() {
  if (jI) return ZI;
  jI = 1;
  var e = pi(), r = It(), t = yn(), a = ac(), o = URLSearchParams, l = o.prototype, c = r(l.getAll), u = r(l.has), p = new o("a=1");
  return (p.has("a", 2) || !p.has("a", void 0)) && e(l, "has", function(h) {
    var C = arguments.length, E = C < 2 ? void 0 : arguments[1];
    if (C && E === void 0) return u(this, h);
    var m = c(this, h);
    a(C, 1);
    for (var S = t(E), v = 0; v < m.length; )
      if (m[v++] === S) return !0;
    return !1;
  }, { enumerable: !0, unsafe: !0 }), ZI;
}
Ky();
var zI = {}, qI;
function Xy() {
  if (qI) return zI;
  qI = 1;
  var e = jt(), r = It(), t = bi(), a = URLSearchParams.prototype, o = r(a.forEach);
  return e && !("size" in a) && t(a, "size", {
    get: function() {
      var c = 0;
      return o(this, function() {
        c++;
      }), c;
    },
    configurable: !0,
    enumerable: !0
  }), zI;
}
Xy();
function m2(e, r, t) {
  return (r = Qy(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Qy(e) {
  var r = Jy(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Jy(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class WI {
  constructor(r, t) {
    m2(this, "deviceId", void 0), m2(this, "facing", void 0), m2(this, "groupId", void 0), m2(this, "label", void 0), this.deviceId = r.deviceId, this.facing = t, this.groupId = r.groupId, this.label = r.label;
  }
}
var we = {}, Ls = { exports: {} }, e9 = Ls.exports, YI;
function t9() {
  return YI || (YI = 1, function(e, r) {
    (function(t, a) {
      var o = "1.0.40", l = "", c = "?", u = "function", p = "undefined", f = "object", h = "string", C = "major", E = "model", m = "name", S = "type", v = "vendor", g = "version", O = "architecture", D = "console", R = "mobile", T = "tablet", N = "smarttv", b = "wearable", L = "embedded", k = 500, w = "Amazon", V = "Apple", U = "ASUS", z = "BlackBerry", q = "Browser", W = "Chrome", te = "Edge", se = "Firefox", le = "Google", B = "Huawei", J = "LG", Q = "Microsoft", P = "Motorola", $ = "Opera", ce = "Samsung", ue = "Sharp", ie = "Sony", Re = "Xiaomi", Ae = "Zebra", Ce = "Facebook", Le = "Chromium OS", Ze = "Mac OS", at = " Browser", ot = function(De, He) {
        var Be = {};
        for (var Je in De)
          He[Je] && He[Je].length % 2 === 0 ? Be[Je] = He[Je].concat(De[Je]) : Be[Je] = De[Je];
        return Be;
      }, ct = function(De) {
        for (var He = {}, Be = 0; Be < De.length; Be++)
          He[De[Be].toUpperCase()] = De[Be];
        return He;
      }, lt = function(De, He) {
        return typeof De === h ? Ct(He).indexOf(Ct(De)) !== -1 : !1;
      }, Ct = function(De) {
        return De.toLowerCase();
      }, yt = function(De) {
        return typeof De === h ? De.replace(/[^\d\.]/g, l).split(".")[0] : a;
      }, St = function(De, He) {
        if (typeof De === h)
          return De = De.replace(/^\s\s*/, l), typeof He === p ? De : De.substring(0, k);
      }, st = function(De, He) {
        for (var Be = 0, Je, ut, Tt, Ye, ge, Xe; Be < He.length && !ge; ) {
          var bt = He[Be], Pt = He[Be + 1];
          for (Je = ut = 0; Je < bt.length && !ge && bt[Je]; )
            if (ge = bt[Je++].exec(De), ge)
              for (Tt = 0; Tt < Pt.length; Tt++)
                Xe = ge[++ut], Ye = Pt[Tt], typeof Ye === f && Ye.length > 0 ? Ye.length === 2 ? typeof Ye[1] == u ? this[Ye[0]] = Ye[1].call(this, Xe) : this[Ye[0]] = Ye[1] : Ye.length === 3 ? typeof Ye[1] === u && !(Ye[1].exec && Ye[1].test) ? this[Ye[0]] = Xe ? Ye[1].call(this, Xe, Ye[2]) : a : this[Ye[0]] = Xe ? Xe.replace(Ye[1], Ye[2]) : a : Ye.length === 4 && (this[Ye[0]] = Xe ? Ye[3].call(this, Xe.replace(Ye[1], Ye[2])) : a) : this[Ye] = Xe || a;
          Be += 2;
        }
      }, ze = function(De, He) {
        for (var Be in He)
          if (typeof He[Be] === f && He[Be].length > 0) {
            for (var Je = 0; Je < He[Be].length; Je++)
              if (lt(He[Be][Je], De))
                return Be === c ? a : Be;
          } else if (lt(He[Be], De))
            return Be === c ? a : Be;
        return He.hasOwnProperty("*") ? He["*"] : De;
      }, ht = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, me = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, ye = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [g, [m, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [g, [m, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [m, g], [/opios[\/ ]+([\w\.]+)/i], [g, [m, $ + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [g, [m, $ + " GX"]], [/\bopr\/([\w\.]+)/i], [g, [m, $]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [g, [m, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [g, [m, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [m, g], [/quark(?:pc)?\/([-\w\.]+)/i], [g, [m, "Quark"]], [/\bddg\/([\w\.]+)/i], [g, [m, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [g, [m, "UC" + q]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [g, [m, "WeChat"]], [/konqueror\/([\w\.]+)/i], [g, [m, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [g, [m, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [g, [m, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [g, [m, "Smart Lenovo " + q]], [/(avast|avg)\/([\w\.]+)/i], [[m, /(.+)/, "$1 Secure " + q], g], [/\bfocus\/([\w\.]+)/i], [g, [m, se + " Focus"]], [/\bopt\/([\w\.]+)/i], [g, [m, $ + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [g, [m, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [g, [m, "Dolphin"]], [/coast\/([\w\.]+)/i], [g, [m, $ + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [g, [m, "MIUI" + at]], [/fxios\/([\w\.-]+)/i], [g, [m, se]], [/\bqihoobrowser\/?([\w\.]*)/i], [g, [m, "360"]], [/\b(qq)\/([\w\.]+)/i], [[m, /(.+)/, "$1Browser"], g], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[m, /(.+)/, "$1" + at], g], [/samsungbrowser\/([\w\.]+)/i], [g, [m, ce + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [g, [m, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[m, "Sogou Mobile"], g], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [m, g], [/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i], [m], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [g, m], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[m, Ce], g], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [m, g], [/\bgsa\/([\w\.]+) .*safari\//i], [g, [m, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [g, [m, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [g, [m, W + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[m, W + " WebView"], g], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [g, [m, "Android " + q]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [m, g], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [g, [m, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [g, m], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [m, [g, ze, ht]], [/(webkit|khtml)\/([\w\.]+)/i], [m, g], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[m, "Netscape"], g], [/(wolvic|librewolf)\/([\w\.]+)/i], [m, g], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [g, [m, se + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [m, [g, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [m, [g, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[O, "amd64"]], [/(ia32(?=;))/i], [[O, Ct]], [/((?:i[346]|x)86)[;\)]/i], [[O, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[O, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[O, "armhf"]], [/windows (ce|mobile); ppc;/i], [[O, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[O, /ower/, l, Ct]], [/(sun4\w)[;\)]/i], [[O, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[O, Ct]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [E, [v, ce], [S, T]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [E, [v, ce], [S, R]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [E, [v, V], [S, R]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [E, [v, V], [S, T]], [/(macintosh);/i], [E, [v, V]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [E, [v, ue], [S, R]], [/(?:honor)([-\w ]+)[;\)]/i], [E, [v, "Honor"], [S, R]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [E, [v, B], [S, T]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [E, [v, B], [S, R]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i], [[E, /_/g, " "], [v, Re], [S, R]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[E, /_/g, " "], [v, Re], [S, T]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [E, [v, "OPPO"], [S, R]], [/\b(opd2\d{3}a?) bui/i], [E, [v, "OPPO"], [S, T]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [E, [v, "Vivo"], [S, R]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [E, [v, "Realme"], [S, R]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [E, [v, P], [S, R]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [E, [v, P], [S, T]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [E, [v, J], [S, T]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [E, [v, J], [S, R]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [E, [v, "Lenovo"], [S, T]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[E, /_/g, " "], [v, "Nokia"], [S, R]], [/(pixel c)\b/i], [E, [v, le], [S, T]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [E, [v, le], [S, R]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [E, [v, ie], [S, R]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[E, "Xperia Tablet"], [v, ie], [S, T]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [E, [v, "OnePlus"], [S, R]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [E, [v, w], [S, T]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[E, /(.+)/g, "Fire Phone $1"], [v, w], [S, R]], [/(playbook);[-\w\),; ]+(rim)/i], [E, v, [S, T]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [E, [v, z], [S, R]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [E, [v, U], [S, T]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [E, [v, U], [S, R]], [/(nexus 9)/i], [E, [v, "HTC"], [S, T]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [v, [E, /_/g, " "], [S, R]], [/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i], [E, [v, "TCL"], [S, T]], [/(itel) ((\w+))/i], [[v, Ct], E, [S, ze, { tablet: ["p10001l", "w7001"], "*": "mobile" }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [E, [v, "Acer"], [S, T]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [E, [v, "Meizu"], [S, R]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [E, [v, "Ulefone"], [S, R]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [E, [v, "Energizer"], [S, R]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [E, [v, "Cat"], [S, R]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [E, [v, "Smartfren"], [S, R]], [/droid.+; (a(?:015|06[35]|142p?))/i], [E, [v, "Nothing"], [S, R]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [v, E, [S, R]], [/(imo) (tab \w+)/i, /(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [v, E, [S, T]], [/(surface duo)/i], [E, [v, Q], [S, T]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [E, [v, "Fairphone"], [S, R]], [/(u304aa)/i], [E, [v, "AT&T"], [S, R]], [/\bsie-(\w*)/i], [E, [v, "Siemens"], [S, R]], [/\b(rct\w+) b/i], [E, [v, "RCA"], [S, T]], [/\b(venue[\d ]{2,7}) b/i], [E, [v, "Dell"], [S, T]], [/\b(q(?:mv|ta)\w+) b/i], [E, [v, "Verizon"], [S, T]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [E, [v, "Barnes & Noble"], [S, T]], [/\b(tm\d{3}\w+) b/i], [E, [v, "NuVision"], [S, T]], [/\b(k88) b/i], [E, [v, "ZTE"], [S, T]], [/\b(nx\d{3}j) b/i], [E, [v, "ZTE"], [S, R]], [/\b(gen\d{3}) b.+49h/i], [E, [v, "Swiss"], [S, R]], [/\b(zur\d{3}) b/i], [E, [v, "Swiss"], [S, T]], [/\b((zeki)?tb.*\b) b/i], [E, [v, "Zeki"], [S, T]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[v, "Dragon Touch"], E, [S, T]], [/\b(ns-?\w{0,9}) b/i], [E, [v, "Insignia"], [S, T]], [/\b((nxa|next)-?\w{0,9}) b/i], [E, [v, "NextBook"], [S, T]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[v, "Voice"], E, [S, R]], [/\b(lvtel\-)?(v1[12]) b/i], [[v, "LvTel"], E, [S, R]], [/\b(ph-1) /i], [E, [v, "Essential"], [S, R]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [E, [v, "Envizen"], [S, T]], [/\b(trio[-\w\. ]+) b/i], [E, [v, "MachSpeed"], [S, T]], [/\btu_(1491) b/i], [E, [v, "Rotor"], [S, T]], [/(shield[\w ]+) b/i], [E, [v, "Nvidia"], [S, T]], [/(sprint) (\w+)/i], [v, E, [S, R]], [/(kin\.[onetw]{3})/i], [[E, /\./g, " "], [v, Q], [S, R]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [E, [v, Ae], [S, T]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [E, [v, Ae], [S, R]], [/smart-tv.+(samsung)/i], [v, [S, N]], [/hbbtv.+maple;(\d+)/i], [[E, /^/, "SmartTV"], [v, ce], [S, N]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[v, J], [S, N]], [/(apple) ?tv/i], [v, [E, V + " TV"], [S, N]], [/crkey/i], [[E, W + "cast"], [v, le], [S, N]], [/droid.+aft(\w+)( bui|\))/i], [E, [v, w], [S, N]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [E, [v, ue], [S, N]], [/(bravia[\w ]+)( bui|\))/i], [E, [v, ie], [S, N]], [/(mitv-\w{5}) bui/i], [E, [v, Re], [S, N]], [/Hbbtv.*(technisat) (.*);/i], [v, E, [S, N]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[v, St], [E, St], [S, N]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[S, N]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [v, E, [S, D]], [/droid.+; (shield) bui/i], [E, [v, "Nvidia"], [S, D]], [/(playstation [345portablevi]+)/i], [E, [v, ie], [S, D]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [E, [v, Q], [S, D]], [/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i], [E, [v, ce], [S, b]], [/((pebble))app/i], [v, E, [S, b]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [E, [v, V], [S, b]], [/droid.+; (glass) \d/i], [E, [v, le], [S, b]], [/droid.+; (wt63?0{2,3})\)/i], [E, [v, Ae], [S, b]], [/droid.+; (glass) \d/i], [E, [v, le], [S, b]], [/(pico) (4|neo3(?: link|pro)?)/i], [v, E, [S, b]], [/; (quest( \d| pro)?)/i], [E, [v, Ce], [S, b]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [v, [S, L]], [/(aeobc)\b/i], [E, [v, w], [S, L]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [E, [S, R]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [E, [S, T]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[S, T]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[S, R]], [/(android[-\w\. ]{0,9});.+buil/i], [E, [v, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [g, [m, te + "HTML"]], [/(arkweb)\/([\w\.]+)/i], [m, g], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [g, [m, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [m, g], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [g, m]], os: [[/microsoft (windows) (vista|xp)/i], [m, g], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [m, [g, ze, me]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[g, ze, me], [m, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[g, /_/g, "."], [m, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[m, Ze], [g, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [g, m], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [m, g], [/\(bb(10);/i], [g, [m, z]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [g, [m, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [g, [m, se + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [g, [m, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [g, [m, "watchOS"]], [/crkey\/([\d\.]+)/i], [g, [m, W + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[m, Le], g], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [m, g], [/(sunos) ?([\w\.\d]*)/i], [[m, "Solaris"], g], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [m, g]] }, xe = function(De, He) {
        if (typeof De === f && (He = De, De = a), !(this instanceof xe))
          return new xe(De, He).getResult();
        var Be = typeof t !== p && t.navigator ? t.navigator : a, Je = De || (Be && Be.userAgent ? Be.userAgent : l), ut = Be && Be.userAgentData ? Be.userAgentData : a, Tt = He ? ot(ye, He) : ye, Ye = Be && Be.userAgent == Je;
        return this.getBrowser = function() {
          var ge = {};
          return ge[m] = a, ge[g] = a, st.call(ge, Je, Tt.browser), ge[C] = yt(ge[g]), Ye && Be && Be.brave && typeof Be.brave.isBrave == u && (ge[m] = "Brave"), ge;
        }, this.getCPU = function() {
          var ge = {};
          return ge[O] = a, st.call(ge, Je, Tt.cpu), ge;
        }, this.getDevice = function() {
          var ge = {};
          return ge[v] = a, ge[E] = a, ge[S] = a, st.call(ge, Je, Tt.device), Ye && !ge[S] && ut && ut.mobile && (ge[S] = R), Ye && ge[E] == "Macintosh" && Be && typeof Be.standalone !== p && Be.maxTouchPoints && Be.maxTouchPoints > 2 && (ge[E] = "iPad", ge[S] = T), ge;
        }, this.getEngine = function() {
          var ge = {};
          return ge[m] = a, ge[g] = a, st.call(ge, Je, Tt.engine), ge;
        }, this.getOS = function() {
          var ge = {};
          return ge[m] = a, ge[g] = a, st.call(ge, Je, Tt.os), Ye && !ge[m] && ut && ut.platform && ut.platform != "Unknown" && (ge[m] = ut.platform.replace(/chrome os/i, Le).replace(/macos/i, Ze)), ge;
        }, this.getResult = function() {
          return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
        }, this.getUA = function() {
          return Je;
        }, this.setUA = function(ge) {
          return Je = typeof ge === h && ge.length > k ? St(ge, k) : ge, this;
        }, this.setUA(Je), this;
      };
      xe.VERSION = o, xe.BROWSER = ct([m, g, C]), xe.CPU = ct([O]), xe.DEVICE = ct([E, v, S, D, R, N, T, b, L]), xe.ENGINE = xe.OS = ct([m, g]), e.exports && (r = e.exports = xe), r.UAParser = xe;
      var Lt = typeof t !== p && (t.jQuery || t.Zepto);
      if (Lt && !Lt.ua) {
        var _t = new xe();
        Lt.ua = _t.getResult(), Lt.ua.get = function() {
          return _t.getUA();
        }, Lt.ua.set = function(De) {
          _t.setUA(De);
          var He = _t.getResult();
          for (var Be in He)
            Lt.ua[Be] = He[Be];
        };
      }
    })(typeof window == "object" ? window : e9);
  }(Ls, Ls.exports)), Ls.exports;
}
var KI;
function r9() {
  if (KI) return we;
  KI = 1, Object.defineProperty(we, "__esModule", { value: !0 });
  function e(Z) {
    return Z && typeof Z == "object" && "default" in Z ? Z.default : Z;
  }
  var r = Ys(), t = e(r), a = t9(), o = new a(), l = o.getBrowser(), c = o.getCPU(), u = o.getDevice(), p = o.getEngine(), f = o.getOS(), h = o.getUA(), C = function(y) {
    return o.setUA(y);
  }, E = function(y) {
    if (!y) {
      console.error("No userAgent string was provided");
      return;
    }
    var H = new a(y);
    return {
      UA: H,
      browser: H.getBrowser(),
      cpu: H.getCPU(),
      device: H.getDevice(),
      engine: H.getEngine(),
      os: H.getOS(),
      ua: H.getUA(),
      setUserAgent: function(de) {
        return H.setUA(de);
      }
    };
  }, m = /* @__PURE__ */ Object.freeze({
    ClientUAInstance: o,
    browser: l,
    cpu: c,
    device: u,
    engine: p,
    os: f,
    ua: h,
    setUa: C,
    parseUserAgent: E
  });
  function S(Z, y) {
    var H = Object.keys(Z);
    if (Object.getOwnPropertySymbols) {
      var ae = Object.getOwnPropertySymbols(Z);
      y && (ae = ae.filter(function(de) {
        return Object.getOwnPropertyDescriptor(Z, de).enumerable;
      })), H.push.apply(H, ae);
    }
    return H;
  }
  function v(Z) {
    for (var y = 1; y < arguments.length; y++) {
      var H = arguments[y] != null ? arguments[y] : {};
      y % 2 ? S(Object(H), !0).forEach(function(ae) {
        T(Z, ae, H[ae]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Z, Object.getOwnPropertyDescriptors(H)) : S(Object(H)).forEach(function(ae) {
        Object.defineProperty(Z, ae, Object.getOwnPropertyDescriptor(H, ae));
      });
    }
    return Z;
  }
  function g(Z) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? g = function(y) {
      return typeof y;
    } : g = function(y) {
      return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
    }, g(Z);
  }
  function O(Z, y) {
    if (!(Z instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function D(Z, y) {
    for (var H = 0; H < y.length; H++) {
      var ae = y[H];
      ae.enumerable = ae.enumerable || !1, ae.configurable = !0, "value" in ae && (ae.writable = !0), Object.defineProperty(Z, ae.key, ae);
    }
  }
  function R(Z, y, H) {
    return y && D(Z.prototype, y), Z;
  }
  function T(Z, y, H) {
    return y in Z ? Object.defineProperty(Z, y, {
      value: H,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : Z[y] = H, Z;
  }
  function N() {
    return N = Object.assign || function(Z) {
      for (var y = 1; y < arguments.length; y++) {
        var H = arguments[y];
        for (var ae in H)
          Object.prototype.hasOwnProperty.call(H, ae) && (Z[ae] = H[ae]);
      }
      return Z;
    }, N.apply(this, arguments);
  }
  function b(Z, y) {
    if (typeof y != "function" && y !== null)
      throw new TypeError("Super expression must either be null or a function");
    Z.prototype = Object.create(y && y.prototype, {
      constructor: {
        value: Z,
        writable: !0,
        configurable: !0
      }
    }), y && k(Z, y);
  }
  function L(Z) {
    return L = Object.setPrototypeOf ? Object.getPrototypeOf : function(H) {
      return H.__proto__ || Object.getPrototypeOf(H);
    }, L(Z);
  }
  function k(Z, y) {
    return k = Object.setPrototypeOf || function(ae, de) {
      return ae.__proto__ = de, ae;
    }, k(Z, y);
  }
  function w(Z, y) {
    if (Z == null) return {};
    var H = {}, ae = Object.keys(Z), de, et;
    for (et = 0; et < ae.length; et++)
      de = ae[et], !(y.indexOf(de) >= 0) && (H[de] = Z[de]);
    return H;
  }
  function V(Z, y) {
    if (Z == null) return {};
    var H = w(Z, y), ae, de;
    if (Object.getOwnPropertySymbols) {
      var et = Object.getOwnPropertySymbols(Z);
      for (de = 0; de < et.length; de++)
        ae = et[de], !(y.indexOf(ae) >= 0) && Object.prototype.propertyIsEnumerable.call(Z, ae) && (H[ae] = Z[ae]);
    }
    return H;
  }
  function U(Z) {
    if (Z === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Z;
  }
  function z(Z, y) {
    if (y && (typeof y == "object" || typeof y == "function"))
      return y;
    if (y !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return U(Z);
  }
  function q(Z, y) {
    return W(Z) || te(Z, y) || se(Z, y) || B();
  }
  function W(Z) {
    if (Array.isArray(Z)) return Z;
  }
  function te(Z, y) {
    var H = Z == null ? null : typeof Symbol != "undefined" && Z[Symbol.iterator] || Z["@@iterator"];
    if (H != null) {
      var ae = [], de = !0, et = !1, Ut, Or;
      try {
        for (H = H.call(Z); !(de = (Ut = H.next()).done) && (ae.push(Ut.value), !(y && ae.length === y)); de = !0)
          ;
      } catch (Ya) {
        et = !0, Or = Ya;
      } finally {
        try {
          !de && H.return != null && H.return();
        } finally {
          if (et) throw Or;
        }
      }
      return ae;
    }
  }
  function se(Z, y) {
    if (Z) {
      if (typeof Z == "string") return le(Z, y);
      var H = Object.prototype.toString.call(Z).slice(8, -1);
      if (H === "Object" && Z.constructor && (H = Z.constructor.name), H === "Map" || H === "Set") return Array.from(Z);
      if (H === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(H)) return le(Z, y);
    }
  }
  function le(Z, y) {
    (y == null || y > Z.length) && (y = Z.length);
    for (var H = 0, ae = new Array(y); H < y; H++) ae[H] = Z[H];
    return ae;
  }
  function B() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var J = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: void 0
  }, Q = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
  }, P = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
  }, $ = {
    isMobile: !1,
    isTablet: !1,
    isBrowser: !1,
    isSmartTV: !1,
    isConsole: !1,
    isWearable: !1
  }, ce = function(y) {
    switch (y) {
      case J.Mobile:
        return {
          isMobile: !0
        };
      case J.Tablet:
        return {
          isTablet: !0
        };
      case J.SmartTv:
        return {
          isSmartTV: !0
        };
      case J.Console:
        return {
          isConsole: !0
        };
      case J.Wearable:
        return {
          isWearable: !0
        };
      case J.Browser:
        return {
          isBrowser: !0
        };
      case J.Embedded:
        return {
          isEmbedded: !0
        };
      default:
        return $;
    }
  }, ue = function(y) {
    return C(y);
  }, ie = function(y) {
    var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
    return y || H;
  }, Re = function() {
    return typeof window != "undefined" && (window.navigator || navigator) ? window.navigator || navigator : !1;
  }, Ae = function(y) {
    var H = Re();
    return H && H.platform && (H.platform.indexOf(y) !== -1 || H.platform === "MacIntel" && H.maxTouchPoints > 1 && !window.MSStream);
  }, Ce = function(y, H, ae, de, et) {
    return {
      isBrowser: y,
      browserMajorVersion: ie(H.major),
      browserFullVersion: ie(H.version),
      browserName: ie(H.name),
      engineName: ie(ae.name),
      engineVersion: ie(ae.version),
      osName: ie(de.name),
      osVersion: ie(de.version),
      userAgent: ie(et)
    };
  }, Le = function(y, H, ae, de) {
    return v({}, y, {
      vendor: ie(H.vendor),
      model: ie(H.model),
      os: ie(ae.name),
      osVersion: ie(ae.version),
      ua: ie(de)
    });
  }, Ze = function(y, H, ae, de) {
    return {
      isSmartTV: y,
      engineName: ie(H.name),
      engineVersion: ie(H.version),
      osName: ie(ae.name),
      osVersion: ie(ae.version),
      userAgent: ie(de)
    };
  }, at = function(y, H, ae, de) {
    return {
      isConsole: y,
      engineName: ie(H.name),
      engineVersion: ie(H.version),
      osName: ie(ae.name),
      osVersion: ie(ae.version),
      userAgent: ie(de)
    };
  }, ot = function(y, H, ae, de) {
    return {
      isWearable: y,
      engineName: ie(H.name),
      engineVersion: ie(H.version),
      osName: ie(ae.name),
      osVersion: ie(ae.version),
      userAgent: ie(de)
    };
  }, ct = function(y, H, ae, de, et) {
    return {
      isEmbedded: y,
      vendor: ie(H.vendor),
      model: ie(H.model),
      engineName: ie(ae.name),
      engineVersion: ie(ae.version),
      osName: ie(de.name),
      osVersion: ie(de.version),
      userAgent: ie(et)
    };
  };
  function lt(Z) {
    var y = Z ? E(Z) : m, H = y.device, ae = y.browser, de = y.engine, et = y.os, Ut = y.ua, Or = ce(H.type), Ya = Or.isBrowser, Yo = Or.isMobile, Ka = Or.isTablet, Xa = Or.isSmartTV, Ko = Or.isConsole, Pn = Or.isWearable, Qa = Or.isEmbedded;
    if (Ya)
      return Ce(Ya, ae, de, et, Ut);
    if (Xa)
      return Ze(Xa, de, et, Ut);
    if (Ko)
      return at(Ko, de, et, Ut);
    if (Yo || Ka)
      return Le(Or, H, et, Ut);
    if (Pn)
      return ot(Pn, de, et, Ut);
    if (Qa)
      return ct(Qa, H, de, et, Ut);
  }
  var Ct = function(y) {
    var H = y.type;
    return H === J.Mobile;
  }, yt = function(y) {
    var H = y.type;
    return H === J.Tablet;
  }, St = function(y) {
    var H = y.type;
    return H === J.Mobile || H === J.Tablet;
  }, st = function(y) {
    var H = y.type;
    return H === J.SmartTv;
  }, ze = function(y) {
    var H = y.type;
    return H === J.Browser;
  }, ht = function(y) {
    var H = y.type;
    return H === J.Wearable;
  }, me = function(y) {
    var H = y.type;
    return H === J.Console;
  }, ye = function(y) {
    var H = y.type;
    return H === J.Embedded;
  }, xe = function(y) {
    var H = y.vendor;
    return ie(H);
  }, Lt = function(y) {
    var H = y.model;
    return ie(H);
  }, _t = function(y) {
    var H = y.type;
    return ie(H, "browser");
  }, De = function(y) {
    var H = y.name;
    return H === P.Android;
  }, He = function(y) {
    var H = y.name;
    return H === P.Windows;
  }, Be = function(y) {
    var H = y.name;
    return H === P.MAC_OS;
  }, Je = function(y) {
    var H = y.name;
    return H === P.WindowsPhone;
  }, ut = function(y) {
    var H = y.name;
    return H === P.IOS;
  }, Tt = function(y) {
    var H = y.version;
    return ie(H);
  }, Ye = function(y) {
    var H = y.name;
    return ie(H);
  }, ge = function(y) {
    var H = y.name;
    return H === Q.Chrome;
  }, Xe = function(y) {
    var H = y.name;
    return H === Q.Firefox;
  }, bt = function(y) {
    var H = y.name;
    return H === Q.Chromium;
  }, Pt = function(y) {
    var H = y.name;
    return H === Q.Edge;
  }, Ar = function(y) {
    var H = y.name;
    return H === Q.Yandex;
  }, Ie = function(y) {
    var H = y.name;
    return H === Q.Safari || H === Q.MobileSafari;
  }, Me = function(y) {
    var H = y.name;
    return H === Q.MobileSafari;
  }, Te = function(y) {
    var H = y.name;
    return H === Q.Opera;
  }, Pe = function(y) {
    var H = y.name;
    return H === Q.InternetExplorer || H === Q.Ie;
  }, je = function(y) {
    var H = y.name;
    return H === Q.MIUI;
  }, rt = function(y) {
    var H = y.name;
    return H === Q.SamsungBrowser;
  }, Rt = function(y) {
    var H = y.version;
    return ie(H);
  }, Nt = function(y) {
    var H = y.major;
    return ie(H);
  }, wt = function(y) {
    var H = y.name;
    return ie(H);
  }, Qt = function(y) {
    var H = y.name;
    return ie(H);
  }, Ir = function(y) {
    var H = y.version;
    return ie(H);
  }, hi = function() {
    var y = Re(), H = y && y.userAgent && y.userAgent.toLowerCase();
    return typeof H == "string" ? /electron/.test(H) : !1;
  }, Vr = function(y) {
    return typeof y == "string" && y.indexOf("Edg/") !== -1;
  }, zn = function() {
    var y = Re();
    return y && (/iPad|iPhone|iPod/.test(y.platform) || y.platform === "MacIntel" && y.maxTouchPoints > 1) && !window.MSStream;
  }, qt = function() {
    return Ae("iPad");
  }, kr = function() {
    return Ae("iPhone");
  }, Ln = function() {
    return Ae("iPod");
  }, Fr = function(y) {
    return ie(y);
  };
  function vr(Z) {
    var y = Z || m, H = y.device, ae = y.browser, de = y.os, et = y.engine, Ut = y.ua;
    return {
      isSmartTV: st(H),
      isConsole: me(H),
      isWearable: ht(H),
      isEmbedded: ye(H),
      isMobileSafari: Me(ae) || qt(),
      isChromium: bt(ae),
      isMobile: St(H) || qt(),
      isMobileOnly: Ct(H),
      isTablet: yt(H) || qt(),
      isBrowser: ze(H),
      isDesktop: ze(H),
      isAndroid: De(de),
      isWinPhone: Je(de),
      isIOS: ut(de) || qt(),
      isChrome: ge(ae),
      isFirefox: Xe(ae),
      isSafari: Ie(ae),
      isOpera: Te(ae),
      isIE: Pe(ae),
      osVersion: Tt(de),
      osName: Ye(de),
      fullBrowserVersion: Rt(ae),
      browserVersion: Nt(ae),
      browserName: wt(ae),
      mobileVendor: xe(H),
      mobileModel: Lt(H),
      engineName: Qt(et),
      engineVersion: Ir(et),
      getUA: Fr(Ut),
      isEdge: Pt(ae) || Vr(Ut),
      isYandex: Ar(ae),
      deviceType: _t(H),
      isIOS13: zn(),
      isIPad13: qt(),
      isIPhone13: kr(),
      isIPod13: Ln(),
      isElectron: hi(),
      isEdgeChromium: Vr(Ut),
      isLegacyEdge: Pt(ae) && !Vr(Ut),
      isWindows: He(de),
      isMacOs: Be(de),
      isMIUI: je(ae),
      isSamsungBrowser: rt(ae)
    };
  }
  var qn = st(u), Mn = me(u), or = ht(u), Tr = ye(u), dn = Me(l) || qt(), la = bt(l), X = St(u) || qt(), Ee = Ct(u), ne = yt(u) || qt(), G = ze(u), fe = ze(u), Ke = De(f), Ve = Je(f), Ht = ut(f) || qt(), tt = ge(l), nr = Xe(l), _r = Ie(l), _e = Te(l), Vt = Pe(l), en = Tt(f), Vi = Ye(f), _i = Rt(l), Ur = Nt(l), ca = wt(l), tn = xe(u), Ic = Lt(u), vc = Qt(p), gc = Ir(p), ja = Fr(h), za = Pt(l) || Vr(h), ua = Ar(l), qa = _t(u), Rc = zn(), Dc = qt(), Zo = kr(), cl = Ln(), jo = hi(), fa = Vr(h), Ac = Pt(l) && !Vr(h), zo = He(f), Ot = Be(f), ul = je(l), fl = rt(l), qo = function(y) {
    if (!y || typeof y != "string") {
      console.error("No valid user agent string was provided");
      return;
    }
    var H = E(y), ae = H.device, de = H.browser, et = H.os, Ut = H.engine, Or = H.ua;
    return vr({
      device: ae,
      browser: de,
      os: et,
      engine: Ut,
      ua: Or
    });
  }, dl = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return Ke ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, pl = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return G ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, hl = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return Vt ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Wo = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return Ht ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Wa = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return X ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Wn = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return ne ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Yn = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return Ve ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Kn = function(y) {
    var H = y.renderWithFragment, ae = y.children;
    y.viewClassName, y.style;
    var de = V(y, ["renderWithFragment", "children", "viewClassName", "style"]);
    return Ee ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, da = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return qn ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, pa = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return Mn ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Xn = function(y) {
    var H = y.renderWithFragment, ae = y.children, de = V(y, ["renderWithFragment", "children"]);
    return or ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", de, ae) : null;
  }, Tc = function(y) {
    var H = y.renderWithFragment, ae = y.children;
    y.viewClassName, y.style;
    var de = y.condition, et = V(y, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
    return de ? H ? t.createElement(r.Fragment, null, ae) : t.createElement("div", et, ae) : null;
  };
  function _l(Z) {
    return /* @__PURE__ */ function(y) {
      b(H, y);
      function H(ae) {
        var de;
        return O(this, H), de = z(this, L(H).call(this, ae)), de.isEventListenerAdded = !1, de.handleOrientationChange = de.handleOrientationChange.bind(U(de)), de.onOrientationChange = de.onOrientationChange.bind(U(de)), de.onPageLoad = de.onPageLoad.bind(U(de)), de.state = {
          isLandscape: !1,
          isPortrait: !1
        }, de;
      }
      return R(H, [{
        key: "handleOrientationChange",
        value: function() {
          this.isEventListenerAdded || (this.isEventListenerAdded = !0);
          var de = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: de === 0,
            isLandscape: de === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function() {
          (typeof window == "undefined" ? "undefined" : g(window)) !== void 0 && X && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.onOrientationChange, !1);
        }
      }, {
        key: "render",
        value: function() {
          return t.createElement(Z, N({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]), H;
    }(t.Component);
  }
  function ha() {
    var Z = r.useState(function() {
      var et = window.innerWidth > window.innerHeight ? 90 : 0;
      return {
        isPortrait: et === 0,
        isLandscape: et === 90,
        orientation: et === 0 ? "portrait" : "landscape"
      };
    }), y = q(Z, 2), H = y[0], ae = y[1], de = r.useCallback(function() {
      var et = window.innerWidth > window.innerHeight ? 90 : 0, Ut = {
        isPortrait: et === 0,
        isLandscape: et === 90,
        orientation: et === 0 ? "portrait" : "landscape"
      };
      H.orientation !== Ut.orientation && ae(Ut);
    }, [H.orientation]);
    return r.useEffect(function() {
      return (typeof window == "undefined" ? "undefined" : g(window)) !== void 0 && X && (de(), window.addEventListener("load", de, !1), window.addEventListener("resize", de, !1)), function() {
        window.removeEventListener("resize", de, !1), window.removeEventListener("load", de, !1);
      };
    }, [de]), H;
  }
  function ml(Z) {
    var y = Z || window.navigator.userAgent;
    return E(y);
  }
  function El(Z) {
    var y = Z || window.navigator.userAgent, H = ml(y), ae = vr(H);
    return [ae, H];
  }
  return we.AndroidView = dl, we.BrowserTypes = Q, we.BrowserView = pl, we.ConsoleView = pa, we.CustomView = Tc, we.IEView = hl, we.IOSView = Wo, we.MobileOnlyView = Kn, we.MobileView = Wa, we.OsTypes = P, we.SmartTVView = da, we.TabletView = Wn, we.WearableView = Xn, we.WinPhoneView = Yn, we.browserName = ca, we.browserVersion = Ur, we.deviceDetect = lt, we.deviceType = qa, we.engineName = vc, we.engineVersion = gc, we.fullBrowserVersion = _i, we.getSelectorsByUserAgent = qo, we.getUA = ja, we.isAndroid = Ke, we.isBrowser = G, we.isChrome = tt, we.isChromium = la, we.isConsole = Mn, we.isDesktop = fe, we.isEdge = za, we.isEdgeChromium = fa, we.isElectron = jo, we.isEmbedded = Tr, we.isFirefox = nr, we.isIE = Vt, we.isIOS = Ht, we.isIOS13 = Rc, we.isIPad13 = Dc, we.isIPhone13 = Zo, we.isIPod13 = cl, we.isLegacyEdge = Ac, we.isMIUI = ul, we.isMacOs = Ot, we.isMobile = X, we.isMobileOnly = Ee, we.isMobileSafari = dn, we.isOpera = _e, we.isSafari = _r, we.isSamsungBrowser = fl, we.isSmartTV = qn, we.isTablet = ne, we.isWearable = or, we.isWinPhone = Ve, we.isWindows = zo, we.isYandex = ua, we.mobileModel = Ic, we.mobileVendor = tn, we.osName = Vi, we.osVersion = en, we.parseUserAgent = E, we.setUserAgent = ue, we.useDeviceData = ml, we.useDeviceSelectors = El, we.useMobileOrientation = ha, we.withOrientationChange = _l, we;
}
var Kt = r9();
const Dr = [];
for (let e = 0; e < 256; ++e)
  Dr.push((e + 256).toString(16).slice(1));
function n9(e, r = 0) {
  return (Dr[e[r + 0]] + Dr[e[r + 1]] + Dr[e[r + 2]] + Dr[e[r + 3]] + "-" + Dr[e[r + 4]] + Dr[e[r + 5]] + "-" + Dr[e[r + 6]] + Dr[e[r + 7]] + "-" + Dr[e[r + 8]] + Dr[e[r + 9]] + "-" + Dr[e[r + 10]] + Dr[e[r + 11]] + Dr[e[r + 12]] + Dr[e[r + 13]] + Dr[e[r + 14]] + Dr[e[r + 15]]).toLowerCase();
}
let A1;
const i9 = new Uint8Array(16);
function a9() {
  if (!A1) {
    if (typeof crypto == "undefined" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    A1 = crypto.getRandomValues.bind(crypto);
  }
  return A1(i9);
}
const o9 = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), XI = { randomUUID: o9 };
function pp(e, r, t) {
  var o, l, c;
  if (XI.randomUUID && !e)
    return XI.randomUUID();
  e = e || {};
  const a = (c = (l = e.random) != null ? l : (o = e.rng) == null ? void 0 : o.call(e)) != null ? c : a9();
  if (a.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, n9(a);
}
const bR = (e) => {
  switch (e) {
    case "":
    case "true":
      return !0;
    case "false":
      return !1;
    case null:
    default:
      return;
  }
};
function wR() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  const a = [...r];
  return a.length === 0 ? function(o) {
    return o;
  } : a.length === 1 ? a[0] : a.reduce(function(o, l) {
    return function() {
      return o(l(...arguments));
    };
  });
}
function QI(e, r, t, a, o, l, c, u, p) {
  const f = e / r, h = t / a, E = (p === B2.contain ? h < f : h > f) ? e / t : r / a, m = (e / E - t) / 2, S = (r / E - a) / 2, v = o / E, g = l / E, O = c / E - m, D = t - (O + v), R = u / E - S;
  return {
    width: v,
    height: g,
    left: O,
    right: D,
    top: R
  };
}
function HR(e, r) {
  return new CustomEvent(e, {
    bubbles: !0,
    composed: !0,
    detail: r
  });
}
function VR() {
  return Oe(this, null, function* () {
    const r = (yield navigator.mediaDevices.enumerateDevices()).filter((a) => a.kind === "videoinput"), t = r.every((a) => a.label !== "");
    return {
      videoDevices: r,
      isCameraAllowed: t
    };
  });
}
function s9(e, r) {
  const t = e.toLowerCase();
  return r.some((a) => t.includes(a));
}
function kR(e) {
  return Oe(this, null, function* () {
    const r = {
      frontCameras: [],
      backCameras: []
    };
    let t = e.videoDevices;
    if (!e.isCameraAllowed) {
      const a = yield navigator.mediaDevices.getUserMedia({
        video: !0,
        audio: !1
      });
      t = (yield navigator.mediaDevices.enumerateDevices()).filter((l) => l.kind === "videoinput"), a.getTracks().forEach((l) => l.stop());
    }
    for (const a of t)
      s9(a.label, _y) ? r.backCameras.push(new WI(a, fn.environment)) : r.frontCameras.push(new WI(a, fn.user));
    return r;
  });
}
function FR(e, r, t) {
  const a = [...r.frontCameras, ...r.backCameras];
  if (!a.length)
    return {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (t)
    return a.find((l) => l.deviceId === t) || {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (e === fn.environment && r.backCameras.length) {
    const l = r.backCameras.map((c) => {
      const u = /\b([0-9]+)MP?\b/i, p = c.label.match(u);
      return p !== null ? parseInt(p[1], 10) : NaN;
    });
    if (l.every((c) => !isNaN(c))) {
      const c = l.lastIndexOf(Math.max(...l));
      return r.backCameras[c];
    } else
      return Kt.isIOS ? {
        deviceId: "",
        facing: fn.environment,
        groupId: "",
        label: ""
      } : r.backCameras.sort((c, u) => c.label.localeCompare(u.label))[0];
  } else
    return {
      deviceId: "",
      facing: fn.user,
      groupId: "",
      label: ""
    };
}
const hp = (e) => {
  e.getTracks().forEach((r) => r.stop());
};
function UR(e, r, t) {
  return Oe(this, null, function* () {
    const a = {
      status: Ft.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    };
    if (navigator.mediaDevices) {
      if (!r.deviceId && !r.facing)
        return t ? (a.status = Ft.INCORRECT_CAMERA_ID, a) : (a.status = Ft.NO_CAMERA, a);
      const o = {
        height: {
          ideal: e.height > MS ? ui.FULL_HD.height : e.height
        },
        width: {
          ideal: e.width > MS ? ui.FULL_HD.width : e.width
        },
        frameRate: {
          ideal: 30
        }
      };
      r.deviceId ? o.deviceId = {
        exact: r.deviceId
      } : o.facingMode = {
        ideal: r.facing
      };
      const l = yield navigator.mediaDevices.getUserMedia({
        video: o,
        audio: !1
      }), c = l.getVideoTracks()[0], {
        deviceId: u,
        groupId: p,
        facingMode: f
      } = c.getSettings(), h = {
        deviceId: u || r.deviceId,
        label: c.label || r.label,
        groupId: p || r.groupId,
        facing: f || r.facing
      };
      return {
        status: Ft.READY,
        stream: l,
        camera: h
      };
    } else
      return a.status = Ft.NOT_SUPPORTED, a;
  });
}
function oc(e, r) {
  const t = {
    imageData: [],
    raw: "",
    mimeType: ""
  }, {
    videoHeight: a,
    videoWidth: o,
    readyState: l
  } = e;
  if (a && o && l === vR.HAVE_ENOUGH_DATA) {
    const c = document.createElement("canvas");
    c.width = o, c.height = a;
    const u = c.getContext("2d", {
      willReadFrequently: !0
    });
    if (u == null || u.drawImage(e, 0, 0), r !== ba.UINT) {
      const p = "image/jpeg";
      t.raw = c.toDataURL(p, 0.8).replace("data:".concat(p, ";base64,"), ""), t.mimeType = p;
    }
    if (r !== ba.BASE64) {
      const p = u == null ? void 0 : u.getImageData(0, 0, o, a);
      p && (t.imageData = [p]);
    }
  }
  return t;
}
function ph(e, r) {
  const t = [...e.frontCameras, ...e.backCameras], o = (t.findIndex((l) => l.deviceId === r) + 1) % t.length;
  return t[o].deviceId;
}
function $r(e, r) {
  const t = (o) => o !== null && typeof o == "object" && !Array.isArray(o), a = Object.assign({}, e);
  if (t(e) && t(r))
    for (const o of Object.keys(r)) {
      const l = e[o], c = r[o];
      t(c) ? l === void 0 ? a[o] = c : a[o] = $r(l, c) : a[o] = c;
    }
  return a;
}
function xR(e) {
  return Oe(this, null, function* () {
    return new Promise((r) => setTimeout(r, e));
  });
}
const BR = (e) => {
  let r;
  try {
    var t;
    r = (t = window.localStorage.getItem(e)) !== null && t !== void 0 ? t : pp(), window.localStorage.setItem(e, r);
  } catch (a) {
    r = pp();
  }
  return r;
}, l9 = () => ["localhost", "127.0.0.1", "", "::1"].includes(window.location.hostname), c9 = () => !l9() && window.location.protocol === "http:", u9 = () => {
  if (typeof window == "undefined") return "SERVER_SIDE_RENDERING";
  if (!document.referrer) return window.location.origin;
  try {
    return new URL(document.referrer).origin;
  } catch (e) {
    return window.location.origin;
  }
}, $R = (e, r, t, a, o) => {
  const l = e.map((u) => ({
    cameraID: u.deviceId,
    label: u.label,
    groupId: u.groupId,
    facing: u.facing === fn.user ? "front" : "back"
  }));
  return {
    platform: "Web",
    osVersion: "".concat(Kt.osVersion),
    sdkVersion: t,
    hostAppId: u9(),
    serviceUrl: a,
    userID: BR(AR),
    deviceModel: "".concat(Kt.osName, "/").concat(Kt.osVersion, " ").concat(Kt.browserName, "/").concat(Kt.fullBrowserVersion),
    hostAppVersion: "".concat(Kt.browserName, "/").concat(Kt.fullBrowserVersion),
    currentCameraInfo: {
      cameraID: r
    },
    cameraState: l
  };
};
var oe = Ys();
const dt = /* @__PURE__ */ Gs(oe);
function As(e, r, t) {
  return (r = f9(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function f9(e) {
  var r = d9(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function d9(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class p9 {
  constructor() {
    As(this, "_levels", []), As(this, "_transports", []), As(this, "_logs", []), As(this, "_prevTime", 0), As(this, "logListener", null);
    try {
      if (!window.localStorage) return;
      const r = window.localStorage.getItem("logger");
      if (!r) return;
      const [t, a] = r.split(">");
      this._levels = t.split(","), a && (this._transports = a.split(","));
    } catch (r) {
      return;
    }
  }
  create(r, t) {
    return (a) => {
      if (!this._levels.includes(r) && !this._levels.includes("all") && !this.logListener) return;
      const o = Date.now();
      let l = 0;
      if (this._prevTime && (l = o - this._prevTime), this._prevTime = o, this.logListener && this.logListener("".concat(r, ": ").concat(a, " +").concat(l, "ms")), this._transports.includes("console")) {
        const c = (t == null ? void 0 : t.color) || "blue";
        console.log("%c%s: %c%s %c+%dms", "color: ".concat(c, ";"), r, "", a, "color: ".concat(c, ";"), l);
      }
      this._transports.includes("file") && this._logs.push("".concat(r, ": ").concat(a, " +").concat(l, "ms"));
    };
  }
  saveLogs() {
    if (!this._logs.length) return;
    const r = this._logs.join(`
`), t = new Blob([r], {
      type: "text/plain"
    }), a = window.URL.createObjectURL(t), o = document.createElement("a");
    o.download = "log.txt", o.href = a, o.click(), window.URL.revokeObjectURL(a), this._logs = [];
  }
}
const Gr = new p9();
function JI(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Sn(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? JI(Object(t), !0).forEach(function(a) {
      h9(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : JI(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function h9(e, r, t) {
  return (r = _9(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function _9(e) {
  var r = m9(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function m9(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const ya = Gr.create("main");
function E9() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fn.environment, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ui.VGA, t = arguments.length > 2 ? arguments[2] : void 0;
  const [{
    status: a,
    stream: o,
    camera: l
  }, c] = oe.useState({
    status: Ft.PREPARING,
    stream: null,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    }
  }), [u, p] = oe.useState(null), [f, h] = oe.useState(null), C = oe.useRef(""), E = oe.useCallback(() => {
    c((m) => Sn(Sn({}, m), {}, {
      status: Ft.PLAY
    }));
  }, []);
  return oe.useEffect(() => {
    let m = !0;
    return VR().then((S) => {
      ya("Video devices: ".concat(JSON.stringify(S))), m && (ya(S.isCameraAllowed ? "Preparing the camera" : "Requesting the camera"), c((v) => Sn(Sn({}, v), {}, {
        status: S.isCameraAllowed ? Ft.PREPARING : Ft.REQUESTING
      })), p(S));
    }).catch((S) => {
      ya("Error in receiving media devices: ".concat(S)), m && c((v) => Sn(Sn({}, v), {}, {
        status: c9() ? Ft.HTTP_NOT_SUPPORTED : window.isSecureContext ? Ft.NOT_SUPPORTED : Ft.INSECURE_PAGE_CONTEXT
      }));
    }), () => {
      m = !1;
    };
  }, []), oe.useEffect(() => {
    let m = !0;
    if (!(!u || f))
      return kR(u).then((S) => {
        ya("Sorted cameras: ".concat(JSON.stringify(S))), m && h(S);
      }).catch((S) => {
        if (ya("Error sorting cameras: ".concat(S)), !!m) {
          if (S instanceof Error && S.name === gR)
            return c((v) => Sn(Sn({}, v), {}, {
              status: Ft.PERMISSION_DENIED
            }));
          c((v) => Sn(Sn({}, v), {}, {
            status: Ft.UNKNOWN_ERROR
          }));
        }
      }), () => {
        m = !1;
      };
  }, [u]), oe.useEffect(() => {
    let m = !0;
    const S = a === Ft.PREPARING || a === Ft.REQUESTING;
    return !f || !S ? void 0 : (Oe(null, null, function* () {
      try {
        const g = Kt.isFirefox ? RR : 0;
        yield xR(g);
        const O = FR(e, f, t), D = yield UR(r, O, t);
        if (ya("Selected camera: ".concat(JSON.stringify(O))), m)
          C.current = D.camera.deviceId, c(D);
        else {
          if (!D.stream) return;
          hp(D.stream);
        }
      } catch (g) {
        if (ya("Get video error: ".concat(g)), !m) return;
        c((O) => Sn(Sn({}, O), {}, {
          status: Ft.UNKNOWN_ERROR
        }));
      }
    }), () => {
      m = !1;
    });
  }, [f, e, t, a, r.width, r.height]), oe.useEffect(() => () => {
    o && hp(o);
  }, [o]), oe.useEffect(() => {
    if (!t || !C.current) return;
    const m = t !== C.current;
    a !== Ft.PLAY || !m || c({
      status: Ft.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    });
  }, [t, a]), {
    status: a,
    stream: o,
    camera: l,
    sortedDevices: f,
    onPlay: E
  };
}
const C9 = "_container_1hyic_1", S9 = "_video_1hyic_6", e6 = {
  container: C9,
  video: S9
};
function Un(e, r, t) {
  return (r = I9(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function I9(e) {
  var r = v9(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function v9(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const Ro = Gr.create("main");
class g9 {
  constructor() {
    Un(this, "chunks", []), Un(this, "recorder", null), Un(
      this,
      "mimeType",
      "video/webm"
      /* WEBM */
    ), Un(this, "record", null), Un(this, "delayTimeout", null), Un(this, "durationTimeout", null), Un(this, "isRecording", !1), Un(this, "debug", !1), Un(this, "delay", 0), Un(this, "bitrate", 12e5), Un(this, "duration", void 0);
  }
  init(r) {
    if (!("MediaRecorder" in window)) {
      Ro("MediaRecorder is missing");
      return;
    }
    this.mimeType = MediaRecorder.isTypeSupported(
      "video/webm"
      /* WEBM */
    ) ? "video/webm" : "video/mp4;codecs=avc1", this.recorder = new MediaRecorder(r, {
      mimeType: this.mimeType,
      videoBitsPerSecond: this.bitrate
    }), this.recorder.addEventListener("dataavailable", this.setChunk.bind(this)), this.recorder.addEventListener("error", this.errorHandle.bind(this)), this.delay ? this.delayTimeout = setTimeout(() => {
      this.delayTimeout = null, this.startRecording();
    }, this.delay) : this.startRecording(), this.duration && (this.durationTimeout = setTimeout(() => Oe(this, null, function* () {
      this.durationTimeout = null, this.record = yield this.getRecord();
    }), this.delay + this.duration)), Ro("MediaRecorder initialized: { duration: ".concat(this.duration, ", delay: ").concat(this.delay, ", mimeType: ").concat(this.mimeType, " }"));
  }
  startRecording() {
    this.recorder && (this.recorder.start(), this.isRecording = !0, Ro("Recording has started"));
  }
  clearTimeouts() {
    this.delayTimeout && clearTimeout(this.delayTimeout), this.durationTimeout && clearTimeout(this.durationTimeout);
  }
  getRecord() {
    return Oe(this, null, function* () {
      if (this.record) {
        const r = this.record;
        return this.record = null, r;
      }
      return !this.recorder || this.recorder.state === "inactive" ? null : (this.stopRecord(), new Promise((r) => {
        if (!this.recorder)
          return r(null);
        this.recorder.onstop = () => Oe(this, null, function* () {
          const t = yield this.getVideoData();
          Ro("Video record resolved"), r(t);
        });
      }));
    });
  }
  stopRecord() {
    var r, t, a;
    if (!this.recorder || this.recorder.state === "inactive") {
      this.clearTimeouts();
      return;
    }
    (r = this.recorder) === null || r === void 0 || r.stop(), (t = this.recorder) === null || t === void 0 || t.removeEventListener("dataavailable", this.setChunk), (a = this.recorder) === null || a === void 0 || a.removeEventListener("error", this.errorHandle), this.clearTimeouts(), this.isRecording = !1, Ro("Recording stopped");
  }
  errorHandle(r) {
    Ro("Stream recorder service error: ".concat(JSON.stringify(r)));
  }
  setChunk(r) {
    this.chunks.push(r.data);
  }
  getVideoData() {
    return Oe(this, null, function* () {
      const r = new Blob(this.chunks, {
        type: this.mimeType
      });
      if (this.debug) {
        const t = document.createElement("a"), a = URL.createObjectURL(r);
        t.href = a, t.download = "video", t.click(), URL.revokeObjectURL(a);
      }
      return new Promise((t) => {
        t({
          data: r,
          mimeType: r.type
        });
      });
    });
  }
}
const GR = oe.forwardRef(function(r, t) {
  let {
    onVideoStatusChange: a,
    onVideoSizeChange: o,
    mode: l,
    resolution: c,
    onFailStatus: u,
    cameraId: p,
    onRecordService: f,
    videoRecord: h,
    onVideoStarted: C,
    onVideoStopped: E,
    onMirroringChange: m,
    mirrorType: S = dp.mirror
  } = r;
  const {
    status: v,
    stream: g,
    camera: O,
    sortedDevices: D,
    onPlay: R
  } = E9(l, c, p), [T, N] = oe.useState(!1), b = oe.useRef(null), L = oe.useRef(null), k = oe.useRef(null), w = () => {
    R(), C == null || C();
  };
  return oe.useEffect(() => {
    N(O.facing === fn.user && S === dp.mirror);
  }, [O.facing, S]), oe.useEffect(() => {
    m == null || m(T);
  }, [T]), oe.useImperativeHandle(t, () => ({
    changeMirror: () => {
      N((V) => !V);
    }
  })), oe.useEffect(() => {
    const V = L.current, U = k.current, z = () => {
      !V || !U || o == null || o({
        videoElement: V,
        videoParams: {
          width: V.videoWidth,
          height: V.videoHeight
        },
        videoContainerParams: {
          width: U.clientWidth,
          height: U.clientHeight
        }
      });
    };
    return V && (window.addEventListener("resize", z), V.addEventListener("resize", z)), () => {
      var q;
      V && (window.removeEventListener("resize", z), V.removeEventListener("resize", z)), (q = b.current) === null || q === void 0 || q.stopRecord();
    };
  }, []), oe.useEffect(() => {
    const V = L.current;
    if (v === Ft.READY && V && g && (V.srcObject = g, Kt.isIOS ? setTimeout(() => V.play(), hy) : V.play(), h)) {
      if (b.current) {
        var W;
        (W = b.current) === null || W === void 0 || W.stopRecord();
      } else {
        const se = new g9();
        if (typeof h != "boolean") {
          var z, q;
          se.delay = (z = h.delay) !== null && z !== void 0 ? z : se.delay, se.duration = h.duration, se.bitrate = (q = h.bitrate) !== null && q !== void 0 ? q : se.bitrate, se.debug = !!h.debug;
        }
        b.current = se, f == null || f(se);
      }
      b.current.init(g);
    }
    const te = DR[v];
    u && te && u(te), a({
      videoStatus: v,
      camera: O,
      sortedDevices: D
    });
  }, [v, O, g, D, h]), /* @__PURE__ */ Y.jsx("div", { part: "webcamera-container", ref: k, className: e6.container, children: /* @__PURE__ */ Y.jsx("video", { part: "webcamera-video", onAbort: E, onLoadedData: w, className: e6.video, style: {
    transform: "scaleX(".concat(T ? -1 : 1, ")")
  }, ref: L, playsInline: !0, disablePictureInPicture: !0 }) });
}), R9 = "_container_bzjwi_1", D9 = "_layout_bzjwi_2", A9 = "_loader_bzjwi_19", T1 = {
  container: R9,
  layout: D9,
  loader: A9
};
function T9(e) {
  switch (e) {
    case it.SHAKING:
      return {
        icon: "processing-error-icon",
        title: "keepDeviceStill"
      };
    case it.FINDING:
      return {
        icon: "search-icon",
        title: "placeDocumentIntoFrame"
      };
    case it.SNAPSHOT:
      return {
        icon: "square-icon",
        title: "positionDocumentCenter"
      };
    case it.FOCUS:
      return {
        icon: "processing-error-icon",
        title: "noFocus"
      };
    case it.RESOLUTION:
      return {
        icon: "processing-error-icon",
        title: "moveCloser"
      };
    case it.GLARE:
      return {
        icon: "processing-error-icon",
        title: "glaresOnDocument"
      };
    case it.HOLD:
      return {
        icon: "processing-error-icon",
        title: "holdDocumentStraight"
      };
    default:
      return {
        icon: null,
        title: null
      };
  }
}
const O9 = "_svg_15k34_1", y9 = {
  svg: O9
}, N9 = Gr.create("main"), ZR = oe.createContext({
  onEvent: () => N9('Function "onEvent" not defined.')
}), ur = () => oe.useContext(ZR);
function L9(e) {
  let {
    layoutParams: r,
    maskParams: t,
    borderColor: a
  } = e;
  const {
    cameraFrameShapeType: o = Ns.line,
    cameraFrameLineCap: l = _R.butt,
    cameraFrameLineLength: c = JO,
    cameraFrameCornerRadius: u = QO
  } = ur(), [p, f] = oe.useState(null);
  return oe.useEffect(() => {
    if (o !== Ns.corners) return;
    const h = t.width / 100 * c, C = t.left + t.width - h - u, E = t.left + t.width, m = t.top + t.height - h - u, S = t.left + h + u, v = t.top + t.height, g = t.top + h + u;
    f({
      topRight: {
        x: C,
        y: t.top
      },
      bottomRight: {
        x: E,
        y: m
      },
      bottomLeft: {
        x: S,
        y: v
      },
      topLeft: {
        x: t.left,
        y: g
      },
      pathWidth: h
    });
  }, [o, t, c, u]), /* @__PURE__ */ Y.jsxs("svg", { part: "frame", className: y9.svg, xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid slice", viewBox: "0 0 ".concat(r.width, " ").concat(r.height), role: "img", "aria-label": "Document frame", children: [
    /* @__PURE__ */ Y.jsx("defs", { children: /* @__PURE__ */ Y.jsxs("mask", { id: "bgClip", children: [
      /* @__PURE__ */ Y.jsx("rect", { x: "0", y: "0", width: r.width, height: r.height, fill: "#fff", part: "frame-mask-background" }),
      /* @__PURE__ */ Y.jsx("rect", { x: t.left, y: t.top, rx: u, ry: u, width: t.width, height: t.height, stroke: "black", strokeWidth: t.stroke, part: "frame-mask-background-clip" })
    ] }) }),
    /* @__PURE__ */ Y.jsx("rect", { mask: "url(#bgClip)", x: "0", y: "0", width: r.width, height: r.height, fill: "black", part: "frame-external-background" }),
    o === Ns.corners && p && /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
      /* @__PURE__ */ Y.jsx("path", { d: "M".concat(p.topRight.x, ",").concat(p.topRight.y, " h").concat(p.pathWidth, " a").concat(u, ",").concat(u, " 0 0 1 ").concat(u, ",").concat(u, " v").concat(p.pathWidth), fill: "none", stroke: a, strokeWidth: t.stroke, strokeLinecap: l, part: "frame-top-right-corner" }),
      /* @__PURE__ */ Y.jsx("path", { d: "M".concat(p.bottomRight.x, ",").concat(p.bottomRight.y, " v").concat(p.pathWidth, " a").concat(u, ",").concat(u, " 0 0 1 ").concat(-u, ",").concat(u, " h-").concat(p.pathWidth), fill: "none", stroke: a, strokeWidth: t.stroke, strokeLinecap: l, part: "frame-bottom-right-corner" }),
      /* @__PURE__ */ Y.jsx("path", { d: "M".concat(p.bottomLeft.x, ",").concat(p.bottomLeft.y, " h-").concat(p.pathWidth, " a").concat(u, ",").concat(u, " 0 0 1 ").concat(-u, ",").concat(-u, " v-").concat(p.pathWidth), fill: "none", stroke: a, strokeWidth: t.stroke, strokeLinecap: l, part: "frame-bottom-left-corner" }),
      /* @__PURE__ */ Y.jsx("path", { d: "M".concat(p.topLeft.x, ",").concat(p.topLeft.y, " v-").concat(p.pathWidth, " a").concat(u, ",").concat(-u, " 0 0 1 ").concat(u, ",").concat(-u, " h").concat(p.pathWidth), fill: "none", stroke: a, strokeWidth: t.stroke, strokeLinecap: l, part: "frame-top-left-corner" })
    ] }),
    o === Ns.line && /* @__PURE__ */ Y.jsx("rect", { x: t.left, y: t.top, rx: u, ry: u, width: t.width, height: t.height, fill: "none", stroke: a, strokeWidth: t.stroke, part: "frame-line" })
  ] });
}
function _p() {
  return _p = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var a in t) ({}).hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, _p.apply(null, arguments);
}
function jR(e, r) {
  if (e == null) return {};
  var t = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (r.indexOf(a) !== -1) continue;
    t[a] = e[a];
  }
  return t;
}
function mp(e, r) {
  return mp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, a) {
    return t.__proto__ = a, t;
  }, mp(e, r);
}
function hh(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, mp(e, r);
}
function M9(e, r) {
  return e.classList ? !!r && e.classList.contains(r) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + r + " ") !== -1;
}
function P9(e, r) {
  e.classList ? e.classList.add(r) : M9(e, r) || (typeof e.className == "string" ? e.className = e.className + " " + r : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + r));
}
function t6(e, r) {
  return e.replace(new RegExp("(^|\\s)" + r + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function b9(e, r) {
  e.classList ? e.classList.remove(r) : typeof e.className == "string" ? e.className = t6(e.className, r) : e.setAttribute("class", t6(e.className && e.className.baseVal || "", r));
}
var w9 = Jg();
const E2 = /* @__PURE__ */ Gs(w9), r6 = {
  disabled: !1
}, _h = dt.createContext(null);
var zR = function(r) {
  return r.scrollTop;
}, Ms = "unmounted", Na = "exited", Rn = "entering", ci = "entered", Fs = "exiting", wi = /* @__PURE__ */ function(e) {
  hh(r, e);
  function r(a, o) {
    var l;
    l = e.call(this, a, o) || this;
    var c = o, u = c && !c.isMounting ? a.enter : a.appear, p;
    return l.appearStatus = null, a.in ? u ? (p = Na, l.appearStatus = Rn) : p = ci : a.unmountOnExit || a.mountOnEnter ? p = Ms : p = Na, l.state = {
      status: p
    }, l.nextCallback = null, l;
  }
  r.getDerivedStateFromProps = function(o, l) {
    var c = o.in;
    return c && l.status === Ms ? {
      status: Na
    } : null;
  };
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, t.componentDidUpdate = function(o) {
    var l = null;
    if (o !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== Rn && c !== ci && (l = Rn) : (c === Rn || c === ci) && (l = Fs);
    }
    this.updateStatus(!1, l);
  }, t.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, t.getTimeouts = function() {
    var o = this.props.timeout, l, c, u;
    return l = c = u = o, o != null && typeof o != "number" && (l = o.exit, c = o.enter, u = o.appear !== void 0 ? o.appear : c), {
      exit: l,
      enter: c,
      appear: u
    };
  }, t.updateStatus = function(o, l) {
    if (o === void 0 && (o = !1), l !== null)
      if (this.cancelNextCallback(), l === Rn) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : E2.findDOMNode(this);
          c && zR(c);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Na && this.setState({
      status: Ms
    });
  }, t.performEnter = function(o) {
    var l = this, c = this.props.enter, u = this.context ? this.context.isMounting : o, p = this.props.nodeRef ? [u] : [E2.findDOMNode(this), u], f = p[0], h = p[1], C = this.getTimeouts(), E = u ? C.appear : C.enter;
    if (!o && !c || r6.disabled) {
      this.safeSetState({
        status: ci
      }, function() {
        l.props.onEntered(f);
      });
      return;
    }
    this.props.onEnter(f, h), this.safeSetState({
      status: Rn
    }, function() {
      l.props.onEntering(f, h), l.onTransitionEnd(E, function() {
        l.safeSetState({
          status: ci
        }, function() {
          l.props.onEntered(f, h);
        });
      });
    });
  }, t.performExit = function() {
    var o = this, l = this.props.exit, c = this.getTimeouts(), u = this.props.nodeRef ? void 0 : E2.findDOMNode(this);
    if (!l || r6.disabled) {
      this.safeSetState({
        status: Na
      }, function() {
        o.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: Fs
    }, function() {
      o.props.onExiting(u), o.onTransitionEnd(c.exit, function() {
        o.safeSetState({
          status: Na
        }, function() {
          o.props.onExited(u);
        });
      });
    });
  }, t.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, t.safeSetState = function(o, l) {
    l = this.setNextCallback(l), this.setState(o, l);
  }, t.setNextCallback = function(o) {
    var l = this, c = !0;
    return this.nextCallback = function(u) {
      c && (c = !1, l.nextCallback = null, o(u));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, t.onTransitionEnd = function(o, l) {
    this.setNextCallback(l);
    var c = this.props.nodeRef ? this.props.nodeRef.current : E2.findDOMNode(this), u = o == null && !this.props.addEndListener;
    if (!c || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var p = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], f = p[0], h = p[1];
      this.props.addEndListener(f, h);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, t.render = function() {
    var o = this.state.status;
    if (o === Ms)
      return null;
    var l = this.props, c = l.children;
    l.in, l.mountOnEnter, l.unmountOnExit, l.appear, l.enter, l.exit, l.timeout, l.addEndListener, l.onEnter, l.onEntering, l.onEntered, l.onExit, l.onExiting, l.onExited, l.nodeRef;
    var u = jR(l, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ dt.createElement(_h.Provider, {
        value: null
      }, typeof c == "function" ? c(o, u) : dt.cloneElement(dt.Children.only(c), u))
    );
  }, r;
}(dt.Component);
wi.contextType = _h;
wi.propTypes = {};
function Do() {
}
wi.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Do,
  onEntering: Do,
  onEntered: Do,
  onExit: Do,
  onExiting: Do,
  onExited: Do
};
wi.UNMOUNTED = Ms;
wi.EXITED = Na;
wi.ENTERING = Rn;
wi.ENTERED = ci;
wi.EXITING = Fs;
var H9 = function(r, t) {
  return r && t && t.split(" ").forEach(function(a) {
    return P9(r, a);
  });
}, O1 = function(r, t) {
  return r && t && t.split(" ").forEach(function(a) {
    return b9(r, a);
  });
}, mh = /* @__PURE__ */ function(e) {
  hh(r, e);
  function r() {
    for (var a, o = arguments.length, l = new Array(o), c = 0; c < o; c++)
      l[c] = arguments[c];
    return a = e.call.apply(e, [this].concat(l)) || this, a.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, a.onEnter = function(u, p) {
      var f = a.resolveArguments(u, p), h = f[0], C = f[1];
      a.removeClasses(h, "exit"), a.addClass(h, C ? "appear" : "enter", "base"), a.props.onEnter && a.props.onEnter(u, p);
    }, a.onEntering = function(u, p) {
      var f = a.resolveArguments(u, p), h = f[0], C = f[1], E = C ? "appear" : "enter";
      a.addClass(h, E, "active"), a.props.onEntering && a.props.onEntering(u, p);
    }, a.onEntered = function(u, p) {
      var f = a.resolveArguments(u, p), h = f[0], C = f[1], E = C ? "appear" : "enter";
      a.removeClasses(h, E), a.addClass(h, E, "done"), a.props.onEntered && a.props.onEntered(u, p);
    }, a.onExit = function(u) {
      var p = a.resolveArguments(u), f = p[0];
      a.removeClasses(f, "appear"), a.removeClasses(f, "enter"), a.addClass(f, "exit", "base"), a.props.onExit && a.props.onExit(u);
    }, a.onExiting = function(u) {
      var p = a.resolveArguments(u), f = p[0];
      a.addClass(f, "exit", "active"), a.props.onExiting && a.props.onExiting(u);
    }, a.onExited = function(u) {
      var p = a.resolveArguments(u), f = p[0];
      a.removeClasses(f, "exit"), a.addClass(f, "exit", "done"), a.props.onExited && a.props.onExited(u);
    }, a.resolveArguments = function(u, p) {
      return a.props.nodeRef ? [a.props.nodeRef.current, u] : [u, p];
    }, a.getClassNames = function(u) {
      var p = a.props.classNames, f = typeof p == "string", h = f && p ? p + "-" : "", C = f ? "" + h + u : p[u], E = f ? C + "-active" : p[u + "Active"], m = f ? C + "-done" : p[u + "Done"];
      return {
        baseClassName: C,
        activeClassName: E,
        doneClassName: m
      };
    }, a;
  }
  var t = r.prototype;
  return t.addClass = function(o, l, c) {
    var u = this.getClassNames(l)[c + "ClassName"], p = this.getClassNames("enter"), f = p.doneClassName;
    l === "appear" && c === "done" && f && (u += " " + f), c === "active" && o && zR(o), u && (this.appliedClasses[l][c] = u, H9(o, u));
  }, t.removeClasses = function(o, l) {
    var c = this.appliedClasses[l], u = c.base, p = c.active, f = c.done;
    this.appliedClasses[l] = {}, u && O1(o, u), p && O1(o, p), f && O1(o, f);
  }, t.render = function() {
    var o = this.props;
    o.classNames;
    var l = jR(o, ["classNames"]);
    return /* @__PURE__ */ dt.createElement(wi, _p({}, l, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, r;
}(dt.Component);
mh.defaultProps = {
  classNames: ""
};
mh.propTypes = {};
var C2, S2;
function V9(e, r) {
  return !(e === r || dt.isValidElement(e) && dt.isValidElement(r) && e.key != null && e.key === r.key);
}
var Po = {
  out: "out-in",
  in: "in-out"
}, $2 = function(r, t, a) {
  return function() {
    var o;
    r.props[t] && (o = r.props)[t].apply(o, arguments), a();
  };
}, k9 = (C2 = {}, C2[Po.out] = function(e) {
  var r = e.current, t = e.changeState;
  return dt.cloneElement(r, {
    in: !1,
    onExited: $2(r, "onExited", function() {
      t(Rn, null);
    })
  });
}, C2[Po.in] = function(e) {
  var r = e.current, t = e.changeState, a = e.children;
  return [r, dt.cloneElement(a, {
    in: !0,
    onEntered: $2(a, "onEntered", function() {
      t(Rn);
    })
  })];
}, C2), F9 = (S2 = {}, S2[Po.out] = function(e) {
  var r = e.children, t = e.changeState;
  return dt.cloneElement(r, {
    in: !0,
    onEntered: $2(r, "onEntered", function() {
      t(ci, dt.cloneElement(r, {
        in: !0
      }));
    })
  });
}, S2[Po.in] = function(e) {
  var r = e.current, t = e.children, a = e.changeState;
  return [dt.cloneElement(r, {
    in: !1,
    onExited: $2(r, "onExited", function() {
      a(ci, dt.cloneElement(t, {
        in: !0
      }));
    })
  }), dt.cloneElement(t, {
    in: !0
  })];
}, S2), Eh = /* @__PURE__ */ function(e) {
  hh(r, e);
  function r() {
    for (var a, o = arguments.length, l = new Array(o), c = 0; c < o; c++)
      l[c] = arguments[c];
    return a = e.call.apply(e, [this].concat(l)) || this, a.state = {
      status: ci,
      current: null
    }, a.appeared = !1, a.changeState = function(u, p) {
      p === void 0 && (p = a.state.current), a.setState({
        status: u,
        current: p
      });
    }, a;
  }
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.appeared = !0;
  }, r.getDerivedStateFromProps = function(o, l) {
    return o.children == null ? {
      current: null
    } : l.status === Rn && o.mode === Po.in ? {
      status: Rn
    } : l.current && V9(l.current, o.children) ? {
      status: Fs
    } : {
      current: dt.cloneElement(o.children, {
        in: !0
      })
    };
  }, t.render = function() {
    var o = this.props, l = o.children, c = o.mode, u = this.state, p = u.status, f = u.current, h = {
      children: l,
      current: f,
      changeState: this.changeState,
      status: p
    }, C;
    switch (p) {
      case Rn:
        C = F9[c](h);
        break;
      case Fs:
        C = k9[c](h);
        break;
      case ci:
        C = f;
    }
    return /* @__PURE__ */ dt.createElement(_h.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, C);
  }, r;
}(dt.Component);
Eh.propTypes = {};
Eh.defaultProps = {
  mode: Po.out
};
const U9 = "_message_13yzs_10", x9 = "_icon_13yzs_45", B9 = "_title_13yzs_96", $9 = "_copyright_13yzs_103", sn = {
  "hint-container": "_hint-container_13yzs_1",
  "tips-frameless": "_tips-frameless_13yzs_10",
  message: U9,
  "fade-enter": "_fade-enter_13yzs_14",
  "fade-exit": "_fade-exit_13yzs_18",
  "fade-enter-active": "_fade-enter-active_13yzs_22",
  "fade-exit-active": "_fade-exit-active_13yzs_26",
  "message-container": "_message-container_13yzs_35",
  icon: x9,
  "processing-error-icon": "_processing-error-icon_13yzs_61",
  "search-icon": "_search-icon_13yzs_67",
  "square-icon": "_square-icon_13yzs_73",
  "message-background": "_message-background_13yzs_88",
  title: B9,
  copyright: $9
};
var Ps = { exports: {} }, G9 = Ps.exports, n6;
function Z9() {
  return n6 || (n6 = 1, function(e, r) {
    (function(t, a) {
      a(r, Ys());
    })(G9, function(t, a) {
      var o = "default" in a ? a.default : a;
      function l(S) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
          return typeof v;
        } : function(v) {
          return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
        })(S);
      }
      var c = {}, u = "[LOCALIZE-REACT]: There are no translations for specified locale", p = "[LOCALIZE-REACT] Looks like template is being used, but no value passed for ", f = /{{([^{]+[^}])}}/g;
      function h(S, v) {
        if (!v || Object.keys(v).length === 0) return S;
        var g, O, D, R = S.match(f);
        return R && R.length !== 0 ? (g = R, O = v, D = Object.keys(O), g.map(function(T) {
          var N = Array.prototype.slice.call(T, 2, -2).join(""), b = D.find(function(L) {
            return L === N;
          });
          return b ? [T, O[b]] : (console.warn(p, T), [T, T]);
        })).reduce(function(T, N) {
          var b = new RegExp(N[0], "gi");
          return T.replace(b, N[1]);
        }, S) : S;
      }
      var C = o.createContext(), E = C.Consumer;
      function m() {
        return a.useContext(C);
      }
      t.LocalizationConsumer = E, t.LocalizationContext = C, t.LocalizationProvider = function(S) {
        var v = S.children, g = S.disableCache, O = S.locale, D = S.translations, R = D === void 0 ? {} : D, T = function(w, V) {
          if (!w) return null;
          if (l(V[w]) === "object") return w;
          var U = w.toLowerCase().replace(/-/g, "_");
          if (l(V[U]) === "object") return U;
          var z = U.split("_")[0];
          return l(V[z]) === "object" ? z : (console.warn(u, w), w);
        }(O, R), N = T ? R[T] : R;
        function b(w, V, U) {
          if (!N || !w) return U || w;
          var z = typeof U == "string" ? U : w, q = N[w];
          if (typeof q == "string") return V ? h(q, V) : q;
          var W = w.split(".");
          if (W.length === 1) return h(z, V);
          for (var te = N[W[0]], se = 1; se < W.length; se++) te = te && te[W[se]];
          return h(typeof te == "string" ? te : z, V);
        }
        a.useEffect(function() {
          c = {};
        }, [O, R]);
        var L, k = g ? b : (L = b, function(w, V, U) {
          var z = 2 < arguments.length && U !== void 0 ? U : "", q = V ? JSON.stringify(V, null, "") + w + z : w + z;
          if (c[q]) return c[q];
          var W = L(w, V, z);
          return c[q] = W;
        });
        return o.createElement(C.Provider, { value: { locale: O, translate: k, translations: R } }, v);
      }, t.Message = function(S) {
        var v = S.defaultMessage, g = S.descriptor, O = S.values;
        return (0, m().translate)(g, O, v);
      }, t.useLocalize = m, Object.defineProperty(t, "__esModule", { value: !0 });
    });
  }(Ps, Ps.exports)), Ps.exports;
}
var oa = Z9();
const j9 = "_copyright_6b3ik_1", z9 = {
  copyright: j9
}, q9 = "data:image/svg+xml,%3csvg%20width='39'%20height='13'%20viewBox='0%200%2039%2013'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.88952%205.98264C6.70681%205.48369%207.28459%204.49575%207.28459%203.40906C7.28459%201.34699%205.65607%200%203.60916%200C1.56225%200%200%201.34743%200%203.67543V5.42175H1.49815V3.675C1.49815%202.27819%202.44624%201.49642%203.61046%201.49642C4.77468%201.49642%205.60583%202.29465%205.60583%203.40906C5.60583%204.52347%204.70798%205.42132%203.54376%205.42132H1.49815V9.21326H2.995V6.75186H3.57711C5.04061%206.75186%206.00516%207.88272%206.03851%209.21326H7.60163C7.57391%207.89658%206.94373%206.56778%205.89082%205.98264'%20fill='%23BD7DFF'/%3e%3cpath%20d='M37.5857%202.6262V3.57429C37.1863%202.97573%2036.4877%202.57812%2035.4902%202.57812C33.6608%202.57812%2032.2969%204.04163%2032.2969%205.92092C32.2969%207.78332%2033.6608%209.26371%2035.4902%209.26371C36.4379%209.26371%2037.1201%208.88127%2037.5857%208.29916V9.21391H38.9994V2.6262H37.5857ZM35.6566%207.83183C34.592%207.83183%2033.8271%207.00025%2033.8271%205.91919C33.8271%204.83813%2034.592%204.00654%2035.6566%204.00654C36.7212%204.00654%2037.5025%204.83813%2037.5025%205.91919C37.5025%207.00025%2036.7229%207.83183%2035.6566%207.83183Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M27.5078%206.0384C27.5078%207.33559%2026.8426%207.81808%2025.9945%207.81808C25.1465%207.81808%2024.4812%207.33559%2024.4812%206.0384V2.62891H22.9844V5.9717C22.9844%208.16717%2024.1152%209.26339%2025.9945%209.26339C27.8738%209.26339%2029.0047%208.16587%2029.0047%205.9717V2.62891H27.5078V6.0384Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M11.2922%202.57812C9.44578%202.57812%208.01562%204.09143%208.01562%205.93781C8.01562%207.78419%209.44491%209.26371%2011.342%209.26371C12.4893%209.26371%2013.3209%208.86481%2014.003%208.14974L13.1879%207.18519C12.7388%207.58409%2012.1735%207.86691%2011.3753%207.86691C10.5771%207.86691%209.82865%207.46758%209.59693%206.60264H14.5184C14.578%206.34086%2014.6059%206.07286%2014.6016%205.80441C14.6016%203.94201%2013.1381%202.57812%2011.2922%202.57812ZM9.51248%205.42197C9.71214%204.55574%2010.4437%203.97536%2011.3749%203.97536C12.3061%203.97536%2012.938%204.54058%2013.1212%205.42197H9.51248Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M31.4988%200.0664062H30.002V9.2134H31.4988V0.0664062Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M20.572%203.57429C20.2394%203.00864%2019.4745%202.57812%2018.4766%202.57812C16.7302%202.57812%2015.2832%204.04163%2015.2832%205.92092C15.2832%207.78332%2016.7302%209.21261%2018.4766%209.21261C19.4247%209.21261%2020.0232%208.92978%2020.4888%208.34637V8.94537C20.4888%2010.2426%2019.5741%2010.7082%2018.6927%2010.7082C17.8113%2010.7082%2017.1127%2010.275%2016.9797%209.32782H15.5162C15.5829%2010.991%2016.913%2012.0565%2018.6927%2012.0565C20.4724%2012.0565%2021.9844%2011.0421%2021.9844%208.84662V2.6262H20.572V3.57429ZM18.6429%207.78202C17.5783%207.78202%2016.8134%207.00025%2016.8134%205.91962C16.8134%204.839%2017.5783%204.00698%2018.6429%204.00698C19.7075%204.00698%2020.4888%204.83856%2020.4888%205.91962C20.4888%207.00068%2019.7071%207.78202%2018.6429%207.78202Z'%20fill='%23BD7DFF'/%3e%3c/svg%3e";
function qR(e) {
  let {
    className: r
  } = e;
  const {
    copyright: t = !0
  } = ur();
  return t ? /* @__PURE__ */ Y.jsxs("div", { part: "container-copyright", className: "".concat(z9.copyright, " ").concat(r != null ? r : ""), children: [
    /* @__PURE__ */ Y.jsx("span", { "data-e2e": "powered-by", children: "Powered by" }),
    " ",
    /* @__PURE__ */ Y.jsx("img", { src: q9, alt: "regula-logo" })
  ] }) : null;
}
function Ep(e) {
  switch (e) {
    case lr.Unknown:
      return "id-front-icon";
    case lr.PassportSinglePage:
      return "passport-single-icon";
    case lr.PassportTwoPages:
      return "passport-both-pages-icon";
    case lr.IDFront:
      return "id-front-icon";
    case lr.IDFrontMRZ:
      return "id-mrz-front-icon";
    case lr.IDBack:
      return "id-back-icon";
    case lr.IDBackMrz:
      return "id-mrz-back-icon";
    case lr.IDBackBarcode:
      return "id-barcode-back-icon";
    case lr.IDBackBarcodeMRZ:
      return "id-mrz-barcode-back-icon";
    case lr.BankCardFront:
      return "bank-card-front-icon";
    case lr.BankCardBack:
      return "bank-card-back-icon";
    case lr.DocumentFront:
      return "document-front-icon";
    case lr.DocumentBack:
      return "document-back-icon";
    default:
      return "id-front-icon";
  }
}
function W9(e) {
  switch (e) {
    case yo.Horizontal:
      return "horizontal";
    case yo.Vertical:
      return "vertical";
    case yo.LeftBottomRightTop:
      return "left-bottom-right-top";
    case yo.RightBottomLeftTop:
      return "right-bottom-left-top";
    default:
      return "";
  }
}
const Y9 = "_announcer_1qj2e_1", K9 = {
  announcer: Y9
};
function Us(e) {
  let {
    text: r,
    timeout: t = 100
  } = e;
  const [a, o] = oe.useState("");
  return oe.useEffect(() => {
    if (!r) return;
    o("");
    const l = setTimeout(() => {
      o(r);
    }, t);
    return () => {
      clearTimeout(l);
    };
  }, [r, t]), /* @__PURE__ */ Y.jsx("div", { role: "status", "aria-live": "assertive", className: K9.announcer, children: a });
}
const X9 = "_tilt_e1bzj_1", Q9 = "_vertical_e1bzj_19", J9 = "_horizontal_e1bzj_23", y1 = {
  tilt: X9,
  vertical: Q9,
  horizontal: J9,
  "left-bottom-right-top": "_left-bottom-right-top_e1bzj_27",
  "right-bottom-left-top": "_right-bottom-left-top_e1bzj_31",
  "id-front-icon": "_id-front-icon_e1bzj_35",
  "passport-single-icon": "_passport-single-icon_e1bzj_39",
  "passport-both-pages-icon": "_passport-both-pages-icon_e1bzj_43",
  "id-mrz-front-icon": "_id-mrz-front-icon_e1bzj_47",
  "id-back-icon": "_id-back-icon_e1bzj_51",
  "id-mrz-back-icon": "_id-mrz-back-icon_e1bzj_55",
  "id-barcode-back-icon": "_id-barcode-back-icon_e1bzj_59",
  "id-mrz-barcode-back-icon": "_id-mrz-barcode-back-icon_e1bzj_63",
  "bank-card-front-icon": "_bank-card-front-icon_e1bzj_67",
  "bank-card-back-icon": "_bank-card-back-icon_e1bzj_71",
  "document-front-icon": "_document-front-icon_e1bzj_75",
  "document-back-icon": "_document-back-icon_e1bzj_79"
}, eN = oe.forwardRef(function(r, t) {
  var a, o, l;
  let {
    holoData: c
  } = r;
  const u = Ep((a = c == null ? void 0 : c.livenessAnimationImage) !== null && a !== void 0 ? a : lr.IDFront), p = (o = c == null ? void 0 : c.hologramTiltType) !== null && o !== void 0 ? o : yo.Vertical;
  return /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
    /* @__PURE__ */ Y.jsx(Us, { text: "Tilt the document" }),
    /* @__PURE__ */ Y.jsx("div", { part: "hint-holo-".concat(u), className: "".concat(y1.tilt, " ").concat(y1[W9(p)], " ").concat((l = y1[u]) !== null && l !== void 0 ? l : ""), ref: t, role: "img", "aria-label": "Document tilt animation" })
  ] });
}), tN = "_flip_194nz_1", rN = "_front_194nz_10", nN = "_back_194nz_11", iN = "_slide_194nz_22", Xi = {
  flip: tN,
  "one-side": "_one-side_194nz_2",
  front: rN,
  back: nN,
  slide: iN,
  "flip-front": "_flip-front_194nz_1",
  "flip-back": "_flip-back_194nz_1",
  "id-front-icon": "_id-front-icon_194nz_51",
  "passport-single-icon": "_passport-single-icon_194nz_55",
  "passport-both-pages-icon": "_passport-both-pages-icon_194nz_59",
  "id-mrz-front-icon": "_id-mrz-front-icon_194nz_63",
  "id-back-icon": "_id-back-icon_194nz_67",
  "id-mrz-back-icon": "_id-mrz-back-icon_194nz_71",
  "id-barcode-back-icon": "_id-barcode-back-icon_194nz_75",
  "id-mrz-barcode-back-icon": "_id-mrz-barcode-back-icon_194nz_79",
  "bank-card-front-icon": "_bank-card-front-icon_194nz_83",
  "bank-card-back-icon": "_bank-card-back-icon_194nz_87",
  "document-front-icon": "_document-front-icon_194nz_91",
  "document-back-icon": "_document-back-icon_194nz_95"
};
var N1, i6;
function aN() {
  if (i6) return N1;
  i6 = 1;
  function e(r) {
    return r && r.length ? r[0] : void 0;
  }
  return N1 = e, N1;
}
var L1, a6;
function oN() {
  return a6 || (a6 = 1, L1 = aN()), L1;
}
var sN = oN();
const G2 = /* @__PURE__ */ Gs(sN), lN = oe.forwardRef(function(r, t) {
  var a, o, l, c;
  let {
    animationImage: u
  } = r;
  const {
    nextPageAnimationStartDelay: p = CR
  } = ur(), f = (u == null ? void 0 : u.length) === 1, h = f && G2(u) === lr.PassportTwoPages, C = Ep((a = G2(u)) !== null && a !== void 0 ? a : lr.DocumentFront), E = {
    "--animation-delay": p + "ms",
    "--animation-duration": ER + "ms"
  };
  if (f) {
    var m;
    return /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
      /* @__PURE__ */ Y.jsx(Us, { text: "Slide the document" }),
      /* @__PURE__ */ Y.jsx("div", { ref: t, className: "".concat(Xi["one-side"], " ").concat(h ? Xi.slide : "", " ").concat((m = Xi[C]) !== null && m !== void 0 ? m : ""), style: E, role: "img", "aria-label": "Document slide animation" })
    ] });
  }
  const S = Ep((o = u == null ? void 0 : u[1]) !== null && o !== void 0 ? o : lr.DocumentBack);
  return /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
    /* @__PURE__ */ Y.jsx(Us, { text: "Flip the document" }),
    /* @__PURE__ */ Y.jsxs("div", { ref: t, className: Xi.flip, style: E, role: "img", "aria-label": "Document flip animation", part: "hint-next-page-icon", children: [
      /* @__PURE__ */ Y.jsx("div", { part: "hint-next-page-front-".concat(C), className: "".concat(Xi.front, " ").concat((l = Xi[C]) !== null && l !== void 0 ? l : "") }),
      /* @__PURE__ */ Y.jsx("div", { part: "hint-next-page-back-".concat(S), className: "".concat(Xi.back, " ").concat((c = Xi[S]) !== null && c !== void 0 ? c : "") })
    ] })
  ] });
}), cN = oe.forwardRef(function(r, t) {
  let {
    animation: a,
    animationImage: o,
    holoData: l
  } = r;
  return a === ks.Tilt ? /* @__PURE__ */ Y.jsx(eN, { holoData: l, ref: t }) : a === ks.Flip ? /* @__PURE__ */ Y.jsx(lN, { animationImage: o, ref: t }) : null;
});
function uN(e, r) {
  return e === it.START_NEXT_PAGE ? ks.Flip : r ? ks.Tilt : null;
}
function fN(e) {
  var r;
  let {
    status: t,
    icon: a,
    title: o,
    maskParams: l,
    animationImage: c,
    holoData: u,
    layoutParams: p,
    controlsWidth: f,
    isLandscape: h
  } = e;
  const {
    statusIcon: C = !0,
    statusPositionMultiplier: E,
    activityIndicatorPortraitPositionMultiplier: m,
    activityIndicatorLandscapePositionMultiplier: S
  } = ur(), v = oe.useRef(null), g = oe.useRef(null), O = oe.useRef(null), D = oe.useRef(null), R = oe.useRef(null), T = h && l == null, N = "".concat(sn["hint-container"], " ").concat(T ? sn["tips-frameless"] : ""), b = uN(t, u), {
    translate: L
  } = oa.useLocalize();
  return oe.useEffect(() => {
    var k, w;
    const V = g.current;
    if (!V || !p) return;
    V.style.width = "".concat(l ? l.width - (l.stroke || 0) : p.width - f, "px"), V.style.height = "".concat(l ? l.height - (l.stroke || 0) : p.height, "px"), V.style.top = "".concat(l ? l.top + (l.stroke || 0) / 2 : 0, "px"), V.style.left = "".concat(l ? l.left + (l.stroke || 0) / 2 : f, "px");
    const U = E !== void 0, z = m !== void 0 || S !== void 0, q = ((k = l == null ? void 0 : l.height) !== null && k !== void 0 ? k : p.height) / 2 + ((w = l == null ? void 0 : l.top) !== null && w !== void 0 ? w : 0), W = (te, se, le) => {
      te.style.setProperty(se, "".concat(le, "px"));
    };
    if (U && R.current) {
      const te = R.current.clientHeight, se = (p.height - te) / 2 * E - q;
      W(V, "--message-top", se);
    }
    if (z && D.current) {
      const te = D.current.clientHeight, le = p.width > p.height ? S : m;
      if (le !== void 0) {
        const B = (p.height - te) / 2 * le - q;
        W(V, "--indicator-top", B);
      }
    }
  }, [E, l, p, f, m, S]), /* @__PURE__ */ Y.jsxs("div", { part: "hint-container", ref: g, className: N, children: [
    /* @__PURE__ */ Y.jsx(Eh, { children: /* @__PURE__ */ Y.jsx(mh, { nodeRef: b ? v : O, classNames: {
      enter: sn["fade-enter"],
      enterActive: sn["fade-enter-active"],
      exit: sn["fade-exit"],
      exitActive: sn["fade-exit-active"]
    }, timeout: 300, children: b ? /* @__PURE__ */ Y.jsx(cN, { animation: b, animationImage: c, holoData: u, ref: v }) : /* @__PURE__ */ Y.jsxs("div", { part: "hint-status-message-container", ref: O, className: sn["message-container"], children: [
      C && !!a && /* @__PURE__ */ Y.jsx("div", { role: "img", "aria-label": "Status icon", part: "hint-status-".concat(a), ref: D, className: "".concat(sn.icon, " ").concat((r = sn[a]) !== null && r !== void 0 ? r : "") }),
      !!o && /* @__PURE__ */ Y.jsx("div", { part: "hint-status-message", ref: R, className: sn.message, children: /* @__PURE__ */ Y.jsx("div", { part: "hint-status-message-background", className: sn["message-background"], children: /* @__PURE__ */ Y.jsx("p", { role: "status", "aria-live": "assertive", part: "hint-status-message-title", className: sn.title, children: L(o) }) }) })
    ] }) }, b ? "document-animation" : "message-container") }),
    /* @__PURE__ */ Y.jsx(qR, { className: sn.copyright })
  ] });
}
const xn = {
  "top-functional-buttons": "_top-functional-buttons_1ua8y_1",
  "bottom-functional-buttons": "_bottom-functional-buttons_1ua8y_2",
  "left-functional-buttons": "_left-functional-buttons_1ua8y_3",
  "skip-button": "_skip-button_1ua8y_51",
  "controls-container": "_controls-container_1ua8y_57",
  "process-close-button": "_process-close-button_1ua8y_65",
  "process-button": "_process-button_1ua8y_71",
  "snapshot-button": "_snapshot-button_1ua8y_77",
  "mirror-back-button": "_mirror-back-button_1ua8y_89",
  "mirror-front-button": "_mirror-front-button_1ua8y_95",
  "change-camera-button": "_change-camera-button_1ua8y_101"
};
function dN(e) {
  let {
    mirroring: r,
    isSkipButtonVisible: t,
    isChangeCameraAvailable: a,
    isLandscape: o,
    onClose: l,
    onChangeCamera: c,
    onChangeMirroring: u,
    captureButton: p = !0,
    facing: f,
    onSnapshotProcess: h,
    onCameraSnapshot: C,
    onSkip: E,
    onControlsWidth: m
  } = e;
  const {
    closeButton: S = !0,
    skipButton: v = !0,
    mirrorButton: g = !1,
    changeCameraButton: O,
    captureButtonDelay: D
  } = ur(), [R, T] = oe.useState(D === void 0), N = oe.useRef(null), b = oe.useRef(null), L = oe.useRef(null), k = h && p && R, w = t && v, V = f !== fn.environment && g, U = a && O, z = S, q = k || C || w, W = V || U;
  return oe.useEffect(() => {
    var te, se, le;
    const B = ((te = N.current) === null || te === void 0 ? void 0 : te.offsetWidth) || 0, J = ((se = b.current) === null || se === void 0 ? void 0 : se.offsetWidth) || 0, Q = ((le = L.current) === null || le === void 0 ? void 0 : le.offsetWidth) || 0, P = o ? Math.max(B, J, Q) : 0;
    m(P);
  }, [z, q, W, o]), oe.useEffect(() => {
    if (typeof D != "number") return;
    const te = setTimeout(() => {
      T(!0);
    }, D * 1e3);
    return () => {
      clearTimeout(te);
    };
  }, [D]), !z && !q && !W ? null : /* @__PURE__ */ Y.jsxs("div", { part: "controls-container", className: xn["controls-container"], "data-orientation": o ? "landscape" : "portrait", children: [
    z && /* @__PURE__ */ Y.jsx("div", { part: "controls-top-buttons", className: xn["top-functional-buttons"], ref: N, children: S && /* @__PURE__ */ Y.jsx("button", { part: "controls-process-close-button", className: xn["process-close-button"], onClick: l, "aria-label": "Close processing" }) }),
    q && /* @__PURE__ */ Y.jsxs("div", { part: "controls-left-buttons", className: xn["left-functional-buttons"], ref: b, children: [
      k && /* @__PURE__ */ Y.jsx("button", { part: "controls-process-button", className: xn["process-button"], onClick: h, "aria-label": "Process the frame" }),
      C && /* @__PURE__ */ Y.jsx("button", { part: "controls-snapshot-button", className: xn["snapshot-button"], onClick: C, "aria-label": "Take a snapshot" }),
      w && /* @__PURE__ */ Y.jsx("button", { "aria-label": "Skip the page", part: "controls-skip-button", className: xn["skip-button"], onClick: E })
    ] }),
    W && /* @__PURE__ */ Y.jsxs("div", { part: "controls-bottom-buttons", className: xn["bottom-functional-buttons"], ref: L, children: [
      U && /* @__PURE__ */ Y.jsx("button", { part: "controls-change-camera-button", className: xn["change-camera-button"], onClick: c, "aria-label": "Change the camera" }),
      V && /* @__PURE__ */ Y.jsx("button", { part: "controls-mirror-button", className: r ? xn["mirror-back-button"] : xn["mirror-front-button"], onClick: u, "aria-label": "Flip horizontally" })
    ] })
  ] });
}
const pN = "_spinner_1vpw0_1", hN = "_message_1vpw0_51", M1 = {
  spinner: pN,
  "process-message": "_process-message_1vpw0_41",
  message: hN
};
function Js(e) {
  let {
    title: r
  } = e;
  const {
    translate: t
  } = oa.useLocalize();
  return /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
    /* @__PURE__ */ Y.jsx(Us, { text: r || t("pleaseWait") }),
    /* @__PURE__ */ Y.jsxs("div", { part: "processing-container", className: M1["process-message"], children: [
      /* @__PURE__ */ Y.jsx("div", { role: "img", "aria-label": "Spinner", part: "spinner-container", className: M1.spinner, children: /* @__PURE__ */ Y.jsx("div", { part: "spinner-circle" }) }),
      /* @__PURE__ */ Y.jsx("span", { part: "processing-message", className: M1.message, children: r || t("pleaseWait") })
    ] })
  ] });
}
const _N = "_window_m3xyu_14", mN = "_header_m3xyu_36", EN = "_footer_m3xyu_57", I2 = {
  window: _N,
  header: mN,
  footer: EN,
  "close-button": "_close-button_m3xyu_63"
};
function Ch(e) {
  let {
    onClose: r,
    children: t,
    direction: a,
    showHeaderAndFooter: o = !0,
    className: l
  } = e;
  const {
    closeButton: c = !0
  } = ur();
  return /* @__PURE__ */ Y.jsxs("div", { part: "container", className: "".concat(I2.window, " ").concat(l != null ? l : ""), "data-direction": a, children: [
    o && /* @__PURE__ */ Y.jsx("div", { part: "container-header", className: I2.header, children: c && /* @__PURE__ */ Y.jsx("button", { part: "container-close-button", className: I2["close-button"], "data-e2e": "cross", onClick: r, "aria-label": "Close document reader component" }) }),
    t,
    o && /* @__PURE__ */ Y.jsx("div", { part: "container-footer", className: I2.footer, children: /* @__PURE__ */ Y.jsx(qR, {}) })
  ] });
}
function WR(e) {
  let {
    status: r,
    children: t,
    mirroring: a,
    onChangeMirroring: o,
    onChangeCamera: l,
    videoStatusParams: c,
    videoElementParams: u,
    onProcessClose: p,
    onClose: f,
    holoData: h,
    onSnapshotProcess: C,
    onCameraSnapshot: E,
    onSkip: m,
    frameParams: S,
    captureButton: v,
    animationImage: g,
    onControlsWidth: O
  } = e;
  const {
    cameraFrameBorderWidth: D = XO,
    cameraFrame: R = !0,
    cameraFrameDefaultColor: T = ey,
    cameraFrameActiveColor: N = ty
  } = ur(), b = oe.useRef(null), [L, k] = oe.useState(!1), [w, V] = oe.useState(null), [U, z] = oe.useState(null), [q, W] = oe.useState(0), te = !!(c.sortedDevices && c.sortedDevices.frontCameras.length + c.sortedDevices.backCameras.length > py), se = r === it.HOLD || r === it.FOCUS || r === it.RESOLUTION || r === it.PROCESSING || r === it.GLARE, le = r !== it.SERVICE_PREPARING, B = se ? N : T, J = c.videoStatus === Ft.PLAY, {
    icon: Q,
    title: P
  } = T9(r), $ = u.videoParams.width > u.videoParams.height;
  return oe.useEffect(() => {
    r === it.START_NEXT_PAGE && k(!0);
  }, [r]), oe.useEffect(() => {
    const ce = b.current;
    if (!J || !ce || !le) return;
    const {
      width: ue,
      height: ie,
      top: Re,
      left: Ae,
      right: Ce
    } = QI(u.videoParams.width, u.videoParams.height, u.videoContainerParams.width, u.videoContainerParams.height, u.videoParams.width, u.videoParams.height, 0, 0, B2.contain);
    ce.style.width = "".concat(ue, "px"), ce.style.height = "".concat(ie, "px"), ce.style.top = "".concat(Re, "px"), ce.style.left = "".concat(Ae, "px"), ce.style.right = "".concat(Ce, "px"), z({
      width: ue,
      height: ie,
      top: Re,
      left: Ae,
      right: Ce
    });
  }, [u, J, le]), oe.useEffect(() => {
    if (!S || !U)
      return V(null);
    const ce = S.frameRight - S.frameLeft, ue = S.frameBottom - S.frameTop;
    if (!(U.width && U.height) || !(ce && ue)) return;
    const {
      width: Ae,
      height: Ce,
      left: Le,
      top: Ze,
      right: at
    } = QI(u.videoParams.width, u.videoParams.height, U.width, U.height, ce, ue, S.frameLeft, S.frameTop, B2.contain);
    V({
      width: Ae,
      height: Ce,
      top: Ze,
      left: a ? U.width - (Le + Ae) : Le,
      right: a ? U.width - (at + Ae) : at,
      stroke: D
    });
  }, [U, S, u.videoParams, a, D]), oe.useEffect(() => {
    if (!q || !U || !O) return;
    const ce = U.width / u.videoParams.width, ue = q / ce;
    O(ue);
  }, [U, q, u.videoParams.width]), /* @__PURE__ */ Y.jsxs("div", { part: "layout-container", className: T1.container, children: [
    t,
    r !== it.SERVICE_PREPARING && J ? /* @__PURE__ */ Y.jsxs("div", { part: "layout", ref: b, className: T1.layout, children: [
      R && w && U && /* @__PURE__ */ Y.jsx(L9, { layoutParams: U, maskParams: w, borderColor: B }),
      /* @__PURE__ */ Y.jsx(fN, { status: r, title: P, icon: Q, maskParams: w, layoutParams: U, controlsWidth: q, isLandscape: $, animationImage: g, holoData: h }),
      /* @__PURE__ */ Y.jsx(dN, { mirroring: a, captureButton: v, facing: c.camera.facing, isLandscape: $, isSkipButtonVisible: L, isChangeCameraAvailable: te, onClose: p, onChangeCamera: l, onChangeMirroring: o, onSnapshotProcess: C, onCameraSnapshot: E, onSkip: m, onControlsWidth: W })
    ] }) : /* @__PURE__ */ Y.jsx(Ch, { onClose: f, className: T1.loader, children: /* @__PURE__ */ Y.jsx(Js, {}) })
  ] });
}
var o6 = {}, P1, s6;
function YR() {
  return s6 || (s6 = 1, P1 = `	
\v\f\r                　\u2028\u2029\uFEFF`), P1;
}
var b1, l6;
function CN() {
  if (l6) return b1;
  l6 = 1;
  var e = It(), r = Ho(), t = yn(), a = YR(), o = e("".replace), l = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), u = function(p) {
    return function(f) {
      var h = t(r(f));
      return p & 1 && (h = o(h, l, "")), p & 2 && (h = o(h, c, "$1")), h;
    };
  };
  return b1 = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: u(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: u(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: u(3)
  }, b1;
}
var w1, c6;
function SN() {
  if (c6) return w1;
  c6 = 1;
  var e = J2().PROPER, r = vt(), t = YR(), a = "​᠎";
  return w1 = function(o) {
    return r(function() {
      return !!t[o]() || a[o]() !== a || e && t[o].name !== o;
    });
  }, w1;
}
var u6;
function IN() {
  if (u6) return o6;
  u6 = 1;
  var e = zt(), r = CN().trim, t = SN();
  return e({ target: "String", proto: !0, forced: t("trim") }, {
    trim: function() {
      return r(this);
    }
  }), o6;
}
IN();
var f6 = {}, d6;
function vN() {
  if (d6) return f6;
  d6 = 1;
  var e = zt(), r = Mt(), t = Qs(), a = Qr(), o = ar(), l = Ba(), c = Zn(), u = $a(), p = u("find", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    find: function(h) {
      o(this);
      try {
        a(h);
      } catch (m) {
        c(this, "throw", m);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return t(C, function(m, S) {
        if (h(m, E++)) return S(m);
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).result;
    }
  }), f6;
}
vN();
function gN(e) {
  let {
    videoSize: r,
    mirroring: t,
    controlsWidth: a,
    frameKWHLandscape: o,
    frameKWHPortrait: l,
    cameraFrameOffsetWidth: c,
    cameraFrameLandscapeAspectRatio: u = Number(o),
    cameraFramePortraitAspectRatio: p = Number(l),
    cameraFrameVerticalPositionMultiplier: f,
    cameraFrameHorizontalPositionMultiplier: h
  } = e;
  const C = r.width > r.height, E = C ? a : 0, S = (C ? r.height : r.width) / 100 * (C ? c != null ? c : WO : c != null ? c : 1), v = (r.width - (C ? E : 0)) / r.height, g = C ? u : p;
  let O, D, R, T;
  if (C) {
    v > g ? (D = r.height - S * 2, O = D * g, R = ((t ? 0 : E) + (r.width - E - O) / 2) * (h != null ? h : 1), T = S) : (O = r.width - E - S * 2, D = O / g, R = (t ? 0 : E) + S, T = (r.height - D) / 2);
    const N = (r.width - O) / 2;
    N > E + S && (v > g && h !== void 0 || (R = N));
  } else
    v < g ? (O = r.width - S * 2, D = O / g, R = S, T = (r.height - D) / 2 * (f != null ? f : 1)) : (D = r.height - S * 2, O = D * g, R = (r.width - O) / 2, T = S);
  return {
    height: D,
    width: O,
    left: R,
    top: T
  };
}
function RN(e) {
  let {
    videoSize: r,
    mirroring: t,
    controlsWidth: a,
    scenario: o,
    scenarioParams: l
  } = e;
  const {
    cameraFramePortraitAspectRatio: c,
    cameraFrameLandscapeAspectRatio: u,
    cameraFrameOffsetWidth: p,
    cameraFrameVerticalPositionMultiplier: f,
    cameraFrameHorizontalPositionMultiplier: h,
    cameraFrame: C = !0
  } = ur(), [E, m] = oe.useState(null);
  return oe.useEffect(() => {
    if (!C)
      return m(null);
    const S = !!r.width, v = !!r.height;
    if (!(S && v && (l == null ? void 0 : l.length)) || !o) return;
    const D = l.find((V) => V.name === o), R = window.RegulaDocumentSDK.recognizerProcessParam.processParam.doublePageSpread, T = R ? D == null ? void 0 : D.frameKWHDoublePageSpreadLandscape : D == null ? void 0 : D.frameKWHLandscape, N = R ? D == null ? void 0 : D.frameKWHDoublePageSpreadPortrait : D == null ? void 0 : D.frameKWHPortrait;
    if (!T || !N) return;
    const {
      width: b,
      height: L,
      top: k,
      left: w
    } = gN({
      videoSize: r,
      mirroring: t,
      controlsWidth: a,
      frameKWHLandscape: T,
      frameKWHPortrait: N,
      cameraFrameOffsetWidth: p,
      cameraFrameLandscapeAspectRatio: u,
      cameraFramePortraitAspectRatio: c,
      cameraFrameVerticalPositionMultiplier: f,
      cameraFrameHorizontalPositionMultiplier: h
    });
    m({
      frameBottom: Math.floor(k + L),
      frameLeft: Math.floor(w),
      frameRight: Math.floor(w + b),
      frameTop: Math.floor(k)
    });
  }, [C, o, r, l, t, a, c, u, p, f, h]), E;
}
function p6(e, r, t) {
  return (r = DN(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function DN(e) {
  var r = AN(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function AN(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class $t {
  constructor(r) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    p6(this, "type", void 0), p6(this, "details", void 0), this.type = r, this.details = t;
  }
}
function KR(e, r) {
  return function() {
    return e.apply(r, arguments);
  };
}
const { toString: TN } = Object.prototype, { getPrototypeOf: Sh } = Object, { iterator: sc, toStringTag: XR } = Symbol, lc = /* @__PURE__ */ ((e) => (r) => {
  const t = TN.call(r);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), jn = (e) => (e = e.toLowerCase(), (r) => lc(r) === e), cc = (e) => (r) => typeof r === e, { isArray: xo } = Array, bo = cc("undefined");
function el(e) {
  return e !== null && !bo(e) && e.constructor !== null && !bo(e.constructor) && Kr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const QR = jn("ArrayBuffer");
function ON(e) {
  let r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && QR(e.buffer), r;
}
const yN = cc("string"), Kr = cc("function"), JR = cc("number"), tl = (e) => e !== null && typeof e == "object", NN = (e) => e === !0 || e === !1, b2 = (e) => {
  if (lc(e) !== "object")
    return !1;
  const r = Sh(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(XR in e) && !(sc in e);
}, LN = (e) => {
  if (!tl(e) || el(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch (r) {
    return !1;
  }
}, MN = jn("Date"), PN = jn("File"), bN = jn("Blob"), wN = jn("FileList"), HN = (e) => tl(e) && Kr(e.pipe), VN = (e) => {
  let r;
  return e && (typeof FormData == "function" && e instanceof FormData || Kr(e.append) && ((r = lc(e)) === "formdata" || // detect form-data instance
  r === "object" && Kr(e.toString) && e.toString() === "[object FormData]"));
}, kN = jn("URLSearchParams"), [FN, UN, xN, BN] = ["ReadableStream", "Request", "Response", "Headers"].map(jn), $N = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function rl(e, r, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, o;
  if (typeof e != "object" && (e = [e]), xo(e))
    for (a = 0, o = e.length; a < o; a++)
      r.call(null, e[a], a, e);
  else {
    if (el(e))
      return;
    const l = t ? Object.getOwnPropertyNames(e) : Object.keys(e), c = l.length;
    let u;
    for (a = 0; a < c; a++)
      u = l[a], r.call(null, e[u], u, e);
  }
}
function eD(e, r) {
  if (el(e))
    return null;
  r = r.toLowerCase();
  const t = Object.keys(e);
  let a = t.length, o;
  for (; a-- > 0; )
    if (o = t[a], r === o.toLowerCase())
      return o;
  return null;
}
const La = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, tD = (e) => !bo(e) && e !== La;
function Cp() {
  const { caseless: e, skipUndefined: r } = tD(this) && this || {}, t = {}, a = (o, l) => {
    const c = e && eD(t, l) || l;
    b2(t[c]) && b2(o) ? t[c] = Cp(t[c], o) : b2(o) ? t[c] = Cp({}, o) : xo(o) ? t[c] = o.slice() : (!r || !bo(o)) && (t[c] = o);
  };
  for (let o = 0, l = arguments.length; o < l; o++)
    arguments[o] && rl(arguments[o], a);
  return t;
}
const GN = (e, r, t, { allOwnKeys: a } = {}) => (rl(r, (o, l) => {
  t && Kr(o) ? e[l] = KR(o, t) : e[l] = o;
}, { allOwnKeys: a }), e), ZN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), jN = (e, r, t, a) => {
  e.prototype = Object.create(r.prototype, a), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: r.prototype
  }), t && Object.assign(e.prototype, t);
}, zN = (e, r, t, a) => {
  let o, l, c;
  const u = {};
  if (r = r || {}, e == null) return r;
  do {
    for (o = Object.getOwnPropertyNames(e), l = o.length; l-- > 0; )
      c = o[l], (!a || a(c, e, r)) && !u[c] && (r[c] = e[c], u[c] = !0);
    e = t !== !1 && Sh(e);
  } while (e && (!t || t(e, r)) && e !== Object.prototype);
  return r;
}, qN = (e, r, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= r.length;
  const a = e.indexOf(r, t);
  return a !== -1 && a === t;
}, WN = (e) => {
  if (!e) return null;
  if (xo(e)) return e;
  let r = e.length;
  if (!JR(r)) return null;
  const t = new Array(r);
  for (; r-- > 0; )
    t[r] = e[r];
  return t;
}, YN = /* @__PURE__ */ ((e) => (r) => e && r instanceof e)(typeof Uint8Array < "u" && Sh(Uint8Array)), KN = (e, r) => {
  const t = (e && e[sc]).call(e);
  let a;
  for (; (a = t.next()) && !a.done; ) {
    const o = a.value;
    r.call(e, o[0], o[1]);
  }
}, XN = (e, r) => {
  let t;
  const a = [];
  for (; (t = e.exec(r)) !== null; )
    a.push(t);
  return a;
}, QN = jn("HTMLFormElement"), JN = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, t, a) {
    return t.toUpperCase() + a;
  }
), h6 = (({ hasOwnProperty: e }) => (r, t) => e.call(r, t))(Object.prototype), eL = jn("RegExp"), rD = (e, r) => {
  const t = Object.getOwnPropertyDescriptors(e), a = {};
  rl(t, (o, l) => {
    let c;
    (c = r(o, l, e)) !== !1 && (a[l] = c || o);
  }), Object.defineProperties(e, a);
}, tL = (e) => {
  rD(e, (r, t) => {
    if (Kr(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const a = e[t];
    if (Kr(a)) {
      if (r.enumerable = !1, "writable" in r) {
        r.writable = !1;
        return;
      }
      r.set || (r.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, rL = (e, r) => {
  const t = {}, a = (o) => {
    o.forEach((l) => {
      t[l] = !0;
    });
  };
  return xo(e) ? a(e) : a(String(e).split(r)), t;
}, nL = () => {
}, iL = (e, r) => e != null && Number.isFinite(e = +e) ? e : r;
function aL(e) {
  return !!(e && Kr(e.append) && e[XR] === "FormData" && e[sc]);
}
const oL = (e) => {
  const r = new Array(10), t = (a, o) => {
    if (tl(a)) {
      if (r.indexOf(a) >= 0)
        return;
      if (el(a))
        return a;
      if (!("toJSON" in a)) {
        r[o] = a;
        const l = xo(a) ? [] : {};
        return rl(a, (c, u) => {
          const p = t(c, o + 1);
          !bo(p) && (l[u] = p);
        }), r[o] = void 0, l;
      }
    }
    return a;
  };
  return t(e, 0);
}, sL = jn("AsyncFunction"), lL = (e) => e && (tl(e) || Kr(e)) && Kr(e.then) && Kr(e.catch), nD = ((e, r) => e ? setImmediate : r ? ((t, a) => (La.addEventListener("message", ({ source: o, data: l }) => {
  o === La && l === t && a.length && a.shift()();
}, !1), (o) => {
  a.push(o), La.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Kr(La.postMessage)
), cL = typeof queueMicrotask < "u" ? queueMicrotask.bind(La) : typeof process < "u" && process.nextTick || nD, uL = (e) => e != null && Kr(e[sc]), re = {
  isArray: xo,
  isArrayBuffer: QR,
  isBuffer: el,
  isFormData: VN,
  isArrayBufferView: ON,
  isString: yN,
  isNumber: JR,
  isBoolean: NN,
  isObject: tl,
  isPlainObject: b2,
  isEmptyObject: LN,
  isReadableStream: FN,
  isRequest: UN,
  isResponse: xN,
  isHeaders: BN,
  isUndefined: bo,
  isDate: MN,
  isFile: PN,
  isBlob: bN,
  isRegExp: eL,
  isFunction: Kr,
  isStream: HN,
  isURLSearchParams: kN,
  isTypedArray: YN,
  isFileList: wN,
  forEach: rl,
  merge: Cp,
  extend: GN,
  trim: $N,
  stripBOM: ZN,
  inherits: jN,
  toFlatObject: zN,
  kindOf: lc,
  kindOfTest: jn,
  endsWith: qN,
  toArray: WN,
  forEachEntry: KN,
  matchAll: XN,
  isHTMLForm: QN,
  hasOwnProperty: h6,
  hasOwnProp: h6,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: rD,
  freezeMethods: tL,
  toObjectSet: rL,
  toCamelCase: JN,
  noop: nL,
  toFiniteNumber: iL,
  findKey: eD,
  global: La,
  isContextDefined: tD,
  isSpecCompliantForm: aL,
  toJSONObject: oL,
  isAsyncFn: sL,
  isThenable: lL,
  setImmediate: nD,
  asap: cL,
  isIterable: uL
};
function nt(e, r, t, a, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", r && (this.code = r), t && (this.config = t), a && (this.request = a), o && (this.response = o, this.status = o.status ? o.status : null);
}
re.inherits(nt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: re.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const iD = nt.prototype, aD = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  aD[e] = { value: e };
});
Object.defineProperties(nt, aD);
Object.defineProperty(iD, "isAxiosError", { value: !0 });
nt.from = (e, r, t, a, o, l) => {
  const c = Object.create(iD);
  re.toFlatObject(e, c, function(f) {
    return f !== Error.prototype;
  }, (f) => f !== "isAxiosError");
  const u = e && e.message ? e.message : "Error", p = r == null && e ? e.code : r;
  return nt.call(c, u, p, t, a, o), e && c.cause == null && Object.defineProperty(c, "cause", { value: e, configurable: !0 }), c.name = e && e.name || "Error", l && Object.assign(c, l), c;
};
const fL = null;
function Sp(e) {
  return re.isPlainObject(e) || re.isArray(e);
}
function oD(e) {
  return re.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function _6(e, r, t) {
  return e ? e.concat(r).map(function(a, o) {
    return a = oD(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : r;
}
function dL(e) {
  return re.isArray(e) && !e.some(Sp);
}
const pL = re.toFlatObject(re, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function uc(e, r, t) {
  if (!re.isObject(e))
    throw new TypeError("target must be an object");
  r = r || new FormData(), t = re.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, S) {
    return !re.isUndefined(S[m]);
  });
  const a = t.metaTokens, o = t.visitor || f, l = t.dots, c = t.indexes, u = (t.Blob || typeof Blob < "u" && Blob) && re.isSpecCompliantForm(r);
  if (!re.isFunction(o))
    throw new TypeError("visitor must be a function");
  function p(m) {
    if (m === null) return "";
    if (re.isDate(m))
      return m.toISOString();
    if (re.isBoolean(m))
      return m.toString();
    if (!u && re.isBlob(m))
      throw new nt("Blob is not supported. Use a Buffer instead.");
    return re.isArrayBuffer(m) || re.isTypedArray(m) ? u && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function f(m, S, v) {
    let g = m;
    if (m && !v && typeof m == "object") {
      if (re.endsWith(S, "{}"))
        S = a ? S : S.slice(0, -2), m = JSON.stringify(m);
      else if (re.isArray(m) && dL(m) || (re.isFileList(m) || re.endsWith(S, "[]")) && (g = re.toArray(m)))
        return S = oD(S), g.forEach(function(O, D) {
          !(re.isUndefined(O) || O === null) && r.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? _6([S], D, l) : c === null ? S : S + "[]",
            p(O)
          );
        }), !1;
    }
    return Sp(m) ? !0 : (r.append(_6(v, S, l), p(m)), !1);
  }
  const h = [], C = Object.assign(pL, {
    defaultVisitor: f,
    convertValue: p,
    isVisitable: Sp
  });
  function E(m, S) {
    if (!re.isUndefined(m)) {
      if (h.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      h.push(m), re.forEach(m, function(v, g) {
        (!(re.isUndefined(v) || v === null) && o.call(
          r,
          v,
          re.isString(g) ? g.trim() : g,
          S,
          C
        )) === !0 && E(v, S ? S.concat(g) : [g]);
      }), h.pop();
    }
  }
  if (!re.isObject(e))
    throw new TypeError("data must be an object");
  return E(e), r;
}
function m6(e) {
  const r = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(t) {
    return r[t];
  });
}
function Ih(e, r) {
  this._pairs = [], e && uc(e, this, r);
}
const sD = Ih.prototype;
sD.append = function(e, r) {
  this._pairs.push([e, r]);
};
sD.toString = function(e) {
  const r = e ? function(t) {
    return e.call(this, t, m6);
  } : m6;
  return this._pairs.map(function(t) {
    return r(t[0]) + "=" + r(t[1]);
  }, "").join("&");
};
function hL(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function lD(e, r, t) {
  if (!r)
    return e;
  const a = t && t.encode || hL;
  re.isFunction(t) && (t = {
    serialize: t
  });
  const o = t && t.serialize;
  let l;
  if (o ? l = o(r, t) : l = re.isURLSearchParams(r) ? r.toString() : new Ih(r, t).toString(a), l) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return e;
}
class E6 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(r, t, a) {
    return this.handlers.push({
      fulfilled: r,
      rejected: t,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(r) {
    re.forEach(this.handlers, function(t) {
      t !== null && r(t);
    });
  }
}
const cD = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, _L = typeof URLSearchParams < "u" ? URLSearchParams : Ih, mL = typeof FormData < "u" ? FormData : null, EL = typeof Blob < "u" ? Blob : null, CL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: _L,
    FormData: mL,
    Blob: EL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, vh = typeof window < "u" && typeof document < "u", Ip = typeof navigator == "object" && navigator || void 0, SL = vh && (!Ip || ["ReactNative", "NativeScript", "NS"].indexOf(Ip.product) < 0), IL = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", vL = vh && window.location.href || "http://localhost", gL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: vh,
  hasStandardBrowserEnv: SL,
  hasStandardBrowserWebWorkerEnv: IL,
  navigator: Ip,
  origin: vL
}, Symbol.toStringTag, { value: "Module" })), br = ke(ke({}, gL), CL);
function RL(e, r) {
  return uc(e, new br.classes.URLSearchParams(), ke({
    visitor: function(t, a, o, l) {
      return br.isNode && re.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    }
  }, r));
}
function DL(e) {
  return re.matchAll(/\w+|\[(\w*)]/g, e).map((r) => r[0] === "[]" ? "" : r[1] || r[0]);
}
function AL(e) {
  const r = {}, t = Object.keys(e);
  let a;
  const o = t.length;
  let l;
  for (a = 0; a < o; a++)
    l = t[a], r[l] = e[l];
  return r;
}
function uD(e) {
  function r(t, a, o, l) {
    let c = t[l++];
    if (c === "__proto__") return !0;
    const u = Number.isFinite(+c), p = l >= t.length;
    return c = !c && re.isArray(o) ? o.length : c, p ? (re.hasOwnProp(o, c) ? o[c] = [o[c], a] : o[c] = a, !u) : ((!o[c] || !re.isObject(o[c])) && (o[c] = []), r(t, a, o[c], l) && re.isArray(o[c]) && (o[c] = AL(o[c])), !u);
  }
  if (re.isFormData(e) && re.isFunction(e.entries)) {
    const t = {};
    return re.forEachEntry(e, (a, o) => {
      r(DL(a), o, t, 0);
    }), t;
  }
  return null;
}
function TL(e, r, t) {
  if (re.isString(e))
    try {
      return (r || JSON.parse)(e), re.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (t || JSON.stringify)(e);
}
const nl = {
  transitional: cD,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const t = r.getContentType() || "", a = t.indexOf("application/json") > -1, o = re.isObject(e);
    if (o && re.isHTMLForm(e) && (e = new FormData(e)), re.isFormData(e))
      return a ? JSON.stringify(uD(e)) : e;
    if (re.isArrayBuffer(e) || re.isBuffer(e) || re.isStream(e) || re.isFile(e) || re.isBlob(e) || re.isReadableStream(e))
      return e;
    if (re.isArrayBufferView(e))
      return e.buffer;
    if (re.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let l;
    if (o) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return RL(e, this.formSerializer).toString();
      if ((l = re.isFileList(e)) || t.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return uc(
          l ? { "files[]": e } : e,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), TL(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || nl.transitional, t = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (re.isResponse(e) || re.isReadableStream(e))
      return e;
    if (e && re.isString(e) && (t && !this.responseType || a)) {
      const o = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (l) {
        if (o)
          throw l.name === "SyntaxError" ? nt.from(l, nt.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: br.classes.FormData,
    Blob: br.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
re.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  nl.headers[e] = {};
});
const OL = re.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), yL = (e) => {
  const r = {};
  let t, a, o;
  return e && e.split(`
`).forEach(function(l) {
    o = l.indexOf(":"), t = l.substring(0, o).trim().toLowerCase(), a = l.substring(o + 1).trim(), !(!t || r[t] && OL[t]) && (t === "set-cookie" ? r[t] ? r[t].push(a) : r[t] = [a] : r[t] = r[t] ? r[t] + ", " + a : a);
  }), r;
}, C6 = Symbol("internals");
function Ts(e) {
  return e && String(e).trim().toLowerCase();
}
function w2(e) {
  return e === !1 || e == null ? e : re.isArray(e) ? e.map(w2) : String(e);
}
function NL(e) {
  const r = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = t.exec(e); )
    r[a[1]] = a[2];
  return r;
}
const LL = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function H1(e, r, t, a, o) {
  if (re.isFunction(a))
    return a.call(this, r, t);
  if (o && (r = t), !!re.isString(r)) {
    if (re.isString(a))
      return r.indexOf(a) !== -1;
    if (re.isRegExp(a))
      return a.test(r);
  }
}
function ML(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (r, t, a) => t.toUpperCase() + a);
}
function PL(e, r) {
  const t = re.toCamelCase(" " + r);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + t, {
      value: function(o, l, c) {
        return this[a].call(this, r, o, l, c);
      },
      configurable: !0
    });
  });
}
let Xr = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, t) {
    const a = this;
    function o(c, u, p) {
      const f = Ts(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const h = re.findKey(a, f);
      (!h || a[h] === void 0 || p === !0 || p === void 0 && a[h] !== !1) && (a[h || u] = w2(c));
    }
    const l = (c, u) => re.forEach(c, (p, f) => o(p, f, u));
    if (re.isPlainObject(e) || e instanceof this.constructor)
      l(e, r);
    else if (re.isString(e) && (e = e.trim()) && !LL(e))
      l(yL(e), r);
    else if (re.isObject(e) && re.isIterable(e)) {
      let c = {}, u, p;
      for (const f of e) {
        if (!re.isArray(f))
          throw TypeError("Object iterator must return a key-value pair");
        c[p = f[0]] = (u = c[p]) ? re.isArray(u) ? [...u, f[1]] : [u, f[1]] : f[1];
      }
      l(c, r);
    } else
      e != null && o(r, e, t);
    return this;
  }
  get(e, r) {
    if (e = Ts(e), e) {
      const t = re.findKey(this, e);
      if (t) {
        const a = this[t];
        if (!r)
          return a;
        if (r === !0)
          return NL(a);
        if (re.isFunction(r))
          return r.call(this, a, t);
        if (re.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Ts(e), e) {
      const t = re.findKey(this, e);
      return !!(t && this[t] !== void 0 && (!r || H1(this, this[t], t, r)));
    }
    return !1;
  }
  delete(e, r) {
    const t = this;
    let a = !1;
    function o(l) {
      if (l = Ts(l), l) {
        const c = re.findKey(t, l);
        c && (!r || H1(t, t[c], c, r)) && (delete t[c], a = !0);
      }
    }
    return re.isArray(e) ? e.forEach(o) : o(e), a;
  }
  clear(e) {
    const r = Object.keys(this);
    let t = r.length, a = !1;
    for (; t--; ) {
      const o = r[t];
      (!e || H1(this, this[o], o, e, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(e) {
    const r = this, t = {};
    return re.forEach(this, (a, o) => {
      const l = re.findKey(t, o);
      if (l) {
        r[l] = w2(a), delete r[o];
        return;
      }
      const c = e ? ML(o) : String(o).trim();
      c !== o && delete r[o], r[c] = w2(a), t[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return re.forEach(this, (t, a) => {
      t != null && t !== !1 && (r[a] = e && re.isArray(t) ? t.join(", ") : t);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const t = new this(e);
    return r.forEach((a) => t.set(a)), t;
  }
  static accessor(e) {
    const r = (this[C6] = this[C6] = {
      accessors: {}
    }).accessors, t = this.prototype;
    function a(o) {
      const l = Ts(o);
      r[l] || (PL(t, o), r[l] = !0);
    }
    return re.isArray(e) ? e.forEach(a) : a(e), this;
  }
};
Xr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
re.reduceDescriptors(Xr.prototype, ({ value: e }, r) => {
  let t = r[0].toUpperCase() + r.slice(1);
  return {
    get: () => e,
    set(a) {
      this[t] = a;
    }
  };
});
re.freezeMethods(Xr);
function V1(e, r) {
  const t = this || nl, a = r || t, o = Xr.from(a.headers);
  let l = a.data;
  return re.forEach(e, function(c) {
    l = c.call(t, l, o.normalize(), r ? r.status : void 0);
  }), o.normalize(), l;
}
function fD(e) {
  return !!(e && e.__CANCEL__);
}
function Bo(e, r, t) {
  nt.call(this, e != null ? e : "canceled", nt.ERR_CANCELED, r, t), this.name = "CanceledError";
}
re.inherits(Bo, nt, {
  __CANCEL__: !0
});
function dD(e, r, t) {
  const a = t.config.validateStatus;
  !t.status || !a || a(t.status) ? e(t) : r(new nt(
    "Request failed with status code " + t.status,
    [nt.ERR_BAD_REQUEST, nt.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function bL(e) {
  const r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return r && r[1] || "";
}
function wL(e, r) {
  e = e || 10;
  const t = new Array(e), a = new Array(e);
  let o = 0, l = 0, c;
  return r = r !== void 0 ? r : 1e3, function(u) {
    const p = Date.now(), f = a[l];
    c || (c = p), t[o] = u, a[o] = p;
    let h = l, C = 0;
    for (; h !== o; )
      C += t[h++], h = h % e;
    if (o = (o + 1) % e, o === l && (l = (l + 1) % e), p - c < r)
      return;
    const E = f && p - f;
    return E ? Math.round(C * 1e3 / E) : void 0;
  };
}
function HL(e, r) {
  let t = 0, a = 1e3 / r, o, l;
  const c = (u, p = Date.now()) => {
    t = p, o = null, l && (clearTimeout(l), l = null), e(...u);
  };
  return [(...u) => {
    const p = Date.now(), f = p - t;
    f >= a ? c(u, p) : (o = u, l || (l = setTimeout(() => {
      l = null, c(o);
    }, a - f)));
  }, () => o && c(o)];
}
const Z2 = (e, r, t = 3) => {
  let a = 0;
  const o = wL(50, 250);
  return HL((l) => {
    const c = l.loaded, u = l.lengthComputable ? l.total : void 0, p = c - a, f = o(p), h = c <= u;
    a = c;
    const C = {
      loaded: c,
      total: u,
      progress: u ? c / u : void 0,
      bytes: p,
      rate: f || void 0,
      estimated: f && u && h ? (u - c) / f : void 0,
      event: l,
      lengthComputable: u != null,
      [r ? "download" : "upload"]: !0
    };
    e(C);
  }, t);
}, S6 = (e, r) => {
  const t = e != null;
  return [(a) => r[0]({
    lengthComputable: t,
    total: e,
    loaded: a
  }), r[1]];
}, I6 = (e) => (...r) => re.asap(() => e(...r)), VL = br.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, r) => (t) => (t = new URL(t, br.origin), e.protocol === t.protocol && e.host === t.host && (r || e.port === t.port)))(
  new URL(br.origin),
  br.navigator && /(msie|trident)/i.test(br.navigator.userAgent)
) : () => !0, kL = br.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, r, t, a, o, l) {
      const c = [e + "=" + encodeURIComponent(r)];
      re.isNumber(t) && c.push("expires=" + new Date(t).toGMTString()), re.isString(a) && c.push("path=" + a), re.isString(o) && c.push("domain=" + o), l === !0 && c.push("secure"), document.cookie = c.join("; ");
    },
    read(e) {
      const r = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return r ? decodeURIComponent(r[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function FL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function UL(e, r) {
  return r ? e.replace(/\/?\/$/, "") + "/" + r.replace(/^\/+/, "") : e;
}
function pD(e, r, t) {
  let a = !FL(r);
  return e && (a || t == !1) ? UL(e, r) : r;
}
const v6 = (e) => e instanceof Xr ? ke({}, e) : e;
function wa(e, r) {
  r = r || {};
  const t = {};
  function a(f, h, C, E) {
    return re.isPlainObject(f) && re.isPlainObject(h) ? re.merge.call({ caseless: E }, f, h) : re.isPlainObject(h) ? re.merge({}, h) : re.isArray(h) ? h.slice() : h;
  }
  function o(f, h, C, E) {
    if (re.isUndefined(h)) {
      if (!re.isUndefined(f))
        return a(void 0, f, C, E);
    } else return a(f, h, C, E);
  }
  function l(f, h) {
    if (!re.isUndefined(h))
      return a(void 0, h);
  }
  function c(f, h) {
    if (re.isUndefined(h)) {
      if (!re.isUndefined(f))
        return a(void 0, f);
    } else return a(void 0, h);
  }
  function u(f, h, C) {
    if (C in r)
      return a(f, h);
    if (C in e)
      return a(void 0, f);
  }
  const p = {
    url: l,
    method: l,
    data: l,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: u,
    headers: (f, h, C) => o(v6(f), v6(h), C, !0)
  };
  return re.forEach(Object.keys(ke(ke({}, e), r)), function(f) {
    const h = p[f] || o, C = h(e[f], r[f], f);
    re.isUndefined(C) && h !== u || (t[f] = C);
  }), t;
}
const hD = (e) => {
  const r = wa({}, e);
  let { data: t, withXSRFToken: a, xsrfHeaderName: o, xsrfCookieName: l, headers: c, auth: u } = r;
  if (r.headers = c = Xr.from(c), r.url = lD(pD(r.baseURL, r.url, r.allowAbsoluteUrls), e.params, e.paramsSerializer), u && c.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  ), re.isFormData(t)) {
    if (br.hasStandardBrowserEnv || br.hasStandardBrowserWebWorkerEnv)
      c.setContentType(void 0);
    else if (re.isFunction(t.getHeaders)) {
      const p = t.getHeaders(), f = ["content-type", "content-length"];
      Object.entries(p).forEach(([h, C]) => {
        f.includes(h.toLowerCase()) && c.set(h, C);
      });
    }
  }
  if (br.hasStandardBrowserEnv && (a && re.isFunction(a) && (a = a(r)), a || a !== !1 && VL(r.url))) {
    const p = o && l && kL.read(l);
    p && c.set(o, p);
  }
  return r;
}, xL = typeof XMLHttpRequest < "u", BL = xL && function(e) {
  return new Promise(function(r, t) {
    const a = hD(e);
    let o = a.data;
    const l = Xr.from(a.headers).normalize();
    let { responseType: c, onUploadProgress: u, onDownloadProgress: p } = a, f, h, C, E, m;
    function S() {
      E && E(), m && m(), a.cancelToken && a.cancelToken.unsubscribe(f), a.signal && a.signal.removeEventListener("abort", f);
    }
    let v = new XMLHttpRequest();
    v.open(a.method.toUpperCase(), a.url, !0), v.timeout = a.timeout;
    function g() {
      if (!v)
        return;
      const D = Xr.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), R = {
        data: !c || c === "text" || c === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: D,
        config: e,
        request: v
      };
      dD(function(T) {
        r(T), S();
      }, function(T) {
        t(T), S();
      }, R), v = null;
    }
    "onloadend" in v ? v.onloadend = g : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, v.onabort = function() {
      v && (t(new nt("Request aborted", nt.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function(D) {
      const R = D && D.message ? D.message : "Network Error", T = new nt(R, nt.ERR_NETWORK, e, v);
      T.event = D || null, t(T), v = null;
    }, v.ontimeout = function() {
      let D = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const R = a.transitional || cD;
      a.timeoutErrorMessage && (D = a.timeoutErrorMessage), t(new nt(
        D,
        R.clarifyTimeoutError ? nt.ETIMEDOUT : nt.ECONNABORTED,
        e,
        v
      )), v = null;
    }, o === void 0 && l.setContentType(null), "setRequestHeader" in v && re.forEach(l.toJSON(), function(D, R) {
      v.setRequestHeader(R, D);
    }), re.isUndefined(a.withCredentials) || (v.withCredentials = !!a.withCredentials), c && c !== "json" && (v.responseType = a.responseType), p && ([C, m] = Z2(p, !0), v.addEventListener("progress", C)), u && v.upload && ([h, E] = Z2(u), v.upload.addEventListener("progress", h), v.upload.addEventListener("loadend", E)), (a.cancelToken || a.signal) && (f = (D) => {
      v && (t(!D || D.type ? new Bo(null, e, v) : D), v.abort(), v = null);
    }, a.cancelToken && a.cancelToken.subscribe(f), a.signal && (a.signal.aborted ? f() : a.signal.addEventListener("abort", f)));
    const O = bL(a.url);
    if (O && br.protocols.indexOf(O) === -1) {
      t(new nt("Unsupported protocol " + O + ":", nt.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, $L = (e, r) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (r || t) {
    let a = new AbortController(), o;
    const l = function(f) {
      if (!o) {
        o = !0, u();
        const h = f instanceof Error ? f : this.reason;
        a.abort(h instanceof nt ? h : new Bo(h instanceof Error ? h.message : h));
      }
    };
    let c = r && setTimeout(() => {
      c = null, l(new nt(`timeout ${r} of ms exceeded`, nt.ETIMEDOUT));
    }, r);
    const u = () => {
      e && (c && clearTimeout(c), c = null, e.forEach((f) => {
        f.unsubscribe ? f.unsubscribe(l) : f.removeEventListener("abort", l);
      }), e = null);
    };
    e.forEach((f) => f.addEventListener("abort", l));
    const { signal: p } = a;
    return p.unsubscribe = () => re.asap(u), p;
  }
}, GL = function* (e, r) {
  let t = e.byteLength;
  if (t < r) {
    yield e;
    return;
  }
  let a = 0, o;
  for (; a < t; )
    o = a + r, yield e.slice(a, o), a = o;
}, ZL = function(e, r) {
  return Qu(this, null, function* () {
    try {
      for (var t = Km(jL(e)), a, o, l; a = !(o = yield new Oa(t.next())).done; a = !1) {
        const c = o.value;
        yield* Ju(GL(c, r));
      }
    } catch (o) {
      l = [o];
    } finally {
      try {
        a && (o = t.return) && (yield new Oa(o.call(t)));
      } finally {
        if (l)
          throw l[0];
      }
    }
  });
}, jL = function(e) {
  return Qu(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* Ju(e);
      return;
    }
    const r = e.getReader();
    try {
      for (; ; ) {
        const { done: t, value: a } = yield new Oa(r.read());
        if (t)
          break;
        yield a;
      }
    } finally {
      yield new Oa(r.cancel());
    }
  });
}, g6 = (e, r, t, a) => {
  const o = ZL(e, r);
  let l = 0, c, u = (f) => {
    c || (c = !0, a && a(f));
  };
  return new ReadableStream({
    pull(f) {
      return Oe(this, null, function* () {
        try {
          const { done: h, value: C } = yield o.next();
          if (h) {
            u(), f.close();
            return;
          }
          let E = C.byteLength;
          if (t) {
            let m = l += E;
            t(m);
          }
          f.enqueue(new Uint8Array(C));
        } catch (h) {
          throw u(h), h;
        }
      });
    },
    cancel(f) {
      return u(f), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, R6 = 64 * 1024, { isFunction: v2 } = re, zL = (({ Request: e, Response: r }) => ({
  Request: e,
  Response: r
}))(re.global), {
  ReadableStream: D6,
  TextEncoder: A6
} = re.global, T6 = (e, ...r) => {
  try {
    return !!e(...r);
  } catch (t) {
    return !1;
  }
}, qL = (e) => {
  e = re.merge.call({
    skipUndefined: !0
  }, zL, e);
  const { fetch: r, Request: t, Response: a } = e, o = r ? v2(r) : typeof fetch == "function", l = v2(t), c = v2(a);
  if (!o)
    return !1;
  const u = o && v2(D6), p = o && (typeof A6 == "function" ? /* @__PURE__ */ ((S) => (v) => S.encode(v))(new A6()) : (S) => Oe(null, null, function* () {
    return new Uint8Array(yield new t(S).arrayBuffer());
  })), f = l && u && T6(() => {
    let S = !1;
    const v = new t(br.origin, {
      body: new D6(),
      method: "POST",
      get duplex() {
        return S = !0, "half";
      }
    }).headers.has("Content-Type");
    return S && !v;
  }), h = c && u && T6(() => re.isReadableStream(new a("").body)), C = {
    stream: h && ((S) => S.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((S) => {
    !C[S] && (C[S] = (v, g) => {
      let O = v && v[S];
      if (O)
        return O.call(v);
      throw new nt(`Response type '${S}' is not supported`, nt.ERR_NOT_SUPPORT, g);
    });
  });
  const E = (S) => Oe(null, null, function* () {
    if (S == null)
      return 0;
    if (re.isBlob(S))
      return S.size;
    if (re.isSpecCompliantForm(S))
      return (yield new t(br.origin, {
        method: "POST",
        body: S
      }).arrayBuffer()).byteLength;
    if (re.isArrayBufferView(S) || re.isArrayBuffer(S))
      return S.byteLength;
    if (re.isURLSearchParams(S) && (S = S + ""), re.isString(S))
      return (yield p(S)).byteLength;
  }), m = (S, v) => Oe(null, null, function* () {
    const g = re.toFiniteNumber(S.getContentLength());
    return g != null ? g : E(v);
  });
  return (S) => Oe(null, null, function* () {
    let {
      url: v,
      method: g,
      data: O,
      signal: D,
      cancelToken: R,
      timeout: T,
      onDownloadProgress: N,
      onUploadProgress: b,
      responseType: L,
      headers: k,
      withCredentials: w = "same-origin",
      fetchOptions: V
    } = hD(S), U = r || fetch;
    L = L ? (L + "").toLowerCase() : "text";
    let z = $L([D, R && R.toAbortSignal()], T), q = null;
    const W = z && z.unsubscribe && (() => {
      z.unsubscribe();
    });
    let te;
    try {
      if (b && f && g !== "get" && g !== "head" && (te = yield m(k, O)) !== 0) {
        let P = new t(v, {
          method: "POST",
          body: O,
          duplex: "half"
        }), $;
        if (re.isFormData(O) && ($ = P.headers.get("content-type")) && k.setContentType($), P.body) {
          const [ce, ue] = S6(
            te,
            Z2(I6(b))
          );
          O = g6(P.body, R6, ce, ue);
        }
      }
      re.isString(w) || (w = w ? "include" : "omit");
      const se = l && "credentials" in t.prototype, le = go(ke({}, V), {
        signal: z,
        method: g.toUpperCase(),
        headers: k.normalize().toJSON(),
        body: O,
        duplex: "half",
        credentials: se ? w : void 0
      });
      q = l && new t(v, le);
      let B = yield l ? U(q, V) : U(v, le);
      const J = h && (L === "stream" || L === "response");
      if (h && (N || J && W)) {
        const P = {};
        ["status", "statusText", "headers"].forEach((ie) => {
          P[ie] = B[ie];
        });
        const $ = re.toFiniteNumber(B.headers.get("content-length")), [ce, ue] = N && S6(
          $,
          Z2(I6(N), !0)
        ) || [];
        B = new a(
          g6(B.body, R6, ce, () => {
            ue && ue(), W && W();
          }),
          P
        );
      }
      L = L || "text";
      let Q = yield C[re.findKey(C, L) || "text"](B, S);
      return !J && W && W(), yield new Promise((P, $) => {
        dD(P, $, {
          data: Q,
          headers: Xr.from(B.headers),
          status: B.status,
          statusText: B.statusText,
          config: S,
          request: q
        });
      });
    } catch (se) {
      throw W && W(), se && se.name === "TypeError" && /Load failed|fetch/i.test(se.message) ? Object.assign(
        new nt("Network Error", nt.ERR_NETWORK, S, q),
        {
          cause: se.cause || se
        }
      ) : nt.from(se, se && se.code, S, q);
    }
  });
}, WL = /* @__PURE__ */ new Map(), _D = (e) => {
  let r = e ? e.env : {};
  const { fetch: t, Request: a, Response: o } = r, l = [
    a,
    o,
    t
  ];
  let c = l.length, u = c, p, f, h = WL;
  for (; u--; )
    p = l[u], f = h.get(p), f === void 0 && h.set(p, f = u ? /* @__PURE__ */ new Map() : qL(r)), h = f;
  return f;
};
_D();
const vp = {
  http: fL,
  xhr: BL,
  fetch: {
    get: _D
  }
};
re.forEach(vp, (e, r) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: r });
    } catch (t) {
    }
    Object.defineProperty(e, "adapterName", { value: r });
  }
});
const O6 = (e) => `- ${e}`, YL = (e) => re.isFunction(e) || e === null || e === !1, mD = {
  getAdapter: (e, r) => {
    e = re.isArray(e) ? e : [e];
    const { length: t } = e;
    let a, o;
    const l = {};
    for (let c = 0; c < t; c++) {
      a = e[c];
      let u;
      if (o = a, !YL(a) && (o = vp[(u = String(a)).toLowerCase()], o === void 0))
        throw new nt(`Unknown adapter '${u}'`);
      if (o && (re.isFunction(o) || (o = o.get(r))))
        break;
      l[u || "#" + c] = o;
    }
    if (!o) {
      const c = Object.entries(l).map(
        ([p, f]) => `adapter ${p} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let u = t ? c.length > 1 ? `since :
` + c.map(O6).join(`
`) : " " + O6(c[0]) : "as no adapter specified";
      throw new nt(
        "There is no suitable adapter to dispatch the request " + u,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: vp
};
function k1(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Bo(null, e);
}
function y6(e) {
  return k1(e), e.headers = Xr.from(e.headers), e.data = V1.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), mD.getAdapter(e.adapter || nl.adapter, e)(e).then(function(r) {
    return k1(e), r.data = V1.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Xr.from(r.headers), r;
  }, function(r) {
    return fD(r) || (k1(e), r && r.response && (r.response.data = V1.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Xr.from(r.response.headers))), Promise.reject(r);
  });
}
const ED = "1.12.2", fc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, r) => {
  fc[e] = function(t) {
    return typeof t === e || "a" + (r < 1 ? "n " : " ") + e;
  };
});
const N6 = {};
fc.transitional = function(e, r, t) {
  function a(o, l) {
    return "[Axios v" + ED + "] Transitional option '" + o + "'" + l + (t ? ". " + t : "");
  }
  return (o, l, c) => {
    if (e === !1)
      throw new nt(
        a(l, " has been removed" + (r ? " in " + r : "")),
        nt.ERR_DEPRECATED
      );
    return r && !N6[l] && (N6[l] = !0, console.warn(
      a(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(o, l, c) : !0;
  };
};
fc.spelling = function(e) {
  return (r, t) => (console.warn(`${t} is likely a misspelling of ${e}`), !0);
};
function KL(e, r, t) {
  if (typeof e != "object")
    throw new nt("options must be an object", nt.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let o = a.length;
  for (; o-- > 0; ) {
    const l = a[o], c = r[l];
    if (c) {
      const u = e[l], p = u === void 0 || c(u, l, e);
      if (p !== !0)
        throw new nt("option " + l + " must be " + p, nt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new nt("Unknown option " + l, nt.ERR_BAD_OPTION);
  }
}
const H2 = {
  assertOptions: KL,
  validators: fc
}, ri = H2.validators;
let Ma = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new E6(),
      response: new E6()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(e, r) {
    return Oe(this, null, function* () {
      try {
        return yield this._request(e, r);
      } catch (t) {
        if (t instanceof Error) {
          let a = {};
          Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
          const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
          try {
            t.stack ? o && !String(t.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + o) : t.stack = o;
          } catch (l) {
          }
        }
        throw t;
      }
    });
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = wa(this.defaults, r);
    const { transitional: t, paramsSerializer: a, headers: o } = r;
    t !== void 0 && H2.assertOptions(t, {
      silentJSONParsing: ri.transitional(ri.boolean),
      forcedJSONParsing: ri.transitional(ri.boolean),
      clarifyTimeoutError: ri.transitional(ri.boolean)
    }, !1), a != null && (re.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : H2.assertOptions(a, {
      encode: ri.function,
      serialize: ri.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), H2.assertOptions(r, {
      baseUrl: ri.spelling("baseURL"),
      withXsrfToken: ri.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = o && re.merge(
      o.common,
      o[r.method]
    );
    o && re.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete o[m];
      }
    ), r.headers = Xr.concat(l, o);
    const c = [];
    let u = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(r) === !1 || (u = u && m.synchronous, c.unshift(m.fulfilled, m.rejected));
    });
    const p = [];
    this.interceptors.response.forEach(function(m) {
      p.push(m.fulfilled, m.rejected);
    });
    let f, h = 0, C;
    if (!u) {
      const m = [y6.bind(this), void 0];
      for (m.unshift(...c), m.push(...p), C = m.length, f = Promise.resolve(r); h < C; )
        f = f.then(m[h++], m[h++]);
      return f;
    }
    C = c.length;
    let E = r;
    for (; h < C; ) {
      const m = c[h++], S = c[h++];
      try {
        E = m(E);
      } catch (v) {
        S.call(this, v);
        break;
      }
    }
    try {
      f = y6.call(this, E);
    } catch (m) {
      return Promise.reject(m);
    }
    for (h = 0, C = p.length; h < C; )
      f = f.then(p[h++], p[h++]);
    return f;
  }
  getUri(e) {
    e = wa(this.defaults, e);
    const r = pD(e.baseURL, e.url, e.allowAbsoluteUrls);
    return lD(r, e.params, e.paramsSerializer);
  }
};
re.forEach(["delete", "get", "head", "options"], function(e) {
  Ma.prototype[e] = function(r, t) {
    return this.request(wa(t || {}, {
      method: e,
      url: r,
      data: (t || {}).data
    }));
  };
});
re.forEach(["post", "put", "patch"], function(e) {
  function r(t) {
    return function(a, o, l) {
      return this.request(wa(l || {}, {
        method: e,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Ma.prototype[e] = r(), Ma.prototype[e + "Form"] = r(!0);
});
let XL = class CD {
  constructor(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const a = this;
    this.promise.then((o) => {
      if (!a._listeners) return;
      let l = a._listeners.length;
      for (; l-- > 0; )
        a._listeners[l](o);
      a._listeners = null;
    }), this.promise.then = (o) => {
      let l;
      const c = new Promise((u) => {
        a.subscribe(u), l = u;
      }).then(o);
      return c.cancel = function() {
        a.unsubscribe(l);
      }, c;
    }, r(function(o, l, c) {
      a.reason || (a.reason = new Bo(o, l, c), t(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(r) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(r);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const r = new AbortController(), t = (a) => {
      r.abort(a);
    };
    return this.subscribe(t), r.signal.unsubscribe = () => this.unsubscribe(t), r.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let r;
    return {
      token: new CD(function(t) {
        r = t;
      }),
      cancel: r
    };
  }
};
function QL(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function JL(e) {
  return re.isObject(e) && e.isAxiosError === !0;
}
const gp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(gp).forEach(([e, r]) => {
  gp[r] = e;
});
function SD(e) {
  const r = new Ma(e), t = KR(Ma.prototype.request, r);
  return re.extend(t, Ma.prototype, r, { allOwnKeys: !0 }), re.extend(t, r, null, { allOwnKeys: !0 }), t.create = function(a) {
    return SD(wa(e, a));
  }, t;
}
const At = SD(nl);
At.Axios = Ma;
At.CanceledError = Bo;
At.CancelToken = XL;
At.isCancel = fD;
At.VERSION = ED;
At.toFormData = uc;
At.AxiosError = nt;
At.Cancel = At.CanceledError;
At.all = function(e) {
  return Promise.all(e);
};
At.spread = QL;
At.isAxiosError = JL;
At.mergeConfig = wa;
At.AxiosHeaders = Xr;
At.formToJSON = (e) => uD(re.isHTMLForm(e) ? new FormData(e) : e);
At.getAdapter = mD.getAdapter;
At.HttpStatusCode = gp;
At.default = At;
const {
  Axios: t0e,
  AxiosError: r0e,
  CanceledError: n0e,
  isCancel: i0e,
  CancelToken: a0e,
  VERSION: o0e,
  all: s0e,
  Cancel: l0e,
  isAxiosError: c0e,
  spread: u0e,
  toFormData: f0e,
  AxiosHeaders: d0e,
  HttpStatusCode: p0e,
  formToJSON: h0e,
  getAdapter: _0e,
  mergeConfig: m0e
} = At, Dn = "https://api.regulaforensics.com".replace(/\/+$/, "");
class gh {
  constructor(r, t = Dn, a = At) {
    var o;
    this.basePath = t, this.axios = a, r && (this.configuration = r, this.basePath = (o = r.basePath) != null ? o : t);
  }
}
class eM extends Error {
  constructor(r, t) {
    super(t), this.field = r, this.name = "RequiredError";
  }
}
const ii = {}, ai = "https://example.com", Oi = function(e, r, t) {
  if (t == null)
    throw new eM(r, `Required parameter ${r} was null or undefined when calling ${e}.`);
};
function Rp(e, r, t = "") {
  r != null && (typeof r == "object" ? Array.isArray(r) ? r.forEach((a) => Rp(e, a, t)) : Object.keys(r).forEach(
    (a) => Rp(e, r[a], `${t}${t !== "" ? "." : ""}${a}`)
  ) : e.has(t) ? e.append(t, r) : e.set(t, r));
}
const oi = function(e, ...r) {
  const t = new URLSearchParams(e.search);
  Rp(t, r), e.search = t.toString();
}, ID = function(e, r, t) {
  const a = typeof e != "string";
  return (a && t && t.isJsonMime ? t.isJsonMime(r.headers["Content-Type"]) : a) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, si = function(e) {
  return e.pathname + e.search + e.hash;
}, li = function(e, r, t, a) {
  return (o = r, l = t) => {
    var u;
    const c = go(ke({}, e.options), { url: (o.defaults.baseURL ? "" : (u = a == null ? void 0 : a.basePath) != null ? u : l) + e.url });
    return o.request(c);
  };
}, tM = function(e) {
  return {
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthz: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/healthz", c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "GET" }, u), t), f = {}, h = {};
      r != null && (f["X-RequestID"] = String(r)), oi(c, h);
      let C = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), C), t.headers), {
        url: si(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ping: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/ping", c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "GET" }, u), t), f = {}, h = {};
      r != null && (f["X-RequestID"] = String(r)), oi(c, h);
      let C = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), C), t.headers), {
        url: si(c),
        options: p
      };
    }),
    /**
     * 
     * @summary License health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readyz: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/readyz", c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "GET" }, u), t), f = {}, h = {};
      r != null && (f["X-RequestID"] = String(r)), oi(c, h);
      let C = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), C), t.headers), {
        url: si(c),
        options: p
      };
    })
  };
}, F1 = function(e) {
  const r = tM(e);
  return {
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthz(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.healthz(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["HealthcheckApi.healthz"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    },
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ping(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.ping(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["HealthcheckApi.ping"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    },
    /**
     * 
     * @summary License health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readyz(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.readyz(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["HealthcheckApi.readyz"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    }
  };
};
class rM extends gh {
  /**
   * 
   * @summary Server health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  healthz(r, t) {
    return F1(this.configuration).healthz(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Server health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  ping(r, t) {
    return F1(this.configuration).ping(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary License health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  readyz(r, t) {
    return F1(this.configuration).readyz(r, t).then((a) => a(this.axios, this.basePath));
  }
}
const nM = function(e) {
  return {
    /**
     * 
     * @summary Process list of documents images and return extracted data
     * @param {ProcessRequest} processRequest 
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcess: (o, l, ...c) => Oe(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiProcess", "processRequest", r);
      const u = "/api/process", p = new URL(u, ai);
      let f;
      e && (f = e.baseOptions);
      const h = ke(ke({ method: "POST" }, f), a), C = {}, E = {};
      C["Content-Type"] = "application/json", t != null && (C["X-RequestID"] = String(t)), oi(p, E);
      let m = f && f.headers ? f.headers : {};
      return h.headers = ke(ke(ke({}, C), m), a.headers), h.data = ID(r, h, e), {
        url: si(p),
        options: h
      };
    })
  };
}, iM = function(e) {
  const r = nM(e);
  return {
    /**
     * 
     * @summary Process list of documents images and return extracted data
     * @param {ProcessRequest} processRequest 
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcess(a, o, l) {
      return Oe(this, null, function* () {
        var f, h, C;
        const c = yield r.apiProcess(a, o, l), u = (f = e == null ? void 0 : e.serverIndex) != null ? f : 0, p = (C = (h = ii["ProcessApi.apiProcess"]) == null ? void 0 : h[u]) == null ? void 0 : C.url;
        return (E, m) => li(c, At, Dn, e)(E, p || m);
      });
    }
  };
};
class aM extends gh {
  /**
   * 
   * @summary Process list of documents images and return extracted data
   * @param {ProcessRequest} processRequest 
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  apiProcess(r, t, a) {
    return iM(this.configuration).apiProcess(r, t, a).then((o) => o(this.axios, this.basePath));
  }
}
const oM = function(e) {
  return {
    /**
     * 
     * @summary Delete Reprocess transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdDelete: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TagTagIdDelete", "tagId", r);
      const l = "/api/v2/tag/{tagId}".replace("{tagId}", encodeURIComponent(String(r))), c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "DELETE" }, u), t), f = {};
      oi(c, {});
      let h = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), h), t.headers), {
        url: si(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Get transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdTransactionsGet: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TagTagIdTransactionsGet", "tagId", r);
      const l = "/api/v2/tag/{tagId}/transactions".replace("{tagId}", encodeURIComponent(String(r))), c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "GET" }, u), t), f = {};
      oi(c, {});
      let h = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), h), t.headers), {
        url: si(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction file
     * @param {string} transactionId Transaction id
     * @param {string} name File name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdFileGet: (o, l, ...c) => Oe(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiV2TransactionTransactionIdFileGet", "transactionId", r), Oi("apiV2TransactionTransactionIdFileGet", "name", t);
      const u = "/api/v2/transaction/{transactionId}/file".replace("{transactionId}", encodeURIComponent(String(r))), p = new URL(u, ai);
      let f;
      e && (f = e.baseOptions);
      const h = ke(ke({ method: "GET" }, f), a), C = {}, E = {};
      t !== void 0 && (E.name = t), oi(p, E);
      let m = f && f.headers ? f.headers : {};
      return h.headers = ke(ke(ke({}, C), m), a.headers), {
        url: si(p),
        options: h
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction data
     * @param {string} transactionId Transaction id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdGet: (a, ...o) => Oe(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TransactionTransactionIdGet", "transactionId", r);
      const l = "/api/v2/transaction/{transactionId}".replace("{transactionId}", encodeURIComponent(String(r))), c = new URL(l, ai);
      let u;
      e && (u = e.baseOptions);
      const p = ke(ke({ method: "GET" }, u), t), f = {};
      oi(c, {});
      let h = u && u.headers ? u.headers : {};
      return p.headers = ke(ke(ke({}, f), h), t.headers), {
        url: si(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Reprocess
     * @param {string} transactionId Transaction id
     * @param {TransactionProcessRequest} transactionProcessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdProcessPost: (o, l, ...c) => Oe(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiV2TransactionTransactionIdProcessPost", "transactionId", r), Oi("apiV2TransactionTransactionIdProcessPost", "transactionProcessRequest", t);
      const u = "/api/v2/transaction/{transactionId}/process".replace("{transactionId}", encodeURIComponent(String(r))), p = new URL(u, ai);
      let f;
      e && (f = e.baseOptions);
      const h = ke(ke({ method: "POST" }, f), a), C = {}, E = {};
      C["Content-Type"] = "application/json", oi(p, E);
      let m = f && f.headers ? f.headers : {};
      return h.headers = ke(ke(ke({}, C), m), a.headers), h.data = ID(t, h, e), {
        url: si(p),
        options: h
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction result
     * @param {string} transactionId Transaction id
     * @param {boolean} [withImages] With base64 images or url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdResultsGet: (o, l, ...c) => Oe(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiV2TransactionTransactionIdResultsGet", "transactionId", r);
      const u = "/api/v2/transaction/{transactionId}/results".replace("{transactionId}", encodeURIComponent(String(r))), p = new URL(u, ai);
      let f;
      e && (f = e.baseOptions);
      const h = ke(ke({ method: "GET" }, f), a), C = {}, E = {};
      t !== void 0 && (E.withImages = t), oi(p, E);
      let m = f && f.headers ? f.headers : {};
      return h.headers = ke(ke(ke({}, C), m), a.headers), {
        url: si(p),
        options: h
      };
    })
  };
}, Ao = function(e) {
  const r = oM(e);
  return {
    /**
     * 
     * @summary Delete Reprocess transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdDelete(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.apiV2TagTagIdDelete(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["TransactionApi.apiV2TagTagIdDelete"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    },
    /**
     * 
     * @summary Get transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdTransactionsGet(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.apiV2TagTagIdTransactionsGet(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["TransactionApi.apiV2TagTagIdTransactionsGet"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction file
     * @param {string} transactionId Transaction id
     * @param {string} name File name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdFileGet(a, o, l) {
      return Oe(this, null, function* () {
        var f, h, C;
        const c = yield r.apiV2TransactionTransactionIdFileGet(a, o, l), u = (f = e == null ? void 0 : e.serverIndex) != null ? f : 0, p = (C = (h = ii["TransactionApi.apiV2TransactionTransactionIdFileGet"]) == null ? void 0 : h[u]) == null ? void 0 : C.url;
        return (E, m) => li(c, At, Dn, e)(E, p || m);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction data
     * @param {string} transactionId Transaction id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdGet(a, o) {
      return Oe(this, null, function* () {
        var p, f, h;
        const l = yield r.apiV2TransactionTransactionIdGet(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, u = (h = (f = ii["TransactionApi.apiV2TransactionTransactionIdGet"]) == null ? void 0 : f[c]) == null ? void 0 : h.url;
        return (C, E) => li(l, At, Dn, e)(C, u || E);
      });
    },
    /**
     * 
     * @summary Reprocess
     * @param {string} transactionId Transaction id
     * @param {TransactionProcessRequest} transactionProcessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdProcessPost(a, o, l) {
      return Oe(this, null, function* () {
        var f, h, C;
        const c = yield r.apiV2TransactionTransactionIdProcessPost(a, o, l), u = (f = e == null ? void 0 : e.serverIndex) != null ? f : 0, p = (C = (h = ii["TransactionApi.apiV2TransactionTransactionIdProcessPost"]) == null ? void 0 : h[u]) == null ? void 0 : C.url;
        return (E, m) => li(c, At, Dn, e)(E, p || m);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction result
     * @param {string} transactionId Transaction id
     * @param {boolean} [withImages] With base64 images or url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdResultsGet(a, o, l) {
      return Oe(this, null, function* () {
        var f, h, C;
        const c = yield r.apiV2TransactionTransactionIdResultsGet(a, o, l), u = (f = e == null ? void 0 : e.serverIndex) != null ? f : 0, p = (C = (h = ii["TransactionApi.apiV2TransactionTransactionIdResultsGet"]) == null ? void 0 : h[u]) == null ? void 0 : C.url;
        return (E, m) => li(c, At, Dn, e)(E, p || m);
      });
    }
  };
};
class sM extends gh {
  /**
   * 
   * @summary Delete Reprocess transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TagTagIdDelete(r, t) {
    return Ao(this.configuration).apiV2TagTagIdDelete(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TagTagIdTransactionsGet(r, t) {
    return Ao(this.configuration).apiV2TagTagIdTransactionsGet(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction file
   * @param {string} transactionId Transaction id
   * @param {string} name File name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdFileGet(r, t, a) {
    return Ao(this.configuration).apiV2TransactionTransactionIdFileGet(r, t, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction data
   * @param {string} transactionId Transaction id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdGet(r, t) {
    return Ao(this.configuration).apiV2TransactionTransactionIdGet(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Reprocess
   * @param {string} transactionId Transaction id
   * @param {TransactionProcessRequest} transactionProcessRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdProcessPost(r, t, a) {
    return Ao(this.configuration).apiV2TransactionTransactionIdProcessPost(r, t, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction result
   * @param {string} transactionId Transaction id
   * @param {boolean} [withImages] With base64 images or url
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdResultsGet(r, t, a) {
    return Ao(this.configuration).apiV2TransactionTransactionIdResultsGet(r, t, a).then((o) => o(this.axios, this.basePath));
  }
}
var pr = /* @__PURE__ */ ((e) => (e[e.UV_LUMINESCENCE = 1] = "UV_LUMINESCENCE", e[e.IR_B900 = 2] = "IR_B900", e[e.IMAGE_PATTERN = 4] = "IMAGE_PATTERN", e[e.AXIAL_PROTECTION = 8] = "AXIAL_PROTECTION", e[e.UV_FIBERS = 16] = "UV_FIBERS", e[e.IR_VISIBILITY = 32] = "IR_VISIBILITY", e[e.OCR_SECURITY_TEXT = 64] = "OCR_SECURITY_TEXT", e[e.IPI = 128] = "IPI", e[e.PHOTO_EMBED_TYPE = 512] = "PHOTO_EMBED_TYPE", e[e.OVI = 1024] = "OVI", e[e.HOLOGRAMS = 4096] = "HOLOGRAMS", e[e.PHOTO_AREA = 8192] = "PHOTO_AREA", e[e.PORTRAIT_COMPARISON = 32768] = "PORTRAIT_COMPARISON", e[e.BARCODE_FORMAT_CHECK = 65536] = "BARCODE_FORMAT_CHECK", e[e.KINEGRAM = 131072] = "KINEGRAM", e[e.LETTER_SCREEN = 262144] = "LETTER_SCREEN", e[e.HOLOGRAM_DETECTION = 524288] = "HOLOGRAM_DETECTION", e[e.FINGERPRINT_COMPARISON = 1048576] = "FINGERPRINT_COMPARISON", e[e.LIVENESS = 2097152] = "LIVENESS", e[e.EXTENDED_OCR_CHECK = 4194304] = "EXTENDED_OCR_CHECK", e[e.EXTENDED_MRZ_CHECK = 8388608] = "EXTENDED_MRZ_CHECK", e[e.ENCRYPTED_IPI = 16777216] = "ENCRYPTED_IPI", e))(pr || {}), lM = /* @__PURE__ */ ((e) => (e[e.TEXT = 0] = "TEXT", e[e.BYTE = 1] = "BYTE", e[e.NUM = 2] = "NUM", e[e.SHIFT = 3] = "SHIFT", e[e.ALL = 4] = "ALL", e))(lM || {}), cM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.CODE128 = 1] = "CODE128", e[e.CODE39 = 2] = "CODE39", e[e.EAN8 = 3] = "EAN8", e[e.ITF = 4] = "ITF", e[e.PDF417 = 5] = "PDF417", e[e.STF = 6] = "STF", e[e.MTF = 7] = "MTF", e[e.IATA = 8] = "IATA", e[e.CODABAR = 9] = "CODABAR", e[e.UPCA = 10] = "UPCA", e[e.CODE93 = 11] = "CODE93", e[e.UPCE = 12] = "UPCE", e[e.EAN13 = 13] = "EAN13", e[e.QRCODE = 14] = "QRCODE", e[e.AZTEC = 15] = "AZTEC", e[e.DATAMATRIX = 16] = "DATAMATRIX", e[e.ALL_1D = 17] = "ALL_1D", e[e.CODE11 = 18] = "CODE11", e[e.JABCODE = 19] = "JABCODE", e))(cM || {}), uM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.PASS = 1] = "PASS", e[e.INVALID_INPUT_DATA = 2] = "INVALID_INPUT_DATA", e[e.INTERNAL_ERROR = 3] = "INTERNAL_ERROR", e[e.EXCEPTION_IN_MODULE = 4] = "EXCEPTION_IN_MODULE", e[e.UNCERTAIN_VERIFICATION = 5] = "UNCERTAIN_VERIFICATION", e[e.NECESSARY_IMAGE_NOT_FOUND = 7] = "NECESSARY_IMAGE_NOT_FOUND", e[e.PHOTO_SIDES_NOT_FOUND = 8] = "PHOTO_SIDES_NOT_FOUND", e[e.INVALID_CHECKSUM = 10] = "INVALID_CHECKSUM", e[e.SYNTAX_ERROR = 11] = "SYNTAX_ERROR", e[e.LOGIC_ERROR = 12] = "LOGIC_ERROR", e[e.SOURCES_COMPARISON_ERROR = 13] = "SOURCES_COMPARISON_ERROR", e[e.FIELDS_COMPARISON_LOGIC_ERROR = 14] = "FIELDS_COMPARISON_LOGIC_ERROR", e[e.INVALID_FIELD_FORMAT = 15] = "INVALID_FIELD_FORMAT", e[e.TRUE_LUMINESCENCE_ERROR = 20] = "TRUE_LUMINESCENCE_ERROR", e[e.FALSE_LUMINESCENCE_ERROR = 21] = "FALSE_LUMINESCENCE_ERROR", e[e.FIXED_PATTERN_ERROR = 22] = "FIXED_PATTERN_ERROR", e[e.LOW_CONTRAST_IN_IR_LIGHT = 23] = "LOW_CONTRAST_IN_IR_LIGHT", e[e.INCORRECT_BACKGROUND_LIGHT = 24] = "INCORRECT_BACKGROUND_LIGHT", e[e.BACKGROUND_COMPARISON_ERROR = 25] = "BACKGROUND_COMPARISON_ERROR", e[e.INCORRECT_TEXT_COLOR = 26] = "INCORRECT_TEXT_COLOR", e[e.PHOTO_FALSE_LUMINESCENCE = 27] = "PHOTO_FALSE_LUMINESCENCE", e[e.TOO_MUCH_SHIFT = 28] = "TOO_MUCH_SHIFT", e[e.CONTACT_CHIP_TYPE_MISMATCH = 29] = "CONTACT_CHIP_TYPE_MISMATCH", e[e.FIBERS_NOT_FOUND = 30] = "FIBERS_NOT_FOUND", e[e.TOO_MANY_OBJECTS = 31] = "TOO_MANY_OBJECTS", e[e.SPECKS_IN_UV = 33] = "SPECKS_IN_UV", e[e.TOO_LOW_RESOLUTION = 34] = "TOO_LOW_RESOLUTION", e[e.INVISIBLE_ELEMENT_PRESENT = 40] = "INVISIBLE_ELEMENT_PRESENT", e[e.VISIBLE_ELEMENT_ABSENT = 41] = "VISIBLE_ELEMENT_ABSENT", e[e.ELEMENT_SHOULD_BE_COLORED = 42] = "ELEMENT_SHOULD_BE_COLORED", e[e.ELEMENT_SHOULD_BE_GRAYSCALE = 43] = "ELEMENT_SHOULD_BE_GRAYSCALE", e[e.PHOTO_WHITE_IR_DONT_MATCH = 44] = "PHOTO_WHITE_IR_DONT_MATCH", e[e.UV_DULL_PAPER_MRZ = 50] = "UV_DULL_PAPER_MRZ", e[e.FALSE_LUMINESCENCE_IN_MRZ = 51] = "FALSE_LUMINESCENCE_IN_MRZ", e[e.UV_DULL_PAPER_PHOTO = 52] = "UV_DULL_PAPER_PHOTO", e[e.UV_DULL_PAPER_BLANK = 53] = "UV_DULL_PAPER_BLANK", e[e.UV_DULL_PAPER_ERROR = 54] = "UV_DULL_PAPER_ERROR", e[e.FALSE_LUMINESCENCE_IN_BLANK = 55] = "FALSE_LUMINESCENCE_IN_BLANK", e[e.BAD_AREA_IN_AXIAL = 60] = "BAD_AREA_IN_AXIAL", e[e.FALSE_IPI_PARAMETERS = 65] = "FALSE_IPI_PARAMETERS", e[e.ENCRYPTED_IPI_NOT_FOUND = 66] = "ENCRYPTED_IPI_NOT_FOUND", e[e.ENCRYPTED_IPI_DATA_DONT_MATCH = 67] = "ENCRYPTED_IPI_DATA_DONT_MATCH", e[e.FIELD_POS_CORRECTOR_HIGHLIGHT_IR = 80] = "FIELD_POS_CORRECTOR_HIGHLIGHT_IR", e[e.FIELD_POS_CORRECTOR_GLARES_IN_PHOTO_AREA = 81] = "FIELD_POS_CORRECTOR_GLARES_IN_PHOTO_AREA", e[e.FIELD_POS_CORRECTOR_PHOTO_REPLACED = 82] = "FIELD_POS_CORRECTOR_PHOTO_REPLACED", e[e.FIELD_POS_CORRECTOR_LANDMARKS_CHECK_ERROR = 83] = "FIELD_POS_CORRECTOR_LANDMARKS_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_FACE_PRESENCE_CHECK_ERROR = 84] = "FIELD_POS_CORRECTOR_FACE_PRESENCE_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_FACE_ABSENCE_CHECK_ERROR = 85] = "FIELD_POS_CORRECTOR_FACE_ABSENCE_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_INCORRECT_HEAD_POSITION = 86] = "FIELD_POS_CORRECTOR_INCORRECT_HEAD_POSITION", e[e.OVI_IR_INVISIBLE = 90] = "OVI_IR_INVISIBLE", e[e.OVI_INSUFFICIENT_AREA = 91] = "OVI_INSUFFICIENT_AREA", e[e.OVI_COLOR_INVARIABLE = 92] = "OVI_COLOR_INVARIABLE", e[e.OVI_BAD_COLOR_FRONT = 93] = "OVI_BAD_COLOR_FRONT", e[e.OVI_BAD_COLOR_SIDE = 94] = "OVI_BAD_COLOR_SIDE", e[e.OVI_WIDE_COLOR_SPREAD = 95] = "OVI_WIDE_COLOR_SPREAD", e[e.OVI_BAD_COLOR_PERCENT = 96] = "OVI_BAD_COLOR_PERCENT", e[e.HOLOGRAM_ELEMENT_ABSENT = 100] = "HOLOGRAM_ELEMENT_ABSENT", e[e.HOLOGRAM_SIDE_TOP_IMAGES_ABSENT = 101] = "HOLOGRAM_SIDE_TOP_IMAGES_ABSENT", e[e.HOLOGRAM_ELEMENT_PRESENT = 102] = "HOLOGRAM_ELEMENT_PRESENT", e[e.HOLOGRAM_FRAMES_IS_ABSENT = 103] = "HOLOGRAM_FRAMES_IS_ABSENT", e[e.HOLOGRAM_HOLO_FIELD_IS_ABSENT = 104] = "HOLOGRAM_HOLO_FIELD_IS_ABSENT", e[e.PHOTO_PATTERN_INTERRUPTED = 110] = "PHOTO_PATTERN_INTERRUPTED", e[e.PHOTO_PATTERN_SHIFTED = 111] = "PHOTO_PATTERN_SHIFTED", e[e.PHOTO_PATTERN_DIFFERENT_COLORS = 112] = "PHOTO_PATTERN_DIFFERENT_COLORS", e[e.PHOTO_PATTERN_IR_VISIBLE = 113] = "PHOTO_PATTERN_IR_VISIBLE", e[e.PHOTO_PATTERN_NOT_INTERSECT = 114] = "PHOTO_PATTERN_NOT_INTERSECT", e[e.PHOTO_SIZE_IS_WRONG = 115] = "PHOTO_SIZE_IS_WRONG", e[e.PHOTO_PATTERN_INVALID_COLOR = 116] = "PHOTO_PATTERN_INVALID_COLOR", e[e.PHOTO_PATTERN_SHIFTED_VERT = 117] = "PHOTO_PATTERN_SHIFTED_VERT", e[e.PHOTO_PATTERN_PATTERN_NOT_FOUND = 118] = "PHOTO_PATTERN_PATTERN_NOT_FOUND", e[e.PHOTO_PATTERN_DIFFERENT_LINES_THICKNESS = 119] = "PHOTO_PATTERN_DIFFERENT_LINES_THICKNESS", e[e.PHOTO_IS_NOT_RECTANGLE = 120] = "PHOTO_IS_NOT_RECTANGLE", e[e.PHOTO_CORNERS_IS_WRONG = 121] = "PHOTO_CORNERS_IS_WRONG", e[e.DOCUMENT_IS_CANCELLING = 122] = "DOCUMENT_IS_CANCELLING", e[e.TEXT_COLOR_SHOULD_BE_BLUE = 130] = "TEXT_COLOR_SHOULD_BE_BLUE", e[e.TEXT_COLOR_SHOULD_BE_GREEN = 131] = "TEXT_COLOR_SHOULD_BE_GREEN", e[e.TEXT_COLOR_SHOULD_BE_RED = 132] = "TEXT_COLOR_SHOULD_BE_RED", e[e.TEXT_SHOULD_BE_BLACK = 133] = "TEXT_SHOULD_BE_BLACK", e[e.TEXT_IS_ABSENT = 134] = "TEXT_IS_ABSENT", e[e.BARCODE_WAS_READ_WITH_ERRORS = 140] = "BARCODE_WAS_READ_WITH_ERRORS", e[e.BARCODE_DATA_FORMAT_ERROR = 141] = "BARCODE_DATA_FORMAT_ERROR", e[e.BARCODE_SIZE_PARAMS_ERROR = 142] = "BARCODE_SIZE_PARAMS_ERROR", e[e.NOT_ALL_BARCODES_READ = 143] = "NOT_ALL_BARCODES_READ", e[e.GLARES_IN_BARCODE_AREA = 144] = "GLARES_IN_BARCODE_AREA", e[e.NO_CERTIFICATE_FOR_DIGITAL_SIGNATURE_CHECK = 145] = "NO_CERTIFICATE_FOR_DIGITAL_SIGNATURE_CHECK", e[e.PORTRAIT_COMPARISON_PORTRAITS_DIFFER = 150] = "PORTRAIT_COMPARISON_PORTRAITS_DIFFER", e[e.PORTRAIT_COMPARISON_NO_SERVICE_REPLY = 151] = "PORTRAIT_COMPARISON_NO_SERVICE_REPLY", e[e.PORTRAIT_COMPARISON_SERVICE_ERROR = 152] = "PORTRAIT_COMPARISON_SERVICE_ERROR", e[e.PORTRAIT_COMPARISON_NOT_ENOUGH_IMAGES = 153] = "PORTRAIT_COMPARISON_NOT_ENOUGH_IMAGES", e[e.PORTRAIT_COMPARISON_NO_LIVE_PHOTO = 154] = "PORTRAIT_COMPARISON_NO_LIVE_PHOTO", e[e.PORTRAIT_COMPARISON_NO_SERVICE_LICENSE = 155] = "PORTRAIT_COMPARISON_NO_SERVICE_LICENSE", e[e.PORTRAIT_COMPARISON_NO_PORTRAIT_DETECTED = 156] = "PORTRAIT_COMPARISON_NO_PORTRAIT_DETECTED", e[e.MOBILE_IMAGES_UNSUITABLE_LIGHT_CONDITIONS = 160] = "MOBILE_IMAGES_UNSUITABLE_LIGHT_CONDITIONS", e[e.MOBILE_IMAGES_WHITE_UV_NO_DIFFERENCE = 161] = "MOBILE_IMAGES_WHITE_UV_NO_DIFFERENCE", e[e.FINGERPRINTS_COMPARISON_MISMATCH = 170] = "FINGERPRINTS_COMPARISON_MISMATCH", e[e.HOLO_PHOTO_FACE_NOT_DETECTED = 180] = "HOLO_PHOTO_FACE_NOT_DETECTED", e[e.HOLO_PHOTO_FACE_COMPARISON_FAILED = 181] = "HOLO_PHOTO_FACE_COMPARISON_FAILED", e[e.HOLO_PHOTO_GLARE_IN_CENTER_ABSENT = 182] = "HOLO_PHOTO_GLARE_IN_CENTER_ABSENT", e[e.HOLO_PHOTO_HOLO_ELEMENT_SHAPE_ERROR = 183] = "HOLO_PHOTO_HOLO_ELEMENT_SHAPE_ERROR", e[e.HOLO_PHOTO_ALGORITHMS_STEPS_ERROR = 184] = "HOLO_PHOTO_ALGORITHMS_STEPS_ERROR", e[e.HOLO_PHOTO_HOLO_AREAS_NOT_LOADED = 185] = "HOLO_PHOTO_HOLO_AREAS_NOT_LOADED", e[e.HOLO_PHOTO_FINISHED_BY_TIMEOUT = 186] = "HOLO_PHOTO_FINISHED_BY_TIMEOUT", e[e.HOLO_PHOTO_DOCUMENT_OUTSIDE_FRAME = 187] = "HOLO_PHOTO_DOCUMENT_OUTSIDE_FRAME", e[e.LIVENESS_DEPTH_CHECK_FAILED = 190] = "LIVENESS_DEPTH_CHECK_FAILED", e[e.MRZ_QUALITY_WRONG_SYMBOL_POSITION = 200] = "MRZ_QUALITY_WRONG_SYMBOL_POSITION", e[e.MRZ_QUALITY_WRONG_BACKGROUND = 201] = "MRZ_QUALITY_WRONG_BACKGROUND", e[e.MRZ_QUALITY_WRONG_MRZ_WIDTH = 202] = "MRZ_QUALITY_WRONG_MRZ_WIDTH", e[e.MRZ_QUALITY_WRONG_MRZ_HEIGHT = 203] = "MRZ_QUALITY_WRONG_MRZ_HEIGHT", e[e.MRZ_QUALITY_WRONG_LINE_POSITION = 204] = "MRZ_QUALITY_WRONG_LINE_POSITION", e[e.MRZ_QUALITY_WRONG_FONT_TYPE = 205] = "MRZ_QUALITY_WRONG_FONT_TYPE", e[e.OCR_QUALITY_TEXT_POSITION = 220] = "OCR_QUALITY_TEXT_POSITION", e[e.OCR_QUALITY_INVALID_FONT = 221] = "OCR_QUALITY_INVALID_FONT", e[e.OCR_QUALITY_INVALID_BACKGROUND = 222] = "OCR_QUALITY_INVALID_BACKGROUND", e[e.LASINK_INVALID_LINES_FREQUENCY = 230] = "LASINK_INVALID_LINES_FREQUENCY", e[e.DOC_LIVENESS_DOCUMENT_NOT_LIVE = 238] = "DOC_LIVENESS_DOCUMENT_NOT_LIVE", e[e.DOC_LIVENESS_BLACK_AND_WHITE_COPY_DETECTED = 239] = "DOC_LIVENESS_BLACK_AND_WHITE_COPY_DETECTED", e[e.DOC_LIVENESS_ELECTRONIC_DEVICE_DETECTED = 240] = "DOC_LIVENESS_ELECTRONIC_DEVICE_DETECTED", e[e.DOC_LIVENESS_INVALID_BARCODE_BACKGROUND = 241] = "DOC_LIVENESS_INVALID_BARCODE_BACKGROUND", e[e.CHD_ICAO_IDB_BASE32_ERROR = 243] = "CHD_ICAO_IDB_BASE32_ERROR", e[e.CHD_ICAO_IDB_ZIPPED_ERROR = 244] = "CHD_ICAO_IDB_ZIPPED_ERROR", e[e.CHD_ICAO_IDB_MESSAGE_ZONE_EMPTY = 245] = "CHD_ICAO_IDB_MESSAGE_ZONE_EMPTY", e[e.CHD_ICAO_IDB_SIGNATURE_MUST_BE_PRESENT = 246] = "CHD_ICAO_IDB_SIGNATURE_MUST_BE_PRESENT", e[e.CHD_ICAO_IDB_SIGNATURE_MUST_NOT_BE_PRESENT = 247] = "CHD_ICAO_IDB_SIGNATURE_MUST_NOT_BE_PRESENT", e[e.CHD_ICAO_IDB_CERTIFICATE_MUST_NOT_BE_PRESENT = 248] = "CHD_ICAO_IDB_CERTIFICATE_MUST_NOT_BE_PRESENT", e[e.CHD_INCORRECT_OBJECT_COLOR = 250] = "CHD_INCORRECT_OBJECT_COLOR", e))(uM || {}), Mi = /* @__PURE__ */ ((e) => (e[e.ERROR = 0] = "ERROR", e[e.OK = 1] = "OK", e[e.WAS_NOT_DONE = 2] = "WAS_NOT_DONE", e))(Mi || {}), fM = /* @__PURE__ */ ((e) => (e[e.NOT_CRITICAL = 0] = "NOT_CRITICAL", e[e.CRITICAL = 1] = "CRITICAL", e))(fM || {}), dM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = -1] = "UNKNOWN", e[e.ID1 = 0] = "ID1", e[e.ID2 = 1] = "ID2", e[e.ID3 = 2] = "ID3", e[e.NON = 3] = "NON", e[e.A4 = 4] = "A4", e[e.ID3_X2 = 5] = "ID3_X2", e[e.ID1_90 = 10] = "ID1_90", e[e.ID1_180 = 11] = "ID1_180", e[e.ID1_270 = 12] = "ID1_270", e[e.ID2_180 = 13] = "ID2_180", e[e.ID3_180 = 14] = "ID3_180", e[e.CUSTOM = 1e3] = "CUSTOM", e[e.FLEXIBLE = 1002] = "FLEXIBLE", e))(dM || {}), pM = /* @__PURE__ */ ((e) => (e[e.NOT_DEFINED = 0] = "NOT_DEFINED", e[e.PASSPORT = 11] = "PASSPORT", e[e.IDENTITY_CARD = 12] = "IDENTITY_CARD", e[e.DIPLOMATIC_PASSPORT = 13] = "DIPLOMATIC_PASSPORT", e[e.SERVICE_PASSPORT = 14] = "SERVICE_PASSPORT", e[e.SEAMANS_IDENTITY_DOCUMENT = 15] = "SEAMANS_IDENTITY_DOCUMENT", e[e.IDENTITY_CARD_FOR_RESIDENCE = 16] = "IDENTITY_CARD_FOR_RESIDENCE", e[e.TRAVEL_DOCUMENT = 17] = "TRAVEL_DOCUMENT", e[e.NATIONAL_IDENTITY_CARD = 20] = "NATIONAL_IDENTITY_CARD", e[e.SOCIAL_IDENTITY_CARD = 21] = "SOCIAL_IDENTITY_CARD", e[e.ALIENS_IDENTITY_CARD = 22] = "ALIENS_IDENTITY_CARD", e[e.PRIVILEGED_IDENTITY_CARD = 23] = "PRIVILEGED_IDENTITY_CARD", e[e.RESIDENCE_PERMIT_IDENTITY_CARD = 24] = "RESIDENCE_PERMIT_IDENTITY_CARD", e[e.ORIGIN_CARD = 25] = "ORIGIN_CARD", e[e.EMERGENCY_PASSPORT = 26] = "EMERGENCY_PASSPORT", e[e.ALIENS_PASSPORT = 27] = "ALIENS_PASSPORT", e[e.ALTERNATIVE_IDENTITY_CARD = 28] = "ALTERNATIVE_IDENTITY_CARD", e[e.VISA_ID2 = 29] = "VISA_ID2", e[e.VISA_ID3 = 30] = "VISA_ID3", e[e.AUTHORIZATION_CARD = 32] = "AUTHORIZATION_CARD", e[e.BEGINNER_PERMIT = 33] = "BEGINNER_PERMIT", e[e.BORDER_CROSSING_CARD = 34] = "BORDER_CROSSING_CARD", e[e.CHAUFFEUR_LICENSE = 35] = "CHAUFFEUR_LICENSE", e[e.CHAUFFEUR_LICENSE_UNDER_18 = 36] = "CHAUFFEUR_LICENSE_UNDER_18", e[e.CHAUFFEUR_LICENSE_UNDER_21 = 37] = "CHAUFFEUR_LICENSE_UNDER_21", e[e.COMMERCIAL_DRIVING_LICENSE = 38] = "COMMERCIAL_DRIVING_LICENSE", e[e.COMMERCIAL_DRIVING_LICENSE_INSTRUCTIONAL_PERMIT = 39] = "COMMERCIAL_DRIVING_LICENSE_INSTRUCTIONAL_PERMIT", e[e.COMMERCIAL_DRIVING_LICENSE_UNDER_18 = 40] = "COMMERCIAL_DRIVING_LICENSE_UNDER_18", e[e.COMMERCIAL_DRIVING_LICENSE_UNDER_21 = 41] = "COMMERCIAL_DRIVING_LICENSE_UNDER_21", e[e.COMMERCIAL_INSTRUCTION_PERMIT = 42] = "COMMERCIAL_INSTRUCTION_PERMIT", e[e.COMMERCIAL_NEW_PERMIT = 43] = "COMMERCIAL_NEW_PERMIT", e[e.CONCEALED_CARRY_LICENSE = 44] = "CONCEALED_CARRY_LICENSE", e[e.CONCEALED_FIREARM_PERMIT = 45] = "CONCEALED_FIREARM_PERMIT", e[e.CONDITIONAL_DRIVING_LICENSE = 46] = "CONDITIONAL_DRIVING_LICENSE", e[e.DEPARTMENT_OF_VETERANS_AFFAIRS_IDENTITY_CARD = 47] = "DEPARTMENT_OF_VETERANS_AFFAIRS_IDENTITY_CARD", e[e.DIPLOMATIC_DRIVING_LICENSE = 48] = "DIPLOMATIC_DRIVING_LICENSE", e[e.DRIVING_LICENSE = 49] = "DRIVING_LICENSE", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT = 50] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_18 = 51] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_18", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_21 = 52] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_21", e[e.DRIVING_LICENSE_LEARNERS_PERMIT = 53] = "DRIVING_LICENSE_LEARNERS_PERMIT", e[e.DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_18 = 54] = "DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_18", e[e.DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_21 = 55] = "DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_21", e[e.DRIVING_LICENSE_NOVICE = 56] = "DRIVING_LICENSE_NOVICE", e[e.DRIVING_LICENSE_NOVICE_UNDER_18 = 57] = "DRIVING_LICENSE_NOVICE_UNDER_18", e[e.DRIVING_LICENSE_NOVICE_UNDER_21 = 58] = "DRIVING_LICENSE_NOVICE_UNDER_21", e[e.DRIVING_LICENSE_REGISTERED_OFFENDER = 59] = "DRIVING_LICENSE_REGISTERED_OFFENDER", e[e.DRIVING_LICENSE_RESTRICTED_UNDER_18 = 60] = "DRIVING_LICENSE_RESTRICTED_UNDER_18", e[e.DRIVING_LICENSE_RESTRICTED_UNDER_21 = 61] = "DRIVING_LICENSE_RESTRICTED_UNDER_21", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR = 62] = "DRIVING_LICENSE_TEMPORARY_VISITOR", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_18 = 63] = "DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_18", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_21 = 64] = "DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_21", e[e.DRIVING_LICENSE_UNDER_18 = 65] = "DRIVING_LICENSE_UNDER_18", e[e.DRIVING_LICENSE_UNDER_21 = 66] = "DRIVING_LICENSE_UNDER_21", e[e.EMPLOYMENT_DRIVING_PERMIT = 67] = "EMPLOYMENT_DRIVING_PERMIT", e[e.ENHANCED_CHAUFFEUR_LICENSE = 68] = "ENHANCED_CHAUFFEUR_LICENSE", e[e.ENHANCED_CHAUFFEUR_LICENSE_UNDER_18 = 69] = "ENHANCED_CHAUFFEUR_LICENSE_UNDER_18", e[e.ENHANCED_CHAUFFEUR_LICENSE_UNDER_21 = 70] = "ENHANCED_CHAUFFEUR_LICENSE_UNDER_21", e[e.ENHANCED_COMMERCIAL_DRIVING_LICENSE = 71] = "ENHANCED_COMMERCIAL_DRIVING_LICENSE", e[e.ENHANCED_DRIVING_LICENSE = 72] = "ENHANCED_DRIVING_LICENSE", e[e.ENHANCED_DRIVING_LICENSE_UNDER_18 = 73] = "ENHANCED_DRIVING_LICENSE_UNDER_18", e[e.ENHANCED_DRIVING_LICENSE_UNDER_21 = 74] = "ENHANCED_DRIVING_LICENSE_UNDER_21", e[e.ENHANCED_IDENTITY_CARD = 75] = "ENHANCED_IDENTITY_CARD", e[e.ENHANCED_IDENTITY_CARD_UNDER_18 = 76] = "ENHANCED_IDENTITY_CARD_UNDER_18", e[e.ENHANCED_IDENTITY_CARD_UNDER_21 = 77] = "ENHANCED_IDENTITY_CARD_UNDER_21", e[e.ENHANCED_OPERATORS_LICENSE = 78] = "ENHANCED_OPERATORS_LICENSE", e[e.FIREARMS_PERMIT = 79] = "FIREARMS_PERMIT", e[e.FULL_PROVISIONAL_LICENSE = 80] = "FULL_PROVISIONAL_LICENSE", e[e.FULL_PROVISIONAL_LICENSE_UNDER_18 = 81] = "FULL_PROVISIONAL_LICENSE_UNDER_18", e[e.FULL_PROVISIONAL_LICENSE_UNDER_21 = 82] = "FULL_PROVISIONAL_LICENSE_UNDER_21", e[e.GENEVA_CONVENTIONS_IDENTITY_CARD = 83] = "GENEVA_CONVENTIONS_IDENTITY_CARD", e[e.GRADUATED_DRIVING_LICENSE_UNDER_18 = 84] = "GRADUATED_DRIVING_LICENSE_UNDER_18", e[e.GRADUATED_DRIVING_LICENSE_UNDER_21 = 85] = "GRADUATED_DRIVING_LICENSE_UNDER_21", e[e.GRADUATED_INSTRUCTION_PERMIT_UNDER_18 = 86] = "GRADUATED_INSTRUCTION_PERMIT_UNDER_18", e[e.GRADUATED_INSTRUCTION_PERMIT_UNDER_21 = 87] = "GRADUATED_INSTRUCTION_PERMIT_UNDER_21", e[e.GRADUATED_LICENSE_UNDER_18 = 88] = "GRADUATED_LICENSE_UNDER_18", e[e.GRADUATED_LICENSE_UNDER_21 = 89] = "GRADUATED_LICENSE_UNDER_21", e[e.HANDGUN_CARRY_PERMIT = 90] = "HANDGUN_CARRY_PERMIT", e[e.IDENTITY_AND_PRIVILEGE_CARD = 91] = "IDENTITY_AND_PRIVILEGE_CARD", e[e.IDENTITY_CARD_MOBILITY_IMPAIRED = 92] = "IDENTITY_CARD_MOBILITY_IMPAIRED", e[e.IDENTITY_CARD_REGISTERED_OFFENDER = 93] = "IDENTITY_CARD_REGISTERED_OFFENDER", e[e.IDENTITY_CARD_TEMPORARY_VISITOR = 94] = "IDENTITY_CARD_TEMPORARY_VISITOR", e[e.IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_18 = 95] = "IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_18", e[e.IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_21 = 96] = "IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_21", e[e.IDENTITY_CARD_UNDER_18 = 97] = "IDENTITY_CARD_UNDER_18", e[e.IDENTITY_CARD_UNDER_21 = 98] = "IDENTITY_CARD_UNDER_21", e[e.OTHER = 99] = "OTHER", e[e.IGNITION_INTERLOCK_PERMIT = 100] = "IGNITION_INTERLOCK_PERMIT", e[e.IMMIGRANT_VISA = 101] = "IMMIGRANT_VISA", e[e.INSTRUCTION_PERMIT = 102] = "INSTRUCTION_PERMIT", e[e.INSTRUCTION_PERMIT_UNDER_18 = 103] = "INSTRUCTION_PERMIT_UNDER_18", e[e.INSTRUCTION_PERMIT_UNDER_21 = 104] = "INSTRUCTION_PERMIT_UNDER_21", e[e.INTERIM_DRIVING_LICENSE = 105] = "INTERIM_DRIVING_LICENSE", e[e.INTERIM_IDENTITY_CARD = 106] = "INTERIM_IDENTITY_CARD", e[e.INTERMEDIATE_DRIVING_LICENSE = 107] = "INTERMEDIATE_DRIVING_LICENSE", e[e.INTERMEDIATE_DRIVING_LICENSE_UNDER_18 = 108] = "INTERMEDIATE_DRIVING_LICENSE_UNDER_18", e[e.INTERMEDIATE_DRIVING_LICENSE_UNDER_21 = 109] = "INTERMEDIATE_DRIVING_LICENSE_UNDER_21", e[e.JUNIOR_DRIVING_LICENSE = 110] = "JUNIOR_DRIVING_LICENSE", e[e.LEARNER_INSTRUCTIONAL_PERMIT = 111] = "LEARNER_INSTRUCTIONAL_PERMIT", e[e.LEARNER_LICENSE = 112] = "LEARNER_LICENSE", e[e.LEARNER_LICENSE_UNDER_18 = 113] = "LEARNER_LICENSE_UNDER_18", e[e.LEARNER_LICENSE_UNDER_21 = 114] = "LEARNER_LICENSE_UNDER_21", e[e.LEARNER_PERMIT = 115] = "LEARNER_PERMIT", e[e.LEARNER_PERMIT_UNDER_18 = 116] = "LEARNER_PERMIT_UNDER_18", e[e.LEARNER_PERMIT_UNDER_21 = 117] = "LEARNER_PERMIT_UNDER_21", e[e.LIMITED_LICENSE = 118] = "LIMITED_LICENSE", e[e.LIMITED_PERMIT = 119] = "LIMITED_PERMIT", e[e.LIMITED_TERM_DRIVING_LICENSE = 120] = "LIMITED_TERM_DRIVING_LICENSE", e[e.LIMITED_TERM_IDENTITY_CARD = 121] = "LIMITED_TERM_IDENTITY_CARD", e[e.LIQUOR_IDENTITY_CARD = 122] = "LIQUOR_IDENTITY_CARD", e[e.NEW_PERMIT = 123] = "NEW_PERMIT", e[e.NEW_PERMIT_UNDER_18 = 124] = "NEW_PERMIT_UNDER_18", e[e.NEW_PERMIT_UNDER_21 = 125] = "NEW_PERMIT_UNDER_21", e[e.NON_US_CITIZEN_DRIVING_LICENSE = 126] = "NON_US_CITIZEN_DRIVING_LICENSE", e[e.OCCUPATIONAL_DRIVING_LICENSE = 127] = "OCCUPATIONAL_DRIVING_LICENSE", e[e.ONEIDA_TRIBE_OF_INDIANS_IDENTITY_CARD = 128] = "ONEIDA_TRIBE_OF_INDIANS_IDENTITY_CARD", e[e.OPERATOR_LICENSE = 129] = "OPERATOR_LICENSE", e[e.OPERATOR_LICENSE_UNDER_18 = 130] = "OPERATOR_LICENSE_UNDER_18", e[e.OPERATOR_LICENSE_UNDER_21 = 131] = "OPERATOR_LICENSE_UNDER_21", e[e.PERMANENT_DRIVING_LICENSE = 132] = "PERMANENT_DRIVING_LICENSE", e[e.PERMIT_TO_REENTER = 133] = "PERMIT_TO_REENTER", e[e.PROBATIONARY_AUTO_LICENSE = 134] = "PROBATIONARY_AUTO_LICENSE", e[e.PROBATIONARY_DRIVING_LICENSE_UNDER_18 = 135] = "PROBATIONARY_DRIVING_LICENSE_UNDER_18", e[e.PROBATIONARY_DRIVING_LICENSE_UNDER_21 = 136] = "PROBATIONARY_DRIVING_LICENSE_UNDER_21", e[e.PROBATIONARY_VEHICLE_SALES_PERSON_LICENSE = 137] = "PROBATIONARY_VEHICLE_SALES_PERSON_LICENSE", e[e.PROVISIONAL_DRIVING_LICENSE = 138] = "PROVISIONAL_DRIVING_LICENSE", e[e.PROVISIONAL_DRIVING_LICENSE_UNDER_18 = 139] = "PROVISIONAL_DRIVING_LICENSE_UNDER_18", e[e.PROVISIONAL_DRIVING_LICENSE_UNDER_21 = 140] = "PROVISIONAL_DRIVING_LICENSE_UNDER_21", e[e.PROVISIONAL_LICENSE = 141] = "PROVISIONAL_LICENSE", e[e.PROVISIONAL_LICENSE_UNDER_18 = 142] = "PROVISIONAL_LICENSE_UNDER_18", e[e.PROVISIONAL_LICENSE_UNDER_21 = 143] = "PROVISIONAL_LICENSE_UNDER_21", e[e.PUBLIC_PASSENGER_CHAUFFEUR_LICENSE = 144] = "PUBLIC_PASSENGER_CHAUFFEUR_LICENSE", e[e.RACING_AND_GAMING_COMISSION_CARD = 145] = "RACING_AND_GAMING_COMISSION_CARD", e[e.REFUGEE_TRAVEL_DOCUMENT = 146] = "REFUGEE_TRAVEL_DOCUMENT", e[e.RENEWAL_PERMIT = 147] = "RENEWAL_PERMIT", e[e.RESTRICTED_COMMERCIAL_DRIVER_LICENSE = 148] = "RESTRICTED_COMMERCIAL_DRIVER_LICENSE", e[e.RESTRICTED_DRIVER_LICENSE = 149] = "RESTRICTED_DRIVER_LICENSE", e[e.RESTRICTED_PERMIT = 150] = "RESTRICTED_PERMIT", e[e.SEASONAL_PERMIT = 151] = "SEASONAL_PERMIT", e[e.SEASONAL_RESIDENT_IDENTITY_CARD = 152] = "SEASONAL_RESIDENT_IDENTITY_CARD", e[e.SEASONAL_CITIZEN_IDENTITY_CARD = 153] = "SEASONAL_CITIZEN_IDENTITY_CARD", e[e.SEX_OFFENDER = 154] = "SEX_OFFENDER", e[e.SOCIAL_SECURITY_CARD = 155] = "SOCIAL_SECURITY_CARD", e[e.TEMPORARY_DRIVING_LICENSE = 156] = "TEMPORARY_DRIVING_LICENSE", e[e.TEMPORARY_DRIVING_LICENSE_UNDER_18 = 157] = "TEMPORARY_DRIVING_LICENSE_UNDER_18", e[e.TEMPORARY_DRIVING_LICENSE_UNDER_21 = 158] = "TEMPORARY_DRIVING_LICENSE_UNDER_21", e[e.TEMPORARY_IDENTITY_CARD = 159] = "TEMPORARY_IDENTITY_CARD", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD = 160] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_18 = 161] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_18", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_21 = 162] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_21", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE = 163] = "TEMPORARY_VISITOR_DRIVING_LICENSE", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_18 = 164] = "TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_18", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_21 = 165] = "TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_21", e[e.UNIFORMED_SERVICES_IDENTITY_CARD = 166] = "UNIFORMED_SERVICES_IDENTITY_CARD", e[e.VEHICLE_SALES_PERSON_LICENSE = 167] = "VEHICLE_SALES_PERSON_LICENSE", e[e.WORKER_IDENTIFICATION_CREDENTIAL = 168] = "WORKER_IDENTIFICATION_CREDENTIAL", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE = 169] = "COMMERCIAL_DRIVING_LICENSE_NOVICE", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_18 = 170] = "COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_18", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_21 = 171] = "COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_21", e[e.PASSPORT_CARD = 172] = "PASSPORT_CARD", e[e.PASSPORT_RESIDENT_CARD = 173] = "PASSPORT_RESIDENT_CARD", e[e.PERSONAL_IDENTIFICATION_VERIFICATION = 174] = "PERSONAL_IDENTIFICATION_VERIFICATION", e[e.TEMPORARY_OPERATOR_LICENSE = 175] = "TEMPORARY_OPERATOR_LICENSE", e[e.DRIVING_LICENSE_UNDER_19 = 176] = "DRIVING_LICENSE_UNDER_19", e[e.IDENTITY_CARD_UNDER_19 = 177] = "IDENTITY_CARD_UNDER_19", e[e.VISA = 178] = "VISA", e[e.TEMPORARY_PASSPORT = 179] = "TEMPORARY_PASSPORT", e[e.VOTING_CARD = 180] = "VOTING_CARD", e[e.HEALTH_CARD = 181] = "HEALTH_CARD", e[e.CERTIFICATE_OF_CITIZENSHIP = 182] = "CERTIFICATE_OF_CITIZENSHIP", e[e.ADDRESS_CARD = 183] = "ADDRESS_CARD", e[e.AIRPORT_IMMIGRATION_CARD = 184] = "AIRPORT_IMMIGRATION_CARD", e[e.ALIEN_REGISTRATION_CARD = 185] = "ALIEN_REGISTRATION_CARD", e[e.APEH_CARD = 186] = "APEH_CARD", e[e.COUPON_TO_DRIVING_LICENSE = 187] = "COUPON_TO_DRIVING_LICENSE", e[e.CREW_MEMBER_CERTIFICATE = 188] = "CREW_MEMBER_CERTIFICATE", e[e.DOCUMENT_FOR_RETURN = 189] = "DOCUMENT_FOR_RETURN", e[e.E_CARD = 190] = "E_CARD", e[e.EMPLOYMENT_CARD = 191] = "EMPLOYMENT_CARD", e[e.HKSAR_IMMIGRATION_FORM = 192] = "HKSAR_IMMIGRATION_FORM", e[e.IMMIGRANT_CARD = 193] = "IMMIGRANT_CARD", e[e.LABOUR_CARD = 194] = "LABOUR_CARD", e[e.LAISSEZ_PASSER = 195] = "LAISSEZ_PASSER", e[e.LAWYER_IDENTITY_CERTIFICATE = 196] = "LAWYER_IDENTITY_CERTIFICATE", e[e.LICENSE_CARD = 197] = "LICENSE_CARD", e[e.PASSPORT_STATELESS = 198] = "PASSPORT_STATELESS", e[e.PASSPORT_CHILD = 199] = "PASSPORT_CHILD", e[e.PASSPORT_CONSULAR = 200] = "PASSPORT_CONSULAR", e[e.PASSPORT_DIPLOMATIC_SERVICE = 201] = "PASSPORT_DIPLOMATIC_SERVICE", e[e.PASSPORT_OFFICIAL = 202] = "PASSPORT_OFFICIAL", e[e.PASSPORT_PROVISIONAL = 203] = "PASSPORT_PROVISIONAL", e[e.PASSPORT_SPECIAL = 204] = "PASSPORT_SPECIAL", e[e.PERMISSION_TO_THE_LOCAL_BORDER_TRAFFIC = 205] = "PERMISSION_TO_THE_LOCAL_BORDER_TRAFFIC", e[e.REGISTRATION_CERTIFICATE = 206] = "REGISTRATION_CERTIFICATE", e[e.SEDESOL_CARD = 207] = "SEDESOL_CARD", e[e.SOCIAL_CARD = 208] = "SOCIAL_CARD", e[e.TB_CARD = 209] = "TB_CARD", e[e.VEHICLE_PASSPORT = 210] = "VEHICLE_PASSPORT", e[e.W_DOCUMENT = 211] = "W_DOCUMENT", e[e.DIPLOMATIC_IDENTITY_CARD = 212] = "DIPLOMATIC_IDENTITY_CARD", e[e.CONSULAR_IDENTITY_CARD = 213] = "CONSULAR_IDENTITY_CARD", e[e.INCOME_TAX_CARD = 214] = "INCOME_TAX_CARD", e[e.RESIDENCE_PERMIT = 215] = "RESIDENCE_PERMIT", e[e.DOCUMENT_OF_IDENTITY = 216] = "DOCUMENT_OF_IDENTITY", e[e.BORDER_CROSSING_PERMIT = 217] = "BORDER_CROSSING_PERMIT", e[e.PASSPORT_LIMITED_VALIDITY = 218] = "PASSPORT_LIMITED_VALIDITY", e[e.SIM_CARD = 219] = "SIM_CARD", e[e.TAX_CARD = 220] = "TAX_CARD", e[e.COMPANY_CARD = 221] = "COMPANY_CARD", e[e.DOMESTIC_PASSPORT = 222] = "DOMESTIC_PASSPORT", e[e.IDENTITY_CERTIFICATE = 223] = "IDENTITY_CERTIFICATE", e[e.RESIDENT_ID_CARD = 224] = "RESIDENT_ID_CARD", e[e.ARMED_FORCES_IDENTITY_CARD = 225] = "ARMED_FORCES_IDENTITY_CARD", e[e.PROFESSIONAL_CARD = 226] = "PROFESSIONAL_CARD", e[e.REGISTRATION_STAMP = 227] = "REGISTRATION_STAMP", e[e.DRIVER_CARD = 228] = "DRIVER_CARD", e[e.DRIVER_TRAINING_CERTIFICATE = 229] = "DRIVER_TRAINING_CERTIFICATE", e[e.QUALIFICATION_DRIVING_LICENSE = 230] = "QUALIFICATION_DRIVING_LICENSE", e[e.MEMBERSHIP_CARD = 231] = "MEMBERSHIP_CARD", e[e.PUBLIC_VEHICLE_DRIVER_AUTHORITY_CARD = 232] = "PUBLIC_VEHICLE_DRIVER_AUTHORITY_CARD", e[e.MARINE_LICENSE = 233] = "MARINE_LICENSE", e[e.TEMPORARY_LEARNER_LICENSE = 234] = "TEMPORARY_LEARNER_LICENSE", e[e.TEMPORARY_COMMERCIAL_DRIVING_LICENSE = 235] = "TEMPORARY_COMMERCIAL_DRIVING_LICENSE", e[e.INTERIM_INSTRUCTIONAL_PERMIT = 236] = "INTERIM_INSTRUCTIONAL_PERMIT", e[e.CERTIFICATE_OF_COMPETENCY = 237] = "CERTIFICATE_OF_COMPETENCY", e[e.CERTIFICATE_OF_PROFICIENCY = 238] = "CERTIFICATE_OF_PROFICIENCY", e[e.TRADE_LICENSE = 239] = "TRADE_LICENSE", e[e.PASSPORT_PAGE = 240] = "PASSPORT_PAGE", e[e.INVOICE = 241] = "INVOICE", e[e.PASSENGER_LOCATOR_FORM = 242] = "PASSENGER_LOCATOR_FORM", e))(pM || {}), hM = /* @__PURE__ */ ((e) => (e[e.OK = 0] = "OK", e[e.UNKNOWN = 15] = "UNKNOWN", e[e.NEED_MORE_IMAGES = 29] = "NEED_MORE_IMAGES", e))(hM || {}), _M = /* @__PURE__ */ ((e) => (e[e.PORTRAIT = 201] = "PORTRAIT", e[e.FINGERPRINT = 202] = "FINGERPRINT", e[e.EYE = 203] = "EYE", e[e.SIGNATURE = 204] = "SIGNATURE", e[e.BAR_CODE = 205] = "BAR_CODE", e[e.PROOF_OF_CITIZENSHIP = 206] = "PROOF_OF_CITIZENSHIP", e[e.DOCUMENT_FRONT = 207] = "DOCUMENT_FRONT", e[e.DOCUMENT_REAR = 208] = "DOCUMENT_REAR", e[e.COLOR_DYNAMIC = 209] = "COLOR_DYNAMIC", e[e.GHOST_PORTRAIT = 210] = "GHOST_PORTRAIT", e[e.STAMP = 211] = "STAMP", e[e.PORTRAIT_OF_CHILD = 212] = "PORTRAIT_OF_CHILD", e[e.CONTACT_CHIP = 213] = "CONTACT_CHIP", e[e.OTHER = 250] = "OTHER", e[e.FINGER_LEFT_THUMB = 300] = "FINGER_LEFT_THUMB", e[e.FINGER_LEFT_INDEX = 301] = "FINGER_LEFT_INDEX", e[e.FINGER_LEFT_MIDDLE = 302] = "FINGER_LEFT_MIDDLE", e[e.FINGER_LEFT_RING = 303] = "FINGER_LEFT_RING", e[e.FINGER_LEFT_LITTLE = 304] = "FINGER_LEFT_LITTLE", e[e.FINGER_RIGHT_THUMB = 305] = "FINGER_RIGHT_THUMB", e[e.FINGER_RIGHT_INDEX = 306] = "FINGER_RIGHT_INDEX", e[e.FINGER_RIGHT_MIDDLE = 307] = "FINGER_RIGHT_MIDDLE", e[e.FINGER_RIGHT_RING = 308] = "FINGER_RIGHT_RING", e[e.FINGER_RIGHT_LITTLE = 309] = "FINGER_RIGHT_LITTLE", e[e.FINGER_RIGHT_FOUR_FINGERS = 313] = "FINGER_RIGHT_FOUR_FINGERS", e[e.FINGER_LEFT_FOUR_FINGERS = 314] = "FINGER_LEFT_FOUR_FINGERS", e[e.FINGER_TWO_THUMBS = 315] = "FINGER_TWO_THUMBS", e))(_M || {}), V2 = /* @__PURE__ */ ((e) => (e[e.ImageGlares = 0] = "ImageGlares", e[e.ImageFocus = 1] = "ImageFocus", e[e.ImageResolution = 2] = "ImageResolution", e[e.ImageColorness = 3] = "ImageColorness", e[e.Perspective = 4] = "Perspective", e[e.Bounds = 5] = "Bounds", e[e.Portrait = 7] = "Portrait", e[e.Handwritten = 8] = "Handwritten", e[e.Brightness = 9] = "Brightness", e[e.Occlusion = 10] = "Occlusion", e))(V2 || {}), mM = /* @__PURE__ */ ((e) => (e.UNKNOWN = "bct_unknown", e.CODE128 = "bct_Code128", e.CODE39 = "bct_Code39", e.EAN8 = "bct_EAN8", e.ITF = "bct_ITF", e.PDF417 = "bct_PDF417", e.STF = "bct_STF", e.MTF = "bct_MTF", e.IATA = "bct_IATA", e.CODABAR = "bct_CODABAR", e.UPCA = "bct_UPCA", e.CODE93 = "bct_CODE93", e.UPCE = "bct_UPCE", e.EAN13 = "bct_EAN13", e.QRCODE = "bct_QRCODE", e.AZTEC = "bct_AZTEC", e.DATAMATRIX = "bct_DATAMATRIX", e.ALL_1D = "bct_ALL_1D", e.CODE11 = "bct_Code11", e.JABCODE = "bct_JABCODE", e))(mM || {}), EM = /* @__PURE__ */ ((e) => (e.Glares = "glaresCheck", e.Focus = "focusCheck", e.Resolution = "dpiThreshold", e.Colorness = "colornessCheck", e.Perspective = "perspectiveCheck", e.Bounds = "documentPosition", e.Portrait = "portraitCheck", e.Brightness = "brightnessCheck", e.Occlusion = "occlusionCheck", e))(EM || {}), Dp = /* @__PURE__ */ ((e) => (e[e.LATIN = 0] = "LATIN", e[e.AFRIKAANS = 1078] = "AFRIKAANS", e[e.ALBANIAN = 1052] = "ALBANIAN", e[e.ARABIC_ALGERIA = 5121] = "ARABIC_ALGERIA", e[e.ARABIC_BAHRAIN = 15361] = "ARABIC_BAHRAIN", e[e.ARABIC_EGYPT = 3073] = "ARABIC_EGYPT", e[e.ARABIC_IRAQ = 2049] = "ARABIC_IRAQ", e[e.ARABIC_JORDAN = 11265] = "ARABIC_JORDAN", e[e.ARABIC_KUWAIT = 13313] = "ARABIC_KUWAIT", e[e.ARABIC_LEBANON = 12289] = "ARABIC_LEBANON", e[e.ARABIC_LIBYA = 4097] = "ARABIC_LIBYA", e[e.ARABIC_MOROCCO = 6145] = "ARABIC_MOROCCO", e[e.ARABIC_OMAN = 8193] = "ARABIC_OMAN", e[e.ARABIC_QATAR = 16385] = "ARABIC_QATAR", e[e.ARABIC_SAUDI_ARABIA = 1025] = "ARABIC_SAUDI_ARABIA", e[e.ARABIC_SYRIA = 10241] = "ARABIC_SYRIA", e[e.ARABIC_TUNISIA = 7169] = "ARABIC_TUNISIA", e[e.ARABIC_UAE = 14337] = "ARABIC_UAE", e[e.ARABIC_YEMEN = 9217] = "ARABIC_YEMEN", e[e.ARABIC_ARMENIAN = 1067] = "ARABIC_ARMENIAN", e[e.AZERI_CYRILIC = 2092] = "AZERI_CYRILIC", e[e.AZERI_LATIN = 1068] = "AZERI_LATIN", e[e.BASQUE = 1069] = "BASQUE", e[e.BELARUSIAN = 1059] = "BELARUSIAN", e[e.BULGARIAN = 1026] = "BULGARIAN", e[e.BURMESE = 1109] = "BURMESE", e[e.CATALAN = 1027] = "CATALAN", e[e.CHINESE_HONGKONG_SAR = 3076] = "CHINESE_HONGKONG_SAR", e[e.CHINESE_MACAO_SAR = 5124] = "CHINESE_MACAO_SAR", e[e.CHINESE = 2052] = "CHINESE", e[e.CHINESE_SINGAPORE = 4100] = "CHINESE_SINGAPORE", e[e.CHINESE_TAIWAN = 1028] = "CHINESE_TAIWAN", e[e.CROATIAN = 1050] = "CROATIAN", e[e.CZECH = 1029] = "CZECH", e[e.DANISH = 1030] = "DANISH", e[e.DIVEHI = 1125] = "DIVEHI", e[e.DUTCH_BELGIUM = 2067] = "DUTCH_BELGIUM", e[e.DUTCH_NETHERLANDS = 1043] = "DUTCH_NETHERLANDS", e[e.ENGLISH_AUSTRALIA = 3081] = "ENGLISH_AUSTRALIA", e[e.ENGLISH_BELIZE = 10249] = "ENGLISH_BELIZE", e[e.ENGLISH_CANADA = 4105] = "ENGLISH_CANADA", e[e.ENGLISH_CARRIBEAN = 9225] = "ENGLISH_CARRIBEAN", e[e.ENGLISH_IRELAND = 6153] = "ENGLISH_IRELAND", e[e.ENGLISH_JAMAICA = 8201] = "ENGLISH_JAMAICA", e[e.ENGLISH_NEW_ZEALAND = 5129] = "ENGLISH_NEW_ZEALAND", e[e.ENGLISH_PHILIPPINES = 13321] = "ENGLISH_PHILIPPINES", e[e.ENGLISH_SOUTH_AFRICA = 7177] = "ENGLISH_SOUTH_AFRICA", e[e.ENGLISH_TRINIDAD = 11273] = "ENGLISH_TRINIDAD", e[e.ENGLISH_UK = 2057] = "ENGLISH_UK", e[e.ENGLISH_US = 1033] = "ENGLISH_US", e[e.ENGLISH_ZIMBABWE = 12297] = "ENGLISH_ZIMBABWE", e[e.ESTONIAN = 1061] = "ESTONIAN", e[e.FAROESE = 1080] = "FAROESE", e[e.FARSI = 1065] = "FARSI", e[e.FINNISH = 1035] = "FINNISH", e[e.FRENCH_BELGIUM = 2060] = "FRENCH_BELGIUM", e[e.FRENCH_CANADA = 3084] = "FRENCH_CANADA", e[e.FRENCH_FRANCE = 1036] = "FRENCH_FRANCE", e[e.FRENCH_LUXEMBOURG = 5132] = "FRENCH_LUXEMBOURG", e[e.FRENCH_MONACO = 6156] = "FRENCH_MONACO", e[e.FRENCH_SWITZERLAND = 4108] = "FRENCH_SWITZERLAND", e[e.FYRO_MACEDONIAN = 1071] = "FYRO_MACEDONIAN", e[e.GALICIAN = 1110] = "GALICIAN", e[e.GEORGIAN = 1079] = "GEORGIAN", e[e.GERMAN_AUSTRIA = 3079] = "GERMAN_AUSTRIA", e[e.GERMAN_GERMANY = 1031] = "GERMAN_GERMANY", e[e.GERMAN_LIECHTENSTEIN = 5127] = "GERMAN_LIECHTENSTEIN", e[e.GERMAN_LUXEMBOURG = 4103] = "GERMAN_LUXEMBOURG", e[e.GERMAN_SWITZERLAND = 2055] = "GERMAN_SWITZERLAND", e[e.GREEK = 1032] = "GREEK", e[e.GUJARATI = 1095] = "GUJARATI", e[e.HEBREW = 1037] = "HEBREW", e[e.HINDI_INDIA = 1081] = "HINDI_INDIA", e[e.HUNGARIAN = 1038] = "HUNGARIAN", e[e.ICELANDIC = 1039] = "ICELANDIC", e[e.INDONESIAN = 1057] = "INDONESIAN", e[e.ITALIAN_ITALY = 1040] = "ITALIAN_ITALY", e[e.ITALIAN_SWITZERLAND = 2064] = "ITALIAN_SWITZERLAND", e[e.JAPANESE = 1041] = "JAPANESE", e[e.KANNADA = 1099] = "KANNADA", e[e.KAZAKH = 1087] = "KAZAKH", e[e.KHMER = 1107] = "KHMER", e[e.KONKANI = 1111] = "KONKANI", e[e.KOREAN = 1042] = "KOREAN", e[e.KYRGYZ_CYRILICK = 1088] = "KYRGYZ_CYRILICK", e[e.LATVIAN = 1062] = "LATVIAN", e[e.LITHUANIAN = 1063] = "LITHUANIAN", e[e.MALAY_MALAYSIA = 1086] = "MALAY_MALAYSIA", e[e.MALAY_BRUNEI_DARUSSALAM = 2110] = "MALAY_BRUNEI_DARUSSALAM", e[e.MALTESE = 1082] = "MALTESE", e[e.MARATHI = 1102] = "MARATHI", e[e.MONGOLIAN_CYRILIC = 1104] = "MONGOLIAN_CYRILIC", e[e.NORWEGIAN_BOKMAL = 1044] = "NORWEGIAN_BOKMAL", e[e.NORWEGIAN_NYORSK = 2068] = "NORWEGIAN_NYORSK", e[e.POLISH = 1045] = "POLISH", e[e.PORTUGUESE_BRAZIL = 1046] = "PORTUGUESE_BRAZIL", e[e.PORTUGUESE_PORTUGAL = 2070] = "PORTUGUESE_PORTUGAL", e[e.PUNJABI = 1094] = "PUNJABI", e[e.RHAETO_ROMANIC = 1047] = "RHAETO_ROMANIC", e[e.ROMANIAN = 1048] = "ROMANIAN", e[e.RUSSIAN = 1049] = "RUSSIAN", e[e.SANSKRIT = 1103] = "SANSKRIT", e[e.SERBIAN_CYRILIC = 3098] = "SERBIAN_CYRILIC", e[e.SERBIAN_LATIN = 2074] = "SERBIAN_LATIN", e[e.SINHALA = 1115] = "SINHALA", e[e.SLOVAK = 1051] = "SLOVAK", e[e.SLOVENIAN = 1060] = "SLOVENIAN", e[e.SPANISH_ARGENTINA = 11274] = "SPANISH_ARGENTINA", e[e.SPANISH_BOLIVIA = 16394] = "SPANISH_BOLIVIA", e[e.SPANISH_CHILE = 13322] = "SPANISH_CHILE", e[e.SPANICH_COLOMBIA = 9226] = "SPANICH_COLOMBIA", e[e.SPANISH_COSTA_RICA = 5130] = "SPANISH_COSTA_RICA", e[e.SPANISH_DOMINICAN_REPUBLIC = 7178] = "SPANISH_DOMINICAN_REPUBLIC", e[e.SPANISH_ECUADOR = 12298] = "SPANISH_ECUADOR", e[e.SPANISH_EL_SALVADOR = 17418] = "SPANISH_EL_SALVADOR", e[e.SPANISH_GUATEMALA = 4106] = "SPANISH_GUATEMALA", e[e.SPANISH_HONDURAS = 18442] = "SPANISH_HONDURAS", e[e.SPANISH_MEXICO = 2058] = "SPANISH_MEXICO", e[e.SPANISH_NICARAGUA = 19466] = "SPANISH_NICARAGUA", e[e.SPANISH_PANAMA = 6154] = "SPANISH_PANAMA", e[e.SPANISH_PARAGUAY = 15370] = "SPANISH_PARAGUAY", e[e.SPANISH_PERU = 10250] = "SPANISH_PERU", e[e.SPANISH_PUERTO_RICO = 20490] = "SPANISH_PUERTO_RICO", e[e.SPANISH_TRADITIONAL_SORT = 1034] = "SPANISH_TRADITIONAL_SORT", e[e.SPANISH_INTERNATIONAL_SORT = 3082] = "SPANISH_INTERNATIONAL_SORT", e[e.SPANISH_URUGUAY = 14346] = "SPANISH_URUGUAY", e[e.SPANISH_VENEZUELA = 8202] = "SPANISH_VENEZUELA", e[e.SWAHILI = 1089] = "SWAHILI", e[e.SWEDISH = 1053] = "SWEDISH", e[e.SWEDISH_FINLAND = 2077] = "SWEDISH_FINLAND", e[e.SYRIAC = 1114] = "SYRIAC", e[e.TAMIL = 1097] = "TAMIL", e[e.TATAR = 1092] = "TATAR", e[e.TELUGU = 1098] = "TELUGU", e[e.THAI_THAILAND = 1054] = "THAI_THAILAND", e[e.TURKISH = 1055] = "TURKISH", e[e.TAJIK_CYRILLIC = 1064] = "TAJIK_CYRILLIC", e[e.TURKMEN = 1090] = "TURKMEN", e[e.UKRAINIAN = 1058] = "UKRAINIAN", e[e.URDU = 1056] = "URDU", e[e.UZBEK_CYRILIC = 2115] = "UZBEK_CYRILIC", e[e.UZBEK_LATIN = 1091] = "UZBEK_LATIN", e[e.VIETNAMESE = 1066] = "VIETNAMESE", e[e.CTC_SIMPLIFIED = 50001] = "CTC_SIMPLIFIED", e[e.CTC_TRADITIONAL = 50002] = "CTC_TRADITIONAL", e[e.BENGALI_BANGLADESH = 2117] = "BENGALI_BANGLADESH", e[e.BENGALI_INDIA = 1093] = "BENGALI_INDIA", e[e.ASSAMESE = 1101] = "ASSAMESE", e[e.ORIYA = 1096] = "ORIYA", e[e.MALAYALAM = 1100] = "MALAYALAM", e[e.LAO = 1108] = "LAO", e[e.SINDHI_INDIA = 1113] = "SINDHI_INDIA", e[e.AMHARIC = 1118] = "AMHARIC", e[e.KASHMIRI = 1120] = "KASHMIRI", e[e.NEPALI = 1121] = "NEPALI", e[e.PASHTO = 1123] = "PASHTO", e[e.SINDHI = 2137] = "SINDHI", e[e.ARABIC = 4096] = "ARABIC", e[e.BANK_CARD_NUMBER = 1e4] = "BANK_CARD_NUMBER", e[e.BANK_CARD_EXPIRY_DATE = 10001] = "BANK_CARD_EXPIRY_DATE", e[e.BANK_CARD_NAME = 10002] = "BANK_CARD_NAME", e[e.BANK_CARD = 10003] = "BANK_CARD", e[e.BANK_CARD_CVV2 = 10004] = "BANK_CARD_CVV2", e[e.ABKHAZIAN = 10011] = "ABKHAZIAN", e[e.KARAKALPAK = 10012] = "KARAKALPAK", e[e.URDU_DETECTION = 10560] = "URDU_DETECTION", e))(Dp || {}), Ap = /* @__PURE__ */ ((e) => (e[e.OFF = 0] = "OFF", e[e.WHITE_TOP = 2] = "WHITE_TOP", e[e.WHITE_SIDE = 4] = "WHITE_SIDE", e[e.WHITE = 6] = "WHITE", e[e.IR = 24] = "IR", e[e.UV = 128] = "UV", e[e.AXIAL_WHITE = 3072] = "AXIAL_WHITE", e))(Ap || {}), CM = /* @__PURE__ */ ((e) => (e.FATAL_ERROR = "FatalError", e.ERROR = "Error", e.WARNING = "Warning", e.INFO = "Info", e.DEBUG = "Debug", e))(CM || {}), SM = /* @__PURE__ */ ((e) => (e.IDL = "1x30", e.ID1 = "3x30", e.ID2 = "2x36", e.ID3 = "2x44", e.CAN = "1x6", e.ID1_2_30 = "2x30", e))(SM || {}), IM = /* @__PURE__ */ ((e) => (e[e.METRIC = 0] = "METRIC", e[e.IMPERIAL = 1] = "IMPERIAL", e))(IM || {}), vM = /* @__PURE__ */ ((e) => (e[e.eMDM_Default = 0] = "eMDM_Default", e[e.eMDM_ResizeBinarizeWindow = 1] = "eMDM_ResizeBinarizeWindow", e[e.eMDM_BlurBeforeBinarization = 2] = "eMDM_BlurBeforeBinarization", e))(vM || {}), gM = /* @__PURE__ */ ((e) => (e[e.errLDS_Ok = 1] = "errLDS_Ok", e[e.errLDS_ASN_IncorrectData = 2147483649] = "errLDS_ASN_IncorrectData", e[e.errLDS_ASN_NotEnoughData = 2147483650] = "errLDS_ASN_NotEnoughData", e[e.errLDS_ASN_Contents_UnexpectedData = 2147483651] = "errLDS_ASN_Contents_UnexpectedData", e[e.errLDS_ASN_SignedData_IncorrectData = 2147483656] = "errLDS_ASN_SignedData_IncorrectData", e[e.errLDS_ASN_SignedData_EncapContents_IncorrectData = 2147483657] = "errLDS_ASN_SignedData_EncapContents_IncorrectData", e[e.errLDS_ASN_SignedData_Version_IncorrectData = 2147483658] = "errLDS_ASN_SignedData_Version_IncorrectData", e[e.errLDS_ASN_SignedData_DigestAlgorithms_IncorrectData = 2147483665] = "errLDS_ASN_SignedData_DigestAlgorithms_IncorrectData", e[e.errLDS_ASN_LDSObject_IncorrectData = 2147483667] = "errLDS_ASN_LDSObject_IncorrectData", e[e.errLDS_ASN_LDSObject_Version_IncorrectData = 2147483668] = "errLDS_ASN_LDSObject_Version_IncorrectData", e[e.errLDS_ASN_LDSObject_DigestAlgorithm_IncorrectData = 2147483669] = "errLDS_ASN_LDSObject_DigestAlgorithm_IncorrectData", e[e.errLDS_ASN_LDSObject_DGHashes_IncorrectData = 2147483670] = "errLDS_ASN_LDSObject_DGHashes_IncorrectData", e[e.errLDS_ASN_LDSObject_VersionInfo_IncorrectData = 2147483666] = "errLDS_ASN_LDSObject_VersionInfo_IncorrectData", e[e.errLDS_ASN_Certificate_IncorrectData = 2147483671] = "errLDS_ASN_Certificate_IncorrectData", e[e.errLDS_ASN_Certificate_Version_IncorrectData = 2147483672] = "errLDS_ASN_Certificate_Version_IncorrectData", e[e.errLDS_ASN_Certificate_SN_IncorrectData = 2147483673] = "errLDS_ASN_Certificate_SN_IncorrectData", e[e.errLDS_ASN_Certificate_Signature_IncorrectData = 2147483674] = "errLDS_ASN_Certificate_Signature_IncorrectData", e[e.errLDS_ASN_Certificate_Issuer_IncorrectData = 2147483675] = "errLDS_ASN_Certificate_Issuer_IncorrectData", e[e.errLDS_ASN_Certificate_Validity_IncorrectData = 2147483676] = "errLDS_ASN_Certificate_Validity_IncorrectData", e[e.errLDS_ASN_Certificate_Subject_IncorrectData = 2147483677] = "errLDS_ASN_Certificate_Subject_IncorrectData", e[e.errLDS_ASN_Certificate_SubjectPK_IncorrectData = 2147483678] = "errLDS_ASN_Certificate_SubjectPK_IncorrectData", e[e.errLDS_ASN_Certificate_Extensions_IncorrectData = 2147483679] = "errLDS_ASN_Certificate_Extensions_IncorrectData", e[e.errLDS_ASN_SignerInfo_IncorrectData = 2147483680] = "errLDS_ASN_SignerInfo_IncorrectData", e[e.errLDS_ASN_SignerInfo_Version_IncorrectData = 2147483681] = "errLDS_ASN_SignerInfo_Version_IncorrectData", e[e.errLDS_ASN_SignerInfo_SID_IncorrectData = 2147483682] = "errLDS_ASN_SignerInfo_SID_IncorrectData", e[e.errLDS_ASN_SignerInfo_DigestAlg_IncorrectData = 2147483683] = "errLDS_ASN_SignerInfo_DigestAlg_IncorrectData", e[e.errLDS_ASN_SignerInfo_SignedAttrs_IncorrectData = 2147483684] = "errLDS_ASN_SignerInfo_SignedAttrs_IncorrectData", e[e.errLDS_ASN_SignerInfo_SignAlg_IncorrectData = 2147483685] = "errLDS_ASN_SignerInfo_SignAlg_IncorrectData", e[e.errLDS_ASN_SignerInfo_Signature_IncorrectData = 2147483686] = "errLDS_ASN_SignerInfo_Signature_IncorrectData", e[e.errLDS_ASN_SignerInfo_UnsignedAttrs_IncorrectData = 2147483687] = "errLDS_ASN_SignerInfo_UnsignedAttrs_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_IncorrectData = 2147483712] = "errLDS_ASN_DTC_SignerInfo_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_Certificate_IncorrectData = 2147483713] = "errLDS_ASN_DTC_SignerInfo_Certificate_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_DigestAlg_IncorrectData = 2147483714] = "errLDS_ASN_DTC_SignerInfo_DigestAlg_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_SignedAttrs_IncorrectData = 2147483715] = "errLDS_ASN_DTC_SignerInfo_SignedAttrs_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_SignAlg_IncorrectData = 2147483716] = "errLDS_ASN_DTC_SignerInfo_SignAlg_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_Signature_IncorrectData = 2147483717] = "errLDS_ASN_DTC_SignerInfo_Signature_IncorrectData", e[e.errLDS_ASN_DTC_SecurityInfo_IncorrectData = 2147483718] = "errLDS_ASN_DTC_SecurityInfo_IncorrectData", e[e.errLDS_ASN_DTC_ContentInfo_IncorrectData = 2147483719] = "errLDS_ASN_DTC_ContentInfo_IncorrectData", e[e.errLDS_ICAO_LDSObject_UnsupportedDigestAlgorithm = 2147483696] = "errLDS_ICAO_LDSObject_UnsupportedDigestAlgorithm", e[e.errLDS_ICAO_SignedData_SignerInfos_Empty = 2147483697] = "errLDS_ICAO_SignedData_SignerInfos_Empty", e[e.errLDS_ICAO_SignerInfo_UnsupportedDigestAlgorithm = 2147483698] = "errLDS_ICAO_SignerInfo_UnsupportedDigestAlgorithm", e[e.errLDS_ICAO_SignerInfo_UnsupportedSignatureAlgorithm = 2147483699] = "errLDS_ICAO_SignerInfo_UnsupportedSignatureAlgorithm", e[e.errLDS_ICAO_SignerInfo_MessageDigestError = 2147483700] = "errLDS_ICAO_SignerInfo_MessageDigestError", e[e.errLDS_ICAO_SignerInfo_SignedAttrs_Missed = 2147483702] = "errLDS_ICAO_SignerInfo_SignedAttrs_Missed", e[e.errLDS_Auth_SignerInfo_CantFindCertificate = 2147483701] = "errLDS_Auth_SignerInfo_CantFindCertificate", e[e.errLDS_Auth_Error = 2147483728] = "errLDS_Auth_Error", e[e.errLDS_Auth_UnsupportedSignatureAlgorithm = 2147483729] = "errLDS_Auth_UnsupportedSignatureAlgorithm", e[e.errLDS_Auth_UnsupportedPublicKeyAlgorithm = 2147483730] = "errLDS_Auth_UnsupportedPublicKeyAlgorithm", e[e.errLDS_Auth_MessedAlgorithms = 2147483731] = "errLDS_Auth_MessedAlgorithms", e[e.errLDS_Auth_PublicKeyDataInvalid = 2147483732] = "errLDS_Auth_PublicKeyDataInvalid", e[e.errLDS_Auth_AlgorithmParametersDataInvalid = 2147483733] = "errLDS_Auth_AlgorithmParametersDataInvalid", e[e.errLDS_Auth_SignatureDataInvalid = 2147483734] = "errLDS_Auth_SignatureDataInvalid", e[e.errLDS_Auth_UnsupportedDigestAlgorithm = 2147483735] = "errLDS_Auth_UnsupportedDigestAlgorithm", e[e.errLDS_Auth_SignatureDataIncorrect = 2147483736] = "errLDS_Auth_SignatureDataIncorrect", e[e.errLDS_Auth_AlgorithmParametersNotDefined = 2147483737] = "errLDS_Auth_AlgorithmParametersNotDefined", e[e.errLDS_Auth_SignatureCheckFailed = 2147483738] = "errLDS_Auth_SignatureCheckFailed", e[e.errLDS_DG_WrongTag = 2147483760] = "errLDS_DG_WrongTag", e[e.errLDS_DG_Contents_UnexpectedData = 2147483761] = "errLDS_DG_Contents_UnexpectedData", e[e.errLDS_BAP_SymmetricCypher_CantInitialize = 2164260881] = "errLDS_BAP_SymmetricCypher_CantInitialize", e[e.errLDS_PACE_Info_NotAvailable = 2164260896] = "errLDS_PACE_Info_NotAvailable", e[e.errLDS_PACE_SymmetricCypher_CantInitialize = 2164260897] = "errLDS_PACE_SymmetricCypher_CantInitialize", e[e.errLDS_PACE_KeyAgreement_CantInitialize = 2164260898] = "errLDS_PACE_KeyAgreement_CantInitialize", e[e.errLDS_PACE_EphemeralKeys_CantCreate = 2164260899] = "errLDS_PACE_EphemeralKeys_CantCreate", e[e.errLDS_PACE_Mapping_CantDecodeNonce = 2164260900] = "errLDS_PACE_Mapping_CantDecodeNonce", e[e.errLDS_PACE_SharedSecret_CantCreate = 2164260901] = "errLDS_PACE_SharedSecret_CantCreate", e[e.errLDS_PACE_DomainParams_UnsupportedFormat = 2164260902] = "errLDS_PACE_DomainParams_UnsupportedFormat", e[e.errLDS_PACE_EphemeralKeys_Incorrect = 2164260903] = "errLDS_PACE_EphemeralKeys_Incorrect", e[e.errLDS_PACE_Mapping_EphemeralKeys_Incorrect = 2164260904] = "errLDS_PACE_Mapping_EphemeralKeys_Incorrect", e[e.errLDS_PACE_Mapping_CantPerform = 2164260905] = "errLDS_PACE_Mapping_CantPerform", e[e.errLDS_PACE_NonMatchingAuthTokens = 2164260906] = "errLDS_PACE_NonMatchingAuthTokens", e[e.errLDS_PACE_CAM_Data_Incorrect = 2164260907] = "errLDS_PACE_CAM_Data_Incorrect", e[e.errLDS_PACE_CAM_Data_CantVerify = 2164260908] = "errLDS_PACE_CAM_Data_CantVerify", e[e.errLDS_PACE_CAM_Data_NonMatching = 2164260909] = "errLDS_PACE_CAM_Data_NonMatching", e[e.errLDS_PACE_IM_Scheme_Incorrect = 2164260910] = "errLDS_PACE_IM_Scheme_Incorrect", e[e.errLDS_PACE_IM_RandomMapping_Failed = 2164260911] = "errLDS_PACE_IM_RandomMapping_Failed", e[e.errLDS_CA_CantFindPublicKey = 2164260912] = "errLDS_CA_CantFindPublicKey", e[e.errLDS_CA_CantFindInfo = 2164260913] = "errLDS_CA_CantFindInfo", e[e.errLDS_CA_IncorrectVersion = 2164260914] = "errLDS_CA_IncorrectVersion", e[e.errLDS_CA_CantFindDomainParameters = 2164260915] = "errLDS_CA_CantFindDomainParameters", e[e.errLDS_CA_KeyAgreement_CantInitialize = 2164260916] = "errLDS_CA_KeyAgreement_CantInitialize", e[e.errLDS_CA_PublicKey_UnsupportedAlgorithm = 2164260917] = "errLDS_CA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_CA_EphemeralKeys_CantCreate = 2164260918] = "errLDS_CA_EphemeralKeys_CantCreate", e[e.errLDS_CA_SharedSecret_CantCreate = 2164260919] = "errLDS_CA_SharedSecret_CantCreate", e[e.errLDS_CA_NonMatchingAuthTokens = 2164260920] = "errLDS_CA_NonMatchingAuthTokens", e[e.errLDS_TA_IncorrectVersion = 2164260928] = "errLDS_TA_IncorrectVersion", e[e.errLDS_TA_CantBuildCertificateChain = 2164260929] = "errLDS_TA_CantBuildCertificateChain", e[e.errLDS_TA_CantFindISPrivateKey = 2164260930] = "errLDS_TA_CantFindISPrivateKey", e[e.errLDS_TA_PublicKey_UnsupportedAlgorithm = 2164260931] = "errLDS_TA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_TA_SignatureBuildingError = 2164260932] = "errLDS_TA_SignatureBuildingError", e[e.errLDS_TA_InvalidKeyAlgorithmParameters = 2164260933] = "errLDS_TA_InvalidKeyAlgorithmParameters", e[e.errLDS_AA_PublicKey_UnsupportedAlgorithm = 2164260944] = "errLDS_AA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_AA_PublicKey_IncorrectData = 2164260945] = "errLDS_AA_PublicKey_IncorrectData", e[e.errLDS_AA_PublicKey_IncorrectParameters = 2164260946] = "errLDS_AA_PublicKey_IncorrectParameters", e[e.errLDS_AA_PublicKey_UndefinedParameters = 2164260947] = "errLDS_AA_PublicKey_UndefinedParameters", e[e.errLDS_AA_Signature_IncorrectData = 2164260948] = "errLDS_AA_Signature_IncorrectData", e[e.errLDS_AA_UnsupportedRecoveryScheme = 2164260949] = "errLDS_AA_UnsupportedRecoveryScheme", e[e.errLDS_AA_IncorrectTrailer = 2164260950] = "errLDS_AA_IncorrectTrailer", e[e.errLDS_AA_UnsupportedDigestAlgorithm = 2164260951] = "errLDS_AA_UnsupportedDigestAlgorithm", e[e.errLDS_RI_SectorKey_CantFind = 2164260976] = "errLDS_RI_SectorKey_CantFind", e[e.errLDS_RI_SectorKey_IncorrectData = 2164260977] = "errLDS_RI_SectorKey_IncorrectData", e[e.errLDS_RI_SectorKey_IncompleteData = 2164260978] = "errLDS_RI_SectorKey_IncompleteData", e[e.errLDS_CV_Certificate_MissingMandatoryData_PK = 2164260960] = "errLDS_CV_Certificate_MissingMandatoryData_PK", e[e.errLDS_CV_Certificate_PublicKey_Unsupported = 2164260962] = "errLDS_CV_Certificate_PublicKey_Unsupported", e[e.errLDS_CV_Certificate_CHAT_UnsupportedTerminalType = 2164260963] = "errLDS_CV_Certificate_CHAT_UnsupportedTerminalType", e[e.errLDS_CV_Certificate_PrivateKey_Unsupported = 2164260964] = "errLDS_CV_Certificate_PrivateKey_Unsupported", e[e.errLDS_CV_Certificate_PrivateKey_InvalidParams = 2164260965] = "errLDS_CV_Certificate_PrivateKey_InvalidParams", e[e.errLDS_CV_Certificate_IncorrectData = 2164261216] = "errLDS_CV_Certificate_IncorrectData", e[e.errLDS_CV_Certificate_CPI_IncorrectData = 2164261217] = "errLDS_CV_Certificate_CPI_IncorrectData", e[e.errLDS_CV_Certificate_CAR_IncorrectData = 2164261218] = "errLDS_CV_Certificate_CAR_IncorrectData", e[e.errLDS_CV_Certificate_PublicKey_IncorrectData = 2164261219] = "errLDS_CV_Certificate_PublicKey_IncorrectData", e[e.errLDS_CV_Certificate_CHR_IncorrectData = 2164261220] = "errLDS_CV_Certificate_CHR_IncorrectData", e[e.errLDS_CV_Certificate_CHAT_IncorrectData = 2164261221] = "errLDS_CV_Certificate_CHAT_IncorrectData", e[e.errLDS_CV_Certificate_ValidFrom_IncorrectData = 2164261222] = "errLDS_CV_Certificate_ValidFrom_IncorrectData", e[e.errLDS_CV_Certificate_ValidTo_IncorrectData = 2164261223] = "errLDS_CV_Certificate_ValidTo_IncorrectData", e[e.errLDS_CV_Certificate_Extensions_IncorrectData = 2164261224] = "errLDS_CV_Certificate_Extensions_IncorrectData", e[e.errLDS_CV_Certificate_PrivateKey_IncorrectData = 2164261225] = "errLDS_CV_Certificate_PrivateKey_IncorrectData", e[e.errLDS_CV_Certificate_PrivateKey_Missing = 2164261226] = "errLDS_CV_Certificate_PrivateKey_Missing", e[e.errLDS_VDS_UnsupportedVersion = 2164261376] = "errLDS_VDS_UnsupportedVersion", e[e.errLDS_VDS_Issuing_Country_Size = 2164261377] = "errLDS_VDS_Issuing_Country_Size", e[e.errLDS_VDS_Issuing_Country_IncorrectData = 2164261378] = "errLDS_VDS_Issuing_Country_IncorrectData", e[e.errLDS_VDS_Signer_Certificate_Size = 2164261379] = "errLDS_VDS_Signer_Certificate_Size", e[e.errLDS_VDS_Signer_Certificate_Data = 2164261380] = "errLDS_VDS_Signer_Certificate_Data", e[e.errLDS_VDS_Signature_IncorrectData = 2164261381] = "errLDS_VDS_Signature_IncorrectData", e[e.errLDS_VDS_NC_IncorrectData = 2164261632] = "errLDS_VDS_NC_IncorrectData", e[e.errLDS_VDS_NC_MissingOrIncorrect_Data = 2164261633] = "errLDS_VDS_NC_MissingOrIncorrect_Data", e[e.errLDS_VDS_NC_MissingOrIncorrect_Header = 2164261634] = "errLDS_VDS_NC_MissingOrIncorrect_Header", e[e.errLDS_VDS_NC_MissingOrIncorrect_Type = 2164261635] = "errLDS_VDS_NC_MissingOrIncorrect_Type", e[e.errLDS_VDS_NC_MissingOrIncorrect_Version = 2164261636] = "errLDS_VDS_NC_MissingOrIncorrect_Version", e[e.errLDS_VDS_NC_MissingOrIncorrect_IssuingCountry = 2164261637] = "errLDS_VDS_NC_MissingOrIncorrect_IssuingCountry", e[e.errLDS_VDS_NC_MissingOrIncorrect_Message = 2164261638] = "errLDS_VDS_NC_MissingOrIncorrect_Message", e[e.errLDS_VDS_NC_MissingOrIncorrect_Signature = 2164261639] = "errLDS_VDS_NC_MissingOrIncorrect_Signature", e[e.errLDS_VDS_NC_MissingOrIncorrect_SigAlgorithm = 2164261640] = "errLDS_VDS_NC_MissingOrIncorrect_SigAlgorithm", e[e.errLDS_VDS_NC_MissingOrIncorrect_Certificate = 2164261641] = "errLDS_VDS_NC_MissingOrIncorrect_Certificate", e[e.errLDS_VDS_NC_MissingOrIncorrect_SigValue = 2164261642] = "errLDS_VDS_NC_MissingOrIncorrect_SigValue", e))(gM || {}), RM = /* @__PURE__ */ ((e) => (e[e.ntfLDS_ASN_Certificate_IncorrectVersion = 2415919105] = "ntfLDS_ASN_Certificate_IncorrectVersion", e[e.ntfLDS_ASN_Certificate_NonMatchingSignatureAlgorithm = 2415919106] = "ntfLDS_ASN_Certificate_NonMatchingSignatureAlgorithm", e[e.ntfLDS_ASN_Certificate_IncorrectTimeCoding = 2415919107] = "ntfLDS_ASN_Certificate_IncorrectTimeCoding", e[e.ntfLDS_ASN_Certificate_IncorrectUseOfGeneralizedTime = 2415919108] = "ntfLDS_ASN_Certificate_IncorrectUseOfGeneralizedTime", e[e.ntfLDS_ASN_Certificate_EmptyIssuer = 2415919109] = "ntfLDS_ASN_Certificate_EmptyIssuer", e[e.ntfLDS_ASN_Certificate_EmptySubject = 2415919110] = "ntfLDS_ASN_Certificate_EmptySubject", e[e.ntfLDS_ASN_Certificate_UnsupportedCriticalExtension = 2415919112] = "ntfLDS_ASN_Certificate_UnsupportedCriticalExtension", e[e.ntfLDS_ASN_Certificate_ForcedDefaultCSCARole = 2415919118] = "ntfLDS_ASN_Certificate_ForcedDefaultCSCARole", e[e.ntfLDS_ASN_Certificate_ForcedDefaultDSRole = 2415919119] = "ntfLDS_ASN_Certificate_ForcedDefaultDSRole", e[e.ntfLDS_ASN_Certificate_IncorrectIssuerSubjectDS = 2415919120] = "ntfLDS_ASN_Certificate_IncorrectIssuerSubjectDS", e[e.ntfLDS_ASN_Certificate_DuplicatingExtensions = 2415919127] = "ntfLDS_ASN_Certificate_DuplicatingExtensions", e[e.ntfLDS_ICAO_Certificate_Version_Missed = 2415919616] = "ntfLDS_ICAO_Certificate_Version_Missed", e[e.ntfLDS_ICAO_Certificate_Version_Incorrect = 2415919617] = "ntfLDS_ICAO_Certificate_Version_Incorrect", e[e.ntfLDS_ICAO_Certificate_Issuer_Country_Missed = 2415919618] = "ntfLDS_ICAO_Certificate_Issuer_Country_Missed", e[e.ntfLDS_ICAO_Certificate_Issuer_CommonName_Missed = 2415919619] = "ntfLDS_ICAO_Certificate_Issuer_CommonName_Missed", e[e.ntfLDS_ICAO_Certificate_Issuer_CountryNonCompliant = 2415919620] = "ntfLDS_ICAO_Certificate_Issuer_CountryNonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_Country_Missed = 2415919621] = "ntfLDS_ICAO_Certificate_Subject_Country_Missed", e[e.ntfLDS_ICAO_Certificate_Subject_CommonName_Missed = 2415919622] = "ntfLDS_ICAO_Certificate_Subject_CommonName_Missed", e[e.ntfLDS_ICAO_Certificate_Subject_CountryNonCompliant = 2415919623] = "ntfLDS_ICAO_Certificate_Subject_CountryNonCompliant", e[e.ntfLDS_ICAO_Certificate_UsingNonCompliantData = 2415919624] = "ntfLDS_ICAO_Certificate_UsingNonCompliantData", e[e.ntfLDS_ICAO_Certificate_UnsupportedSignatureAlgorithm = 2415919625] = "ntfLDS_ICAO_Certificate_UnsupportedSignatureAlgorithm", e[e.ntfLDS_ICAO_Certificate_UnsupportedPublicKeyAlgorithm = 2415919626] = "ntfLDS_ICAO_Certificate_UnsupportedPublicKeyAlgorithm", e[e.ntfLDS_ICAO_Certificate_MissedExtensions = 2415919627] = "ntfLDS_ICAO_Certificate_MissedExtensions", e[e.ntfLDS_ICAO_Certificate_Validity = 2415919628] = "ntfLDS_ICAO_Certificate_Validity", e[e.ntfLDS_ICAO_Certificate_Ext_UsingNonCompliantData = 2415919629] = "ntfLDS_ICAO_Certificate_Ext_UsingNonCompliantData", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_Missed = 2415919630] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_NotCritical = 2415919631] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_IncorrectData = 2415919632] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_Missed = 2415919633] = "ntfLDS_ICAO_Certificate_Ext_BasicC_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage1 = 2415919634] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage1", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage2 = 2415919635] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage2", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_NotCritical = 2415919636] = "ntfLDS_ICAO_Certificate_Ext_BasicC_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectData = 2415919637] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Missed = 2415919638] = "ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Incorrect = 2415919639] = "ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_NotCritical = 2415919640] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectUsage = 2415919641] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectUsage", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectData = 2415919642] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_Missed = 2415919643] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_IncorrectData = 2415919644] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_KeyID_Missed = 2415919645] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_KeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_Missed = 2415919646] = "ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_IncorrectData = 2415919647] = "ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Missed = 2415919648] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_IncorrectData = 2415919649] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Empty = 2415919650] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Missed = 2415919651] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_IncorrectData = 2415919652] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Empty = 2415919653] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_NonCompliant = 2415919654] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Critical = 2415919656] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Empty = 2415919657] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Incorrect = 2415919658] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_NonCompliant = 2415919659] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Missed = 2415919660] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_IncorrectData = 2415919661] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Empty = 2415919662] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_NonCompliant = 2415919663] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Critical = 2415919665] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Empty = 2415919666] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Incorrect = 2415919667] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_NonCompliant = 2415919668] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Missed = 2415919669] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_IncorrectData = 2415919670] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Version = 2415919671] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Version", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes = 2415919672] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes_Empty = 2415919673] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_IncorrectData = 2415919674] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_Empty = 2415919675] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_PolicyID_Missed = 2415919676] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_PolicyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Missed = 2415919677] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_IncorrectData = 2415919678] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Empty = 2415919679] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_PointMissed = 2415919680] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_PointMissed", e[e.ntfLDS_ICAO_Certificate_SN_NonCompliant = 2415919681] = "ntfLDS_ICAO_Certificate_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Issuer_SN_NonCompliant = 2415919682] = "ntfLDS_ICAO_Certificate_Issuer_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_SN_NonCompliant = 2415919683] = "ntfLDS_ICAO_Certificate_Subject_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Issuer_AttributeNonCompliant = 2415919684] = "ntfLDS_ICAO_Certificate_Issuer_AttributeNonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_AttributeNonCompliant = 2415919685] = "ntfLDS_ICAO_Certificate_Subject_AttributeNonCompliant", e[e.ntfLDS_ICAO_Certificate_IssuerSubject_Country_NonMatching = 2415919686] = "ntfLDS_ICAO_Certificate_IssuerSubject_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_Ext_CSCA_AltNames_NonMatching = 2415919687] = "ntfLDS_ICAO_Certificate_Ext_CSCA_AltNames_NonMatching", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_IncorrectData = 2415919688] = "ntfLDS_ICAO_Certificate_Ext_NameChange_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_NonCompliant = 2415919689] = "ntfLDS_ICAO_Certificate_Ext_NameChange_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_Critical = 2415919690] = "ntfLDS_ICAO_Certificate_Ext_NameChange_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_NonCompliant = 2415919691] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Critical = 2415919692] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_Optional_Critical = 2415919693] = "ntfLDS_ICAO_Certificate_Ext_Optional_Critical", e[e.ntfLDS_ICAO_Certificate_Subject_NonCompliant = 2415919694] = "ntfLDS_ICAO_Certificate_Subject_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_CommonNameNonCompliant = 2415919695] = "ntfLDS_ICAO_Certificate_Subject_CommonNameNonCompliant", e[e.ntfLDS_ICAO_Certificate_Chain_Country_NonMatching = 2415919696] = "ntfLDS_ICAO_Certificate_Chain_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_VisualMrz_Country_NonMatching = 2415919697] = "ntfLDS_ICAO_Certificate_VisualMrz_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_MRZ_Country_NonMatching = 2415919698] = "ntfLDS_ICAO_Certificate_MRZ_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_Issuer_CountryNonUpperCase = 2415919699] = "ntfLDS_ICAO_Certificate_Issuer_CountryNonUpperCase", e[e.ntfLDS_ICAO_Certificate_Subject_CountryNonUpperCase = 2415919700] = "ntfLDS_ICAO_Certificate_Subject_CountryNonUpperCase", e[e.ntfLDS_ICAO_COM_LDS_Version_Incorrect = 2415919136] = "ntfLDS_ICAO_COM_LDS_Version_Incorrect", e[e.ntfLDS_ICAO_COM_LDS_Version_Missing = 2415919137] = "ntfLDS_ICAO_COM_LDS_Version_Missing", e[e.ntfLDS_ICAO_COM_Unicode_Version_Incorrect = 2415919138] = "ntfLDS_ICAO_COM_Unicode_Version_Incorrect", e[e.ntfLDS_ICAO_COM_Unicode_Version_Missing = 2415919139] = "ntfLDS_ICAO_COM_Unicode_Version_Missing", e[e.ntfLDS_ICAO_COM_DGPM_Incorrect = 2415919140] = "ntfLDS_ICAO_COM_DGPM_Incorrect", e[e.ntfLDS_ICAO_COM_DGPM_Missing = 2415919141] = "ntfLDS_ICAO_COM_DGPM_Missing", e[e.ntfLDS_ICAO_COM_DGPM_Unexpected = 2415919142] = "ntfLDS_ICAO_COM_DGPM_Unexpected", e[e.ntfLDS_ICAO_Application_LDSVersion_Unsupported = 2415919152] = "ntfLDS_ICAO_Application_LDSVersion_Unsupported", e[e.ntfLDS_ICAO_Application_UnicodeVersion_Unsupported = 2415919153] = "ntfLDS_ICAO_Application_UnicodeVersion_Unsupported", e[e.ntfLDS_ICAO_Application_LDSVersion_Inconsistent = 2415919154] = "ntfLDS_ICAO_Application_LDSVersion_Inconsistent", e[e.ntfLDS_ICAO_Application_UnicodeVersion_Inconsistent = 2415919155] = "ntfLDS_ICAO_Application_UnicodeVersion_Inconsistent", e[e.ntfLDS_ASN_SignedData_OID_Incorrect = 2415919360] = "ntfLDS_ASN_SignedData_OID_Incorrect", e[e.ntfLDS_ASN_SignedData_Version_Incorrect = 2415919520] = "ntfLDS_ASN_SignedData_Version_Incorrect", e[e.ntfLDS_ASN_SignedData_ContentOID_Incorrect = 2415919521] = "ntfLDS_ASN_SignedData_ContentOID_Incorrect", e[e.ntfLDS_ICAO_SignedData_Version_Incorrect = 2415919361] = "ntfLDS_ICAO_SignedData_Version_Incorrect", e[e.ntfLDS_ICAO_SignedData_DigestAlgorithms_Empty = 2415919362] = "ntfLDS_ICAO_SignedData_DigestAlgorithms_Empty", e[e.ntfLDS_ICAO_SignedData_DigestAlgorithms_Unsupported = 2415919363] = "ntfLDS_ICAO_SignedData_DigestAlgorithms_Unsupported", e[e.ntfLDS_ICAO_SignedData_SignerInfos_MultipleEntries = 2415919369] = "ntfLDS_ICAO_SignedData_SignerInfos_MultipleEntries", e[e.ntfLDS_ICAO_SignedData_Certificates_Missed = 2415919536] = "ntfLDS_ICAO_SignedData_Certificates_Missed", e[e.ntfLDS_ICAO_SignedData_Certificates_Empty = 2415919537] = "ntfLDS_ICAO_SignedData_Certificates_Empty", e[e.ntfLDS_ICAO_SignedData_CRLs_IncorrectUsage = 2415919538] = "ntfLDS_ICAO_SignedData_CRLs_IncorrectUsage", e[e.ntfLDS_ICAO_LDSObject_IncorrectContentOID = 2415919364] = "ntfLDS_ICAO_LDSObject_IncorrectContentOID", e[e.ntfLDS_ICAO_LDSObject_DGNumber_Incorrect = 2415919365] = "ntfLDS_ICAO_LDSObject_DGNumber_Incorrect", e[e.ntfLDS_ICAO_LDSObject_DGHash_Missing = 2415919366] = "ntfLDS_ICAO_LDSObject_DGHash_Missing", e[e.ntfLDS_ICAO_LDSObject_DGHash_Extra = 2415919367] = "ntfLDS_ICAO_LDSObject_DGHash_Extra", e[e.ntfLDS_ICAO_LDSObject_Version_Incorrect = 2415919368] = "ntfLDS_ICAO_LDSObject_Version_Incorrect", e[e.ntfLDS_ICAO_MasterList_Version_Incorrect = 2415919552] = "ntfLDS_ICAO_MasterList_Version_Incorrect", e[e.ntfLDS_ICAO_DeviationList_Version_Incorrect = 2415919560] = "ntfLDS_ICAO_DeviationList_Version_Incorrect", e[e.ntfLDS_BSI_DefectList_Version_Incorrect = 2415919568] = "ntfLDS_BSI_DefectList_Version_Incorrect", e[e.ntfLDS_BSI_BlackList_Version_Incorrect = 2415919576] = "ntfLDS_BSI_BlackList_Version_Incorrect", e[e.ntfLDS_ASN_SignerInfo_Version_Incorrect = 2415919370] = "ntfLDS_ASN_SignerInfo_Version_Incorrect", e[e.ntfLDS_ASN_SignerInfo_SID_IncorrectChoice = 2415919371] = "ntfLDS_ASN_SignerInfo_SID_IncorrectChoice", e[e.ntfLDS_ASN_SignerInfo_SID_DigestAlgorithmNotListed = 2415919372] = "ntfLDS_ASN_SignerInfo_SID_DigestAlgorithmNotListed", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Missing = 2415919373] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Data = 2415919374] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Data", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Value = 2415919375] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Value", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Missing = 2415919376] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Data = 2415919377] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Data", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Value = 2415919378] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Value", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Missing = 2415919387] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Data = 2415919388] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Data", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Value = 2415919389] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Value", e[e.ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Missing = 2415919390] = "ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Data = 2415919391] = "ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Data", e[e.ntfLDS_Auth_SignerInfo_Certificate_Validity = 2415919381] = "ntfLDS_Auth_SignerInfo_Certificate_Validity", e[e.ntfLDS_Auth_SignerInfo_Certificate_RootIsNotTrusted = 2415919382] = "ntfLDS_Auth_SignerInfo_Certificate_RootIsNotTrusted", e[e.ntfLDS_Auth_SignerInfo_Certificate_CantFindCSCA = 2415919383] = "ntfLDS_Auth_SignerInfo_Certificate_CantFindCSCA", e[e.ntfLDS_Auth_SignerInfo_Certificate_Revoked = 2415919384] = "ntfLDS_Auth_SignerInfo_Certificate_Revoked", e[e.ntfLDS_Auth_SignerInfo_Certificate_SignatureInvalid = 2415919385] = "ntfLDS_Auth_SignerInfo_Certificate_SignatureInvalid", e[e.ntfLDS_UnsupportedImageFormat = 2415919386] = "ntfLDS_UnsupportedImageFormat", e[e.ntfLDS_MRZ_DocumentType_Unknown = 139272] = "ntfLDS_MRZ_DocumentType_Unknown", e[e.ntfLDS_MRZ_IssuingState_SyntaxError = 139273] = "ntfLDS_MRZ_IssuingState_SyntaxError", e[e.ntfLDS_MRZ_Name_IsVoid = 139274] = "ntfLDS_MRZ_Name_IsVoid", e[e.ntfLDS_MRZ_Number_IncorrectChecksum = 139277] = "ntfLDS_MRZ_Number_IncorrectChecksum", e[e.ntfLDS_MRZ_Nationality_SyntaxError = 139278] = "ntfLDS_MRZ_Nationality_SyntaxError", e[e.ntfLDS_MRZ_DOB_SyntaxError = 139279] = "ntfLDS_MRZ_DOB_SyntaxError", e[e.ntfLDS_MRZ_DOB_Error = 139280] = "ntfLDS_MRZ_DOB_Error", e[e.ntfLDS_MRZ_DOB_IncorrectChecksum = 139281] = "ntfLDS_MRZ_DOB_IncorrectChecksum", e[e.ntfLDS_MRZ_Sex_Incorrect = 139282] = "ntfLDS_MRZ_Sex_Incorrect", e[e.ntfLDS_MRZ_DOE_SyntaxError = 139283] = "ntfLDS_MRZ_DOE_SyntaxError", e[e.ntfLDS_MRZ_DOE_Error = 139284] = "ntfLDS_MRZ_DOE_Error", e[e.ntfLDS_MRZ_DOE_IncorrectChecksum = 139285] = "ntfLDS_MRZ_DOE_IncorrectChecksum", e[e.ntfLDS_MRZ_OptionalData_IncorrectChecksum = 139286] = "ntfLDS_MRZ_OptionalData_IncorrectChecksum", e[e.ntfLDS_MRZ_IncorrectChecksum = 139287] = "ntfLDS_MRZ_IncorrectChecksum", e[e.ntfLDS_MRZ_Incorrect = 139288] = "ntfLDS_MRZ_Incorrect", e[e.ntfLDS_MRZ_CountryCode_VisualMrz_NonMatching = 139289] = "ntfLDS_MRZ_CountryCode_VisualMrz_NonMatching", e[e.ntfLDS_Biometrics_FormatOwner_Missing = 2415984640] = "ntfLDS_Biometrics_FormatOwner_Missing", e[e.ntfLDS_Biometrics_FormatOwner_Incorrect = 2416050176] = "ntfLDS_Biometrics_FormatOwner_Incorrect", e[e.ntfLDS_Biometrics_FormatType_Missing = 2416115712] = "ntfLDS_Biometrics_FormatType_Missing", e[e.ntfLDS_Biometrics_FormatType_Incorrect = 2416181248] = "ntfLDS_Biometrics_FormatType_Incorrect", e[e.ntfLDS_Biometrics_Type_Incorrect = 2416246784] = "ntfLDS_Biometrics_Type_Incorrect", e[e.ntfLDS_Biometrics_SubType_Missing = 2416312320] = "ntfLDS_Biometrics_SubType_Missing", e[e.ntfLDS_Biometrics_SubType_Incorrect = 2416377856] = "ntfLDS_Biometrics_SubType_Incorrect", e[e.ntfLDS_Biometrics_BDB_Image_Missing = 2416443392] = "ntfLDS_Biometrics_BDB_Image_Missing", e[e.ntfLDS_Biometrics_BDB_FormatID_Incorrect = 2416508928] = "ntfLDS_Biometrics_BDB_FormatID_Incorrect", e[e.ntfLDS_Biometrics_BDB_Version_Incorrect = 2416574464] = "ntfLDS_Biometrics_BDB_Version_Incorrect", e[e.ntfLDS_Biometrics_BDB_DataLength_Incorrect = 241664e4] = "ntfLDS_Biometrics_BDB_DataLength_Incorrect", e[e.ntfLDS_Biometrics_BDB_Data_Incorrect = 2416705536] = "ntfLDS_Biometrics_BDB_Data_Incorrect", e[e.ntfLDS_Biometrics_BDB_Data_Gender = 2416967680] = "ntfLDS_Biometrics_BDB_Data_Gender", e[e.ntfLDS_Biometrics_BDB_Data_EyeColor = 2417033216] = "ntfLDS_Biometrics_BDB_Data_EyeColor", e[e.ntfLDS_Biometrics_BDB_Data_HairColor = 2417098752] = "ntfLDS_Biometrics_BDB_Data_HairColor", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Yaw = 2417164288] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Yaw", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Pitch = 2417229824] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Pitch", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Roll = 2417295360] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Roll", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Yaw = 2417360896] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Yaw", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Pitch = 2417426432] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Pitch", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Roll = 2417491968] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Roll", e[e.ntfLDS_Biometrics_BDB_Data_FaceImageType = 2417557504] = "ntfLDS_Biometrics_BDB_Data_FaceImageType", e[e.ntfLDS_Biometrics_BDB_Data_ImageDataType = 2417623040] = "ntfLDS_Biometrics_BDB_Data_ImageDataType", e[e.ntfLDS_Biometrics_RB_Data_Incorrect = 2449539072] = "ntfLDS_Biometrics_RB_Data_Incorrect", e[e.ntfLDS_Biometrics_RB_Item_Incorrect = 2449604608] = "ntfLDS_Biometrics_RB_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Item_Missing = 2449670144] = "ntfLDS_Biometrics_RB_Item_Missing", e[e.ntfLDS_Biometrics_RB_Item_Unexpected = 2449735680] = "ntfLDS_Biometrics_RB_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_RID_Incorrect = 2449801232] = "ntfLDS_Biometrics_RB_RID_Incorrect", e[e.ntfLDS_Biometrics_RB_ImageR_Incorrect = 2449801248] = "ntfLDS_Biometrics_RB_ImageR_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Item_Incorrect = 2449801264] = "ntfLDS_Biometrics_RB_Image_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Item_Missing = 2449801265] = "ntfLDS_Biometrics_RB_Image_Item_Missing", e[e.ntfLDS_Biometrics_RB_Image_Item_Unexpected = 2449801266] = "ntfLDS_Biometrics_RB_Image_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Incorrect = 2449801280] = "ntfLDS_Biometrics_RB_Image_Info_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Missing = 2449801281] = "ntfLDS_Biometrics_RB_Image_Info_Item_Missing", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Unexpected = 2449801282] = "ntfLDS_Biometrics_RB_Image_Info_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Info_Format_Incorrect = 2449801283] = "ntfLDS_Biometrics_RB_Image_Info_Format_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Format_Unsupported = 2449801284] = "ntfLDS_Biometrics_RB_Image_Info_Format_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_Kind_Incorrect = 2449801285] = "ntfLDS_Biometrics_RB_Image_Info_Kind_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Kind_Unsupported = 2449801286] = "ntfLDS_Biometrics_RB_Image_Info_Kind_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_PostAPB_Incorrect = 2449801287] = "ntfLDS_Biometrics_RB_Image_Info_PostAPB_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_LossyTA_Incorrect = 2449801288] = "ntfLDS_Biometrics_RB_Image_Info_LossyTA_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_LossyTA_Unsupported = 2449801289] = "ntfLDS_Biometrics_RB_Image_Info_LossyTA_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_Cam2Subj_Unsupported = 2449801290] = "ntfLDS_Biometrics_RB_Image_Info_Cam2Subj_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_SensDiag_Unsupported = 2449801291] = "ntfLDS_Biometrics_RB_Image_Info_SensDiag_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_LensF_Unsupported = 2449801292] = "ntfLDS_Biometrics_RB_Image_Info_LensF_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ImSize_Incorrect = 2449801293] = "ntfLDS_Biometrics_RB_Image_Info_ImSize_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_ImSize_Unsupported = 2449801294] = "ntfLDS_Biometrics_RB_Image_Info_ImSize_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ImMeas_Incorrect = 2449801295] = "ntfLDS_Biometrics_RB_Image_Info_ImMeas_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Color_Incorrect = 2449801296] = "ntfLDS_Biometrics_RB_Image_Info_Color_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Color_Unsupported = 2449801297] = "ntfLDS_Biometrics_RB_Image_Info_Color_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ColorMap_Incorrect = 2449801298] = "ntfLDS_Biometrics_RB_Image_Info_ColorMap_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_Item_Incorrect = 2449801312] = "ntfLDS_Biometrics_RB_Image_Capt_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_Item_Unexpected = 2449801313] = "ntfLDS_Biometrics_RB_Image_Capt_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Capt_Spectral_Unsupported = 2449801314] = "ntfLDS_Biometrics_RB_Image_Capt_Spectral_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Capt_TechCode_Incorrect = 2449801315] = "ntfLDS_Biometrics_RB_Image_Capt_TechCode_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_TechCode_Unsupported = 2449801316] = "ntfLDS_Biometrics_RB_Image_Capt_TechCode_Unsupported", e[e.ntfLDS_Biometrics_RB_Date_Item_Incorrect = 2449801328] = "ntfLDS_Biometrics_RB_Date_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Date_Item_Missing = 2449801329] = "ntfLDS_Biometrics_RB_Date_Item_Missing", e[e.ntfLDS_Biometrics_RB_Date_Item_Unexpected = 2449801330] = "ntfLDS_Biometrics_RB_Date_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Date_Incorrect = 2449801331] = "ntfLDS_Biometrics_RB_Date_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Item_Incorrect = 2449801344] = "ntfLDS_Biometrics_RB_Quality_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Item_Missing = 2449801345] = "ntfLDS_Biometrics_RB_Quality_Item_Missing", e[e.ntfLDS_Biometrics_RB_Quality_Item_Unexpected = 2449801346] = "ntfLDS_Biometrics_RB_Quality_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Quality_AlgID_Item_Incorrect = 2449801347] = "ntfLDS_Biometrics_RB_Quality_AlgID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_SoE_Item_Incorrect = 2449801348] = "ntfLDS_Biometrics_RB_Quality_SoE_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Score_Item_Incorrect = 2449801349] = "ntfLDS_Biometrics_RB_Quality_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Error_Item_Incorrect = 2449801350] = "ntfLDS_Biometrics_RB_Quality_Error_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Error_Item_Unsupported = 2449801351] = "ntfLDS_Biometrics_RB_Quality_Error_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Item_Incorrect = 2449801360] = "ntfLDS_Biometrics_RB_PAD_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Item_Unexpected = 2449801361] = "ntfLDS_Biometrics_RB_PAD_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_PAD_Decision_Item_Incorrect = 2449801362] = "ntfLDS_Biometrics_RB_PAD_Decision_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Decision_Item_Unsupported = 2449801363] = "ntfLDS_Biometrics_RB_PAD_Decision_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Score_Item_Incorrect = 2449801364] = "ntfLDS_Biometrics_RB_PAD_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Score_RegID_Item_Incorrect = 2449801365] = "ntfLDS_Biometrics_RB_PAD_Score_RegID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Item_Incorrect = 2449801366] = "ntfLDS_Biometrics_RB_PAD_SoE_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Score_Item_Incorrect = 2449801367] = "ntfLDS_Biometrics_RB_PAD_SoE_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Incorrect = 2449801368] = "ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Unsupported = 2449801369] = "ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_ExtData_Item_Incorrect = 2449801370] = "ntfLDS_Biometrics_RB_PAD_ExtData_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_ExtData_Type_Item_Incorrect = 2449801371] = "ntfLDS_Biometrics_RB_PAD_ExtData_Type_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Context_Item_Incorrect = 2449801372] = "ntfLDS_Biometrics_RB_PAD_Context_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Context_Item_Unsupported = 2449801373] = "ntfLDS_Biometrics_RB_PAD_Context_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_SLevel_Item_Incorrect = 2449801374] = "ntfLDS_Biometrics_RB_PAD_SLevel_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SLevel_Item_Unsupported = 2449801375] = "ntfLDS_Biometrics_RB_PAD_SLevel_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_RiskLevel_Item_Incorrect = 2449801376] = "ntfLDS_Biometrics_RB_PAD_RiskLevel_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Criteria_Item_Incorrect = 2449801377] = "ntfLDS_Biometrics_RB_PAD_Criteria_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Criteria_Item_Unsupported = 2449801378] = "ntfLDS_Biometrics_RB_PAD_Criteria_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Incorrect = 2449801379] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Missing = 2449801380] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Missing", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Unexpected = 2449801381] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_PAD_Date_Incorrect = 2449801382] = "ntfLDS_Biometrics_RB_PAD_Date_Incorrect", e[e.ntfLDS_Biometrics_RB_SessionID_Incorrect = 2449801392] = "ntfLDS_Biometrics_RB_SessionID_Incorrect", e[e.ntfLDS_Biometrics_RB_Derived_Incorrect = 2449801408] = "ntfLDS_Biometrics_RB_Derived_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_Incorrect = 2449801424] = "ntfLDS_Biometrics_RB_Device_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_Item_Unexpected = 2449801425] = "ntfLDS_Biometrics_RB_Device_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Device_ModelID_Item_Incorrect = 2449801426] = "ntfLDS_Biometrics_RB_Device_ModelID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_CertID_Item_Incorrect = 2449801427] = "ntfLDS_Biometrics_RB_Device_CertID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Item_Incorrect = 2449801440] = "ntfLDS_Biometrics_RB_Metadata_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Item_Unexpected = 2449801441] = "ntfLDS_Biometrics_RB_Metadata_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Gender_Item_Incorrect = 2449801442] = "ntfLDS_Biometrics_RB_Metadata_Gender_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Gender_Item_Unsupported = 2449801443] = "ntfLDS_Biometrics_RB_Metadata_Gender_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Eye_Item_Incorrect = 2449801444] = "ntfLDS_Biometrics_RB_Metadata_Eye_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Eye_Item_Unsupported = 2449801445] = "ntfLDS_Biometrics_RB_Metadata_Eye_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Hair_Item_Incorrect = 2449801446] = "ntfLDS_Biometrics_RB_Metadata_Hair_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Hair_Item_Unsupported = 2449801447] = "ntfLDS_Biometrics_RB_Metadata_Hair_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Height_Item_Incorrect = 2449801448] = "ntfLDS_Biometrics_RB_Metadata_Height_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Props_Item_Incorrect = 2449801449] = "ntfLDS_Biometrics_RB_Metadata_Props_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Props_Item_Unexpected = 2449801450] = "ntfLDS_Biometrics_RB_Metadata_Props_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Express_Item_Incorrect = 2449801451] = "ntfLDS_Biometrics_RB_Metadata_Express_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Express_Item_Unexpected = 2449801452] = "ntfLDS_Biometrics_RB_Metadata_Express_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Pose_Item_Incorrect = 2449801453] = "ntfLDS_Biometrics_RB_Metadata_Pose_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Pose_Item_Unexpected = 2449801454] = "ntfLDS_Biometrics_RB_Metadata_Pose_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Incorrect = 2449801456] = "ntfLDS_Biometrics_RB_LandMark_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Missing = 2449801457] = "ntfLDS_Biometrics_RB_LandMark_Item_Missing", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Unexpected = 2449801458] = "ntfLDS_Biometrics_RB_LandMark_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_LandMark_Kind_Item_Incorrect = 2449801459] = "ntfLDS_Biometrics_RB_LandMark_Kind_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Incorrect = 2449801460] = "ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Unsupported = 2449801461] = "ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_LandMark_AntrL_Item_Incorrect = 2449801462] = "ntfLDS_Biometrics_RB_LandMark_AntrL_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Coord_Item_Incorrect = 2449801463] = "ntfLDS_Biometrics_RB_LandMark_Coord_Item_Incorrect", e[e.ntfLDS_DTC_ContentInfo_Version_Incorrect = 2415919872] = "ntfLDS_DTC_ContentInfo_Version_Incorrect", e[e.ntfLDS_SI_PACE_Info_UnsupportedStdParameters = 2432696320] = "ntfLDS_SI_PACE_Info_UnsupportedStdParameters", e[e.ntfLDS_SI_PACE_Info_DeprecatedVersion = 2432696321] = "ntfLDS_SI_PACE_Info_DeprecatedVersion", e[e.ntfLDS_SI_PACE_DomainParams_UsingStdRef = 2432696322] = "ntfLDS_SI_PACE_DomainParams_UsingStdRef", e[e.ntfLDS_SI_PACE_DomainParams_UnsupportedAlgorithm = 2432696323] = "ntfLDS_SI_PACE_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_CA_Info_IncorrectVersion = 2432696324] = "ntfLDS_SI_CA_Info_IncorrectVersion", e[e.ntfLDS_SI_CA_PublicKey_UnsupportedAlgorithm = 2432696325] = "ntfLDS_SI_CA_PublicKey_UnsupportedAlgorithm", e[e.ntfLDS_SI_CA_DomainParams_UnsupportedAlgorithm = 2432696326] = "ntfLDS_SI_CA_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_TA_Info_IncorrectVersion = 2432696327] = "ntfLDS_SI_TA_Info_IncorrectVersion", e[e.ntfLDS_SI_TA_Info_FileIDForVersion2 = 2432696328] = "ntfLDS_SI_TA_Info_FileIDForVersion2", e[e.ntfLDS_SI_eIDSecurity_UnsupportedDigestAlgorithm = 2432696329] = "ntfLDS_SI_eIDSecurity_UnsupportedDigestAlgorithm", e[e.ntfLDS_SI_RI_Info_IncorrectVersion = 2432696330] = "ntfLDS_SI_RI_Info_IncorrectVersion", e[e.ntfLDS_SI_RI_DomainParams_UnsupportedAlgorithm = 2432696331] = "ntfLDS_SI_RI_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_AA_Info_IncorrectVersion = 2432696332] = "ntfLDS_SI_AA_Info_IncorrectVersion", e[e.ntfLDS_SI_AA_Info_UnsupportedAlgorithm = 2432696333] = "ntfLDS_SI_AA_Info_UnsupportedAlgorithm", e[e.ntfLDS_SI_AA_Info_InconsistentAlgorithmReference = 2432696334] = "ntfLDS_SI_AA_Info_InconsistentAlgorithmReference", e[e.ntfLDS_SI_Storage_PACE_Info_NotAvailable = 2432696576] = "ntfLDS_SI_Storage_PACE_Info_NotAvailable", e[e.ntfLDS_SI_Storage_PACE_Info_NoStdParameters = 2432696577] = "ntfLDS_SI_Storage_PACE_Info_NoStdParameters", e[e.ntfLDS_SI_Storage_PACE_Info_NoMatchingDomainParams = 2432696578] = "ntfLDS_SI_Storage_PACE_Info_NoMatchingDomainParams", e[e.ntfLDS_SI_Storage_CA_Info_NotAvailable = 2432696579] = "ntfLDS_SI_Storage_CA_Info_NotAvailable", e[e.ntfLDS_SI_Storage_CA_DomainParams_NoRequiredOption = 2432696580] = "ntfLDS_SI_Storage_CA_DomainParams_NoRequiredOption", e[e.ntfLDS_SI_Storage_CA_DomainParams_NotAvailable = 2432696581] = "ntfLDS_SI_Storage_CA_DomainParams_NotAvailable", e[e.ntfLDS_SI_Storage_CA_AnonymousInfos = 2432696582] = "ntfLDS_SI_Storage_CA_AnonymousInfos", e[e.ntfLDS_SI_Storage_CA_Info_NoMatchingDomainParams = 2432696583] = "ntfLDS_SI_Storage_CA_Info_NoMatchingDomainParams", e[e.ntfLDS_SI_Storage_CA_Info_NoMatchingPublicKey = 2432696584] = "ntfLDS_SI_Storage_CA_Info_NoMatchingPublicKey", e[e.ntfLDS_SI_Storage_CA_IncorrectInfosQuantity = 2432696585] = "ntfLDS_SI_Storage_CA_IncorrectInfosQuantity", e[e.ntfLDS_SI_Storage_TA_Info_NotAvailable = 2432696586] = "ntfLDS_SI_Storage_TA_Info_NotAvailable", e[e.ntfLDS_SI_Storage_CardInfoLocator_MultipleEntries = 2432696587] = "ntfLDS_SI_Storage_CardInfoLocator_MultipleEntries", e[e.ntfLDS_SI_Storage_eIDSecurityInfo_MultipleEntries = 2432696588] = "ntfLDS_SI_Storage_eIDSecurityInfo_MultipleEntries", e[e.ntfLDS_SI_Storage_PrivilegedTI_MultipleEntries = 2432696589] = "ntfLDS_SI_Storage_PrivilegedTI_MultipleEntries", e[e.ntfLDS_SI_Storage_PrivilegedTI_IncorrectUsage = 2432696590] = "ntfLDS_SI_Storage_PrivilegedTI_IncorrectUsage", e[e.ntfLDS_SI_Storage_RI_DomainParams_MultipleEntries = 2432696591] = "ntfLDS_SI_Storage_RI_DomainParams_MultipleEntries", e[e.ntfLDS_SI_Storage_PACEInfos_NonConsistant = 2432696592] = "ntfLDS_SI_Storage_PACEInfos_NonConsistant", e[e.ntfLDS_CVCertificate_Profile_IncorrectVersion = 2432696833] = "ntfLDS_CVCertificate_Profile_IncorrectVersion", e[e.ntfLDS_CVCertificate_Validity = 2432696834] = "ntfLDS_CVCertificate_Validity", e[e.ntfLDS_CVCertificate_NonCVCADomainParameters = 2432696835] = "ntfLDS_CVCertificate_NonCVCADomainParameters", e[e.ntfLDS_CV_Certificate_PrivateKey_IncorrectVersion = 2432696836] = "ntfLDS_CV_Certificate_PrivateKey_IncorrectVersion", e[e.ntfLDS_TA_PACEStaticBindingUsed = 2432697088] = "ntfLDS_TA_PACEStaticBindingUsed", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_Validity = 2449473813] = "ntfLDS_Auth_MLSignerInfo_Certificate_Validity", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_RootIsNotTrusted = 2449473814] = "ntfLDS_Auth_MLSignerInfo_Certificate_RootIsNotTrusted", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_CantFindCSCA = 2449473815] = "ntfLDS_Auth_MLSignerInfo_Certificate_CantFindCSCA", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_Revoked = 2449473816] = "ntfLDS_Auth_MLSignerInfo_Certificate_Revoked", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_SignatureInvalid = 2449473817] = "ntfLDS_Auth_MLSignerInfo_Certificate_SignatureInvalid", e))(RM || {}), j2 = /* @__PURE__ */ ((e) => (e[e.NOT_FINISHED = 0] = "NOT_FINISHED", e[e.FINISHED = 1] = "FINISHED", e[e.TIMEOUT = 2] = "TIMEOUT", e))(j2 || {}), DM = /* @__PURE__ */ ((e) => (e[e.RFID_Error_NoError = 1] = "RFID_Error_NoError", e[e.RFID_Error_AlreadyDone = 2] = "RFID_Error_AlreadyDone", e[e.RFID_Error_Failed = 4294967295] = "RFID_Error_Failed", e[e.RFID_Error_NoChipDetected = 2147549185] = "RFID_Error_NoChipDetected", e[e.RFID_Error_NotAvailable = 2147549186] = "RFID_Error_NotAvailable", e[e.RFID_Error_InvalidParameter = 2147549188] = "RFID_Error_InvalidParameter", e[e.RFID_Error_NotInitialized = 2147549189] = "RFID_Error_NotInitialized", e[e.RFID_Error_NotEnoughMemory = 2147549190] = "RFID_Error_NotEnoughMemory", e[e.RFID_Error_NotEnoughData = 2147549191] = "RFID_Error_NotEnoughData", e[e.RFID_Error_InvalidDirectory = 2147549192] = "RFID_Error_InvalidDirectory", e[e.RFID_Error_UnknownCommand = 2147549193] = "RFID_Error_UnknownCommand", e[e.RFID_Error_FileIOError = 2147549194] = "RFID_Error_FileIOError", e[e.RFID_Error_Busy = 2147549195] = "RFID_Error_Busy", e[e.RFID_Error_OldFirmware = 2147549196] = "RFID_Error_OldFirmware", e[e.RFID_Error_PCSC_Failed = 2147614720] = "RFID_Error_PCSC_Failed", e[e.RFID_Error_PCSC_ReaderNotAvailable = 2147614721] = "RFID_Error_PCSC_ReaderNotAvailable", e[e.RFID_Error_PCSC_CantConnectCard = 2147614722] = "RFID_Error_PCSC_CantConnectCard", e[e.RFID_Error_PCSC_CardIsNotConnected = 2147614723] = "RFID_Error_PCSC_CardIsNotConnected", e[e.RFID_Error_PCSC_OperationCancelled = 2147614724] = "RFID_Error_PCSC_OperationCancelled", e[e.RFID_Error_PCSC_CardIsBusy = 2147614725] = "RFID_Error_PCSC_CardIsBusy", e[e.RFID_Error_PCSC_FailedSCard = 2147614726] = "RFID_Error_PCSC_FailedSCard", e[e.RFID_Error_PCSC_ExtLe_Failed = 2147614736] = "RFID_Error_PCSC_ExtLe_Failed", e[e.RFID_LAYER6_SECURITY_MANAGER = 2248146944] = "RFID_LAYER6_SECURITY_MANAGER", e[e.RFID_LAYER6_APP_SELECTION_FAILURE = 2248146945] = "RFID_LAYER6_APP_SELECTION_FAILURE", e[e.RFID_LAYER6_MUTUAL_AUTH_MAC_FAIL = 2248147200] = "RFID_LAYER6_MUTUAL_AUTH_MAC_FAIL", e[e.RFID_LAYER6_MUTUAL_AUTH_ENC_FAIL = 2248147201] = "RFID_LAYER6_MUTUAL_AUTH_ENC_FAIL", e[e.RFID_LAYER6_MUTUAL_AUTH_FAILURE = 2248147202] = "RFID_LAYER6_MUTUAL_AUTH_FAILURE", e[e.RFID_LAYER6_MUTUAL_AUTH_FAILURE_DATA = 2248147203] = "RFID_LAYER6_MUTUAL_AUTH_FAILURE_DATA", e[e.RFID_LAYER6_SM_DO8E_MISSING = 2248147456] = "RFID_LAYER6_SM_DO8E_MISSING", e[e.RFID_LAYER6_SM_DO87_MISSING = 2248147457] = "RFID_LAYER6_SM_DO87_MISSING", e[e.RFID_LAYER6_SM_DO99_MISSING = 2248147458] = "RFID_LAYER6_SM_DO99_MISSING", e[e.RFID_LAYER6_SM_MAC_INCORRECT = 2248147459] = "RFID_LAYER6_SM_MAC_INCORRECT", e[e.RFID_LAYER6_SM_DO87_INCORRECT = 2248147460] = "RFID_LAYER6_SM_DO87_INCORRECT", e[e.RFID_LAYER6_NON_TLV_RESPONSE_DATA = 2248147712] = "RFID_LAYER6_NON_TLV_RESPONSE_DATA", e[e.RFID_LAYER6_WRONG_RND_ICC_LENGTH = 2248147713] = "RFID_LAYER6_WRONG_RND_ICC_LENGTH", e[e.RFID_LAYER6_INT_AUTH_FAILURE = 2248147714] = "RFID_LAYER6_INT_AUTH_FAILURE", e[e.RFID_LAYER6_MSE_SET_KAT_FAILURE = 2248147715] = "RFID_LAYER6_MSE_SET_KAT_FAILURE", e[e.RFID_LAYER6_MSE_SET_DST_FAILURE = 2248147716] = "RFID_LAYER6_MSE_SET_DST_FAILURE", e[e.RFID_LAYER6_PSO_CERTIFICATE_FAILURE = 2248147717] = "RFID_LAYER6_PSO_CERTIFICATE_FAILURE", e[e.RFID_LAYER6_MSE_SET_AT_FAILURE = 2248147718] = "RFID_LAYER6_MSE_SET_AT_FAILURE", e[e.RFID_LAYER6_GET_CHALLENGE_FAILURE = 2248147719] = "RFID_LAYER6_GET_CHALLENGE_FAILURE", e[e.RFID_LAYER6_EXT_AUTH_FAILURE = 2248147720] = "RFID_LAYER6_EXT_AUTH_FAILURE", e[e.RFID_LAYER6_GENERAL_AUTH_FAILURE = 2248147721] = "RFID_LAYER6_GENERAL_AUTH_FAILURE", e[e.RFID_LAYER6_FILE_NOT_FOUND = 2147510914] = "RFID_LAYER6_FILE_NOT_FOUND", e[e.RFID_LAYER6_FILE_EOF1 = 2147508866] = "RFID_LAYER6_FILE_EOF1", e[e.RFID_LAYER6_FILE_EOF2 = 2147511040] = "RFID_LAYER6_FILE_EOF2", e[e.RFID_LAYER6_WRONG_LENGTH = 2147510016] = "RFID_LAYER6_WRONG_LENGTH", e[e.RFID_LAYER6_INCORRECT_PARAMS = 2147510912] = "RFID_LAYER6_INCORRECT_PARAMS", e[e.RFID_LAYER6_NO_REFERENCE_DATA = 2147510920] = "RFID_LAYER6_NO_REFERENCE_DATA", e[e.RFID_LAYER6_PWD_SUSPENDED = 2147509185] = "RFID_LAYER6_PWD_SUSPENDED", e[e.RFID_LAYER6_PWD_BLOCKED = 2147509184] = "RFID_LAYER6_PWD_BLOCKED", e[e.RFID_LAYER6_PWD_DEACTIVATED = 2147508867] = "RFID_LAYER6_PWD_DEACTIVATED", e[e.RFID_LAYER6_PWD_BLOCKED_2 = 2147510659] = "RFID_LAYER6_PWD_BLOCKED_2", e[e.RFID_LAYER6_PWD_DEACTIVATED_2 = 2147510660] = "RFID_LAYER6_PWD_DEACTIVATED_2", e[e.RFID_LAYER6_PWD_SUSPENDED_2 = 2147510661] = "RFID_LAYER6_PWD_SUSPENDED_2", e[e.RFID_LAYER6_PWD_FAILED = 2148557760] = "RFID_LAYER6_PWD_FAILED", e[e.RFID_Error_NotPerformed = 2197815296] = "RFID_Error_NotPerformed", e[e.RFID_Error_Session_IsClosed = 2197815297] = "RFID_Error_Session_IsClosed", e[e.RFID_Error_Session_Terminal_UnsupportedOperation = 2197815298] = "RFID_Error_Session_Terminal_UnsupportedOperation", e[e.RFID_Error_Session_TerminalType_Unknown = 2197815312] = "RFID_Error_Session_TerminalType_Unknown", e[e.RFID_Error_Session_TerminalType_BadCertificate = 2197815313] = "RFID_Error_Session_TerminalType_BadCertificate", e[e.RFID_Error_Session_TerminalType_NotSet = 2197815314] = "RFID_Error_Session_TerminalType_NotSet", e[e.RFID_Error_Session_ProcedureType_Unknown = 2197815315] = "RFID_Error_Session_ProcedureType_Unknown", e[e.RFID_Error_Session_ProcedureType_Unsupported = 2197815316] = "RFID_Error_Session_ProcedureType_Unsupported", e[e.RFID_Error_Session_ProcedureType_NotSet = 2197815317] = "RFID_Error_Session_ProcedureType_NotSet", e[e.RFID_Error_Session_AccessKey_UnknownType = 2197815318] = "RFID_Error_Session_AccessKey_UnknownType", e[e.RFID_Error_Session_AccessKey_UnsupportedSMType = 2197815319] = "RFID_Error_Session_AccessKey_UnsupportedSMType", e[e.RFID_Error_Session_AccessKey_IncorrectSMType = 2197815320] = "RFID_Error_Session_AccessKey_IncorrectSMType", e[e.RFID_Error_Session_AccessKey_Restricted = 2197815321] = "RFID_Error_Session_AccessKey_Restricted", e[e.RFID_Error_Session_AccessKey_IncorrectData = 2197815322] = "RFID_Error_Session_AccessKey_IncorrectData", e[e.RFID_Error_Session_AccessKey_NotSet = 2197815323] = "RFID_Error_Session_AccessKey_NotSet", e[e.RFID_Error_Session_PwdManagement_NotAuthorized = 2197815324] = "RFID_Error_Session_PwdManagement_NotAuthorized", e[e.RFID_Error_Session_AccessControl_UnknownType = 2197815328] = "RFID_Error_Session_AccessControl_UnknownType", e[e.RFID_Error_Session_AccessControl_RequiresSM = 2197815329] = "RFID_Error_Session_AccessControl_RequiresSM", e[e.RFID_Error_Session_AccessControl_RequiresPACE = 2197815330] = "RFID_Error_Session_AccessControl_RequiresPACE", e[e.RFID_Error_Session_AccessControl_RequiresCAKeys = 2197815331] = "RFID_Error_Session_AccessControl_RequiresCAKeys", e[e.RFID_Error_Session_AccessControl_RequiresTA = 2197815332] = "RFID_Error_Session_AccessControl_RequiresTA", e[e.RFID_Error_Session_AccessControl_RequiresCA = 2197815333] = "RFID_Error_Session_AccessControl_RequiresCA", e[e.RFID_Error_Session_AccessControl_IncorrectOptionCA = 2197815334] = "RFID_Error_Session_AccessControl_IncorrectOptionCA", e[e.RFID_Error_Session_AccessControl_CA_Failed = 2197815335] = "RFID_Error_Session_AccessControl_CA_Failed", e[e.RFID_Error_Session_AccessControl_TA_Failed = 2197815336] = "RFID_Error_Session_AccessControl_TA_Failed", e[e.RFID_Error_Session_AccessControl_AA_Failed = 2197815337] = "RFID_Error_Session_AccessControl_AA_Failed", e[e.RFID_Error_Session_AccessControl_RI_Failed = 2197815338] = "RFID_Error_Session_AccessControl_RI_Failed", e[e.RFID_Error_Session_PA_SignatureCheckFailed = 2197815344] = "RFID_Error_Session_PA_SignatureCheckFailed", e[e.RFID_Error_Session_PA_HashCheckFailed = 2197815345] = "RFID_Error_Session_PA_HashCheckFailed", e[e.RFID_Error_Session_InvalidAuxData_DateOfExpiry = 2197815360] = "RFID_Error_Session_InvalidAuxData_DateOfExpiry", e[e.RFID_Error_Session_InvalidAuxData_DateOfBirth = 2197815361] = "RFID_Error_Session_InvalidAuxData_DateOfBirth", e[e.RFID_Error_Session_InvalidAuxData_CommunityID = 2197815362] = "RFID_Error_Session_InvalidAuxData_CommunityID", e[e.RFID_Error_Session_eSign_RequiresAppSelection = 2197815376] = "RFID_Error_Session_eSign_RequiresAppSelection", e[e.RFID_Error_Session_eSign_PIN_NotSet = 2197815377] = "RFID_Error_Session_eSign_PIN_NotSet", e[e.RFID_Error_Session_eSign_PIN_NotVerified = 2197815378] = "RFID_Error_Session_eSign_PIN_NotVerified", e[e.RFID_Error_Session_IncorrectData = 2197815392] = "RFID_Error_Session_IncorrectData", e[e.RFID_Error_Session_File_NotEnoughData = 2197880832] = "RFID_Error_Session_File_NotEnoughData", e[e.RFID_Error_Session_File_IncorrectData = 2197946368] = "RFID_Error_Session_File_IncorrectData", e[e.RFID_Error_Session_File_UnexpectedData = 2198011904] = "RFID_Error_Session_File_UnexpectedData", e[e.RFID_Error_Session_File_Contents_UnexpectedData = 2198077440] = "RFID_Error_Session_File_Contents_UnexpectedData", e[e.RFID_Error_Session_File_WrongTag = 2198142976] = "RFID_Error_Session_File_WrongTag", e[e.RFID_Error_Session_File_CantUseData = 2198208512] = "RFID_Error_Session_File_CantUseData", e[e.RFID_Error_Session_File_CantReadData = 2198274048] = "RFID_Error_Session_File_CantReadData", e[e.RFID_Error_Session_File_AccessDenied = 2198339584] = "RFID_Error_Session_File_AccessDenied", e[e.RFID_Error_Layer34_NoError = 2214592512] = "RFID_Error_Layer34_NoError", e[e.RFID_Error_Layer34_TimeOut = 2214658048] = "RFID_Error_Layer34_TimeOut", e[e.RFID_Error_Layer34_Collision = 2214723584] = "RFID_Error_Layer34_Collision", e[e.RFID_Error_Layer34_CRC = 2214789120] = "RFID_Error_Layer34_CRC", e[e.RFID_Error_Layer34_DataIntegrity = 2214854656] = "RFID_Error_Layer34_DataIntegrity", e[e.RFID_Error_Layer34_DataLength = 2214920192] = "RFID_Error_Layer34_DataLength", e[e.RFID_Error_Layer34_RFU = 2214985728] = "RFID_Error_Layer34_RFU", e[e.RFID_Error_Layer34_Collision_TooMany = 2215051264] = "RFID_Error_Layer34_Collision_TooMany", e[e.RFID_Error_Layer34_ProtocolB = 2215116800] = "RFID_Error_Layer34_ProtocolB", e[e.RFID_Error_Layer34_DataContents = 2215182336] = "RFID_Error_Layer34_DataContents", e[e.RFID_Error_Layer34_Protocol = 2215247872] = "RFID_Error_Layer34_Protocol", e[e.RFID_Error_Layer34_GlobalTimeOut = 2215313408] = "RFID_Error_Layer34_GlobalTimeOut", e[e.RFID_Error_Layer34_MIFARE_Auth = 2215378944] = "RFID_Error_Layer34_MIFARE_Auth", e[e.RFID_Error_Layer34_SAM_Error = 2215444480] = "RFID_Error_Layer34_SAM_Error", e[e.RFID_Error_Layer34_SAM_Collision = 2215510016] = "RFID_Error_Layer34_SAM_Collision", e[e.RFID_Error_Layer34_SAM_Acknowledge = 2215575552] = "RFID_Error_Layer34_SAM_Acknowledge", e))(DM || {}), AM = /* @__PURE__ */ ((e) => (e[e.CERTIFICATE_PA = 0] = "CERTIFICATE_PA", e[e.CERTIFICATE_TA = 1] = "CERTIFICATE_TA", e[e.LDIF = 2] = "LDIF", e[e.CRL = 3] = "CRL", e[e.ML = 4] = "ML", e[e.DEFL = 5] = "DEFL", e[e.DEVL = 6] = "DEVL", e[e.BL = 7] = "BL", e[e.LDIF_TA = 8] = "LDIF_TA", e[e.ML_TA = 9] = "ML_TA", e))(AM || {}), An = /* @__PURE__ */ ((e) => (e[e.DOCUMENT_IMAGE = 1] = "DOCUMENT_IMAGE", e[e.MRZ_TEXT = 3] = "MRZ_TEXT", e[e.BARCODES = 5] = "BARCODES", e[e.VISUAL_GRAPHICS = 6] = "VISUAL_GRAPHICS", e[e.MRZ_TEST_QUALITY = 7] = "MRZ_TEST_QUALITY", e[e.DOCUMENT_TYPE_CANDIDATES = 8] = "DOCUMENT_TYPE_CANDIDATES", e[e.DOCUMENT_TYPE = 9] = "DOCUMENT_TYPE", e[e.LEXICAL_ANALYSIS = 15] = "LEXICAL_ANALYSIS", e[e.RAW_UNCROPPED_IMAGE = 16] = "RAW_UNCROPPED_IMAGE", e[e.VISUAL_TEXT = 17] = "VISUAL_TEXT", e[e.BARCODE_TEXT = 18] = "BARCODE_TEXT", e[e.BARCODE_GRAPHICS = 19] = "BARCODE_GRAPHICS", e[e.AUTHENTICITY = 20] = "AUTHENTICITY", e[e.MAGNETIC_STRIPE_TEXT_DATA = 26] = "MAGNETIC_STRIPE_TEXT_DATA", e[e.IMAGE_QUALITY = 30] = "IMAGE_QUALITY", e[e.LIVE_PORTRAIT = 32] = "LIVE_PORTRAIT", e[e.STATUS = 33] = "STATUS", e[e.PORTRAIT_COMPARISON = 34] = "PORTRAIT_COMPARISON", e[e.EXT_PORTRAIT = 35] = "EXT_PORTRAIT", e[e.TEXT = 36] = "TEXT", e[e.IMAGES = 37] = "IMAGES", e[e.FINGERPRINTS = 38] = "FINGERPRINTS", e[e.FINGERPRINT_COMPARISON = 39] = "FINGERPRINT_COMPARISON", e[e.ENCRYPTED_RCL = 49] = "ENCRYPTED_RCL", e[e.LICENSE = 50] = "LICENSE", e[e.MRZ_POSITION = 61] = "MRZ_POSITION", e[e.BARCODE_POSITION = 62] = "BARCODE_POSITION", e[e.DOCUMENT_POSITION = 85] = "DOCUMENT_POSITION", e[e.MRZ_DETECTOR = 87] = "MRZ_DETECTOR", e[e.FACE_DETECTION = 97] = "FACE_DETECTION", e[e.RFID_RAW_DATA = 101] = "RFID_RAW_DATA", e[e.RFID_TEXT = 102] = "RFID_TEXT", e[e.RFID_GRAPHICS = 103] = "RFID_GRAPHICS", e[e.RFID_BINARY_DATA = 104] = "RFID_BINARY_DATA", e[e.RFID_ORIGINAL_GRAPHICS = 105] = "RFID_ORIGINAL_GRAPHICS", e[e.DTC_VC = 109] = "DTC_VC", e))(An || {}), TM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.MIFARE_1K = 1] = "MIFARE_1K", e[e.MIFARE_4K = 2] = "MIFARE_4K", e[e.MIFARE_ULTRALIGHT = 3] = "MIFARE_ULTRALIGHT", e[e.MIFARE_DES_FIRE = 4] = "MIFARE_DES_FIRE", e[e.MIFARE_PROX = 5] = "MIFARE_PROX", e))(TM || {}), OM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.BAC = 1] = "BAC", e[e.PACE = 2] = "PACE", e[e.CA = 3] = "CA", e[e.TA = 4] = "TA", e[e.AA = 5] = "AA", e[e.RI = 6] = "RI", e[e.CARD_INFO = 10] = "CARD_INFO", e[e.DTC_INFO = 11] = "DTC_INFO", e))(OM || {}), yM = /* @__PURE__ */ ((e) => (e[e.ROOT_FILES = 0] = "ROOT_FILES", e[e.E_PASSPORT = 1] = "E_PASSPORT", e[e.E_ID = 2] = "E_ID", e[e.E_SIGN = 3] = "E_SIGN", e[e.E_DL = 4] = "E_DL", e[e.LDS2_TravelRecords = 5] = "LDS2_TravelRecords", e[e.LDS2_VisaRecords = 6] = "LDS2_VisaRecords", e[e.LDS2_AddBiometrics = 7] = "LDS2_AddBiometrics", e[e.eDTC_PC = 8] = "eDTC_PC", e))(yM || {}), NM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.STANDARD = 1] = "STANDARD", e[e.ADVANCED = 2] = "ADVANCED", e[e.GENERAL = 3] = "GENERAL", e))(NM || {}), LM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.RFBR_106 = 1] = "RFBR_106", e[e.RFBR_212 = 2] = "RFBR_212", e[e.RFBR_424 = 4] = "RFBR_424", e[e.RFBR_848 = 8] = "RFBR_848", e[e.RFBR_1695 = 16] = "RFBR_1695", e[e.RFBR_3390 = 32] = "RFBR_3390", e[e.RFBR_6780 = 64] = "RFBR_6780", e))(LM || {}), MM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.PKD = 1] = "PKD", e[e.SECURITY_OBJECT = 2] = "SECURITY_OBJECT", e[e.USER_DEFINED = 3] = "USER_DEFINED", e[e.MASTER_LIST_PKD = 4] = "MASTER_LIST_PKD", e[e.MASTER_LIST_SO = 5] = "MASTER_LIST_SO", e[e.DEFECT_LIST_SO = 6] = "DEFECT_LIST_SO", e[e.DEVIATION_LIST_SO = 7] = "DEVIATION_LIST_SO", e[e.BLACK_LIST_SO = 8] = "BLACK_LIST_SO", e))(MM || {}), PM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.CSCA = 1] = "CSCA", e[e.CSCA_LINK = 2] = "CSCA_LINK", e[e.DS = 3] = "DS", e[e.MLS = 4] = "MLS", e[e.DEV_LS = 5] = "DEV_LS", e[e.DEF_LS = 6] = "DEF_LS", e[e.BLS = 7] = "BLS", e[e.LDS2 = 8] = "LDS2", e[e.BCS = 9] = "BCS", e[e.BCS_NC = 10] = "BCS_NC", e[e.DTCS = 11] = "DTCS", e))(PM || {}), bM = /* @__PURE__ */ ((e) => (e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.PASSPORT_DG1 = 1] = "PASSPORT_DG1", e[e.PASSPORT_DG2 = 2] = "PASSPORT_DG2", e[e.PASSPORT_DG3 = 3] = "PASSPORT_DG3", e[e.PASSPORT_DG4 = 4] = "PASSPORT_DG4", e[e.PASSPORT_DG5 = 5] = "PASSPORT_DG5", e[e.PASSPORT_DG6 = 6] = "PASSPORT_DG6", e[e.PASSPORT_DG7 = 7] = "PASSPORT_DG7", e[e.PASSPORT_DG8 = 8] = "PASSPORT_DG8", e[e.PASSPORT_DG9 = 9] = "PASSPORT_DG9", e[e.PASSPORT_DG10 = 10] = "PASSPORT_DG10", e[e.PASSPORT_DG11 = 11] = "PASSPORT_DG11", e[e.PASSPORT_DG12 = 12] = "PASSPORT_DG12", e[e.PASSPORT_DG13 = 13] = "PASSPORT_DG13", e[e.PASSPORT_DG14 = 14] = "PASSPORT_DG14", e[e.PASSPORT_DG15 = 15] = "PASSPORT_DG15", e[e.PASSPORT_DG16 = 16] = "PASSPORT_DG16", e[e.PASSPORT_DG17 = 17] = "PASSPORT_DG17", e[e.PASSPORT_DG18 = 18] = "PASSPORT_DG18", e[e.PASSPORT_DG19 = 19] = "PASSPORT_DG19", e[e.PASSPORT_DG20 = 20] = "PASSPORT_DG20", e[e.PASSPORT_SOD = 21] = "PASSPORT_SOD", e[e.PASSPORT_CVCA = 22] = "PASSPORT_CVCA", e[e.PASSPORT_COM = 23] = "PASSPORT_COM", e[e.DTC_DG17 = 57] = "DTC_DG17", e[e.DTC_DG18 = 58] = "DTC_DG18", e[e.DTC_DG22 = 62] = "DTC_DG22", e[e.DTC_DG23 = 63] = "DTC_DG23", e[e.DTC_DG24 = 64] = "DTC_DG24", e[e.ID_DG1 = 101] = "ID_DG1", e[e.ID_DG2 = 102] = "ID_DG2", e[e.ID_DG3 = 103] = "ID_DG3", e[e.ID_DG4 = 104] = "ID_DG4", e[e.ID_DG5 = 105] = "ID_DG5", e[e.ID_DG6 = 106] = "ID_DG6", e[e.ID_DG7 = 107] = "ID_DG7", e[e.ID_DG8 = 108] = "ID_DG8", e[e.ID_DG9 = 109] = "ID_DG9", e[e.ID_DG10 = 110] = "ID_DG10", e[e.ID_DG11 = 111] = "ID_DG11", e[e.ID_DG12 = 112] = "ID_DG12", e[e.ID_DG13 = 113] = "ID_DG13", e[e.ID_DG14 = 114] = "ID_DG14", e[e.ID_DG15 = 115] = "ID_DG15", e[e.ID_DG16 = 116] = "ID_DG16", e[e.ID_DG17 = 117] = "ID_DG17", e[e.ID_DG18 = 118] = "ID_DG18", e[e.ID_DG19 = 119] = "ID_DG19", e[e.ID_DG20 = 120] = "ID_DG20", e[e.ID_DG21 = 121] = "ID_DG21", e[e.DL_COM = 150] = "DL_COM", e[e.DL_DG1 = 151] = "DL_DG1", e[e.DL_DG2 = 152] = "DL_DG2", e[e.DL_DG3 = 153] = "DL_DG3", e[e.DL_DG4 = 154] = "DL_DG4", e[e.DL_DG5 = 155] = "DL_DG5", e[e.DL_DG6 = 156] = "DL_DG6", e[e.DL_DG7 = 157] = "DL_DG7", e[e.DL_DG8 = 158] = "DL_DG8", e[e.DL_DG9 = 159] = "DL_DG9", e[e.DL_DG10 = 160] = "DL_DG10", e[e.DL_DG11 = 161] = "DL_DG11", e[e.DL_DG12 = 162] = "DL_DG12", e[e.DL_DG13 = 163] = "DL_DG13", e[e.DL_DG14 = 164] = "DL_DG14", e[e.DL_SOD = 165] = "DL_SOD", e[e.DL_CE = 166] = "DL_CE", e[e.DL_CVCA = 167] = "DL_CVCA", e[e.PACE_CARD_ACCESS = 200] = "PACE_CARD_ACCESS", e[e.PACE_CARD_SECURITY = 201] = "PACE_CARD_SECURITY", e[e.PACE_CHIP_SECURITY = 202] = "PACE_CHIP_SECURITY", e[e.MIFARE_DATA = 300] = "MIFARE_DATA", e[e.MIFARE_VALIDITY = 301] = "MIFARE_VALIDITY", e[e.AUTHENTICITY_V2 = 302] = "AUTHENTICITY_V2", e[e.ATR = 400] = "ATR", e[e.DIR = 401] = "DIR", e[e.E_SIGN_PK = 500] = "E_SIGN_PK", e[e.E_SIGN_SIGNED_DATA = 501] = "E_SIGN_SIGNED_DATA", e[e.CERTIFICATE = 600] = "CERTIFICATE", e[e.MASTER_LIST = 601] = "MASTER_LIST", e[e.DEFECT_LIST = 602] = "DEFECT_LIST", e[e.DEVIATION_LIST = 603] = "DEVIATION_LIST", e[e.BLACK_LIST = 604] = "BLACK_LIST", e[e.APP_DIRECTORY = 700] = "APP_DIRECTORY", e[e.SESSION = 701] = "SESSION", e[e.LOG_DATA = 702] = "LOG_DATA", e[e.CHIP_PROPERTIES = 703] = "CHIP_PROPERTIES", e[e.DTC_INFO = 704] = "DTC_INFO", e[e.POST_CA_RESPONSE = 710] = "POST_CA_RESPONSE", e[e.POST_CA_PUBLIC_KEY = 711] = "POST_CA_PUBLIC_KEY", e[e.POST_CA_INFO = 712] = "POST_CA_INFO", e[e.POST_CA_D_PARAMS = 713] = "POST_CA_D_PARAMS", e[e.POST_CA_CHECK_PK = 714] = "POST_CA_CHECK_PK", e[e.POST_CA_CHECK_SK = 715] = "POST_CA_CHECK_SK", e[e.SAM_DATA = 800] = "SAM_DATA", e[e.SAM_DATA_MAX = 832] = "SAM_DATA_MAX", e[e.VDS = 900] = "VDS", e[e.VDS_NC = 901] = "VDS_NC", e[e.DS = 902] = "DS", e[e.USER_DEFINED = 1e3] = "USER_DEFINED", e))(bM || {}), wM = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.MAIN_PAGE = 1] = "MAIN_PAGE", e[e.BACK_PAGE = 2] = "BACK_PAGE", e))(wM || {}), HM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.MRZ = 1] = "MRZ", e[e.CAN = 2] = "CAN", e[e.PIN = 3] = "PIN", e[e.PUK = 4] = "PUK", e[e.PIN_E_SIGN = 5] = "PIN_E_SIGN", e[e.SAI = 6] = "SAI", e[e.MRZ_HASH = 7] = "MRZ_HASH", e))(HM || {}), VM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.INSPECTION_SYSTEM = 1] = "INSPECTION_SYSTEM", e[e.AUTHENTICATION_TERMINAL = 2] = "AUTHENTICATION_TERMINAL", e[e.SIGNATURE_TERMINAL = 3] = "SIGNATURE_TERMINAL", e[e.UNAUTHENTICATED_TERMINAL = 4] = "UNAUTHENTICATED_TERMINAL", e))(VM || {}), kM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.B = 2] = "B", e))(kM || {}), vD = /* @__PURE__ */ ((e) => (e.MRZ = "Mrz", e.BARCODE = "Barcode", e.LOCATE = "Locate", e.OCR = "Ocr", e.DOCTYPE = "DocType", e.MRZ_OR_BARCODE = "MrzOrBarcode", e.MRZ_OR_LOCATE = "MrzOrLocate", e.MRZ_AND_LOCATE = "MrzAndLocate", e.BARCODE_AND_LOCATE = "BarcodeAndLocate", e.MRZ_OR_OCR = "MrzOrOcr", e.MRZ_OR_BARCODE_OR_OCR = "MrzOrBarcodeOrOcr", e.LOCATE_VISUAL_AND_MRZ_OR_OCR = "LocateVisual_And_MrzOrOcr", e.FULL_PROCESS = "FullProcess", e.FULL_AUTH = "FullAuth", e.RUS_STAMP = "RusStamp", e.OCR_FREE = "OcrFree", e.CREDIT_CARD = "CreditCard", e.CAPTURE = "Capture", e.DTC = "DTC", e.RFID = "RFID", e))(vD || {}), FM = /* @__PURE__ */ ((e) => (e[e.BLANK = 0] = "BLANK", e[e.FILL = 1] = "FILL", e[e.PHOTO = 2] = "PHOTO", e[e.MRZ = 3] = "MRZ", e[e.FALSE_LUMINESCENCE = 4] = "FALSE_LUMINESCENCE", e[e.HOLO_SIMPLE = 5] = "HOLO_SIMPLE", e[e.HOLO_VERIFY_STATIC = 6] = "HOLO_VERIFY_STATIC", e[e.HOLO_VERIFY_MULTI_STATIC = 7] = "HOLO_VERIFY_MULTI_STATIC", e[e.HOLO_VERIFY_DYNAMIC = 8] = "HOLO_VERIFY_DYNAMIC", e[e.PATTERN_NOT_INTERRUPTED = 9] = "PATTERN_NOT_INTERRUPTED", e[e.PATTERN_NOT_SHIFTED = 10] = "PATTERN_NOT_SHIFTED", e[e.PATTERN_SAME_COLORS = 11] = "PATTERN_SAME_COLORS", e[e.PATTERN_IR_INVISIBLE = 12] = "PATTERN_IR_INVISIBLE", e[e.PHOTO_SIZE_CHECK = 13] = "PHOTO_SIZE_CHECK", e[e.PORTRAIT_COMPARISON_VS_GHOST = 14] = "PORTRAIT_COMPARISON_VS_GHOST", e[e.PORTRAIT_COMPARISON_VS_RFID = 15] = "PORTRAIT_COMPARISON_VS_RFID", e[e.PORTRAIT_COMPARISON_VS_VISUAL = 16] = "PORTRAIT_COMPARISON_VS_VISUAL", e[e.BARCODE = 17] = "BARCODE", e[e.PATTERN_DIFFERENT_LINES_THICKNESS = 18] = "PATTERN_DIFFERENT_LINES_THICKNESS", e[e.PORTRAIT_COMPARISON_VS_CAMERA = 19] = "PORTRAIT_COMPARISON_VS_CAMERA", e[e.PORTRAIT_COMPARISON_RFID_VS_CAMERA = 20] = "PORTRAIT_COMPARISON_RFID_VS_CAMERA", e[e.GHOST_PHOTO = 21] = "GHOST_PHOTO", e[e.CLEAR_GHOST_PHOTO = 22] = "CLEAR_GHOST_PHOTO", e[e.INVISIBLE_OBJECT = 23] = "INVISIBLE_OBJECT", e[e.LOW_CONTRAST_OBJECT = 24] = "LOW_CONTRAST_OBJECT", e[e.PHOTO_COLOR = 25] = "PHOTO_COLOR", e[e.PHOTO_SHAPE = 26] = "PHOTO_SHAPE", e[e.PHOTO_CORNERS = 27] = "PHOTO_CORNERS", e[e.OCR = 28] = "OCR", e[e.PORTRAIT_COMPARISON_EXT_VS_VISUAL = 29] = "PORTRAIT_COMPARISON_EXT_VS_VISUAL", e[e.PORTRAIT_COMPARISON_EXT_VS_RFID = 30] = "PORTRAIT_COMPARISON_EXT_VS_RFID", e[e.PORTRAIT_COMPARISON_EXT_VS_CAMERA = 31] = "PORTRAIT_COMPARISON_EXT_VS_CAMERA", e[e.LIVENESS_DEPTH = 32] = "LIVENESS_DEPTH", e[e.MICRO_TEXT = 33] = "MICRO_TEXT", e[e.FLUORESCENT_OBJECT = 34] = "FLUORESCENT_OBJECT", e[e.LANDMARK_CHECK = 35] = "LANDMARK_CHECK", e[e.FACE_PRESENCE = 36] = "FACE_PRESENCE", e[e.FACE_ABSENCE = 38] = "FACE_ABSENCE", e[e.LIVENESS_SCREEN_CAPTURE = 39] = "LIVENESS_SCREEN_CAPTURE", e[e.LIVENESS_ELECTRONIC_DEVICE = 40] = "LIVENESS_ELECTRONIC_DEVICE", e[e.LIVENESS_OVI = 41] = "LIVENESS_OVI", e[e.BARCODE_SIZE_CHECK = 42] = "BARCODE_SIZE_CHECK", e[e.LASINK = 43] = "LASINK", e[e.LIVENESS_MLI = 44] = "LIVENESS_MLI", e[e.LIVENESS_BARCODE_BACKGROUND = 45] = "LIVENESS_BARCODE_BACKGROUND", e[e.PORTRAIT_COMPARISON_VS_BARCODE = 46] = "PORTRAIT_COMPARISON_VS_BARCODE", e[e.PORTRAIT_COMPARISON_RFID_VS_BARCODE = 47] = "PORTRAIT_COMPARISON_RFID_VS_BARCODE", e[e.PORTRAIT_COMPARISON_EXT_VS_BARCODE = 48] = "PORTRAIT_COMPARISON_EXT_VS_BARCODE", e[e.PORTRAIT_COMPARISON_BARCODE_VS_CAMERA = 49] = "PORTRAIT_COMPARISON_BARCODE_VS_CAMERA", e[e.CHECK_DIGITAL_SIGNATURE = 50] = "CHECK_DIGITAL_SIGNATURE", e[e.CONTACT_CHIP_CLASSIFICATION = 51] = "CONTACT_CHIP_CLASSIFICATION", e[e.HEAD_POSITION_CHECK = 52] = "HEAD_POSITION_CHECK", e[e.LIVENESS_BLACK_AND_WHITE_COPY_CHECK = 53] = "LIVENESS_BLACK_AND_WHITE_COPY_CHECK", e[e.LIVENESS_DYNAPRINT = 54] = "LIVENESS_DYNAPRINT", e[e.LIVENESS_GEOMETRY_CHECK = 55] = "LIVENESS_GEOMETRY_CHECK", e))(FM || {}), k2 = /* @__PURE__ */ ((e) => (e.MRZ = "MRZ", e.VISUAL = "VISUAL", e.BARCODE = "BARCODE", e.RFID = "RFID", e.MAGNETIC = "MAGNETIC", e.EXTERNAL = "EXTERNAL", e.LIVE = "LIVE", e.FINGERPRINT = "FINGERPRINT", e))(k2 || {}), UM = /* @__PURE__ */ ((e) => (e[e.DOCUMENT_CLASS_CODE = 0] = "DOCUMENT_CLASS_CODE", e[e.ISSUING_STATE_CODE = 1] = "ISSUING_STATE_CODE", e[e.DOCUMENT_NUMBER = 2] = "DOCUMENT_NUMBER", e[e.DATE_OF_EXPIRY = 3] = "DATE_OF_EXPIRY", e[e.DATE_OF_ISSUE = 4] = "DATE_OF_ISSUE", e[e.DATE_OF_BIRTH = 5] = "DATE_OF_BIRTH", e[e.PLACE_OF_BIRTH = 6] = "PLACE_OF_BIRTH", e[e.PERSONAL_NUMBER = 7] = "PERSONAL_NUMBER", e[e.SURNAME = 8] = "SURNAME", e[e.GIVEN_NAMES = 9] = "GIVEN_NAMES", e[e.MOTHERS_NAME = 10] = "MOTHERS_NAME", e[e.NATIONALITY = 11] = "NATIONALITY", e[e.SEX = 12] = "SEX", e[e.HEIGHT = 13] = "HEIGHT", e[e.WEIGHT = 14] = "WEIGHT", e[e.EYES_COLOR = 15] = "EYES_COLOR", e[e.HAIR_COLOR = 16] = "HAIR_COLOR", e[e.ADDRESS = 17] = "ADDRESS", e[e.DONOR = 18] = "DONOR", e[e.SOCIAL_SECURITY_NUMBER = 19] = "SOCIAL_SECURITY_NUMBER", e[e.DL_CLASS = 20] = "DL_CLASS", e[e.DL_ENDORSED = 21] = "DL_ENDORSED", e[e.DL_RESTRICTION_CODE = 22] = "DL_RESTRICTION_CODE", e[e.DL_UNDER_21_DATE = 23] = "DL_UNDER_21_DATE", e[e.AUTHORITY = 24] = "AUTHORITY", e[e.SURNAME_AND_GIVEN_NAMES = 25] = "SURNAME_AND_GIVEN_NAMES", e[e.NATIONALITY_CODE = 26] = "NATIONALITY_CODE", e[e.PASSPORT_NUMBER = 27] = "PASSPORT_NUMBER", e[e.INVITATION_NUMBER = 28] = "INVITATION_NUMBER", e[e.VISA_ID = 29] = "VISA_ID", e[e.VISA_CLASS = 30] = "VISA_CLASS", e[e.VISA_SUBCLASS = 31] = "VISA_SUBCLASS", e[e.MRZ_TYPE = 35] = "MRZ_TYPE", e[e.OPTIONAL_DATA = 36] = "OPTIONAL_DATA", e[e.DOCUMENT_CLASS_NAME = 37] = "DOCUMENT_CLASS_NAME", e[e.ISSUING_STATE_NAME = 38] = "ISSUING_STATE_NAME", e[e.PLACE_OF_ISSUE = 39] = "PLACE_OF_ISSUE", e[e.DOCUMENT_NUMBER_CHECKSUM = 40] = "DOCUMENT_NUMBER_CHECKSUM", e[e.DATE_OF_BIRTH_CHECKSUM = 41] = "DATE_OF_BIRTH_CHECKSUM", e[e.DATE_OF_EXPIRY_CHECKSUM = 42] = "DATE_OF_EXPIRY_CHECKSUM", e[e.PERSONAL_NUMBER_CHECKSUM = 43] = "PERSONAL_NUMBER_CHECKSUM", e[e.FINAL_CHECKSUM = 44] = "FINAL_CHECKSUM", e[e.PASSPORT_NUMBER_CHECKSUM = 45] = "PASSPORT_NUMBER_CHECKSUM", e[e.INVITATION_NUMBER_CHECKSUM = 46] = "INVITATION_NUMBER_CHECKSUM", e[e.VISA_ID_CHECKSUM = 47] = "VISA_ID_CHECKSUM", e[e.SURNAME_AND_GIVEN_NAMES_CHECKSUM = 48] = "SURNAME_AND_GIVEN_NAMES_CHECKSUM", e[e.VISA_VALID_UNTIL_CHECKSUM = 49] = "VISA_VALID_UNTIL_CHECKSUM", e[e.OTHER = 50] = "OTHER", e[e.MRZ_STRINGS = 51] = "MRZ_STRINGS", e[e.NAME_SUFFIX = 52] = "NAME_SUFFIX", e[e.NAME_PREFIX = 53] = "NAME_PREFIX", e[e.DATE_OF_ISSUE_CHECKSUM = 54] = "DATE_OF_ISSUE_CHECKSUM", e[e.DATE_OF_ISSUE_CHECK_DIGIT = 55] = "DATE_OF_ISSUE_CHECK_DIGIT", e[e.DOCUMENT_SERIES = 56] = "DOCUMENT_SERIES", e[e.REG_CERT_REG_NUMBER = 57] = "REG_CERT_REG_NUMBER", e[e.REG_CERT_CAR_MODEL = 58] = "REG_CERT_CAR_MODEL", e[e.REG_CERT_CAR_COLOR = 59] = "REG_CERT_CAR_COLOR", e[e.REG_CERT_BODY_NUMBER = 60] = "REG_CERT_BODY_NUMBER", e[e.REG_CERT_CAR_TYPE = 61] = "REG_CERT_CAR_TYPE", e[e.REG_CERT_MAX_WEIGHT = 62] = "REG_CERT_MAX_WEIGHT", e[e.REG_CERT_WEIGHT = 63] = "REG_CERT_WEIGHT", e[e.ADDRESS_AREA = 64] = "ADDRESS_AREA", e[e.ADDRESS_STATE = 65] = "ADDRESS_STATE", e[e.ADDRESS_BUILDING = 66] = "ADDRESS_BUILDING", e[e.ADDRESS_HOUSE = 67] = "ADDRESS_HOUSE", e[e.ADDRESS_FLAT = 68] = "ADDRESS_FLAT", e[e.PLACE_OF_REGISTRATION = 69] = "PLACE_OF_REGISTRATION", e[e.DATE_OF_REGISTRATION = 70] = "DATE_OF_REGISTRATION", e[e.RESIDENT_FROM = 71] = "RESIDENT_FROM", e[e.RESIDENT_UNTIL = 72] = "RESIDENT_UNTIL", e[e.AUTHORITY_CODE = 73] = "AUTHORITY_CODE", e[e.PLACE_OF_BIRTH_AREA = 74] = "PLACE_OF_BIRTH_AREA", e[e.PLACE_OF_BIRTH_STATE_CODE = 75] = "PLACE_OF_BIRTH_STATE_CODE", e[e.ADDRESS_STREET = 76] = "ADDRESS_STREET", e[e.ADDRESS_CITY = 77] = "ADDRESS_CITY", e[e.ADDRESS_JURISDICTION_CODE = 78] = "ADDRESS_JURISDICTION_CODE", e[e.ADDRESS_POSTAL_CODE = 79] = "ADDRESS_POSTAL_CODE", e[e.DOCUMENT_NUMBER_CHECK_DIGIT = 80] = "DOCUMENT_NUMBER_CHECK_DIGIT", e[e.DATE_OF_BIRTH_CHECK_DIGIT = 81] = "DATE_OF_BIRTH_CHECK_DIGIT", e[e.DATE_OF_EXPIRY_CHECK_DIGIT = 82] = "DATE_OF_EXPIRY_CHECK_DIGIT", e[e.PERSONAL_NUMBER_CHECK_DIGIT = 83] = "PERSONAL_NUMBER_CHECK_DIGIT", e[e.FINAL_CHECK_DIGIT = 84] = "FINAL_CHECK_DIGIT", e[e.PASSPORT_NUMBER_CHECK_DIGIT = 85] = "PASSPORT_NUMBER_CHECK_DIGIT", e[e.INVITATION_NUMBER_CHECK_DIGIT = 86] = "INVITATION_NUMBER_CHECK_DIGIT", e[e.VISA_ID_CHECK_DIGIT = 87] = "VISA_ID_CHECK_DIGIT", e[e.SURNAME_AND_GIVEN_NAMES_CHECK_DIGIT = 88] = "SURNAME_AND_GIVEN_NAMES_CHECK_DIGIT", e[e.VISA_VALID_UNTIL_CHECK_DIGIT = 89] = "VISA_VALID_UNTIL_CHECK_DIGIT", e[e.PERMIT_DL_CLASS = 90] = "PERMIT_DL_CLASS", e[e.PERMIT_DATE_OF_EXPIRY = 91] = "PERMIT_DATE_OF_EXPIRY", e[e.PERMIT_IDENTIFIER = 92] = "PERMIT_IDENTIFIER", e[e.PERMIT_DATE_OF_ISSUE = 93] = "PERMIT_DATE_OF_ISSUE", e[e.PERMIT_RESTRICTION_CODE = 94] = "PERMIT_RESTRICTION_CODE", e[e.PERMIT_ENDORSED = 95] = "PERMIT_ENDORSED", e[e.ISSUE_TIMESTAMP = 96] = "ISSUE_TIMESTAMP", e[e.NUMBER_OF_DUPLICATES = 97] = "NUMBER_OF_DUPLICATES", e[e.MEDICAL_INDICATOR_CODES = 98] = "MEDICAL_INDICATOR_CODES", e[e.NON_RESIDENT_INDICATOR = 99] = "NON_RESIDENT_INDICATOR", e[e.VISA_TYPE = 100] = "VISA_TYPE", e[e.VISA_VALID_FROM = 101] = "VISA_VALID_FROM", e[e.VISA_VALID_UNTIL = 102] = "VISA_VALID_UNTIL", e[e.DURATION_OF_STAY = 103] = "DURATION_OF_STAY", e[e.NUMBER_OF_ENTRIES = 104] = "NUMBER_OF_ENTRIES", e[e.DAY = 105] = "DAY", e[e.MONTH = 106] = "MONTH", e[e.YEAR = 107] = "YEAR", e[e.UNIQUE_CUSTOMER_IDENTIFIER = 108] = "UNIQUE_CUSTOMER_IDENTIFIER", e[e.COMMERCIAL_VEHICLE_CODES = 109] = "COMMERCIAL_VEHICLE_CODES", e[e.AKA_DATE_OF_BIRTH = 110] = "AKA_DATE_OF_BIRTH", e[e.AKA_SOCIAL_SECURITY_NUMBER = 111] = "AKA_SOCIAL_SECURITY_NUMBER", e[e.AKA_SURNAME = 112] = "AKA_SURNAME", e[e.AKA_GIVEN_NAMES = 113] = "AKA_GIVEN_NAMES", e[e.AKA_NAME_SUFFIX = 114] = "AKA_NAME_SUFFIX", e[e.AKA_NAME_PREFIX = 115] = "AKA_NAME_PREFIX", e[e.MAILING_ADDRESS_STREET = 116] = "MAILING_ADDRESS_STREET", e[e.MAILING_ADDRESS_CITY = 117] = "MAILING_ADDRESS_CITY", e[e.MAILING_ADDRESS_JURISDICTION_CODE = 118] = "MAILING_ADDRESS_JURISDICTION_CODE", e[e.MAILING_ADDRESS_POSTAL_CODE = 119] = "MAILING_ADDRESS_POSTAL_CODE", e[e.AUDIT_INFORMATION = 120] = "AUDIT_INFORMATION", e[e.INVENTORY_NUMBER = 121] = "INVENTORY_NUMBER", e[e.RACE_ETHNICITY = 122] = "RACE_ETHNICITY", e[e.JURISDICTION_VEHICLE_CLASS = 123] = "JURISDICTION_VEHICLE_CLASS", e[e.JURISDICTION_ENDORSEMENT_CODE = 124] = "JURISDICTION_ENDORSEMENT_CODE", e[e.JURISDICTION_RESTRICTION_CODE = 125] = "JURISDICTION_RESTRICTION_CODE", e[e.FAMILY_NAME = 126] = "FAMILY_NAME", e[e.GIVEN_NAMES_RUS = 127] = "GIVEN_NAMES_RUS", e[e.VISA_ID_RUS = 128] = "VISA_ID_RUS", e[e.FATHERS_NAME = 129] = "FATHERS_NAME", e[e.FATHERS_NAME_RUS = 130] = "FATHERS_NAME_RUS", e[e.SURNAME_AND_GIVEN_NAMES_RUS = 131] = "SURNAME_AND_GIVEN_NAMES_RUS", e[e.PLACE_OF_BIRTH_RUS = 132] = "PLACE_OF_BIRTH_RUS", e[e.AUTHORITY_RUS = 133] = "AUTHORITY_RUS", e[e.ISSUING_STATE_CODE_NUMERIC = 134] = "ISSUING_STATE_CODE_NUMERIC", e[e.NATIONALITY_CODE_NUMERIC = 135] = "NATIONALITY_CODE_NUMERIC", e[e.ENGINE_POWER = 136] = "ENGINE_POWER", e[e.ENGINE_VOLUME = 137] = "ENGINE_VOLUME", e[e.CHASSIS_NUMBER = 138] = "CHASSIS_NUMBER", e[e.ENGINE_NUMBER = 139] = "ENGINE_NUMBER", e[e.ENGINE_MODEL = 140] = "ENGINE_MODEL", e[e.VEHICLE_CATEGORY = 141] = "VEHICLE_CATEGORY", e[e.IDENTITY_CARD_NUMBER = 142] = "IDENTITY_CARD_NUMBER", e[e.CONTROL_NUMBER = 143] = "CONTROL_NUMBER", e[e.PARENTS_GIVEN_NAMES = 144] = "PARENTS_GIVEN_NAMES", e[e.SECOND_SURNAME = 145] = "SECOND_SURNAME", e[e.MIDDLE_NAME = 146] = "MIDDLE_NAME", e[e.REG_CERT_VIN = 147] = "REG_CERT_VIN", e[e.REG_CERT_VIN_CHECK_DIGIT = 148] = "REG_CERT_VIN_CHECK_DIGIT", e[e.REG_CERT_VIN_CHECKSUM = 149] = "REG_CERT_VIN_CHECKSUM", e[e.LINE_1_CHECK_DIGIT = 150] = "LINE_1_CHECK_DIGIT", e[e.LINE_2_CHECK_DIGIT = 151] = "LINE_2_CHECK_DIGIT", e[e.LINE_3_CHECK_DIGIT = 152] = "LINE_3_CHECK_DIGIT", e[e.LINE_1_CHECKSUM = 153] = "LINE_1_CHECKSUM", e[e.LINE_2_CHECKSUM = 154] = "LINE_2_CHECKSUM", e[e.LINE_3_CHECKSUM = 155] = "LINE_3_CHECKSUM", e[e.REG_CERT_REG_NUMBER_CHECK_DIGIT = 156] = "REG_CERT_REG_NUMBER_CHECK_DIGIT", e[e.REG_CERT_REG_NUMBER_CHECKSUM = 157] = "REG_CERT_REG_NUMBER_CHECKSUM", e[e.REG_CERT_VEHICLE_ITS_CODE = 158] = "REG_CERT_VEHICLE_ITS_CODE", e[e.CARD_ACCESS_NUMBER = 159] = "CARD_ACCESS_NUMBER", e[e.MARITAL_STATUS = 160] = "MARITAL_STATUS", e[e.COMPANY_NAME = 161] = "COMPANY_NAME", e[e.SPECIAL_NOTES = 162] = "SPECIAL_NOTES", e[e.SURNAME_OF_SPOUSE = 163] = "SURNAME_OF_SPOUSE", e[e.TRACKING_NUMBER = 164] = "TRACKING_NUMBER", e[e.BOOKLET_NUMBER = 165] = "BOOKLET_NUMBER", e[e.CHILDREN = 166] = "CHILDREN", e[e.COPY = 167] = "COPY", e[e.SERIAL_NUMBER = 168] = "SERIAL_NUMBER", e[e.DOSSIER_NUMBER = 169] = "DOSSIER_NUMBER", e[e.AKA_SURNAME_AND_GIVEN_NAMES = 170] = "AKA_SURNAME_AND_GIVEN_NAMES", e[e.TERRITORIAL_VALIDITY = 171] = "TERRITORIAL_VALIDITY", e[e.MRZ_STRINGS_WITH_CORRECT_CHECK_SUMS = 172] = "MRZ_STRINGS_WITH_CORRECT_CHECK_SUMS", e[e.DL_CDL_RESTRICTION_CODE = 173] = "DL_CDL_RESTRICTION_CODE", e[e.DL_UNDER_18_DATE = 174] = "DL_UNDER_18_DATE", e[e.DL_RECORD_CREATED = 175] = "DL_RECORD_CREATED", e[e.DL_DUPLICATE_DATE = 176] = "DL_DUPLICATE_DATE", e[e.DL_ISSUE_TYPE = 177] = "DL_ISSUE_TYPE", e[e.MILITARY_BOOK_NUMBER = 178] = "MILITARY_BOOK_NUMBER", e[e.DESTINATION = 179] = "DESTINATION", e[e.BLOOD_GROUP = 180] = "BLOOD_GROUP", e[e.SEQUENCE_NUMBER = 181] = "SEQUENCE_NUMBER", e[e.REG_CERT_BODY_TYPE = 182] = "REG_CERT_BODY_TYPE", e[e.REG_CERT_CAR_MARK = 183] = "REG_CERT_CAR_MARK", e[e.TRANSACTION_NUMBER = 184] = "TRANSACTION_NUMBER", e[e.AGE = 185] = "AGE", e[e.FOLIO_NUMBER = 186] = "FOLIO_NUMBER", e[e.VOTER_KEY = 187] = "VOTER_KEY", e[e.ADDRESS_MUNICIPALITY = 188] = "ADDRESS_MUNICIPALITY", e[e.ADDRESS_LOCATION = 189] = "ADDRESS_LOCATION", e[e.SECTION = 190] = "SECTION", e[e.OCR_NUMBER = 191] = "OCR_NUMBER", e[e.FEDERAL_ELECTIONS = 192] = "FEDERAL_ELECTIONS", e[e.REFERENCE_NUMBER = 193] = "REFERENCE_NUMBER", e[e.OPTIONAL_DATA_CHECKSUM = 194] = "OPTIONAL_DATA_CHECKSUM", e[e.OPTIONAL_DATA_CHECK_DIGIT = 195] = "OPTIONAL_DATA_CHECK_DIGIT", e[e.VISA_NUMBER = 196] = "VISA_NUMBER", e[e.VISA_NUMBER_CHECKSUM = 197] = "VISA_NUMBER_CHECKSUM", e[e.VISA_NUMBER_CHECK_DIGIT = 198] = "VISA_NUMBER_CHECK_DIGIT", e[e.VOTER = 199] = "VOTER", e[e.PREVIOUS_TYPE = 200] = "PREVIOUS_TYPE", e[e.FIELD_FROM_MRZ = 220] = "FIELD_FROM_MRZ", e[e.CURRENT_DATE = 221] = "CURRENT_DATE", e[e.STATUS_DATE_OF_EXPIRY = 251] = "STATUS_DATE_OF_EXPIRY", e[e.BANKNOTE_NUMBER = 252] = "BANKNOTE_NUMBER", e[e.CSC_CODE = 253] = "CSC_CODE", e[e.ARTISTIC_NAME = 254] = "ARTISTIC_NAME", e[e.ACADEMIC_TITLE = 255] = "ACADEMIC_TITLE", e[e.ADDRESS_COUNTRY = 256] = "ADDRESS_COUNTRY", e[e.ADDRESS_ZIP_CODE = 257] = "ADDRESS_ZIP_CODE", e[e.E_ID_RESIDENCE_PERMIT_1 = 258] = "E_ID_RESIDENCE_PERMIT_1", e[e.E_ID_RESIDENCE_PERMIT_2 = 259] = "E_ID_RESIDENCE_PERMIT_2", e[e.E_ID_PLACE_OF_BIRTH_STREET = 260] = "E_ID_PLACE_OF_BIRTH_STREET", e[e.E_ID_PLACE_OF_BIRTH_CITY = 261] = "E_ID_PLACE_OF_BIRTH_CITY", e[e.E_ID_PLACE_OF_BIRTH_STATE = 262] = "E_ID_PLACE_OF_BIRTH_STATE", e[e.E_ID_PLACE_OF_BIRTH_COUNTRY = 263] = "E_ID_PLACE_OF_BIRTH_COUNTRY", e[e.E_ID_PLACE_OF_BIRTH_ZIP_CODE = 264] = "E_ID_PLACE_OF_BIRTH_ZIP_CODE", e[e.CDL_CLASS = 265] = "CDL_CLASS", e[e.DL_UNDER_19_DATE = 266] = "DL_UNDER_19_DATE", e[e.WEIGHT_POUNDS = 267] = "WEIGHT_POUNDS", e[e.LIMITED_DURATION_DOCUMENT_INDICATOR = 268] = "LIMITED_DURATION_DOCUMENT_INDICATOR", e[e.ENDORSEMENT_EXPIRATION_DATE = 269] = "ENDORSEMENT_EXPIRATION_DATE", e[e.REVISION_DATE = 270] = "REVISION_DATE", e[e.COMPLIANCE_TYPE = 271] = "COMPLIANCE_TYPE", e[e.FAMILY_NAME_TRUNCATION = 272] = "FAMILY_NAME_TRUNCATION", e[e.FIRST_NAME_TRUNCATION = 273] = "FIRST_NAME_TRUNCATION", e[e.MIDDLE_NAME_TRUNCATION = 274] = "MIDDLE_NAME_TRUNCATION", e[e.EXAM_DATE = 275] = "EXAM_DATE", e[e.ORGANIZATION = 276] = "ORGANIZATION", e[e.DEPARTMENT = 277] = "DEPARTMENT", e[e.PAY_GRADE = 278] = "PAY_GRADE", e[e.RANK = 279] = "RANK", e[e.BENEFITS_NUMBER = 280] = "BENEFITS_NUMBER", e[e.SPONSOR_SERVICE = 281] = "SPONSOR_SERVICE", e[e.SPONSOR_STATUS = 282] = "SPONSOR_STATUS", e[e.SPONSOR = 283] = "SPONSOR", e[e.RELATIONSHIP = 284] = "RELATIONSHIP", e[e.USCIS = 285] = "USCIS", e[e.CATEGORY = 286] = "CATEGORY", e[e.CONDITIONS = 287] = "CONDITIONS", e[e.IDENTIFIER = 288] = "IDENTIFIER", e[e.CONFIGURATION = 289] = "CONFIGURATION", e[e.DISCRETIONARY_DATA = 290] = "DISCRETIONARY_DATA", e[e.LINE_1_OPTIONAL_DATA = 291] = "LINE_1_OPTIONAL_DATA", e[e.LINE_2_OPTIONAL_DATA = 292] = "LINE_2_OPTIONAL_DATA", e[e.LINE_3_OPTIONAL_DATA = 293] = "LINE_3_OPTIONAL_DATA", e[e.EQV_CODE = 294] = "EQV_CODE", e[e.ALT_CODE = 295] = "ALT_CODE", e[e.BINARY_CODE = 296] = "BINARY_CODE", e[e.PSEUDO_CODE = 297] = "PSEUDO_CODE", e[e.FEE = 298] = "FEE", e[e.STAMP_NUMBER = 299] = "STAMP_NUMBER", e[e.SBH_SECURITY_OPTIONS = 300] = "SBH_SECURITY_OPTIONS", e[e.SBH_INTEGRITY_OPTIONS = 301] = "SBH_INTEGRITY_OPTIONS", e[e.DATE_OF_CREATION = 302] = "DATE_OF_CREATION", e[e.VALIDITY_PERIOD = 303] = "VALIDITY_PERIOD", e[e.PATRON_HEADER_VERSION = 304] = "PATRON_HEADER_VERSION", e[e.BDB_TYPE = 305] = "BDB_TYPE", e[e.BIOMETRIC_TYPE = 306] = "BIOMETRIC_TYPE", e[e.BIOMETRIC_SUBTYPE = 307] = "BIOMETRIC_SUBTYPE", e[e.BIOMETRIC_PRODUCT_ID = 308] = "BIOMETRIC_PRODUCT_ID", e[e.BIOMETRIC_FORMAT_OWNER = 309] = "BIOMETRIC_FORMAT_OWNER", e[e.BIOMETRIC_FORMAT_TYPE = 310] = "BIOMETRIC_FORMAT_TYPE", e[e.PHONE = 311] = "PHONE", e[e.PROFESSION = 312] = "PROFESSION", e[e.TITLE = 313] = "TITLE", e[e.PERSONAL_SUMMARY = 314] = "PERSONAL_SUMMARY", e[e.OTHER_VALID_ID = 315] = "OTHER_VALID_ID", e[e.CUSTODY_INFO = 316] = "CUSTODY_INFO", e[e.OTHER_NAME = 317] = "OTHER_NAME", e[e.OBSERVATIONS = 318] = "OBSERVATIONS", e[e.TAX = 319] = "TAX", e[e.DATE_OF_PERSONALIZATION = 320] = "DATE_OF_PERSONALIZATION", e[e.PERSONALIZATION_SN = 321] = "PERSONALIZATION_SN", e[e.OTHER_PERSON_NAME = 322] = "OTHER_PERSON_NAME", e[e.PERSON_TO_NOTIFY_DATE_OF_RECORD = 323] = "PERSON_TO_NOTIFY_DATE_OF_RECORD", e[e.PERSON_TO_NOTIFY_NAME = 324] = "PERSON_TO_NOTIFY_NAME", e[e.PERSON_TO_NOTIFY_PHONE = 325] = "PERSON_TO_NOTIFY_PHONE", e[e.PERSON_TO_NOTIFY_ADDRESS = 326] = "PERSON_TO_NOTIFY_ADDRESS", e[e.DS_CERTIFICATE_ISSUER = 327] = "DS_CERTIFICATE_ISSUER", e[e.DS_CERTIFICATE_SUBJECT = 328] = "DS_CERTIFICATE_SUBJECT", e[e.DS_CERTIFICATE_VALID_FROM = 329] = "DS_CERTIFICATE_VALID_FROM", e[e.DS_CERTIFICATE_VALID_TO = 330] = "DS_CERTIFICATE_VALID_TO", e[e.VRC_DATA_OBJECT_ENTRY = 331] = "VRC_DATA_OBJECT_ENTRY", e[e.TYPE_APPROVAL_NUMBER = 332] = "TYPE_APPROVAL_NUMBER", e[e.ADMINISTRATIVE_NUMBER = 333] = "ADMINISTRATIVE_NUMBER", e[e.DOCUMENT_DISCRIMINATOR = 334] = "DOCUMENT_DISCRIMINATOR", e[e.DATA_DISCRIMINATOR = 335] = "DATA_DISCRIMINATOR", e[e.ISO_ISSUER_ID_NUMBER = 336] = "ISO_ISSUER_ID_NUMBER", e[e.DTC_VERSION = 337] = "DTC_VERSION", e[e.DTC_ID = 338] = "DTC_ID", e[e.DTC_DATE_OF_EXPIRY = 339] = "DTC_DATE_OF_EXPIRY", e[e.GNIB_NUMBER = 340] = "GNIB_NUMBER", e[e.DEPT_NUMBER = 341] = "DEPT_NUMBER", e[e.TELEX_CODE = 342] = "TELEX_CODE", e[e.ALLERGIES = 343] = "ALLERGIES", e[e.SP_CODE = 344] = "SP_CODE", e[e.COURT_CODE = 345] = "COURT_CODE", e[e.CTY = 346] = "CTY", e[e.SPONSOR_SSN = 347] = "SPONSOR_SSN", e[e.DOD_NUMBER = 348] = "DOD_NUMBER", e[e.MC_NOVICE_DATE = 349] = "MC_NOVICE_DATE", e[e.DUF_NUMBER = 350] = "DUF_NUMBER", e[e.AGY = 351] = "AGY", e[e.PNR_CODE = 352] = "PNR_CODE", e[e.FROM_AIRPORT_CODE = 353] = "FROM_AIRPORT_CODE", e[e.TO_AIRPORT_CODE = 354] = "TO_AIRPORT_CODE", e[e.FLIGHT_NUMBER = 355] = "FLIGHT_NUMBER", e[e.DATE_OF_FLIGHT = 356] = "DATE_OF_FLIGHT", e[e.SEAT_NUMBER = 357] = "SEAT_NUMBER", e[e.DATE_OF_ISSUE_BOARDING_PASS = 358] = "DATE_OF_ISSUE_BOARDING_PASS", e[e.CCW_UNTIL = 359] = "CCW_UNTIL", e[e.REFERENCE_NUMBER_CHECKSUM = 360] = "REFERENCE_NUMBER_CHECKSUM", e[e.REFERENCE_NUMBER_CHECK_DIGIT = 361] = "REFERENCE_NUMBER_CHECK_DIGIT", e[e.ROOM_NUMBER = 362] = "ROOM_NUMBER", e[e.RELIGION = 363] = "RELIGION", e[e.REMAINDER_TERM = 364] = "REMAINDER_TERM", e[e.ELECTRONIC_TICKET_INDICATOR = 365] = "ELECTRONIC_TICKET_INDICATOR", e[e.COMPARTMENT_CODE = 366] = "COMPARTMENT_CODE", e[e.CHECK_IN_SEQUENCE_NUMBER = 367] = "CHECK_IN_SEQUENCE_NUMBER", e[e.AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER = 368] = "AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER", e[e.AIRLINE_NUMERIC_CODE = 369] = "AIRLINE_NUMERIC_CODE", e[e.TICKET_NUMBER = 370] = "TICKET_NUMBER", e[e.FREQUENT_FLYER_AIRLINE_DESIGNATOR = 371] = "FREQUENT_FLYER_AIRLINE_DESIGNATOR", e[e.FREQUENT_FLYER_NUMBER = 372] = "FREQUENT_FLYER_NUMBER", e[e.FREE_BAGGAGE_ALLOWANCE = 373] = "FREE_BAGGAGE_ALLOWANCE", e[e.PDF417_CODEC = 374] = "PDF417_CODEC", e[e.IDENTITY_CARD_NUMBER_CHECKSUM = 375] = "IDENTITY_CARD_NUMBER_CHECKSUM", e[e.IDENTITY_CARD_NUMBER_CHECK_DIGIT = 376] = "IDENTITY_CARD_NUMBER_CHECK_DIGIT", e[e.VETERAN = 377] = "VETERAN", e[e.DL_CLASS_CODE_A1_FROM = 378] = "DL_CLASS_CODE_A1_FROM", e[e.DL_CLASS_CODE_A1_TO = 379] = "DL_CLASS_CODE_A1_TO", e[e.DL_CLASS_CODE_A1_NOTES = 380] = "DL_CLASS_CODE_A1_NOTES", e[e.DL_CLASS_CODE_A_FROM = 381] = "DL_CLASS_CODE_A_FROM", e[e.DL_CLASS_CODE_A_TO = 382] = "DL_CLASS_CODE_A_TO", e[e.DL_CLASS_CODE_A_NOTES = 383] = "DL_CLASS_CODE_A_NOTES", e[e.DL_CLASS_CODE_B_FROM = 384] = "DL_CLASS_CODE_B_FROM", e[e.DL_CLASS_CODE_B_TO = 385] = "DL_CLASS_CODE_B_TO", e[e.DL_CLASS_CODE_B_NOTES = 386] = "DL_CLASS_CODE_B_NOTES", e[e.DL_CLASS_CODE_C1_FROM = 387] = "DL_CLASS_CODE_C1_FROM", e[e.DL_CLASS_CODE_C1_TO = 388] = "DL_CLASS_CODE_C1_TO", e[e.DL_CLASS_CODE_C1_NOTES = 389] = "DL_CLASS_CODE_C1_NOTES", e[e.DL_CLASS_CODE_C_FROM = 390] = "DL_CLASS_CODE_C_FROM", e[e.DL_CLASS_CODE_C_TO = 391] = "DL_CLASS_CODE_C_TO", e[e.DL_CLASS_CODE_C_NOTES = 392] = "DL_CLASS_CODE_C_NOTES", e[e.DL_CLASS_CODE_D1_FROM = 393] = "DL_CLASS_CODE_D1_FROM", e[e.DL_CLASS_CODE_D1_TO = 394] = "DL_CLASS_CODE_D1_TO", e[e.DL_CLASS_CODE_D1_NOTES = 395] = "DL_CLASS_CODE_D1_NOTES", e[e.DL_CLASS_CODE_D_FROM = 396] = "DL_CLASS_CODE_D_FROM", e[e.DL_CLASS_CODE_D_TO = 397] = "DL_CLASS_CODE_D_TO", e[e.DL_CLASS_CODE_D_NOTES = 398] = "DL_CLASS_CODE_D_NOTES", e[e.DL_CLASS_CODE_BE_FROM = 399] = "DL_CLASS_CODE_BE_FROM", e[e.DL_CLASS_CODE_BE_TO = 400] = "DL_CLASS_CODE_BE_TO", e[e.DL_CLASS_CODE_BE_NOTES = 401] = "DL_CLASS_CODE_BE_NOTES", e[e.DL_CLASS_CODE_C1E_FROM = 402] = "DL_CLASS_CODE_C1E_FROM", e[e.DL_CLASS_CODE_C1E_TO = 403] = "DL_CLASS_CODE_C1E_TO", e[e.DL_CLASS_CODE_C1E_NOTES = 404] = "DL_CLASS_CODE_C1E_NOTES", e[e.DL_CLASS_CODE_CE_FROM = 405] = "DL_CLASS_CODE_CE_FROM", e[e.DL_CLASS_CODE_CE_TO = 406] = "DL_CLASS_CODE_CE_TO", e[e.DL_CLASS_CODE_CE_NOTES = 407] = "DL_CLASS_CODE_CE_NOTES", e[e.DL_CLASS_CODE_D1E_FROM = 408] = "DL_CLASS_CODE_D1E_FROM", e[e.DL_CLASS_CODE_D1E_TO = 409] = "DL_CLASS_CODE_D1E_TO", e[e.DL_CLASS_CODE_D1E_NOTES = 410] = "DL_CLASS_CODE_D1E_NOTES", e[e.DL_CLASS_CODE_DE_FROM = 411] = "DL_CLASS_CODE_DE_FROM", e[e.DL_CLASS_CODE_DE_TO = 412] = "DL_CLASS_CODE_DE_TO", e[e.DL_CLASS_CODE_DE_NOTES = 413] = "DL_CLASS_CODE_DE_NOTES", e[e.DL_CLASS_CODE_M_FROM = 414] = "DL_CLASS_CODE_M_FROM", e[e.DL_CLASS_CODE_M_TO = 415] = "DL_CLASS_CODE_M_TO", e[e.DL_CLASS_CODE_M_NOTES = 416] = "DL_CLASS_CODE_M_NOTES", e[e.DL_CLASS_CODE_L_FROM = 417] = "DL_CLASS_CODE_L_FROM", e[e.DL_CLASS_CODE_L_TO = 418] = "DL_CLASS_CODE_L_TO", e[e.DL_CLASS_CODE_L_NOTES = 419] = "DL_CLASS_CODE_L_NOTES", e[e.DL_CLASS_CODE_T_FROM = 420] = "DL_CLASS_CODE_T_FROM", e[e.DL_CLASS_CODE_T_TO = 421] = "DL_CLASS_CODE_T_TO", e[e.DL_CLASS_CODE_T_NOTES = 422] = "DL_CLASS_CODE_T_NOTES", e[e.DL_CLASS_CODE_AM_FROM = 423] = "DL_CLASS_CODE_AM_FROM", e[e.DL_CLASS_CODE_AM_TO = 424] = "DL_CLASS_CODE_AM_TO", e[e.DL_CLASS_CODE_AM_NOTES = 425] = "DL_CLASS_CODE_AM_NOTES", e[e.DL_CLASS_CODE_A2_FROM = 426] = "DL_CLASS_CODE_A2_FROM", e[e.DL_CLASS_CODE_A2_TO = 427] = "DL_CLASS_CODE_A2_TO", e[e.DL_CLASS_CODE_A2_NOTES = 428] = "DL_CLASS_CODE_A2_NOTES", e[e.DL_CLASS_CODE_B1_FROM = 429] = "DL_CLASS_CODE_B1_FROM", e[e.DL_CLASS_CODE_B1_TO = 430] = "DL_CLASS_CODE_B1_TO", e[e.DL_CLASS_CODE_B1_NOTES = 431] = "DL_CLASS_CODE_B1_NOTES", e[e.SURNAME_AT_BIRTH = 432] = "SURNAME_AT_BIRTH", e[e.CIVIL_STATUS = 433] = "CIVIL_STATUS", e[e.NUMBER_OF_SEATS = 434] = "NUMBER_OF_SEATS", e[e.NUMBER_OF_STANDING_PLACES = 435] = "NUMBER_OF_STANDING_PLACES", e[e.MAX_SPEED = 436] = "MAX_SPEED", e[e.FUEL_TYPE = 437] = "FUEL_TYPE", e[e.EC_ENVIRONMENTAL_TYPE = 438] = "EC_ENVIRONMENTAL_TYPE", e[e.POWER_WEIGHT_RATIO = 439] = "POWER_WEIGHT_RATIO", e[e.MAX_MASS_OF_TRAILER_BRAKED = 440] = "MAX_MASS_OF_TRAILER_BRAKED", e[e.MAX_MASS_OF_TRAILER_UNBRAKED = 441] = "MAX_MASS_OF_TRAILER_UNBRAKED", e[e.TRANSMISSION_TYPE = 442] = "TRANSMISSION_TYPE", e[e.TRAILER_HITCH = 443] = "TRAILER_HITCH", e[e.ACCOMPANIED_BY = 444] = "ACCOMPANIED_BY", e[e.POLICE_DISTRICT = 445] = "POLICE_DISTRICT", e[e.FIRST_ISSUE_DATE = 446] = "FIRST_ISSUE_DATE", e[e.PAYLOAD_CAPACITY = 447] = "PAYLOAD_CAPACITY", e[e.NUMBER_OF_AXLES = 448] = "NUMBER_OF_AXLES", e[e.PERMISSIBLE_AXLE_LOAD = 449] = "PERMISSIBLE_AXLE_LOAD", e[e.PRECINCT = 450] = "PRECINCT", e[e.INVITED_BY = 451] = "INVITED_BY", e[e.PURPOSE_OF_ENTRY = 452] = "PURPOSE_OF_ENTRY", e[e.SKIN_COLOR = 453] = "SKIN_COLOR", e[e.COMPLEXION = 454] = "COMPLEXION", e[e.AIRPORT_FROM = 455] = "AIRPORT_FROM", e[e.AIRPORT_TO = 456] = "AIRPORT_TO", e[e.AIRLINE_NAME = 457] = "AIRLINE_NAME", e[e.AIRLINE_NAME_FREQUENT_FLYER = 458] = "AIRLINE_NAME_FREQUENT_FLYER", e[e.LICENSE_NUMBER = 459] = "LICENSE_NUMBER", e[e.IN_TANKS = 460] = "IN_TANKS", e[e.EXCEPT_IN_TANKS = 461] = "EXCEPT_IN_TANKS", e[e.FAST_TRACK = 462] = "FAST_TRACK", e[e.OWNER = 463] = "OWNER", e[e.MRZ_STRINGS_ICAO_RFID = 464] = "MRZ_STRINGS_ICAO_RFID", e[e.NUMBER_OF_CARD_ISSUANCE = 465] = "NUMBER_OF_CARD_ISSUANCE", e[e.NUMBER_OF_CARD_ISSUANCE_CHECKSUM = 466] = "NUMBER_OF_CARD_ISSUANCE_CHECKSUM", e[e.NUMBER_OF_CARD_ISSUANCE_CHECK_DIGIT = 467] = "NUMBER_OF_CARD_ISSUANCE_CHECK_DIGIT", e[e.CENTURY_DATE_OF_BIRTH = 468] = "CENTURY_DATE_OF_BIRTH", e[e.DL_CLASS_CODE_A3_FROM = 469] = "DL_CLASS_CODE_A3_FROM", e[e.DL_CLASS_CODE_A3_TO = 470] = "DL_CLASS_CODE_A3_TO", e[e.DL_CLASS_CODE_A3_NOTES = 471] = "DL_CLASS_CODE_A3_NOTES", e[e.DL_CLASS_CODE_C2_FROM = 472] = "DL_CLASS_CODE_C2_FROM", e[e.DL_CLASS_CODE_C2_TO = 473] = "DL_CLASS_CODE_C2_TO", e[e.DL_CLASS_CODE_C2_NOTES = 474] = "DL_CLASS_CODE_C2_NOTES", e[e.DL_CLASS_CODE_B2_FROM = 475] = "DL_CLASS_CODE_B2_FROM", e[e.DL_CLASS_CODE_B2_TO = 476] = "DL_CLASS_CODE_B2_TO", e[e.DL_CLASS_CODE_B2_NOTES = 477] = "DL_CLASS_CODE_B2_NOTES", e[e.DL_CLASS_CODE_D2_FROM = 478] = "DL_CLASS_CODE_D2_FROM", e[e.DL_CLASS_CODE_D2_TO = 479] = "DL_CLASS_CODE_D2_TO", e[e.DL_CLASS_CODE_D2_NOTES = 480] = "DL_CLASS_CODE_D2_NOTES", e[e.DL_CLASS_CODE_B2E_FROM = 481] = "DL_CLASS_CODE_B2E_FROM", e[e.DL_CLASS_CODE_B2E_TO = 482] = "DL_CLASS_CODE_B2E_TO", e[e.DL_CLASS_CODE_B2E_NOTES = 483] = "DL_CLASS_CODE_B2E_NOTES", e[e.DL_CLASS_CODE_G_FROM = 484] = "DL_CLASS_CODE_G_FROM", e[e.DL_CLASS_CODE_G_TO = 485] = "DL_CLASS_CODE_G_TO", e[e.DL_CLASS_CODE_G_NOTES = 486] = "DL_CLASS_CODE_G_NOTES", e[e.DL_CLASS_CODE_J_FROM = 487] = "DL_CLASS_CODE_J_FROM", e[e.DL_CLASS_CODE_J_TO = 488] = "DL_CLASS_CODE_J_TO", e[e.DL_CLASS_CODE_J_NOTES = 489] = "DL_CLASS_CODE_J_NOTES", e[e.DL_CLASS_CODE_LC_FROM = 490] = "DL_CLASS_CODE_LC_FROM", e[e.DL_CLASS_CODE_LC_TO = 491] = "DL_CLASS_CODE_LC_TO", e[e.DL_CLASS_CODE_LC_NOTES = 492] = "DL_CLASS_CODE_LC_NOTES", e[e.BANK_CARD_NUMBER = 493] = "BANK_CARD_NUMBER", e[e.BANK_CARD_VALID_THRU = 494] = "BANK_CARD_VALID_THRU", e[e.TAX_NUMBER = 495] = "TAX_NUMBER", e[e.HEALTH_NUMBER = 496] = "HEALTH_NUMBER", e[e.GRANDFATHER_NAME = 497] = "GRANDFATHER_NAME", e[e.SELECTEE_INDICATOR = 498] = "SELECTEE_INDICATOR", e[e.MOTHER_SURNAME = 499] = "MOTHER_SURNAME", e[e.MOTHER_GIVEN_NAME = 500] = "MOTHER_GIVEN_NAME", e[e.FATHER_SURNAME = 501] = "FATHER_SURNAME", e[e.FATHER_GIVEN_NAME = 502] = "FATHER_GIVEN_NAME", e[e.MOTHER_DATE_OF_BIRTH = 503] = "MOTHER_DATE_OF_BIRTH", e[e.FATHER_DATE_OF_BIRTH = 504] = "FATHER_DATE_OF_BIRTH", e[e.MOTHER_PERSONAL_NUMBER = 505] = "MOTHER_PERSONAL_NUMBER", e[e.FATHER_PERSONAL_NUMBER = 506] = "FATHER_PERSONAL_NUMBER", e[e.MOTHER_PLACE_OF_BIRTH = 507] = "MOTHER_PLACE_OF_BIRTH", e[e.FATHER_PLACE_OF_BIRTH = 508] = "FATHER_PLACE_OF_BIRTH", e[e.MOTHER_COUNTRY_OF_BIRTH = 509] = "MOTHER_COUNTRY_OF_BIRTH", e[e.FATHER_COUNTRY_OF_BIRTH = 510] = "FATHER_COUNTRY_OF_BIRTH", e[e.DATE_FIRST_RENEWAL = 511] = "DATE_FIRST_RENEWAL", e[e.DATE_SECOND_RENEWAL = 512] = "DATE_SECOND_RENEWAL", e[e.PLACE_OF_EXAMINATION = 513] = "PLACE_OF_EXAMINATION", e[e.APPLICATION_NUMBER = 514] = "APPLICATION_NUMBER", e[e.VOUCHER_NUMBER = 515] = "VOUCHER_NUMBER", e[e.AUTHORIZATION_NUMBER = 516] = "AUTHORIZATION_NUMBER", e[e.FACULTY = 517] = "FACULTY", e[e.FORM_OF_EDUCATION = 518] = "FORM_OF_EDUCATION", e[e.DNI_NUMBER = 519] = "DNI_NUMBER", e[e.RETIREMENT_NUMBER = 520] = "RETIREMENT_NUMBER", e[e.PROFESSIONAL_ID_NUMBER = 521] = "PROFESSIONAL_ID_NUMBER", e[e.AGE_AT_ISSUE = 522] = "AGE_AT_ISSUE", e[e.YEARS_SINCE_ISSUE = 523] = "YEARS_SINCE_ISSUE", e[e.DL_CLASS_CODE_BTP_FROM = 524] = "DL_CLASS_CODE_BTP_FROM", e[e.DL_CLASS_CODE_BTP_NOTES = 525] = "DL_CLASS_CODE_BTP_NOTES", e[e.DL_CLASS_CODE_BTP_TO = 526] = "DL_CLASS_CODE_BTP_TO", e[e.DL_CLASS_CODE_C3_FROM = 527] = "DL_CLASS_CODE_C3_FROM", e[e.DL_CLASS_CODE_C3_NOTES = 528] = "DL_CLASS_CODE_C3_NOTES", e[e.DL_CLASS_CODE_C3_TO = 529] = "DL_CLASS_CODE_C3_TO", e[e.DL_CLASS_CODE_E_FROM = 530] = "DL_CLASS_CODE_E_FROM", e[e.DL_CLASS_CODE_E_NOTES = 531] = "DL_CLASS_CODE_E_NOTES", e[e.DL_CLASS_CODE_E_TO = 532] = "DL_CLASS_CODE_E_TO", e[e.DL_CLASS_CODE_F_FROM = 533] = "DL_CLASS_CODE_F_FROM", e[e.DL_CLASS_CODE_F_NOTES = 534] = "DL_CLASS_CODE_F_NOTES", e[e.DL_CLASS_CODE_F_TO = 535] = "DL_CLASS_CODE_F_TO", e[e.DL_CLASS_CODE_FA_FROM = 536] = "DL_CLASS_CODE_FA_FROM", e[e.DL_CLASS_CODE_FA_NOTES = 537] = "DL_CLASS_CODE_FA_NOTES", e[e.DL_CLASS_CODE_FA_TO = 538] = "DL_CLASS_CODE_FA_TO", e[e.DL_CLASS_CODE_FA1_FROM = 539] = "DL_CLASS_CODE_FA1_FROM", e[e.DL_CLASS_CODE_FA1_NOTES = 540] = "DL_CLASS_CODE_FA1_NOTES", e[e.DL_CLASS_CODE_FA1_TO = 541] = "DL_CLASS_CODE_FA1_TO", e[e.DL_CLASS_CODE_FB_FROM = 542] = "DL_CLASS_CODE_FB_FROM", e[e.DL_CLASS_CODE_FB_NOTES = 543] = "DL_CLASS_CODE_FB_NOTES", e[e.DL_CLASS_CODE_FB_TO = 544] = "DL_CLASS_CODE_FB_TO", e[e.DL_CLASS_CODE_G1_FROM = 545] = "DL_CLASS_CODE_G1_FROM", e[e.DL_CLASS_CODE_G1_NOTES = 546] = "DL_CLASS_CODE_G1_NOTES", e[e.DL_CLASS_CODE_G1_TO = 547] = "DL_CLASS_CODE_G1_TO", e[e.DL_CLASS_CODE_H_FROM = 548] = "DL_CLASS_CODE_H_FROM", e[e.DL_CLASS_CODE_H_NOTES = 549] = "DL_CLASS_CODE_H_NOTES", e[e.DL_CLASS_CODE_H_TO = 550] = "DL_CLASS_CODE_H_TO", e[e.DL_CLASS_CODE_I_FROM = 551] = "DL_CLASS_CODE_I_FROM", e[e.DL_CLASS_CODE_I_NOTES = 552] = "DL_CLASS_CODE_I_NOTES", e[e.DL_CLASS_CODE_I_TO = 553] = "DL_CLASS_CODE_I_TO", e[e.DL_CLASS_CODE_K_FROM = 554] = "DL_CLASS_CODE_K_FROM", e[e.DL_CLASS_CODE_K_NOTES = 555] = "DL_CLASS_CODE_K_NOTES", e[e.DL_CLASS_CODE_K_TO = 556] = "DL_CLASS_CODE_K_TO", e[e.DL_CLASS_CODE_LK_FROM = 557] = "DL_CLASS_CODE_LK_FROM", e[e.DL_CLASS_CODE_LK_NOTES = 558] = "DL_CLASS_CODE_LK_NOTES", e[e.DL_CLASS_CODE_LK_TO = 559] = "DL_CLASS_CODE_LK_TO", e[e.DL_CLASS_CODE_N_FROM = 560] = "DL_CLASS_CODE_N_FROM", e[e.DL_CLASS_CODE_N_NOTES = 561] = "DL_CLASS_CODE_N_NOTES", e[e.DL_CLASS_CODE_N_TO = 562] = "DL_CLASS_CODE_N_TO", e[e.DL_CLASS_CODE_S_FROM = 563] = "DL_CLASS_CODE_S_FROM", e[e.DL_CLASS_CODE_S_NOTES = 564] = "DL_CLASS_CODE_S_NOTES", e[e.DL_CLASS_CODE_S_TO = 565] = "DL_CLASS_CODE_S_TO", e[e.DL_CLASS_CODE_TB_FROM = 566] = "DL_CLASS_CODE_TB_FROM", e[e.DL_CLASS_CODE_TB_NOTES = 567] = "DL_CLASS_CODE_TB_NOTES", e[e.DL_CLASS_CODE_TB_TO = 568] = "DL_CLASS_CODE_TB_TO", e[e.DL_CLASS_CODE_TM_FROM = 569] = "DL_CLASS_CODE_TM_FROM", e[e.DL_CLASS_CODE_TM_NOTES = 570] = "DL_CLASS_CODE_TM_NOTES", e[e.DL_CLASS_CODE_TM_TO = 571] = "DL_CLASS_CODE_TM_TO", e[e.DL_CLASS_CODE_TR_FROM = 572] = "DL_CLASS_CODE_TR_FROM", e[e.DL_CLASS_CODE_TR_NOTES = 573] = "DL_CLASS_CODE_TR_NOTES", e[e.DL_CLASS_CODE_TR_TO = 574] = "DL_CLASS_CODE_TR_TO", e[e.DL_CLASS_CODE_TV_FROM = 575] = "DL_CLASS_CODE_TV_FROM", e[e.DL_CLASS_CODE_TV_NOTES = 576] = "DL_CLASS_CODE_TV_NOTES", e[e.DL_CLASS_CODE_TV_TO = 577] = "DL_CLASS_CODE_TV_TO", e[e.DL_CLASS_CODE_V_FROM = 578] = "DL_CLASS_CODE_V_FROM", e[e.DL_CLASS_CODE_V_NOTES = 579] = "DL_CLASS_CODE_V_NOTES", e[e.DL_CLASS_CODE_V_TO = 580] = "DL_CLASS_CODE_V_TO", e[e.DL_CLASS_CODE_W_FROM = 581] = "DL_CLASS_CODE_W_FROM", e[e.DL_CLASS_CODE_W_NOTES = 582] = "DL_CLASS_CODE_W_NOTES", e[e.DL_CLASS_CODE_W_TO = 583] = "DL_CLASS_CODE_W_TO", e[e.URL = 584] = "URL", e[e.CALIBER = 585] = "CALIBER", e[e.MODEL = 586] = "MODEL", e[e.MAKE = 587] = "MAKE", e[e.NUMBER_OF_CYLINDERS = 588] = "NUMBER_OF_CYLINDERS", e[e.SURNAME_OF_HUSBAND_AFTER_REGISTRATION = 589] = "SURNAME_OF_HUSBAND_AFTER_REGISTRATION", e[e.SURNAME_OF_WIFE_AFTER_REGISTRATION = 590] = "SURNAME_OF_WIFE_AFTER_REGISTRATION", e[e.DATE_OF_BIRTH_OF_WIFE = 591] = "DATE_OF_BIRTH_OF_WIFE", e[e.DATE_OF_BIRTH_OF_HUSBAND = 592] = "DATE_OF_BIRTH_OF_HUSBAND", e[e.CITIZENSHIP_OF_FIRST_PERSON = 593] = "CITIZENSHIP_OF_FIRST_PERSON", e[e.CITIZENSHIP_OF_SECOND_PERSON = 594] = "CITIZENSHIP_OF_SECOND_PERSON", e[e.CVV = 595] = "CVV", e[e.DATE_OF_INSURANCE_EXPIRY = 596] = "DATE_OF_INSURANCE_EXPIRY", e[e.MORTGAGE_BY = 597] = "MORTGAGE_BY", e[e.OLD_DOCUMENT_NUMBER = 598] = "OLD_DOCUMENT_NUMBER", e[e.OLD_DATE_OF_ISSUE = 599] = "OLD_DATE_OF_ISSUE", e[e.OLD_PLACE_OF_ISSUE = 600] = "OLD_PLACE_OF_ISSUE", e[e.DL_CLASS_CODE_LR_FROM = 601] = "DL_CLASS_CODE_LR_FROM", e[e.DL_CLASS_CODE_LR_TO = 602] = "DL_CLASS_CODE_LR_TO", e[e.DL_CLASS_CODE_LR_NOTES = 603] = "DL_CLASS_CODE_LR_NOTES", e[e.DL_CLASS_CODE_MR_FROM = 604] = "DL_CLASS_CODE_MR_FROM", e[e.DL_CLASS_CODE_MR_TO = 605] = "DL_CLASS_CODE_MR_TO", e[e.DL_CLASS_CODE_MR_NOTES = 606] = "DL_CLASS_CODE_MR_NOTES", e[e.DL_CLASS_CODE_HR_FROM = 607] = "DL_CLASS_CODE_HR_FROM", e[e.DL_CLASS_CODE_HR_TO = 608] = "DL_CLASS_CODE_HR_TO", e[e.DL_CLASS_CODE_HR_NOTES = 609] = "DL_CLASS_CODE_HR_NOTES", e[e.DL_CLASS_CODE_HC_FROM = 610] = "DL_CLASS_CODE_HC_FROM", e[e.DL_CLASS_CODE_HC_TO = 611] = "DL_CLASS_CODE_HC_TO", e[e.DL_CLASS_CODE_HC_NOTES = 612] = "DL_CLASS_CODE_HC_NOTES", e[e.DL_CLASS_CODE_MC_FROM = 613] = "DL_CLASS_CODE_MC_FROM", e[e.DL_CLASS_CODE_MC_TO = 614] = "DL_CLASS_CODE_MC_TO", e[e.DL_CLASS_CODE_MC_NOTES = 615] = "DL_CLASS_CODE_MC_NOTES", e[e.DL_CLASS_CODE_RE_FROM = 616] = "DL_CLASS_CODE_RE_FROM", e[e.DL_CLASS_CODE_RE_TO = 617] = "DL_CLASS_CODE_RE_TO", e[e.DL_CLASS_CODE_RE_NOTES = 618] = "DL_CLASS_CODE_RE_NOTES", e[e.DL_CLASS_CODE_R_FROM = 619] = "DL_CLASS_CODE_R_FROM", e[e.DL_CLASS_CODE_R_TO = 620] = "DL_CLASS_CODE_R_TO", e[e.DL_CLASS_CODE_R_NOTES = 621] = "DL_CLASS_CODE_R_NOTES", e[e.DL_CLASS_CODE_CA_FROM = 622] = "DL_CLASS_CODE_CA_FROM", e[e.DL_CLASS_CODE_CA_TO = 623] = "DL_CLASS_CODE_CA_TO", e[e.DL_CLASS_CODE_CA_NOTES = 624] = "DL_CLASS_CODE_CA_NOTES", e[e.CITIZENSHIP_STATUS = 625] = "CITIZENSHIP_STATUS", e[e.MILITARY_SERVICE_FROM = 626] = "MILITARY_SERVICE_FROM", e[e.MILITARY_SERVICE_TO = 627] = "MILITARY_SERVICE_TO", e[e.DL_CLASS_CODE_NT_FROM = 628] = "DL_CLASS_CODE_NT_FROM", e[e.DL_CLASS_CODE_NT_TO = 629] = "DL_CLASS_CODE_NT_TO", e[e.DL_CLASS_CODE_NT_NOTES = 630] = "DL_CLASS_CODE_NT_NOTES", e[e.DL_CLASS_CODE_TN_FROM = 631] = "DL_CLASS_CODE_TN_FROM", e[e.DL_CLASS_CODE_TN_TO = 632] = "DL_CLASS_CODE_TN_TO", e[e.DL_CLASS_CODE_TN_NOTES = 633] = "DL_CLASS_CODE_TN_NOTES", e[e.DL_CLASS_CODE_D3_FROM = 634] = "DL_CLASS_CODE_D3_FROM", e[e.DL_CLASS_CODE_D3_TO = 635] = "DL_CLASS_CODE_D3_TO", e[e.DL_CLASS_CODE_D3_NOTES = 636] = "DL_CLASS_CODE_D3_NOTES", e[e.ALT_DATE_OF_EXPIRY = 637] = "ALT_DATE_OF_EXPIRY", e[e.DL_CLASS_CODE_CD_FROM = 638] = "DL_CLASS_CODE_CD_FROM", e[e.DL_CLASS_CODE_CD_TO = 639] = "DL_CLASS_CODE_CD_TO", e[e.DL_CLASS_CODE_CD_NOTES = 640] = "DL_CLASS_CODE_CD_NOTES", e[e.ISSUER_IDENTIFICATION_NUMBER = 641] = "ISSUER_IDENTIFICATION_NUMBER", e[e.PAYMENT_PERIOD_FROM = 642] = "PAYMENT_PERIOD_FROM", e[e.PAYMENT_PERIOD_TO = 643] = "PAYMENT_PERIOD_TO", e[e.VACCINATION_CERTIFICATE_IDENTIFIER = 644] = "VACCINATION_CERTIFICATE_IDENTIFIER", e[e.FIRST_NAME = 645] = "FIRST_NAME", e[e.DATE_OF_ARRIVAL = 646] = "DATE_OF_ARRIVAL", e[e.SECOND_NAME = 647] = "SECOND_NAME", e[e.THIRD_NAME = 648] = "THIRD_NAME", e[e.FOURTH_NAME = 649] = "FOURTH_NAME", e[e.LAST_NAME = 650] = "LAST_NAME", e[e.DL_CLASS_CODE_RM_FROM = 651] = "DL_CLASS_CODE_RM_FROM", e[e.DL_CLASS_CODE_RM_NOTES = 652] = "DL_CLASS_CODE_RM_NOTES", e[e.DL_CLASS_CODE_RM_TO = 653] = "DL_CLASS_CODE_RM_TO", e[e.DL_CLASS_CODE_PW_FROM = 654] = "DL_CLASS_CODE_PW_FROM", e[e.DL_CLASS_CODE_PW_NOTES = 655] = "DL_CLASS_CODE_PW_NOTES", e[e.DL_CLASS_CODE_PW_TO = 656] = "DL_CLASS_CODE_PW_TO", e[e.DL_CLASS_CODE_EB_FROM = 657] = "DL_CLASS_CODE_EB_FROM", e[e.DL_CLASS_CODE_EB_NOTES = 658] = "DL_CLASS_CODE_EB_NOTES", e[e.DL_CLASS_CODE_EB_TO = 659] = "DL_CLASS_CODE_EB_TO", e[e.DL_CLASS_CODE_EC_FROM = 660] = "DL_CLASS_CODE_EC_FROM", e[e.DL_CLASS_CODE_EC_NOTES = 661] = "DL_CLASS_CODE_EC_NOTES", e[e.DL_CLASS_CODE_EC_TO = 662] = "DL_CLASS_CODE_EC_TO", e[e.DL_CLASS_CODE_EC1_FROM = 663] = "DL_CLASS_CODE_EC1_FROM", e[e.DL_CLASS_CODE_EC1_NOTES = 664] = "DL_CLASS_CODE_EC1_NOTES", e[e.DL_CLASS_CODE_EC1_TO = 665] = "DL_CLASS_CODE_EC1_TO", e[e.PLACE_OF_BIRTH_CITY = 666] = "PLACE_OF_BIRTH_CITY", e[e.YEAR_OF_BIRTH = 667] = "YEAR_OF_BIRTH", e[e.YEAR_OF_EXPIRY = 668] = "YEAR_OF_EXPIRY", e[e.GRANDFATHER_NAME_MATERNAL = 669] = "GRANDFATHER_NAME_MATERNAL", e[e.FIRST_SURNAME = 670] = "FIRST_SURNAME", e[e.MONTH_OF_BIRTH = 671] = "MONTH_OF_BIRTH", e[e.ADDRESS_FLOOR_NUMBER = 672] = "ADDRESS_FLOOR_NUMBER", e[e.ADDRESS_ENTRANCE = 673] = "ADDRESS_ENTRANCE", e[e.ADDRESS_BLOCK_NUMBER = 674] = "ADDRESS_BLOCK_NUMBER", e[e.ADDRESS_STREET_NUMBER = 675] = "ADDRESS_STREET_NUMBER", e[e.ADDRESS_STREET_TYPE = 676] = "ADDRESS_STREET_TYPE", e[e.ADDRESS_CITY_SECTOR = 677] = "ADDRESS_CITY_SECTOR", e[e.ADDRESS_COUNTY_TYPE = 678] = "ADDRESS_COUNTY_TYPE", e[e.ADDRESS_CITY_TYPE = 679] = "ADDRESS_CITY_TYPE", e[e.ADDRESS_BUILDING_TYPE = 680] = "ADDRESS_BUILDING_TYPE", e[e.DATE_OF_RETIREMENT = 681] = "DATE_OF_RETIREMENT", e[e.DOCUMENT_STATUS = 682] = "DOCUMENT_STATUS", e[e.SIGNATURE = 683] = "SIGNATURE", e[e.FT_UNIQUE_CERTIFICATE_IDENTIFIER = 684] = "FT_UNIQUE_CERTIFICATE_IDENTIFIER", e[e.FT_EMAIL = 685] = "FT_EMAIL", e[e.FT_DATE_OF_SPECIMEN_COLLECTION = 686] = "FT_DATE_OF_SPECIMEN_COLLECTION", e[e.FT_TYPE_OF_TESTING = 687] = "FT_TYPE_OF_TESTING", e[e.FT_RESULT_OF_TESTING = 688] = "FT_RESULT_OF_TESTING", e[e.FT_METHOD_OF_TESTING = 689] = "FT_METHOD_OF_TESTING", e[e.FT_DIGITAL_TRAVEL_AUTHORIZATION_NUMBER = 690] = "FT_DIGITAL_TRAVEL_AUTHORIZATION_NUMBER", e[e.FT_DATE_OF_FIRST_POSITIVE_TEST_RESULT = 691] = "FT_DATE_OF_FIRST_POSITIVE_TEST_RESULT", e[e.EF_CARD_ACCESS = 692] = "EF_CARD_ACCESS", e[e.SHORT_FLIGHT_NUMBER = 693] = "SHORT_FLIGHT_NUMBER", e[e.AIRLINE_CODE = 694] = "AIRLINE_CODE", e[e.FT_MVC_AGENCY = 695] = "FT_MVC_AGENCY", e[e.FT_ISSUING_STATE_CODE_ALPHA2 = 696] = "FT_ISSUING_STATE_CODE_ALPHA2", e[e.FT_NATIONALITY_CODE_ALPHA2 = 697] = "FT_NATIONALITY_CODE_ALPHA2", e[e.FT_FIRST_ISSUE_DATE_CHECK_DIGIT = 698] = "FT_FIRST_ISSUE_DATE_CHECK_DIGIT", e[e.FT_FIRST_ISSUE_DATE_CHECKSUM = 699] = "FT_FIRST_ISSUE_DATE_CHECKSUM", e))(UM || {}), xM = /* @__PURE__ */ ((e) => (e[e.NO_CHANGE = 0] = "NO_CHANGE", e[e.UPPERCASE = 1] = "UPPERCASE", e[e.LOWERCASE = 2] = "LOWERCASE", e[e.CAPITAL = 3] = "CAPITAL", e))(xM || {}), BM = /* @__PURE__ */ ((e) => (e[e.DISABLED = 0] = "DISABLED", e[e.VERIFIED = 1] = "VERIFIED", e[e.NOT_VERIFIED = 2] = "NOT_VERIFIED", e[e.COMPARE_MATCH = 3] = "COMPARE_MATCH", e[e.COMPARE_NOT_MATCH = 4] = "COMPARE_NOT_MATCH", e))(BM || {}), $M = /* @__PURE__ */ ((e) => (e[e.INVISIBLE = 0] = "INVISIBLE", e[e.VISIBLE = 1] = "VISIBLE", e[e.COLORED = 2] = "COLORED", e[e.GRAYSCALE = 4] = "GRAYSCALE", e[e.WHITE_IR_MATCHING = 8] = "WHITE_IR_MATCHING", e))($M || {});
const GM = {
  0: "Latin",
  1078: "Afrikaans",
  1052: "Albanian",
  5121: "Arabic (Algeria)",
  15361: "Arabic (Bahrain)",
  3073: "Arabic (Egypt)",
  2049: "Arabic (Iraq)",
  11265: "Arabic (Jordan)",
  13313: "Arabic (Kuwait)",
  12289: "Arabic (Lebanon)",
  4097: "Arabic (Libya)",
  6145: "Arabic (Morocco)",
  8193: "Arabic (Oman)",
  16385: "Arabic (Qatar)",
  1025: "Arabic (Saudi Arabia)",
  10241: "Arabic (Syria)",
  7169: "Arabic (Tunisia)",
  14337: "Arabic (U.A.E.)",
  9217: "Arabic (Yemen)",
  1067: "Arabic Armenian",
  2092: "Azeri (Cyrillic)",
  1068: "Azeri (Latin)",
  1069: "Basque",
  1059: "Belarusian",
  1026: "Bulgarian",
  1027: "Catalan",
  3076: "Chinese (HongKong S.A.R.)",
  5124: "Chinese (Macao S.A.R.)",
  2052: "Chinese",
  4100: "Chinese (Singapore)",
  1028: "Chinese (Taiwan)",
  1050: "Croatian",
  1029: "Czech",
  1030: "Danish",
  1125: "Divehi",
  2067: "Dutch (Belgium)",
  1043: "Dutch (Netherlands)",
  3081: "English (Australia)",
  10249: "English (Belize)",
  4105: "English (Canada)",
  9225: "English (Caribbean)",
  6153: "English (Ireland)",
  8201: "English (Jamaica)",
  5129: "English (New Zealand)",
  13321: "English (Philippines)",
  7177: "English (South Africa)",
  11273: "English (Trinidad)",
  2057: "English (United Kingdom)",
  1033: "English (United States)",
  12297: "English (Zimbabwe)",
  1061: "Estonian",
  1080: "Faroese",
  1065: "Farsi",
  1035: "Finnish",
  2060: "French (Belgium)",
  3084: "French (Canada)",
  1036: "French (France)",
  5132: "French (Luxembourg)",
  6156: "French (Monaco)",
  4108: "French (Switzerland)",
  1071: "FYRO Macedonian",
  1110: "Galician",
  1079: "Georgian",
  3079: "German (Austria)",
  1031: "German (Germany)",
  5127: "German (Liechtenstein)",
  4103: "German (Luxembourg)",
  2055: "German (Switzerland)",
  1032: "Greek",
  1095: "Gujarati",
  1037: "Hebrew",
  1081: "Hindi (India)",
  1038: "Hungarian",
  1039: "Icelandic",
  1057: "Indonesian",
  1040: "Italian (Italy)",
  2064: "Italian (Switzerland)",
  1041: "Japanese",
  1099: "Kannada",
  1087: "Kazakh",
  1111: "Konkani",
  1042: "Korean",
  1088: "Kyrgyz (Cyrillic)",
  1062: "Latvian",
  1063: "Lithuanian",
  2110: "Malay (Brunei Darussalam)",
  1102: "Marathi",
  1086: "Malay (Malaysia)",
  1104: "Mongolian (Cyrillic)",
  1044: "Norwegian (Bokmal)",
  2068: "Norwegian (Nynorsk)",
  1045: "Polish",
  1046: "Portuguese (Brazil)",
  2070: "Portuguese (Portugal)",
  1094: "Punjabi",
  1047: "Rhaeto-Romanic",
  1048: "Romanian",
  1049: "Russian",
  1103: "Sanskrit",
  3098: "Serbian (Cyrillic)",
  2074: "Serbian (Latin)",
  1051: "Slovak",
  1060: "Slovenian",
  11274: "Spanish (Argentina)",
  16394: "Spanish (Bolivia)",
  13322: "Spanish (Chile)",
  9226: "Spanish (Colombia)",
  5130: "Spanish (Costa Rica)",
  7178: "Spanish (Dominican Republic)",
  12298: "Spanish (Ecuador)",
  17418: "Spanish (El Salvador)",
  4106: "Spanish (Guatemala)",
  18442: "Spanish (Honduras)",
  3082: "Spanish (International Sort)",
  2058: "Spanish (Mexico)",
  19466: "Spanish (Nicaragua)",
  6154: "Spanish (Panama)",
  15370: "Spanish (Paraguay)",
  10250: "Spanish (Peru)",
  20490: "Spanish (Puerto Rico)",
  1034: "Spanish (Traditional Sort)",
  14346: "Spanish (Uruguay)",
  8202: "Spanish (Venezuela)",
  1089: "Swahili",
  1053: "Swedish",
  2077: "Swedish (Finland)",
  1114: "Syriac",
  1097: "Tamil",
  1092: "Tatar",
  1098: "Telugu",
  1054: "Thai (Thailand)",
  1055: "Turkish",
  1058: "Ukrainian",
  1056: "Urdu",
  2115: "Uzbek (Cyrillic)",
  1091: "Uzbek (Latin)",
  1066: "Vietnamese",
  1064: "Tajik (Cyrillic)",
  1090: "Turkmen",
  50001: "CTC Simplified",
  50002: "CTC Traditional",
  9999: "Custom"
};
class ZM {
  constructor(r) {
    this.fieldType = r.fieldType, this.fieldName = r.fieldName, this.lcid = r.lcid, this.status = r.status, this.validityStatus = r.validityStatus, this.comparisonStatus = r.comparisonStatus, this.value = r.value, this.valueList = r.valueList, this.validityList = r.validityList, this.comparisonList = r.comparisonList, this.lcidName = r.lcidName;
  }
  /**
   * This method returns value of the text field. Value encoded in UTF8.
   * Fields value obtained in the following order:
   * - if MRZ value is present, it will be taken
   * - if no MRZ, but RFID value is present, it will be taken
   * - if no MRZ, no RFID, but Barcode value is present, it will be taken
   * - if no MRZ, no RFID, no Barcode, but Visual OCR value is present, it will be taken
   *
   * @param source See {@code Source}
   * @param original Each value formatted according to input params and server settings.
   * To get original representation, set this flag to true. Date example:
   *  - original visual value - "3 January 2009"
   *  - formatted value - "03.01.2009"
   */
  getValue(r, t = !1) {
    if (!r)
      return this.value;
    const a = this.getValueBySource(r);
    return t ? a == null ? void 0 : a.originalValue : a == null ? void 0 : a.value;
  }
  /**
   * Returns validity check of all values for given source.
   * @param source See {@code Source}
   */
  sourceValidity(r) {
    for (const t of this.validityList)
      if (t.source === r)
        return t.status;
    return Mi.WAS_NOT_DONE;
  }
  /**
   * Returns value matching result for different sources.
   */
  crossSourceComparison(r, t) {
    for (const a of this.comparisonList)
      if (a.sourceLeft === r && a.sourceRight === t || a.sourceLeft === t && a.sourceRight === r)
        return a.status;
    return Mi.WAS_NOT_DONE;
  }
  getLCIDName() {
    if (this.lcid)
      return GM[this.lcid] || String(this.lcid);
  }
  getValueBySource(r) {
    for (const t of this.valueList)
      if (t.source == r)
        return t;
  }
}
class jM {
  constructor(r) {
    this.status = r.status, this.validityStatus = r.validityStatus, this.comparisonStatus = r.comparisonStatus, this.dateFormat = r.dateFormat, this.availableSourceList = r.availableSourceList, this.fieldList = r.fieldList.map((t) => new ZM(t));
  }
  getField(r, t) {
    let a;
    for (const o of this.fieldList)
      if (o.fieldType == r) {
        if (t != null && o.lcid == t || t == null && o.lcid == Dp.LATIN)
          return o;
        t == null && a == null && (a = o);
      }
    return a;
  }
  getFieldByName(r, t) {
    let a;
    for (const o of this.fieldList)
      if (o.fieldName == r) {
        if (t != null && o.lcid == t || t == null && o.lcid == Dp.LATIN)
          return o;
        t == null && a == null && (a = o);
      }
    return a;
  }
  getFieldValue(r, t) {
    var a;
    return (a = this.getField(r, t)) == null ? void 0 : a.getValue();
  }
  getFieldValueByName(r, t) {
    var a;
    return (a = this.getFieldByName(r, t)) == null ? void 0 : a.getValue();
  }
}
var No = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bs = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var g2 = 0; g2 < No.length; g2++)
  bs[No.charCodeAt(g2)] = g2;
var zM = function(e) {
  var r = new Uint8Array(e), t, a = r.length, o = "";
  for (t = 0; t < a; t += 3)
    o += No[r[t] >> 2], o += No[(r[t] & 3) << 4 | r[t + 1] >> 4], o += No[(r[t + 1] & 15) << 2 | r[t + 2] >> 6], o += No[r[t + 2] & 63];
  return a % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : a % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, gD = function(e) {
  var r = e.length * 0.75, t = e.length, a, o = 0, l, c, u, p;
  e[e.length - 1] === "=" && (r--, e[e.length - 2] === "=" && r--);
  var f = new ArrayBuffer(r), h = new Uint8Array(f);
  for (a = 0; a < t; a += 4)
    l = bs[e.charCodeAt(a)], c = bs[e.charCodeAt(a + 1)], u = bs[e.charCodeAt(a + 2)], p = bs[e.charCodeAt(a + 3)], h[o++] = l << 2 | c >> 4, h[o++] = (c & 15) << 4 | u >> 2, h[o++] = (u & 3) << 6 | p & 63;
  return f;
};
class qM {
  constructor(r) {
    this.availableSourceList = r.availableSourceList, this.fieldList = r.fieldList.map((t) => new WM(t)), this.fieldCount = r.fieldCount, this.availableSourceCount = r.availableSourceCount;
  }
  getField(r) {
    for (const t of this.fieldList)
      if (t.fieldType == r)
        return t;
  }
  getFields(r) {
    return this.fieldList.filter((t) => t.fieldType == r);
  }
}
class WM {
  constructor(r) {
    this.fieldName = r.fieldName, this.fieldType = r.fieldType, this.valueList = r.valueList, this.valueCount = r.valueCount;
  }
  getValue(r, t = !1) {
    const a = r ? this.getValueBySource(r) : this.getValueBySource(k2.RFID) || this.getValueBySource(k2.VISUAL) || this.getValueBySource(k2.BARCODE);
    if (!a) return;
    const o = t && a.originalValue ? a.originalValue : a.value;
    return o ? YM(o) : void 0;
  }
  getValueBySource(r) {
    for (const t of this.valueList)
      if (t.source == r)
        return t;
  }
}
function YM(e) {
  return gD(e);
}
class KM {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class XM {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
  checksByElement(r) {
    const t = [];
    for (const a of this.List)
      a.ElementType === r && t.push(a);
    return t;
  }
}
class QM {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class JM {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class eP {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
  checksByElement(r) {
    const t = [];
    for (const a of this.List)
      a.ElementType === r && t.push(a);
    return t;
  }
}
class L6 {
  constructor(r, t) {
    this.List = r.List, this.page_idx = t, this.Count = r.Count;
  }
  uvLuminescenceChecks() {
    return this.securityFeatureOrUndefined(pr.UV_LUMINESCENCE);
  }
  irB900Checks() {
    return this.securityFeatureOrUndefined(pr.IR_B900);
  }
  imagePatternChecks() {
    return this.identOrUndefined(pr.IMAGE_PATTERN);
  }
  axialProtectionChecks() {
    return this.securityFeatureOrUndefined(pr.AXIAL_PROTECTION);
  }
  uvFiberChecks() {
    return this.fiberOrUndefined(pr.UV_FIBERS);
  }
  irVisibilityChecks() {
    return this.identOrUndefined(pr.IR_VISIBILITY);
  }
  ocrSecurityTextChecks() {
    return this.ocrSecurityTextOrUndefined(pr.OCR_SECURITY_TEXT);
  }
  ipiChecks() {
    return this.imageIdentOrUndefined(pr.IPI);
  }
  embedImageChecks() {
    return this.securityFeatureOrUndefined(pr.PHOTO_EMBED_TYPE);
  }
  hologramsChecks() {
    return this.securityFeatureOrUndefined(pr.HOLOGRAMS);
  }
  imageAreaChecks() {
    return this.securityFeatureOrUndefined(pr.PHOTO_AREA);
  }
  portraitComparisonChecks() {
    return this.identOrUndefined(pr.PORTRAIT_COMPARISON);
  }
  barcodeFormatCheckChecks() {
    return this.securityFeatureOrUndefined(pr.BARCODE_FORMAT_CHECK);
  }
  kinegramChecks() {
    return this.identOrUndefined(pr.KINEGRAM);
  }
  letterScreenChecks() {
    return this.identOrUndefined(pr.LETTER_SCREEN);
  }
  hologramDetectionChecks() {
    return this.identOrUndefined(pr.HOLOGRAM_DETECTION);
  }
  mrzChecks() {
    return this.securityFeatureOrUndefined(pr.EXTENDED_MRZ_CHECK);
  }
  livenessChecks() {
    return this.identOrUndefined(pr.LIVENESS);
  }
  resultByType(r) {
    for (const t of this.List)
      if (t.Type == r)
        return t;
  }
  fiberOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new KM(t);
  }
  identOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new XM(t);
  }
  imageIdentOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new QM(t);
  }
  ocrSecurityTextOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new JM(t);
  }
  securityFeatureOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new eP(t);
  }
}
function $o(e) {
  let r = e.length;
  for (; --r >= 0; )
    e[r] = 0;
}
const tP = 3, rP = 258, RD = 29, nP = 256, iP = nP + 1 + RD, DD = 30, aP = 512, oP = new Array((iP + 2) * 2);
$o(oP);
const sP = new Array(DD * 2);
$o(sP);
const lP = new Array(aP);
$o(lP);
const cP = new Array(rP - tP + 1);
$o(cP);
const uP = new Array(RD);
$o(uP);
const fP = new Array(DD);
$o(fP);
const dP = (e, r, t, a) => {
  let o = e & 65535 | 0, l = e >>> 16 & 65535 | 0, c = 0;
  for (; t !== 0; ) {
    c = t > 2e3 ? 2e3 : t, t -= c;
    do
      o = o + r[a++] | 0, l = l + o | 0;
    while (--c);
    o %= 65521, l %= 65521;
  }
  return o | l << 16 | 0;
};
var Tp = dP;
const pP = () => {
  let e, r = [];
  for (var t = 0; t < 256; t++) {
    e = t;
    for (var a = 0; a < 8; a++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    r[t] = e;
  }
  return r;
}, hP = new Uint32Array(pP()), _P = (e, r, t, a) => {
  const o = hP, l = a + t;
  e ^= -1;
  for (let c = a; c < l; c++)
    e = e >>> 8 ^ o[(e ^ r[c]) & 255];
  return e ^ -1;
};
var ni = _P, Op = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, AD = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const mP = (e, r) => Object.prototype.hasOwnProperty.call(e, r);
var EP = function(e) {
  const r = Array.prototype.slice.call(arguments, 1);
  for (; r.length; ) {
    const t = r.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const a in t)
        mP(t, a) && (e[a] = t[a]);
    }
  }
  return e;
}, CP = (e) => {
  let r = 0;
  for (let a = 0, o = e.length; a < o; a++)
    r += e[a].length;
  const t = new Uint8Array(r);
  for (let a = 0, o = 0, l = e.length; a < l; a++) {
    let c = e[a];
    t.set(c, o), o += c.length;
  }
  return t;
}, TD = {
  assign: EP,
  flattenChunks: CP
};
let OD = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (e) {
  OD = !1;
}
const xs = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  xs[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
xs[254] = xs[254] = 1;
var SP = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let r, t, a, o, l, c = e.length, u = 0;
  for (o = 0; o < c; o++)
    t = e.charCodeAt(o), (t & 64512) === 55296 && o + 1 < c && (a = e.charCodeAt(o + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), o++)), u += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (r = new Uint8Array(u), l = 0, o = 0; l < u; o++)
    t = e.charCodeAt(o), (t & 64512) === 55296 && o + 1 < c && (a = e.charCodeAt(o + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), o++)), t < 128 ? r[l++] = t : t < 2048 ? (r[l++] = 192 | t >>> 6, r[l++] = 128 | t & 63) : t < 65536 ? (r[l++] = 224 | t >>> 12, r[l++] = 128 | t >>> 6 & 63, r[l++] = 128 | t & 63) : (r[l++] = 240 | t >>> 18, r[l++] = 128 | t >>> 12 & 63, r[l++] = 128 | t >>> 6 & 63, r[l++] = 128 | t & 63);
  return r;
};
const IP = (e, r) => {
  if (r < 65534 && e.subarray && OD)
    return String.fromCharCode.apply(null, e.length === r ? e : e.subarray(0, r));
  let t = "";
  for (let a = 0; a < r; a++)
    t += String.fromCharCode(e[a]);
  return t;
};
var vP = (e, r) => {
  const t = r || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, r));
  let a, o;
  const l = new Array(t * 2);
  for (o = 0, a = 0; a < t; ) {
    let c = e[a++];
    if (c < 128) {
      l[o++] = c;
      continue;
    }
    let u = xs[c];
    if (u > 4) {
      l[o++] = 65533, a += u - 1;
      continue;
    }
    for (c &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && a < t; )
      c = c << 6 | e[a++] & 63, u--;
    if (u > 1) {
      l[o++] = 65533;
      continue;
    }
    c < 65536 ? l[o++] = c : (c -= 65536, l[o++] = 55296 | c >> 10 & 1023, l[o++] = 56320 | c & 1023);
  }
  return IP(l, o);
}, gP = (e, r) => {
  r = r || e.length, r > e.length && (r = e.length);
  let t = r - 1;
  for (; t >= 0 && (e[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? r : t + xs[e[t]] > r ? t : r;
}, yp = {
  string2buf: SP,
  buf2string: vP,
  utf8border: gP
};
function RP() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var DP = RP;
const R2 = 16209, AP = 16191;
var TP = function(e, r) {
  let t, a, o, l, c, u, p, f, h, C, E, m, S, v, g, O, D, R, T, N, b, L, k, w;
  const V = e.state;
  t = e.next_in, k = e.input, a = t + (e.avail_in - 5), o = e.next_out, w = e.output, l = o - (r - e.avail_out), c = o + (e.avail_out - 257), u = V.dmax, p = V.wsize, f = V.whave, h = V.wnext, C = V.window, E = V.hold, m = V.bits, S = V.lencode, v = V.distcode, g = (1 << V.lenbits) - 1, O = (1 << V.distbits) - 1;
  e:
    do {
      m < 15 && (E += k[t++] << m, m += 8, E += k[t++] << m, m += 8), D = S[E & g];
      t:
        for (; ; ) {
          if (R = D >>> 24, E >>>= R, m -= R, R = D >>> 16 & 255, R === 0)
            w[o++] = D & 65535;
          else if (R & 16) {
            T = D & 65535, R &= 15, R && (m < R && (E += k[t++] << m, m += 8), T += E & (1 << R) - 1, E >>>= R, m -= R), m < 15 && (E += k[t++] << m, m += 8, E += k[t++] << m, m += 8), D = v[E & O];
            r:
              for (; ; ) {
                if (R = D >>> 24, E >>>= R, m -= R, R = D >>> 16 & 255, R & 16) {
                  if (N = D & 65535, R &= 15, m < R && (E += k[t++] << m, m += 8, m < R && (E += k[t++] << m, m += 8)), N += E & (1 << R) - 1, N > u) {
                    e.msg = "invalid distance too far back", V.mode = R2;
                    break e;
                  }
                  if (E >>>= R, m -= R, R = o - l, N > R) {
                    if (R = N - R, R > f && V.sane) {
                      e.msg = "invalid distance too far back", V.mode = R2;
                      break e;
                    }
                    if (b = 0, L = C, h === 0) {
                      if (b += p - R, R < T) {
                        T -= R;
                        do
                          w[o++] = C[b++];
                        while (--R);
                        b = o - N, L = w;
                      }
                    } else if (h < R) {
                      if (b += p + h - R, R -= h, R < T) {
                        T -= R;
                        do
                          w[o++] = C[b++];
                        while (--R);
                        if (b = 0, h < T) {
                          R = h, T -= R;
                          do
                            w[o++] = C[b++];
                          while (--R);
                          b = o - N, L = w;
                        }
                      }
                    } else if (b += h - R, R < T) {
                      T -= R;
                      do
                        w[o++] = C[b++];
                      while (--R);
                      b = o - N, L = w;
                    }
                    for (; T > 2; )
                      w[o++] = L[b++], w[o++] = L[b++], w[o++] = L[b++], T -= 3;
                    T && (w[o++] = L[b++], T > 1 && (w[o++] = L[b++]));
                  } else {
                    b = o - N;
                    do
                      w[o++] = w[b++], w[o++] = w[b++], w[o++] = w[b++], T -= 3;
                    while (T > 2);
                    T && (w[o++] = w[b++], T > 1 && (w[o++] = w[b++]));
                  }
                } else if ((R & 64) === 0) {
                  D = v[(D & 65535) + (E & (1 << R) - 1)];
                  continue r;
                } else {
                  e.msg = "invalid distance code", V.mode = R2;
                  break e;
                }
                break;
              }
          } else if ((R & 64) === 0) {
            D = S[(D & 65535) + (E & (1 << R) - 1)];
            continue t;
          } else if (R & 32) {
            V.mode = AP;
            break e;
          } else {
            e.msg = "invalid literal/length code", V.mode = R2;
            break e;
          }
          break;
        }
    } while (t < a && o < c);
  T = m >> 3, t -= T, m -= T << 3, E &= (1 << m) - 1, e.next_in = t, e.next_out = o, e.avail_in = t < a ? 5 + (a - t) : 5 - (t - a), e.avail_out = o < c ? 257 + (c - o) : 257 - (o - c), V.hold = E, V.bits = m;
};
const To = 15, M6 = 852, P6 = 592, b6 = 0, U1 = 1, w6 = 2, OP = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), yP = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), NP = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), LP = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), MP = (e, r, t, a, o, l, c, u) => {
  const p = u.bits;
  let f = 0, h = 0, C = 0, E = 0, m = 0, S = 0, v = 0, g = 0, O = 0, D = 0, R, T, N, b, L, k = null, w;
  const V = new Uint16Array(To + 1), U = new Uint16Array(To + 1);
  let z = null, q, W, te;
  for (f = 0; f <= To; f++)
    V[f] = 0;
  for (h = 0; h < a; h++)
    V[r[t + h]]++;
  for (m = p, E = To; E >= 1 && V[E] === 0; E--)
    ;
  if (m > E && (m = E), E === 0)
    return o[l++] = 1 << 24 | 64 << 16 | 0, o[l++] = 1 << 24 | 64 << 16 | 0, u.bits = 1, 0;
  for (C = 1; C < E && V[C] === 0; C++)
    ;
  for (m < C && (m = C), g = 1, f = 1; f <= To; f++)
    if (g <<= 1, g -= V[f], g < 0)
      return -1;
  if (g > 0 && (e === b6 || E !== 1))
    return -1;
  for (U[1] = 0, f = 1; f < To; f++)
    U[f + 1] = U[f] + V[f];
  for (h = 0; h < a; h++)
    r[t + h] !== 0 && (c[U[r[t + h]]++] = h);
  if (e === b6 ? (k = z = c, w = 20) : e === U1 ? (k = OP, z = yP, w = 257) : (k = NP, z = LP, w = 0), D = 0, h = 0, f = C, L = l, S = m, v = 0, N = -1, O = 1 << m, b = O - 1, e === U1 && O > M6 || e === w6 && O > P6)
    return 1;
  for (; ; ) {
    q = f - v, c[h] + 1 < w ? (W = 0, te = c[h]) : c[h] >= w ? (W = z[c[h] - w], te = k[c[h] - w]) : (W = 96, te = 0), R = 1 << f - v, T = 1 << S, C = T;
    do
      T -= R, o[L + (D >> v) + T] = q << 24 | W << 16 | te | 0;
    while (T !== 0);
    for (R = 1 << f - 1; D & R; )
      R >>= 1;
    if (R !== 0 ? (D &= R - 1, D += R) : D = 0, h++, --V[f] === 0) {
      if (f === E)
        break;
      f = r[t + c[h]];
    }
    if (f > m && (D & b) !== N) {
      for (v === 0 && (v = m), L += C, S = f - v, g = 1 << S; S + v < E && (g -= V[S + v], !(g <= 0)); )
        S++, g <<= 1;
      if (O += 1 << S, e === U1 && O > M6 || e === w6 && O > P6)
        return 1;
      N = D & b, o[N] = m << 24 | S << 16 | L - l | 0;
    }
  }
  return D !== 0 && (o[L + D] = f - v << 24 | 64 << 16 | 0), u.bits = m, 0;
};
var Vs = MP;
const PP = 0, yD = 1, ND = 2, {
  Z_FINISH: H6,
  Z_BLOCK: bP,
  Z_TREES: D2,
  Z_OK: Ha,
  Z_STREAM_END: wP,
  Z_NEED_DICT: HP,
  Z_STREAM_ERROR: Bn,
  Z_DATA_ERROR: LD,
  Z_MEM_ERROR: MD,
  Z_BUF_ERROR: VP,
  Z_DEFLATED: V6
} = AD, dc = 16180, k6 = 16181, F6 = 16182, U6 = 16183, x6 = 16184, B6 = 16185, $6 = 16186, G6 = 16187, Z6 = 16188, j6 = 16189, z2 = 16190, Di = 16191, x1 = 16192, z6 = 16193, B1 = 16194, q6 = 16195, W6 = 16196, Y6 = 16197, K6 = 16198, A2 = 16199, T2 = 16200, X6 = 16201, Q6 = 16202, J6 = 16203, e7 = 16204, t7 = 16205, $1 = 16206, r7 = 16207, n7 = 16208, Zt = 16209, PD = 16210, bD = 16211, kP = 852, FP = 592, UP = 15, xP = UP, i7 = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function BP() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const Ga = (e) => {
  if (!e)
    return 1;
  const r = e.state;
  return !r || r.strm !== e || r.mode < dc || r.mode > bD ? 1 : 0;
}, wD = (e) => {
  if (Ga(e))
    return Bn;
  const r = e.state;
  return e.total_in = e.total_out = r.total = 0, e.msg = "", r.wrap && (e.adler = r.wrap & 1), r.mode = dc, r.last = 0, r.havedict = 0, r.flags = -1, r.dmax = 32768, r.head = null, r.hold = 0, r.bits = 0, r.lencode = r.lendyn = new Int32Array(kP), r.distcode = r.distdyn = new Int32Array(FP), r.sane = 1, r.back = -1, Ha;
}, HD = (e) => {
  if (Ga(e))
    return Bn;
  const r = e.state;
  return r.wsize = 0, r.whave = 0, r.wnext = 0, wD(e);
}, VD = (e, r) => {
  let t;
  if (Ga(e))
    return Bn;
  const a = e.state;
  return r < 0 ? (t = 0, r = -r) : (t = (r >> 4) + 5, r < 48 && (r &= 15)), r && (r < 8 || r > 15) ? Bn : (a.window !== null && a.wbits !== r && (a.window = null), a.wrap = t, a.wbits = r, HD(e));
}, kD = (e, r) => {
  if (!e)
    return Bn;
  const t = new BP();
  e.state = t, t.strm = e, t.window = null, t.mode = dc;
  const a = VD(e, r);
  return a !== Ha && (e.state = null), a;
}, $P = (e) => kD(e, xP);
let a7 = !0, G1, Z1;
const GP = (e) => {
  if (a7) {
    G1 = new Int32Array(512), Z1 = new Int32Array(32);
    let r = 0;
    for (; r < 144; )
      e.lens[r++] = 8;
    for (; r < 256; )
      e.lens[r++] = 9;
    for (; r < 280; )
      e.lens[r++] = 7;
    for (; r < 288; )
      e.lens[r++] = 8;
    for (Vs(yD, e.lens, 0, 288, G1, 0, e.work, { bits: 9 }), r = 0; r < 32; )
      e.lens[r++] = 5;
    Vs(ND, e.lens, 0, 32, Z1, 0, e.work, { bits: 5 }), a7 = !1;
  }
  e.lencode = G1, e.lenbits = 9, e.distcode = Z1, e.distbits = 5;
}, FD = (e, r, t, a) => {
  let o;
  const l = e.state;
  return l.window === null && (l.wsize = 1 << l.wbits, l.wnext = 0, l.whave = 0, l.window = new Uint8Array(l.wsize)), a >= l.wsize ? (l.window.set(r.subarray(t - l.wsize, t), 0), l.wnext = 0, l.whave = l.wsize) : (o = l.wsize - l.wnext, o > a && (o = a), l.window.set(r.subarray(t - a, t - a + o), l.wnext), a -= o, a ? (l.window.set(r.subarray(t - a, t), 0), l.wnext = a, l.whave = l.wsize) : (l.wnext += o, l.wnext === l.wsize && (l.wnext = 0), l.whave < l.wsize && (l.whave += o))), 0;
}, ZP = (e, r) => {
  let t, a, o, l, c, u, p, f, h, C, E, m, S, v, g = 0, O, D, R, T, N, b, L, k;
  const w = new Uint8Array(4);
  let V, U;
  const z = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (Ga(e) || !e.output || !e.input && e.avail_in !== 0)
    return Bn;
  t = e.state, t.mode === Di && (t.mode = x1), c = e.next_out, o = e.output, p = e.avail_out, l = e.next_in, a = e.input, u = e.avail_in, f = t.hold, h = t.bits, C = u, E = p, k = Ha;
  e:
    for (; ; )
      switch (t.mode) {
        case dc:
          if (t.wrap === 0) {
            t.mode = x1;
            break;
          }
          for (; h < 16; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if (t.wrap & 2 && f === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, w[0] = f & 255, w[1] = f >>> 8 & 255, t.check = ni(t.check, w, 2, 0), f = 0, h = 0, t.mode = k6;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((f & 255) << 8) + (f >> 8)) % 31) {
            e.msg = "incorrect header check", t.mode = Zt;
            break;
          }
          if ((f & 15) !== V6) {
            e.msg = "unknown compression method", t.mode = Zt;
            break;
          }
          if (f >>>= 4, h -= 4, L = (f & 15) + 8, t.wbits === 0 && (t.wbits = L), L > 15 || L > t.wbits) {
            e.msg = "invalid window size", t.mode = Zt;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, e.adler = t.check = 1, t.mode = f & 512 ? j6 : Di, f = 0, h = 0;
          break;
        case k6:
          for (; h < 16; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if (t.flags = f, (t.flags & 255) !== V6) {
            e.msg = "unknown compression method", t.mode = Zt;
            break;
          }
          if (t.flags & 57344) {
            e.msg = "unknown header flags set", t.mode = Zt;
            break;
          }
          t.head && (t.head.text = f >> 8 & 1), t.flags & 512 && t.wrap & 4 && (w[0] = f & 255, w[1] = f >>> 8 & 255, t.check = ni(t.check, w, 2, 0)), f = 0, h = 0, t.mode = F6;
        /* falls through */
        case F6:
          for (; h < 32; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          t.head && (t.head.time = f), t.flags & 512 && t.wrap & 4 && (w[0] = f & 255, w[1] = f >>> 8 & 255, w[2] = f >>> 16 & 255, w[3] = f >>> 24 & 255, t.check = ni(t.check, w, 4, 0)), f = 0, h = 0, t.mode = U6;
        /* falls through */
        case U6:
          for (; h < 16; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          t.head && (t.head.xflags = f & 255, t.head.os = f >> 8), t.flags & 512 && t.wrap & 4 && (w[0] = f & 255, w[1] = f >>> 8 & 255, t.check = ni(t.check, w, 2, 0)), f = 0, h = 0, t.mode = x6;
        /* falls through */
        case x6:
          if (t.flags & 1024) {
            for (; h < 16; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            t.length = f, t.head && (t.head.extra_len = f), t.flags & 512 && t.wrap & 4 && (w[0] = f & 255, w[1] = f >>> 8 & 255, t.check = ni(t.check, w, 2, 0)), f = 0, h = 0;
          } else t.head && (t.head.extra = null);
          t.mode = B6;
        /* falls through */
        case B6:
          if (t.flags & 1024 && (m = t.length, m > u && (m = u), m && (t.head && (L = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            a.subarray(
              l,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              l + m
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            L
          )), t.flags & 512 && t.wrap & 4 && (t.check = ni(t.check, a, m, l)), u -= m, l += m, t.length -= m), t.length))
            break e;
          t.length = 0, t.mode = $6;
        /* falls through */
        case $6:
          if (t.flags & 2048) {
            if (u === 0)
              break e;
            m = 0;
            do
              L = a[l + m++], t.head && L && t.length < 65536 && (t.head.name += String.fromCharCode(L));
            while (L && m < u);
            if (t.flags & 512 && t.wrap & 4 && (t.check = ni(t.check, a, m, l)), u -= m, l += m, L)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = G6;
        /* falls through */
        case G6:
          if (t.flags & 4096) {
            if (u === 0)
              break e;
            m = 0;
            do
              L = a[l + m++], t.head && L && t.length < 65536 && (t.head.comment += String.fromCharCode(L));
            while (L && m < u);
            if (t.flags & 512 && t.wrap & 4 && (t.check = ni(t.check, a, m, l)), u -= m, l += m, L)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = Z6;
        /* falls through */
        case Z6:
          if (t.flags & 512) {
            for (; h < 16; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            if (t.wrap & 4 && f !== (t.check & 65535)) {
              e.msg = "header crc mismatch", t.mode = Zt;
              break;
            }
            f = 0, h = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = Di;
          break;
        case j6:
          for (; h < 32; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          e.adler = t.check = i7(f), f = 0, h = 0, t.mode = z2;
        /* falls through */
        case z2:
          if (t.havedict === 0)
            return e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = u, t.hold = f, t.bits = h, HP;
          e.adler = t.check = 1, t.mode = Di;
        /* falls through */
        case Di:
          if (r === bP || r === D2)
            break e;
        /* falls through */
        case x1:
          if (t.last) {
            f >>>= h & 7, h -= h & 7, t.mode = $1;
            break;
          }
          for (; h < 3; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          switch (t.last = f & 1, f >>>= 1, h -= 1, f & 3) {
            case 0:
              t.mode = z6;
              break;
            case 1:
              if (GP(t), t.mode = A2, r === D2) {
                f >>>= 2, h -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = W6;
              break;
            case 3:
              e.msg = "invalid block type", t.mode = Zt;
          }
          f >>>= 2, h -= 2;
          break;
        case z6:
          for (f >>>= h & 7, h -= h & 7; h < 32; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if ((f & 65535) !== (f >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", t.mode = Zt;
            break;
          }
          if (t.length = f & 65535, f = 0, h = 0, t.mode = B1, r === D2)
            break e;
        /* falls through */
        case B1:
          t.mode = q6;
        /* falls through */
        case q6:
          if (m = t.length, m) {
            if (m > u && (m = u), m > p && (m = p), m === 0)
              break e;
            o.set(a.subarray(l, l + m), c), u -= m, l += m, p -= m, c += m, t.length -= m;
            break;
          }
          t.mode = Di;
          break;
        case W6:
          for (; h < 14; ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if (t.nlen = (f & 31) + 257, f >>>= 5, h -= 5, t.ndist = (f & 31) + 1, f >>>= 5, h -= 5, t.ncode = (f & 15) + 4, f >>>= 4, h -= 4, t.nlen > 286 || t.ndist > 30) {
            e.msg = "too many length or distance symbols", t.mode = Zt;
            break;
          }
          t.have = 0, t.mode = Y6;
        /* falls through */
        case Y6:
          for (; t.have < t.ncode; ) {
            for (; h < 3; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            t.lens[z[t.have++]] = f & 7, f >>>= 3, h -= 3;
          }
          for (; t.have < 19; )
            t.lens[z[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, V = { bits: t.lenbits }, k = Vs(PP, t.lens, 0, 19, t.lencode, 0, t.work, V), t.lenbits = V.bits, k) {
            e.msg = "invalid code lengths set", t.mode = Zt;
            break;
          }
          t.have = 0, t.mode = K6;
        /* falls through */
        case K6:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; g = t.lencode[f & (1 << t.lenbits) - 1], O = g >>> 24, D = g >>> 16 & 255, R = g & 65535, !(O <= h); ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            if (R < 16)
              f >>>= O, h -= O, t.lens[t.have++] = R;
            else {
              if (R === 16) {
                for (U = O + 2; h < U; ) {
                  if (u === 0)
                    break e;
                  u--, f += a[l++] << h, h += 8;
                }
                if (f >>>= O, h -= O, t.have === 0) {
                  e.msg = "invalid bit length repeat", t.mode = Zt;
                  break;
                }
                L = t.lens[t.have - 1], m = 3 + (f & 3), f >>>= 2, h -= 2;
              } else if (R === 17) {
                for (U = O + 3; h < U; ) {
                  if (u === 0)
                    break e;
                  u--, f += a[l++] << h, h += 8;
                }
                f >>>= O, h -= O, L = 0, m = 3 + (f & 7), f >>>= 3, h -= 3;
              } else {
                for (U = O + 7; h < U; ) {
                  if (u === 0)
                    break e;
                  u--, f += a[l++] << h, h += 8;
                }
                f >>>= O, h -= O, L = 0, m = 11 + (f & 127), f >>>= 7, h -= 7;
              }
              if (t.have + m > t.nlen + t.ndist) {
                e.msg = "invalid bit length repeat", t.mode = Zt;
                break;
              }
              for (; m--; )
                t.lens[t.have++] = L;
            }
          }
          if (t.mode === Zt)
            break;
          if (t.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", t.mode = Zt;
            break;
          }
          if (t.lenbits = 9, V = { bits: t.lenbits }, k = Vs(yD, t.lens, 0, t.nlen, t.lencode, 0, t.work, V), t.lenbits = V.bits, k) {
            e.msg = "invalid literal/lengths set", t.mode = Zt;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, V = { bits: t.distbits }, k = Vs(ND, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, V), t.distbits = V.bits, k) {
            e.msg = "invalid distances set", t.mode = Zt;
            break;
          }
          if (t.mode = A2, r === D2)
            break e;
        /* falls through */
        case A2:
          t.mode = T2;
        /* falls through */
        case T2:
          if (u >= 6 && p >= 258) {
            e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = u, t.hold = f, t.bits = h, TP(e, E), c = e.next_out, o = e.output, p = e.avail_out, l = e.next_in, a = e.input, u = e.avail_in, f = t.hold, h = t.bits, t.mode === Di && (t.back = -1);
            break;
          }
          for (t.back = 0; g = t.lencode[f & (1 << t.lenbits) - 1], O = g >>> 24, D = g >>> 16 & 255, R = g & 65535, !(O <= h); ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if (D && (D & 240) === 0) {
            for (T = O, N = D, b = R; g = t.lencode[b + ((f & (1 << T + N) - 1) >> T)], O = g >>> 24, D = g >>> 16 & 255, R = g & 65535, !(T + O <= h); ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            f >>>= T, h -= T, t.back += T;
          }
          if (f >>>= O, h -= O, t.back += O, t.length = R, D === 0) {
            t.mode = t7;
            break;
          }
          if (D & 32) {
            t.back = -1, t.mode = Di;
            break;
          }
          if (D & 64) {
            e.msg = "invalid literal/length code", t.mode = Zt;
            break;
          }
          t.extra = D & 15, t.mode = X6;
        /* falls through */
        case X6:
          if (t.extra) {
            for (U = t.extra; h < U; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            t.length += f & (1 << t.extra) - 1, f >>>= t.extra, h -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = Q6;
        /* falls through */
        case Q6:
          for (; g = t.distcode[f & (1 << t.distbits) - 1], O = g >>> 24, D = g >>> 16 & 255, R = g & 65535, !(O <= h); ) {
            if (u === 0)
              break e;
            u--, f += a[l++] << h, h += 8;
          }
          if ((D & 240) === 0) {
            for (T = O, N = D, b = R; g = t.distcode[b + ((f & (1 << T + N) - 1) >> T)], O = g >>> 24, D = g >>> 16 & 255, R = g & 65535, !(T + O <= h); ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            f >>>= T, h -= T, t.back += T;
          }
          if (f >>>= O, h -= O, t.back += O, D & 64) {
            e.msg = "invalid distance code", t.mode = Zt;
            break;
          }
          t.offset = R, t.extra = D & 15, t.mode = J6;
        /* falls through */
        case J6:
          if (t.extra) {
            for (U = t.extra; h < U; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            t.offset += f & (1 << t.extra) - 1, f >>>= t.extra, h -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            e.msg = "invalid distance too far back", t.mode = Zt;
            break;
          }
          t.mode = e7;
        /* falls through */
        case e7:
          if (p === 0)
            break e;
          if (m = E - p, t.offset > m) {
            if (m = t.offset - m, m > t.whave && t.sane) {
              e.msg = "invalid distance too far back", t.mode = Zt;
              break;
            }
            m > t.wnext ? (m -= t.wnext, S = t.wsize - m) : S = t.wnext - m, m > t.length && (m = t.length), v = t.window;
          } else
            v = o, S = c - t.offset, m = t.length;
          m > p && (m = p), p -= m, t.length -= m;
          do
            o[c++] = v[S++];
          while (--m);
          t.length === 0 && (t.mode = T2);
          break;
        case t7:
          if (p === 0)
            break e;
          o[c++] = t.length, p--, t.mode = T2;
          break;
        case $1:
          if (t.wrap) {
            for (; h < 32; ) {
              if (u === 0)
                break e;
              u--, f |= a[l++] << h, h += 8;
            }
            if (E -= p, e.total_out += E, t.total += E, t.wrap & 4 && E && (e.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? ni(t.check, o, E, c - E) : Tp(t.check, o, E, c - E)), E = p, t.wrap & 4 && (t.flags ? f : i7(f)) !== t.check) {
              e.msg = "incorrect data check", t.mode = Zt;
              break;
            }
            f = 0, h = 0;
          }
          t.mode = r7;
        /* falls through */
        case r7:
          if (t.wrap && t.flags) {
            for (; h < 32; ) {
              if (u === 0)
                break e;
              u--, f += a[l++] << h, h += 8;
            }
            if (t.wrap & 4 && f !== (t.total & 4294967295)) {
              e.msg = "incorrect length check", t.mode = Zt;
              break;
            }
            f = 0, h = 0;
          }
          t.mode = n7;
        /* falls through */
        case n7:
          k = wP;
          break e;
        case Zt:
          k = LD;
          break e;
        case PD:
          return MD;
        case bD:
        /* falls through */
        default:
          return Bn;
      }
  return e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = u, t.hold = f, t.bits = h, (t.wsize || E !== e.avail_out && t.mode < Zt && (t.mode < $1 || r !== H6)) && FD(e, e.output, e.next_out, E - e.avail_out), C -= e.avail_in, E -= e.avail_out, e.total_in += C, e.total_out += E, t.total += E, t.wrap & 4 && E && (e.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? ni(t.check, o, E, e.next_out - E) : Tp(t.check, o, E, e.next_out - E)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Di ? 128 : 0) + (t.mode === A2 || t.mode === B1 ? 256 : 0), (C === 0 && E === 0 || r === H6) && k === Ha && (k = VP), k;
}, jP = (e) => {
  if (Ga(e))
    return Bn;
  let r = e.state;
  return r.window && (r.window = null), e.state = null, Ha;
}, zP = (e, r) => {
  if (Ga(e))
    return Bn;
  const t = e.state;
  return (t.wrap & 2) === 0 ? Bn : (t.head = r, r.done = !1, Ha);
}, qP = (e, r) => {
  const t = r.length;
  let a, o, l;
  return Ga(e) || (a = e.state, a.wrap !== 0 && a.mode !== z2) ? Bn : a.mode === z2 && (o = 1, o = Tp(o, r, t, 0), o !== a.check) ? LD : (l = FD(e, r, t, t), l ? (a.mode = PD, MD) : (a.havedict = 1, Ha));
};
var WP = HD, YP = VD, KP = wD, XP = $P, QP = kD, JP = ZP, eb = jP, tb = zP, rb = qP, nb = "pako inflate (from Nodeca project)", yi = {
  inflateReset: WP,
  inflateReset2: YP,
  inflateResetKeep: KP,
  inflateInit: XP,
  inflateInit2: QP,
  inflate: JP,
  inflateEnd: eb,
  inflateGetHeader: tb,
  inflateSetDictionary: rb,
  inflateInfo: nb
};
function ib() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var ab = ib;
const UD = Object.prototype.toString, {
  Z_NO_FLUSH: ob,
  Z_FINISH: sb,
  Z_OK: Bs,
  Z_STREAM_END: j1,
  Z_NEED_DICT: z1,
  Z_STREAM_ERROR: lb,
  Z_DATA_ERROR: o7,
  Z_MEM_ERROR: cb
} = AD;
function pc(e) {
  this.options = TD.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const r = this.options;
  r.raw && r.windowBits >= 0 && r.windowBits < 16 && (r.windowBits = -r.windowBits, r.windowBits === 0 && (r.windowBits = -15)), r.windowBits >= 0 && r.windowBits < 16 && !(e && e.windowBits) && (r.windowBits += 32), r.windowBits > 15 && r.windowBits < 48 && (r.windowBits & 15) === 0 && (r.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new DP(), this.strm.avail_out = 0;
  let t = yi.inflateInit2(
    this.strm,
    r.windowBits
  );
  if (t !== Bs)
    throw new Error(Op[t]);
  if (this.header = new ab(), yi.inflateGetHeader(this.strm, this.header), r.dictionary && (typeof r.dictionary == "string" ? r.dictionary = yp.string2buf(r.dictionary) : UD.call(r.dictionary) === "[object ArrayBuffer]" && (r.dictionary = new Uint8Array(r.dictionary)), r.raw && (t = yi.inflateSetDictionary(this.strm, r.dictionary), t !== Bs)))
    throw new Error(Op[t]);
}
pc.prototype.push = function(e, r) {
  const t = this.strm, a = this.options.chunkSize, o = this.options.dictionary;
  let l, c, u;
  if (this.ended) return !1;
  for (r === ~~r ? c = r : c = r === !0 ? sb : ob, UD.call(e) === "[object ArrayBuffer]" ? t.input = new Uint8Array(e) : t.input = e, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(a), t.next_out = 0, t.avail_out = a), l = yi.inflate(t, c), l === z1 && o && (l = yi.inflateSetDictionary(t, o), l === Bs ? l = yi.inflate(t, c) : l === o7 && (l = z1)); t.avail_in > 0 && l === j1 && t.state.wrap > 0 && e[t.next_in] !== 0; )
      yi.inflateReset(t), l = yi.inflate(t, c);
    switch (l) {
      case lb:
      case o7:
      case z1:
      case cb:
        return this.onEnd(l), this.ended = !0, !1;
    }
    if (u = t.avail_out, t.next_out && (t.avail_out === 0 || l === j1))
      if (this.options.to === "string") {
        let p = yp.utf8border(t.output, t.next_out), f = t.next_out - p, h = yp.buf2string(t.output, p);
        t.next_out = f, t.avail_out = a - f, f && t.output.set(t.output.subarray(p, p + f), 0), this.onData(h);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out));
    if (!(l === Bs && u === 0)) {
      if (l === j1)
        return l = yi.inflateEnd(this.strm), this.onEnd(l), this.ended = !0, !0;
      if (t.avail_in === 0) break;
    }
  }
  return !0;
};
pc.prototype.onData = function(e) {
  this.chunks.push(e);
};
pc.prototype.onEnd = function(e) {
  e === Bs && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = TD.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function ub(e, r) {
  const t = new pc(r);
  if (t.push(e), t.err) throw t.msg || Op[t.err];
  return t.result;
}
var fb = ub, db = {
  inflate: fb
};
const { inflate: pb } = db;
var hb = pb;
class Np {
  constructor(r) {
    var l;
    const t = new _b(r);
    this.lowLvlResponse = t, this.rawResponse = r, this.TransactionInfo = r.TransactionInfo || {}, this.status = (l = t.statusResult()) == null ? void 0 : l.Status;
    const a = t.textResult();
    a && (this.text = new jM(a.Text));
    const o = t.imagesResult();
    o && (this.images = new qM(o.Images));
  }
  authenticity(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(An.AUTHENTICITY, r);
    if (t)
      return new L6(t.AuthenticityCheckList, r);
  }
  json() {
    return JSON.stringify(this.lowLvlResponse);
  }
  authenticityPerPage() {
    return this.lowLvlResponse.resultsByType(An.AUTHENTICITY).map((r) => new L6(r.AuthenticityCheckList, r.page_idx || 0)).sort((r, t) => r.page_idx - t.page_idx);
  }
  imageQualityChecks(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(An.IMAGE_QUALITY, r);
    if (t)
      return t.ImageQualityCheckList;
  }
  imageQualityChecksPerPage() {
    return this.lowLvlResponse.resultsByType(An.IMAGE_QUALITY);
  }
  documentType(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(An.DOCUMENT_TYPE, r);
    if (t)
      return t.OneCandidate;
  }
  decodedLog() {
    const r = this.lowLvlResponse.log;
    if (r) {
      const t = gD(r), a = new Uint8Array(t);
      let o;
      try {
        const f = hb(a);
        o = f.length > a.length ? f : a;
      } catch (f) {
        o = a;
      }
      const l = o.length, c = 1e4, u = [], p = [].slice.call(o);
      for (let f = 0; f < l; f += c) {
        const h = String.fromCharCode.apply(null, p.slice(f, f + c));
        u.push(h);
      }
      return u.join("");
    }
  }
}
class _b {
  constructor(r) {
    this.ContainerList = r.ContainerList || { Count: 0, List: [] }, this.ProcessingFinished = r.ProcessingFinished || j2.NOT_FINISHED, this.TransactionInfo = r.TransactionInfo || {}, this.ChipPage = r.ChipPage, this.morePagesAvailable = r.morePagesAvailable, this.elapsedTime = r.elapsedTime, "log" in r && (this.log = r.log), "passBackObject" in r && (this.passBackObject = r.passBackObject), "metadata" in r && (this.metadata = r.metadata), "CoreLibResultCode" in r && (this.CoreLibResultCode = r.CoreLibResultCode);
  }
  statusResult() {
    return this.resultByType(An.STATUS);
  }
  textResult() {
    return this.resultByType(An.TEXT);
  }
  imagesResult() {
    return this.resultByType(An.IMAGES);
  }
  barcodeResult() {
    return this.resultByType(An.BARCODES);
  }
  documentTypeResults() {
    return this.resultsByType(An.DOCUMENT_TYPE);
  }
  resultByType(r) {
    for (const t of this.ContainerList.List)
      if (t.result_type === r)
        return t;
  }
  resultByTypeAndPage(r, t = 0) {
    for (const a of this.ContainerList.List)
      if (a.result_type === r && a.page_idx == t)
        return a;
  }
  resultsByType(r) {
    return this.ContainerList.List.filter((t) => t.result_type === r);
  }
}
class q1 {
  constructor(r = {}) {
    var t;
    this.apiKey = r.apiKey, this.username = r.username, this.password = r.password, this.accessToken = r.accessToken, this.basePath = r.basePath, this.serverIndex = r.serverIndex, this.baseOptions = go(ke({}, r.baseOptions), {
      headers: ke({}, (t = r.baseOptions) == null ? void 0 : t.headers)
    }), this.formDataCtor = r.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(r) {
    const t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (t.test(r) || r.toLowerCase() === "application/json-patch+json");
  }
}
const mb = (e) => "images" in e;
class xD {
  constructor(r, t = Dn, a = At) {
    this.healthcheckApi = new rM(new q1(r), t, a), this.processApi = new aM(new q1(r), t, a), this.transactionApi = new sM(new q1(r), t, a);
  }
  ping(r) {
    return Oe(this, null, function* () {
      return (yield this.healthcheckApi.ping(r)).data;
    });
  }
  health(r) {
    return Oe(this, null, function* () {
      return (yield this.healthcheckApi.healthz(r)).data;
    });
  }
  /**
   *
   * @summary Process list of documents images and return extracted data
   * @param {ProcessRequestExt} [request] Request options such as image, results types and etc.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError} If some request params are missed
   * */
  process(r, t, a) {
    return Oe(this, null, function* () {
      let o;
      mb(r) ? (r.processParam || (r.processParam = {
        scenario: vD.FULL_PROCESS,
        resultTypeOutput: [An.TEXT]
      }), r.systemInfo || (r.systemInfo = {}), !r.systemInfo.license && this.license && (r.systemInfo.license = this.license), o = Eb(r)) : o = r;
      const l = yield this.processApi.apiProcess(o, t, a);
      return new Np(l.data);
    });
  }
  setLicense(r) {
    typeof r == "string" ? this.license = r : this.license = Rh(r);
  }
  /**
   *
   * @summary Reprocess
   * @param {string} transactionId Transaction id
   * @param {TransactionProcessRequest} transactionProcessRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reprocessTransaction(r, t, a) {
    return this.transactionApi.apiV2TransactionTransactionIdProcessPost(
      r,
      t,
      a
    );
  }
  /**
   *
   * @summary Get Reprocess transaction result
   * @param {string} transactionId Transaction id
   * @param {boolean} [withImages] With base64 images or url
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionResult(r, t, a) {
    return Oe(this, null, function* () {
      const o = yield this.transactionApi.apiV2TransactionTransactionIdResultsGet(
        r,
        t,
        a
      );
      return new Np(o.data);
    });
  }
  /**
   *
   * @summary Get transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getTransactionsByTag(r, t) {
    return Oe(this, null, function* () {
      return this.transactionApi.apiV2TagTagIdTransactionsGet(r, t);
    });
  }
  /**
   *
   * @summary Delete Reprocess transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReprocessTransactionsByTag(r, t) {
    return Oe(this, null, function* () {
      return this.transactionApi.apiV2TagTagIdDelete(r, t);
    });
  }
  /**
   *
   * @summary Get Reprocess transaction file
   * @param {string} transactionId Transaction id
   * @param {string} name File name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionFile(r, t, a) {
    return Oe(this, null, function* () {
      return this.transactionApi.apiV2TransactionTransactionIdFileGet(r, t, a);
    });
  }
  /**
   *
   * @summary Get Reprocess transaction data
   * @param {string} transactionId Transaction id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionData(r, t) {
    return Oe(this, null, function* () {
      return this.transactionApi.apiV2TransactionTransactionIdGet(r, t);
    });
  }
}
function Eb(e) {
  const r = [];
  return e.images.forEach((t, a) => {
    if (typeof t == "string")
      r.push({ ImageData: { image: t }, light: Ap.WHITE, page_idx: a });
    else if (t instanceof ArrayBuffer) {
      const o = Rh(t);
      r.push({ ImageData: { image: o }, light: Ap.WHITE, page_idx: a });
    } else
      r.push(Cb(t, a));
  }), go(ke({}, e), {
    List: r
  });
}
function Cb(e, r) {
  let t;
  return typeof e.ImageData == "string" ? t = e.ImageData : t = Rh(e.ImageData), {
    ImageData: { image: t },
    light: e.light,
    page_idx: typeof e.page_idx > "u" ? r : e.page_idx
  };
}
function Rh(e) {
  return zM(e);
}
function BD(e) {
  return Oe(this, null, function* () {
    const t = Array.from(e).map((a) => Oe(null, null, function* () {
      if (!a || !a.size) throw new $t(rr.INCORRECT_FILE);
      const o = URL.createObjectURL(a), c = yield ((u) => new Promise((p, f) => {
        const h = new Image();
        h.onload = () => {
          p(h), URL.revokeObjectURL(o);
        }, h.onerror = () => {
          f(new $t(rr.INCORRECT_FILE)), URL.revokeObjectURL(o);
        }, h.src = u;
      }))(o);
      if (c.width * c.height > KO)
        throw new $t(rr.INCORRECT_FILE);
      return {
        width: c.width,
        height: c.height,
        data: yield a.arrayBuffer()
      };
    }));
    return Promise.all(t);
  });
}
function Sb(e, r) {
  var t;
  const a = {
    glareCheck: Mi.WAS_NOT_DONE,
    resolutionCheck: Mi.WAS_NOT_DONE,
    focusCheck: Mi.WAS_NOT_DONE,
    isDocumentAvailable: !1
  };
  return (t = e.ContainerList) === null || t === void 0 || t.List.forEach((o) => {
    o.page_idx === r && ("ImageQualityCheckList" in o && o.ImageQualityCheckList.List.forEach((l) => {
      l.result !== void 0 && (l.type === V2.ImageFocus && (a.focusCheck = l.result), l.type === V2.ImageGlares && (a.glareCheck = l.result), l.type === V2.ImageResolution && (a.resolutionCheck = l.result));
    }), "DocumentPosition" in o && (a.isDocumentAvailable = !0));
  }), a;
}
function $D(e, r) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const {
    glareCheck: a,
    resolutionCheck: o,
    focusCheck: l,
    isDocumentAvailable: c
  } = Sb(e, r), u = !t || t && e.morePagesAvailable === 0;
  return e.ProcessingFinished === j2.FINISHED ? u ? it.SUCCESS : it.START_NEXT_PAGE : e.ProcessingFinished === j2.TIMEOUT ? it.TIMEOUT : c ? l === Mi.ERROR ? it.FOCUS : a === Mi.ERROR ? it.GLARE : o === Mi.ERROR ? it.RESOLUTION : it.HOLD : it.FINDING;
}
function Ib(e, r) {
  return e.replace(/https:\/\/wasm\.regulaforensics\.com\/document\/\w+\/\d+\.\d+\/\w+\/[a-f0-9-]+/, r);
}
function vb(e, r) {
  var t, a;
  const o = {
    [P2.BarcodeMRZ]: {
      PROD: "https://wasm.regulaforensics.com/document/release/8.3/barcodemrz/f526ea12-07843559c",
      DEV: "./wasm/barcode-mrz/"
    },
    [P2.BoundsLite]: {
      PROD: "https://wasm.regulaforensics.com/document/release/8.3/boundslite/f526ea12-07843559c",
      DEV: "./wasm/bounds-lite/"
    }
  };
  return (t = (a = o[e]) === null || a === void 0 ? void 0 : a[r]) !== null && t !== void 0 ? t : o[P2.BarcodeMRZ][r];
}
function s7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function l7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? s7(Object(t), !0).forEach(function(a) {
      gb(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : s7(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function gb(e, r, t) {
  return (r = Rb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Rb(e) {
  var r = Db(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Db(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const c7 = Gr.create("main");
function GD(e) {
  let {
    scenario: r,
    onError: t
  } = e;
  const {
    onEvent: a
  } = ur(), o = window.RegulaDocumentSDK, [l, c] = oe.useState({
    initialized: !1,
    initData: o.initData
  });
  return oe.useEffect(() => {
    if (!(!l.initData || l.initialized || !r))
      if (l.initData.license.errorCode === 0 && l.initData.license.status) {
        const u = l.initData.scenario.filter((f) => f.name !== ry);
        u.some((f) => f.name === r) ? (c({
          initialized: !0,
          initData: {
            scenario: u,
            license: l.initData.license
          }
        }), a({
          action: pt.SERVICE_INITIALIZED,
          data: null
        })) : (t(new $t(rr.INCORRECT_SCENARIO)), c7("Incorrect scenario: ".concat(r)));
      } else
        t(new $t(rr.WASM_LICENSE, l.initData.license.message)), c7("Problems with initialization.");
  }, [l, r]), oe.useEffect(() => {
    !o || o.isInitialized || o.initData || (o.initializeListener = (u) => {
      let {
        isInitialized: p
      } = u;
      !p || !o.initData || c((f) => l7(l7({}, f), {}, {
        initData: o.initData
      }));
    });
  }, [o]), l;
}
function Ab(e, r) {
  const [t, a] = oe.useState(e), [o, l] = oe.useState(!1);
  return oe.useEffect(() => {
    o || a(e);
  }, [o, e]), oe.useEffect(() => {
    l(!0);
    const c = setTimeout(() => {
      l(!1);
    }, r);
    return () => {
      clearTimeout(c);
    };
  }, [t]), t;
}
const W1 = Gr.create("main"), Tb = 5;
function Ob(e) {
  const [r, t] = oe.useState(!1), a = oe.useRef({
    x: 0,
    y: 0,
    z: 0
  }), o = Ab(r, 1e3), l = (c) => {
    var u, p;
    if (!((u = c.acceleration) !== null && u !== void 0 && u.x) || !((p = c.acceleration) !== null && p !== void 0 && p.y) || !c.acceleration.z) return;
    const f = Math.abs(c.acceleration.x - a.current.x) + Math.abs(c.acceleration.y - a.current.y) + Math.abs(c.acceleration.z - a.current.z);
    t(f > Tb), a.current.x = c.acceleration.x, a.current.y = c.acceleration.y, a.current.z = c.acceleration.z;
  };
  return oe.useEffect(() => {
    if (!e) return;
    const c = DeviceOrientationEvent.requestPermission;
    if (typeof c == "function")
      c().then((u) => {
        u === "granted" ? window.addEventListener("devicemotion", l) : W1("Device orientation service permission denied");
      }).catch((u) => "Device orientation service error: ".concat(u));
    else if ("permissions" in navigator)
      navigator.permissions.query({
        name: "accelerometer"
      }).then((u) => {
        u.state === "granted" ? window.addEventListener("devicemotion", l) : W1("Device orientation service permission denied");
      }).catch((u) => "Device orientation service error: ".concat(u));
    else
      return W1("Device orientation service is missing");
    return () => {
      window.removeEventListener("devicemotion", l);
    };
  }, []), {
    isShake: o
  };
}
function u7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function In(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? u7(Object(t), !0).forEach(function(a) {
      yb(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : u7(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function yb(e, r, t) {
  return (r = Nb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Nb(e) {
  var r = Lb(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Lb(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const Qi = Gr.create("main");
function Mb(e) {
  let {
    videoElementParams: r,
    videoStatusParams: t,
    mirroring: a,
    onError: o,
    controlsWidth: l,
    captureMode: c
  } = e;
  const u = window.RegulaDocumentSDK, {
    onEvent: p,
    multipageProcessing: f,
    internalScenario: h,
    videoCaptureMotionControl: C,
    nextPageAnimationStartDelay: E = CR,
    nextPageAnimationEndDelay: m = ny
  } = ur(), {
    isShake: S
  } = Ob(C), v = oe.useRef(!1), [g, O] = oe.useState(!1), [D, R] = oe.useState(!1), [T, N] = oe.useState(!1), [b, L] = oe.useState(0), [k, w] = oe.useState(void 0), [V, U] = oe.useState([lr.DocumentFront, lr.DocumentBack]), [z, q] = oe.useState(null), [W, te] = oe.useState(void 0), [se, le] = oe.useState({
    status: it.SERVICE_PREPARING,
    response: null
  }), {
    initData: B,
    initialized: J
  } = GD({
    scenario: k,
    onError: o
  }), Q = RN({
    videoSize: r.videoParams,
    mirroring: a,
    controlsWidth: l,
    scenario: k,
    scenarioParams: B == null ? void 0 : B.scenario
  }), P = c === ra.captureFrame, $ = se.status === it.START_NEXT_PAGE;
  return oe.useEffect(() => {
    if (u) {
      if (u.recognizerProcessParam = $r(oy, u.recognizerProcessParam), f !== void 0) {
        const ce = {
          processParam: {
            multipageProcessing: f
          }
        };
        u.recognizerProcessParam = $r(u.recognizerProcessParam, ce);
      }
      if (h !== void 0) {
        const ce = {
          processParam: {
            scenario: h
          }
        };
        u.recognizerProcessParam = $r(u.recognizerProcessParam, ce);
      }
      Qi("Current scenario: ".concat(u.recognizerProcessParam.processParam.scenario)), w(u.recognizerProcessParam.processParam.scenario);
    }
  }, [u, h, f]), oe.useEffect(() => {
    const {
      frameTop: ce,
      frameBottom: ue,
      frameLeft: ie,
      frameRight: Re
    } = Q || {};
    Qi("Frame params: ".concat(JSON.stringify(Q))), u.recognizerProcessParam = $r(u.recognizerProcessParam, {
      imageInputParam: {
        frameTop: ce,
        frameBottom: ue,
        frameLeft: ie,
        frameRight: Re,
        light: W,
        resolutionType: 0
      }
    });
  }, [Q, W]), oe.useEffect(() => {
    var ce;
    if (!u || !J || D || P || t.videoStatus !== Ft.PLAY || !t.sortedDevices) return;
    const ue = $R([...t.sortedDevices.frontCameras, ...t.sortedDevices.backCameras], t.camera.deviceId, "8.3.2456".trim(), ((ce = u.recognizerProcessParam.processParam.backendProcessing) === null || ce === void 0 ? void 0 : ce.serviceURL) || "");
    Qi("Metadata: ".concat(JSON.stringify(ue))), (u.recognizerProcessParam.processParam.backendProcessing ? u.createBackendTransaction(ue) : u.startNewDocument(ue)).then(() => {
      R(!0), Qi("New document started");
    }).catch((Re) => {
      le((Ae) => In(In({}, Ae), {}, {
        status: it.FAILED
      })), o(new $t(rr.WASM_ERROR, Re));
    });
  }, [J, D, c, t]), oe.useEffect(() => {
    const ce = D && (!c || c === ra.auto), ue = D && c === ra.captureVideo, ie = J && c === ra.captureFrame;
    ce && O(!0), (ie || ue) && le((Re) => In(In({}, Re), {}, {
      status: it.FINDING
    }));
  }, [D, c, J]), oe.useEffect(() => {
    const ce = t.videoStatus === Ft.PLAY;
    if (!u || !ce || T || !g || !r.videoElement) return;
    if (v.current || (p({
      action: pt.CAMERA_PROCESS_STARTED,
      data: null
    }), v.current = !0), S)
      return le((ie) => In(In({}, ie), {}, {
        status: it.SHAKING
      }));
    N(!0);
    const {
      imageData: ue
    } = oc(r.videoElement, ba.UINT);
    Qi("Image processing started"), u.process(ue).then((ie) => {
      const Re = $D(ie.rawResponse, b, u.recognizerProcessParam.processParam.multipageProcessing);
      le((Ce) => In(In({}, Ce), {}, {
        status: Re,
        response: ie
      })), N(!1), Qi("Image processing is finished");
      const Ae = !!ch[Re];
      if (Re === it.START_NEXT_PAGE || Ae) {
        const {
          multipageAnimationImage: Ce
        } = ie.rawResponse;
        Ce && U(Ce), O(!1);
      }
      if ("lightType" in ie.rawResponse) {
        const {
          lightType: Ce
        } = ie.rawResponse;
        te(G2(Ce));
      } else
        te(void 0);
      if ("hologramTiltType" in ie.rawResponse) {
        const {
          hologramTiltType: Ce,
          livenessAnimationImage: Le
        } = ie.rawResponse;
        q({
          hologramTiltType: Ce,
          livenessAnimationImage: Le
        });
      } else
        q(null);
    }).catch((ie) => {
      le({
        response: null,
        status: it.FAILED
      }), o(new $t(rr.WASM_ERROR, ie)), O(!1);
    });
  }, [T, r.videoElement, t.videoStatus, b, g, S]), oe.useEffect(() => {
    if (!u || !$) return;
    Qi("More pages available"), p({
      action: pt.NEW_PAGE_AVAILABLE,
      data: null
    });
    const ce = setTimeout(() => Oe(null, null, function* () {
      try {
        yield u.startNewPage(), p({
          action: pt.NEW_PAGE_STARTED,
          data: null
        }), O(!0), L((ue) => ue + YO), Qi("New page started");
      } catch (ue) {
        le((ie) => In(In({}, ie), {}, {
          status: it.FAILED
        })), o(new $t(rr.WASM_ERROR, ue));
      }
    }), E + ER + m);
    return () => {
      clearTimeout(ce);
    };
  }, [$]), In(In({}, se), {}, {
    frameParams: Q,
    setIsRecognitionStarted: O,
    animationImage: V,
    holoData: z
  });
}
const Os = Gr.create("main");
function Pb() {
  var e, r, t;
  const {
    mobileDelegate: a
  } = ur(), [o, l] = oe.useState(Ni.CHECKING), c = window.RegulaDocumentSDK, u = ((e = c.recognizerProcessParam) === null || e === void 0 ? void 0 : e.tag) || "", p = ((r = c.recognizerProcessParam.processParam.backendProcessing) === null || r === void 0 ? void 0 : r.serviceURL) || "", f = ((t = c.recognizerProcessParam.processParam.backendProcessing) === null || t === void 0 ? void 0 : t.httpHeaders) || {};
  return oe.useEffect(() => {
    if (!a)
      return Os("Transaction check is disabled"), l(Ni.NOT_AVAILABLE);
    Os("Transaction check parameters: ".concat(JSON.stringify({
      tag: u,
      basePath: p,
      headers: f
    }))), Oe(null, null, function* () {
      try {
        var C;
        const E = new xD({
          basePath: p,
          baseOptions: {
            headers: f
          }
        }), {
          data: m
        } = yield E.getTransactionsByTag(u, {
          headers: f
        });
        Os("Transaction check data: ".concat(JSON.stringify(m)));
        const S = (C = m.items) !== null && C !== void 0 && C.some((v) => v.state === x2.PROCESSED) ? Ni.AVAILABLE : Ni.NOT_AVAILABLE;
        Os("Transaction check status: ".concat(S)), l(S);
      } catch (E) {
        Os("Transaction check status: ERROR. Details: ".concat(E)), l(Ni.ERROR);
      }
    });
  }, [a]), o;
}
const bb = ["data"];
function wb(e, r) {
  if (e == null) return {};
  var t, a, o = Hb(e, r);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (a = 0; a < l.length; a++) t = l[a], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Hb(e, r) {
  if (e == null) return {};
  var t = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (r.indexOf(a) !== -1) continue;
    t[a] = e[a];
  }
  return t;
}
function Vb(e) {
  let {
    onStatusChange: r,
    onFileImageSet: t,
    onError: a,
    onClose: o
  } = e;
  const {
    onEvent: l,
    cameraId: c,
    startScreen: u,
    captureButton: p,
    captureMode: f,
    resolution: h,
    cameraMode: C,
    videoRecord: E,
    mirrorType: m,
    mobileDelegate: S,
    finalizeOnTimeout: v = !0
  } = ur(), g = window.RegulaDocumentSDK, O = oe.useMemo(() => ({
    width: (h == null ? void 0 : h.width) || ui.FULL_HD.width,
    height: (h == null ? void 0 : h.height) || ui.FULL_HD.height
  }), [h]), D = oe.useRef(!0), R = oe.useRef(null), T = oe.useRef(null), [N, b] = oe.useState(!1), [L, k] = oe.useState(0), [w, V] = oe.useState({
    videoElement: null,
    videoParams: {
      width: 0,
      height: 0
    },
    videoContainerParams: {
      width: 0,
      height: 0
    }
  }), [U, z] = oe.useState({
    videoStatus: Ft.PREPARING,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    },
    sortedDevices: null
  }), [q, W] = oe.useState(c), {
    status: te,
    response: se,
    frameParams: le,
    setIsRecognitionStarted: B,
    animationImage: J,
    holoData: Q
  } = Mb({
    videoElementParams: w,
    videoStatusParams: U,
    mirroring: N,
    onError: a,
    captureMode: f,
    controlsWidth: L
  }), P = Pb(), [$, ce] = oe.useState(null), ue = (lt, Ct, yt) => Oe(null, null, function* () {
    r(Ne.PROCESSING);
    const {
      backendProcessing: St
    } = g.recognizerProcessParam.processParam, st = {
      status: lt,
      response: yt
    };
    if (E && $) {
      const ze = yield $.getRecord();
      if (!ze) return;
      if (st.video = ze, St) {
        const {
          data: ht
        } = ze, me = wb(ze, bb), ye = yield ht.arrayBuffer(), xe = new Uint8ClampedArray(ye);
        yield g.addDataToPackage(xe, {
          sizeBytes: ht.size,
          dataName: "processingVideo",
          metadata: me
        });
      }
    }
    if (St)
      if (Ct === Ne.TIMEOUT && !v) {
        r(S ? Ne.DELEGATE_SUCCESS : Ct), l({
          action: pt.PROCESS_FINISHED,
          data: st
        });
        return;
      } else
        g.onFinalize = (ze) => {
          if (!ze.transactionId) return r(Ne.FAILED);
          r(S ? Ne.DELEGATE_SUCCESS : Ne.SUCCESS);
        };
    l({
      action: pt.PROCESS_FINISHED,
      data: st
    }), r(St ? Ne.PROCESSING : Ct);
  }), ie = () => {
    var lt;
    l({
      action: pt.PRESS_MIRRORING_BUTTON,
      data: null
    }), (lt = R.current) === null || lt === void 0 || lt.changeMirror();
  }, Re = oe.useCallback(() => {
    l({
      action: pt.CAMERA_PROCESS_CLOSED,
      data: null
    }), u && r(Ne.CHOOSE_INPUT_SOURCE);
  }, [u]), Ae = () => Oe(null, null, function* () {
    l({
      action: pt.PRESS_SKIP_BUTTON,
      data: null
    }), T.current && (yield ue(Li.OK, Ne.SUCCESS, T.current));
  }), Ce = oe.useCallback(() => {
    if (l({
      action: pt.PRESS_CHANGE_CAMERA_BUTTON,
      data: null
    }), !U.sortedDevices) return;
    const lt = ph(U.sortedDevices, U.camera.deviceId);
    lt && W(lt);
  }, [U.camera.deviceId, U.sortedDevices]), Le = oe.useCallback(() => {
    if (l({
      action: pt.PRESS_CAPTURE_BUTTON,
      data: null
    }), f === ra.captureVideo && D.current)
      D.current = !1, B(!0);
    else {
      if (!w.videoElement) return;
      B(!1);
      const {
        imageData: lt
      } = oc(w.videoElement, ba.UINT);
      t(lt);
    }
  }, [w.videoElement, f]), Ze = (lt) => {
    a(new $t(lt));
  }, at = p || p === void 0 || f === ra.captureFrame || f === ra.captureVideo;
  oe.useEffect(() => {
    if (se) {
      if (te === it.START_NEXT_PAGE && (T.current = se), te === it.SUCCESS) {
        const lt = S ? Ne.DELEGATE_SUCCESS : Ne.SUCCESS;
        ue(Li.OK, lt, se);
      }
      if (te === it.TIMEOUT) {
        const lt = S ? Ne.DELEGATE_SUCCESS : Ne.TIMEOUT;
        ue(Li.TIMEOUT, lt, se);
      }
    }
  }, [te, se, S]), oe.useEffect(() => {
    P === Ni.AVAILABLE && r(Ne.DELEGATE_SUCCESS), P === Ni.ERROR && a(new $t(rr.CONNECTION_ERROR, "Transaction check failed."));
  }, [P]);
  const ot = () => {
    l({
      action: pt.VIDEO_STARTED,
      data: null
    });
  }, ct = () => {
    l({
      action: pt.VIDEO_STOPPED,
      data: null
    });
  };
  return oe.useMemo(() => /* @__PURE__ */ Y.jsx(WR, { mirroring: N, onChangeMirroring: ie, status: te, videoStatusParams: U, frameParams: le, videoElementParams: w, onProcessClose: Re, onClose: o, onSnapshotProcess: Le, onSkip: Ae, onChangeCamera: Ce, captureButton: at, animationImage: J, holoData: Q, onControlsWidth: k, children: P === Ni.NOT_AVAILABLE ? /* @__PURE__ */ Y.jsx(GR, { onVideoSizeChange: V, onVideoStatusChange: z, resolution: O, onFailStatus: Ze, mode: C || fn.environment, cameraId: q, onRecordService: ce, videoRecord: E, onVideoStarted: ot, onVideoStopped: ct, onMirroringChange: b, mirrorType: m, ref: R }) : null }), [q, N, Le, te, U, le, Re, Ce, w, at, O, C, E, J, P, Q]);
}
const kb = "_title_1fk4r_28", Fb = "_subtitle_1fk4r_37", ys = {
  "info-message": "_info-message_1fk4r_1",
  "text-container": "_text-container_1fk4r_10",
  title: kb,
  subtitle: Fb,
  "retry-button": "_retry-button_1fk4r_46"
}, Ub = "_button_7h3jm_1", xb = {
  button: Ub
};
function F2(e) {
  let {
    children: r,
    className: t,
    part: a,
    onClick: o,
    e2e: l
  } = e;
  return /* @__PURE__ */ Y.jsx("button", { part: a, className: "".concat(xb.button, " ").concat(t != null ? t : ""), "data-e2e": l, onClick: o, children: r });
}
function tr(e) {
  let {
    title: r,
    subtitle: t,
    className: a,
    onReset: o
  } = e;
  const {
    translate: l
  } = oa.useLocalize();
  return /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
    /* @__PURE__ */ Y.jsx(Us, { text: r }),
    /* @__PURE__ */ Y.jsx("div", { part: "info-container", className: ys["info-message"], children: /* @__PURE__ */ Y.jsxs("div", { part: "info-text-container", className: "".concat(ys["text-container"], " ").concat(a != null ? a : ""), children: [
      /* @__PURE__ */ Y.jsx("p", { part: "info-title", "data-e2e": "info-msg-title", className: ys.title, children: r }),
      t && /* @__PURE__ */ Y.jsx("p", { part: "info-subtitle", "data-e2e": "info-msg-subtitle", className: ys.subtitle, children: t }),
      o && /* @__PURE__ */ Y.jsx(F2, { part: "info-try-again-button", className: ys["retry-button"], onClick: o, children: l("tryAgain") })
    ] }) })
  ] });
}
const Bb = "_text_1ywb7_11", $b = "_title_1ywb7_19", Gb = "_subtitle_1ywb7_28", Zb = "_buttons_1ywb7_38", Ji = {
  "start-window": "_start-window_1ywb7_1",
  text: Bb,
  title: $b,
  subtitle: Gb,
  buttons: Zb,
  "camera-button": "_camera-button_1ywb7_46",
  "gallery-button": "_gallery-button_1ywb7_50",
  "phone-button": "_phone-button_1ywb7_54"
};
function ZD(e) {
  let {
    onStart: r,
    onFileImageSet: t,
    title: a,
    subtitle: o,
    allowRemote: l = !1,
    onRemoteDevice: c
  } = e;
  const {
    onEvent: u,
    multipleFileInput: p = !0,
    fromCameraButton: f = !0,
    uploadFileButton: h = !0
  } = ur(), C = oe.useRef(null), {
    translate: E
  } = oa.useLocalize(), m = () => {
    const g = C.current;
    g && (u({
      action: pt.PRESS_FILE_BUTTON,
      data: null
    }), g.click());
  }, S = (g) => {
    var O;
    (O = g.target.files) !== null && O !== void 0 && O.length && t(g.target.files);
  }, v = () => {
    u({
      action: pt.PRESS_REMOTE_DEVICE_BUTTON,
      data: null
    }), c == null || c();
  };
  return /* @__PURE__ */ Y.jsxs("div", { part: "menu-container", className: Ji["start-window"], children: [
    /* @__PURE__ */ Y.jsxs("div", { "aria-live": "polite", part: "menu-text-container", className: Ji.text, children: [
      /* @__PURE__ */ Y.jsx("h1", { part: "menu-title", className: Ji.title, children: a }),
      /* @__PURE__ */ Y.jsx("p", { part: "menu-subtitle", className: Ji.subtitle, children: o })
    ] }),
    /* @__PURE__ */ Y.jsxs("div", { part: "menu-buttons-container", className: Ji.buttons, children: [
      f && /* @__PURE__ */ Y.jsx(F2, { part: "menu-from-camera-button", e2e: "from-camera", className: Ji["camera-button"], onClick: r, children: E("camera") }),
      h && /* @__PURE__ */ Y.jsx(F2, { part: "menu-from-gallery-button", e2e: "from-gallery", className: Ji["gallery-button"], onClick: m, children: E(Kt.isMobile ? "gallery" : "files") }),
      l && c && /* @__PURE__ */ Y.jsx(F2, { part: "menu-from-mobile-button", e2e: "from-other-phone", className: Ji["phone-button"], onClick: v, children: E("mobileDevice") })
    ] }),
    /* @__PURE__ */ Y.jsx("input", { ref: C, style: {
      display: "none"
    }, type: "file", multiple: p, accept: uy.join(","), onChange: S })
  ] });
}
var f7 = {}, d7;
function jb() {
  if (d7) return f7;
  d7 = 1;
  var e = zt(), r = Qs(), t = Qr(), a = ar(), o = Ba(), l = Zn(), c = $a(), u = rc(), p = vt(), f = TypeError, h = p(function() {
    [].keys().reduce(function() {
    }, void 0);
  }), C = !h && c("reduce", f);
  return e({ target: "Iterator", proto: !0, real: !0, forced: h || C }, {
    reduce: function(m) {
      a(this);
      try {
        t(m);
      } catch (D) {
        l(this, "throw", D);
      }
      var S = arguments.length < 2, v = S ? void 0 : arguments[1];
      if (C)
        return u(C, this, S ? [m] : [m, v]);
      var g = o(this), O = 0;
      if (r(g, function(D) {
        S ? (S = !1, v = D) : v = m(v, D, O), O++;
      }, { IS_RECORD: !0 }), S) throw new f("Reduce of empty iterator with no initial value");
      return v;
    }
  }), f7;
}
jb();
function p7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function h7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? p7(Object(t), !0).forEach(function(a) {
      zb(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : p7(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function zb(e, r, t) {
  return (r = qb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function qb(e) {
  var r = Wb(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Wb(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const _7 = Gr.create("main");
function Yb(e) {
  let {
    imageDataArray: r,
    onEvent: t,
    onError: a,
    isRecognizerProcessParam: o
  } = e;
  const l = window.RegulaDocumentSDK, {
    internalScenario: c
  } = ur(), [u, p] = oe.useState(void 0), [f, h] = oe.useState({
    status: it.SERVICE_PREPARING,
    response: null
  }), {
    initialized: C
  } = GD({
    scenario: u,
    onError: a
  });
  return oe.useEffect(() => {
    if (l) {
      if (l.imageProcessParam = $r(sy, l.imageProcessParam), c !== void 0) {
        const E = {
          processParam: {
            scenario: c
          }
        };
        l.imageProcessParam = $r(l.imageProcessParam, E);
      }
      p(o ? l.recognizerProcessParam.processParam.scenario : l.imageProcessParam.processParam.scenario);
    }
  }, [l, c, o]), oe.useEffect(() => {
    const E = !!ch[f.status];
    if (!l || !C || !r.length || E) return;
    t({
      action: pt.FILE_PROCESS_STARTED,
      data: null
    });
    const m = o ? l.recognizerProcessParam : l.imageProcessParam;
    l.processingListener = (S) => Oe(null, null, function* () {
      let {
        isProcessing: v
      } = S;
      if (!v) {
        l.processingListener = null, _7("Image processing started");
        try {
          var g;
          if ((g = l.imageProcessParam.processParam) !== null && g !== void 0 && g.backendProcessing) {
            var O;
            const R = $R([], "", "8.3.2456".trim(), ((O = l.recognizerProcessParam.processParam) === null || O === void 0 || (O = O.backendProcessing) === null || O === void 0 ? void 0 : O.serviceURL) || "");
            yield l.createBackendTransaction(R, l.imageProcessParam);
          }
          const D = yield l.processImage(r, m);
          h((R) => h7(h7({}, R), {}, {
            status: it.SUCCESS,
            response: D
          })), _7("Image processing is finished");
        } catch (D) {
          h({
            response: null,
            status: it.FAILED
          }), a(new $t(rr.WASM_ERROR, D));
        }
      }
    });
  }, [C, f.status, r, o]), f;
}
function Kb(e) {
  let {
    onStatusChange: r,
    images: t,
    onError: a
  } = e;
  const o = window.RegulaDocumentSDK, l = oe.useRef(!1), {
    onEvent: c,
    mobileDelegate: u,
    maxImageSize: p,
    maxResolutionSize: f
  } = ur(), [h, C] = oe.useState(!1), [E, m] = oe.useState([]), {
    status: S,
    response: v
  } = Yb({
    imageDataArray: E,
    onEvent: c,
    onError: a,
    isRecognizerProcessParam: h
  });
  return oe.useEffect(() => {
    if (!(!t || l.current)) {
      if (l.current = !0, !(t instanceof FileList))
        return C(!0), m(t);
      BD(t).then((g) => {
        const {
          resolution: O,
          bytes: D
        } = g.reduce((N, b) => (N.resolution += b.width * b.height, N.bytes += b.data.byteLength, N), {
          resolution: 0,
          bytes: 0
        }), R = p && D / 1024 > p;
        if (O > (f || mR) || R)
          a(new $t(rr.FILE_SIZE));
        else {
          const N = g.map((b) => {
            let {
              data: L
            } = b;
            return L;
          });
          m(N);
        }
      }).catch((g) => {
        a(g);
      }).then(() => {
        l.current = !1;
      });
    }
  }, [t, p, f]), oe.useEffect(() => {
    if (S === it.SUCCESS && v) {
      const O = o.recognizerProcessParam.processParam.backendProcessing && h;
      O && (o.onFinalize = () => r(u ? Ne.DELEGATE_SUCCESS : Ne.SUCCESS)), c({
        action: pt.PROCESS_FINISHED,
        data: {
          status: Li.OK,
          response: v
        }
      }), r(O ? Ne.PROCESSING : Ne.SUCCESS);
    }
  }, [S, v, h, o, u]), /* @__PURE__ */ Y.jsx(Js, {});
}
function Xb() {
  if (typeof document == "undefined") return null;
  const e = document.documentElement;
  return e && typeof e.getAttribute == "function" ? e.getAttribute("lang") : null;
}
function Qb() {
  return typeof navigator != "undefined" ? window.navigator.language : null;
}
function jD(e) {
  function r(t) {
    const {
      locale: a,
      translations: o,
      dictionaries: l
    } = t;
    let c = l;
    if (o)
      for (const h in o)
        if (Object.prototype.hasOwnProperty.call(l, h))
          c = $r(c, {
            [h]: o[h]
          });
        else {
          const C = $r(l.en, o[h]);
          c = $r(c, {
            [h]: C
          });
        }
    let u = fy;
    const p = [a, Xb(), Qb()];
    for (const h of p) {
      if (!h) continue;
      const C = h.substring(0, 2).toLowerCase();
      if (Object.prototype.hasOwnProperty.call(c, C)) {
        u = C;
        break;
      }
    }
    const f = dy.includes(u) ? fp.Rtl : fp.Ltr;
    return /* @__PURE__ */ Y.jsx(oa.LocalizationProvider, { disableCache: !0, locale: u, translations: c, children: /* @__PURE__ */ Y.jsx(e, go(ke({}, t), { direction: f })) });
  }
  return r;
}
function zD(e) {
  function r(t) {
    return /* @__PURE__ */ Y.jsx(ZR.Provider, { value: t, children: /* @__PURE__ */ Y.jsx(e, ke({}, t)) });
  }
  return r;
}
function m7(e, r, t) {
  return (r = Jb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Jb(e) {
  var r = ew(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function ew(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class qD extends oe.Component {
  constructor(r) {
    super(r), m7(this, "onError", void 0), m7(this, "supportedBrowserVersions", void 0), this.supportedBrowserVersions = r.supportedBrowserVersions, this.onError = r.onError;
  }
  componentDidCatch(r) {
    this.onError(new $t("UNKNOWN_ERROR", r));
  }
  componentDidMount() {
    if (this.supportedBrowserVersions) {
      let r = null;
      if (Kt.isMobile && Kt.osName in this.supportedBrowserVersions && (r = this.supportedBrowserVersions[Kt.osName]), Kt.isDesktop && (r = this.supportedBrowserVersions.desktop), r && Kt.browserName in r) {
        const t = r[Kt.browserName];
        t !== void 0 && Number(Kt.browserVersion) < t && this.onError(new $t("NOT_SUPPORTED"));
      }
    }
  }
  render() {
    return this.props.children;
  }
}
function tw() {
  const e = () => window.matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait", [r, t] = oe.useState(() => {
    const o = e();
    return {
      isPortrait: o === "portrait",
      isLandscape: o === "landscape",
      orientation: o
    };
  }), a = oe.useCallback(() => {
    const o = e();
    t((l) => l.orientation !== o ? {
      isPortrait: o === "portrait",
      isLandscape: o === "landscape",
      orientation: o
    } : l);
  }, []);
  return oe.useEffect(() => (typeof window != "undefined" && (a(), window.addEventListener("load", a, !1), window.addEventListener("resize", a, !1)), () => {
    window.removeEventListener("load", a, !1), window.removeEventListener("resize", a, !1);
  }), [a]), r;
}
const rw = "_text_18b5u_19", nw = "_title_18b5u_27", iw = "_subtitle_18b5u_36", aw = "_divider_18b5u_52", ow = "_button_18b5u_71", ea = {
  "remote-scanner-wrapper": "_remote-scanner-wrapper_18b5u_1",
  "qr-container": "_qr-container_18b5u_11",
  text: rw,
  title: nw,
  subtitle: iw,
  "content-container": "_content-container_18b5u_46",
  divider: aw,
  button: ow
};
var sw = Object.defineProperty, q2 = Object.getOwnPropertySymbols, WD = Object.prototype.hasOwnProperty, YD = Object.prototype.propertyIsEnumerable, E7 = (e, r, t) => r in e ? sw(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Lp = (e, r) => {
  for (var t in r || (r = {}))
    WD.call(r, t) && E7(e, t, r[t]);
  if (q2)
    for (var t of q2(r))
      YD.call(r, t) && E7(e, t, r[t]);
  return e;
}, Mp = (e, r) => {
  var t = {};
  for (var a in e)
    WD.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && q2)
    for (var a of q2(e))
      r.indexOf(a) < 0 && YD.call(e, a) && (t[a] = e[a]);
  return t;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var Va;
((e) => {
  const r = class mt {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(p, f, h, C) {
      if (this.version = p, this.errorCorrectionLevel = f, this.modules = [], this.isFunction = [], p < mt.MIN_VERSION || p > mt.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (C < -1 || C > 7)
        throw new RangeError("Mask value out of range");
      this.size = p * 4 + 17;
      let E = [];
      for (let S = 0; S < this.size; S++)
        E.push(!1);
      for (let S = 0; S < this.size; S++)
        this.modules.push(E.slice()), this.isFunction.push(E.slice());
      this.drawFunctionPatterns();
      const m = this.addEccAndInterleave(h);
      if (this.drawCodewords(m), C == -1) {
        let S = 1e9;
        for (let v = 0; v < 8; v++) {
          this.applyMask(v), this.drawFormatBits(v);
          const g = this.getPenaltyScore();
          g < S && (C = v, S = g), this.applyMask(v);
        }
      }
      o(0 <= C && C <= 7), this.mask = C, this.applyMask(C), this.drawFormatBits(C), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(p, f) {
      const h = e.QrSegment.makeSegments(p);
      return mt.encodeSegments(h, f);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(p, f) {
      const h = e.QrSegment.makeBytes(p);
      return mt.encodeSegments([h], f);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(p, f, h = 1, C = 40, E = -1, m = !0) {
      if (!(mt.MIN_VERSION <= h && h <= C && C <= mt.MAX_VERSION) || E < -1 || E > 7)
        throw new RangeError("Invalid value");
      let S, v;
      for (S = h; ; S++) {
        const R = mt.getNumDataCodewords(S, f) * 8, T = c.getTotalBits(p, S);
        if (T <= R) {
          v = T;
          break;
        }
        if (S >= C)
          throw new RangeError("Data too long");
      }
      for (const R of [mt.Ecc.MEDIUM, mt.Ecc.QUARTILE, mt.Ecc.HIGH])
        m && v <= mt.getNumDataCodewords(S, R) * 8 && (f = R);
      let g = [];
      for (const R of p) {
        t(R.mode.modeBits, 4, g), t(R.numChars, R.mode.numCharCountBits(S), g);
        for (const T of R.getData())
          g.push(T);
      }
      o(g.length == v);
      const O = mt.getNumDataCodewords(S, f) * 8;
      o(g.length <= O), t(0, Math.min(4, O - g.length), g), t(0, (8 - g.length % 8) % 8, g), o(g.length % 8 == 0);
      for (let R = 236; g.length < O; R ^= 253)
        t(R, 8, g);
      let D = [];
      for (; D.length * 8 < g.length; )
        D.push(0);
      return g.forEach((R, T) => D[T >>> 3] |= R << 7 - (T & 7)), new mt(S, f, D, E);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(p, f) {
      return 0 <= p && p < this.size && 0 <= f && f < this.size && this.modules[f][p];
    }
    // Modified to expose modules for easy access
    getModules() {
      return this.modules;
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let h = 0; h < this.size; h++)
        this.setFunctionModule(6, h, h % 2 == 0), this.setFunctionModule(h, 6, h % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const p = this.getAlignmentPatternPositions(), f = p.length;
      for (let h = 0; h < f; h++)
        for (let C = 0; C < f; C++)
          h == 0 && C == 0 || h == 0 && C == f - 1 || h == f - 1 && C == 0 || this.drawAlignmentPattern(p[h], p[C]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(p) {
      const f = this.errorCorrectionLevel.formatBits << 3 | p;
      let h = f;
      for (let E = 0; E < 10; E++)
        h = h << 1 ^ (h >>> 9) * 1335;
      const C = (f << 10 | h) ^ 21522;
      o(C >>> 15 == 0);
      for (let E = 0; E <= 5; E++)
        this.setFunctionModule(8, E, a(C, E));
      this.setFunctionModule(8, 7, a(C, 6)), this.setFunctionModule(8, 8, a(C, 7)), this.setFunctionModule(7, 8, a(C, 8));
      for (let E = 9; E < 15; E++)
        this.setFunctionModule(14 - E, 8, a(C, E));
      for (let E = 0; E < 8; E++)
        this.setFunctionModule(this.size - 1 - E, 8, a(C, E));
      for (let E = 8; E < 15; E++)
        this.setFunctionModule(8, this.size - 15 + E, a(C, E));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7)
        return;
      let p = this.version;
      for (let h = 0; h < 12; h++)
        p = p << 1 ^ (p >>> 11) * 7973;
      const f = this.version << 12 | p;
      o(f >>> 18 == 0);
      for (let h = 0; h < 18; h++) {
        const C = a(f, h), E = this.size - 11 + h % 3, m = Math.floor(h / 3);
        this.setFunctionModule(E, m, C), this.setFunctionModule(m, E, C);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(p, f) {
      for (let h = -4; h <= 4; h++)
        for (let C = -4; C <= 4; C++) {
          const E = Math.max(Math.abs(C), Math.abs(h)), m = p + C, S = f + h;
          0 <= m && m < this.size && 0 <= S && S < this.size && this.setFunctionModule(m, S, E != 2 && E != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(p, f) {
      for (let h = -2; h <= 2; h++)
        for (let C = -2; C <= 2; C++)
          this.setFunctionModule(p + C, f + h, Math.max(Math.abs(C), Math.abs(h)) != 1);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(p, f, h) {
      this.modules[f][p] = h, this.isFunction[f][p] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(p) {
      const f = this.version, h = this.errorCorrectionLevel;
      if (p.length != mt.getNumDataCodewords(f, h))
        throw new RangeError("Invalid argument");
      const C = mt.NUM_ERROR_CORRECTION_BLOCKS[h.ordinal][f], E = mt.ECC_CODEWORDS_PER_BLOCK[h.ordinal][f], m = Math.floor(mt.getNumRawDataModules(f) / 8), S = C - m % C, v = Math.floor(m / C);
      let g = [];
      const O = mt.reedSolomonComputeDivisor(E);
      for (let R = 0, T = 0; R < C; R++) {
        let N = p.slice(T, T + v - E + (R < S ? 0 : 1));
        T += N.length;
        const b = mt.reedSolomonComputeRemainder(N, O);
        R < S && N.push(0), g.push(N.concat(b));
      }
      let D = [];
      for (let R = 0; R < g[0].length; R++)
        g.forEach((T, N) => {
          (R != v - E || N >= S) && D.push(T[R]);
        });
      return o(D.length == m), D;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(p) {
      if (p.length != Math.floor(mt.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let f = 0;
      for (let h = this.size - 1; h >= 1; h -= 2) {
        h == 6 && (h = 5);
        for (let C = 0; C < this.size; C++)
          for (let E = 0; E < 2; E++) {
            const m = h - E, v = (h + 1 & 2) == 0 ? this.size - 1 - C : C;
            !this.isFunction[v][m] && f < p.length * 8 && (this.modules[v][m] = a(p[f >>> 3], 7 - (f & 7)), f++);
          }
      }
      o(f == p.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(p) {
      if (p < 0 || p > 7)
        throw new RangeError("Mask value out of range");
      for (let f = 0; f < this.size; f++)
        for (let h = 0; h < this.size; h++) {
          let C;
          switch (p) {
            case 0:
              C = (h + f) % 2 == 0;
              break;
            case 1:
              C = f % 2 == 0;
              break;
            case 2:
              C = h % 3 == 0;
              break;
            case 3:
              C = (h + f) % 3 == 0;
              break;
            case 4:
              C = (Math.floor(h / 3) + Math.floor(f / 2)) % 2 == 0;
              break;
            case 5:
              C = h * f % 2 + h * f % 3 == 0;
              break;
            case 6:
              C = (h * f % 2 + h * f % 3) % 2 == 0;
              break;
            case 7:
              C = ((h + f) % 2 + h * f % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[f][h] && C && (this.modules[f][h] = !this.modules[f][h]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let p = 0;
      for (let E = 0; E < this.size; E++) {
        let m = !1, S = 0, v = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[E][g] == m ? (S++, S == 5 ? p += mt.PENALTY_N1 : S > 5 && p++) : (this.finderPenaltyAddHistory(S, v), m || (p += this.finderPenaltyCountPatterns(v) * mt.PENALTY_N3), m = this.modules[E][g], S = 1);
        p += this.finderPenaltyTerminateAndCount(m, S, v) * mt.PENALTY_N3;
      }
      for (let E = 0; E < this.size; E++) {
        let m = !1, S = 0, v = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[g][E] == m ? (S++, S == 5 ? p += mt.PENALTY_N1 : S > 5 && p++) : (this.finderPenaltyAddHistory(S, v), m || (p += this.finderPenaltyCountPatterns(v) * mt.PENALTY_N3), m = this.modules[g][E], S = 1);
        p += this.finderPenaltyTerminateAndCount(m, S, v) * mt.PENALTY_N3;
      }
      for (let E = 0; E < this.size - 1; E++)
        for (let m = 0; m < this.size - 1; m++) {
          const S = this.modules[E][m];
          S == this.modules[E][m + 1] && S == this.modules[E + 1][m] && S == this.modules[E + 1][m + 1] && (p += mt.PENALTY_N2);
        }
      let f = 0;
      for (const E of this.modules)
        f = E.reduce((m, S) => m + (S ? 1 : 0), f);
      const h = this.size * this.size, C = Math.ceil(Math.abs(f * 20 - h * 10) / h) - 1;
      return o(0 <= C && C <= 9), p += C * mt.PENALTY_N4, o(0 <= p && p <= 2568888), p;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const p = Math.floor(this.version / 7) + 2, f = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (p * 2 - 2)) * 2;
        let h = [6];
        for (let C = this.size - 7; h.length < p; C -= f)
          h.splice(1, 0, C);
        return h;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(p) {
      if (p < mt.MIN_VERSION || p > mt.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let f = (16 * p + 128) * p + 64;
      if (p >= 2) {
        const h = Math.floor(p / 7) + 2;
        f -= (25 * h - 10) * h - 55, p >= 7 && (f -= 36);
      }
      return o(208 <= f && f <= 29648), f;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(p, f) {
      return Math.floor(mt.getNumRawDataModules(p) / 8) - mt.ECC_CODEWORDS_PER_BLOCK[f.ordinal][p] * mt.NUM_ERROR_CORRECTION_BLOCKS[f.ordinal][p];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(p) {
      if (p < 1 || p > 255)
        throw new RangeError("Degree out of range");
      let f = [];
      for (let C = 0; C < p - 1; C++)
        f.push(0);
      f.push(1);
      let h = 1;
      for (let C = 0; C < p; C++) {
        for (let E = 0; E < f.length; E++)
          f[E] = mt.reedSolomonMultiply(f[E], h), E + 1 < f.length && (f[E] ^= f[E + 1]);
        h = mt.reedSolomonMultiply(h, 2);
      }
      return f;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(p, f) {
      let h = f.map((C) => 0);
      for (const C of p) {
        const E = C ^ h.shift();
        h.push(0), f.forEach((m, S) => h[S] ^= mt.reedSolomonMultiply(m, E));
      }
      return h;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(p, f) {
      if (p >>> 8 || f >>> 8)
        throw new RangeError("Byte out of range");
      let h = 0;
      for (let C = 7; C >= 0; C--)
        h = h << 1 ^ (h >>> 7) * 285, h ^= (f >>> C & 1) * p;
      return o(h >>> 8 == 0), h;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(p) {
      const f = p[1];
      o(f <= this.size * 3);
      const h = f > 0 && p[2] == f && p[3] == f * 3 && p[4] == f && p[5] == f;
      return (h && p[0] >= f * 4 && p[6] >= f ? 1 : 0) + (h && p[6] >= f * 4 && p[0] >= f ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(p, f, h) {
      return p && (this.finderPenaltyAddHistory(f, h), f = 0), f += this.size, this.finderPenaltyAddHistory(f, h), this.finderPenaltyCountPatterns(h);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(p, f) {
      f[0] == 0 && (p += this.size), f.pop(), f.unshift(p);
    }
  };
  r.MIN_VERSION = 1, r.MAX_VERSION = 40, r.PENALTY_N1 = 3, r.PENALTY_N2 = 3, r.PENALTY_N3 = 40, r.PENALTY_N4 = 10, r.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Low
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    // Medium
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Quartile
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
    // High
  ], r.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    // Low
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    // Medium
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    // Quartile
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
    // High
  ], e.QrCode = r;
  function t(u, p, f) {
    if (p < 0 || p > 31 || u >>> p)
      throw new RangeError("Value out of range");
    for (let h = p - 1; h >= 0; h--)
      f.push(u >>> h & 1);
  }
  function a(u, p) {
    return (u >>> p & 1) != 0;
  }
  function o(u) {
    if (!u)
      throw new Error("Assertion error");
  }
  const l = class er {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(p, f, h) {
      if (this.mode = p, this.numChars = f, this.bitData = h, f < 0)
        throw new RangeError("Invalid argument");
      this.bitData = h.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(p) {
      let f = [];
      for (const h of p)
        t(h, 8, f);
      return new er(er.Mode.BYTE, p.length, f);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(p) {
      if (!er.isNumeric(p))
        throw new RangeError("String contains non-numeric characters");
      let f = [];
      for (let h = 0; h < p.length; ) {
        const C = Math.min(p.length - h, 3);
        t(parseInt(p.substring(h, h + C), 10), C * 3 + 1, f), h += C;
      }
      return new er(er.Mode.NUMERIC, p.length, f);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(p) {
      if (!er.isAlphanumeric(p))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let f = [], h;
      for (h = 0; h + 2 <= p.length; h += 2) {
        let C = er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h)) * 45;
        C += er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h + 1)), t(C, 11, f);
      }
      return h < p.length && t(er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h)), 6, f), new er(er.Mode.ALPHANUMERIC, p.length, f);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(p) {
      return p == "" ? [] : er.isNumeric(p) ? [er.makeNumeric(p)] : er.isAlphanumeric(p) ? [er.makeAlphanumeric(p)] : [er.makeBytes(er.toUtf8ByteArray(p))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(p) {
      let f = [];
      if (p < 0)
        throw new RangeError("ECI assignment value out of range");
      if (p < 128)
        t(p, 8, f);
      else if (p < 16384)
        t(2, 2, f), t(p, 14, f);
      else if (p < 1e6)
        t(6, 3, f), t(p, 21, f);
      else
        throw new RangeError("ECI assignment value out of range");
      return new er(er.Mode.ECI, 0, f);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(p) {
      return er.NUMERIC_REGEX.test(p);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(p) {
      return er.ALPHANUMERIC_REGEX.test(p);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(p, f) {
      let h = 0;
      for (const C of p) {
        const E = C.mode.numCharCountBits(f);
        if (C.numChars >= 1 << E)
          return 1 / 0;
        h += 4 + E + C.bitData.length;
      }
      return h;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(p) {
      p = encodeURI(p);
      let f = [];
      for (let h = 0; h < p.length; h++)
        p.charAt(h) != "%" ? f.push(p.charCodeAt(h)) : (f.push(parseInt(p.substring(h + 1, h + 3), 16)), h += 2);
      return f;
    }
  };
  l.NUMERIC_REGEX = /^[0-9]*$/, l.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, l.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let c = l;
  e.QrSegment = l;
})(Va || (Va = {}));
((e) => {
  ((r) => {
    const t = class {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(o, l) {
        this.ordinal = o, this.formatBits = l;
      }
    };
    t.LOW = new t(0, 1), t.MEDIUM = new t(1, 0), t.QUARTILE = new t(2, 3), t.HIGH = new t(3, 2), r.Ecc = t;
  })(e.QrCode || (e.QrCode = {}));
})(Va || (Va = {}));
((e) => {
  ((r) => {
    const t = class {
      /*-- Constructor and fields --*/
      constructor(o, l) {
        this.modeBits = o, this.numBitsCharCount = l;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(o) {
        return this.numBitsCharCount[Math.floor((o + 7) / 17)];
      }
    };
    t.NUMERIC = new t(1, [10, 12, 14]), t.ALPHANUMERIC = new t(2, [9, 11, 13]), t.BYTE = new t(4, [8, 16, 16]), t.KANJI = new t(8, [8, 10, 12]), t.ECI = new t(7, [0, 0, 0]), r.Mode = t;
  })(e.QrSegment || (e.QrSegment = {}));
})(Va || (Va = {}));
var Lo = Va;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var lw = {
  L: Lo.QrCode.Ecc.LOW,
  M: Lo.QrCode.Ecc.MEDIUM,
  Q: Lo.QrCode.Ecc.QUARTILE,
  H: Lo.QrCode.Ecc.HIGH
}, KD = 128, XD = "L", QD = "#FFFFFF", JD = "#000000", e8 = !1, t8 = 1, cw = 4, uw = 0, fw = 0.1;
function r8(e, r = 0) {
  const t = [];
  return e.forEach(function(a, o) {
    let l = null;
    a.forEach(function(c, u) {
      if (!c && l !== null) {
        t.push(
          `M${l + r} ${o + r}h${u - l}v1H${l + r}z`
        ), l = null;
        return;
      }
      if (u === a.length - 1) {
        if (!c)
          return;
        l === null ? t.push(`M${u + r},${o + r} h1v1H${u + r}z`) : t.push(
          `M${l + r},${o + r} h${u + 1 - l}v1H${l + r}z`
        );
        return;
      }
      c && l === null && (l = u);
    });
  }), t.join("");
}
function n8(e, r) {
  return e.slice().map((t, a) => a < r.y || a >= r.y + r.h ? t : t.map((o, l) => l < r.x || l >= r.x + r.w ? o : !1));
}
function dw(e, r, t, a) {
  if (a == null)
    return null;
  const o = e.length + t * 2, l = Math.floor(r * fw), c = o / r, u = (a.width || l) * c, p = (a.height || l) * c, f = a.x == null ? e.length / 2 - u / 2 : a.x * c, h = a.y == null ? e.length / 2 - p / 2 : a.y * c, C = a.opacity == null ? 1 : a.opacity;
  let E = null;
  if (a.excavate) {
    let S = Math.floor(f), v = Math.floor(h), g = Math.ceil(u + f - S), O = Math.ceil(p + h - v);
    E = { x: S, y: v, w: g, h: O };
  }
  const m = a.crossOrigin;
  return { x: f, y: h, h: p, w: u, excavation: E, opacity: C, crossOrigin: m };
}
function pw(e, r) {
  return r != null ? Math.max(Math.floor(r), 0) : e ? cw : uw;
}
function i8({
  value: e,
  level: r,
  minVersion: t,
  includeMargin: a,
  marginSize: o,
  imageSettings: l,
  size: c,
  boostLevel: u
}) {
  let p = dt.useMemo(() => {
    const S = (Array.isArray(e) ? e : [e]).reduce((v, g) => (v.push(...Lo.QrSegment.makeSegments(g)), v), []);
    return Lo.QrCode.encodeSegments(
      S,
      lw[r],
      t,
      void 0,
      void 0,
      u
    );
  }, [e, r, t, u]);
  const { cells: f, margin: h, numCells: C, calculatedImageSettings: E } = dt.useMemo(() => {
    let m = p.getModules();
    const S = pw(a, o), v = m.length + S * 2, g = dw(
      m,
      c,
      S,
      l
    );
    return {
      cells: m,
      margin: S,
      numCells: v,
      calculatedImageSettings: g
    };
  }, [p, c, l, a, o]);
  return {
    qrcode: p,
    margin: h,
    cells: f,
    numCells: C,
    calculatedImageSettings: E
  };
}
var hw = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return !1;
  }
  return !0;
}(), _w = dt.forwardRef(
  function(r, t) {
    const a = r, {
      value: o,
      size: l = KD,
      level: c = XD,
      bgColor: u = QD,
      fgColor: p = JD,
      includeMargin: f = e8,
      minVersion: h = t8,
      boostLevel: C,
      marginSize: E,
      imageSettings: m
    } = a, v = Mp(a, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "marginSize",
      "imageSettings"
    ]), { style: g } = v, O = Mp(v, ["style"]), D = m == null ? void 0 : m.src, R = dt.useRef(null), T = dt.useRef(null), N = dt.useCallback(
      (W) => {
        R.current = W, typeof t == "function" ? t(W) : t && (t.current = W);
      },
      [t]
    ), [b, L] = dt.useState(!1), { margin: k, cells: w, numCells: V, calculatedImageSettings: U } = i8({
      value: o,
      level: c,
      minVersion: h,
      boostLevel: C,
      includeMargin: f,
      marginSize: E,
      imageSettings: m,
      size: l
    });
    dt.useEffect(() => {
      if (R.current != null) {
        const W = R.current, te = W.getContext("2d");
        if (!te)
          return;
        let se = w;
        const le = T.current, B = U != null && le !== null && le.complete && le.naturalHeight !== 0 && le.naturalWidth !== 0;
        B && U.excavation != null && (se = n8(
          w,
          U.excavation
        ));
        const J = window.devicePixelRatio || 1;
        W.height = W.width = l * J;
        const Q = l / V * J;
        te.scale(Q, Q), te.fillStyle = u, te.fillRect(0, 0, V, V), te.fillStyle = p, hw ? te.fill(new Path2D(r8(se, k))) : w.forEach(function(P, $) {
          P.forEach(function(ce, ue) {
            ce && te.fillRect(ue + k, $ + k, 1, 1);
          });
        }), U && (te.globalAlpha = U.opacity), B && te.drawImage(
          le,
          U.x + k,
          U.y + k,
          U.w,
          U.h
        );
      }
    }), dt.useEffect(() => {
      L(!1);
    }, [D]);
    const z = Lp({ height: l, width: l }, g);
    let q = null;
    return D != null && (q = /* @__PURE__ */ dt.createElement(
      "img",
      {
        src: D,
        key: D,
        style: { display: "none" },
        onLoad: () => {
          L(!0);
        },
        ref: T,
        crossOrigin: U == null ? void 0 : U.crossOrigin
      }
    )), /* @__PURE__ */ dt.createElement(dt.Fragment, null, /* @__PURE__ */ dt.createElement(
      "canvas",
      Lp({
        style: z,
        height: l,
        width: l,
        ref: N,
        role: "img"
      }, O)
    ), q);
  }
);
_w.displayName = "QRCodeCanvas";
var a8 = dt.forwardRef(
  function(r, t) {
    const a = r, {
      value: o,
      size: l = KD,
      level: c = XD,
      bgColor: u = QD,
      fgColor: p = JD,
      includeMargin: f = e8,
      minVersion: h = t8,
      boostLevel: C,
      title: E,
      marginSize: m,
      imageSettings: S
    } = a, v = Mp(a, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "title",
      "marginSize",
      "imageSettings"
    ]), { margin: g, cells: O, numCells: D, calculatedImageSettings: R } = i8({
      value: o,
      level: c,
      minVersion: h,
      boostLevel: C,
      includeMargin: f,
      marginSize: m,
      imageSettings: S,
      size: l
    });
    let T = O, N = null;
    S != null && R != null && (R.excavation != null && (T = n8(
      O,
      R.excavation
    )), N = /* @__PURE__ */ dt.createElement(
      "image",
      {
        href: S.src,
        height: R.h,
        width: R.w,
        x: R.x + g,
        y: R.y + g,
        preserveAspectRatio: "none",
        opacity: R.opacity,
        crossOrigin: R.crossOrigin
      }
    ));
    const b = r8(T, g);
    return /* @__PURE__ */ dt.createElement(
      "svg",
      Lp({
        height: l,
        width: l,
        viewBox: `0 0 ${D} ${D}`,
        ref: t,
        role: "img"
      }, v),
      !!E && /* @__PURE__ */ dt.createElement("title", null, E),
      /* @__PURE__ */ dt.createElement(
        "path",
        {
          fill: u,
          d: `M0,0 h${D}v${D}H0z`,
          shapeRendering: "crispEdges"
        }
      ),
      /* @__PURE__ */ dt.createElement("path", { fill: p, d: b, shapeRendering: "crispEdges" }),
      N
    );
  }
);
a8.displayName = "QRCodeSVG";
var Y1, C7;
function mw() {
  if (C7) return Y1;
  C7 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Y1 = e, Y1;
}
var K1, S7;
function Dh() {
  if (S7) return K1;
  S7 = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return K1 = e, K1;
}
var X1, I7;
function hc() {
  if (I7) return X1;
  I7 = 1;
  var e = Dh();
  function r(t, a) {
    for (var o = t.length; o--; )
      if (e(t[o][0], a))
        return o;
    return -1;
  }
  return X1 = r, X1;
}
var Q1, v7;
function Ew() {
  if (v7) return Q1;
  v7 = 1;
  var e = hc(), r = Array.prototype, t = r.splice;
  function a(o) {
    var l = this.__data__, c = e(l, o);
    if (c < 0)
      return !1;
    var u = l.length - 1;
    return c == u ? l.pop() : t.call(l, c, 1), --this.size, !0;
  }
  return Q1 = a, Q1;
}
var J1, g7;
function Cw() {
  if (g7) return J1;
  g7 = 1;
  var e = hc();
  function r(t) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? void 0 : a[o][1];
  }
  return J1 = r, J1;
}
var ed, R7;
function Sw() {
  if (R7) return ed;
  R7 = 1;
  var e = hc();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return ed = r, ed;
}
var td, D7;
function Iw() {
  if (D7) return td;
  D7 = 1;
  var e = hc();
  function r(t, a) {
    var o = this.__data__, l = e(o, t);
    return l < 0 ? (++this.size, o.push([t, a])) : o[l][1] = a, this;
  }
  return td = r, td;
}
var rd, A7;
function _c() {
  if (A7) return rd;
  A7 = 1;
  var e = mw(), r = Ew(), t = Cw(), a = Sw(), o = Iw();
  function l(c) {
    var u = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++u < p; ) {
      var f = c[u];
      this.set(f[0], f[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, rd = l, rd;
}
var nd, T7;
function vw() {
  if (T7) return nd;
  T7 = 1;
  var e = _c();
  function r() {
    this.__data__ = new e(), this.size = 0;
  }
  return nd = r, nd;
}
var id, O7;
function gw() {
  if (O7) return id;
  O7 = 1;
  function e(r) {
    var t = this.__data__, a = t.delete(r);
    return this.size = t.size, a;
  }
  return id = e, id;
}
var ad, y7;
function Rw() {
  if (y7) return ad;
  y7 = 1;
  function e(r) {
    return this.__data__.get(r);
  }
  return ad = e, ad;
}
var od, N7;
function Dw() {
  if (N7) return od;
  N7 = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return od = e, od;
}
var sd, L7;
function o8() {
  if (L7) return sd;
  L7 = 1;
  var e = typeof Oo == "object" && Oo && Oo.Object === Object && Oo;
  return sd = e, sd;
}
var ld, M7;
function Hi() {
  if (M7) return ld;
  M7 = 1;
  var e = o8(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return ld = t, ld;
}
var cd, P7;
function il() {
  if (P7) return cd;
  P7 = 1;
  var e = Hi(), r = e.Symbol;
  return cd = r, cd;
}
var ud, b7;
function Aw() {
  if (b7) return ud;
  b7 = 1;
  var e = il(), r = Object.prototype, t = r.hasOwnProperty, a = r.toString, o = e ? e.toStringTag : void 0;
  function l(c) {
    var u = t.call(c, o), p = c[o];
    try {
      c[o] = void 0;
      var f = !0;
    } catch (C) {
    }
    var h = a.call(c);
    return f && (u ? c[o] = p : delete c[o]), h;
  }
  return ud = l, ud;
}
var fd, w7;
function Tw() {
  if (w7) return fd;
  w7 = 1;
  var e = Object.prototype, r = e.toString;
  function t(a) {
    return r.call(a);
  }
  return fd = t, fd;
}
var dd, H7;
function al() {
  if (H7) return dd;
  H7 = 1;
  var e = il(), r = Aw(), t = Tw(), a = "[object Null]", o = "[object Undefined]", l = e ? e.toStringTag : void 0;
  function c(u) {
    return u == null ? u === void 0 ? o : a : l && l in Object(u) ? r(u) : t(u);
  }
  return dd = c, dd;
}
var pd, V7;
function Ah() {
  if (V7) return pd;
  V7 = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return pd = e, pd;
}
var hd, k7;
function s8() {
  if (k7) return hd;
  k7 = 1;
  var e = al(), r = Ah(), t = "[object AsyncFunction]", a = "[object Function]", o = "[object GeneratorFunction]", l = "[object Proxy]";
  function c(u) {
    if (!r(u))
      return !1;
    var p = e(u);
    return p == a || p == o || p == t || p == l;
  }
  return hd = c, hd;
}
var _d, F7;
function Ow() {
  if (F7) return _d;
  F7 = 1;
  var e = Hi(), r = e["__core-js_shared__"];
  return _d = r, _d;
}
var md, U7;
function yw() {
  if (U7) return md;
  U7 = 1;
  var e = Ow(), r = function() {
    var a = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }();
  function t(a) {
    return !!r && r in a;
  }
  return md = t, md;
}
var Ed, x7;
function l8() {
  if (x7) return Ed;
  x7 = 1;
  var e = Function.prototype, r = e.toString;
  function t(a) {
    if (a != null) {
      try {
        return r.call(a);
      } catch (o) {
      }
      try {
        return a + "";
      } catch (o) {
      }
    }
    return "";
  }
  return Ed = t, Ed;
}
var Cd, B7;
function Nw() {
  if (B7) return Cd;
  B7 = 1;
  var e = s8(), r = yw(), t = Ah(), a = l8(), o = /[\\^$.*+?()[\]{}|]/g, l = /^\[object .+?Constructor\]$/, c = Function.prototype, u = Object.prototype, p = c.toString, f = u.hasOwnProperty, h = RegExp(
    "^" + p.call(f).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function C(E) {
    if (!t(E) || r(E))
      return !1;
    var m = e(E) ? h : l;
    return m.test(a(E));
  }
  return Cd = C, Cd;
}
var Sd, $7;
function Lw() {
  if ($7) return Sd;
  $7 = 1;
  function e(r, t) {
    return r == null ? void 0 : r[t];
  }
  return Sd = e, Sd;
}
var Id, G7;
function Za() {
  if (G7) return Id;
  G7 = 1;
  var e = Nw(), r = Lw();
  function t(a, o) {
    var l = r(a, o);
    return e(l) ? l : void 0;
  }
  return Id = t, Id;
}
var vd, Z7;
function Th() {
  if (Z7) return vd;
  Z7 = 1;
  var e = Za(), r = Hi(), t = e(r, "Map");
  return vd = t, vd;
}
var gd, j7;
function mc() {
  if (j7) return gd;
  j7 = 1;
  var e = Za(), r = e(Object, "create");
  return gd = r, gd;
}
var Rd, z7;
function Mw() {
  if (z7) return Rd;
  z7 = 1;
  var e = mc();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Rd = r, Rd;
}
var Dd, q7;
function Pw() {
  if (q7) return Dd;
  q7 = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return Dd = e, Dd;
}
var Ad, W7;
function bw() {
  if (W7) return Ad;
  W7 = 1;
  var e = mc(), r = "__lodash_hash_undefined__", t = Object.prototype, a = t.hasOwnProperty;
  function o(l) {
    var c = this.__data__;
    if (e) {
      var u = c[l];
      return u === r ? void 0 : u;
    }
    return a.call(c, l) ? c[l] : void 0;
  }
  return Ad = o, Ad;
}
var Td, Y7;
function ww() {
  if (Y7) return Td;
  Y7 = 1;
  var e = mc(), r = Object.prototype, t = r.hasOwnProperty;
  function a(o) {
    var l = this.__data__;
    return e ? l[o] !== void 0 : t.call(l, o);
  }
  return Td = a, Td;
}
var Od, K7;
function Hw() {
  if (K7) return Od;
  K7 = 1;
  var e = mc(), r = "__lodash_hash_undefined__";
  function t(a, o) {
    var l = this.__data__;
    return this.size += this.has(a) ? 0 : 1, l[a] = e && o === void 0 ? r : o, this;
  }
  return Od = t, Od;
}
var yd, X7;
function Vw() {
  if (X7) return yd;
  X7 = 1;
  var e = Mw(), r = Pw(), t = bw(), a = ww(), o = Hw();
  function l(c) {
    var u = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++u < p; ) {
      var f = c[u];
      this.set(f[0], f[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, yd = l, yd;
}
var Nd, Q7;
function kw() {
  if (Q7) return Nd;
  Q7 = 1;
  var e = Vw(), r = _c(), t = Th();
  function a() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return Nd = a, Nd;
}
var Ld, J7;
function Fw() {
  if (J7) return Ld;
  J7 = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return Ld = e, Ld;
}
var Md, ev;
function Ec() {
  if (ev) return Md;
  ev = 1;
  var e = Fw();
  function r(t, a) {
    var o = t.__data__;
    return e(a) ? o[typeof a == "string" ? "string" : "hash"] : o.map;
  }
  return Md = r, Md;
}
var Pd, tv;
function Uw() {
  if (tv) return Pd;
  tv = 1;
  var e = Ec();
  function r(t) {
    var a = e(this, t).delete(t);
    return this.size -= a ? 1 : 0, a;
  }
  return Pd = r, Pd;
}
var bd, rv;
function xw() {
  if (rv) return bd;
  rv = 1;
  var e = Ec();
  function r(t) {
    return e(this, t).get(t);
  }
  return bd = r, bd;
}
var wd, nv;
function Bw() {
  if (nv) return wd;
  nv = 1;
  var e = Ec();
  function r(t) {
    return e(this, t).has(t);
  }
  return wd = r, wd;
}
var Hd, iv;
function $w() {
  if (iv) return Hd;
  iv = 1;
  var e = Ec();
  function r(t, a) {
    var o = e(this, t), l = o.size;
    return o.set(t, a), this.size += o.size == l ? 0 : 1, this;
  }
  return Hd = r, Hd;
}
var Vd, av;
function Oh() {
  if (av) return Vd;
  av = 1;
  var e = kw(), r = Uw(), t = xw(), a = Bw(), o = $w();
  function l(c) {
    var u = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++u < p; ) {
      var f = c[u];
      this.set(f[0], f[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, Vd = l, Vd;
}
var kd, ov;
function Gw() {
  if (ov) return kd;
  ov = 1;
  var e = _c(), r = Th(), t = Oh(), a = 200;
  function o(l, c) {
    var u = this.__data__;
    if (u instanceof e) {
      var p = u.__data__;
      if (!r || p.length < a - 1)
        return p.push([l, c]), this.size = ++u.size, this;
      u = this.__data__ = new t(p);
    }
    return u.set(l, c), this.size = u.size, this;
  }
  return kd = o, kd;
}
var Fd, sv;
function Zw() {
  if (sv) return Fd;
  sv = 1;
  var e = _c(), r = vw(), t = gw(), a = Rw(), o = Dw(), l = Gw();
  function c(u) {
    var p = this.__data__ = new e(u);
    this.size = p.size;
  }
  return c.prototype.clear = r, c.prototype.delete = t, c.prototype.get = a, c.prototype.has = o, c.prototype.set = l, Fd = c, Fd;
}
var Ud, lv;
function jw() {
  if (lv) return Ud;
  lv = 1;
  var e = "__lodash_hash_undefined__";
  function r(t) {
    return this.__data__.set(t, e), this;
  }
  return Ud = r, Ud;
}
var xd, cv;
function zw() {
  if (cv) return xd;
  cv = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return xd = e, xd;
}
var Bd, uv;
function qw() {
  if (uv) return Bd;
  uv = 1;
  var e = Oh(), r = jw(), t = zw();
  function a(o) {
    var l = -1, c = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++l < c; )
      this.add(o[l]);
  }
  return a.prototype.add = a.prototype.push = r, a.prototype.has = t, Bd = a, Bd;
}
var $d, fv;
function Ww() {
  if (fv) return $d;
  fv = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length; ++a < o; )
      if (t(r[a], a, r))
        return !0;
    return !1;
  }
  return $d = e, $d;
}
var Gd, dv;
function Yw() {
  if (dv) return Gd;
  dv = 1;
  function e(r, t) {
    return r.has(t);
  }
  return Gd = e, Gd;
}
var Zd, pv;
function c8() {
  if (pv) return Zd;
  pv = 1;
  var e = qw(), r = Ww(), t = Yw(), a = 1, o = 2;
  function l(c, u, p, f, h, C) {
    var E = p & a, m = c.length, S = u.length;
    if (m != S && !(E && S > m))
      return !1;
    var v = C.get(c), g = C.get(u);
    if (v && g)
      return v == u && g == c;
    var O = -1, D = !0, R = p & o ? new e() : void 0;
    for (C.set(c, u), C.set(u, c); ++O < m; ) {
      var T = c[O], N = u[O];
      if (f)
        var b = E ? f(N, T, O, u, c, C) : f(T, N, O, c, u, C);
      if (b !== void 0) {
        if (b)
          continue;
        D = !1;
        break;
      }
      if (R) {
        if (!r(u, function(L, k) {
          if (!t(R, k) && (T === L || h(T, L, p, f, C)))
            return R.push(k);
        })) {
          D = !1;
          break;
        }
      } else if (!(T === N || h(T, N, p, f, C))) {
        D = !1;
        break;
      }
    }
    return C.delete(c), C.delete(u), D;
  }
  return Zd = l, Zd;
}
var jd, hv;
function Kw() {
  if (hv) return jd;
  hv = 1;
  var e = Hi(), r = e.Uint8Array;
  return jd = r, jd;
}
var zd, _v;
function Xw() {
  if (_v) return zd;
  _v = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(o, l) {
      a[++t] = [l, o];
    }), a;
  }
  return zd = e, zd;
}
var qd, mv;
function Qw() {
  if (mv) return qd;
  mv = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(o) {
      a[++t] = o;
    }), a;
  }
  return qd = e, qd;
}
var Wd, Ev;
function Jw() {
  if (Ev) return Wd;
  Ev = 1;
  var e = il(), r = Kw(), t = Dh(), a = c8(), o = Xw(), l = Qw(), c = 1, u = 2, p = "[object Boolean]", f = "[object Date]", h = "[object Error]", C = "[object Map]", E = "[object Number]", m = "[object RegExp]", S = "[object Set]", v = "[object String]", g = "[object Symbol]", O = "[object ArrayBuffer]", D = "[object DataView]", R = e ? e.prototype : void 0, T = R ? R.valueOf : void 0;
  function N(b, L, k, w, V, U, z) {
    switch (k) {
      case D:
        if (b.byteLength != L.byteLength || b.byteOffset != L.byteOffset)
          return !1;
        b = b.buffer, L = L.buffer;
      case O:
        return !(b.byteLength != L.byteLength || !U(new r(b), new r(L)));
      case p:
      case f:
      case E:
        return t(+b, +L);
      case h:
        return b.name == L.name && b.message == L.message;
      case m:
      case v:
        return b == L + "";
      case C:
        var q = o;
      case S:
        var W = w & c;
        if (q || (q = l), b.size != L.size && !W)
          return !1;
        var te = z.get(b);
        if (te)
          return te == L;
        w |= u, z.set(b, L);
        var se = a(q(b), q(L), w, V, U, z);
        return z.delete(b), se;
      case g:
        if (T)
          return T.call(b) == T.call(L);
    }
    return !1;
  }
  return Wd = N, Wd;
}
var Yd, Cv;
function u8() {
  if (Cv) return Yd;
  Cv = 1;
  function e(r, t) {
    for (var a = -1, o = t.length, l = r.length; ++a < o; )
      r[l + a] = t[a];
    return r;
  }
  return Yd = e, Yd;
}
var Kd, Sv;
function sa() {
  if (Sv) return Kd;
  Sv = 1;
  var e = Array.isArray;
  return Kd = e, Kd;
}
var Xd, Iv;
function eH() {
  if (Iv) return Xd;
  Iv = 1;
  var e = u8(), r = sa();
  function t(a, o, l) {
    var c = o(a);
    return r(a) ? c : e(c, l(a));
  }
  return Xd = t, Xd;
}
var Qd, vv;
function tH() {
  if (vv) return Qd;
  vv = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length, l = 0, c = []; ++a < o; ) {
      var u = r[a];
      t(u, a, r) && (c[l++] = u);
    }
    return c;
  }
  return Qd = e, Qd;
}
var Jd, gv;
function rH() {
  if (gv) return Jd;
  gv = 1;
  function e() {
    return [];
  }
  return Jd = e, Jd;
}
var e5, Rv;
function nH() {
  if (Rv) return e5;
  Rv = 1;
  var e = tH(), r = rH(), t = Object.prototype, a = t.propertyIsEnumerable, o = Object.getOwnPropertySymbols, l = o ? function(c) {
    return c == null ? [] : (c = Object(c), e(o(c), function(u) {
      return a.call(c, u);
    }));
  } : r;
  return e5 = l, e5;
}
var t5, Dv;
function iH() {
  if (Dv) return t5;
  Dv = 1;
  function e(r, t) {
    for (var a = -1, o = Array(r); ++a < r; )
      o[a] = t(a);
    return o;
  }
  return t5 = e, t5;
}
var r5, Av;
function ol() {
  if (Av) return r5;
  Av = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return r5 = e, r5;
}
var n5, Tv;
function aH() {
  if (Tv) return n5;
  Tv = 1;
  var e = al(), r = ol(), t = "[object Arguments]";
  function a(o) {
    return r(o) && e(o) == t;
  }
  return n5 = a, n5;
}
var i5, Ov;
function yh() {
  if (Ov) return i5;
  Ov = 1;
  var e = aH(), r = ol(), t = Object.prototype, a = t.hasOwnProperty, o = t.propertyIsEnumerable, l = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(c) {
    return r(c) && a.call(c, "callee") && !o.call(c, "callee");
  };
  return i5 = l, i5;
}
var ws = { exports: {} }, a5, yv;
function oH() {
  if (yv) return a5;
  yv = 1;
  function e() {
    return !1;
  }
  return a5 = e, a5;
}
ws.exports;
var Nv;
function f8() {
  return Nv || (Nv = 1, function(e, r) {
    var t = Hi(), a = oH(), o = r && !r.nodeType && r, l = o && !0 && e && !e.nodeType && e, c = l && l.exports === o, u = c ? t.Buffer : void 0, p = u ? u.isBuffer : void 0, f = p || a;
    e.exports = f;
  }(ws, ws.exports)), ws.exports;
}
var o5, Lv;
function Nh() {
  if (Lv) return o5;
  Lv = 1;
  var e = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
  function t(a, o) {
    var l = typeof a;
    return o = o == null ? e : o, !!o && (l == "number" || l != "symbol" && r.test(a)) && a > -1 && a % 1 == 0 && a < o;
  }
  return o5 = t, o5;
}
var s5, Mv;
function Lh() {
  if (Mv) return s5;
  Mv = 1;
  var e = 9007199254740991;
  function r(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return s5 = r, s5;
}
var l5, Pv;
function sH() {
  if (Pv) return l5;
  Pv = 1;
  var e = al(), r = Lh(), t = ol(), a = "[object Arguments]", o = "[object Array]", l = "[object Boolean]", c = "[object Date]", u = "[object Error]", p = "[object Function]", f = "[object Map]", h = "[object Number]", C = "[object Object]", E = "[object RegExp]", m = "[object Set]", S = "[object String]", v = "[object WeakMap]", g = "[object ArrayBuffer]", O = "[object DataView]", D = "[object Float32Array]", R = "[object Float64Array]", T = "[object Int8Array]", N = "[object Int16Array]", b = "[object Int32Array]", L = "[object Uint8Array]", k = "[object Uint8ClampedArray]", w = "[object Uint16Array]", V = "[object Uint32Array]", U = {};
  U[D] = U[R] = U[T] = U[N] = U[b] = U[L] = U[k] = U[w] = U[V] = !0, U[a] = U[o] = U[g] = U[l] = U[O] = U[c] = U[u] = U[p] = U[f] = U[h] = U[C] = U[E] = U[m] = U[S] = U[v] = !1;
  function z(q) {
    return t(q) && r(q.length) && !!U[e(q)];
  }
  return l5 = z, l5;
}
var c5, bv;
function lH() {
  if (bv) return c5;
  bv = 1;
  function e(r) {
    return function(t) {
      return r(t);
    };
  }
  return c5 = e, c5;
}
var Hs = { exports: {} };
Hs.exports;
var wv;
function cH() {
  return wv || (wv = 1, function(e, r) {
    var t = o8(), a = r && !r.nodeType && r, o = a && !0 && e && !e.nodeType && e, l = o && o.exports === a, c = l && t.process, u = function() {
      try {
        var p = o && o.require && o.require("util").types;
        return p || c && c.binding && c.binding("util");
      } catch (f) {
      }
    }();
    e.exports = u;
  }(Hs, Hs.exports)), Hs.exports;
}
var u5, Hv;
function d8() {
  if (Hv) return u5;
  Hv = 1;
  var e = sH(), r = lH(), t = cH(), a = t && t.isTypedArray, o = a ? r(a) : e;
  return u5 = o, u5;
}
var f5, Vv;
function uH() {
  if (Vv) return f5;
  Vv = 1;
  var e = iH(), r = yh(), t = sa(), a = f8(), o = Nh(), l = d8(), c = Object.prototype, u = c.hasOwnProperty;
  function p(f, h) {
    var C = t(f), E = !C && r(f), m = !C && !E && a(f), S = !C && !E && !m && l(f), v = C || E || m || S, g = v ? e(f.length, String) : [], O = g.length;
    for (var D in f)
      (h || u.call(f, D)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (D == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (D == "offset" || D == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (D == "buffer" || D == "byteLength" || D == "byteOffset") || // Skip index properties.
      o(D, O))) && g.push(D);
    return g;
  }
  return f5 = p, f5;
}
var d5, kv;
function fH() {
  if (kv) return d5;
  kv = 1;
  var e = Object.prototype;
  function r(t) {
    var a = t && t.constructor, o = typeof a == "function" && a.prototype || e;
    return t === o;
  }
  return d5 = r, d5;
}
var p5, Fv;
function dH() {
  if (Fv) return p5;
  Fv = 1;
  function e(r, t) {
    return function(a) {
      return r(t(a));
    };
  }
  return p5 = e, p5;
}
var h5, Uv;
function pH() {
  if (Uv) return h5;
  Uv = 1;
  var e = dH(), r = e(Object.keys, Object);
  return h5 = r, h5;
}
var _5, xv;
function hH() {
  if (xv) return _5;
  xv = 1;
  var e = fH(), r = pH(), t = Object.prototype, a = t.hasOwnProperty;
  function o(l) {
    if (!e(l))
      return r(l);
    var c = [];
    for (var u in Object(l))
      a.call(l, u) && u != "constructor" && c.push(u);
    return c;
  }
  return _5 = o, _5;
}
var m5, Bv;
function _H() {
  if (Bv) return m5;
  Bv = 1;
  var e = s8(), r = Lh();
  function t(a) {
    return a != null && r(a.length) && !e(a);
  }
  return m5 = t, m5;
}
var E5, $v;
function mH() {
  if ($v) return E5;
  $v = 1;
  var e = uH(), r = hH(), t = _H();
  function a(o) {
    return t(o) ? e(o) : r(o);
  }
  return E5 = a, E5;
}
var C5, Gv;
function EH() {
  if (Gv) return C5;
  Gv = 1;
  var e = eH(), r = nH(), t = mH();
  function a(o) {
    return e(o, t, r);
  }
  return C5 = a, C5;
}
var S5, Zv;
function CH() {
  if (Zv) return S5;
  Zv = 1;
  var e = EH(), r = 1, t = Object.prototype, a = t.hasOwnProperty;
  function o(l, c, u, p, f, h) {
    var C = u & r, E = e(l), m = E.length, S = e(c), v = S.length;
    if (m != v && !C)
      return !1;
    for (var g = m; g--; ) {
      var O = E[g];
      if (!(C ? O in c : a.call(c, O)))
        return !1;
    }
    var D = h.get(l), R = h.get(c);
    if (D && R)
      return D == c && R == l;
    var T = !0;
    h.set(l, c), h.set(c, l);
    for (var N = C; ++g < m; ) {
      O = E[g];
      var b = l[O], L = c[O];
      if (p)
        var k = C ? p(L, b, O, c, l, h) : p(b, L, O, l, c, h);
      if (!(k === void 0 ? b === L || f(b, L, u, p, h) : k)) {
        T = !1;
        break;
      }
      N || (N = O == "constructor");
    }
    if (T && !N) {
      var w = l.constructor, V = c.constructor;
      w != V && "constructor" in l && "constructor" in c && !(typeof w == "function" && w instanceof w && typeof V == "function" && V instanceof V) && (T = !1);
    }
    return h.delete(l), h.delete(c), T;
  }
  return S5 = o, S5;
}
var I5, jv;
function SH() {
  if (jv) return I5;
  jv = 1;
  var e = Za(), r = Hi(), t = e(r, "DataView");
  return I5 = t, I5;
}
var v5, zv;
function IH() {
  if (zv) return v5;
  zv = 1;
  var e = Za(), r = Hi(), t = e(r, "Promise");
  return v5 = t, v5;
}
var g5, qv;
function vH() {
  if (qv) return g5;
  qv = 1;
  var e = Za(), r = Hi(), t = e(r, "Set");
  return g5 = t, g5;
}
var R5, Wv;
function gH() {
  if (Wv) return R5;
  Wv = 1;
  var e = Za(), r = Hi(), t = e(r, "WeakMap");
  return R5 = t, R5;
}
var D5, Yv;
function RH() {
  if (Yv) return D5;
  Yv = 1;
  var e = SH(), r = Th(), t = IH(), a = vH(), o = gH(), l = al(), c = l8(), u = "[object Map]", p = "[object Object]", f = "[object Promise]", h = "[object Set]", C = "[object WeakMap]", E = "[object DataView]", m = c(e), S = c(r), v = c(t), g = c(a), O = c(o), D = l;
  return (e && D(new e(new ArrayBuffer(1))) != E || r && D(new r()) != u || t && D(t.resolve()) != f || a && D(new a()) != h || o && D(new o()) != C) && (D = function(R) {
    var T = l(R), N = T == p ? R.constructor : void 0, b = N ? c(N) : "";
    if (b)
      switch (b) {
        case m:
          return E;
        case S:
          return u;
        case v:
          return f;
        case g:
          return h;
        case O:
          return C;
      }
    return T;
  }), D5 = D, D5;
}
var A5, Kv;
function DH() {
  if (Kv) return A5;
  Kv = 1;
  var e = Zw(), r = c8(), t = Jw(), a = CH(), o = RH(), l = sa(), c = f8(), u = d8(), p = 1, f = "[object Arguments]", h = "[object Array]", C = "[object Object]", E = Object.prototype, m = E.hasOwnProperty;
  function S(v, g, O, D, R, T) {
    var N = l(v), b = l(g), L = N ? h : o(v), k = b ? h : o(g);
    L = L == f ? C : L, k = k == f ? C : k;
    var w = L == C, V = k == C, U = L == k;
    if (U && c(v)) {
      if (!c(g))
        return !1;
      N = !0, w = !1;
    }
    if (U && !w)
      return T || (T = new e()), N || u(v) ? r(v, g, O, D, R, T) : t(v, g, L, O, D, R, T);
    if (!(O & p)) {
      var z = w && m.call(v, "__wrapped__"), q = V && m.call(g, "__wrapped__");
      if (z || q) {
        var W = z ? v.value() : v, te = q ? g.value() : g;
        return T || (T = new e()), R(W, te, O, D, T);
      }
    }
    return U ? (T || (T = new e()), a(v, g, O, D, R, T)) : !1;
  }
  return A5 = S, A5;
}
var T5, Xv;
function AH() {
  if (Xv) return T5;
  Xv = 1;
  var e = DH(), r = ol();
  function t(a, o, l, c, u) {
    return a === o ? !0 : a == null || o == null || !r(a) && !r(o) ? a !== a && o !== o : e(a, o, l, c, t, u);
  }
  return T5 = t, T5;
}
var O5, Qv;
function TH() {
  if (Qv) return O5;
  Qv = 1;
  var e = AH();
  function r(t, a) {
    return e(t, a);
  }
  return O5 = r, O5;
}
var OH = TH();
const yH = /* @__PURE__ */ Gs(OH);
var y5, Jv;
function Mh() {
  if (Jv) return y5;
  Jv = 1;
  var e = al(), r = ol(), t = "[object Symbol]";
  function a(o) {
    return typeof o == "symbol" || r(o) && e(o) == t;
  }
  return y5 = a, y5;
}
var N5, eg;
function NH() {
  if (eg) return N5;
  eg = 1;
  var e = sa(), r = Mh(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/;
  function o(l, c) {
    if (e(l))
      return !1;
    var u = typeof l;
    return u == "number" || u == "symbol" || u == "boolean" || l == null || r(l) ? !0 : a.test(l) || !t.test(l) || c != null && l in Object(c);
  }
  return N5 = o, N5;
}
var L5, tg;
function LH() {
  if (tg) return L5;
  tg = 1;
  var e = Oh(), r = "Expected a function";
  function t(a, o) {
    if (typeof a != "function" || o != null && typeof o != "function")
      throw new TypeError(r);
    var l = function() {
      var c = arguments, u = o ? o.apply(this, c) : c[0], p = l.cache;
      if (p.has(u))
        return p.get(u);
      var f = a.apply(this, c);
      return l.cache = p.set(u, f) || p, f;
    };
    return l.cache = new (t.Cache || e)(), l;
  }
  return t.Cache = e, L5 = t, L5;
}
var M5, rg;
function MH() {
  if (rg) return M5;
  rg = 1;
  var e = LH(), r = 500;
  function t(a) {
    var o = e(a, function(c) {
      return l.size === r && l.clear(), c;
    }), l = o.cache;
    return o;
  }
  return M5 = t, M5;
}
var P5, ng;
function PH() {
  if (ng) return P5;
  ng = 1;
  var e = MH(), r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, a = e(function(o) {
    var l = [];
    return o.charCodeAt(0) === 46 && l.push(""), o.replace(r, function(c, u, p, f) {
      l.push(p ? f.replace(t, "$1") : u || c);
    }), l;
  });
  return P5 = a, P5;
}
var b5, ig;
function bH() {
  if (ig) return b5;
  ig = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length, l = Array(o); ++a < o; )
      l[a] = t(r[a], a, r);
    return l;
  }
  return b5 = e, b5;
}
var w5, ag;
function wH() {
  if (ag) return w5;
  ag = 1;
  var e = il(), r = bH(), t = sa(), a = Mh(), o = e ? e.prototype : void 0, l = o ? o.toString : void 0;
  function c(u) {
    if (typeof u == "string")
      return u;
    if (t(u))
      return r(u, c) + "";
    if (a(u))
      return l ? l.call(u) : "";
    var p = u + "";
    return p == "0" && 1 / u == -1 / 0 ? "-0" : p;
  }
  return w5 = c, w5;
}
var H5, og;
function HH() {
  if (og) return H5;
  og = 1;
  var e = wH();
  function r(t) {
    return t == null ? "" : e(t);
  }
  return H5 = r, H5;
}
var V5, sg;
function Cc() {
  if (sg) return V5;
  sg = 1;
  var e = sa(), r = NH(), t = PH(), a = HH();
  function o(l, c) {
    return e(l) ? l : r(l, c) ? [l] : t(a(l));
  }
  return V5 = o, V5;
}
var k5, lg;
function Ph() {
  if (lg) return k5;
  lg = 1;
  var e = Mh();
  function r(t) {
    if (typeof t == "string" || e(t))
      return t;
    var a = t + "";
    return a == "0" && 1 / t == -1 / 0 ? "-0" : a;
  }
  return k5 = r, k5;
}
var F5, cg;
function VH() {
  if (cg) return F5;
  cg = 1;
  var e = Cc(), r = Ph();
  function t(a, o) {
    o = e(o, a);
    for (var l = 0, c = o.length; a != null && l < c; )
      a = a[r(o[l++])];
    return l && l == c ? a : void 0;
  }
  return F5 = t, F5;
}
var U5, ug;
function p8() {
  if (ug) return U5;
  ug = 1;
  var e = Za(), r = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch (a) {
    }
  }();
  return U5 = r, U5;
}
var x5, fg;
function kH() {
  if (fg) return x5;
  fg = 1;
  var e = p8();
  function r(t, a, o) {
    a == "__proto__" && e ? e(t, a, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : t[a] = o;
  }
  return x5 = r, x5;
}
var B5, dg;
function FH() {
  if (dg) return B5;
  dg = 1;
  var e = kH(), r = Dh(), t = Object.prototype, a = t.hasOwnProperty;
  function o(l, c, u) {
    var p = l[c];
    (!(a.call(l, c) && r(p, u)) || u === void 0 && !(c in l)) && e(l, c, u);
  }
  return B5 = o, B5;
}
var $5, pg;
function UH() {
  if (pg) return $5;
  pg = 1;
  var e = FH(), r = Cc(), t = Nh(), a = Ah(), o = Ph();
  function l(c, u, p, f) {
    if (!a(c))
      return c;
    u = r(u, c);
    for (var h = -1, C = u.length, E = C - 1, m = c; m != null && ++h < C; ) {
      var S = o(u[h]), v = p;
      if (S === "__proto__" || S === "constructor" || S === "prototype")
        return c;
      if (h != E) {
        var g = m[S];
        v = f ? f(g, S, m) : void 0, v === void 0 && (v = a(g) ? g : t(u[h + 1]) ? [] : {});
      }
      e(m, S, v), m = m[S];
    }
    return c;
  }
  return $5 = l, $5;
}
var G5, hg;
function xH() {
  if (hg) return G5;
  hg = 1;
  var e = VH(), r = UH(), t = Cc();
  function a(o, l, c) {
    for (var u = -1, p = l.length, f = {}; ++u < p; ) {
      var h = l[u], C = e(o, h);
      c(C, h) && r(f, t(h, o), C);
    }
    return f;
  }
  return G5 = a, G5;
}
var Z5, _g;
function BH() {
  if (_g) return Z5;
  _g = 1;
  function e(r, t) {
    return r != null && t in Object(r);
  }
  return Z5 = e, Z5;
}
var j5, mg;
function $H() {
  if (mg) return j5;
  mg = 1;
  var e = Cc(), r = yh(), t = sa(), a = Nh(), o = Lh(), l = Ph();
  function c(u, p, f) {
    p = e(p, u);
    for (var h = -1, C = p.length, E = !1; ++h < C; ) {
      var m = l(p[h]);
      if (!(E = u != null && f(u, m)))
        break;
      u = u[m];
    }
    return E || ++h != C ? E : (C = u == null ? 0 : u.length, !!C && o(C) && a(m, C) && (t(u) || r(u)));
  }
  return j5 = c, j5;
}
var z5, Eg;
function GH() {
  if (Eg) return z5;
  Eg = 1;
  var e = BH(), r = $H();
  function t(a, o) {
    return a != null && r(a, o, e);
  }
  return z5 = t, z5;
}
var q5, Cg;
function ZH() {
  if (Cg) return q5;
  Cg = 1;
  var e = xH(), r = GH();
  function t(a, o) {
    return e(a, o, function(l, c) {
      return r(a, c);
    });
  }
  return q5 = t, q5;
}
var W5, Sg;
function jH() {
  if (Sg) return W5;
  Sg = 1;
  var e = il(), r = yh(), t = sa(), a = e ? e.isConcatSpreadable : void 0;
  function o(l) {
    return t(l) || r(l) || !!(a && l && l[a]);
  }
  return W5 = o, W5;
}
var Y5, Ig;
function zH() {
  if (Ig) return Y5;
  Ig = 1;
  var e = u8(), r = jH();
  function t(a, o, l, c, u) {
    var p = -1, f = a.length;
    for (l || (l = r), u || (u = []); ++p < f; ) {
      var h = a[p];
      o > 0 && l(h) ? o > 1 ? t(h, o - 1, l, c, u) : e(u, h) : c || (u[u.length] = h);
    }
    return u;
  }
  return Y5 = t, Y5;
}
var K5, vg;
function qH() {
  if (vg) return K5;
  vg = 1;
  var e = zH();
  function r(t) {
    var a = t == null ? 0 : t.length;
    return a ? e(t, 1) : [];
  }
  return K5 = r, K5;
}
var X5, gg;
function WH() {
  if (gg) return X5;
  gg = 1;
  function e(r, t, a) {
    switch (a.length) {
      case 0:
        return r.call(t);
      case 1:
        return r.call(t, a[0]);
      case 2:
        return r.call(t, a[0], a[1]);
      case 3:
        return r.call(t, a[0], a[1], a[2]);
    }
    return r.apply(t, a);
  }
  return X5 = e, X5;
}
var Q5, Rg;
function YH() {
  if (Rg) return Q5;
  Rg = 1;
  var e = WH(), r = Math.max;
  function t(a, o, l) {
    return o = r(o === void 0 ? a.length - 1 : o, 0), function() {
      for (var c = arguments, u = -1, p = r(c.length - o, 0), f = Array(p); ++u < p; )
        f[u] = c[o + u];
      u = -1;
      for (var h = Array(o + 1); ++u < o; )
        h[u] = c[u];
      return h[o] = l(f), e(a, this, h);
    };
  }
  return Q5 = t, Q5;
}
var J5, Dg;
function KH() {
  if (Dg) return J5;
  Dg = 1;
  function e(r) {
    return function() {
      return r;
    };
  }
  return J5 = e, J5;
}
var ep, Ag;
function XH() {
  if (Ag) return ep;
  Ag = 1;
  function e(r) {
    return r;
  }
  return ep = e, ep;
}
var tp, Tg;
function QH() {
  if (Tg) return tp;
  Tg = 1;
  var e = KH(), r = p8(), t = XH(), a = r ? function(o, l) {
    return r(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(l),
      writable: !0
    });
  } : t;
  return tp = a, tp;
}
var rp, Og;
function JH() {
  if (Og) return rp;
  Og = 1;
  var e = 800, r = 16, t = Date.now;
  function a(o) {
    var l = 0, c = 0;
    return function() {
      var u = t(), p = r - (u - c);
      if (c = u, p > 0) {
        if (++l >= e)
          return arguments[0];
      } else
        l = 0;
      return o.apply(void 0, arguments);
    };
  }
  return rp = a, rp;
}
var np, yg;
function eV() {
  if (yg) return np;
  yg = 1;
  var e = QH(), r = JH(), t = r(e);
  return np = t, np;
}
var ip, Ng;
function tV() {
  if (Ng) return ip;
  Ng = 1;
  var e = qH(), r = YH(), t = eV();
  function a(o) {
    return t(r(o, void 0, e), o + "");
  }
  return ip = a, ip;
}
var ap, Lg;
function rV() {
  if (Lg) return ap;
  Lg = 1;
  var e = ZH(), r = tV(), t = r(function(a, o) {
    return a == null ? {} : e(a, o);
  });
  return ap = t, ap;
}
var nV = rV();
const Mg = /* @__PURE__ */ Gs(nV), O2 = Gr.create("main"), Pg = (e) => {
  var r;
  return ((r = e.recognizerProcessParam.delegateProcessing) === null || r === void 0 ? void 0 : r.httpHeaders) || {};
};
function iV(e) {
  var r, t, a;
  let {
    onError: o,
    onStatusChange: l
  } = e;
  const {
    onEvent: c,
    continueInBrowserButton: u = !0
  } = ur(), {
    translate: p
  } = oa.useLocalize(), f = window.RegulaDocumentSDK, h = ((r = f.recognizerProcessParam) === null || r === void 0 ? void 0 : r.tag) || pp(), C = (((t = f.recognizerProcessParam) === null || t === void 0 || (t = t.delegateProcessing) === null || t === void 0 ? void 0 : t.delegateURL) || window.location.href).replace("{tag}", h), E = new xD({
    basePath: ((a = f.recognizerProcessParam.delegateProcessing) === null || a === void 0 ? void 0 : a.serviceURL) || "",
    baseOptions: {
      headers: Pg(f)
    }
  }), m = oe.useRef(), S = oe.useRef(), [v, g] = oe.useState(!1);
  return oe.useEffect(() => {
    O2("Remote scanner parameters: ".concat(JSON.stringify({
      tag: h,
      url: C
    })));
    const O = () => Oe(null, null, function* () {
      try {
        const {
          data: D
        } = yield E.getTransactionsByTag(h, {
          headers: Pg(f)
        }), R = G2(D.items);
        if (O2("Remote scanner transaction data: ".concat(JSON.stringify(D))), R && (yH(Mg(R, ["id", "state"]), Mg(m.current, ["id", "state"])) || (R.state === x2.UPLOADED && (c({
          action: pt.REMOTE_TRANSACTION_UPLOADED,
          data: R
        }), g(!0)), O2("Remote scanner status: UPLOADED"), m.current = R), R.state === x2.PROCESSED && R.id)) {
          clearInterval(S.current);
          const T = yield E.getReprocessTransactionResult(R.id, !0);
          O2("Remote scanner reprocess result: ".concat(JSON.stringify(T))), c({
            action: pt.REMOTE_PROCESS_FINISHED,
            data: {
              status: Li.OK,
              response: T
            }
          }), l(Ne.SUCCESS);
        }
      } catch (D) {
        clearInterval(S.current), o(new $t(rr.CONNECTION_ERROR, D)), l(Ne.FAILED);
      }
    });
    return O(), S.current = setInterval(O, 5e3), () => clearInterval(S.current);
  }, []), v ? /* @__PURE__ */ Y.jsx(Js, {}) : /* @__PURE__ */ Y.jsxs("div", { part: "remote-scanner-container", className: ea["remote-scanner-wrapper"], children: [
    /* @__PURE__ */ Y.jsxs("div", { "aria-live": "assertive", part: "remote-scanner-text", className: ea.text, children: [
      /* @__PURE__ */ Y.jsx("p", { part: "remote-scanner-title", className: ea.title, children: p("switchToMobile") }),
      /* @__PURE__ */ Y.jsx("p", { part: "remote-scanner-subtitle", className: ea.subtitle, children: p("openPhoneCamera") })
    ] }),
    /* @__PURE__ */ Y.jsxs("div", { part: "remote-scanner-content", className: ea["content-container"], children: [
      /* @__PURE__ */ Y.jsx("div", { part: "remote-scanner-qr", className: ea["qr-container"], children: /* @__PURE__ */ Y.jsx(a8, { value: C }) }),
      u && /* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
        /* @__PURE__ */ Y.jsx("div", { part: "remote-scanner-divider", className: ea.divider, children: p("or") }),
        /* @__PURE__ */ Y.jsx("button", { part: "remote-scanner-continue-button", className: ea.button, onClick: () => l(Ne.CAMERA_PROCESSING), children: p("continueInBrowser") })
      ] })
    ] })
  ] });
}
const aV = (e) => {
  var r, t;
  return !!((r = e.recognizerProcessParam.delegateProcessing) !== null && r !== void 0 && r.serviceURL) && !!((t = e.recognizerProcessParam) !== null && t !== void 0 && (t = t.delegateProcessing) !== null && t !== void 0 && t.delegateURL) && !Kt.isMobile;
}, oV = (e, r, t, a) => e ? r ? t ? "fromCameraGalleryMobile" : "fromMobileDesktop" : t ? "fromGalleryMobile" : "" : r ? t ? a ? "fromCameraFilesMobileDesktop" : "fromCameraFilesDesktop" : a ? "fromCameraMobileDesktop" : "fromCameraDesktop" : t ? a ? "fromFilesMobileDesktop" : "fromFilesDesktop" : a ? "fromMobileDesktop" : "", sV = (e, r, t, a) => e ? Ne.CHOOSE_INPUT_SOURCE : r ? Ne.CAMERA_PROCESSING : !r && a && !t ? Ne.REMOTE_SCANNER : Ne.CONFIGURATION_ERROR, lV = (e, r, t, a, o, l) => {
  const c = t && (o || r), u = a && (l || r);
  return e ? (t ? c : !0) && (a ? u : !0) : o || r;
}, ln = {
  "verified-screen": "_verified-screen_evxkx_1",
  "error-screen": "_error-screen_evxkx_5",
  "camera-disabled-screen": "_camera-disabled-screen_evxkx_9"
};
function cV(e) {
  let {
    direction: r
  } = e;
  const {
    onEvent: t,
    startScreen: a,
    internalScenario: o,
    fromCameraButton: l = !0,
    uploadFileButton: c = !0
  } = ur(), u = window.RegulaDocumentSDK, p = aV(u), f = sV(!!a, l, c, p), {
    translate: h
  } = oa.useLocalize(), {
    orientation: C
  } = tw(), [E, m] = oe.useState(null), [S, v] = oe.useState(f), g = () => {
    t({
      action: pt.PRESS_CAMERA_BUTTON,
      data: null
    }), v(Ne.CAMERA_PROCESSING);
  }, O = () => {
    t({
      action: pt.CLOSE,
      data: null
    });
  }, D = (L) => {
    m(L), v(Ne.FILE_PROCESSING);
  }, R = () => {
    v(Ne.REMOTE_SCANNER);
  }, T = (L) => {
    const k = SR[L.type] || Ne.UNKNOWN_ERROR;
    v(k), t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.ERROR,
        reason: L.type,
        details: L.details
      }
    });
  }, N = () => {
    m(null), v(f);
  }, b = () => {
    t({
      action: pt.PRESS_RETRY_BUTTON,
      data: null
    }), v(Ne.CAMERA_PROCESSING);
  };
  return oe.useEffect(() => {
    !Kt.isMobile || S !== Ne.CAMERA_PROCESSING || N();
  }, [C]), oe.useLayoutEffect(() => {
    const L = u.recognizerProcessParam.processParam.scenario, k = u.imageProcessParam.processParam.scenario;
    if (!lV(!!a, !!o, l, c, !!L, !!k))
      return T(new $t(rr.MISSING_SCENARIO, "Set processing scenario (video and image)"));
    if (f === Ne.CONFIGURATION_ERROR)
      return T(new $t(rr.BAD_CONFIGURATION, "Incorrect component configuration"));
  }, [o, a, l, c, f]), /* @__PURE__ */ Y.jsx(oe.StrictMode, { children: /* @__PURE__ */ Y.jsx(qD, { onError: T, supportedBrowserVersions: IR, children: /* @__PURE__ */ Y.jsx(Ch, { showHeaderAndFooter: S !== Ne.CAMERA_PROCESSING, onClose: O, direction: r, children: S === Ne.CHOOSE_INPUT_SOURCE ? /* @__PURE__ */ Y.jsx(ZD, { onStart: g, onFileImageSet: D, allowRemote: p, onRemoteDevice: R, title: h("verifyYourIdentity"), subtitle: h(oV(Kt.isMobile, l, c, p)) }) : S === Ne.CAMERA_PROCESSING ? /* @__PURE__ */ Y.jsx(Vb, { onStatusChange: v, onFileImageSet: D, onError: T, onClose: O }) : S === Ne.FILE_PROCESSING ? /* @__PURE__ */ Y.jsx(Kb, { onStatusChange: v, images: E, onError: T }) : S === Ne.REMOTE_SCANNER ? /* @__PURE__ */ Y.jsx(iV, { onError: T, onStatusChange: v }) : S === Ne.SUCCESS ? /* @__PURE__ */ Y.jsx(tr, { className: ln["verified-screen"], title: h("done") }) : S === Ne.FILE_SIZE_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("largeFile") }) : S === Ne.NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("versionNotSupported") }) : S === Ne.WASM_LICENSE_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("badLicense") }) : S === Ne.INCORRECT_FILE_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("fileCorrupt") }) : S === Ne.CAMERA_PERMISSION_DENIED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["camera-disabled-screen"], title: h("cameraUnavailable") }) : S === Ne.HTTP_NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("httpNotSupported") }) : S === Ne.INSECURE_PAGE_CONTEXT_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("insecurePageContext") }) : S === Ne.NO_CAMERA_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["camera-disabled-screen"], title: h("noCameraAvailable") }) : S === Ne.INCORRECT_CAMERA_ID_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: ln["camera-disabled-screen"], title: h("incorrectCameraId") }) : S === Ne.TIMEOUT ? /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("timeout"), onReset: b }) : S === Ne.DELEGATE_SUCCESS ? /* @__PURE__ */ Y.jsx(tr, { className: ln["verified-screen"], title: h("returnToComputer"), subtitle: h("documentCaptured") }) : S === Ne.PROCESSING ? /* @__PURE__ */ Y.jsx(Js, {}) : /* @__PURE__ */ Y.jsx(tr, { className: ln["error-screen"], title: h("somethingWentWrong") }) }) }) });
}
const uV = wR(zD, jD)(cV), h8 = `*,*:before,*:after{box-sizing:border-box}:host{display:block;container-type:inline-size;container-name:host;width:100%;height:100%}._window_m3xyu_14{width:100%;height:100%;display:flex;flex-direction:column;background:#fff;box-shadow:0 8px 16px #0000000a,0 2px 4px #00000008,0 1px 2px #00000005;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);font-family:Inter,sans-serif}._window_m3xyu_14[data-direction=rtl]{direction:rtl}._window_m3xyu_14[data-direction=ltr]{direction:ltr}._header_m3xyu_36{display:flex;justify-content:flex-end;padding:16px 16px 0}._header_m3xyu_36 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:background .25s ease-in-out,transform .15s ease;appearance:none}._footer_m3xyu_57{display:flex;align-items:center;padding:0 16px 10px}._close-button_m3xyu_63:before{content:"";display:inline-flex;width:24px;height:24px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20width='24'%20height='24'%20fill='%238C8C8C'%3e%3cpath%20d='M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z'/%3e%3c/svg%3e");background-repeat:no-repeat;background-position:center;background-size:contain}._close-button_m3xyu_63:focus-visible{outline:2px solid blue}@media (max-width: 640px){._footer_m3xyu_57{justify-content:center}}@container host (max-width: 640px){._footer_m3xyu_57{justify-content:center}}`, _8 = `._start-window_1ywb7_1{display:flex;flex:1;align-items:center;justify-content:center;flex-direction:column;row-gap:24px;padding:24px}._text_1ywb7_11{display:flex;flex-direction:column;row-gap:16px;align-items:center;text-align:center}._title_1ywb7_19{max-width:500px;color:#000;font-size:20px;font-weight:600;line-height:20px;margin:0}._subtitle_1ywb7_28{display:block;max-width:465px;color:#454545;font-size:14px;font-weight:400;line-height:20px;margin:0}._buttons_1ywb7_38{display:flex;width:100%;align-items:center;justify-content:center;column-gap:16px}._camera-button_1ywb7_46:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_211)'%3e%3cpath%20d='M16.1697%205.75397L16.2882%206.08594H16.6406H19.5625C20.236%206.08594%2020.7812%206.63122%2020.7812%207.30469V17.1016C20.7812%2017.775%2020.236%2018.3203%2019.5625%2018.3203H4.4375C3.76403%2018.3203%203.21875%2017.775%203.21875%2017.1016V7.30469C3.21875%206.63122%203.76403%206.08594%204.4375%206.08594H7.35938H7.71147L7.83013%205.75443L8.52837%203.80365L8.52891%203.80215C8.55435%203.73034%208.6245%203.67969%208.7043%203.67969L15.2957%203.67969L15.2961%203.67969C15.3351%203.67965%2015.373%203.69163%2015.4049%203.714C15.4366%203.73627%2015.4607%203.76776%2015.474%203.80419C15.474%203.80433%2015.4741%203.80448%2015.4741%203.80463L16.1697%205.75397ZM8.0625%2011.9453C8.0625%2014.1207%209.82464%2015.8828%2012%2015.8828C14.1754%2015.8828%2015.9375%2014.1207%2015.9375%2011.9453C15.9375%209.76995%2014.1754%208.00781%2012%208.00781C9.82464%208.00781%208.0625%209.76995%208.0625%2011.9453Z'%20stroke='%23211236'/%3e%3ccircle%20cx='18'%20cy='9'%20r='1'%20fill='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_211'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._gallery-button_1ywb7_50:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_213)'%3e%3cpath%20d='M11.685%2010.2487H15.4872V11.0062H11.684L11.685%2010.2487Z'%20fill='%23211236'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.3862%2014.1034L9.83531%2012.3636L8.00871%2011.9563L6.69453%2013.5517L5.37938%2011.9563L3.54894%2012.3636L3%2014.1034V7H10.39L10.3862%2014.1034ZM8.00679%208.11942V10.1613C8.00676%2010.3969%207.93334%2010.6274%207.79537%2010.8252C7.6574%2011.023%207.46075%2011.1796%207.22905%2011.2763C7.05875%2011.348%206.87387%2011.3851%206.68683%2011.385C6.4998%2011.3851%206.31492%2011.348%206.14463%2011.2763C5.91292%2011.1796%205.71627%2011.023%205.5783%2010.8252C5.44033%2010.6274%205.36691%2010.3969%205.36688%2010.1613V8.11942H8.00679Z'%20fill='%23211236'/%3e%3cpath%20d='M19%2016H11.684V15.2424H19V16Z'%20fill='%23211236'/%3e%3cpath%20d='M19%2013.5045H11.684V12.7469H19V13.5045Z'%20fill='%23211236'/%3e%3cpath%20d='M1.31939%204.66349C1.45107%204.5964%201.62491%204.55031%201.92748%204.52559C2.2359%204.50039%202.63205%204.50001%203.20034%204.50001L18.8%204.50004C19.3683%204.50004%2019.7645%204.50043%2020.0729%204.52563C20.3755%204.55035%2020.5493%204.59644%2020.681%204.66353C20.9632%204.80735%2021.1927%205.03682%2021.3365%205.31906C21.4036%205.45074%2021.4497%205.62458%2021.4744%205.92716C21.4996%206.23558%2021.5%206.63174%2021.5%207.20004L21.5%2015.8C21.5%2016.3683%2021.4996%2016.7645%2021.4744%2017.0729C21.4497%2017.3755%2021.4036%2017.5493%2021.3365%2017.681C21.1927%2017.9632%2020.9632%2018.1927%2020.681%2018.3365C20.5493%2018.4036%2020.3755%2018.4497%2020.0729%2018.4744C19.7645%2018.4996%2019.3683%2018.5%2018.8%2018.5L3.20009%2018.5C2.63177%2018.5%202.23561%2018.4996%201.92718%2018.4744C1.62459%2018.4497%201.45074%2018.4036%201.31906%2018.3365C1.03681%2018.1927%200.80734%2017.9632%200.663533%2017.681C0.596441%2017.5493%200.550357%2017.3754%200.525643%2017.0728C0.500451%2016.7644%200.500073%2016.3682%200.500089%2015.7999L0.500329%207.19993C0.500345%206.63164%200.500745%206.23549%200.525952%205.92708C0.550682%205.62451%200.596772%205.45067%200.663867%205.31899C0.80768%205.03676%201.03715%204.80729%201.31939%204.66349Z'%20stroke='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_213'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._phone-button_1ywb7_54:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_218)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M20.782%201.0924C21%201.52022%2021%202.08025%2021%203.20033L21%2018.8C21%2019.9201%2021%2020.4802%2020.782%2020.908C20.5902%2021.2843%2020.2843%2021.5903%2019.9079%2021.782C19.4801%2022%2018.9201%2022%2017.8%2022H12.2C11.0799%2022%2010.5198%2022%2010.092%2021.782C9.71569%2021.5903%209.40973%2021.2843%209.21799%2020.908C9%2020.4802%209%2019.9201%209%2018.8V3.20012C9%202.07998%209%201.51991%209.218%201.09208C9.40975%200.715752%209.71573%200.409789%2010.0921%200.218047C10.5199%206.59147e-05%2011.08%208.49657e-05%2012.2001%200.000123068H12.2001L17.8001%200.000319782C18.9202%200.00035892%2019.4802%200.000378489%2019.908%200.218371C20.2843%200.410123%2020.5903%200.716083%2020.782%201.0924ZM10.109%201.54601C10%201.75992%2010%202.03995%2010%202.6V19.4C10%2019.9601%2010%2020.2401%2010.109%2020.454C10.2049%2020.6422%2010.3578%2020.7951%2010.546%2020.891C10.7599%2021%2011.0399%2021%2011.6%2021H18.4C18.9601%2021%2019.2401%2021%2019.454%2020.891C19.6422%2020.7951%2019.7951%2020.6422%2019.891%2020.454C20%2020.2401%2020%2019.9601%2020%2019.4V2.6C20%202.03995%2020%201.75992%2019.891%201.54601C19.7951%201.35785%2019.6422%201.20487%2019.454%201.10899C19.2401%201%2018.9601%201%2018.4%201H11.6C11.0399%201%2010.7599%201%2010.546%201.10899C10.3578%201.20487%2010.2049%201.35785%2010.109%201.54601Z'%20fill='%23211236'/%3e%3ccircle%20cx='15'%20cy='19'%20r='1'%20fill='%23211236'/%3e%3cpath%20d='M12%201H18C18%201.55228%2017.5523%202%2017%202H13C12.4477%202%2012%201.55228%2012%201Z'%20fill='%23211236'/%3e%3cpath%20d='M0%209.75H6V10.75H0V9.75Z'%20fill='%23211236'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.83358%2010.9314C7.199%2010.5452%207.19835%209.94063%206.83211%209.55524L4.56028%207.16458C4.36668%206.96085%204.04324%206.95673%203.84451%207.15546C3.65282%207.34715%203.64888%207.6567%203.83562%207.85321L5.45448%209.55675C5.82072%209.94215%205.82137%2010.5467%205.45596%2010.9329L3.83418%2012.6469C3.64815%2012.8435%203.65242%2013.1524%203.8438%2013.3438C4.04282%2013.5428%204.36683%2013.5383%204.56027%2013.3339L6.83358%2010.9314Z'%20fill='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_218'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}@media (max-width: 640px){._buttons_1ywb7_38{flex-direction:column;row-gap:16px}._title_1ywb7_19{font-size:18px}}@container host (max-width: 640px){._buttons_1ywb7_38{flex-direction:column;row-gap:16px}._title_1ywb7_19{font-size:18px}}`, m8 = `._info-message_1fk4r_1{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;padding:24px}._text-container_1fk4r_10{display:flex;flex-direction:column;align-items:center;word-break:break-word;row-gap:16px}._text-container_1fk4r_10:before{content:"";display:inline-flex;width:80px;height:80px;background-repeat:no-repeat;background-position:center;background-size:contain}._title_1fk4r_28{margin:0;font-size:20px;font-weight:600;line-height:120%;color:#262626;text-align:center}._subtitle_1fk4r_37{margin:0;font-size:16px;font-weight:400;line-height:100%;color:#454545;text-align:center}._retry-button_1fk4r_46:before{background-image:url("data:image/svg+xml,%3csvg%20width='21'%20height='20'%20viewBox='0%200%2021%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.5737%204.07891C15.4824%203.99597%2015.3891%203.91522%2015.2939%203.83677M15.5737%204.07891L15.2939%203.83677M15.5737%204.07891C16.2977%204.73614%2016.9002%205.53165%2017.3422%206.42526M15.2939%203.83677C13.9798%202.7533%2012.3118%202.10522%2010.4966%202.10522C8.07269%202.10522%205.91117%203.26089%204.50449%205.06575M16.9822%2014.2243C15.621%2016.4305%2013.2251%2017.8947%2010.4966%2017.8947C7.51384%2017.8947%204.92843%2016.1447%203.65796%2013.5885'%20stroke='%23211236'%20stroke-linecap='round'/%3e%3cpath%20d='M18.0873%202.58536L17.4019%206.47276L13.5145%205.7873'%20stroke='%23211236'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M2.6126%2017.2589L3.29805%2013.3715L7.18545%2014.0569'%20stroke='%23211236'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`, E8 = "._container_bzjwi_1,._layout_bzjwi_2{display:flex;overflow:hidden}._container_bzjwi_1{position:relative;width:100%;height:100%}._layout_bzjwi_2{justify-content:center;position:absolute;inset:0}._loader_bzjwi_19{position:absolute;inset:0;box-shadow:none}", C8 = `._top-functional-buttons_1ua8y_1,._bottom-functional-buttons_1ua8y_2,._left-functional-buttons_1ua8y_3{position:absolute;padding:15px;display:flex;gap:15px}._top-functional-buttons_1ua8y_1{top:0}._bottom-functional-buttons_1ua8y_2{bottom:0}._bottom-functional-buttons_1ua8y_2 button:focus-visible,._top-functional-buttons_1ua8y_1 button:focus-visible,._left-functional-buttons_1ua8y_3 button:focus-visible{outline:2px solid blue}._left-functional-buttons_1ua8y_3{bottom:50%;transform:translateY(50%);direction:ltr}._top-functional-buttons_1ua8y_1 button:hover,._left-functional-buttons_1ua8y_3 button:hover{transform:scale(1.1)}._top-functional-buttons_1ua8y_1 button,._bottom-functional-buttons_1ua8y_2 button,._left-functional-buttons_1ua8y_3 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:background .25s ease-in-out,transform .15s ease}._left-functional-buttons_1ua8y_3 ._skip-button_1ua8y_51{padding:0 10px;border-radius:6px;background-color:#1b101f80}._controls-container_1ua8y_57 button:before{content:"";display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:contain}._process-close-button_1ua8y_65:before{width:24px;height:24px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20width='24'%20height='24'%20fill='%23ffffff'%3e%3cpath%20d='M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z'/%3e%3c/svg%3e")}._process-button_1ua8y_71:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.6'%3e%3ccircle%20cx='30'%20cy='30'%20r='29.5'%20stroke='white'/%3e%3c/g%3e%3ccircle%20cx='30'%20cy='30'%20r='21'%20fill='white'/%3e%3c/svg%3e")}._snapshot-button_1ua8y_77:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.6'%3e%3ccircle%20cx='30'%20cy='30'%20r='29.5'%20stroke='white'/%3e%3c/g%3e%3ccircle%20cx='30'%20cy='30'%20r='21'%20fill='white'/%3e%3c/svg%3e")}._skip-button_1ua8y_51:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='white'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z'/%3e%3c/svg%3e")}._mirror-back-button_1ua8y_89:before{width:30px;height:30px;background-image:url("data:image/svg+xml,%3csvg%20width='30'%20height='30'%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.9'%3e%3crect%20x='14'%20y='4'%20width='2'%20height='22'%20rx='1'%20fill='white'/%3e%3cpath%20d='M8.698%2015%20L1%205.762%201%2024.238%20Z'%20stroke='white'%20stroke-width='2'/%3e%3cpath%20d='M21.302%2015%20L29%205.762%2029%2024.238%20Z'%20fill='white'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3c/svg%3e")}._mirror-front-button_1ua8y_95:before{width:30px;height:30px;background-image:url("data:image/svg+xml,%3csvg%20width='30'%20height='30'%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.9'%3e%3crect%20x='14'%20y='4'%20width='2'%20height='22'%20rx='1'%20fill='white'/%3e%3cpath%20d='M21.302%2015%20L29%205.762%2029%2024.238%20Z'%20stroke='white'%20stroke-width='2'/%3e%3cpath%20d='M8.698%2015%20L1%205.762%201%2024.238%20Z'%20fill='white'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3c/svg%3e")}._change-camera-button_1ua8y_101:before{width:33px;height:33px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='white'%3e%3cpath%20d='M12.29,5.21l1.5,1.5a1,1,0,0,0,1.42,0,1,1,0,0,0,.13-1.21H19a1,1,0,0,0,0-2H15.34a1,1,0,0,0-.13-1.21,1,1,0,0,0-1.42,0l-1.5,1.5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76A1,1,0,0,0,12.29,5.21ZM22.92,9.12a1,1,0,0,0-.21-.33l-1.5-1.5a1,1,0,0,0-1.42,0,1,1,0,0,0-.13,1.21H16a1,1,0,0,0,0,2h3.66a1,1,0,0,0,.13,1.21,1,1,0,0,0,1.42,0l1.5-1.5a1,1,0,0,0,.21-.33A1,1,0,0,0,22.92,9.12ZM11,10a4,4,0,1,0,4,4A4,4,0,0,0,11,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,11,16Zm9-3a1,1,0,0,0-1,1v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H6a1,1,0,0,0,1-.69l.54-1.62A1,1,0,0,1,8.44,7H10a1,1,0,0,0,0-2H8.44A3,3,0,0,0,5.59,7.06L5.28,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V14A1,1,0,0,0,20,13Z'/%3e%3c/svg%3e")}div[data-orientation=landscape] ._top-functional-buttons_1ua8y_1,div[data-orientation=landscape] ._left-functional-buttons_1ua8y_3,div[data-direction=rtl] div[data-orientation=portrait] ._top-functional-buttons_1ua8y_1,._bottom-functional-buttons_1ua8y_2{left:0}div[data-orientation=portrait] ._bottom-functional-buttons_1ua8y_2,div[data-direction=ltr] div[data-orientation=portrait] ._top-functional-buttons_1ua8y_1{right:0}div[data-orientation=portrait] ._left-functional-buttons_1ua8y_3{bottom:0;right:50%;transform:translate(50%);flex-direction:column-reverse;z-index:1}div[data-orientation=landscape] ._bottom-functional-buttons_1ua8y_2{flex-direction:column}div[data-orientation=portrait] ._bottom-functional-buttons_1ua8y_2{justify-content:space-between}`, S8 = '._svg_15k34_1{position:absolute;inset:0}._svg_15k34_1 rect,._svg_15k34_1 path{transition:.25s stroke}._svg_15k34_1 rect[mask="url(#bgClip)"]{opacity:.5}', I8 = `._hint-container_13yzs_1{display:flex;justify-content:center;position:absolute;inset:0;--message-top: 50px;--indicator-top: -50%}._tips-frameless_13yzs_10 ._message_13yzs_10{margin:0 36px}._fade-enter_13yzs_14{opacity:0}._fade-exit_13yzs_18,._fade-enter-active_13yzs_22{opacity:1}._fade-exit-active_13yzs_26{opacity:0}._fade-enter-active_13yzs_22,._fade-exit-active_13yzs_26{transition:opacity .3s}._message-container_13yzs_35{display:flex;flex-direction:column;width:100%;max-width:370px;position:relative;align-self:center;align-items:center}._icon_13yzs_45{position:absolute;display:flex;justify-content:center;align-items:center;transform:translateY(var(--indicator-top))}._message-container_13yzs_35 ._icon_13yzs_45:before{content:"";display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:contain}._processing-error-icon_13yzs_61:before{width:80px;height:80px;background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='40'%20fill='%23E95454'%20fill-opacity='0.45'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M40%2067C54.9117%2067%2067%2054.9117%2067%2040C67%2025.0883%2054.9117%2013%2040%2013C25.0883%2013%2013%2025.0883%2013%2040C13%2054.9117%2025.0883%2067%2040%2067ZM40%2064C53.2548%2064%2064%2053.2548%2064%2040C64%2026.7452%2053.2548%2016%2040%2016C26.7452%2016%2016%2026.7452%2016%2040C16%2053.2548%2026.7452%2064%2040%2064Z'%20fill='white'/%3e%3c/svg%3e")}._search-icon_13yzs_67:before{width:80px;height:80px;background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%3e%3ccircle%20cx='40'%20cy='40'%20r='40'%20fill='%231B101F'%20fill-opacity='0.5'/%3e%3c/g%3e%3cg%20opacity='0.8'%3e%3ccircle%20cx='40'%20cy='40'%20r='23.5'%20stroke='white'/%3e%3ccircle%20cx='40'%20cy='40'%20r='1'%20fill='white'/%3e%3c/g%3e%3c/svg%3e")}._square-icon_13yzs_73:before{width:46px;height:46px;background-image:url("data:image/svg+xml,%3csvg%20width='46'%20height='46'%20viewBox='0%200%2046%2046'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M45%2034V41C45%2043.2091%2043.2091%2045%2041%2045H34M45%2012V5C45%202.79086%2043.2091%201%2041%201H34M12%201H5C2.79086%201%201%202.79086%201%205V12M1%2034V41C1%2043.2091%202.79086%2045%205%2045H12'%20stroke='white'%20stroke-width='1.5'/%3e%3c/svg%3e")}._message_13yzs_10{position:absolute;left:0;right:0;display:flex;justify-content:center;transform:translateY(var(--message-top))}._message-background_13yzs_88{text-align:center;padding:12px 24px;border-radius:6px;color:#fff;background-color:#1b101f80}._title_13yzs_96{font-weight:400;margin:0;font-size:18px;line-height:21px}._copyright_13yzs_103{position:absolute;bottom:10px;right:20px;filter:drop-shadow(0 0 2px rgba(0,0,0,.5))}._copyright_13yzs_103 span{color:#e9e9e9}`, v8 = `._flip_194nz_1,._one-side_194nz_2{width:70%;height:100%;position:relative;align-self:center;perspective:1000px}._front_194nz_10:before,._back_194nz_11:before,._one-side_194nz_2:before{content:"";width:100%;height:100%;display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:100% auto}._slide_194nz_22:before{background-position:center 115%;animation:_slide_194nz_22 var(--animation-duration) var(--animation-delay) ease-out forwards}._front_194nz_10,._back_194nz_11{position:absolute;display:flex;justify-content:center;align-items:center;top:0;left:0;width:100%;height:100%;backface-visibility:hidden;-webkit-backface-visibility:hidden}._front_194nz_10{z-index:2;animation:_flip-front_194nz_1 var(--animation-duration) var(--animation-delay) ease-out forwards}._back_194nz_11{transform:rotateY(180deg);animation:_flip-back_194nz_1 var(--animation-duration) var(--animation-delay) ease-out forwards}._id-front-icon_194nz_51:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.246%2028.1982H22.4961V126.887C22.4962%20124.482%2027.1732%20123.323%2032.6526%20121.964C39.93%20120.16%2048.6229%20118.005%2049.6542%20112.116C44.6713%20108.96%2042.7698%20104.198%2040.8243%2099.3255C40.4465%2098.3791%2040.0669%2097.4286%2039.6629%2096.485C34.7738%20101.236%2032.5935%2079.4764%2036.9774%2079.4764C28.6435%2056.9793%2051.4615%2038.5191%2072.545%2051.2088C84.91%2048.5382%2091.7424%2063.3145%2084.3766%2079.4768C87.4153%2078.0182%2087.9964%2085.7946%2087.4153%2090.6287C87.4153%2091.8706%2086.1245%20100.564%2082.8626%2097.1966C82.4668%2098.1115%2082.0949%2099.0331%2081.7247%2099.9507L81.7241%2099.9523L81.7239%2099.9527C79.768%20104.801%2077.8573%20109.537%2072.6874%20112.594C74.1725%20118.123%2083.0554%20120.21%2090.5254%20121.964C96.3092%20123.323%20101.246%20124.482%20101.246%20126.887V28.1982Z'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='104.327'%20width='59.0625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='182.812'%20y='104.327'%20width='64.6875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='28.1963'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='53.5742'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='78.9512'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='129.704'%20width='135'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-single-icon_194nz_55:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='219'%20viewBox='0%200%20309%20219'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%20196.527C1.40455%20200.484%201.40564%20203.366%201.59124%20205.638C1.7755%20207.893%202.13459%20209.422%202.78232%20210.693C3.99425%20213.072%205.92806%20215.006%208.3066%20216.218C9.57784%20216.865%2011.1068%20217.225%2013.3621%20217.409C15.6337%20217.594%2018.5165%20217.595%2022.4727%20217.595H286.527C290.484%20217.595%20293.366%20217.594%20295.638%20217.409C297.893%20217.225%20299.422%20216.865%20300.693%20216.218C303.072%20215.006%20305.006%20213.072%20306.218%20210.693C306.865%20209.422%20307.224%20207.893%20307.409%20205.638C307.594%20203.366%20307.595%20200.484%20307.595%20196.527V1.40454H1.40455V196.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%2033.6924H22.4727V129.154H22.4727C22.4729%20126.828%2026.8105%20125.706%2031.8923%20124.392L31.8924%20124.392C38.6418%20122.647%2046.7039%20120.562%2047.6604%20114.866C43.039%20111.813%2041.2755%20107.207%2039.4712%20102.494L39.4711%20102.494C39.1207%20101.578%2038.7687%20100.659%2038.394%2099.7463C33.8596%20104.342%2031.8376%2083.2938%2035.9034%2083.2938C28.1741%2061.5324%2049.3366%2043.6758%2068.8904%2055.9505C80.3582%2053.3672%2086.695%2067.6604%2079.8636%2083.2943C82.6818%2081.8833%2083.2207%2089.4054%2082.6818%2094.0815C82.6818%2095.2828%2081.4847%20103.692%2078.4594%20100.435C78.0921%20101.32%2077.747%20102.212%2077.4035%20103.1L77.4034%20103.1L77.4033%20103.101C75.5893%20107.79%2073.8173%20112.371%2069.0225%20115.329C70.3998%20120.677%2078.6382%20122.695%2085.5662%20124.392C90.9184%20125.703%2095.4886%20126.823%2095.509%20129.138V33.6924Z'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='160.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='53.3457'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='73'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='92.6543'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='112.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='131.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='185.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-both-pages-icon_194nz_59:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='438'%20viewBox='0%200%20309%20438'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%2022.4727C1.40455%2018.5165%201.40564%2015.6337%201.59124%2013.3621C1.7755%2011.1068%202.13459%209.57784%202.78232%208.3066C3.99425%205.92806%205.92806%203.99425%208.3066%202.78232C9.57784%202.13459%2011.1068%201.7755%2013.3621%201.59124C15.6337%201.40564%2018.5165%201.40455%2022.4727%201.40455H286.527C290.484%201.40455%20293.366%201.40564%20295.638%201.59124C297.893%201.7755%20299.422%202.13459%20300.693%202.78232C303.072%203.99425%20305.006%205.92806%20306.218%208.3066C306.865%209.57784%20307.224%2011.1068%20307.409%2013.3621C307.594%2015.6337%20307.595%2018.5165%20307.595%2022.4727V217.595H1.40455V22.4727Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20d='M1.40455%20415.527C1.40455%20419.484%201.40564%20422.366%201.59124%20424.638C1.7755%20426.893%202.13459%20428.422%202.78232%20429.693C3.99425%20432.072%205.92806%20434.006%208.3066%20435.218C9.57784%20435.865%2011.1068%20436.225%2013.3621%20436.409C15.6337%20436.594%2018.5165%20436.595%2022.4727%20436.595H286.527C290.484%20436.595%20293.366%20436.594%20295.638%20436.409C297.893%20436.225%20299.422%20435.865%20300.693%20435.218C303.072%20434.006%20305.006%20432.072%20306.218%20429.693C306.865%20428.422%20307.224%20426.893%20307.409%20424.638C307.594%20422.366%20307.595%20419.484%20307.595%20415.527V220.405H1.40455V415.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3crect%20x='22.4727'%20y='379.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='272.346'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='292'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='311.654'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='331.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='350.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='404.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%20252.692H22.4727V348.154H95.509V348.154H22.4727C22.4727%20345.828%2026.8104%20344.706%2031.8923%20343.392L31.8924%20343.392C38.6418%20341.647%2046.7039%20339.562%2047.6604%20333.866C43.039%20330.813%2041.2755%20326.206%2039.4712%20321.494L39.4711%20321.493C39.1207%20320.578%2038.7687%20319.659%2038.394%20318.746C33.8596%20323.342%2031.8376%20302.294%2035.9034%20302.294C28.1741%20280.532%2049.3366%20262.676%2068.8904%20274.95C80.3582%20272.367%2086.695%20286.66%2079.8636%20302.294C82.6818%20300.883%2083.2207%20308.405%2082.6818%20313.081C82.6818%20314.282%2081.4847%20322.692%2078.4594%20319.434C78.0921%20320.32%2077.747%20321.212%2077.4035%20322.1L77.4034%20322.1L77.4033%20322.1C75.5893%20326.79%2073.8173%20331.371%2069.0225%20334.328C70.3998%20339.677%2078.6382%20341.695%2085.5662%20343.392C90.9184%20344.703%2095.4886%20345.823%2095.509%20348.138V252.692Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-front-icon_194nz_63:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='112.5'%20y='25.377'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='76.1309'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='225'%20height='11.2787'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.25%2025.377H22.5V124.065C22.5003%20121.661%2027.1772%20120.502%2032.6565%20119.143C39.9339%20117.339%2048.6268%20115.184%2049.6581%20109.295C44.6752%20106.139%2042.7737%20101.377%2040.8282%2096.5044C40.4504%2095.558%2040.0708%2094.6075%2039.6668%2093.6639C34.7777%2098.4148%2032.5974%2076.6553%2036.9813%2076.6553C28.6474%2054.1582%2051.4654%2035.698%2072.5489%2048.3877C84.9139%2045.717%2091.7464%2060.4934%2084.3805%2076.6557C87.4192%2075.1971%2088.0003%2082.9735%2087.4192%2087.8076C87.4192%2089.0495%2086.1284%2097.7429%2082.8665%2094.3755C82.4704%2095.2911%2082.0983%2096.2133%2081.7279%2097.1316C79.7719%20101.98%2077.8612%20106.715%2072.6914%20109.773C74.1764%20115.302%2083.0593%20117.388%2090.5293%20119.143C96.3129%20120.502%20101.25%20121.661%20101.25%20124.065V25.377Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-back-icon_194nz_67:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='171.562'%20y='22.5576'%20width='75.9375'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='154.688'%20y='138.164'%20width='92.8125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='73.3115'%20width='73.125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='50.625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-back-icon_194nz_71:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='25.377'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3c/svg%3e")}._id-barcode-back-icon_194nz_75:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='225'%20height='33.8361'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56590)'%3e%3cpath%20d='M247.5%2022.5576H22.5V64.8527H247.5V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.4999%2022.5576H22.5V27.257H37.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2022.5576H39.375V27.257H41.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2022.5576H43.1328V27.257H45.0079V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2022.5576H46.8672V27.257H48.7423V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2022.5576H54.3828V27.257H63.7577V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2022.5576H65.6211V27.257H67.4962V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2022.5576H69.3789V27.257H71.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2022.5576H73.125V27.257H82.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2022.5576H86.2422V27.257H89.9921V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.754%2022.5576H91.8789V27.257H93.754V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2022.5576H95.625V27.257H99.3749V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.621%2022.5576H104.996V27.257H110.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2022.5576H118.125V27.257H121.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2022.5576H129.375V27.257H133.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2022.5576H135V27.257H136.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2022.5576H138.758V27.257H140.633V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2022.5576H149.996V27.257H151.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2022.5576H153.754V27.257H159.379V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.508%2022.5576H166.883V27.257H172.508V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2022.5576H174.375V27.257H176.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2022.5576H181.879V27.257H191.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2022.5576H193.129V27.257H195.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2022.5576H196.875V27.257H198.75V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2022.5576H200.621V27.257H209.996V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2022.5576H213.75V27.257H226.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2022.5576H228.746V27.257H230.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2022.5576H236.25V27.257H238.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2022.5576H240.008V27.257H241.883V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2022.5576H245.621V27.257H247.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2027.2578H22.5V31.9572H37.4999V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2027.2578H39.375V31.9572H41.2501V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2027.2578H43.1328V31.9572H45.0079V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2027.2578H46.8672V31.9572H48.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8829%2027.2578H54.3828V31.9572H61.8829V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.629%2027.2578H63.7539V31.9572H65.629V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2027.2578H67.5V31.9572H69.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7462%2027.2578H76.8711V31.9572H78.7462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8672%2027.2578H86.2422V31.9572H91.8672V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2027.2578H97.5039V31.9572H99.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M105%2027.2578H101.25V31.9572H105V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2027.2578H110.633V31.9572H112.508V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2027.2578H118.125V31.9572H121.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2027.2578H125.629V31.9572H133.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2027.2578H135V31.9572H136.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2027.2578H138.758V31.9572H148.133V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.621%2027.2578H149.996V31.9572H155.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2027.2578H161.246V31.9572H163.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.375%2027.2578H168.75V31.9572H174.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2027.2578H176.254V31.9572H180.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2027.2578H181.879V31.9572H189.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2027.2578H191.25V31.9572H193.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.883%2027.2578H195.008V31.9572H196.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.496%2027.2578H200.621V31.9572H202.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2027.2578H213.75V31.9572H226.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2027.2578H228.746V31.9572H230.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2027.2578H236.25V31.9572H238.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2027.2578H240.008V31.9572H241.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2027.2578H245.621V31.9572H247.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2031.9561H22.5V36.6555H37.4999V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2031.9561H39.375V36.6555H41.2501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2031.9561H43.1328V36.6555H45.0079V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2031.9561H46.8672V36.6555H48.7423V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.2579%2031.9561H54.3828V36.6555H56.2579V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9923%2031.9561H58.1172V36.6555H59.9923V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2031.9561H61.875V36.6555H63.7501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2031.9561H67.5V36.6555H75.0001V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2031.9561H86.2422V36.6555H89.9921V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2031.9561H91.8789V36.6555H103.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2031.9561H104.996V36.6555H108.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2031.9561H110.633V36.6555H112.508V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2031.9561H118.125V36.6555H120V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2031.9561H121.871V36.6555H123.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2031.9561H133.121V36.6555H136.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2031.9561H138.758V36.6555H148.133V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2031.9561H149.996V36.6555H151.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.258%2031.9561H155.633V36.6555H161.258V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.492%2031.9561H170.617V36.6555H172.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2031.9561H174.375V36.6555H178.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2031.9561H181.879V36.6555H183.754V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2031.9561H185.625V36.6555H187.5V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2031.9561H189.371V36.6555H191.246V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.242%2031.9561H198.742V36.6555H206.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2031.9561H213.75V36.6555H226.875V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2031.9561H228.746V36.6555H230.621V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2031.9561H236.25V36.6555H238.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2031.9561H240.008V36.6555H241.883V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2031.9561H245.621V36.6555H247.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2036.6562H22.5V41.3557H37.4999V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2036.6562H39.375V41.3557H41.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2036.6562H43.1328V41.3557H45.0079V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2036.6562H46.8672V41.3557H48.7423V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2036.6562H54.3828V41.3557H58.1327V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2036.6562H59.9961V41.3557H61.8712V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2036.6562H63.7539V41.3557H71.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2036.6562H74.9922V41.3557H84.3671V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6171%2036.6562H86.2422V41.3557H95.6171V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2036.6562H97.5039V41.3557H99.379V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2036.6562H101.25V41.3557H103.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.25%2036.6562H106.875V41.3557H116.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2036.6562H118.125V41.3557H123.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2036.6562H125.629V41.3557H131.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2036.6562H133.121V41.3557H134.996V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2036.6562H138.758V41.3557H140.633V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2036.6562H149.996V41.3557H153.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.508%2036.6562H155.633V41.3557H157.508V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.758%2036.6562H166.883V41.3557H168.758V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2036.6562H176.254V41.3557H180.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.629%2036.6562H181.879V41.3557H185.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.367%2036.6562H187.492V41.3557H189.367V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2036.6562H191.25V41.3557H198.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2036.6562H202.5V41.3557H211.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2036.6562H213.75V41.3557H226.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2036.6562H228.746V41.3557H230.621V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2036.6562H236.25V41.3557H238.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2036.6562H240.008V41.3557H241.883V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2036.6562H245.621V41.3557H247.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2041.3564H22.5V46.0559H37.4999V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2041.3564H39.375V46.0559H41.2501V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2041.3564H43.1328V46.0559H45.0079V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2041.3564H46.8672V46.0559H48.7423V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2041.3564H54.3828V46.0559H58.1327V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2041.3564H59.9961V46.0559H61.8712V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3789%2041.3564H63.7539V46.0559H69.3789V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6251%2041.3564H78.75V46.0559H80.6251V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4922%2041.3564H86.2422V46.0559H97.4922V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M105.008%2041.3564H99.3828V46.0559H105.008V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2041.3564H106.875V46.0559H108.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2041.3564H110.633V46.0559H112.508V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2041.3564H118.125V46.0559H123.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M127.504%2041.3564H125.629V46.0559H127.504V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2041.3564H131.242V46.0559H134.992V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2041.3564H136.879V46.0559H138.754V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2041.3564H149.996V46.0559H153.746V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M166.879%2041.3564H165.004V46.0559H166.879V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M176.242%2041.3564H170.617V46.0559H176.242V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2041.3564H178.121V46.0559H179.996V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2041.3564H181.879V46.0559H189.379V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2041.3564H191.25V46.0559H193.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2041.3564H195.008V46.0559H200.633V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M210.004%2041.3564H204.379V46.0559H210.004V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2041.3564H213.75V46.0559H226.875V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2041.3564H228.746V46.0559H230.621V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2041.3564H236.25V46.0559H238.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2041.3564H240.008V46.0559H241.883V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2041.3564H245.621V46.0559H247.496V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2046.0537H22.5V50.7531H37.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2046.0537H39.375V50.7531H41.2501V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2046.0537H43.1328V50.7531H45.0079V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2046.0537H46.8672V50.7531H48.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2046.0537H54.3828V50.7531H63.7577V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2046.0537H65.6211V50.7531H67.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.879%2046.0537H69.3789V50.7531H76.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2046.0537H78.75V50.7531H82.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7423%2046.0537H86.2422V50.7531H93.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2046.0537H95.625V50.7531H97.5001V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2046.0537H101.25V50.7531H108.75V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2046.0537H110.633V50.7531H112.508V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2046.0537H118.125V50.7531H120V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.496%2046.0537H121.871V50.7531H127.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M135%2046.0537H129.375V50.7531H135V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2046.0537H140.625V50.7531H148.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2046.0537H149.996V50.7531H153.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.742%2046.0537H159.367V50.7531H168.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2046.0537H172.496V50.7531H174.371V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2046.0537H178.121V50.7531H179.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2046.0537H181.879V50.7531H189.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2046.0537H191.25V50.7531H193.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.383%2046.0537H195.008V50.7531H204.383V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2046.0537H206.246V50.7531H209.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2046.0537H213.75V50.7531H226.875V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2046.0537H228.746V50.7531H230.621V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2046.0537H236.25V50.7531H238.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2046.0537H240.008V50.7531H241.883V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2046.0537H245.621V50.7531H247.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2050.7539H22.5V55.4533H37.4999V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2050.7539H39.375V55.4533H41.2501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2050.7539H43.1328V55.4533H45.0079V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2050.7539H46.8672V55.4533H48.7423V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0078%2050.7539H54.3828V55.4533H60.0078V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2050.7539H61.875V55.4533H63.7501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.125%2050.7539H67.5V55.4533H73.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2050.7539H74.9922V55.4533H84.3671V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2050.7539H86.2422V55.4533H88.1173V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2050.7539H95.625V55.4533H99.3749V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2050.7539H104.996V55.4533H108.746V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.375%2050.7539H112.5V55.4533H114.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2050.7539H118.125V55.4533H121.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.379%2050.7539H125.629V55.4533H129.379V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2050.7539H136.879V55.4533H140.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2050.7539H144.371V55.4533H148.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2050.7539H149.996V55.4533H151.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2050.7539H161.246V55.4533H163.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2050.7539H168.75V55.4533H172.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2050.7539H174.375V55.4533H178.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.504%2050.7539H181.879V55.4533H187.504V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2050.7539H189.371V55.4533H191.246V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2050.7539H195.008V55.4533H200.633V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2050.7539H202.5V55.4533H211.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2050.7539H213.75V55.4533H226.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2050.7539H228.746V55.4533H230.621V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2050.7539H236.25V55.4533H238.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2050.7539H240.008V55.4533H241.883V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2050.7539H245.621V55.4533H247.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2055.4551H22.5V60.1545H37.4999V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2055.4551H39.375V60.1545H41.2501V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2055.4551H43.1328V60.1545H45.0079V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2055.4551H46.8672V60.1545H48.7423V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2055.4551H54.3828V60.1545H65.6328V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2055.4551H67.5V60.1545H69.3751V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2055.4551H73.125V60.1545H75.0001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4961%2055.4551H76.8711V60.1545H82.4961V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2055.4551H86.2422V60.1545H88.1173V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2055.4551H90V60.1545H97.5001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.133%2055.4551H99.3828V60.1545H103.133V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2055.4551H104.996V60.1545H114.371V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2055.4551H118.125V60.1545H120V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2055.4551H121.871V60.1545H123.746V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2055.4551H125.629V60.1545H133.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.5%2055.4551H140.625V60.1545H142.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.496%2055.4551H149.996V60.1545H157.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.996%2055.4551H161.246V60.1545H164.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2055.4551H168.75V60.1545H172.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2055.4551H174.375V60.1545H176.25V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2055.4551H181.879V60.1545H183.754V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2055.4551H185.625V60.1545H187.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.621%2055.4551H189.371V60.1545H200.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.125%2055.4551H202.5V60.1545H208.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2055.4551H213.75V60.1545H226.875V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2055.4551H228.746V60.1545H230.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2055.4551H236.25V60.1545H238.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2055.4551H240.008V60.1545H241.883V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2055.4551H245.621V60.1545H247.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2060.1523H22.5V64.8518H37.4999V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2060.1523H39.375V64.8518H41.2501V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2060.1523H43.1328V64.8518H45.0079V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2060.1523H46.8672V64.8518H48.7423V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2060.1523H54.3828V64.8518H65.6328V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2060.1523H67.5V64.8518H69.3751V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8749%2060.1523H73.125V64.8518H76.8749V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M82.504%2060.1523H80.6289V64.8518H82.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2060.1523H86.2422V64.8518H88.1173V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3711%2060.1523H93.7461V64.8518H99.3711V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2060.1523H101.25V64.8518H103.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2060.1523H108.754V64.8518H112.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2060.1523H118.125V64.8518H121.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M131.258%2060.1523H127.508V64.8518H131.258V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2060.1523H136.879V64.8518H138.754V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2060.1523H140.625V64.8518H148.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2060.1523H149.996V64.8518H153.746V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M159.383%2060.1523H155.633V64.8518H159.383V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2060.1523H161.246V64.8518H163.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2060.1523H165.004V64.8518H172.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2060.1523H181.879V64.8518H191.254V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2060.1523H193.129V64.8518H195.004V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M204.367%2060.1523H198.742V64.8518H204.367V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2060.1523H206.246V64.8518H208.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2060.1523H213.75V64.8518H226.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2060.1523H228.746V64.8518H230.621V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2060.1523H236.25V64.8518H238.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2060.1523H240.008V64.8518H241.883V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2060.1523H245.621V64.8518H247.496V60.1523Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56590'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._id-mrz-barcode-back-icon_194nz_79:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56870)'%3e%3cpath%20d='M247.496%2022.5576H22.4961V64.8527H247.496V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.496%2022.5576H22.4961V27.257H37.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2022.5576H39.3711V27.257H41.2462V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2022.5576H43.1289V27.257H45.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2022.5576H46.8633V27.257H48.7384V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2022.5576H54.3789V27.257H63.7538V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2022.5576H65.6172V27.257H67.4923V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2022.5576H69.375V27.257H71.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2022.5576H73.1211V27.257H82.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2022.5576H86.2383V27.257H89.9882V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7501%2022.5576H91.875V27.257H93.7501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2022.5576H95.6211V27.257H99.371V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.617%2022.5576H104.992V27.257H110.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2022.5576H118.121V27.257H121.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.121%2022.5576H129.371V27.257H133.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2022.5576H134.996V27.257H136.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2022.5576H138.754V27.257H140.629V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2022.5576H149.992V27.257H151.867V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.375%2022.5576H153.75V27.257H159.375V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2022.5576H166.879V27.257H172.504V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2022.5576H174.371V27.257H176.246V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2022.5576H181.875V27.257H191.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2022.5576H193.125V27.257H195V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2022.5576H196.871V27.257H198.746V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2022.5576H200.617V27.257H209.992V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2022.5576H213.746V27.257H226.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2022.5576H228.742V27.257H230.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2022.5576H236.246V27.257H238.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2022.5576H240.004V27.257H241.879V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2022.5576H245.617V27.257H247.492V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2027.2578H22.4961V31.9572H37.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2027.2578H39.3711V31.9572H41.2462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2027.2578H43.1289V31.9572H45.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2027.2578H46.8633V31.9572H48.7384V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.879%2027.2578H54.3789V31.9572H61.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6251%2027.2578H63.75V31.9572H65.6251V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2027.2578H67.4961V31.9572H69.3712V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7423%2027.2578H76.8672V31.9572H78.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8633%2027.2578H86.2383V31.9572H91.8633V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2027.2578H97.5V31.9572H99.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M104.996%2027.2578H101.246V31.9572H104.996V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2027.2578H110.629V31.9572H112.504V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2027.2578H118.121V31.9572H121.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2027.2578H125.625V31.9572H133.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2027.2578H134.996V31.9572H136.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2027.2578H138.754V31.9572H148.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.617%2027.2578H149.992V31.9572H155.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2027.2578H161.242V31.9572H163.117V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2027.2578H168.746V31.9572H174.371V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2027.2578H176.25V31.9572H180V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2027.2578H181.875V31.9572H189.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2027.2578H191.246V31.9572H193.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.879%2027.2578H195.004V31.9572H196.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.492%2027.2578H200.617V31.9572H202.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2027.2578H213.746V31.9572H226.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2027.2578H228.742V31.9572H230.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2027.2578H236.246V31.9572H238.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2027.2578H240.004V31.9572H241.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2027.2578H245.617V31.9572H247.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2031.9561H22.4961V36.6555H37.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2031.9561H39.3711V36.6555H41.2462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2031.9561H43.1289V36.6555H45.004V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2031.9561H46.8633V36.6555H48.7384V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.254%2031.9561H54.3789V36.6555H56.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9884%2031.9561H58.1133V36.6555H59.9884V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2031.9561H61.8711V36.6555H63.7462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2031.9561H67.4961V36.6555H74.9962V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2031.9561H86.2383V36.6555H89.9882V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2031.9561H91.875V36.6555H103.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2031.9561H104.992V36.6555H108.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2031.9561H110.629V36.6555H112.504V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2031.9561H118.121V36.6555H119.996V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2031.9561H121.867V36.6555H123.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.867%2031.9561H133.117V36.6555H136.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2031.9561H138.754V36.6555H148.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2031.9561H149.992V36.6555H151.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.254%2031.9561H155.629V36.6555H161.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.488%2031.9561H170.613V36.6555H172.488V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2031.9561H174.371V36.6555H178.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2031.9561H181.875V36.6555H183.75V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2031.9561H185.621V36.6555H187.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2031.9561H189.367V36.6555H191.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.238%2031.9561H198.738V36.6555H206.238V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2031.9561H213.746V36.6555H226.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2031.9561H228.742V36.6555H230.617V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2031.9561H236.246V36.6555H238.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2031.9561H240.004V36.6555H241.879V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2031.9561H245.617V36.6555H247.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2036.6562H22.4961V41.3557H37.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2036.6562H39.3711V41.3557H41.2462V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2036.6562H43.1289V41.3557H45.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2036.6562H46.8633V41.3557H48.7384V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2036.6562H54.3789V41.3557H58.1288V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2036.6562H59.9922V41.3557H61.8673V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2036.6562H63.75V41.3557H71.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2036.6562H74.9883V41.3557H84.3632V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6132%2036.6562H86.2383V41.3557H95.6132V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2036.6562H97.5V41.3557H99.3751V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2036.6562H101.246V41.3557H103.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.246%2036.6562H106.871V41.3557H116.246V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2036.6562H118.121V41.3557H123.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.25%2036.6562H125.625V41.3557H131.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2036.6562H133.117V41.3557H134.992V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2036.6562H138.754V41.3557H140.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2036.6562H149.992V41.3557H153.742V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.504%2036.6562H155.629V41.3557H157.504V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.754%2036.6562H166.879V41.3557H168.754V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2036.6562H176.25V41.3557H180V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.625%2036.6562H181.875V41.3557H185.625V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.363%2036.6562H187.488V41.3557H189.363V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2036.6562H191.246V41.3557H198.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2036.6562H202.496V41.3557H211.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2036.6562H213.746V41.3557H226.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2036.6562H228.742V41.3557H230.617V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2036.6562H236.246V41.3557H238.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2036.6562H240.004V41.3557H241.879V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2036.6562H245.617V41.3557H247.492V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2041.3555H22.4961V46.0549H37.496V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2041.3555H39.3711V46.0549H41.2462V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2041.3555H43.1289V46.0549H45.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2041.3555H46.8633V46.0549H48.7384V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2041.3555H54.3789V46.0549H58.1288V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2041.3555H59.9922V46.0549H61.8673V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M69.375%2041.3555H63.75V46.0549H69.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6212%2041.3555H78.7461V46.0549H80.6212V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4883%2041.3555H86.2383V46.0549H97.4883V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M105.004%2041.3555H99.3789V46.0549H105.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2041.3555H106.871V46.0549H108.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2041.3555H110.629V46.0549H112.504V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2041.3555H118.121V46.0549H123.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M127.5%2041.3555H125.625V46.0549H127.5V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M134.988%2041.3555H131.238V46.0549H134.988V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2041.3555H136.875V46.0549H138.75V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2041.3555H149.992V46.0549H153.742V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M166.875%2041.3555H165V46.0549H166.875V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M176.238%2041.3555H170.613V46.0549H176.238V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2041.3555H178.117V46.0549H179.992V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2041.3555H181.875V46.0549H189.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2041.3555H191.246V46.0549H193.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2041.3555H195.004V46.0549H200.629V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M210%2041.3555H204.375V46.0549H210V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2041.3555H213.746V46.0549H226.871V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2041.3555H228.742V46.0549H230.617V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2041.3555H236.246V46.0549H238.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2041.3555H240.004V46.0549H241.879V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2041.3555H245.617V46.0549H247.492V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2046.0537H22.4961V50.7531H37.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2046.0537H39.3711V50.7531H41.2462V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2046.0537H43.1289V50.7531H45.004V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2046.0537H46.8633V50.7531H48.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2046.0537H54.3789V50.7531H63.7538V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2046.0537H65.6172V50.7531H67.4923V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8751%2046.0537H69.375V50.7531H76.8751V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2046.0537H78.7461V50.7531H82.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7384%2046.0537H86.2383V50.7531H93.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2046.0537H95.6211V50.7531H97.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2046.0537H101.246V50.7531H108.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2046.0537H110.629V50.7531H112.504V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2046.0537H118.121V50.7531H119.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.492%2046.0537H121.867V50.7531H127.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2046.0537H129.371V50.7531H134.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2046.0537H140.621V50.7531H148.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2046.0537H149.992V50.7531H153.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.738%2046.0537H159.363V50.7531H168.738V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.367%2046.0537H172.492V50.7531H174.367V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2046.0537H178.117V50.7531H179.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2046.0537H181.875V50.7531H189.375V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2046.0537H191.246V50.7531H193.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.379%2046.0537H195.004V50.7531H204.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2046.0537H206.242V50.7531H209.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2046.0537H213.746V50.7531H226.871V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2046.0537H228.742V50.7531H230.617V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2046.0537H236.246V50.7531H238.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2046.0537H240.004V50.7531H241.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2046.0537H245.617V50.7531H247.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2050.7539H22.4961V55.4533H37.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2050.7539H39.3711V55.4533H41.2462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2050.7539H43.1289V55.4533H45.004V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2050.7539H46.8633V55.4533H48.7384V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0039%2050.7539H54.3789V55.4533H60.0039V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2050.7539H61.8711V55.4533H63.7462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.1211%2050.7539H67.4961V55.4533H73.1211V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2050.7539H74.9883V55.4533H84.3632V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2050.7539H86.2383V55.4533H88.1134V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2050.7539H95.6211V55.4533H99.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2050.7539H104.992V55.4533H108.742V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2050.7539H112.496V55.4533H114.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2050.7539H118.121V55.4533H121.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.375%2050.7539H125.625V55.4533H129.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.625%2050.7539H136.875V55.4533H140.625V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.117%2050.7539H144.367V55.4533H148.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2050.7539H149.992V55.4533H151.867V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2050.7539H161.242V55.4533H163.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2050.7539H168.746V55.4533H172.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2050.7539H174.371V55.4533H178.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2050.7539H181.875V55.4533H187.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2050.7539H189.367V55.4533H191.242V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2050.7539H195.004V55.4533H200.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2050.7539H202.496V55.4533H211.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2050.7539H213.746V55.4533H226.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2050.7539H228.742V55.4533H230.617V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2050.7539H236.246V55.4533H238.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2050.7539H240.004V55.4533H241.879V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2050.7539H245.617V55.4533H247.492V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2055.4551H22.4961V60.1545H37.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2055.4551H39.3711V60.1545H41.2462V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2055.4551H43.1289V60.1545H45.004V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2055.4551H46.8633V60.1545H48.7384V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2055.4551H54.3789V60.1545H65.6289V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2055.4551H67.4961V60.1545H69.3712V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2055.4551H73.1211V60.1545H74.9962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4922%2055.4551H76.8672V60.1545H82.4922V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2055.4551H86.2383V60.1545H88.1134V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2055.4551H89.9961V60.1545H97.4962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2055.4551H99.3789V60.1545H103.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.367%2055.4551H104.992V60.1545H114.367V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2055.4551H118.121V60.1545H119.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2055.4551H121.867V60.1545H123.742V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2055.4551H125.625V60.1545H133.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.496%2055.4551H140.621V60.1545H142.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.492%2055.4551H149.992V60.1545H157.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.992%2055.4551H161.242V60.1545H164.992V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2055.4551H168.746V60.1545H172.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2055.4551H174.371V60.1545H176.246V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2055.4551H181.875V60.1545H183.75V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2055.4551H185.621V60.1545H187.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.617%2055.4551H189.367V60.1545H200.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2055.4551H202.496V60.1545H208.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2055.4551H213.746V60.1545H226.871V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2055.4551H228.742V60.1545H230.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2055.4551H236.246V60.1545H238.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2055.4551H240.004V60.1545H241.879V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2055.4551H245.617V60.1545H247.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2060.1514H22.4961V64.8508H37.496V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2060.1514H39.3711V64.8508H41.2462V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2060.1514H43.1289V64.8508H45.004V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2060.1514H46.8633V64.8508H48.7384V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2060.1514H54.3789V64.8508H65.6289V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2060.1514H67.4961V64.8508H69.3712V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M76.871%2060.1514H73.1211V64.8508H76.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M82.5001%2060.1514H80.625V64.8508H82.5001V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2060.1514H86.2383V64.8508H88.1134V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3672%2060.1514H93.7422V64.8508H99.3672V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2060.1514H101.246V64.8508H103.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M112.5%2060.1514H108.75V64.8508H112.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2060.1514H118.121V64.8508H121.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2060.1514H127.504V64.8508H131.254V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2060.1514H136.875V64.8508H138.75V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2060.1514H140.621V64.8508H148.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2060.1514H149.992V64.8508H153.742V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2060.1514H155.629V64.8508H159.379V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2060.1514H161.242V64.8508H163.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2060.1514H165V64.8508H172.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2060.1514H181.875V64.8508H191.25V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2060.1514H193.125V64.8508H195V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M204.363%2060.1514H198.738V64.8508H204.363V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M208.117%2060.1514H206.242V64.8508H208.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2060.1514H213.746V64.8508H226.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2060.1514H228.742V64.8508H230.617V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2060.1514H236.246V64.8508H238.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2060.1514H240.004V64.8508H241.879V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2060.1514H245.617V64.8508H247.492V60.1514Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56870'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._bank-card-front-icon_194nz_83:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45763'%20y='-1.45763'%20width='277.085'%20height='169.085'%20rx='13.1186'%20transform='matrix(1%200%200%20-1%200%20169.085)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91525'/%3e%3crect%20x='23.332'%20y='23.3223'%20width='107.917'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='93.332'%20y='142.848'%20width='99.1667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='122.44'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='84.582'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='207.082'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='142.848'%20width='61.25'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='52.4746'%20width='40.8333'%20height='37.8983'%20rx='5.83051'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='58.3047'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='44.4805'%20y='52.4746'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2052.4746)'%20fill='white'/%3e%3crect%20x='37.918'%20y='58.3047'%20width='26.2373'%20height='1.45833'%20transform='rotate(90%2037.918%2058.3047)'%20fill='white'/%3e%3crect%20x='51.043'%20y='67.0508'%20width='17.4915'%20height='1.45833'%20transform='rotate(90%2051.043%2067.0508)'%20fill='white'/%3e%3crect%20x='44.4805'%20y='84.542'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2084.542)'%20fill='white'/%3e%3crect%20x='23.3359'%20y='83.085'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3ccircle%20cx='224.476'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3ccircle%20cx='247.796'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3c/svg%3e")}._bank-card-back-icon_194nz_87:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45833'%20y='-1.45833'%20width='277.083'%20height='169.083'%20rx='13.125'%20transform='matrix(1%200%200%20-1%200%20169.083)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91667'/%3e%3crect%20y='14.5762'%20width='280'%20height='40.8136'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='69.9658'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='224.582'%20y='119.525'%20width='23.3333'%20height='34.9831'%20fill='%23333543'/%3e%3ccircle%20cx='224.582'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3ccircle%20cx='247.918'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3c/svg%3e")}._document-front-icon_194nz_91:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M520%20200H800V240H520V200Z'%20fill='white'/%3e%3cpath%20d='M800%20300H520V340H800V300Z'%20fill='white'/%3e%3cpath%20d='M520%20400H800V440H520V400Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M274.943%20123.429L274.933%20123.432C266.551%20126.295%20258.863%20130.466%20251.927%20135.343C243.39%20140.807%20235.349%20147.484%20228.244%20155.117C216.999%20166.723%20206.985%20181.73%20202.638%20200.462C201.732%20203.954%20201.031%20207.508%20200.554%20211.114C198.857%20223.937%20199.991%20237.409%20204.799%20251.055C201.906%20250.776%20199.719%20251.697%20198.089%20253.419C191.062%20260.842%20194.356%20283.152%20195.842%20288.454C202.652%20312.775%20208.999%20319.597%20213.796%20319.988C216.486%20337.575%20230.545%20358.063%20243.587%20375.139C243.587%20405.888%20203.816%20413.339%20170.442%20419.591C162.723%20421.037%20155.346%20422.419%20148.883%20424.01C114.629%20432.436%20110.268%20472.281%20110.168%20504.349C110.141%20513.052%20117.321%20520%20126.023%20520H473.977C482.679%20520%20489.859%20513.052%20489.839%20504.349C489.769%20472.142%20485.483%20432.464%20451.117%20424.01C445.211%20422.556%20438.486%20421.191%20431.39%20419.752L431.388%20419.751C396.76%20412.725%20353.321%20403.912%20353.321%20374.203C353.664%20373.739%20354.01%20373.272%20354.358%20372.804C357.463%20368.617%20360.701%20364.25%20363.825%20359.791C372.128%20347.938%20379.624%20335.429%20381.652%20323.912C382.709%20324.634%20383.91%20325.123%20385.24%20325.123C385.796%20325.123%20386.374%20325.037%20386.972%20324.849C391.593%20323.394%20397.418%20315.772%20403.633%20293.568C410.9%20267.609%20406.477%20258.905%20400.199%20256.714C420.616%20157.928%20373.971%20154.617%20373.971%20154.617C373.971%20154.617%20366.934%20140.939%20348.397%20130.606C337.66%20124.183%20323.287%20119%20304.851%20119C301.953%20119%20298.964%20119.122%20295.865%20119.395C288.479%20119.744%20281.5%20121.188%20274.943%20123.429ZM321.183%20350.388C316.077%20357.278%20313.321%20365.627%20313.321%20374.203C313.321%20396.791%20323.959%20414.183%20337.296%20425.916C349.473%20436.63%20364.134%20443.009%20376.199%20447.154C388.689%20451.445%20401.819%20454.454%20412.943%20456.796C417.197%20457.692%20421.006%20458.464%20424.494%20459.171L424.495%20459.171C431.031%20460.495%20436.443%20461.592%20441.555%20462.85L441.562%20462.852C442.371%20463.051%20442.688%20463.234%20442.718%20463.251L442.719%20463.252L442.723%20463.254C442.746%20463.267%20442.79%20463.292%20442.907%20463.412C443.207%20463.723%20444.371%20465.103%20445.684%20468.766C446.817%20471.928%20447.691%20475.687%20448.338%20480H151.711C152.363%20475.717%20153.239%20471.971%20154.372%20468.81C155.699%20465.109%20156.878%20463.698%20157.192%20463.372L157.194%20463.369C157.207%20463.34%20157.301%20463.132%20158.438%20462.852L158.445%20462.85C163.729%20461.549%20169.527%20460.462%20176.817%20459.096L176.821%20459.095C179.572%20458.579%20182.535%20458.024%20185.763%20457.402C196.469%20455.34%20209.407%20452.649%20221.731%20448.562C233.686%20444.597%20248.469%20438.255%20260.709%20426.995C274.269%20414.522%20283.587%20396.915%20283.587%20375.139C283.587%20366.365%20280.702%20357.834%20275.376%20350.86C269.197%20342.77%20263.625%20334.956%20259.415%20327.693C254.949%20319.99%20253.579%20315.526%20253.336%20313.941C251.698%20303.233%20245.887%20294.002%20237.651%20287.879C236.767%20285.573%20235.697%20282.397%20234.493%20278.142C234.495%20278.139%20234.486%20278.086%20234.467%20277.984L234.452%20277.901C235.091%20277.195%20235.707%20276.464%20236.298%20275.708C244.717%20264.952%20247.065%20250.644%20242.526%20237.762C239.17%20228.237%20239.103%20219.19%20241.356%20210.506C241.443%20210.173%20241.525%20209.839%20241.603%20209.503C243.904%20199.588%20249.376%20190.79%20256.971%20182.951C257.156%20182.76%20257.34%20182.567%20257.521%20182.372C262.328%20177.208%20267.774%20172.691%20273.489%20169.034C273.978%20168.721%20274.46%20168.397%20274.936%20168.063C279.286%20165.004%20283.597%20162.748%20287.809%20161.303L287.883%20161.278C291.162%20160.157%20294.424%20159.508%20297.75%20159.351C298.292%20159.325%20298.833%20159.288%20299.374%20159.241C301.267%20159.074%20303.083%20159%20304.851%20159C315.374%20159%20322.72%20161.857%20327.864%20164.933C328.213%20165.142%20328.565%20165.345%20328.92%20165.543C333.473%20168.081%20336.341%20170.874%20337.886%20172.659C338.515%20173.386%20338.906%20173.925%20339.077%20174.173C344.22%20183.353%20352.722%20190.05%20362.636%20192.979C364.507%20197.532%20368.476%20212.578%20361.027%20248.618C358.865%20259.075%20361.005%20269.523%20366.336%20278.005C366.023%20279.378%20365.623%20280.965%20365.114%20282.784L365.113%20282.786C364.533%20284.861%20363.983%20286.685%20363.469%20288.283C352.34%20293.961%20344.445%20304.559%20342.258%20316.974C342.258%20316.974%20342.208%20317.246%20342.023%20317.818C341.833%20318.406%20341.53%20319.218%20341.065%20320.269C340.111%20322.423%20338.685%20325.105%20336.678%20328.368C332.654%20334.911%20327.684%20341.617%20321.853%20349.483L321.183%20350.388Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M80%200C35.8172%200%200%2035.8172%200%2080V560C0%20604.183%2035.8172%20640%2080%20640H840C884.183%20640%20920%20604.183%20920%20560V80C920%2035.8172%20884.183%200%20840%200H80ZM840%2040H80C57.9086%2040%2040%2057.9086%2040%2080V560C40%20582.091%2057.9086%20600%2080%20600H840C862.091%20600%20880%20582.091%20880%20560V80C880%2057.9086%20862.091%2040%20840%2040Z'%20fill='white'/%3e%3c/svg%3e")}._document-back-icon_194nz_95:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M460%20300H140V340H460V300Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M100%200C44.7715%200%200%2044.7715%200%20100V540C0%20595.228%2044.7715%20640%20100%20640H820C875.228%20640%20920%20595.228%20920%20540V100C920%2044.7715%20875.229%200%20820%200H100ZM820%2040H100C66.8629%2040%2040%2066.8629%2040%20100V140H880V100C880%2066.8629%20853.137%2040%20820%2040ZM40%20540V240H880V540C880%20573.137%20853.137%20600%20820%20600H100C66.8629%20600%2040%20573.137%2040%20540Z'%20fill='white'/%3e%3c/svg%3e")}@keyframes _slide_194nz_22{0%{background-position:center 115%}to{background-position:center -15%}}@keyframes _flip-front_194nz_1{0%{transform:rotateY(0)}to{transform:rotateY(-180deg)}}@keyframes _flip-back_194nz_1{0%{transform:rotateY(180deg)}to{transform:rotateY(0)}}`, g8 = `._tilt_e1bzj_1{width:70%;height:100%;position:relative;align-self:center;perspective:1000px}._tilt_e1bzj_1:before{content:"";width:100%;height:100%;display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:100% auto}._vertical_e1bzj_19:before{animation:_vertical_e1bzj_19 3.4s .4s infinite}._horizontal_e1bzj_23:before{animation:_horizontal_e1bzj_23 3.4s .4s infinite}._left-bottom-right-top_e1bzj_27:before{animation:_left-bottom-right-top_e1bzj_27 3.4s .4s infinite}._right-bottom-left-top_e1bzj_31:before{animation:_right-bottom-left-top_e1bzj_31 3.4s .4s infinite}._id-front-icon_e1bzj_35:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.246%2028.1982H22.4961V126.887C22.4962%20124.482%2027.1732%20123.323%2032.6526%20121.964C39.93%20120.16%2048.6229%20118.005%2049.6542%20112.116C44.6713%20108.96%2042.7698%20104.198%2040.8243%2099.3255C40.4465%2098.3791%2040.0669%2097.4286%2039.6629%2096.485C34.7738%20101.236%2032.5935%2079.4764%2036.9774%2079.4764C28.6435%2056.9793%2051.4615%2038.5191%2072.545%2051.2088C84.91%2048.5382%2091.7424%2063.3145%2084.3766%2079.4768C87.4153%2078.0182%2087.9964%2085.7946%2087.4153%2090.6287C87.4153%2091.8706%2086.1245%20100.564%2082.8626%2097.1966C82.4668%2098.1115%2082.0949%2099.0331%2081.7247%2099.9507L81.7241%2099.9523L81.7239%2099.9527C79.768%20104.801%2077.8573%20109.537%2072.6874%20112.594C74.1725%20118.123%2083.0554%20120.21%2090.5254%20121.964C96.3092%20123.323%20101.246%20124.482%20101.246%20126.887V28.1982Z'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='104.327'%20width='59.0625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='182.812'%20y='104.327'%20width='64.6875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='28.1963'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='53.5742'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='78.9512'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='129.704'%20width='135'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-single-icon_e1bzj_39:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='219'%20viewBox='0%200%20309%20219'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%20196.527C1.40455%20200.484%201.40564%20203.366%201.59124%20205.638C1.7755%20207.893%202.13459%20209.422%202.78232%20210.693C3.99425%20213.072%205.92806%20215.006%208.3066%20216.218C9.57784%20216.865%2011.1068%20217.225%2013.3621%20217.409C15.6337%20217.594%2018.5165%20217.595%2022.4727%20217.595H286.527C290.484%20217.595%20293.366%20217.594%20295.638%20217.409C297.893%20217.225%20299.422%20216.865%20300.693%20216.218C303.072%20215.006%20305.006%20213.072%20306.218%20210.693C306.865%20209.422%20307.224%20207.893%20307.409%20205.638C307.594%20203.366%20307.595%20200.484%20307.595%20196.527V1.40454H1.40455V196.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%2033.6924H22.4727V129.154H22.4727C22.4729%20126.828%2026.8105%20125.706%2031.8923%20124.392L31.8924%20124.392C38.6418%20122.647%2046.7039%20120.562%2047.6604%20114.866C43.039%20111.813%2041.2755%20107.207%2039.4712%20102.494L39.4711%20102.494C39.1207%20101.578%2038.7687%20100.659%2038.394%2099.7463C33.8596%20104.342%2031.8376%2083.2938%2035.9034%2083.2938C28.1741%2061.5324%2049.3366%2043.6758%2068.8904%2055.9505C80.3582%2053.3672%2086.695%2067.6604%2079.8636%2083.2943C82.6818%2081.8833%2083.2207%2089.4054%2082.6818%2094.0815C82.6818%2095.2828%2081.4847%20103.692%2078.4594%20100.435C78.0921%20101.32%2077.747%20102.212%2077.4035%20103.1L77.4034%20103.1L77.4033%20103.101C75.5893%20107.79%2073.8173%20112.371%2069.0225%20115.329C70.3998%20120.677%2078.6382%20122.695%2085.5662%20124.392C90.9184%20125.703%2095.4886%20126.823%2095.509%20129.138V33.6924Z'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='160.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='53.3457'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='73'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='92.6543'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='112.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='131.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='185.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-both-pages-icon_e1bzj_43:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='438'%20viewBox='0%200%20309%20438'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%2022.4727C1.40455%2018.5165%201.40564%2015.6337%201.59124%2013.3621C1.7755%2011.1068%202.13459%209.57784%202.78232%208.3066C3.99425%205.92806%205.92806%203.99425%208.3066%202.78232C9.57784%202.13459%2011.1068%201.7755%2013.3621%201.59124C15.6337%201.40564%2018.5165%201.40455%2022.4727%201.40455H286.527C290.484%201.40455%20293.366%201.40564%20295.638%201.59124C297.893%201.7755%20299.422%202.13459%20300.693%202.78232C303.072%203.99425%20305.006%205.92806%20306.218%208.3066C306.865%209.57784%20307.224%2011.1068%20307.409%2013.3621C307.594%2015.6337%20307.595%2018.5165%20307.595%2022.4727V217.595H1.40455V22.4727Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20d='M1.40455%20415.527C1.40455%20419.484%201.40564%20422.366%201.59124%20424.638C1.7755%20426.893%202.13459%20428.422%202.78232%20429.693C3.99425%20432.072%205.92806%20434.006%208.3066%20435.218C9.57784%20435.865%2011.1068%20436.225%2013.3621%20436.409C15.6337%20436.594%2018.5165%20436.595%2022.4727%20436.595H286.527C290.484%20436.595%20293.366%20436.594%20295.638%20436.409C297.893%20436.225%20299.422%20435.865%20300.693%20435.218C303.072%20434.006%20305.006%20432.072%20306.218%20429.693C306.865%20428.422%20307.224%20426.893%20307.409%20424.638C307.594%20422.366%20307.595%20419.484%20307.595%20415.527V220.405H1.40455V415.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3crect%20x='22.4727'%20y='379.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='272.346'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='292'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='311.654'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='331.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='350.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='404.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%20252.692H22.4727V348.154H95.509V348.154H22.4727C22.4727%20345.828%2026.8104%20344.706%2031.8923%20343.392L31.8924%20343.392C38.6418%20341.647%2046.7039%20339.562%2047.6604%20333.866C43.039%20330.813%2041.2755%20326.206%2039.4712%20321.494L39.4711%20321.493C39.1207%20320.578%2038.7687%20319.659%2038.394%20318.746C33.8596%20323.342%2031.8376%20302.294%2035.9034%20302.294C28.1741%20280.532%2049.3366%20262.676%2068.8904%20274.95C80.3582%20272.367%2086.695%20286.66%2079.8636%20302.294C82.6818%20300.883%2083.2207%20308.405%2082.6818%20313.081C82.6818%20314.282%2081.4847%20322.692%2078.4594%20319.434C78.0921%20320.32%2077.747%20321.212%2077.4035%20322.1L77.4034%20322.1L77.4033%20322.1C75.5893%20326.79%2073.8173%20331.371%2069.0225%20334.328C70.3998%20339.677%2078.6382%20341.695%2085.5662%20343.392C90.9184%20344.703%2095.4886%20345.823%2095.509%20348.138V252.692Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-front-icon_e1bzj_47:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='112.5'%20y='25.377'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='76.1309'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='225'%20height='11.2787'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.25%2025.377H22.5V124.065C22.5003%20121.661%2027.1772%20120.502%2032.6565%20119.143C39.9339%20117.339%2048.6268%20115.184%2049.6581%20109.295C44.6752%20106.139%2042.7737%20101.377%2040.8282%2096.5044C40.4504%2095.558%2040.0708%2094.6075%2039.6668%2093.6639C34.7777%2098.4148%2032.5974%2076.6553%2036.9813%2076.6553C28.6474%2054.1582%2051.4654%2035.698%2072.5489%2048.3877C84.9139%2045.717%2091.7464%2060.4934%2084.3805%2076.6557C87.4192%2075.1971%2088.0003%2082.9735%2087.4192%2087.8076C87.4192%2089.0495%2086.1284%2097.7429%2082.8665%2094.3755C82.4704%2095.2911%2082.0983%2096.2133%2081.7279%2097.1316C79.7719%20101.98%2077.8612%20106.715%2072.6914%20109.773C74.1764%20115.302%2083.0593%20117.388%2090.5293%20119.143C96.3129%20120.502%20101.25%20121.661%20101.25%20124.065V25.377Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-back-icon_e1bzj_51:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='171.562'%20y='22.5576'%20width='75.9375'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='154.688'%20y='138.164'%20width='92.8125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='73.3115'%20width='73.125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='50.625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-back-icon_e1bzj_55:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='25.377'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3c/svg%3e")}._id-barcode-back-icon_e1bzj_59:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='225'%20height='33.8361'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56590)'%3e%3cpath%20d='M247.5%2022.5576H22.5V64.8527H247.5V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.4999%2022.5576H22.5V27.257H37.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2022.5576H39.375V27.257H41.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2022.5576H43.1328V27.257H45.0079V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2022.5576H46.8672V27.257H48.7423V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2022.5576H54.3828V27.257H63.7577V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2022.5576H65.6211V27.257H67.4962V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2022.5576H69.3789V27.257H71.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2022.5576H73.125V27.257H82.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2022.5576H86.2422V27.257H89.9921V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.754%2022.5576H91.8789V27.257H93.754V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2022.5576H95.625V27.257H99.3749V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.621%2022.5576H104.996V27.257H110.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2022.5576H118.125V27.257H121.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2022.5576H129.375V27.257H133.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2022.5576H135V27.257H136.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2022.5576H138.758V27.257H140.633V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2022.5576H149.996V27.257H151.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2022.5576H153.754V27.257H159.379V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.508%2022.5576H166.883V27.257H172.508V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2022.5576H174.375V27.257H176.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2022.5576H181.879V27.257H191.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2022.5576H193.129V27.257H195.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2022.5576H196.875V27.257H198.75V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2022.5576H200.621V27.257H209.996V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2022.5576H213.75V27.257H226.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2022.5576H228.746V27.257H230.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2022.5576H236.25V27.257H238.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2022.5576H240.008V27.257H241.883V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2022.5576H245.621V27.257H247.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2027.2578H22.5V31.9572H37.4999V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2027.2578H39.375V31.9572H41.2501V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2027.2578H43.1328V31.9572H45.0079V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2027.2578H46.8672V31.9572H48.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8829%2027.2578H54.3828V31.9572H61.8829V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.629%2027.2578H63.7539V31.9572H65.629V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2027.2578H67.5V31.9572H69.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7462%2027.2578H76.8711V31.9572H78.7462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8672%2027.2578H86.2422V31.9572H91.8672V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2027.2578H97.5039V31.9572H99.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M105%2027.2578H101.25V31.9572H105V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2027.2578H110.633V31.9572H112.508V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2027.2578H118.125V31.9572H121.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2027.2578H125.629V31.9572H133.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2027.2578H135V31.9572H136.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2027.2578H138.758V31.9572H148.133V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.621%2027.2578H149.996V31.9572H155.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2027.2578H161.246V31.9572H163.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.375%2027.2578H168.75V31.9572H174.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2027.2578H176.254V31.9572H180.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2027.2578H181.879V31.9572H189.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2027.2578H191.25V31.9572H193.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.883%2027.2578H195.008V31.9572H196.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.496%2027.2578H200.621V31.9572H202.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2027.2578H213.75V31.9572H226.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2027.2578H228.746V31.9572H230.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2027.2578H236.25V31.9572H238.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2027.2578H240.008V31.9572H241.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2027.2578H245.621V31.9572H247.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2031.9561H22.5V36.6555H37.4999V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2031.9561H39.375V36.6555H41.2501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2031.9561H43.1328V36.6555H45.0079V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2031.9561H46.8672V36.6555H48.7423V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.2579%2031.9561H54.3828V36.6555H56.2579V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9923%2031.9561H58.1172V36.6555H59.9923V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2031.9561H61.875V36.6555H63.7501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2031.9561H67.5V36.6555H75.0001V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2031.9561H86.2422V36.6555H89.9921V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2031.9561H91.8789V36.6555H103.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2031.9561H104.996V36.6555H108.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2031.9561H110.633V36.6555H112.508V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2031.9561H118.125V36.6555H120V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2031.9561H121.871V36.6555H123.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2031.9561H133.121V36.6555H136.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2031.9561H138.758V36.6555H148.133V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2031.9561H149.996V36.6555H151.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.258%2031.9561H155.633V36.6555H161.258V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.492%2031.9561H170.617V36.6555H172.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2031.9561H174.375V36.6555H178.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2031.9561H181.879V36.6555H183.754V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2031.9561H185.625V36.6555H187.5V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2031.9561H189.371V36.6555H191.246V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.242%2031.9561H198.742V36.6555H206.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2031.9561H213.75V36.6555H226.875V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2031.9561H228.746V36.6555H230.621V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2031.9561H236.25V36.6555H238.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2031.9561H240.008V36.6555H241.883V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2031.9561H245.621V36.6555H247.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2036.6562H22.5V41.3557H37.4999V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2036.6562H39.375V41.3557H41.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2036.6562H43.1328V41.3557H45.0079V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2036.6562H46.8672V41.3557H48.7423V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2036.6562H54.3828V41.3557H58.1327V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2036.6562H59.9961V41.3557H61.8712V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2036.6562H63.7539V41.3557H71.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2036.6562H74.9922V41.3557H84.3671V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6171%2036.6562H86.2422V41.3557H95.6171V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2036.6562H97.5039V41.3557H99.379V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2036.6562H101.25V41.3557H103.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.25%2036.6562H106.875V41.3557H116.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2036.6562H118.125V41.3557H123.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2036.6562H125.629V41.3557H131.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2036.6562H133.121V41.3557H134.996V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2036.6562H138.758V41.3557H140.633V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2036.6562H149.996V41.3557H153.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.508%2036.6562H155.633V41.3557H157.508V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.758%2036.6562H166.883V41.3557H168.758V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2036.6562H176.254V41.3557H180.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.629%2036.6562H181.879V41.3557H185.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.367%2036.6562H187.492V41.3557H189.367V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2036.6562H191.25V41.3557H198.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2036.6562H202.5V41.3557H211.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2036.6562H213.75V41.3557H226.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2036.6562H228.746V41.3557H230.621V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2036.6562H236.25V41.3557H238.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2036.6562H240.008V41.3557H241.883V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2036.6562H245.621V41.3557H247.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2041.3564H22.5V46.0559H37.4999V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2041.3564H39.375V46.0559H41.2501V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2041.3564H43.1328V46.0559H45.0079V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2041.3564H46.8672V46.0559H48.7423V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2041.3564H54.3828V46.0559H58.1327V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2041.3564H59.9961V46.0559H61.8712V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3789%2041.3564H63.7539V46.0559H69.3789V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6251%2041.3564H78.75V46.0559H80.6251V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4922%2041.3564H86.2422V46.0559H97.4922V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M105.008%2041.3564H99.3828V46.0559H105.008V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2041.3564H106.875V46.0559H108.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2041.3564H110.633V46.0559H112.508V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2041.3564H118.125V46.0559H123.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M127.504%2041.3564H125.629V46.0559H127.504V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2041.3564H131.242V46.0559H134.992V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2041.3564H136.879V46.0559H138.754V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2041.3564H149.996V46.0559H153.746V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M166.879%2041.3564H165.004V46.0559H166.879V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M176.242%2041.3564H170.617V46.0559H176.242V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2041.3564H178.121V46.0559H179.996V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2041.3564H181.879V46.0559H189.379V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2041.3564H191.25V46.0559H193.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2041.3564H195.008V46.0559H200.633V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M210.004%2041.3564H204.379V46.0559H210.004V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2041.3564H213.75V46.0559H226.875V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2041.3564H228.746V46.0559H230.621V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2041.3564H236.25V46.0559H238.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2041.3564H240.008V46.0559H241.883V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2041.3564H245.621V46.0559H247.496V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2046.0537H22.5V50.7531H37.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2046.0537H39.375V50.7531H41.2501V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2046.0537H43.1328V50.7531H45.0079V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2046.0537H46.8672V50.7531H48.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2046.0537H54.3828V50.7531H63.7577V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2046.0537H65.6211V50.7531H67.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.879%2046.0537H69.3789V50.7531H76.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2046.0537H78.75V50.7531H82.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7423%2046.0537H86.2422V50.7531H93.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2046.0537H95.625V50.7531H97.5001V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2046.0537H101.25V50.7531H108.75V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2046.0537H110.633V50.7531H112.508V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2046.0537H118.125V50.7531H120V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.496%2046.0537H121.871V50.7531H127.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M135%2046.0537H129.375V50.7531H135V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2046.0537H140.625V50.7531H148.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2046.0537H149.996V50.7531H153.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.742%2046.0537H159.367V50.7531H168.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2046.0537H172.496V50.7531H174.371V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2046.0537H178.121V50.7531H179.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2046.0537H181.879V50.7531H189.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2046.0537H191.25V50.7531H193.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.383%2046.0537H195.008V50.7531H204.383V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2046.0537H206.246V50.7531H209.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2046.0537H213.75V50.7531H226.875V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2046.0537H228.746V50.7531H230.621V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2046.0537H236.25V50.7531H238.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2046.0537H240.008V50.7531H241.883V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2046.0537H245.621V50.7531H247.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2050.7539H22.5V55.4533H37.4999V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2050.7539H39.375V55.4533H41.2501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2050.7539H43.1328V55.4533H45.0079V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2050.7539H46.8672V55.4533H48.7423V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0078%2050.7539H54.3828V55.4533H60.0078V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2050.7539H61.875V55.4533H63.7501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.125%2050.7539H67.5V55.4533H73.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2050.7539H74.9922V55.4533H84.3671V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2050.7539H86.2422V55.4533H88.1173V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2050.7539H95.625V55.4533H99.3749V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2050.7539H104.996V55.4533H108.746V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.375%2050.7539H112.5V55.4533H114.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2050.7539H118.125V55.4533H121.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.379%2050.7539H125.629V55.4533H129.379V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2050.7539H136.879V55.4533H140.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2050.7539H144.371V55.4533H148.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2050.7539H149.996V55.4533H151.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2050.7539H161.246V55.4533H163.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2050.7539H168.75V55.4533H172.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2050.7539H174.375V55.4533H178.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.504%2050.7539H181.879V55.4533H187.504V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2050.7539H189.371V55.4533H191.246V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2050.7539H195.008V55.4533H200.633V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2050.7539H202.5V55.4533H211.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2050.7539H213.75V55.4533H226.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2050.7539H228.746V55.4533H230.621V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2050.7539H236.25V55.4533H238.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2050.7539H240.008V55.4533H241.883V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2050.7539H245.621V55.4533H247.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2055.4551H22.5V60.1545H37.4999V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2055.4551H39.375V60.1545H41.2501V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2055.4551H43.1328V60.1545H45.0079V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2055.4551H46.8672V60.1545H48.7423V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2055.4551H54.3828V60.1545H65.6328V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2055.4551H67.5V60.1545H69.3751V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2055.4551H73.125V60.1545H75.0001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4961%2055.4551H76.8711V60.1545H82.4961V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2055.4551H86.2422V60.1545H88.1173V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2055.4551H90V60.1545H97.5001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.133%2055.4551H99.3828V60.1545H103.133V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2055.4551H104.996V60.1545H114.371V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2055.4551H118.125V60.1545H120V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2055.4551H121.871V60.1545H123.746V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2055.4551H125.629V60.1545H133.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.5%2055.4551H140.625V60.1545H142.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.496%2055.4551H149.996V60.1545H157.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.996%2055.4551H161.246V60.1545H164.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2055.4551H168.75V60.1545H172.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2055.4551H174.375V60.1545H176.25V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2055.4551H181.879V60.1545H183.754V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2055.4551H185.625V60.1545H187.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.621%2055.4551H189.371V60.1545H200.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.125%2055.4551H202.5V60.1545H208.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2055.4551H213.75V60.1545H226.875V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2055.4551H228.746V60.1545H230.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2055.4551H236.25V60.1545H238.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2055.4551H240.008V60.1545H241.883V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2055.4551H245.621V60.1545H247.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2060.1523H22.5V64.8518H37.4999V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2060.1523H39.375V64.8518H41.2501V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2060.1523H43.1328V64.8518H45.0079V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2060.1523H46.8672V64.8518H48.7423V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2060.1523H54.3828V64.8518H65.6328V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2060.1523H67.5V64.8518H69.3751V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8749%2060.1523H73.125V64.8518H76.8749V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M82.504%2060.1523H80.6289V64.8518H82.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2060.1523H86.2422V64.8518H88.1173V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3711%2060.1523H93.7461V64.8518H99.3711V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2060.1523H101.25V64.8518H103.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2060.1523H108.754V64.8518H112.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2060.1523H118.125V64.8518H121.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M131.258%2060.1523H127.508V64.8518H131.258V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2060.1523H136.879V64.8518H138.754V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2060.1523H140.625V64.8518H148.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2060.1523H149.996V64.8518H153.746V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M159.383%2060.1523H155.633V64.8518H159.383V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2060.1523H161.246V64.8518H163.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2060.1523H165.004V64.8518H172.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2060.1523H181.879V64.8518H191.254V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2060.1523H193.129V64.8518H195.004V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M204.367%2060.1523H198.742V64.8518H204.367V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2060.1523H206.246V64.8518H208.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2060.1523H213.75V64.8518H226.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2060.1523H228.746V64.8518H230.621V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2060.1523H236.25V64.8518H238.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2060.1523H240.008V64.8518H241.883V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2060.1523H245.621V64.8518H247.496V60.1523Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56590'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._id-mrz-barcode-back-icon_e1bzj_63:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56870)'%3e%3cpath%20d='M247.496%2022.5576H22.4961V64.8527H247.496V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.496%2022.5576H22.4961V27.257H37.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2022.5576H39.3711V27.257H41.2462V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2022.5576H43.1289V27.257H45.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2022.5576H46.8633V27.257H48.7384V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2022.5576H54.3789V27.257H63.7538V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2022.5576H65.6172V27.257H67.4923V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2022.5576H69.375V27.257H71.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2022.5576H73.1211V27.257H82.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2022.5576H86.2383V27.257H89.9882V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7501%2022.5576H91.875V27.257H93.7501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2022.5576H95.6211V27.257H99.371V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.617%2022.5576H104.992V27.257H110.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2022.5576H118.121V27.257H121.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.121%2022.5576H129.371V27.257H133.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2022.5576H134.996V27.257H136.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2022.5576H138.754V27.257H140.629V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2022.5576H149.992V27.257H151.867V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.375%2022.5576H153.75V27.257H159.375V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2022.5576H166.879V27.257H172.504V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2022.5576H174.371V27.257H176.246V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2022.5576H181.875V27.257H191.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2022.5576H193.125V27.257H195V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2022.5576H196.871V27.257H198.746V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2022.5576H200.617V27.257H209.992V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2022.5576H213.746V27.257H226.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2022.5576H228.742V27.257H230.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2022.5576H236.246V27.257H238.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2022.5576H240.004V27.257H241.879V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2022.5576H245.617V27.257H247.492V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2027.2578H22.4961V31.9572H37.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2027.2578H39.3711V31.9572H41.2462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2027.2578H43.1289V31.9572H45.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2027.2578H46.8633V31.9572H48.7384V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.879%2027.2578H54.3789V31.9572H61.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6251%2027.2578H63.75V31.9572H65.6251V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2027.2578H67.4961V31.9572H69.3712V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7423%2027.2578H76.8672V31.9572H78.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8633%2027.2578H86.2383V31.9572H91.8633V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2027.2578H97.5V31.9572H99.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M104.996%2027.2578H101.246V31.9572H104.996V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2027.2578H110.629V31.9572H112.504V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2027.2578H118.121V31.9572H121.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2027.2578H125.625V31.9572H133.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2027.2578H134.996V31.9572H136.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2027.2578H138.754V31.9572H148.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.617%2027.2578H149.992V31.9572H155.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2027.2578H161.242V31.9572H163.117V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2027.2578H168.746V31.9572H174.371V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2027.2578H176.25V31.9572H180V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2027.2578H181.875V31.9572H189.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2027.2578H191.246V31.9572H193.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.879%2027.2578H195.004V31.9572H196.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.492%2027.2578H200.617V31.9572H202.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2027.2578H213.746V31.9572H226.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2027.2578H228.742V31.9572H230.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2027.2578H236.246V31.9572H238.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2027.2578H240.004V31.9572H241.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2027.2578H245.617V31.9572H247.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2031.9561H22.4961V36.6555H37.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2031.9561H39.3711V36.6555H41.2462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2031.9561H43.1289V36.6555H45.004V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2031.9561H46.8633V36.6555H48.7384V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.254%2031.9561H54.3789V36.6555H56.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9884%2031.9561H58.1133V36.6555H59.9884V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2031.9561H61.8711V36.6555H63.7462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2031.9561H67.4961V36.6555H74.9962V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2031.9561H86.2383V36.6555H89.9882V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2031.9561H91.875V36.6555H103.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2031.9561H104.992V36.6555H108.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2031.9561H110.629V36.6555H112.504V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2031.9561H118.121V36.6555H119.996V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2031.9561H121.867V36.6555H123.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.867%2031.9561H133.117V36.6555H136.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2031.9561H138.754V36.6555H148.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2031.9561H149.992V36.6555H151.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.254%2031.9561H155.629V36.6555H161.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.488%2031.9561H170.613V36.6555H172.488V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2031.9561H174.371V36.6555H178.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2031.9561H181.875V36.6555H183.75V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2031.9561H185.621V36.6555H187.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2031.9561H189.367V36.6555H191.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.238%2031.9561H198.738V36.6555H206.238V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2031.9561H213.746V36.6555H226.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2031.9561H228.742V36.6555H230.617V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2031.9561H236.246V36.6555H238.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2031.9561H240.004V36.6555H241.879V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2031.9561H245.617V36.6555H247.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2036.6562H22.4961V41.3557H37.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2036.6562H39.3711V41.3557H41.2462V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2036.6562H43.1289V41.3557H45.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2036.6562H46.8633V41.3557H48.7384V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2036.6562H54.3789V41.3557H58.1288V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2036.6562H59.9922V41.3557H61.8673V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2036.6562H63.75V41.3557H71.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2036.6562H74.9883V41.3557H84.3632V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6132%2036.6562H86.2383V41.3557H95.6132V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2036.6562H97.5V41.3557H99.3751V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2036.6562H101.246V41.3557H103.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.246%2036.6562H106.871V41.3557H116.246V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2036.6562H118.121V41.3557H123.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.25%2036.6562H125.625V41.3557H131.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2036.6562H133.117V41.3557H134.992V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2036.6562H138.754V41.3557H140.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2036.6562H149.992V41.3557H153.742V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.504%2036.6562H155.629V41.3557H157.504V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.754%2036.6562H166.879V41.3557H168.754V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2036.6562H176.25V41.3557H180V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.625%2036.6562H181.875V41.3557H185.625V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.363%2036.6562H187.488V41.3557H189.363V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2036.6562H191.246V41.3557H198.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2036.6562H202.496V41.3557H211.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2036.6562H213.746V41.3557H226.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2036.6562H228.742V41.3557H230.617V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2036.6562H236.246V41.3557H238.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2036.6562H240.004V41.3557H241.879V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2036.6562H245.617V41.3557H247.492V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2041.3555H22.4961V46.0549H37.496V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2041.3555H39.3711V46.0549H41.2462V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2041.3555H43.1289V46.0549H45.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2041.3555H46.8633V46.0549H48.7384V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2041.3555H54.3789V46.0549H58.1288V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2041.3555H59.9922V46.0549H61.8673V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M69.375%2041.3555H63.75V46.0549H69.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6212%2041.3555H78.7461V46.0549H80.6212V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4883%2041.3555H86.2383V46.0549H97.4883V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M105.004%2041.3555H99.3789V46.0549H105.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2041.3555H106.871V46.0549H108.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2041.3555H110.629V46.0549H112.504V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2041.3555H118.121V46.0549H123.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M127.5%2041.3555H125.625V46.0549H127.5V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M134.988%2041.3555H131.238V46.0549H134.988V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2041.3555H136.875V46.0549H138.75V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2041.3555H149.992V46.0549H153.742V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M166.875%2041.3555H165V46.0549H166.875V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M176.238%2041.3555H170.613V46.0549H176.238V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2041.3555H178.117V46.0549H179.992V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2041.3555H181.875V46.0549H189.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2041.3555H191.246V46.0549H193.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2041.3555H195.004V46.0549H200.629V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M210%2041.3555H204.375V46.0549H210V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2041.3555H213.746V46.0549H226.871V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2041.3555H228.742V46.0549H230.617V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2041.3555H236.246V46.0549H238.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2041.3555H240.004V46.0549H241.879V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2041.3555H245.617V46.0549H247.492V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2046.0537H22.4961V50.7531H37.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2046.0537H39.3711V50.7531H41.2462V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2046.0537H43.1289V50.7531H45.004V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2046.0537H46.8633V50.7531H48.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2046.0537H54.3789V50.7531H63.7538V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2046.0537H65.6172V50.7531H67.4923V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8751%2046.0537H69.375V50.7531H76.8751V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2046.0537H78.7461V50.7531H82.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7384%2046.0537H86.2383V50.7531H93.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2046.0537H95.6211V50.7531H97.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2046.0537H101.246V50.7531H108.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2046.0537H110.629V50.7531H112.504V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2046.0537H118.121V50.7531H119.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.492%2046.0537H121.867V50.7531H127.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2046.0537H129.371V50.7531H134.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2046.0537H140.621V50.7531H148.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2046.0537H149.992V50.7531H153.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.738%2046.0537H159.363V50.7531H168.738V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.367%2046.0537H172.492V50.7531H174.367V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2046.0537H178.117V50.7531H179.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2046.0537H181.875V50.7531H189.375V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2046.0537H191.246V50.7531H193.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.379%2046.0537H195.004V50.7531H204.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2046.0537H206.242V50.7531H209.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2046.0537H213.746V50.7531H226.871V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2046.0537H228.742V50.7531H230.617V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2046.0537H236.246V50.7531H238.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2046.0537H240.004V50.7531H241.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2046.0537H245.617V50.7531H247.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2050.7539H22.4961V55.4533H37.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2050.7539H39.3711V55.4533H41.2462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2050.7539H43.1289V55.4533H45.004V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2050.7539H46.8633V55.4533H48.7384V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0039%2050.7539H54.3789V55.4533H60.0039V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2050.7539H61.8711V55.4533H63.7462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.1211%2050.7539H67.4961V55.4533H73.1211V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2050.7539H74.9883V55.4533H84.3632V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2050.7539H86.2383V55.4533H88.1134V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2050.7539H95.6211V55.4533H99.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2050.7539H104.992V55.4533H108.742V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2050.7539H112.496V55.4533H114.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2050.7539H118.121V55.4533H121.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.375%2050.7539H125.625V55.4533H129.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.625%2050.7539H136.875V55.4533H140.625V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.117%2050.7539H144.367V55.4533H148.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2050.7539H149.992V55.4533H151.867V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2050.7539H161.242V55.4533H163.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2050.7539H168.746V55.4533H172.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2050.7539H174.371V55.4533H178.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2050.7539H181.875V55.4533H187.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2050.7539H189.367V55.4533H191.242V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2050.7539H195.004V55.4533H200.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2050.7539H202.496V55.4533H211.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2050.7539H213.746V55.4533H226.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2050.7539H228.742V55.4533H230.617V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2050.7539H236.246V55.4533H238.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2050.7539H240.004V55.4533H241.879V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2050.7539H245.617V55.4533H247.492V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2055.4551H22.4961V60.1545H37.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2055.4551H39.3711V60.1545H41.2462V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2055.4551H43.1289V60.1545H45.004V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2055.4551H46.8633V60.1545H48.7384V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2055.4551H54.3789V60.1545H65.6289V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2055.4551H67.4961V60.1545H69.3712V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2055.4551H73.1211V60.1545H74.9962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4922%2055.4551H76.8672V60.1545H82.4922V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2055.4551H86.2383V60.1545H88.1134V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2055.4551H89.9961V60.1545H97.4962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2055.4551H99.3789V60.1545H103.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.367%2055.4551H104.992V60.1545H114.367V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2055.4551H118.121V60.1545H119.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2055.4551H121.867V60.1545H123.742V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2055.4551H125.625V60.1545H133.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.496%2055.4551H140.621V60.1545H142.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.492%2055.4551H149.992V60.1545H157.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.992%2055.4551H161.242V60.1545H164.992V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2055.4551H168.746V60.1545H172.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2055.4551H174.371V60.1545H176.246V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2055.4551H181.875V60.1545H183.75V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2055.4551H185.621V60.1545H187.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.617%2055.4551H189.367V60.1545H200.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2055.4551H202.496V60.1545H208.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2055.4551H213.746V60.1545H226.871V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2055.4551H228.742V60.1545H230.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2055.4551H236.246V60.1545H238.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2055.4551H240.004V60.1545H241.879V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2055.4551H245.617V60.1545H247.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2060.1514H22.4961V64.8508H37.496V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2060.1514H39.3711V64.8508H41.2462V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2060.1514H43.1289V64.8508H45.004V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2060.1514H46.8633V64.8508H48.7384V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2060.1514H54.3789V64.8508H65.6289V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2060.1514H67.4961V64.8508H69.3712V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M76.871%2060.1514H73.1211V64.8508H76.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M82.5001%2060.1514H80.625V64.8508H82.5001V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2060.1514H86.2383V64.8508H88.1134V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3672%2060.1514H93.7422V64.8508H99.3672V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2060.1514H101.246V64.8508H103.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M112.5%2060.1514H108.75V64.8508H112.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2060.1514H118.121V64.8508H121.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2060.1514H127.504V64.8508H131.254V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2060.1514H136.875V64.8508H138.75V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2060.1514H140.621V64.8508H148.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2060.1514H149.992V64.8508H153.742V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2060.1514H155.629V64.8508H159.379V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2060.1514H161.242V64.8508H163.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2060.1514H165V64.8508H172.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2060.1514H181.875V64.8508H191.25V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2060.1514H193.125V64.8508H195V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M204.363%2060.1514H198.738V64.8508H204.363V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M208.117%2060.1514H206.242V64.8508H208.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2060.1514H213.746V64.8508H226.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2060.1514H228.742V64.8508H230.617V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2060.1514H236.246V64.8508H238.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2060.1514H240.004V64.8508H241.879V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2060.1514H245.617V64.8508H247.492V60.1514Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56870'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._bank-card-front-icon_e1bzj_67:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45763'%20y='-1.45763'%20width='277.085'%20height='169.085'%20rx='13.1186'%20transform='matrix(1%200%200%20-1%200%20169.085)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91525'/%3e%3crect%20x='23.332'%20y='23.3223'%20width='107.917'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='93.332'%20y='142.848'%20width='99.1667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='122.44'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='84.582'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='207.082'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='142.848'%20width='61.25'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='52.4746'%20width='40.8333'%20height='37.8983'%20rx='5.83051'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='58.3047'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='44.4805'%20y='52.4746'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2052.4746)'%20fill='white'/%3e%3crect%20x='37.918'%20y='58.3047'%20width='26.2373'%20height='1.45833'%20transform='rotate(90%2037.918%2058.3047)'%20fill='white'/%3e%3crect%20x='51.043'%20y='67.0508'%20width='17.4915'%20height='1.45833'%20transform='rotate(90%2051.043%2067.0508)'%20fill='white'/%3e%3crect%20x='44.4805'%20y='84.542'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2084.542)'%20fill='white'/%3e%3crect%20x='23.3359'%20y='83.085'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3ccircle%20cx='224.476'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3ccircle%20cx='247.796'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3c/svg%3e")}._bank-card-back-icon_e1bzj_71:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45833'%20y='-1.45833'%20width='277.083'%20height='169.083'%20rx='13.125'%20transform='matrix(1%200%200%20-1%200%20169.083)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91667'/%3e%3crect%20y='14.5762'%20width='280'%20height='40.8136'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='69.9658'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='224.582'%20y='119.525'%20width='23.3333'%20height='34.9831'%20fill='%23333543'/%3e%3ccircle%20cx='224.582'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3ccircle%20cx='247.918'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3c/svg%3e")}._document-front-icon_e1bzj_75:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M520%20200H800V240H520V200Z'%20fill='white'/%3e%3cpath%20d='M800%20300H520V340H800V300Z'%20fill='white'/%3e%3cpath%20d='M520%20400H800V440H520V400Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M274.943%20123.429L274.933%20123.432C266.551%20126.295%20258.863%20130.466%20251.927%20135.343C243.39%20140.807%20235.349%20147.484%20228.244%20155.117C216.999%20166.723%20206.985%20181.73%20202.638%20200.462C201.732%20203.954%20201.031%20207.508%20200.554%20211.114C198.857%20223.937%20199.991%20237.409%20204.799%20251.055C201.906%20250.776%20199.719%20251.697%20198.089%20253.419C191.062%20260.842%20194.356%20283.152%20195.842%20288.454C202.652%20312.775%20208.999%20319.597%20213.796%20319.988C216.486%20337.575%20230.545%20358.063%20243.587%20375.139C243.587%20405.888%20203.816%20413.339%20170.442%20419.591C162.723%20421.037%20155.346%20422.419%20148.883%20424.01C114.629%20432.436%20110.268%20472.281%20110.168%20504.349C110.141%20513.052%20117.321%20520%20126.023%20520H473.977C482.679%20520%20489.859%20513.052%20489.839%20504.349C489.769%20472.142%20485.483%20432.464%20451.117%20424.01C445.211%20422.556%20438.486%20421.191%20431.39%20419.752L431.388%20419.751C396.76%20412.725%20353.321%20403.912%20353.321%20374.203C353.664%20373.739%20354.01%20373.272%20354.358%20372.804C357.463%20368.617%20360.701%20364.25%20363.825%20359.791C372.128%20347.938%20379.624%20335.429%20381.652%20323.912C382.709%20324.634%20383.91%20325.123%20385.24%20325.123C385.796%20325.123%20386.374%20325.037%20386.972%20324.849C391.593%20323.394%20397.418%20315.772%20403.633%20293.568C410.9%20267.609%20406.477%20258.905%20400.199%20256.714C420.616%20157.928%20373.971%20154.617%20373.971%20154.617C373.971%20154.617%20366.934%20140.939%20348.397%20130.606C337.66%20124.183%20323.287%20119%20304.851%20119C301.953%20119%20298.964%20119.122%20295.865%20119.395C288.479%20119.744%20281.5%20121.188%20274.943%20123.429ZM321.183%20350.388C316.077%20357.278%20313.321%20365.627%20313.321%20374.203C313.321%20396.791%20323.959%20414.183%20337.296%20425.916C349.473%20436.63%20364.134%20443.009%20376.199%20447.154C388.689%20451.445%20401.819%20454.454%20412.943%20456.796C417.197%20457.692%20421.006%20458.464%20424.494%20459.171L424.495%20459.171C431.031%20460.495%20436.443%20461.592%20441.555%20462.85L441.562%20462.852C442.371%20463.051%20442.688%20463.234%20442.718%20463.251L442.719%20463.252L442.723%20463.254C442.746%20463.267%20442.79%20463.292%20442.907%20463.412C443.207%20463.723%20444.371%20465.103%20445.684%20468.766C446.817%20471.928%20447.691%20475.687%20448.338%20480H151.711C152.363%20475.717%20153.239%20471.971%20154.372%20468.81C155.699%20465.109%20156.878%20463.698%20157.192%20463.372L157.194%20463.369C157.207%20463.34%20157.301%20463.132%20158.438%20462.852L158.445%20462.85C163.729%20461.549%20169.527%20460.462%20176.817%20459.096L176.821%20459.095C179.572%20458.579%20182.535%20458.024%20185.763%20457.402C196.469%20455.34%20209.407%20452.649%20221.731%20448.562C233.686%20444.597%20248.469%20438.255%20260.709%20426.995C274.269%20414.522%20283.587%20396.915%20283.587%20375.139C283.587%20366.365%20280.702%20357.834%20275.376%20350.86C269.197%20342.77%20263.625%20334.956%20259.415%20327.693C254.949%20319.99%20253.579%20315.526%20253.336%20313.941C251.698%20303.233%20245.887%20294.002%20237.651%20287.879C236.767%20285.573%20235.697%20282.397%20234.493%20278.142C234.495%20278.139%20234.486%20278.086%20234.467%20277.984L234.452%20277.901C235.091%20277.195%20235.707%20276.464%20236.298%20275.708C244.717%20264.952%20247.065%20250.644%20242.526%20237.762C239.17%20228.237%20239.103%20219.19%20241.356%20210.506C241.443%20210.173%20241.525%20209.839%20241.603%20209.503C243.904%20199.588%20249.376%20190.79%20256.971%20182.951C257.156%20182.76%20257.34%20182.567%20257.521%20182.372C262.328%20177.208%20267.774%20172.691%20273.489%20169.034C273.978%20168.721%20274.46%20168.397%20274.936%20168.063C279.286%20165.004%20283.597%20162.748%20287.809%20161.303L287.883%20161.278C291.162%20160.157%20294.424%20159.508%20297.75%20159.351C298.292%20159.325%20298.833%20159.288%20299.374%20159.241C301.267%20159.074%20303.083%20159%20304.851%20159C315.374%20159%20322.72%20161.857%20327.864%20164.933C328.213%20165.142%20328.565%20165.345%20328.92%20165.543C333.473%20168.081%20336.341%20170.874%20337.886%20172.659C338.515%20173.386%20338.906%20173.925%20339.077%20174.173C344.22%20183.353%20352.722%20190.05%20362.636%20192.979C364.507%20197.532%20368.476%20212.578%20361.027%20248.618C358.865%20259.075%20361.005%20269.523%20366.336%20278.005C366.023%20279.378%20365.623%20280.965%20365.114%20282.784L365.113%20282.786C364.533%20284.861%20363.983%20286.685%20363.469%20288.283C352.34%20293.961%20344.445%20304.559%20342.258%20316.974C342.258%20316.974%20342.208%20317.246%20342.023%20317.818C341.833%20318.406%20341.53%20319.218%20341.065%20320.269C340.111%20322.423%20338.685%20325.105%20336.678%20328.368C332.654%20334.911%20327.684%20341.617%20321.853%20349.483L321.183%20350.388Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M80%200C35.8172%200%200%2035.8172%200%2080V560C0%20604.183%2035.8172%20640%2080%20640H840C884.183%20640%20920%20604.183%20920%20560V80C920%2035.8172%20884.183%200%20840%200H80ZM840%2040H80C57.9086%2040%2040%2057.9086%2040%2080V560C40%20582.091%2057.9086%20600%2080%20600H840C862.091%20600%20880%20582.091%20880%20560V80C880%2057.9086%20862.091%2040%20840%2040Z'%20fill='white'/%3e%3c/svg%3e")}._document-back-icon_e1bzj_79:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M460%20300H140V340H460V300Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M100%200C44.7715%200%200%2044.7715%200%20100V540C0%20595.228%2044.7715%20640%20100%20640H820C875.228%20640%20920%20595.228%20920%20540V100C920%2044.7715%20875.229%200%20820%200H100ZM820%2040H100C66.8629%2040%2040%2066.8629%2040%20100V140H880V100C880%2066.8629%20853.137%2040%20820%2040ZM40%20540V240H880V540C880%20573.137%20853.137%20600%20820%20600H100C66.8629%20600%2040%20573.137%2040%20540Z'%20fill='white'/%3e%3c/svg%3e")}@keyframes _vertical_e1bzj_19{0%{transform:rotateX(0)}17.65%{transform:rotateX(-20deg)}32.35%{transform:rotateX(-20deg)}67.65%{transform:rotateX(20deg)}82.35%{transform:rotateX(20deg)}to{transform:rotateX(0)}}@keyframes _horizontal_e1bzj_23{0%{transform:rotateY(0)}17.65%{transform:rotateY(-20deg)}32.35%{transform:rotateY(-20deg)}67.65%{transform:rotateY(20deg)}82.35%{transform:rotateY(20deg)}to{transform:rotateY(0)}}@keyframes _left-bottom-right-top_e1bzj_27{0%{transform:rotateX(0) rotateY(0)}17.65%{transform:rotateX(20deg) rotateY(-20deg)}32.35%{transform:rotateX(20deg) rotateY(-20deg)}67.65%{transform:rotateX(-20deg) rotateY(20deg)}82.35%{transform:rotateX(-20deg) rotateY(20deg)}to{transform:rotateX(0) rotateY(0)}}@keyframes _right-bottom-left-top_e1bzj_31{0%{transform:rotateX(0) rotateY(0)}17.65%{transform:rotateX(-20deg) rotateY(-20deg)}32.35%{transform:rotateX(-20deg) rotateY(-20deg)}67.65%{transform:rotateX(20deg) rotateY(20deg)}82.35%{transform:rotateX(20deg) rotateY(20deg)}to{transform:rotateX(0) rotateY(0)}}`, R8 = '._spinner_1vpw0_1{width:48px;height:48px;position:relative}._spinner_1vpw0_1 div{position:absolute;top:0;left:0;box-sizing:border-box;width:100%;height:100%;border-radius:50%;border:2px solid #7E57C5;border-bottom-color:transparent;animation:_spin_1vpw0_1 1s linear infinite}._spinner_1vpw0_1:before{content:"";width:100%;height:100%;border-radius:50%;border:2px solid #D9D9D9;position:absolute;top:0;left:0;box-sizing:border-box}@keyframes _spin_1vpw0_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._process-message_1vpw0_41{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;padding:24px;row-gap:24px}._message_1vpw0_51{display:block;font-size:14px;line-height:20px;color:#000}', D8 = '._button_7h3jm_1{display:flex;width:100%;max-width:290px;padding:12px 24px;justify-content:center;column-gap:5px;background:#fff;border:1px solid #211236;border-radius:112px;cursor:pointer;font-family:Inter,sans-serif;font-style:normal;line-height:135%;font-size:18px;font-weight:400;color:#211236;white-space:nowrap}._button_7h3jm_1:before{content:"";display:inline-flex;width:22px;height:22px;background-repeat:no-repeat;background-position:center;background-size:contain}._button_7h3jm_1:hover:not(:disabled),._button_7h3jm_1:focus:not(:disabled){background:#f5f5f5}._button_7h3jm_1:active:not(:disabled){background:#e2e2e2}._button_7h3jm_1:disabled{opacity:.5;cursor:default}._button_7h3jm_1:focus-visible{outline:2px solid blue}', A8 = "._copyright_6b3ik_1{font-size:12px;font-weight:500;line-height:16px;letter-spacing:-.12px;color:#8c8c8c;direction:ltr}._copyright_6b3ik_1 img{vertical-align:bottom}", fV = '._remote-scanner-wrapper_18b5u_1{display:flex;flex:1;flex-direction:column;align-items:center;row-gap:24px;justify-content:center;padding:24px}._qr-container_18b5u_11{display:flex;flex-direction:column;align-items:center;max-width:350px;max-height:140px}._text_18b5u_19{display:flex;flex-direction:column;align-items:center;text-align:center;row-gap:16px}._title_18b5u_27{max-width:465px;color:#000;font-size:20px;font-weight:600;line-height:20px;margin:0}._subtitle_18b5u_36{display:block;max-width:465px;color:#454545;font-size:14px;font-weight:400;line-height:20px;margin:0}._content-container_18b5u_46{display:flex;flex-direction:column;row-gap:10px}._divider_18b5u_52{display:flex;align-items:center;text-align:center;column-gap:10px;color:#b5b5b5;font-size:12px;font-weight:400;line-height:12px;text-transform:uppercase}._divider_18b5u_52:before,._divider_18b5u_52:after{content:"";flex:1;border-top:1px solid #B5B5B5}._button_18b5u_71{align-self:center;padding:0;border:none;cursor:pointer;background:none;color:#454545;font-size:12px;font-weight:500;line-height:12px;font-family:Inter,sans-serif}._button_18b5u_71:hover{color:#7e57c5}._button_18b5u_71:focus-visible{outline:2px solid blue}', dV = `._verified-screen_evxkx_1:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%235DA600'%20stroke-width='3'/%3e%3cpath%20d='M66%2030L40.5069%2054L28%2042.2256'%20stroke='%235DA600'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._error-screen_evxkx_5:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M57%2028L29%2056M29%2028L57%2056'%20stroke='%23FF0000'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._camera-disabled-screen_evxkx_9:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='37'%20stroke='%23FF5E5E'%20stroke-width='3'/%3e%3cpath%20d='M40.213%2030.6667H44.6663C45.3736%2030.6667%2046.0519%2030.9476%2046.552%2031.4477C47.0521%2031.9478%2047.333%2032.6261%2047.333%2033.3334V37.7867L48.6663%2038.12L56.6663%2033.3334V46.6667M47.333%2045.3334V46.6667C47.333%2047.3739%2047.0521%2048.0522%2046.552%2048.5523C46.0519%2049.0524%2045.3736%2049.3334%2044.6663%2049.3334H29.9997C29.2924%2049.3334%2028.6142%2049.0524%2028.1141%2048.5523C27.614%2048.0522%2027.333%2047.3739%2027.333%2046.6667V33.3334C27.333%2032.6261%2027.614%2031.9478%2028.1141%2031.4477C28.6142%2030.9476%2029.2924%2030.6667%2029.9997%2030.6667H32.6663L47.333%2045.3334Z'%20stroke='%23FF5E5E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M27.333%2025.3333L56.6663%2054.6666'%20stroke='%23FF5E5E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`, T8 = "._container_1hyic_1{display:flex;flex:1}._video_1hyic_6{background-color:#fff;width:100%;height:100%;object-fit:contain}", O8 = "._announcer_1qj2e_1{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);border:0}", pV = "Подготовка камеры...", hV = "Тайм-аут", _V = "Нет фокусировки камеры", mV = "Что-то пошло не так", EV = "Камера с заданным ID не найдена.", CV = "Готово!", SV = "Камера недоступна!", IV = "Версия вашего браузера не поддерживается", vV = "HTTPS не используется", gV = "Небезопасный контекст", RV = "Лицензия не найдена или недействительна", DV = "Файл поврежден или не поддерживается", AV = "Размер загружаемого файла слишком велик", TV = "Поместите документ в рамку", OV = "Держите документ прямо", yV = "Избегайте бликов на документе", NV = "Повторите попытку", LV = "Отсутствует камера", MV = "Расположите документ в центре", PV = "Загрузите фото", bV = "Подвиньтесь ближе", wV = "Держите устройство неподвижно", HV = "Камера", VV = "Перейдите к мобильному устройству", kV = "Откройте камеру мобильного устройства, отсканируйте QR-код и перейдите по ссылке", FV = "Пожалуйста, подождите…", UV = "Мобильное устройство", xV = "Проверка документа, удостоверяющего личность", BV = "Сделайте снимок документа камерой компьютера, загрузите из файлов или отсканируйте с мобильного устройства", $V = "Сделайте снимок документа камерой компьютера или загрузите из файлов", GV = "Сделайте снимок документа камерой компьютера или отсканируйте с мобильного устройства", ZV = "Загрузите документ из файлов или отсканируйте его с мобильного устройства", jV = "Воспользуйтесь камерой компьютера, чтобы сделать снимок документа", zV = "Выберите документ из файлов и загрузите его", qV = "Воспользуйтесь камерой мобильного устройства, чтобы сделать снимок документа", WV = "Сделайте снимок документа камерой мобильного устройства или загрузите из галереи", YV = "Выберите документ из галереи и загрузите его", KV = "Галерея", XV = "Файлы", QV = "Вернитесь к компьютеру", JV = "Ваш документ захвачен", ek = "или", tk = "Нажмите сюда, чтобы продолжить в браузере", rk = {
  preparingCamera: pV,
  timeout: hV,
  noFocus: _V,
  somethingWentWrong: mV,
  incorrectCameraId: EV,
  done: CV,
  cameraUnavailable: SV,
  versionNotSupported: IV,
  httpNotSupported: vV,
  insecurePageContext: gV,
  badLicense: RV,
  fileCorrupt: DV,
  largeFile: AV,
  placeDocumentIntoFrame: TV,
  holdDocumentStraight: OV,
  glaresOnDocument: yV,
  tryAgain: NV,
  noCameraAvailable: LV,
  positionDocumentCenter: MV,
  uploadPhoto: PV,
  moveCloser: bV,
  keepDeviceStill: wV,
  camera: HV,
  switchToMobile: VV,
  openPhoneCamera: kV,
  pleaseWait: FV,
  mobileDevice: UV,
  verifyYourIdentity: xV,
  fromCameraFilesMobileDesktop: BV,
  fromCameraFilesDesktop: $V,
  fromCameraMobileDesktop: GV,
  fromFilesMobileDesktop: ZV,
  fromCameraDesktop: jV,
  fromFilesDesktop: zV,
  fromMobileDesktop: qV,
  fromCameraGalleryMobile: WV,
  fromGalleryMobile: YV,
  gallery: KV,
  files: XV,
  returnToComputer: QV,
  documentCaptured: JV,
  or: ek,
  continueInBrowser: tk
}, nk = "Preparing the camera...", ik = "Timeout", ak = "No camera focus", ok = "Something went wrong", sk = "No camera with the specified ID found.", lk = "Done!", ck = "Camera unavailable!", uk = "Your browser version is not supported", fk = "HTTPS not used", dk = "Insecure context", pk = "The license cannot be found or has expired", hk = "This file is corrupt or not supported", _k = "This file is too large to be uploaded", mk = "Fit the document into the frame", Ek = "Hold the document straight", Ck = "Avoid glare on the document", Sk = "Try again", Ik = "No camera available", vk = "Position the document in the center", gk = "Upload a photo", Rk = "Move closer", Dk = "Hold the device still", Ak = "Camera", Tk = "Switch to mobile", Ok = "Open the camera on your mobile device, scan the QR code, and follow the link", yk = "Please wait...", Nk = "Mobile device", Lk = "Identity document verification", Mk = "Capture a document using the computer’s camera, upload it from files, or scan it on a mobile device", Pk = "Capture a document using the computer’s camera or upload it from files", bk = "Capture a document using the computer’s camera or scan it on a mobile device", wk = "Upload a document from files or scan it on a mobile device", Hk = "Use the computer's camera to capture a document", Vk = "Pick a document from files and upload it", kk = "Use your mobile camera to capture a document", Fk = "Capture a document using the mobile's camera or upload it from gallery", Uk = "Pick a document from the gallery and upload it", xk = "Gallery", Bk = "Files", $k = "Return to the computer", Gk = "Your document has been captured", Zk = "or", jk = "Click here to continue in browser", zk = {
  preparingCamera: nk,
  timeout: ik,
  noFocus: ak,
  somethingWentWrong: ok,
  incorrectCameraId: sk,
  done: lk,
  cameraUnavailable: ck,
  versionNotSupported: uk,
  httpNotSupported: fk,
  insecurePageContext: dk,
  badLicense: pk,
  fileCorrupt: hk,
  largeFile: _k,
  placeDocumentIntoFrame: mk,
  holdDocumentStraight: Ek,
  glaresOnDocument: Ck,
  tryAgain: Sk,
  noCameraAvailable: Ik,
  positionDocumentCenter: vk,
  uploadPhoto: gk,
  moveCloser: Rk,
  keepDeviceStill: Dk,
  camera: Ak,
  switchToMobile: Tk,
  openPhoneCamera: Ok,
  pleaseWait: yk,
  mobileDevice: Nk,
  verifyYourIdentity: Lk,
  fromCameraFilesMobileDesktop: Mk,
  fromCameraFilesDesktop: Pk,
  fromCameraMobileDesktop: bk,
  fromFilesMobileDesktop: wk,
  fromCameraDesktop: Hk,
  fromFilesDesktop: Vk,
  fromMobileDesktop: kk,
  fromCameraGalleryMobile: Fk,
  fromGalleryMobile: Uk,
  gallery: xk,
  files: Bk,
  returnToComputer: $k,
  documentCaptured: Gk,
  or: Zk,
  continueInBrowser: jk
}, qk = "Kamera wird vorbereitet...", Wk = "Timeout", Yk = "Kein Kamerafokus", Kk = "Etwas ist schief gelaufen", Xk = "Keine Kamera mit angegebener ID gefunden", Qk = "Fertig!", Jk = "Kamera nicht verfügbar!", eF = "Ihre Browserversion wird nicht unterstützt", tF = "HTTPS nicht verwendet", rF = "Unsicherer Kontext", nF = "Die Lizenz kann nicht gefunden werden oder ist abgelaufen", iF = "Diese Datei ist beschädigt oder wird nicht unterstützt", aF = "Diese Datei ist zu groß, um hochgeladen zu werden", oF = "Passen Sie das Dokument in den Rahmen ein", sF = "Halten Sie das Dokument gerade", lF = "Vermeiden Sie Blendungen auf dem Dokument", cF = "Erneut versuchen", uF = "Keine Kamera vorhanden", fF = "Positionieren Sie das Dokument in der Mitte", dF = "Foto hochladen", pF = "Näher an die Kamera", hF = "Halten Sie das Gerät still", _F = "Kamera", mF = "Wechseln Sie zurück zum Smartphone", EF = "Öffnen Sie die Kamera auf Ihrem mobilen Gerät, scannen Sie den QR-Code und folgen Sie dem Link", CF = "Bitte warten...", SF = "Mobiles Gerät", IF = "Verifizierung von Ausweisdokumenten", vF = "Erfassen Sie ein Dokument mit der Computerkamera, laden Sie es aus Dateien hoch oder scannen Sie es mit einem mobilen Gerät", gF = "Erfassen Sie ein Dokument mit der Kamera des Computers oder laden Sie es als Datei hoch", RF = "Erfassen Sie ein Dokument mit der Kamera des Computers oder scannen Sie es mit einem mobilen Gerät ein.", DF = "Laden Sie ein Dokument aus den Dateien oder scannen Sie es mit einem mobilen Gerät", AF = "Verwenden Sie die Kamera des Computers, um ein Dokument zu erfassen", TF = "Wählen Sie ein Dokument aus den Dateien aus und laden Sie es hoch", OF = "Verwenden Sie Ihre Smartphone-Kamera, um ein Dokument zu erfassen", yF = "Erfassen Sie ein Dokument mit der Kamera des Smartphones oder laden Sie es aus der Galerie hoch.", NF = "Wählen Sie ein Dokument aus der Galerie und laden Sie es hoch", LF = "Galerie", MF = "Dateien", PF = "Kehren Sie zum Computer zurück", bF = "Ihr Dokument wurde erfasst", wF = "oder", HF = "Klicken Sie hier, um im Browser fortzufahren", VF = {
  preparingCamera: qk,
  timeout: Wk,
  noFocus: Yk,
  somethingWentWrong: Kk,
  incorrectCameraId: Xk,
  done: Qk,
  cameraUnavailable: Jk,
  versionNotSupported: eF,
  httpNotSupported: tF,
  insecurePageContext: rF,
  badLicense: nF,
  fileCorrupt: iF,
  largeFile: aF,
  placeDocumentIntoFrame: oF,
  holdDocumentStraight: sF,
  glaresOnDocument: lF,
  tryAgain: cF,
  noCameraAvailable: uF,
  positionDocumentCenter: fF,
  uploadPhoto: dF,
  moveCloser: pF,
  keepDeviceStill: hF,
  camera: _F,
  switchToMobile: mF,
  openPhoneCamera: EF,
  pleaseWait: CF,
  mobileDevice: SF,
  verifyYourIdentity: IF,
  fromCameraFilesMobileDesktop: vF,
  fromCameraFilesDesktop: gF,
  fromCameraMobileDesktop: RF,
  fromFilesMobileDesktop: DF,
  fromCameraDesktop: AF,
  fromFilesDesktop: TF,
  fromMobileDesktop: OF,
  fromCameraGalleryMobile: yF,
  fromGalleryMobile: NF,
  gallery: LF,
  files: MF,
  returnToComputer: PF,
  documentCaptured: bF,
  or: wF,
  continueInBrowser: HF
}, kF = "Przygotowywanie kamery...", FF = "Limit czasu", UF = "Brak ostrości", xF = "Coś poszło nie tak", BF = "Nie znaleziono kamery o podanym ID", $F = "Gotowe!", GF = "Aparat jest niedostępny!", ZF = "Twoja wersja przeglądarki nie jest obsługiwana", jF = "HTTPS nie jest wykorzystywany", zF = "Niebezpieczny kontekst", qF = "Licencja nie została znaleziona lub jest nieważna", WF = "Plik jest uszkodzony albo nie jest obsługiwany", YF = "Rozmiar ładowanego pliku jest zbyt duży", KF = "Dopasuj dokument do ramki", XF = "Trzymaj urządzenie prosto", QF = "Unikaj oślepiania dokumentu", JF = "Powtórz próbę", eU = "Brak aparatu", tU = "Umieść dokument pośrodku", rU = "Załaduj zdjęcie", nU = "Przysuń się bliżej", iU = "Trzymaj urządzenie nieruchomo", aU = "Kamera", oU = "Przekaż na urządzenie mobilne", sU = "Włącz aparat urządzenia mobilnego, zeskanuj kod QR i skorzystaj z linku", lU = "Czekaj…", cU = "Urządzenie mobilne", uU = "Weryfikacja dokumentu tożsamości", fU = "Zrób zdjęcie dokumentu przy pomocy kamery komputera, prześlij z plików lub zeskanuj urządzeniem mobilnym", dU = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo prześlij z plików", pU = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo zeskanuj urządzeniem mobilnym", hU = "Prześlij dokument z plików albo zeskanuj urządzeniem mobilnym", _U = "Użyj kamery komputera, aby zrobić zdjęcie dokumentu", mU = "Wybierz dokument z plików i prześlij go", EU = "Użyj aparatu urządzenia mobilnego, aby zrobić zdjęcie dokumentu", CU = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo prześlij z galerii", SU = "Wybierz dokument z galerii i prześlj go", IU = "Galeria", vU = "Pliki", gU = "Wróć do komputera", RU = "Dokument został uchwycony", DU = "albo", AU = "Naciśnij tutaj, żeby kontynuować w przeglądare", TU = {
  preparingCamera: kF,
  timeout: FF,
  noFocus: UF,
  somethingWentWrong: xF,
  incorrectCameraId: BF,
  done: $F,
  cameraUnavailable: GF,
  versionNotSupported: ZF,
  httpNotSupported: jF,
  insecurePageContext: zF,
  badLicense: qF,
  fileCorrupt: WF,
  largeFile: YF,
  placeDocumentIntoFrame: KF,
  holdDocumentStraight: XF,
  glaresOnDocument: QF,
  tryAgain: JF,
  noCameraAvailable: eU,
  positionDocumentCenter: tU,
  uploadPhoto: rU,
  moveCloser: nU,
  keepDeviceStill: iU,
  camera: aU,
  switchToMobile: oU,
  openPhoneCamera: sU,
  pleaseWait: lU,
  mobileDevice: cU,
  verifyYourIdentity: uU,
  fromCameraFilesMobileDesktop: fU,
  fromCameraFilesDesktop: dU,
  fromCameraMobileDesktop: pU,
  fromFilesMobileDesktop: hU,
  fromCameraDesktop: _U,
  fromFilesDesktop: mU,
  fromMobileDesktop: EU,
  fromCameraGalleryMobile: CU,
  fromGalleryMobile: SU,
  gallery: IU,
  files: vU,
  returnToComputer: gU,
  documentCaptured: RU,
  or: DU,
  continueInBrowser: AU
}, OU = "Preparazione della fotocamera in corso...", yU = "Timeout", NU = "Nessuna messa a fuoco della fotocamera", LU = "Qualcosa è andato storto", MU = "Nessuna telecamera trovata con l'ID specificato", PU = "Fatto!", bU = "Fotocamera non disponibile!", wU = "La versione del tuo browser non è supportata", HU = "HTTPS non utilizzato", VU = "Contesto incerto", kU = "La licenza non è stata trovata o è scaduta", FU = "Questo file è danneggiato o non supportato", UU = "Questo file è troppo grande per essere caricato", xU = "Adatta il documento alla cornice", BU = "Tieni il documento dritto", $U = "Evita il riflesso sul documento", GU = "Prova di nuovo", ZU = "Non c'è la fotocamera", jU = "Posiziona il documento al centro", zU = "Carica una foto", qU = "Avvicinati", WU = "Tieni fermo il dispositivo", YU = "Fotocamera", KU = "Passa al cellulare", XU = "Apri la fotocamera del tuo dispositivo mobile, scansiona il codice QR e segui il collegamento", QU = "Attendere prego…", JU = "Dispositivo mobile", ex = "Verifica del documento di identità", tx = "Acquisisci un documento utilizzando la fotocamera del computer, caricalo da file o scansionalo su un dispositivo mobile", rx = "Acquisisci un documento utilizzando la fotocamera del computer o caricalo dai file", nx = "Acquisisci un documento utilizzando la fotocamera del computer o scansionalo su un dispositivo mobile", ix = "Carica un documento da file o scansionalo su un dispositivo mobile", ax = "Utilizza la fotocamera del computer per acquisire un documento", ox = "Scegli un documento dai file e caricalo", sx = "Utilizza la fotocamera del tuo cellulare per acquisire un documento", lx = "Acquisisci un documento utilizzando la fotocamera del dispositivo mobile o caricalo dalla galleria", cx = "Scegli un documento dalla galleria e caricalo", ux = "Galleria", fx = "File", dx = "Ritorna al computer", px = "Il tuo documento è stato acquisito", hx = "o", _x = "Clicca qui per continuare nel browser", mx = {
  preparingCamera: OU,
  timeout: yU,
  noFocus: NU,
  somethingWentWrong: LU,
  incorrectCameraId: MU,
  done: PU,
  cameraUnavailable: bU,
  versionNotSupported: wU,
  httpNotSupported: HU,
  insecurePageContext: VU,
  badLicense: kU,
  fileCorrupt: FU,
  largeFile: UU,
  placeDocumentIntoFrame: xU,
  holdDocumentStraight: BU,
  glaresOnDocument: $U,
  tryAgain: GU,
  noCameraAvailable: ZU,
  positionDocumentCenter: jU,
  uploadPhoto: zU,
  moveCloser: qU,
  keepDeviceStill: WU,
  camera: YU,
  switchToMobile: KU,
  openPhoneCamera: XU,
  pleaseWait: QU,
  mobileDevice: JU,
  verifyYourIdentity: ex,
  fromCameraFilesMobileDesktop: tx,
  fromCameraFilesDesktop: rx,
  fromCameraMobileDesktop: nx,
  fromFilesMobileDesktop: ix,
  fromCameraDesktop: ax,
  fromFilesDesktop: ox,
  fromMobileDesktop: sx,
  fromCameraGalleryMobile: lx,
  fromGalleryMobile: cx,
  gallery: ux,
  files: fx,
  returnToComputer: dx,
  documentCaptured: px,
  or: hx,
  continueInBrowser: _x
}, Ex = "A kamera előkészítése...", Cx = "Időkorlát", Sx = "Nem fókuszál a kamera", Ix = "Valami félresikerült", vx = "Nem található ilyen azonosítójú kamera", gx = "Kész!", Rx = "Nem érhető el kamera!", Dx = "Nem támogatott a böngésző verziója", Ax = "HTTPS nincs használatban", Tx = "Bizonytalan kontextus", Ox = "Nem található vagy lejárt az engedély", yx = "Ez a fájl sérült vagy nem támogatott", Nx = "A feltöltendő fájl túl nagy", Lx = "Igazítsa a dokumentumot a keretbe", Mx = "A készüléket tartsa mozdulatlanul", Px = "Kerülje a fény megcsillanását a dokumentumon", bx = "Próbálja újra", wx = "Nincs kamera", Hx = "Helyezze az okiratot középre", Vx = "Fénykép feltöltése", kx = "Vigye közelebb", Fx = "A készüléket tartsa mozdulatlanul", Ux = "Kamera", xx = "Váltás mobilra", Bx = "Nyissa meg a kamerát mobilkészülékén, olvassa be a QR-kódot, és kövesse a hivatkozást", $x = "Please wait...", Gx = "Mobilkészülék", Zx = "Személyazonosító okirat ellenőrzése", jx = "Fotózzon le egy okiratot a számítógépe kamerájával, töltse fel a fájlok közül, vagy olvassa be egy mobilkészülékkel", zx = "Fotózzon le egy okiratot a számítógépe kamerájával, vagy töltse fel a fájlok közül", qx = "Fotózzon le egy okiratot a számítógépe kamerájával, vagy olvassa be egy mobilkészülékkel", Wx = "Töltsön fel egy okiratot a fájlok közül, vagy olvassa be egy mobilkészülékkel", Yx = "Használja a számítógép kameráját egy okirat beolvasására", Kx = "Válasszon egy okiratot a fájlok közül, és töltse fel", Xx = "Használja a mobilja kameráját egy okirat beolvasására", Qx = "Fotózzon le egy okiratot a mobilja kamerájával, vagy töltse fel a galériából", Jx = "Válasszon egy okiratot a galériából, és töltse fel", eB = "Galéria", tB = "Fájlok", rB = "Vissza a számítógépre", nB = "Lefényképeztük az okiratát", iB = "vagy", aB = "Kattinson ide a böngészőben történő folytatáshoz", oB = {
  preparingCamera: Ex,
  timeout: Cx,
  noFocus: Sx,
  somethingWentWrong: Ix,
  incorrectCameraId: vx,
  done: gx,
  cameraUnavailable: Rx,
  versionNotSupported: Dx,
  httpNotSupported: Ax,
  insecurePageContext: Tx,
  badLicense: Ox,
  fileCorrupt: yx,
  largeFile: Nx,
  placeDocumentIntoFrame: Lx,
  holdDocumentStraight: Mx,
  glaresOnDocument: Px,
  tryAgain: bx,
  noCameraAvailable: wx,
  positionDocumentCenter: Hx,
  uploadPhoto: Vx,
  moveCloser: kx,
  keepDeviceStill: Fx,
  camera: Ux,
  switchToMobile: xx,
  openPhoneCamera: Bx,
  pleaseWait: $x,
  mobileDevice: Gx,
  verifyYourIdentity: Zx,
  fromCameraFilesMobileDesktop: jx,
  fromCameraFilesDesktop: zx,
  fromCameraMobileDesktop: qx,
  fromFilesMobileDesktop: Wx,
  fromCameraDesktop: Yx,
  fromFilesDesktop: Kx,
  fromMobileDesktop: Xx,
  fromCameraGalleryMobile: Qx,
  fromGalleryMobile: Jx,
  gallery: eB,
  files: tB,
  returnToComputer: rB,
  documentCaptured: nB,
  or: iB,
  continueInBrowser: aB
}, sB = "正在准备相机", lB = "超时", cB = "没有摄像头对焦", uB = "出了问题", fB = "未找到具有指定 ID 的像机", dB = "完成！", pB = "相机不可用！", hB = "不支持您的浏览器版本", _B = "未使用 HTTPS", mB = "不安全的环境", EB = "无法找到许可证或已过期", CB = "该文件已损坏或不被支持", SB = "该文件太大，无法上传", IB = "对准证件使其在框中", vB = "保持证件直接", gB = "避免证件的反射过强的光", RB = "再试一次", DB = "没有相机", AB = "将证件置于中心", TB = "上传一张照片", OB = "靠近点", yB = "保持设备固定，不要移动", NB = "相机", LB = "切换到移动设备", MB = "打开移动设备上的相机，扫描二维码，并点击链接", PB = "请等待...", bB = "移动设备", wB = "身份证明文件验证", HB = "使用电脑的摄像头拍摄证件，上传它或使用移动设备扫描文件", VB = "使用电脑的摄像头拍摄证件或者把文件上传", kB = "使用电脑的摄像头拍摄证件的照片或使用移动设备扫描它", FB = "从文件中上传证件或使用移动设备扫描证件", UB = "使用电脑的摄像头拍摄证件", xB = "从文件中选择一个证件并上传", BB = "使用手机摄像头拍摄证件", $B = "使用手机相机拍摄证件或从图库上传", GB = "从图库中选择一个证件并上传", ZB = "图库", jB = "文件", zB = "返回电脑", qB = "您的文件已被捕获", WB = "或者", YB = "点击此处继续在浏览器中操作", KB = {
  preparingCamera: sB,
  timeout: lB,
  noFocus: cB,
  somethingWentWrong: uB,
  incorrectCameraId: fB,
  done: dB,
  cameraUnavailable: pB,
  versionNotSupported: hB,
  httpNotSupported: _B,
  insecurePageContext: mB,
  badLicense: EB,
  fileCorrupt: CB,
  largeFile: SB,
  placeDocumentIntoFrame: IB,
  holdDocumentStraight: vB,
  glaresOnDocument: gB,
  tryAgain: RB,
  noCameraAvailable: DB,
  positionDocumentCenter: AB,
  uploadPhoto: TB,
  moveCloser: OB,
  keepDeviceStill: yB,
  camera: NB,
  switchToMobile: LB,
  openPhoneCamera: MB,
  pleaseWait: PB,
  mobileDevice: bB,
  verifyYourIdentity: wB,
  fromCameraFilesMobileDesktop: HB,
  fromCameraFilesDesktop: VB,
  fromCameraMobileDesktop: kB,
  fromFilesMobileDesktop: FB,
  fromCameraDesktop: UB,
  fromFilesDesktop: xB,
  fromMobileDesktop: BB,
  fromCameraGalleryMobile: $B,
  fromGalleryMobile: GB,
  gallery: ZB,
  files: jB,
  returnToComputer: zB,
  documentCaptured: qB,
  or: WB,
  continueInBrowser: YB
}, XB = "Príprava fotoaparátu...", QB = "Čas vypršal", JB = "Žiadne zaostrenie fotoaparátu", e$ = "Niečo sa pokazilo", t$ = "Nenašiel sa žiadny fotoaparát s určeným ID", r$ = "Hotovo!", n$ = "Fotoaparát je nedostupný!", i$ = "Verzia vášho prehliadača nie je podporovaná", a$ = "HTPPS nepoužité", o$ = "Neistý kontext", s$ = "Licenciu nie je možné nájsť, prípadne už nie je platná", l$ = "Súbor je poškodený, prípadne nie je podporovaný", c$ = "Súbor je príliš veľký na odovzdávanie", u$ = "Vložte dokument do rámu", f$ = "Držte dokument rovno", d$ = "Vyhnite sa odleskom na dokumente", p$ = "Skúste to znova", h$ = "Žiadny fotoaparát", _$ = "Umiestnite dokument do stredu", m$ = "Odovzdať fotografiu", E$ = "Posuňte bližšie", C$ = "Držte zariadenie nehybne", S$ = "Fotoaparát", I$ = "Prepnúť na mobil", v$ = "Otvorte na svojom mobilnom zariadení fotoaparát, neskenujte QR kód a otvorte odkaz", g$ = "Please wait...", R$ = "Mobilné zariadenie", D$ = "Overenie dokladu totožnosti", A$ = "Nasnímajte dokument pomocou kamery počítača, nahrajte ho zo súborov alebo naskenujte na mobilnom zariadení", T$ = "Nasnímajte dokument pomocou kamery počítača, prípadne ho nahrajte zo súborov", O$ = "Nasnímajte dokument pomocou kamery počítača, prípadne ho naskenujte na mobilnom zariadení", y$ = "Nahrajte dokument zo súborov, prípadne ho naskenujte na mobilnom zariadení", N$ = "Pomocou kamery počítača nasnímajte dokument", L$ = "Vyberte dokument spomedzi súborov a nahrajte ho", M$ = "Pomocou fotoaparátu mobilu nasnímajte dokument", P$ = "Nasnímajte dokument pomocou fotoaparátu mobilu, prípadne ho nahrajte z galérie", b$ = "Vyberte dokument v galérii a nahrajte ho", w$ = "Galéria", H$ = "Súbory", V$ = "Návrat na počítač", k$ = "Váš dokument bol nasnímaný", F$ = "alebo", U$ = "Kliknutím sem pokračujte v prehliadači", x$ = {
  preparingCamera: XB,
  timeout: QB,
  noFocus: JB,
  somethingWentWrong: e$,
  incorrectCameraId: t$,
  done: r$,
  cameraUnavailable: n$,
  versionNotSupported: i$,
  httpNotSupported: a$,
  insecurePageContext: o$,
  badLicense: s$,
  fileCorrupt: l$,
  largeFile: c$,
  placeDocumentIntoFrame: u$,
  holdDocumentStraight: f$,
  glaresOnDocument: d$,
  tryAgain: p$,
  noCameraAvailable: h$,
  positionDocumentCenter: _$,
  uploadPhoto: m$,
  moveCloser: E$,
  keepDeviceStill: C$,
  camera: S$,
  switchToMobile: I$,
  openPhoneCamera: v$,
  pleaseWait: g$,
  mobileDevice: R$,
  verifyYourIdentity: D$,
  fromCameraFilesMobileDesktop: A$,
  fromCameraFilesDesktop: T$,
  fromCameraMobileDesktop: O$,
  fromFilesMobileDesktop: y$,
  fromCameraDesktop: N$,
  fromFilesDesktop: L$,
  fromMobileDesktop: M$,
  fromCameraGalleryMobile: P$,
  fromGalleryMobile: b$,
  gallery: w$,
  files: H$,
  returnToComputer: V$,
  documentCaptured: k$,
  or: F$,
  continueInBrowser: U$
}, B$ = "Підготовка камери...", $$ = "Тайм-аут", G$ = "Немає фокусування камери", Z$ = "Щось пішло не так", j$ = "Камеру з заданим ID не знайдено", z$ = "Готово!", q$ = "Камера недоступна!", W$ = "Версія вашого браузера не підтримується", Y$ = "HTTPS не використовується", K$ = "Небезпечний контекст", X$ = "Ліцензію не знайдено або вона не є дійсною", Q$ = "Файл пошкоджено або він не підтримується", J$ = "Розмір файлу, що завантажується, занадто великий", eG = "Помістіть документ в рамку", tG = "Тримайте документ прямо", rG = "Уникайте відблисків на документі", nG = "Спробуйте ще раз", iG = "Камера відсутня", aG = "Розташуйте документ у центрі", oG = "Завантажте фото", sG = "Підсуньтеся ближче", lG = "Тримайте пристрій нерухомо", cG = "Камера", uG = "Перейдіть до мобільного пристрою", fG = "Відкрийте камеру мобільного пристрою, відскануйте QR-код і перейдіть за посиланням", dG = "Будь-ласка зачекайте…", pG = "Мобільний пристрій", hG = "Перевірка документа, що засвідчує особу", _G = "Зробіть знімок документа камерою комп'ютера, завантажте з файлів або відскануйте з мобільного пристрою", mG = "Зробіть знімок документа камерою комп'ютера або завантажте з файлів", EG = "Зробіть знімок документа камерою комп'ютера або відскануйте з мобільного пристрою", CG = "Завантажте документ з файлів або відскануйте його з мобільного пристрою", SG = "Скористайтеся камерою комп'ютера, щоб зробити знімок документа", IG = "Оберіть документ з файлів і завантажте його", vG = "Скористайтеся камерою мобільного пристрою, щоб зробити знімок документа", gG = "Зробіть знімок документа камерою мобільного пристрою або завантажте з галереї", RG = "Оберіть документ з галереї та завантажте його", DG = "Галерея", AG = "Файли", TG = "Поверніться до комп'ютера", OG = "Ваш документ захоплено", yG = "або", NG = "Натисніть сюди, щоб продовжити в браузері", LG = {
  preparingCamera: B$,
  timeout: $$,
  noFocus: G$,
  somethingWentWrong: Z$,
  incorrectCameraId: j$,
  done: z$,
  cameraUnavailable: q$,
  versionNotSupported: W$,
  httpNotSupported: Y$,
  insecurePageContext: K$,
  badLicense: X$,
  fileCorrupt: Q$,
  largeFile: J$,
  placeDocumentIntoFrame: eG,
  holdDocumentStraight: tG,
  glaresOnDocument: rG,
  tryAgain: nG,
  noCameraAvailable: iG,
  positionDocumentCenter: aG,
  uploadPhoto: oG,
  moveCloser: sG,
  keepDeviceStill: lG,
  camera: cG,
  switchToMobile: uG,
  openPhoneCamera: fG,
  pleaseWait: dG,
  mobileDevice: pG,
  verifyYourIdentity: hG,
  fromCameraFilesMobileDesktop: _G,
  fromCameraFilesDesktop: mG,
  fromCameraMobileDesktop: EG,
  fromFilesMobileDesktop: CG,
  fromCameraDesktop: SG,
  fromFilesDesktop: IG,
  fromMobileDesktop: vG,
  fromCameraGalleryMobile: gG,
  fromGalleryMobile: RG,
  gallery: DG,
  files: AG,
  returnToComputer: TG,
  documentCaptured: OG,
  or: yG,
  continueInBrowser: NG
}, MG = "Caméra en préparation...", PG = "Délai d'expiration", bG = "Caméra non focalisée", wG = "Anomalie", HG = "Aucune caméra ayant l'ID spécifié", VG = "Terminé!", kG = "Caméra indisponible!", FG = "Version de navigateur non compatible", UG = "HTTPS non utilis", xG = "Contexte non sûr", BG = "License introuvable ou expirée", $G = "Fichier corrompu ou non supporté", GG = "Fichier trop volumineux pour être transféré", ZG = "Ajuster le document dans le cadre", jG = "Garder le document droit", zG = "Eviter les reflets sur le document", qG = "Réessayer", WG = "Caméra introuvable", YG = "Positionner le document au centre", KG = "Envoyez une photo", XG = "Rapprochez", QG = "Maintenir l'appareil immobile", JG = "Caméra", eZ = "Basculer vers le mobile", tZ = "Ouvrez la caméra de votre appareil mobile, scannez le QR-code, et suivez les instructions", rZ = "Veuillez patienter...", nZ = "Appareil mobile", iZ = "Vérification du document d'identité", aZ = "Capturez un document avec la caméra de l'ordinateur, ouvrez-en un à partir d'un fichier, ou scannez-le avec un mobile", oZ = "Capturez un document avec la caméra de l'ordinateur, ou ouvrez-en un à partir d'un fichier", sZ = "Capturez un document avec la caméra de l'ordinateur, ou scannez-le avec un mobile", lZ = "Ouvrez un document à partir d'un fichier, ou scannez-le avec un mobile", cZ = "Utilisez la caméra de l'ordinateur pour capturer un document", uZ = "Ouvrez un document à partir d'un fichier", fZ = "Utilisez la caméra de votre mobile pour capturer un document", dZ = "Capturez un document avec la caméra de votre mobile, ou chargez-le à partir de la galerie", pZ = "Chargez un document à partir de la galerie", hZ = "Galerie", _Z = "Fichiers", mZ = "Retourner à l'ordinateur", EZ = "Votre document a été capturé", CZ = "ou", SZ = "Cliquer ici pour continuer dans le navigateur", IZ = {
  preparingCamera: MG,
  timeout: PG,
  noFocus: bG,
  somethingWentWrong: wG,
  incorrectCameraId: HG,
  done: VG,
  cameraUnavailable: kG,
  versionNotSupported: FG,
  httpNotSupported: UG,
  insecurePageContext: xG,
  badLicense: BG,
  fileCorrupt: $G,
  largeFile: GG,
  placeDocumentIntoFrame: ZG,
  holdDocumentStraight: jG,
  glaresOnDocument: zG,
  tryAgain: qG,
  noCameraAvailable: WG,
  positionDocumentCenter: YG,
  uploadPhoto: KG,
  moveCloser: XG,
  keepDeviceStill: QG,
  camera: JG,
  switchToMobile: eZ,
  openPhoneCamera: tZ,
  pleaseWait: rZ,
  mobileDevice: nZ,
  verifyYourIdentity: iZ,
  fromCameraFilesMobileDesktop: aZ,
  fromCameraFilesDesktop: oZ,
  fromCameraMobileDesktop: sZ,
  fromFilesMobileDesktop: lZ,
  fromCameraDesktop: cZ,
  fromFilesDesktop: uZ,
  fromMobileDesktop: fZ,
  fromCameraGalleryMobile: dZ,
  fromGalleryMobile: pZ,
  gallery: hZ,
  files: _Z,
  returnToComputer: mZ,
  documentCaptured: EZ,
  or: CZ,
  continueInBrowser: SZ
}, vZ = "Preparando la cámara...", gZ = "Tiempo de espera", RZ = "No hay enfoque de la cámara", DZ = "Algo salió mal", AZ = "La cámara con el identificador especificado no encontrada", TZ = "¡Hecho!", OZ = "¡Cámara no disponible!", yZ = "La versión de su navegador no es compatible", NZ = "HTTPS no utilizado", LZ = "Contexto inseguro", MZ = "La licencia no se encuentra o ha expirado", PZ = "Este archivo está dañado o no es compatible", bZ = "Este archivo es demasiado grande para cargarlo", wZ = "Encaje el documento en el marco", HZ = "Sostenga el documento recto", VZ = "Evite el brillo en el documento", kZ = "Inténtelo de nuevo", FZ = "No hay cámara disponible", UZ = "Coloque el documento en el centro", xZ = "Suba una foto", BZ = "Acérquese", $Z = "Sostenga el dispositivo quieto", GZ = "Cámara", ZZ = "Cámbiese al móvil", jZ = "Abra la cámara de su dispositivo móvil, escanee el código QR y siga el enlace", zZ = "Por favor espere...", qZ = "Dispositivo móvil", WZ = "Verificación de documentos de identidad", YZ = "Capture un documento utilizando la cámara del PC, escanéelo con un dispositivo móvil o cargue la imagen previamente capturada", KZ = "Capture un documento con la cámara del PC o cargue la imagen previamente capturada", XZ = "Capture un documento con la cámara del PC o escanéelo con un dispositivo móvil", QZ = "Cargue una imagen de documento previamente capturada o escanee el documento con un dispositivo móvil", JZ = "Utilice la cámara del PC para capturar un documento", ej = "Elige un documento de los archivos y cárgalo", tj = "Utilice la cámara de su móvil para capturar un documento", rj = "Capture un documento con la cámara de su móvil o súbalo desde la galería", nj = "Elija un documento de la galería y cárguelo", ij = "Galería", aj = "Archivos", oj = "Regrese al PC", sj = "Su documento ha sido capturado", lj = "o", cj = "Haga clic aquí para continuar en el navegador", uj = {
  preparingCamera: vZ,
  timeout: gZ,
  noFocus: RZ,
  somethingWentWrong: DZ,
  incorrectCameraId: AZ,
  done: TZ,
  cameraUnavailable: OZ,
  versionNotSupported: yZ,
  httpNotSupported: NZ,
  insecurePageContext: LZ,
  badLicense: MZ,
  fileCorrupt: PZ,
  largeFile: bZ,
  placeDocumentIntoFrame: wZ,
  holdDocumentStraight: HZ,
  glaresOnDocument: VZ,
  tryAgain: kZ,
  noCameraAvailable: FZ,
  positionDocumentCenter: UZ,
  uploadPhoto: xZ,
  moveCloser: BZ,
  keepDeviceStill: $Z,
  camera: GZ,
  switchToMobile: ZZ,
  openPhoneCamera: jZ,
  pleaseWait: zZ,
  mobileDevice: qZ,
  verifyYourIdentity: WZ,
  fromCameraFilesMobileDesktop: YZ,
  fromCameraFilesDesktop: KZ,
  fromCameraMobileDesktop: XZ,
  fromFilesMobileDesktop: QZ,
  fromCameraDesktop: JZ,
  fromFilesDesktop: ej,
  fromMobileDesktop: tj,
  fromCameraGalleryMobile: rj,
  fromGalleryMobile: nj,
  gallery: ij,
  files: aj,
  returnToComputer: oj,
  documentCaptured: sj,
  or: lj,
  continueInBrowser: cj
}, fj = "Preparando a câmara...", dj = "Tempo esgotado", pj = "Sem foco da câmara", hj = "Algo correu mal", _j = "Não foi encontrada nenhuma câmara com o ID especificado", mj = "Feito!", Ej = "Câmara indisponível!", Cj = "A versão do seu navegador não é compatível", Sj = "HTTPS não utilizado", Ij = "Contexto inseguro", vj = "A licença não pode ser encontrada ou expirou", gj = "Este arquivo está corrompido ou não é compatível", Rj = "Este arquivo é muito grande para ser carregado", Dj = "Encaixe o documento no quadro", Aj = "Mantenha o dispositio reto", Tj = "Evite luz sobre o documento", Oj = "Tente outra vez", yj = "Não há câmara", Nj = "Posicione o documento no centro", Lj = "Carregue uma foto", Mj = "Aproxime-se", Pj = "Mantenha o dispositivo imóvel", bj = "Câmera", wj = "Mudar para o telemóvel", Hj = "Abra a câmara do seu dispositivo móvel, leia o código QR e siga a ligação", Vj = "Aguarde...", kj = "Dispositivo móvel", Fj = "Verificação de documento de identidade", Uj = "Capture um documento utilizando a câmara do computador, carregue-o a partir de ficheiros ou digitalize-o num dispositivo móvel", xj = "Capture um documento utilizando a câmara do computador ou carregue-o a partir de ficheiros", Bj = "Capture um documento utilizando a câmara do computador ou digitalizá-lo com um dispositivo móvel", $j = "Carregue um documento a partir de ficheiros ou digitalize-o num dispositivo móvel", Gj = "Utilize a câmara do computador para capturar um documento", Zj = "Escolha um documento dos ficheiros e carregue-o", jj = "Utilize a câmara do telemóvel para capturar um documento", zj = "Capture um documento utilizando a câmara do telemóvel ou carregue-o a partir da galeria", qj = "Escolha um documento da galeria e carregue-o", Wj = "Galeria", Yj = "Ficheiros", Kj = "Regressar ao computador", Xj = "O seu documento foi capturado", Qj = "ou", Jj = "Clique aqui para continuar no navegador", ez = {
  preparingCamera: fj,
  timeout: dj,
  noFocus: pj,
  somethingWentWrong: hj,
  incorrectCameraId: _j,
  done: mj,
  cameraUnavailable: Ej,
  versionNotSupported: Cj,
  httpNotSupported: Sj,
  insecurePageContext: Ij,
  badLicense: vj,
  fileCorrupt: gj,
  largeFile: Rj,
  placeDocumentIntoFrame: Dj,
  holdDocumentStraight: Aj,
  glaresOnDocument: Tj,
  tryAgain: Oj,
  noCameraAvailable: yj,
  positionDocumentCenter: Nj,
  uploadPhoto: Lj,
  moveCloser: Mj,
  keepDeviceStill: Pj,
  camera: bj,
  switchToMobile: wj,
  openPhoneCamera: Hj,
  pleaseWait: Vj,
  mobileDevice: kj,
  verifyYourIdentity: Fj,
  fromCameraFilesMobileDesktop: Uj,
  fromCameraFilesDesktop: xj,
  fromCameraMobileDesktop: Bj,
  fromFilesMobileDesktop: $j,
  fromCameraDesktop: Gj,
  fromFilesDesktop: Zj,
  fromMobileDesktop: jj,
  fromCameraGalleryMobile: zj,
  fromGalleryMobile: qj,
  gallery: Wj,
  files: Yj,
  returnToComputer: Kj,
  documentCaptured: Xj,
  or: Qj,
  continueInBrowser: Jj
}, tz = "تحضير الكاميرا...", rz = "انتهاء المهلة", nz = "لا يوجد تركيز الكاميرا", iz = "شيء سار على نحو خاطئ", az = "لا يتم العثور على الكاميرا ذات المعرّف المحدد", oz = "تم!", sz = "الكاميرا غير متاحة!", lz = "إصدار المتصفح الخاص بك غير مدعوم", cz = "HTTPS غير مستخدم", uz = "سياق غير آمن", fz = "لا يتم العثور على الترخيص أو انتهت صلاحيته", dz = "هذا الملف تالف أو غير مدعوم", pz = "هذا الملف كبير جدًا بحيث لا يمكن تحميله", hz = "تأطير الوثيقة", _z = "أمسك الوثيقة بشكل مستقيم", mz = "تجنب الضوء على الوثيقة", Ez = "حاول مرة أخرى", Cz = "الكاميرا غير موجودة", Sz = "ضع المستند في الوسط", Iz = "حمّل الصورة", vz = "إقترب أكثر", gz = "أمسك الجهاز بشكل ثابت", Rz = "كاميرا", Dz = "تبديل إلى المحمول", Az = "افتح كاميرا جهازك المحمول، وامسح رمز QR، ثم اتبع الرابط", Tz = "يرجى الانتظار...", Oz = "الجهاز المحمول", yz = "التحقق من وثيقة الهوية", Nz = "التقط صورة للمستند باستخدام كاميرا الحاسوب، أو قم بتحميله من الملفات، أو قم بمسحه ضوئيًا باستخدام جهاز محمول", Lz = "التقط صورة للمستند باستخدام كاميرا الحاسوب أو قم بتحميله من الملفات", Mz = "التقط صورة للمستند باستخدام كاميرا الحاسوب أو قم بمسحه ضوئيًا باستخدام جهاز محمول", Pz = "حمّل صورة للمستند من الملفات أو قم بمسحه ضوئيًا باستخدام جهاز محمول", bz = "استخدم كاميرا الحاسوب لالتقاط صورة للمستند", wz = "اختر مستندًا من الملفات وقم بتحميله", Hz = "استخدم كاميرا جهازك المحمول لالتقاط صورة للمستند", Vz = "التقط صورة للمستند باستخدام كاميرا الجهاز المحمول أو قم بتحميله من معرض الصور", kz = "اختر مستندًا من معرض الصور وقم بتحميله", Fz = "معرض الصور", Uz = "الملفات", xz = "عودة إلى الحاسوب", Bz = "تم مسح مستندك بنجاح", $z = "أو", Gz = "اضغط هنا للمتابعة عبر المتصفح", Zz = {
  preparingCamera: tz,
  timeout: rz,
  noFocus: nz,
  somethingWentWrong: iz,
  incorrectCameraId: az,
  done: oz,
  cameraUnavailable: sz,
  versionNotSupported: lz,
  httpNotSupported: cz,
  insecurePageContext: uz,
  badLicense: fz,
  fileCorrupt: dz,
  largeFile: pz,
  placeDocumentIntoFrame: hz,
  holdDocumentStraight: _z,
  glaresOnDocument: mz,
  tryAgain: Ez,
  noCameraAvailable: Cz,
  positionDocumentCenter: Sz,
  uploadPhoto: Iz,
  moveCloser: vz,
  keepDeviceStill: gz,
  camera: Rz,
  switchToMobile: Dz,
  openPhoneCamera: Az,
  pleaseWait: Tz,
  mobileDevice: Oz,
  verifyYourIdentity: yz,
  fromCameraFilesMobileDesktop: Nz,
  fromCameraFilesDesktop: Lz,
  fromCameraMobileDesktop: Mz,
  fromFilesMobileDesktop: Pz,
  fromCameraDesktop: bz,
  fromFilesDesktop: wz,
  fromMobileDesktop: Hz,
  fromCameraGalleryMobile: Vz,
  fromGalleryMobile: kz,
  gallery: Fz,
  files: Uz,
  returnToComputer: xz,
  documentCaptured: Bz,
  or: $z,
  continueInBrowser: Gz
}, jz = "De camera aan het voorbereiden...", zz = "Time-out", qz = "Geen camera-focus", Wz = "Er ging iets fout", Yz = "Geen camera met de opgegeven ID gevonden", Kz = "Uitgevoerd!", Xz = "Camera onbeschikbaar!", Qz = "Uw browserversie wordt niet ondersteund", Jz = "HTTPS niet gebruikt", eq = "Onzekere context", tq = "De licentie kan niet gevonden worden of is verlopen", rq = "Dit bestand is corrupt of wordt niet ondersteund", nq = "Dit bestand is te groot om geüpload te worden", iq = "Pas het document in het kader", aq = "Houd het document recht", oq = "Vermijd glans op het document", sq = "Probeer opnieuw", lq = "Er is geen camera", cq = "Plaats het document in het midden", uq = "Upload een foto", fq = "Kom dichter", dq = "Houd het toestel stil", pq = "Camera", hq = "Schakel over naar mobiel", _q = "Open de camera op uw mobiele apparaat, scan de QR-code en volg de link", mq = "Please wait...", Eq = "Mobiel apparaat", Cq = "Verificatie van identiteitsdocumenten", Sq = "Leg een document vast met de camera van de computer, upload het vanuit bestanden of scan het op een mobiel apparaat", Iq = "Leg een document vast met de camera van de computer of upload het vanuit bestanden", vq = "Leg een document vast met de camera van de computer of scan het op een mobiel apparaat", gq = "Upload een document of scan het op een mobiel apparaat", Rq = "Gebruik de camera van de computer om een document vast te leggen", Dq = "Kies een document uit bestanden en upload het", Aq = "Gebruik een mobiele camera om een document vast te leggen", Tq = "Leg een document vast met de mobiele camera of upload het vanuit de galerij", Oq = "Kies een document uit de galerij en upload het", yq = "Galerij", Nq = "Bestanden", Lq = "Ga terug naar de computer", Mq = "Uw document is vastgelegd", Pq = "of", bq = "Klik hier om verder te gaan in de browser.", wq = {
  preparingCamera: jz,
  timeout: zz,
  noFocus: qz,
  somethingWentWrong: Wz,
  incorrectCameraId: Yz,
  done: Kz,
  cameraUnavailable: Xz,
  versionNotSupported: Qz,
  httpNotSupported: Jz,
  insecurePageContext: eq,
  badLicense: tq,
  fileCorrupt: rq,
  largeFile: nq,
  placeDocumentIntoFrame: iq,
  holdDocumentStraight: aq,
  glaresOnDocument: oq,
  tryAgain: sq,
  noCameraAvailable: lq,
  positionDocumentCenter: cq,
  uploadPhoto: uq,
  moveCloser: fq,
  keepDeviceStill: dq,
  camera: pq,
  switchToMobile: hq,
  openPhoneCamera: _q,
  pleaseWait: mq,
  mobileDevice: Eq,
  verifyYourIdentity: Cq,
  fromCameraFilesMobileDesktop: Sq,
  fromCameraFilesDesktop: Iq,
  fromCameraMobileDesktop: vq,
  fromFilesMobileDesktop: gq,
  fromCameraDesktop: Rq,
  fromFilesDesktop: Dq,
  fromMobileDesktop: Aq,
  fromCameraGalleryMobile: Tq,
  fromGalleryMobile: Oq,
  gallery: yq,
  files: Nq,
  returnToComputer: Lq,
  documentCaptured: Mq,
  or: Pq,
  continueInBrowser: bq
}, Hq = "Menyiapkan kamera...", Vq = "Batas waktu", kq = "Tidak ada fokus kamera", Fq = "Terjadi kesalahan", Uq = "Tidak ditemukan kamera dengan ID yang disebutkan", xq = "Selesai!", Bq = "Kamera tidak tersedia!", $q = "Versi browser Anda tidak didukung", Gq = "HTTPS tidak digunakan", Zq = "Konteks tidak aman", jq = "Lisensi tidak dapat ditemukan atau telah habis masa berlakunya", zq = "File ini rusak atau tidak didukung", qq = "File ini terlalu besar untuk diunggah", Wq = "Sesuaikan dokumen dengan bingkainya", Yq = "Tahan dokumen tatap lurus", Kq = "Hindari pantulan cahaya pada dokumen", Xq = "Coba lagi", Qq = "Tidak ada kamera", Jq = "Posisikan dokumen di tengah", eW = "Unggah foto", tW = "Geser mendekat", rW = "Tahan perangkat tetap diam", nW = "Kamera", iW = "Beralih ke seluler", aW = "Buka kamera pada perangkat seluler Anda, pindai kode QR, dan ikuti tautannya", oW = "Please wait...", sW = "Perangkat seluler", lW = "Verifikasi dokumen identitas", cW = "Ambil gambar dokumen menggunakan kamera komputer, unggah dari file, atau pindai pada perangkat seluler Anda", uW = "Ambil gambar dokumen menggunakan kamera komputer atau unggah dari file", fW = "Ambil gambar dokumen menggunakan kamera komputer atau pindah pada perangkat seluler", dW = "Unggah dokumen dari file atau pindai pada perangkat seluler", pW = "Gunakan kamera komputer untuk mengambil gambar dokumen", hW = "Pilih dokumen dari file dan unggah", _W = "Gunakan kamera seluler Anda untuk menangkap gambar dokumen", mW = "Tangkap gambar dokumen menggunakan kamera seluler atau unggah dari galeri", EW = "Pilih dokumen dari galeri dan unggah", CW = "Galeri", SW = "File", IW = "Kembali ke komputer", vW = "Tangkapan layar dokumen telah diambil", gW = "atau", RW = "Klik di sini untuk melanjutkan di browser", DW = {
  preparingCamera: Hq,
  timeout: Vq,
  noFocus: kq,
  somethingWentWrong: Fq,
  incorrectCameraId: Uq,
  done: xq,
  cameraUnavailable: Bq,
  versionNotSupported: $q,
  httpNotSupported: Gq,
  insecurePageContext: Zq,
  badLicense: jq,
  fileCorrupt: zq,
  largeFile: qq,
  placeDocumentIntoFrame: Wq,
  holdDocumentStraight: Yq,
  glaresOnDocument: Kq,
  tryAgain: Xq,
  noCameraAvailable: Qq,
  positionDocumentCenter: Jq,
  uploadPhoto: eW,
  moveCloser: tW,
  keepDeviceStill: rW,
  camera: nW,
  switchToMobile: iW,
  openPhoneCamera: aW,
  pleaseWait: oW,
  mobileDevice: sW,
  verifyYourIdentity: lW,
  fromCameraFilesMobileDesktop: cW,
  fromCameraFilesDesktop: uW,
  fromCameraMobileDesktop: fW,
  fromFilesMobileDesktop: dW,
  fromCameraDesktop: pW,
  fromFilesDesktop: hW,
  fromMobileDesktop: _W,
  fromCameraGalleryMobile: mW,
  fromGalleryMobile: EW,
  gallery: CW,
  files: SW,
  returnToComputer: IW,
  documentCaptured: vW,
  or: gW,
  continueInBrowser: RW
}, AW = "Đang chuẩn bị camera...", TW = "Thời gian chờ", OW = "Không có tiêu điểm camera", yW = "Có lỗi xảy ra", NW = "Không tìm thấy camera nào có ID đã nêu", LW = "Xong rồi!", MW = "Camera không có sẵn!", PW = "Phiên bản trình duyệt của bạn không được hỗ trợ", bW = "HTTPS không được sử dụng", wW = "Ngữ cảnh không bảo mật", HW = "Không tìm thấy giấy phép hoặc giấy phép đã hết hạn", VW = "Tệp này bị hỏng hoặc không được hỗ trợ", kW = "Tệp này quá lớn để tải lên", FW = "Chỉnh giấy tờ nằm gọn trong khung", UW = "Giữ cho giấy tờ được thẳng", xW = "Tránh cho giấy tờ bị lóe sáng", BW = "Thử lại", $W = "Không có camera", GW = "Đưa giấy tờ vào chính giữa", ZW = "Tải ảnh lên", jW = "Di chuyển tới gần hơn", zW = "Giữ thiết bị ở nguyên vị trí", qW = "Camera", WW = "Chuyển qua di động", YW = "Bật camera trên thiết bị di động của bạn, quét mã QR và theo dõi liên kết", KW = "Please wait...", XW = "Thiết bị di động", QW = "Xác minh giấy tờ tuỳ thân", JW = "Chụp tài liệu bằng camera của máy tính, tải lên từ các tập tin hoặc quét trên một thiết bị di động", eY = "Chụp tài liệu bằng camera của máy tính hoặc tải lên từ các tập tin", tY = "Chụp tài liệu bằng camera của máy tính hoặc quét trên thiết bị di động", rY = "Tải lên tài liệu từ các tập tin hoặc quét trên một thiết bị di động", nY = "Sử dụng camera của máy tính để chụp một tài liệu", iY = "Chọn một tài liệu từ các tập tin và tải lên", aY = "Sử dụng camera của thiết bị di động của bạn để chụp một tài liệu", oY = "Chụp một tài liệu bằng camera của thiết bị di động hoặc tải lên từ thư viện", sY = "Chọn một tài liệu từ thư viện và tải lên", lY = "Thư viện", cY = "Tập tin", uY = "Quay trở lại máy tính", fY = "Tài liệu của bạn đã được chụp", dY = "hoặc", pY = "Nhấp vào đây để tiếp tục ở trình duyệt", hY = {
  preparingCamera: AW,
  timeout: TW,
  noFocus: OW,
  somethingWentWrong: yW,
  incorrectCameraId: NW,
  done: LW,
  cameraUnavailable: MW,
  versionNotSupported: PW,
  httpNotSupported: bW,
  insecurePageContext: wW,
  badLicense: HW,
  fileCorrupt: VW,
  largeFile: kW,
  placeDocumentIntoFrame: FW,
  holdDocumentStraight: UW,
  glaresOnDocument: xW,
  tryAgain: BW,
  noCameraAvailable: $W,
  positionDocumentCenter: GW,
  uploadPhoto: ZW,
  moveCloser: jW,
  keepDeviceStill: zW,
  camera: qW,
  switchToMobile: WW,
  openPhoneCamera: YW,
  pleaseWait: KW,
  mobileDevice: XW,
  verifyYourIdentity: QW,
  fromCameraFilesMobileDesktop: JW,
  fromCameraFilesDesktop: eY,
  fromCameraMobileDesktop: tY,
  fromFilesMobileDesktop: rY,
  fromCameraDesktop: nY,
  fromFilesDesktop: iY,
  fromMobileDesktop: aY,
  fromCameraGalleryMobile: oY,
  fromGalleryMobile: sY,
  gallery: lY,
  files: cY,
  returnToComputer: uY,
  documentCaptured: fY,
  or: dY,
  continueInBrowser: pY
}, _Y = "카메라 준비 중...", mY = "시간 제한", EY = "카메라 초점", CY = "오류가 발생했습니다", SY = "지정된 ID가 있는 카메라를 찾을 수 없음", IY = "완료!", vY = "카메라를 사용할 수 없습니다!", gY = "사용 중인 브라우저는 지원되지 않습니다", RY = "HTTPS가 사용되지 않음", DY = "보안이 취약한 맥락", AY = "라이선스를 찾을 수 없거나 만료되었습니다", TY = "이 파일은 손상되었거나 지원되지 않습니다", OY = "이 파일은 대용량이어서 업로드할 수 없습니다", yY = "문서를 프레임에 맞춤", NY = "문서를 똑바로 놓으십시오", LY = "문서에서 눈부심을 피하십시오", MY = "다시 시도", PY = "카메라가 없습니다", bY = "문서를 가운데에 위치시키십시오", wY = "사진 업로드", HY = "더 가까이 이동", VY = "장치를 꽉 잡으십시오", kY = "카메라", FY = "모바일로 전환", UY = "모바일 장치에서 카메라를 열고 QR 코드를 스캔한 후 링크를 따라가십시오", xY = "Please wait...", BY = "모바일 장치", $Y = "ID 문서 검증", GY = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 파일에서 업로드하거나 모바일 장치에서 스캔하십시오", ZY = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 파일에서 업로드하십시오", jY = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 모바일 장치에서 스캔하십시오", zY = "파일에서 문서를 업로드하거나 모바일 장치에서 스캔하십시오", qY = "컴퓨터의 카메라를 사용하여 문서를 캡처하십시오", WY = "파일에서 문서를 선택하여 업로드하십시오", YY = "모바일 카메라를 사용하여 문서를 캡처하십시오", KY = "모바일의 카메라를 사용하여 문서를 캡처하거나 갤러리에서 업로드하십시오", XY = "갤러리에서 문서를 선택하여 업로드하십시오", QY = "갤러리", JY = "파일", eK = "컴퓨터로 돌아가기", tK = "서류가 캡처되었습니다", rK = "또는", nK = "브라우저에서 계속하려면 여기를 클릭하세요", iK = {
  preparingCamera: _Y,
  timeout: mY,
  noFocus: EY,
  somethingWentWrong: CY,
  incorrectCameraId: SY,
  done: IY,
  cameraUnavailable: vY,
  versionNotSupported: gY,
  httpNotSupported: RY,
  insecurePageContext: DY,
  badLicense: AY,
  fileCorrupt: TY,
  largeFile: OY,
  placeDocumentIntoFrame: yY,
  holdDocumentStraight: NY,
  glaresOnDocument: LY,
  tryAgain: MY,
  noCameraAvailable: PY,
  positionDocumentCenter: bY,
  uploadPhoto: wY,
  moveCloser: HY,
  keepDeviceStill: VY,
  camera: kY,
  switchToMobile: FY,
  openPhoneCamera: UY,
  pleaseWait: xY,
  mobileDevice: BY,
  verifyYourIdentity: $Y,
  fromCameraFilesMobileDesktop: GY,
  fromCameraFilesDesktop: ZY,
  fromCameraMobileDesktop: jY,
  fromFilesMobileDesktop: zY,
  fromCameraDesktop: qY,
  fromFilesDesktop: WY,
  fromMobileDesktop: YY,
  fromCameraGalleryMobile: KY,
  fromGalleryMobile: XY,
  gallery: QY,
  files: JY,
  returnToComputer: eK,
  documentCaptured: tK,
  or: rK,
  continueInBrowser: nK
}, aK = "Menyediakan kamera...", oK = "Ralat masa", sK = "Tiada fokus kamera", lK = "Ada masalah", cK = "Tiada kamera dengan ID yang ditentukan ditemui", uK = "Selesai!", fK = "Kamera tidak tersedia!", dK = "Versi pelayar web anda tidak disokong", pK = "HTTPS tidak digunakan", hK = "Konteks tidak selamat", _K = "Lesen tidak dapat dicari atau telah tamat tempoh", mK = "Fail ini rosak atau tidak disokong", EK = "Fail ini terlalu besar untuk dimuat naik", CK = "Muatkan dokumen dalam bingkai", SK = "Pengang dokumen secara tegak", IK = "Elakan silau pada dokumen", vK = "Sila cuba lagi", gK = "Tiada kamera", RK = "Letakkan dokumen di tengah", DK = "Muat naik gambar", AK = "Dekatkan", TK = "Pegang peranti dengan tenang", OK = "Kamera", yK = "Beralih ke mudah alih", NK = "Buka kamera pada peranti mudah alih anda, imbas kod QR, dan ikuti pautan", LK = "Please wait...", MK = "Peranti mudah alih", PK = "Pengesahan dokumen identiti", bK = "Tangkap gambar dokumen menggunakan kamera komputer, muat naik daripada fail atau imbas pada peranti mudah alih", wK = "Tangkap gambar dokumen menggunakan kamera komputer atau muat naik daripada fail", HK = "Tangkap gambar dokumen menggunakan kamera komputer atau imbas pada peranti mudah alih", VK = "Muat naik dokumen daripada fail atau imbas pada peranti mudah alih", kK = "Guna kamera komputer untuk menangkap gambar dokumen", FK = "Pilih dokumen daripada fail dan muat naik", UK = "Guna kamera mudah alih anda untuk menangkap gambar dokumen", xK = "Tangkap gambar dokumen dengan menggunakan kamera mudah alih atau muat naik daripada galeri", BK = "Pilih dokumen daripada galeri dan muat naik", $K = "Galeri", GK = "Fail", ZK = "Kembali ke komputer", jK = "Dokumen anda telah dirakam", zK = "atau", qK = "Klik sini untuk meneruskan dalam pelayar", WK = {
  preparingCamera: aK,
  timeout: oK,
  noFocus: sK,
  somethingWentWrong: lK,
  incorrectCameraId: cK,
  done: uK,
  cameraUnavailable: fK,
  versionNotSupported: dK,
  httpNotSupported: pK,
  insecurePageContext: hK,
  badLicense: _K,
  fileCorrupt: mK,
  largeFile: EK,
  placeDocumentIntoFrame: CK,
  holdDocumentStraight: SK,
  glaresOnDocument: IK,
  tryAgain: vK,
  noCameraAvailable: gK,
  positionDocumentCenter: RK,
  uploadPhoto: DK,
  moveCloser: AK,
  keepDeviceStill: TK,
  camera: OK,
  switchToMobile: yK,
  openPhoneCamera: NK,
  pleaseWait: LK,
  mobileDevice: MK,
  verifyYourIdentity: PK,
  fromCameraFilesMobileDesktop: bK,
  fromCameraFilesDesktop: wK,
  fromCameraMobileDesktop: HK,
  fromFilesMobileDesktop: VK,
  fromCameraDesktop: kK,
  fromFilesDesktop: FK,
  fromMobileDesktop: UK,
  fromCameraGalleryMobile: xK,
  fromGalleryMobile: BK,
  gallery: $K,
  files: GK,
  returnToComputer: ZK,
  documentCaptured: jK,
  or: zK,
  continueInBrowser: qK
}, YK = "Se pregătește camera...", KK = "Pauză", XK = "Cameră nefocalizată", QK = "Ceva n-a mers bine", JK = "Nu a fost găsită nicio cameră cu ID-ul specificat", eX = "Terminat!", tX = "Camera foto indisponibilă!", rX = "Versiunea browserului dvs. nu este acceptată", nX = "Nu au fost utilizate HTTPS-uri", iX = "Context nesigur", aX = "Licența nu poate fi găsită sau a expirat", oX = "Acest fișier este corupt sau nu este acceptat", sX = "Fișierul este prea mare pentru a fi încărcat", lX = "Încadrați documentul în cadru", cX = "Țineți documentul drept", uX = "Evitați strălucirea de pe document", fX = "Încercați încă o dată", dX = "Nu există cameră", pX = "Poziționați documentul în centru", hX = "Încărcați o fotografie", _X = "Apropiați-vă", mX = "Țineți dispozitivul nemișcat", EX = "Camera", CX = "Treceți pe mobil", SX = "Activați camera dispozitivului dumneavoastră mobil, scanați codul QR și urmați link-ul", IX = "Aşteptaţi Vă rog…", vX = "Dispozitiv mobil", gX = "Verificarea actelor de identitate", RX = "Fotografiați un document utilizând camera computerului, încărcați-l din fișiere sau scanați-l pe un dispozitiv mobil", DX = "Fotografiați un document utilizând camera computerului sau încărcați-l din fișiere", AX = "Fotografiați un document utilizând camera computerului sau scanați-l pe un dispozitiv mobil", TX = "Încărcați un document din fișiere sau scanați-l pe un dispozitiv mobil", OX = "Utilizați camera computerului pentru a fotografia un document", yX = "Selectați un document din fișiere și încărcați-l", NX = "Utilizați camera dispozitivului dumneavoastră mobil pentru a fotografia un document", LX = "Fotografiați un document utilizând camera dispozitivului mobil sau încărcați-l din galerie", MX = "Selectați un document din galerie și încărcați-l", PX = "Galerie", bX = "Fișiere", wX = "Întoarceți-vă la computer", HX = "Documentul dumneavoastră a fost fotografiat", VX = "sau", kX = "Faceți clic aici pentru a continua în browser", FX = {
  preparingCamera: YK,
  timeout: KK,
  noFocus: XK,
  somethingWentWrong: QK,
  incorrectCameraId: JK,
  done: eX,
  cameraUnavailable: tX,
  versionNotSupported: rX,
  httpNotSupported: nX,
  insecurePageContext: iX,
  badLicense: aX,
  fileCorrupt: oX,
  largeFile: sX,
  placeDocumentIntoFrame: lX,
  holdDocumentStraight: cX,
  glaresOnDocument: uX,
  tryAgain: fX,
  noCameraAvailable: dX,
  positionDocumentCenter: pX,
  uploadPhoto: hX,
  moveCloser: _X,
  keepDeviceStill: mX,
  camera: EX,
  switchToMobile: CX,
  openPhoneCamera: SX,
  pleaseWait: IX,
  mobileDevice: vX,
  verifyYourIdentity: gX,
  fromCameraFilesMobileDesktop: RX,
  fromCameraFilesDesktop: DX,
  fromCameraMobileDesktop: AX,
  fromFilesMobileDesktop: TX,
  fromCameraDesktop: OX,
  fromFilesDesktop: yX,
  fromMobileDesktop: NX,
  fromCameraGalleryMobile: LX,
  fromGalleryMobile: MX,
  gallery: PX,
  files: bX,
  returnToComputer: wX,
  documentCaptured: HX,
  or: VX,
  continueInBrowser: kX
}, UX = "Προετοιμασία της κάμερας...", xX = "Εξωχρονισμός", BX = "Δεν υπάρχει εστίαση κάμερας", $X = "Κάτι πήγε στραβά", GX = "Δεν βρέθηκε κάμερα με το καθορισμένο ID", ZX = "Έτοιμο!", jX = "Η κάμερα δεν είναι διαθέσιμη!", zX = "Η έκδοση του προγράμματος περιήγησής σας δεν υποστηρίζεται", qX = "Το HTTPS δεν χρησιμοποιείται", WX = "Μη ασφαλές περιβάλλον", YX = "Η άδεια χρήσης δεν μπορεί να βρεθεί ή έχει λήξει", KX = "Αυτό το αρχείο είναι κατεστραμμένο ή δεν υποστηρίζεται", XX = "Αυτό το αρχείο δεν δύναται να μεταφορτωθεί λόγω υπερβολικού μεγέθους", QX = "Προσαρμόστε το έγγραφο, ώστε να βρίσκεται μέσα στο πλαίσιο", JX = "Κρατήστε το έγγραφο ίσιο", eQ = "Προσέχετε το έγγραφο να μην έχει αντανάκλαση", tQ = "Προσπαθήστε ξανά", rQ = "Δεν υπάρχει κάμερα", nQ = "Τοποθετήστε το έγγραφο στο κέντρο", iQ = "Ανέβασε μια φωτογραφία", aQ = "Πλησιάστε", oQ = "Κρατήστε ακίνητη τη συσκευή", sQ = "Κάμερα", lQ = "Μεταβείτε στην κινητή συσκευή", cQ = "Ανοίξτε την κάμερα στην κινητή συσκευή σας, σαρώστε τον κωδικό QR και μεταβείτε στον σύνδεσμο", uQ = "Please wait...", fQ = "Κινητή συσκευή", dQ = "Επαλήθευση εγγράφου ταυτότητας", pQ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή, ανεβάστε το από τα αρχεία ή σαρώστε το με μια κινητή συσκευή", hQ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή ή ανεβάστε το από τα αρχεία", _Q = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή ή σαρώστε το με μια κινητή συσκευή", mQ = "Ανεβάστε ένα έγγραφο από τα αρχεία ή σαρώστε το με μια κινητή συσκευή", EQ = "Χρησιμοποιήστε την κάμερα του υπολογιστή για τη λήψη εικόνας εγγράφου", CQ = "Επιλέξτε ένα έγγραφο από τα αρχεία και ανεβάστε το", SQ = "Χρησιμοποιήστε την κάμερα της κινητής συσκευής σας για τη λήψη εικόνας εγγράφου", IQ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα της κινητής συσκευής σας ή ανεβάστε το από την γκαλερί", vQ = "Επιλέξτε ένα έγγραφο από την γκαλερί και ανεβάστε το", gQ = "Γκαλερί", RQ = "Αρχεία", DQ = "Επιστρέψτε στον υπολογιστή", AQ = "Λήψη εικόνας του εγγράφου σας έχει πραγματοποιηθεί", TQ = "ή", OQ = "Κάντε κλικ εδώ για να συνεχίσετε στο πρόγραμμα περιήγησης", yQ = {
  preparingCamera: UX,
  timeout: xX,
  noFocus: BX,
  somethingWentWrong: $X,
  incorrectCameraId: GX,
  done: ZX,
  cameraUnavailable: jX,
  versionNotSupported: zX,
  httpNotSupported: qX,
  insecurePageContext: WX,
  badLicense: YX,
  fileCorrupt: KX,
  largeFile: XX,
  placeDocumentIntoFrame: QX,
  holdDocumentStraight: JX,
  glaresOnDocument: eQ,
  tryAgain: tQ,
  noCameraAvailable: rQ,
  positionDocumentCenter: nQ,
  uploadPhoto: iQ,
  moveCloser: aQ,
  keepDeviceStill: oQ,
  camera: sQ,
  switchToMobile: lQ,
  openPhoneCamera: cQ,
  pleaseWait: uQ,
  mobileDevice: fQ,
  verifyYourIdentity: dQ,
  fromCameraFilesMobileDesktop: pQ,
  fromCameraFilesDesktop: hQ,
  fromCameraMobileDesktop: _Q,
  fromFilesMobileDesktop: mQ,
  fromCameraDesktop: EQ,
  fromFilesDesktop: CQ,
  fromMobileDesktop: SQ,
  fromCameraGalleryMobile: IQ,
  fromGalleryMobile: vQ,
  gallery: gQ,
  files: RQ,
  returnToComputer: DQ,
  documentCaptured: AQ,
  or: TQ,
  continueInBrowser: OQ
}, NQ = "Kamera hazırlanıyor...", LQ = "Zaman aşımı", MQ = "Kamera odağı yok", PQ = "Bir hata oluştu", bQ = "Belirtilen kimliğe sahip kamera bulunamadı", wQ = "Tamam!", HQ = "Kamera kullanılamıyor!", VQ = "Tarayıcı sürümünüz desteklenmiyor", kQ = "HTTPS kullanılmamış", FQ = "Güvenilmeyen bağlam", UQ = "Lisans bulunamadı veya lisansın süresi dolmuş", xQ = "Dosya bozuk veya desteklenmiyor", BQ = "Dosya boyutu yüklenemeyecek kadar büyük", $Q = "Belgeyi çerçeve içine yerleştir", GQ = "Dokümanı düz bir zemine yerleştirin", ZQ = "Belge üzerinde parlama olmamasına özen gösterin", jQ = "Tekrar deneyin", zQ = "Kamera yok", qQ = "Belgeyi ortaya konumlandırın", WQ = "Fotoğraf yükleyin", YQ = "Yakına gelin", KQ = "Cihazı sabit tutun", XQ = "Kamera", QQ = "Mobil cihaza geçin", JQ = "Mobil cihazınızdaki kamerayı açın, QR kodunu taratın ve bağlantıyı izleyin", eJ = "Lütfen bekleyiniz", tJ = "Mobil cihazı", rJ = "Kimlik belgesi doğrulaması", nJ = "Belgeyi bilgisayarın kamerasını kullanarak taratın, dosyalardan karşıya yükleyin veya bir mobil cihazda taratın", iJ = "Belgeyi bilgisayarın kamerasını kullanarak taratın veya dosyalardan karşıya yükleyin", aJ = "Belgeyi bilgisayarın kamerasını kullanarak veya bir mobil cihazda taratın", oJ = "Belgeyi dosyalardan karşıya yükleyin veya mobil bir cihazda taratın", sJ = "Belgeyi taratmak için bilgisayarın kamerasını kullanın", lJ = "Dosyalardan bir belge seçip karşıya yükleyin", cJ = "Belgeyi taratmak için mobil cihazınızın kamerasını kullanın", uJ = "Belgeyi mobil cihazınızın kamerasını kullanarak taratın veya galeriden karşıya yükleyin", fJ = "Galeriden bir belge seçip karşıya yükleyin", dJ = "Galeri", pJ = "Dosyalar", hJ = "Bilgisayara dön", _J = "Belge yakalandı", mJ = "veya", EJ = "Tarayıcıda devam etmek için tıklayın", CJ = {
  preparingCamera: NQ,
  timeout: LQ,
  noFocus: MQ,
  somethingWentWrong: PQ,
  incorrectCameraId: bQ,
  done: wQ,
  cameraUnavailable: HQ,
  versionNotSupported: VQ,
  httpNotSupported: kQ,
  insecurePageContext: FQ,
  badLicense: UQ,
  fileCorrupt: xQ,
  largeFile: BQ,
  placeDocumentIntoFrame: $Q,
  holdDocumentStraight: GQ,
  glaresOnDocument: ZQ,
  tryAgain: jQ,
  noCameraAvailable: zQ,
  positionDocumentCenter: qQ,
  uploadPhoto: WQ,
  moveCloser: YQ,
  keepDeviceStill: KQ,
  camera: XQ,
  switchToMobile: QQ,
  openPhoneCamera: JQ,
  pleaseWait: eJ,
  mobileDevice: tJ,
  verifyYourIdentity: rJ,
  fromCameraFilesMobileDesktop: nJ,
  fromCameraFilesDesktop: iJ,
  fromCameraMobileDesktop: aJ,
  fromFilesMobileDesktop: oJ,
  fromCameraDesktop: sJ,
  fromFilesDesktop: lJ,
  fromMobileDesktop: cJ,
  fromCameraGalleryMobile: uJ,
  fromGalleryMobile: fJ,
  gallery: dJ,
  files: pJ,
  returnToComputer: hJ,
  documentCaptured: _J,
  or: mJ,
  continueInBrowser: EJ
}, SJ = "カメラ準備中...", IJ = "タイムアウト", vJ = "カメラの焦点が合っていません", gJ = "何らかの問題が発生しました", RJ = "指定されたIDを持つカメラがみつかりませんでした", DJ = "完了！", AJ = "カメラが利用できません！", TJ = "ご利用のブラウザのバージョンはサポートされていません", OJ = "HTTPSが使用されていません", yJ = "不安定なコンテキスト", NJ = "ライセンスがみつからないか有効期限が切れています", LJ = "このファイルは破損しているかサポートされていません", MJ = "このファイルはアップロードするには大きすぎます", PJ = "フレームに文書をフィットさせます", bJ = "文書をまっすぐに持ってください", wJ = "文書にテカリが発生しないようにしてください", HJ = "もう一度お試しください", VJ = "カメラがありません", kJ = "書類を中心に配置してください", FJ = "写真をアップロード", UJ = "近寄ってください", xJ = "デバイスを構えて静止してください", BJ = "カメラ", $J = "モバイルに切り替えてください", GJ = "ご利用のモバイル機器でカメラを起動し、QRコードをスキャンし、リンクをクリックしてください", ZJ = "Please wait...", jJ = "モバイル機器", zJ = "ID書類の照合", qJ = "コンピューターのカメラを使って書類を撮影し、その画像をファイルからアップロードするか、モバイル機器でスキャンしてください", WJ = "コンピューターのカメラを使って書類を撮影し、その画像をファイルからアップロードしてください", YJ = "コンピューターのカメラを使って書類を撮影するか、モバイル機器でスキャンしてください", KJ = "ファイルから書類をアップロードするか、モバイル機器でスキャンしてください", XJ = "コンピューターのカメラを使って書類を撮影してください", QJ = "ファイルから書類を選択してアップロードしてください", JJ = "モバイル機器のカメラを使って書類を撮影してください", eee = "モバイル機器のカメラを使って書類を撮影するか、ギャラリーからアップロードしてください", tee = "ギャラリーから書類を選択してアップロードしてください", ree = "ギャラリー", nee = "ファイル", iee = "コンピューターに戻ってください", aee = "書類がキャプチャされました", oee = "または", see = "ブラウザで継続するにはこちらをクリックしてください", lee = {
  preparingCamera: SJ,
  timeout: IJ,
  noFocus: vJ,
  somethingWentWrong: gJ,
  incorrectCameraId: RJ,
  done: DJ,
  cameraUnavailable: AJ,
  versionNotSupported: TJ,
  httpNotSupported: OJ,
  insecurePageContext: yJ,
  badLicense: NJ,
  fileCorrupt: LJ,
  largeFile: MJ,
  placeDocumentIntoFrame: PJ,
  holdDocumentStraight: bJ,
  glaresOnDocument: wJ,
  tryAgain: HJ,
  noCameraAvailable: VJ,
  positionDocumentCenter: kJ,
  uploadPhoto: FJ,
  moveCloser: UJ,
  keepDeviceStill: xJ,
  camera: BJ,
  switchToMobile: $J,
  openPhoneCamera: GJ,
  pleaseWait: ZJ,
  mobileDevice: jJ,
  verifyYourIdentity: zJ,
  fromCameraFilesMobileDesktop: qJ,
  fromCameraFilesDesktop: WJ,
  fromCameraMobileDesktop: YJ,
  fromFilesMobileDesktop: KJ,
  fromCameraDesktop: XJ,
  fromFilesDesktop: QJ,
  fromMobileDesktop: JJ,
  fromCameraGalleryMobile: eee,
  fromGalleryMobile: tee,
  gallery: ree,
  files: nee,
  returnToComputer: iee,
  documentCaptured: aee,
  or: oee,
  continueInBrowser: see
}, cee = "Příprava fotoaparátu...", uee = "Časový limit", fee = "Fotoaparát není zaostřen", dee = "Něco se pokazilo", pee = "Nebyl nalezen žádný fotoaparát se zadaným ID", hee = "Hotovo!", _ee = "Fotoaparát není k dispozici!", mee = "Vaše verze prohlížeče není podporována", Eee = "Nebylo použito HTTPS", Cee = "Nejistý kontext", See = "Licenci nelze nalézt nebo vypršela její platnost", Iee = "Tento soubor je poškozený nebo není podporován", vee = "Tento soubor je příliš velký na to, aby mohl být nahrán", gee = "Umístěte dokument do rámečku", Ree = "Držte dokument rovně", Dee = "Vyvarujte se ostrému osvětlení dokumentu", Aee = "Zkusit to znovu", Tee = "Chybí fotoaparát", Oee = "Umístěte dokumentu do středu", yee = "Nahrát fotografii", Nee = "Přibližte se", Lee = "Držte zařízení tak, aby se nehnulo", Mee = "Fotoaparát", Pee = "Přejděte do mobilní verze", bee = "Otevřete fotoaparát na mobilním zařízení, naskenujte QR kód a přejděte na odkaz", wee = "Please wait...", Hee = "Mobilní zařízení", Vee = "Ověřování dokladů totožnosti", kee = "Pořiďte snímek dokumentu pomocí kamery v počítači, nahrajte jej ze souborů nebo jej naskenujte na mobilním zařízení", Fee = "Pořiďte snímek dokumentu pomocí kamery v počítači nebo jej nahrajte ze souborů", Uee = "Pořiďte snímek dokumentu pomocí kamery v počítači nebo jej naskenujte na mobilním zařízení", xee = "Nahrajte dokument ze souborů nebo jej naskenujte na mobilním zařízení", Bee = "Pořiďte snímek dokumentu pomocí kamery v počítači", $ee = "Vyberte dokument ze souborů a nahrajte jej", Gee = "Pořiďte snímek dokumentu pomocí fotoaparátu na mobilu", Zee = "Pořiďte snímek dokumentu pomocí fotoaparátu na mobilu nebo jej nahrajte z galerie", jee = "Vyberte dokument z galerie a nahrajte jej", zee = "Galerie", qee = "Soubory", Wee = "Vraťte se k počítači", Yee = "Dokument byl zaznamenán", Kee = "nebo", Xee = "Po kliknutí zde budete pokračovat v prohlížeči", Qee = {
  preparingCamera: cee,
  timeout: uee,
  noFocus: fee,
  somethingWentWrong: dee,
  incorrectCameraId: pee,
  done: hee,
  cameraUnavailable: _ee,
  versionNotSupported: mee,
  httpNotSupported: Eee,
  insecurePageContext: Cee,
  badLicense: See,
  fileCorrupt: Iee,
  largeFile: vee,
  placeDocumentIntoFrame: gee,
  holdDocumentStraight: Ree,
  glaresOnDocument: Dee,
  tryAgain: Aee,
  noCameraAvailable: Tee,
  positionDocumentCenter: Oee,
  uploadPhoto: yee,
  moveCloser: Nee,
  keepDeviceStill: Lee,
  camera: Mee,
  switchToMobile: Pee,
  openPhoneCamera: bee,
  pleaseWait: wee,
  mobileDevice: Hee,
  verifyYourIdentity: Vee,
  fromCameraFilesMobileDesktop: kee,
  fromCameraFilesDesktop: Fee,
  fromCameraMobileDesktop: Uee,
  fromFilesMobileDesktop: xee,
  fromCameraDesktop: Bee,
  fromFilesDesktop: $ee,
  fromMobileDesktop: Gee,
  fromCameraGalleryMobile: Zee,
  fromGalleryMobile: jee,
  gallery: zee,
  files: qee,
  returnToComputer: Wee,
  documentCaptured: Yee,
  or: Kee,
  continueInBrowser: Xee
}, Jee = "กำลังเตรียมกล้องถ่ายรูป...", ete = "หมดเวลา", tte = "ไม่มีโฟกัสกล้อง", rte = "มีบางอย่างผิดพลาด", nte = "ไม่พบกล้องที่มี ID ที่ระบุ", ite = "เสร็จ!", ate = "กล้องถ่ายรูปไม่พร้อมใช้งาน!", ote = "ไม่รองรับเบราว์เซอร์รุ่นที่คุณใช้งาน", ste = "ไม่ได้ใช้ HTTPS", lte = "เนื้อหาไม่รัดกุม", cte = "ไม่พบใบอนุญาติ หรือใบอนุญาตหมดอายุ", ute = "ไฟล์นี้เสียหายหรือระบบไม่รองรับไฟล์นี้", fte = "ไฟล์นี้ใหญ่เกินกว่าจะอัปโหลดได้", dte = "จัดเอกสารให้พอดีกับกรอบ", pte = "ถือเอกสารให้ตรง", hte = "โปรดหลีกเลี่ยงไม่ให้แสงส่องจ้าบนเอกสาร", _te = "ลองอีกครั้ง", mte = "ไม่มีกล้องถ่ายรูป", Ete = "จัดวางเอกสารไว้ตรงกลาง", Cte = "อัปโหลดรูปภาพ", Ste = "เข้ามาใกล้กว่านี้", Ite = "ถืออุปกรณ์นิ่ง ๆ", vte = "กล้องถ่ายรูป", gte = "สลับไปใช้โทรศัพท์", Rte = "เปิดกล้องถ่ายรูปในอุปกรณ์เคลื่อนที่ สแกนรหัส QR และไปตามลิงก์", Dte = "Please wait...", Ate = "อุปกรณ์เคลื่อนที่", Tte = "การยืนยันเอกสารประจำตัว", Ote = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ อัปโหลดภาพจากไฟล์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", yte = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ หรืออัปโหลดภาพจากไฟล์", Nte = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", Lte = "อัปโหลดภาพจากไฟล์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", Mte = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์", Pte = "เลือกเอกสารจากไฟล์และอัปโหลด", bte = "ใช้กล้องจากอุปกรณ์เคลื่อนที่ของคุณเพื่อจับภาพเอกสาร", wte = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของอุปกรณ์เคลื่อนที่ หรืออัปโหลดจากแกลเลอรี", Hte = "เลือกเอกสารจากแกลเลอรีและอัปโหลด", Vte = "แกลเลอรี", kte = "ไฟล์", Fte = "กลับไปที่คอมพิวเตอร์ของคุณ", Ute = "จับภาพเอกสารของคุณแล้ว", xte = "หรือ", Bte = "คลิกที่นี่เพื่อดำเนินการต่อในเบราว์เซอร์", $te = {
  preparingCamera: Jee,
  timeout: ete,
  noFocus: tte,
  somethingWentWrong: rte,
  incorrectCameraId: nte,
  done: ite,
  cameraUnavailable: ate,
  versionNotSupported: ote,
  httpNotSupported: ste,
  insecurePageContext: lte,
  badLicense: cte,
  fileCorrupt: ute,
  largeFile: fte,
  placeDocumentIntoFrame: dte,
  holdDocumentStraight: pte,
  glaresOnDocument: hte,
  tryAgain: _te,
  noCameraAvailable: mte,
  positionDocumentCenter: Ete,
  uploadPhoto: Cte,
  moveCloser: Ste,
  keepDeviceStill: Ite,
  camera: vte,
  switchToMobile: gte,
  openPhoneCamera: Rte,
  pleaseWait: Dte,
  mobileDevice: Ate,
  verifyYourIdentity: Tte,
  fromCameraFilesMobileDesktop: Ote,
  fromCameraFilesDesktop: yte,
  fromCameraMobileDesktop: Nte,
  fromFilesMobileDesktop: Lte,
  fromCameraDesktop: Mte,
  fromFilesDesktop: Pte,
  fromMobileDesktop: bte,
  fromCameraGalleryMobile: wte,
  fromGalleryMobile: Hte,
  gallery: Vte,
  files: kte,
  returnToComputer: Fte,
  documentCaptured: Ute,
  or: xte,
  continueInBrowser: Bte
}, Gte = "कैमरा तैयार करना...", Zte = "समय समाप्त", jte = "कैमरा फ़ोकस नहीं", zte = "कुछ त्रुटि हुई", qte = "निर्दिष्ट ID वाला कोई कैमरा नहीं मिला", Wte = "ठीक है!", Yte = "कैमरा उपलब्ध नहीं है!", Kte = "आपका ब्राउज़र संस्करण समर्थित नहीं है", Xte = "HTTPS का उपयोग नहीं किया गया", Qte = "असुरक्षित प्रसंग", Jte = "लाइसेंस नहीं मिला या समाप्त हो गया है", ere = "यह फ़ाइल करप्ट है या समर्थित नहीं है", tre = "यह फ़ाइल अपलोड करने के लिए बहुत बड़ी है", rre = "दस्तावेज़ को फ्रेम में फिट करें", nre = "दस्तावेज़ को सीधे रखें", ire = "दस्तावेज़ को चमक से बचाएं", are = "पुनः प्रयास करें", ore = "कोई कैमरा नहीं है", sre = "दस्तावेज़ को बीच में रखें", lre = "एक फ़ोटो अपलोड करें", cre = "नजदीक आएं", ure = "डिवाइस को स्थिर अवस्था में पकड़ें", fre = "कैमरा", dre = "मोबाइल पर स्विच करें", pre = "अपने मोबाइल डिवाइस पर कैमरा खोलें, QR कोड स्कैन करें और लिंक फॉलो करें", hre = "Please wait...", _re = "मोबाइल डिवाइस", mre = "पहचान दस्तावेज़ सत्यापन", Ere = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें, उसे फ़ाइलों से अपलोड करें, या मोबाइल डिवाइस पर स्कैन करें", Cre = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या उसे फ़ाइलों से अपलोड करें", Sre = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या मोबाइल डिवाइस पर स्कैन करें", Ire = "किसी दस्तावेज़ को फ़ाइलों से अपलोड करें या उसे मोबाइल डिवाइस पर स्कैन करें", vre = "किसी दस्तावेज़ को कैप्चर करने के लिए कंप्यूटर के कैमरे का उपयोग करें", gre = "फ़ाइलों में से एक दस्तावेज़ चुनें और उसे अपलोड करें", Rre = "किसी दस्तावेज़ को कैप्चर करने के लिए अपने मोबाइल के कैमरे का उपयोग करें", Dre = "मोबाइल के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या गैलरी से अपलोड करें", Are = "गैलरी से एक दस्तावेज़ चुनें और उसे अपलोड करें", Tre = "गैलरी से", Ore = "फाइल से", yre = "कंप्यूटर पर लौटें", Nre = "आपका दस्तावेज़ कैप्चर कर लिया गया है", Lre = "या", Mre = "ब्राउज़र में जारी रखने के लिए यहां क्लिक करें", Pre = {
  preparingCamera: Gte,
  timeout: Zte,
  noFocus: jte,
  somethingWentWrong: zte,
  incorrectCameraId: qte,
  done: Wte,
  cameraUnavailable: Yte,
  versionNotSupported: Kte,
  httpNotSupported: Xte,
  insecurePageContext: Qte,
  badLicense: Jte,
  fileCorrupt: ere,
  largeFile: tre,
  placeDocumentIntoFrame: rre,
  holdDocumentStraight: nre,
  glaresOnDocument: ire,
  tryAgain: are,
  noCameraAvailable: ore,
  positionDocumentCenter: sre,
  uploadPhoto: lre,
  moveCloser: cre,
  keepDeviceStill: ure,
  camera: fre,
  switchToMobile: dre,
  openPhoneCamera: pre,
  pleaseWait: hre,
  mobileDevice: _re,
  verifyYourIdentity: mre,
  fromCameraFilesMobileDesktop: Ere,
  fromCameraFilesDesktop: Cre,
  fromCameraMobileDesktop: Sre,
  fromFilesMobileDesktop: Ire,
  fromCameraDesktop: vre,
  fromFilesDesktop: gre,
  fromMobileDesktop: Rre,
  fromCameraGalleryMobile: Dre,
  fromGalleryMobile: Are,
  gallery: Tre,
  files: Ore,
  returnToComputer: yre,
  documentCaptured: Nre,
  or: Lre,
  continueInBrowser: Mre
}, bre = "ক্যামেরা প্রস্তুত করা হচ্ছে...", wre = "টাইম আউট", Hre = "ক্যামেরার ফোকাস হয়নি", Vre = "কিছু একটা ভুল হয়েছে", kre = "নির্দিষ্ট আইডি সহ কোনো ক্যামেরা পাওয়া যায়নি", Fre = "হয়ে গেছে!", Ure = "ক্যামেরা বিদ্যমান নেই!", xre = "আপনার ব্রাউজারের সংস্করণটি সমর্থিত নয়", Bre = "HTTPS ব্যবহৃত হয়নি", $re = "অনিরাপদ কন্টেক্সট", Gre = "লাইসেন্স পাওয়া যায়নি বা মেয়াদ শেষ হয়ে গেছে", Zre = "এই ফাইলটি অকার্যকর বা সমর্থিত নয়", jre = "এই ফাইলটি আপলোড করার জন্য খুবই বড়", zre = "ডকুমেন্টটি ফ্রেমের মাঝে রাখুন", qre = "ডকুমেন্টটি সোজাভাবে ধরে রাখুন", Wre = "ডকুমেন্টে আলোর ঝলকানি এড়িয়ে চলুন", Yre = "আবার চেষ্টা করুন", Kre = "কোনো ক্যামেরা নেই", Xre = "ডকুমেন্টটি কেন্দ্রে রাখুন", Qre = "একটি ছবি আপলোড করুন", Jre = "কাছে যান", ene = "ডিভাইসটি ধরে রাখুন", tne = "ক্যামেরা", rne = "মোবাইলে স্যুইচ করুন", nne = "আপনার মোবাইল ডিভাইসের ক্যামেরা দিয়ে QR কোডটি স্ক্যান করুন এবং লিঙ্কটি অনুসরণ করুন", ine = "Please wait...", ane = "মোবাইল ডিভাইস", one = "পরিচয় যাচাইকরণ ডকুমেন্ট", sne = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন, ফাইল থেকে আপলোড করুন বা মোবাইল ডিভাইসে এটি স্ক্যান করুন", lne = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা ফাইল থেকে আপলোড করুন", cne = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা একটি মোবাইল ডিভাইসে এটি স্ক্যান করুন", une = "ফাইল থেকে একটি ডকুমেন্ট আপলোড করুন বা একটি মোবাইল ডিভাইসে এটি স্ক্যান করুন", fne = "একটি ডকুমেন্ট ক্যাপচার করতে কম্পিউটারের ক্যামেরা ব্যবহার করুন", dne = "ফাইল থেকে একটি ডকুমেন্ট বাছাই করুন এবং এটি আপলোড করুন", pne = "একটি ডকুমেন্ট ক্যাপচার করতে আপনার মোবাইল ক্যামেরা ব্যবহার করুন", hne = "মোবাইলের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা গ্যালারি থেকে আপলোড করুন", _ne = "গ্যালারি থেকে একটি ডকুমেন্ট বাছাই করুন এবং এটি আপলোড করুন", mne = "গ্যালারি", Ene = "ফাইল", Cne = "কম্পিউটারে ফিরে যান", Sne = "আপনার ডকুমেন্ট ক্যাপচার করা হয়েছে", Ine = "অথবা", vne = "ব্রাউজারে চালিয়ে যেতে এখানে ক্লিক করুন", gne = {
  preparingCamera: bre,
  timeout: wre,
  noFocus: Hre,
  somethingWentWrong: Vre,
  incorrectCameraId: kre,
  done: Fre,
  cameraUnavailable: Ure,
  versionNotSupported: xre,
  httpNotSupported: Bre,
  insecurePageContext: $re,
  badLicense: Gre,
  fileCorrupt: Zre,
  largeFile: jre,
  placeDocumentIntoFrame: zre,
  holdDocumentStraight: qre,
  glaresOnDocument: Wre,
  tryAgain: Yre,
  noCameraAvailable: Kre,
  positionDocumentCenter: Xre,
  uploadPhoto: Qre,
  moveCloser: Jre,
  keepDeviceStill: ene,
  camera: tne,
  switchToMobile: rne,
  openPhoneCamera: nne,
  pleaseWait: ine,
  mobileDevice: ane,
  verifyYourIdentity: one,
  fromCameraFilesMobileDesktop: sne,
  fromCameraFilesDesktop: lne,
  fromCameraMobileDesktop: cne,
  fromFilesMobileDesktop: une,
  fromCameraDesktop: fne,
  fromFilesDesktop: dne,
  fromMobileDesktop: pne,
  fromCameraGalleryMobile: hne,
  fromGalleryMobile: _ne,
  gallery: mne,
  files: Ene,
  returnToComputer: Cne,
  documentCaptured: Sne,
  or: Ine,
  continueInBrowser: vne
}, Rne = "המצלמה בהכנה...", Dne = "זמן קצוב לתפוגה", Ane = "המצלמה לא בפוקוס", Tne = "משהו השתבש", One = "לא נמצאה מצלמה עם המזהה שצוין", yne = "סיימת!", Nne = "המצלמה לא זמינה", Lne = "אין תמיכה בגרסה הנוכחית של הדפדפן", Mne = "לא נעשה שימוש ב-HTTPS", Pne = "הקשר לא בטוח", bne = "הרישיון לא נמצא או לא בתוקף", wne = "הקובץ פגום או בפורמט שלא נתמך", Hne = "הקובץ גדול מדי ולא ניתן להעלות אותו", Vne = "התאמת המסמך בתוך המסגרת", kne = "יש ליישר את המסמך", Fne = "יש לוודא שאין ברק בזמן צילום המסמך", Une = "כדאי לנסות שוב", xne = "אין מצלמה", Bne = "יש למקם את המסמך במרכז", $ne = "העלאת תמונה", Gne = "להתקרב", Zne = "יש להחזיק את המכשיר בלי לזוז", jne = "מצלמה", zne = "מעבר לנייד", qne = "צריך לפתוח את המצלמה בנייד, לסרוק את קוד ה-QR וללחוץ על הקישור", Wne = "Please wait...", Yne = "נייד", Kne = "אימות של מסמך זיהוי", Xne = "צריך לצלם את המסמך באמצעות מצלמת המחשב, להעלות אותו מתוך הקבצים או לסרוק אותו בנייד", Qne = "צריך לצלם את המסמך באמצעות מצלמת המחשב או להעלות אותו מתוך הקבצים", Jne = "צריך לצלם את המסמך באמצעות מצלמת המחשב או לסרוק אותו בנייד", eie = "צריך להעלות את המסמך מתוך הקבצים או לסרוק אותו בנייד", tie = "צריך לצלם את המסמך באמצעות מצלמת המחשב", rie = "צריך לבחור את המסמך מתוך הקבצים ולהעלות אותו", nie = "צריך לצלם את המסמך באמצעות מצלמת הנייד", iie = "צריך לצלם את המסמך באמצעות מצלמת הנייד או להעלות אותו מהגלריה", aie = "צריך לבחור את המסמך מהגלריה ולהעלות אותו", oie = "גלריה", sie = "קבצים", lie = "חזרה למחשב", cie = "המסמך צולם", uie = "או", fie = "מקישים כאן כדי לפתוח בדפדפן", die = {
  preparingCamera: Rne,
  timeout: Dne,
  noFocus: Ane,
  somethingWentWrong: Tne,
  incorrectCameraId: One,
  done: yne,
  cameraUnavailable: Nne,
  versionNotSupported: Lne,
  httpNotSupported: Mne,
  insecurePageContext: Pne,
  badLicense: bne,
  fileCorrupt: wne,
  largeFile: Hne,
  placeDocumentIntoFrame: Vne,
  holdDocumentStraight: kne,
  glaresOnDocument: Fne,
  tryAgain: Une,
  noCameraAvailable: xne,
  positionDocumentCenter: Bne,
  uploadPhoto: $ne,
  moveCloser: Gne,
  keepDeviceStill: Zne,
  camera: jne,
  switchToMobile: zne,
  openPhoneCamera: qne,
  pleaseWait: Wne,
  mobileDevice: Yne,
  verifyYourIdentity: Kne,
  fromCameraFilesMobileDesktop: Xne,
  fromCameraFilesDesktop: Qne,
  fromCameraMobileDesktop: Jne,
  fromFilesMobileDesktop: eie,
  fromCameraDesktop: tie,
  fromFilesDesktop: rie,
  fromMobileDesktop: nie,
  fromCameraGalleryMobile: iie,
  fromGalleryMobile: aie,
  gallery: oie,
  files: sie,
  returnToComputer: lie,
  documentCaptured: cie,
  or: uie,
  continueInBrowser: fie
}, pie = "Valmistellaan kameraa...", hie = "Aikakatkaisu", _ie = "Kamera ei tarkennettu", mie = "Jokin epäonnistui", Eie = "Kameraa, jonka tunniste on määritetty, ei löydy.", Cie = "Valmis!", Sie = "Kamera ei ole käytettävissä!", Iie = "Selaimesi versiota ei tueta", vie = "HTTPS ei käytössä", gie = "Konteksti ei turvallinen", Rie = "Lisenssiä ei löydy tai se on vanhentunut", Die = "Tämä tiedosto on vioittunut tai sitä ei tueta", Aie = "Tiedosto on liian suuri ladattavaksi", Tie = "Kohdista asiakirja kehykseen", Oie = "Pidä asiakirjaa suorassa", yie = "Vältä heijastuksia asiakirjassa", Nie = "Yritä uudelleen!", Lie = "Kameraa ei ole", Mie = "Sijoita asiakirja keskelle", Pie = "Lataa valokuva", bie = "Siirry lähemmäs", wie = "Pidä laitetta paikallaan", Hie = "Kamera", Vie = "Vaihda mobiiliin", kie = "Avaa mobiililaitteesi kamera, skannaa QR-koodi ja siirry linkin sivustoon", Fie = "Please wait...", Uie = "Mobiililaite", xie = "Henkilöllisyystodistusten todennus", Bie = "Kuvaa asiakirja tietokoneen kameralla, lataa se tiedostoista tai skannaa se mobiililaitteella", $ie = "Kuvaa asiakirja tietokoneen kameralla tai lataa se tiedostoista", Gie = "Kuvaa asiakirja tietokoneen kameralla tai skannaa se mobiililaitteella", Zie = "Lataa asiakirja tiedostoista tai skannaa se mobiililaitteella", jie = "Kuvaa asiakirja tietokoneen kameralla", zie = "Valitse asiakirja tiedostoista ja lataa se", qie = "Kuvaa asiakirja mobiililaitteesi kameralla", Wie = "Kuvaa asiakirja mobiililaitteen kameralla tai lataa se galleriasta", Yie = "Valitse asiakirja galleriasta ja lataa se", Kie = "Galleria", Xie = "Tiedostot", Qie = "Palaa tietokoneeseen", Jie = "Asiakirjasi on kuvattu", eae = "tai", tae = "Jatka selaimessa napsauttamalla tätä", rae = {
  preparingCamera: pie,
  timeout: hie,
  noFocus: _ie,
  somethingWentWrong: mie,
  incorrectCameraId: Eie,
  done: Cie,
  cameraUnavailable: Sie,
  versionNotSupported: Iie,
  httpNotSupported: vie,
  insecurePageContext: gie,
  badLicense: Rie,
  fileCorrupt: Die,
  largeFile: Aie,
  placeDocumentIntoFrame: Tie,
  holdDocumentStraight: Oie,
  glaresOnDocument: yie,
  tryAgain: Nie,
  noCameraAvailable: Lie,
  positionDocumentCenter: Mie,
  uploadPhoto: Pie,
  moveCloser: bie,
  keepDeviceStill: wie,
  camera: Hie,
  switchToMobile: Vie,
  openPhoneCamera: kie,
  pleaseWait: Fie,
  mobileDevice: Uie,
  verifyYourIdentity: xie,
  fromCameraFilesMobileDesktop: Bie,
  fromCameraFilesDesktop: $ie,
  fromCameraMobileDesktop: Gie,
  fromFilesMobileDesktop: Zie,
  fromCameraDesktop: jie,
  fromFilesDesktop: zie,
  fromMobileDesktop: qie,
  fromCameraGalleryMobile: Wie,
  fromGalleryMobile: Yie,
  gallery: Kie,
  files: Xie,
  returnToComputer: Qie,
  documentCaptured: Jie,
  or: eae,
  continueInBrowser: tae
}, nae = "Förbereder kameran...", iae = "Paus", aae = "Ingen kamerafokus", oae = "Ett fel inträffade", sae = "Ingen kamera med specificerat ID hittat", lae = "Klart!", cae = "Kameran är inte tillgänglig!", uae = "Din webbläsarversion stöds inte", fae = "HTTPS används inte", dae = "Otryggt sammanhang", pae = "Licensen går antingen inte att hitta eller så har den utgått", hae = "Filen är antingen korrupt eller stöds inte", _ae = "Filen är för stor för att kunna laddas upp", mae = "Placera dokumentet i ramen", Eae = "Håll dokumentet rakt", Cae = "Undvik reflexer på dokumentet", Sae = "Försök igen", Iae = "Det finns ingen kamera", vae = "Placera dokumentet i mitten", gae = "Ladda upp foto", Rae = "Flytta närmare", Dae = "Håll enheten stilla", Aae = "Kamera", Tae = "Byt till mobil", Oae = "Öppna kameran på din mobila enhet, skanna QR-koden och följ länken", yae = "Please wait...", Nae = "Mobil enhet", Lae = "Verifiering av ID-handlingar", Mae = "Skanna ett dokument med datorns kamera, ladda upp det från filerna eller skanna det med en mobil enhet", Pae = "Skanna ett dokument med datorns kamera eller ladda upp det från filerna", bae = "Skanna ett dokument med datorns kamera eller med en mobil enhet", wae = "Ladda upp det från filer eller skanna det med en mobil enhet", Hae = "Använd datorns kamera till att skanna ett dokument", Vae = "Välj ett dokument från filerna och ladda upp det", kae = "Använd din mobila kamera till att skanna ett dokument", Fae = "Skanna ett dokument med mobilens kamera eller ladda upp det från bildgalleriet", Uae = "Välj ett dokument från bildgalleriet och ladda upp det", xae = "Galleri", Bae = "Filer", $ae = "Gå tillbaka till datorn", Gae = "Ditt dokument har fångats", Zae = "eller", jae = "Klicka här för att fortsätta i webbläsaren", zae = {
  preparingCamera: nae,
  timeout: iae,
  noFocus: aae,
  somethingWentWrong: oae,
  incorrectCameraId: sae,
  done: lae,
  cameraUnavailable: cae,
  versionNotSupported: uae,
  httpNotSupported: fae,
  insecurePageContext: dae,
  badLicense: pae,
  fileCorrupt: hae,
  largeFile: _ae,
  placeDocumentIntoFrame: mae,
  holdDocumentStraight: Eae,
  glaresOnDocument: Cae,
  tryAgain: Sae,
  noCameraAvailable: Iae,
  positionDocumentCenter: vae,
  uploadPhoto: gae,
  moveCloser: Rae,
  keepDeviceStill: Dae,
  camera: Aae,
  switchToMobile: Tae,
  openPhoneCamera: Oae,
  pleaseWait: yae,
  mobileDevice: Nae,
  verifyYourIdentity: Lae,
  fromCameraFilesMobileDesktop: Mae,
  fromCameraFilesDesktop: Pae,
  fromCameraMobileDesktop: bae,
  fromFilesMobileDesktop: wae,
  fromCameraDesktop: Hae,
  fromFilesDesktop: Vae,
  fromMobileDesktop: kae,
  fromCameraGalleryMobile: Fae,
  fromGalleryMobile: Uae,
  gallery: xae,
  files: Bae,
  returnToComputer: $ae,
  documentCaptured: Gae,
  or: Zae,
  continueInBrowser: jae
}, qae = "Gør kameraet klar...", Wae = "Timeout", Yae = "Ingen kamerafokus", Kae = "Noget gik galt", Xae = "Intet kamera med det specificeret ID fundet", Qae = "Færdig!", Jae = "Kamera utilgængelig!", eoe = "Din browserversion er ikke understøttet", toe = "HTTPS ikke brugt", roe = "Usikker kontekst", noe = "Licensen kan ikke findes eller er udløbet", ioe = "Filen er ødelagt eller understøttes ikke", aoe = "Denne fil er for stor til at blive overført", ooe = "Tilpas dokumentet til rammen", soe = "Hold dokumentet lige", loe = "Undgå genskin på dokumentet", coe = "Prøv igen", uoe = "Der er intet kamera", foe = "Placer dokumentet i midten", doe = "Upload et foto", poe = "Flyt tættere på", hoe = "Hold enheden stille", _oe = "Kamera", moe = "Skift til mobil", Eoe = "Åben kameraet på din mobile enhed, scan QR-koden, og følg linket", Coe = "Please wait...", Soe = "Mobil enhed", Ioe = "Bekræftelse af ID-dokument", voe = "Fang et dokument ved hjælp af computerens kamera, upload det fra filer, eller scan det på en mobil enhed", goe = "Fang et dokument ved hjælp af computerens kamera eller upload det fra filer", Roe = "Fang et dokument ved hjælp af computerens kamera, upload det fra filer, eller scan det på en mobil enhed", Doe = "Upload et dokument fra filer eller scan det på en mobil enhed", Aoe = "Brug computerens kamera til at fange et dokument", Toe = "Vælg et dokument fra filer og upload det", Ooe = "Brug dit mobilkamera til at fange et dokument", yoe = "Fang et dokument ved hjælp af mobilens kamera eller upload det fra galleri", Noe = "Vælg et dokument fra galleriet og upload det", Loe = "Galleri", Moe = "Filer", Poe = "Vend tilbage til computeren", boe = "Dit dokument er blevet fanget", woe = "eller", Hoe = "Klik her for at fortsætte i browser", Voe = {
  preparingCamera: qae,
  timeout: Wae,
  noFocus: Yae,
  somethingWentWrong: Kae,
  incorrectCameraId: Xae,
  done: Qae,
  cameraUnavailable: Jae,
  versionNotSupported: eoe,
  httpNotSupported: toe,
  insecurePageContext: roe,
  badLicense: noe,
  fileCorrupt: ioe,
  largeFile: aoe,
  placeDocumentIntoFrame: ooe,
  holdDocumentStraight: soe,
  glaresOnDocument: loe,
  tryAgain: coe,
  noCameraAvailable: uoe,
  positionDocumentCenter: foe,
  uploadPhoto: doe,
  moveCloser: poe,
  keepDeviceStill: hoe,
  camera: _oe,
  switchToMobile: moe,
  openPhoneCamera: Eoe,
  pleaseWait: Coe,
  mobileDevice: Soe,
  verifyYourIdentity: Ioe,
  fromCameraFilesMobileDesktop: voe,
  fromCameraFilesDesktop: goe,
  fromCameraMobileDesktop: Roe,
  fromFilesMobileDesktop: Doe,
  fromCameraDesktop: Aoe,
  fromFilesDesktop: Toe,
  fromMobileDesktop: Ooe,
  fromCameraGalleryMobile: yoe,
  fromGalleryMobile: Noe,
  gallery: Loe,
  files: Moe,
  returnToComputer: Poe,
  documentCaptured: boe,
  or: woe,
  continueInBrowser: Hoe
}, koe = "Priprema kamere...", Foe = "Pauza", Uoe = "Nema fokusa kamere", xoe = "Nešto je pošlo po zlu", Boe = "Nije pronađena kamera s navedenim ID-om", $oe = "Gotovo!", Goe = "Kamera nije dostupna!", Zoe = "Vaša verzija preglednika nije podržana", joe = "HTTPS se ne koristi", zoe = "Nesiguran kontekst", qoe = "Licenca se ne može pronaći ili je istekla", Woe = "Ova datoteka je oštećena ili nije podržana", Yoe = "Ova je datoteka prevelika za prijenos", Koe = "Prilagodite dokument okviru", Xoe = "Držite dokument ravno", Qoe = "Izbjegavajte odsjaj na dokumentu", Joe = "Pokušajte ponovno", ese = "Nema kamere", tse = "Postavite dokument u sredinu", rse = "Uploadujte sliku", nse = "Priđite bliže", ise = "Držite uređaj mirno", ase = "Kamera", ose = "Prebacivanje na mobilni uređaj", sse = "Otvorite kameru na svom mobilnom uređaju, skenirajte QR kod i slijedite poveznicu", lse = "Please wait...", cse = "Mobilni uređaj", use = "Provjera osobnih dokumenata", fse = "Snimite dokument pomoću kamere računala, prenesite ga iz datoteka ili skenirajte na mobilnom uređaju", dse = "Snimite dokument pomoću kamere računala ili ga prenesite iz datoteka", pse = "Snimite dokument pomoću kamere računala ili ga skenirajte na mobilnom uređaju", hse = "Prenesite dokument iz datoteka ili ga skenirajte na mobilnom uređaju", _se = "Koristite kameru računala za snimanje dokumenta", mse = "Odaberite dokument iz datoteka i prenesite ga", Ese = "Koristite svoju mobilnu kameru za snimanje dokumenta", Cse = "Snimite dokument pomoću kamere mobilnog telefona ili ga prenesite iz galerije", Sse = "Odaberite dokument iz galerije i prenesite ga", Ise = "Galerija", vse = "Datoteke", gse = "Vrati se na računalo", Rse = "Vaš dokument je snimljen", Dse = "ili", Ase = "Kliknite ovdje za nastavak u pregledniku", Tse = {
  preparingCamera: koe,
  timeout: Foe,
  noFocus: Uoe,
  somethingWentWrong: xoe,
  incorrectCameraId: Boe,
  done: $oe,
  cameraUnavailable: Goe,
  versionNotSupported: Zoe,
  httpNotSupported: joe,
  insecurePageContext: zoe,
  badLicense: qoe,
  fileCorrupt: Woe,
  largeFile: Yoe,
  placeDocumentIntoFrame: Koe,
  holdDocumentStraight: Xoe,
  glaresOnDocument: Qoe,
  tryAgain: Joe,
  noCameraAvailable: ese,
  positionDocumentCenter: tse,
  uploadPhoto: rse,
  moveCloser: nse,
  keepDeviceStill: ise,
  camera: ase,
  switchToMobile: ose,
  openPhoneCamera: sse,
  pleaseWait: lse,
  mobileDevice: cse,
  verifyYourIdentity: use,
  fromCameraFilesMobileDesktop: fse,
  fromCameraFilesDesktop: dse,
  fromCameraMobileDesktop: pse,
  fromFilesMobileDesktop: hse,
  fromCameraDesktop: _se,
  fromFilesDesktop: mse,
  fromMobileDesktop: Ese,
  fromCameraGalleryMobile: Cse,
  fromGalleryMobile: Sse,
  gallery: Ise,
  files: vse,
  returnToComputer: gse,
  documentCaptured: Rse,
  or: Dse,
  continueInBrowser: Ase
}, Ose = "Forbereder kameraet...", yse = "Pause", Nse = "Ingen kamerafokus", Lse = "Noe gikk galt", Mse = "Kamera med den spesifikke ID-en ble ikke funnet", Pse = "Ferdig!", bse = "Kameraet er ikke tilgjengelig!", wse = "Din nettleserversjon støttes ikke", Hse = "HTTPS ikke brukt", Vse = "Usikker kontekst", kse = "Lisensen finnes ikke eller har utløpt", Fse = "Denne filen er skadet eller støttes ikke", Use = "Denne filen er for stor til å lastes opp", xse = "Plasser dokumentet i rammen", Bse = "Hold dokumentet rett", $se = "Unngå gjenskinn på dokumentet", Gse = "Prøv igjen", Zse = "Ingen kamera tilgjengelig", jse = "Plasser dokumentet i midten", zse = "Last opp et bilde", qse = "Kom nærmere", Wse = "Hold enheten i ro", Yse = "Kamera", Kse = "Bytt til mobil", Xse = "Åpne kameraet på mobilenheten din, skann QR-koden og følg linken", Qse = "Please wait...", Jse = "Mobilenhet", ele = "Identitetsverifikasjon av dokumenter", tle = "Fang et dokument med datamaskinens kamera, last det opp fra filer eller skann det på en mobilenhet", rle = "Fang et dokument med datamaskinens kamera eller last det opp fra filer", nle = "Fang et dokument med datamaskinens kamera eller skann det på en mobilenhet", ile = "Last opp et dokument fra filer eller skann det på en mobilenhet", ale = "Bruk datamaskinens kamera til å fange et dokument", ole = "Velg et dokument fra filer og last det opp", sle = "Bruk mobilkameraet til å fange et dokument", lle = "Fang et dokument med mobilens kamera eller last det opp fra galleriet", cle = "Velg et dokument fra galleriet og last det opp", ule = "Galleri", fle = "Filer", dle = "Gå tilbake til datamaskinen", ple = "Dokumentet ditt har blitt registrert", hle = "eller", _le = "Klikk her for å fortsette i nettleseren", mle = {
  preparingCamera: Ose,
  timeout: yse,
  noFocus: Nse,
  somethingWentWrong: Lse,
  incorrectCameraId: Mse,
  done: Pse,
  cameraUnavailable: bse,
  versionNotSupported: wse,
  httpNotSupported: Hse,
  insecurePageContext: Vse,
  badLicense: kse,
  fileCorrupt: Fse,
  largeFile: Use,
  placeDocumentIntoFrame: xse,
  holdDocumentStraight: Bse,
  glaresOnDocument: $se,
  tryAgain: Gse,
  noCameraAvailable: Zse,
  positionDocumentCenter: jse,
  uploadPhoto: zse,
  moveCloser: qse,
  keepDeviceStill: Wse,
  camera: Yse,
  switchToMobile: Kse,
  openPhoneCamera: Xse,
  pleaseWait: Qse,
  mobileDevice: Jse,
  verifyYourIdentity: ele,
  fromCameraFilesMobileDesktop: tle,
  fromCameraFilesDesktop: rle,
  fromCameraMobileDesktop: nle,
  fromFilesMobileDesktop: ile,
  fromCameraDesktop: ale,
  fromFilesDesktop: ole,
  fromMobileDesktop: sle,
  fromCameraGalleryMobile: lle,
  fromGalleryMobile: cle,
  gallery: ule,
  files: fle,
  returnToComputer: dle,
  documentCaptured: ple,
  or: hle,
  continueInBrowser: _le
}, Ele = "Kamerani tayyorlash...", Cle = "Vaqt tugashi", Sle = "Kamera fokusi yo'q", Ile = "Nimadir noto'g'ri ketdi", vle = "Berilgan ID bilan kamera topilmadi.", gle = "Tayyor!", Rle = "Kamera mavjud emas!", Dle = "Brauzeringiz versiyasi qo'llab-quvvatlanmaydi", Ale = "HTTPS ishlatilmaydi", Tle = "Xavfli kontekst", Ole = "Litsenziya topilmadi yoki bekor qilindi", yle = "Fayl buzilgan yoki qo'llab-quvvatlanmaydi", Nle = "Yuklab olinadigan fayl hajmi juda katta", Lle = "Hujjatni ramkaga joylashtiring", Mle = "Hujjatni to'g'ri ushlang", Ple = "Hujjatingizni yorug'likdan saqlang", ble = "Qayta urinib ko'ring", wle = "Kamera yo'q", Hle = "Hujjatni markazga joylashtiring", Vle = "Fotosuratni yuklang", kle = "Yaqinroq keling", Fle = "Qurilmani harakatsiz ushlang", Ule = "Kamera", xle = "Mobil qurilmangizga o'ting", Ble = "Mobil qurilmangiz kamerasini oching, QR kodini skanerlang va havolaga o'ting", $le = "Iltimos kuting…", Gle = "Mobil qurilma", Zle = "Shaxsni tasdiqlovchi hujjatni tekshirish", jle = "Hujjatni kompyuter kamerasi bilan suratga oling, fayllardan yuklang yoki mobil qurilmangizdan skanerlang", zle = "Hujjatni kompyuter kamerasi bilan suratga oling yoki fayllardan yuklang", qle = "Hujjatni kompyuter kamerasi bilan suratga oling yoki mobil qurilmadan skanerlang", Wle = "Hujjatni fayllardan yuklang yoki mobil qurilmadan skanerlang", Yle = "Hujjatni suratga olish uchun kompyuter kamerasidan foydalaning", Kle = "Fayllardan hujjatni tanlang va uni yuklang", Xle = "Hujjatni suratga olish uchun mobil qurilmangiz kamerasidan foydalaning", Qle = "Hujjatni mobil qurilmangiz kamerasi bilan suratga oling yoki galereyadan yuklang", Jle = "Galereyadan hujjatni tanlang va uni yuklab oling", e2e = "Galereya", t2e = "Fayllar", r2e = "Kompyuterga qaytish", n2e = "Hujjatingiz yozib olindi", i2e = "yoki", a2e = "Brauzerda davom ettirish uchun shu yerga bosing", o2e = {
  preparingCamera: Ele,
  timeout: Cle,
  noFocus: Sle,
  somethingWentWrong: Ile,
  incorrectCameraId: vle,
  done: gle,
  cameraUnavailable: Rle,
  versionNotSupported: Dle,
  httpNotSupported: Ale,
  insecurePageContext: Tle,
  badLicense: Ole,
  fileCorrupt: yle,
  largeFile: Nle,
  placeDocumentIntoFrame: Lle,
  holdDocumentStraight: Mle,
  glaresOnDocument: Ple,
  tryAgain: ble,
  noCameraAvailable: wle,
  positionDocumentCenter: Hle,
  uploadPhoto: Vle,
  moveCloser: kle,
  keepDeviceStill: Fle,
  camera: Ule,
  switchToMobile: xle,
  openPhoneCamera: Ble,
  pleaseWait: $le,
  mobileDevice: Gle,
  verifyYourIdentity: Zle,
  fromCameraFilesMobileDesktop: jle,
  fromCameraFilesDesktop: zle,
  fromCameraMobileDesktop: qle,
  fromFilesMobileDesktop: Wle,
  fromCameraDesktop: Yle,
  fromFilesDesktop: Kle,
  fromMobileDesktop: Xle,
  fromCameraGalleryMobile: Qle,
  fromGalleryMobile: Jle,
  gallery: e2e,
  files: t2e,
  returnToComputer: r2e,
  documentCaptured: n2e,
  or: i2e,
  continueInBrowser: a2e
}, s2e = "Տեսախցիկի նախապատրաստում․․․", l2e = "Թայմաութ", c2e = "Տեսախցիկի ֆոկուսավորում չկա", u2e = "Ինչ-որ բան սխալ է", f2e = "Նշված ID-ով տեսախցիկ չգտնվեց։", d2e = "Պատրաստ է", p2e = "Տեսախցիկը հասանելի չէ։", h2e = "Ձեր դիտարկիչի տարբերակը չի աջակցվում", _2e = "HTTPS չի օգտագործվում", m2e = "Վտանգավոր համատեքստ", E2e = "Արտոնագիրը չի գտնվել կամ այն անվավեր է", C2e = "Ֆայլը վնասված է կամ չի աջակցվում", S2e = "Բեռնված ֆայլի չափը շատ մեծ է", I2e = "Փաստաթուղթը տեղադրեք շրջանակի մեջ", v2e = "Փաստաթուղթը պահեք ուղիղ", g2e = "Խուսափեք փաստաթղթի վրա փայլեր հայտնվելուց", R2e = "Կրկնեք փորձը", D2e = "Տեսախցիկը բացակայում է", A2e = "Փաստաթուղթը տեղադրեք կենտրոնում", T2e = "Բեռնել լուսանկարը", O2e = "Ավելի մոտ տեղավորվերք", y2e = "Սարքը պահեք անշարժ", N2e = "Տեսախցիկ", L2e = "Անցնել բջջային սարքին", M2e = "բացեք բջջային սարքի տեսախցիկը, սկանավորեք QR կոդը և անցեք հղումով", P2e = "Խնդրում ենք սպասել...", b2e = "Բջջային սարք", w2e = "Անձը հաստատող փաստաթղթի ստուգում", H2e = "Համակարգչի տեսախցիկով լուսանկարեք փաստաթուղթը, բեռնեք ֆայլերից կամ սկանավորեք բջջային սարքից", V2e = "Փաստաթուղթը լուսանկարեք համակարգչի տեսախցիկի օգնությամբ կամ բեռնեք այն ֆայլերի ցանկից", k2e = "Համակարգչի տեսախցիկով լուսանկարեք փաստաթուղթը կամ սկանավորեք բջջային սարքից", F2e = "Փաստաթուղթը բեռնեք ֆայլերի ցանկից կամ սկանավորեք այն բջջային սարքից", U2e = "Օգտվեք համակարգչի տեսախցիկից՝ փաստաթուղթը լուսանկարելու համար", x2e = "Ֆայլերի ցանկից փաստաթուղթ ընտրեք և բեռնեք այն", B2e = "Օգտվեք բջջային սարքի տեսախցիկից՝ փաստաթուղթը լուսանկարելու համար", $2e = "Փաստաթուղթը լուսանկարեք բջջային սարքի տեսախցիկի օգնությամբ կամ բեռնեք այն պատկերադարանից", G2e = "Պատկերադարանից ընտրեք փաստաթուղթը և բեռնեք այն", Z2e = "Պատկերադարան", j2e = "Ֆայլեր", z2e = "Վերադարձեք համակարգչի մոտ", q2e = "Ձեր փաստաթուղթը տեսագրված է", W2e = "կամ", Y2e = "Սեղմեք այստեղ՝ դիտարկիչում շարունակելու համար", K2e = {
  preparingCamera: s2e,
  timeout: l2e,
  noFocus: c2e,
  somethingWentWrong: u2e,
  incorrectCameraId: f2e,
  done: d2e,
  cameraUnavailable: p2e,
  versionNotSupported: h2e,
  httpNotSupported: _2e,
  insecurePageContext: m2e,
  badLicense: E2e,
  fileCorrupt: C2e,
  largeFile: S2e,
  placeDocumentIntoFrame: I2e,
  holdDocumentStraight: v2e,
  glaresOnDocument: g2e,
  tryAgain: R2e,
  noCameraAvailable: D2e,
  positionDocumentCenter: A2e,
  uploadPhoto: T2e,
  moveCloser: O2e,
  keepDeviceStill: y2e,
  camera: N2e,
  switchToMobile: L2e,
  openPhoneCamera: M2e,
  pleaseWait: P2e,
  mobileDevice: b2e,
  verifyYourIdentity: w2e,
  fromCameraFilesMobileDesktop: H2e,
  fromCameraFilesDesktop: V2e,
  fromCameraMobileDesktop: k2e,
  fromFilesMobileDesktop: F2e,
  fromCameraDesktop: U2e,
  fromFilesDesktop: x2e,
  fromMobileDesktop: B2e,
  fromCameraGalleryMobile: $2e,
  fromGalleryMobile: G2e,
  gallery: Z2e,
  files: j2e,
  returnToComputer: z2e,
  documentCaptured: q2e,
  or: W2e,
  continueInBrowser: Y2e
}, X2e = "Камера даярдалууда...", Q2e = "Тайм-аут", J2e = "Камеранын фокусу жок", ece = "Бир жерден ката кетти", tce = "Көрсөтүлгөн ID менен камера табылган жок.", rce = "Даяр!", nce = "Камера жеткиликтүү эмес!", ice = "Сиздин браузердин версиясы колдоого алынбайт", ace = "HTTPS колдонулбайт", oce = "Коопсуз контекст", sce = "Лицензия табылган жок же жараксыз", lce = "Файл бузулган же колдоого алынбайт", cce = "Жүктөлүп берилген файлдын өлчөмү өтө чоң", uce = "Документти алкакка жайгаштырыңыз:", fce = "Документти түз кармаңыз", dce = "Документиңизде жаркырап калбаңыз", pce = "Кайра аракет кылып көрүңүз", hce = "Камера жок", _ce = "Документти борборго коюңуз", mce = "Сүрөт жүктөө", Ece = "Жакыныраак жылыңыз", Cce = "Түзмөктү кыймылдатпаңыз", Sce = "Камера", Ice = "Мобилдик түзмөккө өтүңүз", vce = "Мобилдик түзмөгүңүздүн камерасын ачып, QR кодун сканерлеп, шилтемени басыңыз", gce = "Сураныч, күтө туруңуз...", Rce = "Мобилдик түзмөк", Dce = "Өздүгүн тастыктаган документти текшерүү", Ace = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз, файлдардан жүктөңүз же мобилдик түзмөгүңүздөн сканерлеңиз", Tce = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз же файлдардан жүктөңүз", Oce = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз же мобилдик түзмөгүңүздөн сканерлеңиз", yce = "Документти файлдардан жүктөө же мобилдик түзмөктөн сканерлөө", Nce = "Документти сүрөткө тартуу үчүн компьютериңиздин камерасын колдонуңуз", Lce = "Файлдардан документти тандап, жүктөңүз", Mce = "Документти сүрөткө тартуу үчүн мобилдик түзмөгүңүздүн камерасын колдонуңуз", Pce = "Мобилдик түзмөгүңүздүн камерасы менен документтин сүрөтүн тартыңыз же галереяңыздан жүктөңүз", bce = "Галереядан документти тандап, жүктөңүз", wce = "Галерея", Hce = "Файлдар", Vce = "Компьютерге кайтыңыз", kce = "Документиңиз алынды", Fce = "же", Uce = "Браузерде улантуу үчүн бул жакты басыңыз.", xce = {
  preparingCamera: X2e,
  timeout: Q2e,
  noFocus: J2e,
  somethingWentWrong: ece,
  incorrectCameraId: tce,
  done: rce,
  cameraUnavailable: nce,
  versionNotSupported: ice,
  httpNotSupported: ace,
  insecurePageContext: oce,
  badLicense: sce,
  fileCorrupt: lce,
  largeFile: cce,
  placeDocumentIntoFrame: uce,
  holdDocumentStraight: fce,
  glaresOnDocument: dce,
  tryAgain: pce,
  noCameraAvailable: hce,
  positionDocumentCenter: _ce,
  uploadPhoto: mce,
  moveCloser: Ece,
  keepDeviceStill: Cce,
  camera: Sce,
  switchToMobile: Ice,
  openPhoneCamera: vce,
  pleaseWait: gce,
  mobileDevice: Rce,
  verifyYourIdentity: Dce,
  fromCameraFilesMobileDesktop: Ace,
  fromCameraFilesDesktop: Tce,
  fromCameraMobileDesktop: Oce,
  fromFilesMobileDesktop: yce,
  fromCameraDesktop: Nce,
  fromFilesDesktop: Lce,
  fromMobileDesktop: Mce,
  fromCameraGalleryMobile: Pce,
  fromGalleryMobile: bce,
  gallery: wce,
  files: Hce,
  returnToComputer: Vce,
  documentCaptured: kce,
  or: Fce,
  continueInBrowser: Uce
}, y8 = {
  ru: rk,
  en: zk,
  de: VF,
  pl: TU,
  it: mx,
  hu: oB,
  zh: KB,
  sk: x$,
  uk: LG,
  fr: IZ,
  es: uj,
  pt: ez,
  ar: Zz,
  nl: wq,
  id: DW,
  vi: hY,
  ko: iK,
  ms: WK,
  ro: FX,
  el: yQ,
  tr: CJ,
  ja: lee,
  cs: Qee,
  th: $te,
  hi: Pre,
  bn: gne,
  he: die,
  fi: rae,
  sv: zae,
  da: Voe,
  hr: Tse,
  no: mle,
  uz: o2e,
  hy: K2e,
  ky: xce
};
function y2(e, r, t) {
  return (r = Bce(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Bce(e) {
  var r = $ce(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function $ce(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const N2 = Gr.create("main");
class Gce extends HTMLElement {
  constructor() {
    super(), y2(this, "_root", eR.createRoot(this.attachShadow({
      mode: "open"
    }))), y2(this, "_mounted", !1), y2(this, "_translations", null), y2(this, "_settings", {});
  }
  static get observedAttributes() {
    return Object.values(vn);
  }
  onEvent(r) {
    const t = HR(zO, r);
    this.dispatchEvent(t), N2("Component event: ".concat(JSON.stringify(t.detail)));
  }
  attributeChangedCallback(r) {
    N2("Attribute change: ".concat(r));
    const t = this.getAttribute(r), a = bR(t), o = {
      [vn.locale]: () => t && (this._settings.locale = t),
      [vn.multiple]: () => {
        this._settings.multipleFileInput = a;
      },
      [vn.copyright]: () => {
        this._settings.copyright = a;
      },
      [vn.startScreen]: () => {
        this._settings.startScreen = a;
      },
      [vn.internalScenario]: () => t && (this._settings.internalScenario = t),
      [vn.multipageProcessing]: () => {
        this._settings.multipageProcessing = a;
      },
      [vn.cameraId]: () => t && (this._settings.cameraId = t),
      [vn.changeCamera]: () => {
        this._settings.changeCameraButton = a;
      },
      [vn.closeButton]: () => {
        this._settings.closeButton = a;
      },
      [vn.captureButton]: () => {
        this._settings.captureButton = a;
      }
    };
    o[r] && o[r](), this._mounted && this.render();
  }
  connectedCallback() {
    setTimeout(() => {
      N2("Component mounted"), this.render(), this._mounted = !0, this.onEvent({
        action: pt.ELEMENT_VISIBLE,
        data: null
      });
    });
  }
  set translations(r) {
    this._translations = r, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(r) {
    this._settings = $r(this._settings, r), this._mounted && this.render();
  }
  get settings() {
    return this._settings;
  }
  render() {
    this._root.render(/* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
      /* @__PURE__ */ Y.jsx("style", { nonce: this._settings.nonce, children: h8 + _8 + m8 + E8 + C8 + S8 + I8 + v8 + g8 + R8 + D8 + A8 + fV + dV + T8 + O8 }),
      /* @__PURE__ */ Y.jsx(uV, ke({ dictionaries: y8, onEvent: this.onEvent.bind(this), translations: this._translations }, this._settings))
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => this._root.unmount()), N2("Component disconnected"), Gr.saveLogs();
  }
}
function Zce(e) {
  let {
    onStatusChange: r,
    onCapture: t,
    onError: a,
    onClose: o
  } = e;
  const {
    onEvent: l,
    cameraId: c,
    startScreen: u,
    resolution: p,
    cameraMode: f,
    mirrorType: h
  } = ur(), C = oe.useRef(null), E = {
    width: (p == null ? void 0 : p.width) || ui.FULL_HD.width,
    height: (p == null ? void 0 : p.height) || ui.FULL_HD.height
  }, [m, S] = oe.useState(!1), [v, g] = oe.useState({
    videoElement: null,
    videoParams: {
      width: 0,
      height: 0
    },
    videoContainerParams: {
      width: 0,
      height: 0
    }
  }), [O, D] = oe.useState({
    videoStatus: Ft.PREPARING,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    },
    sortedDevices: null
  }), [R, T] = oe.useState(c), N = () => {
    var z;
    l({
      action: pt.PRESS_MIRRORING_BUTTON,
      data: null
    }), (z = C.current) === null || z === void 0 || z.changeMirror();
  }, b = () => {
    l({
      action: pt.CAMERA_PROCESS_CLOSED,
      data: null
    }), u && r(Ne.CHOOSE_INPUT_SOURCE);
  }, L = () => {
    if (l({
      action: pt.PRESS_CAPTURE_BUTTON,
      data: null
    }), !v.videoElement) return;
    const {
      raw: z,
      mimeType: q
    } = oc(v.videoElement, ba.BASE64);
    t([{
      raw: z,
      mimeType: q
    }]), r(Ne.SUCCESS);
  }, k = () => {
    if (!O.sortedDevices) return;
    l({
      action: pt.PRESS_CHANGE_CAMERA_BUTTON,
      data: null
    });
    const z = ph(O.sortedDevices, O.camera.deviceId);
    z && T(z);
  }, w = (z) => {
    a(new $t(z));
  }, V = () => {
    l({
      action: pt.VIDEO_STARTED,
      data: null
    });
  }, U = () => {
    l({
      action: pt.VIDEO_STOPPED,
      data: null
    });
  };
  return /* @__PURE__ */ Y.jsx(WR, { mirroring: m, onChangeMirroring: N, status: it.SNAPSHOT, videoStatusParams: O, onCameraSnapshot: L, onProcessClose: b, onClose: o, onChangeCamera: k, videoElementParams: v, children: /* @__PURE__ */ Y.jsx(GR, { onVideoSizeChange: g, onVideoStatusChange: D, resolution: E, onFailStatus: w, mode: f || fn.environment, cameraId: R, onVideoStarted: V, onVideoStopped: U, onMirroringChange: S, mirrorType: h, ref: C }) });
}
function op(e, r, t) {
  return (r = jce(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function jce(e) {
  var r = zce(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function zce(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class qce {
  constructor(r) {
    op(this, "mimeType", void 0), op(this, "raw", void 0), op(this, "extension", void 0), this.mimeType = r.split(";")[0].replace("data:", ""), this.extension = this.mimeType.split("/")[1], this.raw = r.substring(r.indexOf(",") + 1);
  }
}
function Wce(e) {
  return Oe(this, null, function* () {
    const r = [];
    for (let t = 0; t < e.length; t++) {
      const a = new Promise((o, l) => {
        const c = e.item(t);
        if (c) {
          const u = URL.createObjectURL(c), p = new Image();
          p.onload = () => {
            const f = new FileReader();
            f.readAsDataURL(c), f.onload = () => {
              if (typeof f.result == "string") {
                const {
                  raw: h,
                  mimeType: C
                } = new qce(f.result);
                o({
                  raw: h,
                  mimeType: C
                });
              } else
                l(new $t(rr.INCORRECT_FILE));
              URL.revokeObjectURL(u);
            }, f.onerror = () => l(new $t(rr.INCORRECT_FILE));
          }, p.src = u, p.onerror = () => l(new $t(rr.INCORRECT_FILE));
        }
      });
      r.push(a);
    }
    return r;
  });
}
function Yce(e) {
  let {
    onStatusChange: r,
    onCapture: t,
    images: a,
    onError: o
  } = e;
  const {
    onEvent: l
  } = ur(), [c, u] = oe.useState([]);
  return oe.useEffect(() => {
    a != null && a.length && !(c != null && c.length) && (l({
      action: pt.FILE_PROCESS_STARTED,
      data: null
    }), Wce(a).then((p) => {
      Promise.all(p).then((f) => {
        u(f);
      }).catch((f) => {
        o(f);
      });
    })), c.length && (t(c), r(Ne.SUCCESS));
  }, [a, c]), /* @__PURE__ */ Y.jsx(Js, {});
}
const Kce = (e, r, t) => e ? r ? t ? "fromCameraGalleryMobile" : "fromMobileDesktop" : t ? "fromGalleryMobile" : "" : r ? t ? "fromCameraFilesDesktop" : "fromCameraDesktop" : t ? "fromFilesDesktop" : "", Ai = {
  "verified-screen": "_verified-screen_evxkx_1",
  "error-screen": "_error-screen_evxkx_5",
  "camera-disabled-screen": "_camera-disabled-screen_evxkx_9"
};
function Xce(e) {
  let {
    direction: r
  } = e;
  const {
    onEvent: t,
    startScreen: a,
    fromCameraButton: o = !0,
    uploadFileButton: l = !0
  } = ur(), {
    translate: c
  } = oa.useLocalize(), [u, p] = oe.useState(a ? Ne.CHOOSE_INPUT_SOURCE : Ne.CAMERA_PROCESSING), [f, h] = oe.useState(null), [C, E] = oe.useState([{
    raw: "",
    mimeType: ""
  }]), m = (D) => {
    h(D), p(Ne.FILE_PROCESSING);
  }, S = () => {
    t({
      action: pt.PRESS_CAMERA_BUTTON,
      data: null
    }), p(Ne.CAMERA_PROCESSING);
  }, v = (D) => {
    const R = SR[D.type] || Ne.UNKNOWN_ERROR;
    p(R), t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.ERROR,
        reason: D.type
      }
    });
  }, g = () => {
    h(null), E([{
      raw: "",
      mimeType: ""
    }]), p(a ? Ne.CHOOSE_INPUT_SOURCE : Ne.CAMERA_PROCESSING), t({
      action: pt.PRESS_RETRY_BUTTON,
      data: null
    });
  }, O = () => {
    t({
      action: pt.CLOSE,
      data: null
    });
  };
  return oe.useEffect(() => {
    u === Ne.SUCCESS && t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.OK,
        response: C
      }
    });
  }, [u, C]), /* @__PURE__ */ Y.jsx(qD, { onError: v, supportedBrowserVersions: IR, children: /* @__PURE__ */ Y.jsx(Ch, { showHeaderAndFooter: u !== Ne.CAMERA_PROCESSING, onClose: O, direction: r, children: u === Ne.CHOOSE_INPUT_SOURCE ? /* @__PURE__ */ Y.jsx(ZD, { onStart: S, onFileImageSet: m, title: c("uploadPhoto"), subtitle: c(Kce(Kt.isMobile, o, l)) }) : u === Ne.CAMERA_PROCESSING ? /* @__PURE__ */ Y.jsx(Zce, { onStatusChange: p, onCapture: E, onClose: O, onError: v }) : u === Ne.FILE_PROCESSING ? /* @__PURE__ */ Y.jsx(Yce, { onStatusChange: p, onCapture: E, images: f, onError: v }) : u === Ne.SUCCESS ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["verified-screen"], title: c("done") }) : u === Ne.NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["error-screen"], title: c("versionNotSupported") }) : u === Ne.INCORRECT_FILE_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["error-screen"], title: c("fileCorrupt"), onReset: g }) : u === Ne.CAMERA_PERMISSION_DENIED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("cameraUnavailable") }) : u === Ne.HTTP_NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["error-screen"], title: c("httpNotSupported") }) : u === Ne.INSECURE_PAGE_CONTEXT_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["error-screen"], title: c("insecurePageContext") }) : u === Ne.NO_CAMERA_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("noCameraAvailable") }) : u === Ne.INCORRECT_CAMERA_ID_ERROR ? /* @__PURE__ */ Y.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("incorrectCameraId") }) : /* @__PURE__ */ Y.jsx(tr, { className: Ai["error-screen"], title: c("somethingWentWrong"), onReset: g }) }) });
}
const Qce = wR(zD, jD)(Xce), Jce = `._verified-screen_evxkx_1:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%235DA600'%20stroke-width='3'/%3e%3cpath%20d='M66%2030L40.5069%2054L28%2042.2256'%20stroke='%235DA600'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._error-screen_evxkx_5:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M57%2028L29%2056M29%2028L57%2056'%20stroke='%23FF0000'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._camera-disabled-screen_evxkx_9:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='37'%20stroke='%23FF5E5E'%20stroke-width='3'/%3e%3cpath%20d='M40.213%2030.6667H44.6663C45.3736%2030.6667%2046.0519%2030.9476%2046.552%2031.4477C47.0521%2031.9478%2047.333%2032.6261%2047.333%2033.3334V37.7867L48.6663%2038.12L56.6663%2033.3334V46.6667M47.333%2045.3334V46.6667C47.333%2047.3739%2047.0521%2048.0522%2046.552%2048.5523C46.0519%2049.0524%2045.3736%2049.3334%2044.6663%2049.3334H29.9997C29.2924%2049.3334%2028.6142%2049.0524%2028.1141%2048.5523C27.614%2048.0522%2027.333%2047.3739%2027.333%2046.6667V33.3334C27.333%2032.6261%2027.614%2031.9478%2028.1141%2031.4477C28.6142%2030.9476%2029.2924%2030.6667%2029.9997%2030.6667H32.6663L47.333%2045.3334Z'%20stroke='%23FF5E5E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M27.333%2025.3333L56.6663%2054.6666'%20stroke='%23FF5E5E'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`;
function L2(e, r, t) {
  return (r = eue(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function eue(e) {
  var r = tue(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function tue(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const rue = Gr.create("main");
class nue extends HTMLElement {
  constructor() {
    super(), L2(this, "_root", eR.createRoot(this.attachShadow({
      mode: "open"
    }))), L2(this, "_mounted", !1), L2(this, "_translations", null), L2(this, "_settings", {});
  }
  static get observedAttributes() {
    return Object.values(Ti);
  }
  onEvent(r) {
    const t = HR(qO, r);
    this.dispatchEvent(t), rue("Component event: ".concat(JSON.stringify(t.detail)));
  }
  attributeChangedCallback(r) {
    const t = this.getAttribute(r), a = bR(t), o = {
      [Ti.locale]: () => t && (this._settings.locale = t),
      [Ti.multiple]: () => {
        this._settings.multipleFileInput = a;
      },
      [Ti.copyright]: () => {
        this._settings.copyright = a;
      },
      [Ti.startScreen]: () => {
        this._settings.startScreen = a;
      },
      [Ti.cameraId]: () => t && (this._settings.cameraId = t),
      [Ti.changeCamera]: () => {
        this._settings.changeCameraButton = a;
      },
      [Ti.closeButton]: () => {
        this._settings.closeButton = a;
      }
    };
    o[r] && o[r](), this._mounted && this.render();
  }
  connectedCallback() {
    setTimeout(() => {
      this.render(), this._mounted = !0, this.onEvent({
        action: pt.ELEMENT_VISIBLE,
        data: null
      });
    });
  }
  set translations(r) {
    this._translations = r, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(r) {
    this._settings = $r(this._settings, r), this._mounted && this.render();
  }
  get settings() {
    return this._settings;
  }
  render() {
    this._root.render(/* @__PURE__ */ Y.jsxs(Y.Fragment, { children: [
      /* @__PURE__ */ Y.jsx("style", { nonce: this._settings.nonce, children: h8 + _8 + m8 + E8 + C8 + S8 + I8 + v8 + g8 + R8 + D8 + A8 + Jce + T8 + O8 }),
      /* @__PURE__ */ Y.jsx(Qce, ke({ dictionaries: y8, onEvent: this.onEvent.bind(this), translations: this._translations }, this._settings))
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => this._root.unmount()), Gr.saveLogs();
  }
}
function iue(e, r, t) {
  return (r = aue(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function aue(e) {
  var r = oue(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function oue(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class sue extends HTMLElement {
  constructor() {
    super(), iue(this, "_root", void 0), this._root = this.attachShadow({
      mode: "open"
    }), this._root.innerHTML = `
            <style>
            *, *::before, *::after {
                box-sizing: border-box;
            }
            :host {
                display: block;
                position: fixed;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                overflow: auto;
                z-index: 100;
            }
            </style>
            <slot />
        `;
  }
}
var Pp = function(e, r) {
  return Pp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, a) {
    t.__proto__ = a;
  } || function(t, a) {
    for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
  }, Pp(e, r);
};
function sl(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  Pp(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
function lue(e, r, t, a) {
  function o(l) {
    return l instanceof t ? l : new t(function(c) {
      c(l);
    });
  }
  return new (t || (t = Promise))(function(l, c) {
    function u(h) {
      try {
        f(a.next(h));
      } catch (C) {
        c(C);
      }
    }
    function p(h) {
      try {
        f(a.throw(h));
      } catch (C) {
        c(C);
      }
    }
    function f(h) {
      h.done ? l(h.value) : o(h.value).then(u, p);
    }
    f((a = a.apply(e, r || [])).next());
  });
}
function N8(e, r) {
  var t = { label: 0, sent: function() {
    if (l[0] & 1) throw l[1];
    return l[1];
  }, trys: [], ops: [] }, a, o, l, c = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return c.next = u(0), c.throw = u(1), c.return = u(2), typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(f) {
    return function(h) {
      return p([f, h]);
    };
  }
  function p(f) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, f[0] && (t = 0)), t; ) try {
      if (a = 1, o && (l = f[0] & 2 ? o.return : f[0] ? o.throw || ((l = o.return) && l.call(o), 0) : o.next) && !(l = l.call(o, f[1])).done) return l;
      switch (o = 0, l && (f = [f[0] & 2, l.value]), f[0]) {
        case 0:
        case 1:
          l = f;
          break;
        case 4:
          return t.label++, { value: f[1], done: !1 };
        case 5:
          t.label++, o = f[1], f = [0];
          continue;
        case 7:
          f = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (l = t.trys, !(l = l.length > 0 && l[l.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            t = 0;
            continue;
          }
          if (f[0] === 3 && (!l || f[1] > l[0] && f[1] < l[3])) {
            t.label = f[1];
            break;
          }
          if (f[0] === 6 && t.label < l[1]) {
            t.label = l[1], l = f;
            break;
          }
          if (l && t.label < l[2]) {
            t.label = l[2], t.ops.push(f);
            break;
          }
          l[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      f = r.call(e, t);
    } catch (h) {
      f = [6, h], o = 0;
    } finally {
      a = l = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function wo(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], a = 0;
  if (t) return t.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && a >= e.length && (e = void 0), { value: e && e[a++], done: !e };
    }
  };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function bp(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var a = t.call(e), o, l = [], c;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = a.next()).done; ) l.push(o.value);
  } catch (u) {
    c = { error: u };
  } finally {
    try {
      o && !o.done && (t = a.return) && t.call(a);
    } finally {
      if (c) throw c.error;
    }
  }
  return l;
}
function wp(e, r, t) {
  if (t || arguments.length === 2) for (var a = 0, o = r.length, l; a < o; a++)
    (l || !(a in r)) && (l || (l = Array.prototype.slice.call(r, 0, a)), l[a] = r[a]);
  return e.concat(l || Array.prototype.slice.call(r));
}
function Mo(e) {
  return this instanceof Mo ? (this.v = e, this) : new Mo(e);
}
function cue(e, r, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = t.apply(e, r || []), o, l = [];
  return o = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), u("next"), u("throw"), u("return", c), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function c(m) {
    return function(S) {
      return Promise.resolve(S).then(m, C);
    };
  }
  function u(m, S) {
    a[m] && (o[m] = function(v) {
      return new Promise(function(g, O) {
        l.push([m, v, g, O]) > 1 || p(m, v);
      });
    }, S && (o[m] = S(o[m])));
  }
  function p(m, S) {
    try {
      f(a[m](S));
    } catch (v) {
      E(l[0][3], v);
    }
  }
  function f(m) {
    m.value instanceof Mo ? Promise.resolve(m.value.v).then(h, C) : E(l[0][2], m);
  }
  function h(m) {
    p("next", m);
  }
  function C(m) {
    p("throw", m);
  }
  function E(m, S) {
    m(S), l.shift(), l.length && p(l[0][0], l[0][1]);
  }
}
function uue(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = e[Symbol.asyncIterator], t;
  return r ? r.call(e) : (e = typeof wo == "function" ? wo(e) : e[Symbol.iterator](), t = {}, a("next"), a("throw"), a("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function a(l) {
    t[l] = e[l] && function(c) {
      return new Promise(function(u, p) {
        c = e[l](c), o(u, p, c.done, c.value);
      });
    };
  }
  function o(l, c, u, p) {
    Promise.resolve(p).then(function(f) {
      l({ value: f, done: u });
    }, c);
  }
}
function hr(e) {
  return typeof e == "function";
}
function L8(e) {
  var r = function(a) {
    Error.call(a), a.stack = new Error().stack;
  }, t = e(r);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var sp = L8(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(a, o) {
      return o + 1 + ") " + a.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function Hp(e, r) {
  if (e) {
    var t = e.indexOf(r);
    0 <= t && e.splice(t, 1);
  }
}
var Sc = function() {
  function e(r) {
    this.initialTeardown = r, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var r, t, a, o, l;
    if (!this.closed) {
      this.closed = !0;
      var c = this._parentage;
      if (c)
        if (this._parentage = null, Array.isArray(c))
          try {
            for (var u = wo(c), p = u.next(); !p.done; p = u.next()) {
              var f = p.value;
              f.remove(this);
            }
          } catch (v) {
            r = { error: v };
          } finally {
            try {
              p && !p.done && (t = u.return) && t.call(u);
            } finally {
              if (r) throw r.error;
            }
          }
        else
          c.remove(this);
      var h = this.initialTeardown;
      if (hr(h))
        try {
          h();
        } catch (v) {
          l = v instanceof sp ? v.errors : [v];
        }
      var C = this._finalizers;
      if (C) {
        this._finalizers = null;
        try {
          for (var E = wo(C), m = E.next(); !m.done; m = E.next()) {
            var S = m.value;
            try {
              bg(S);
            } catch (v) {
              l = l != null ? l : [], v instanceof sp ? l = wp(wp([], bp(l)), bp(v.errors)) : l.push(v);
            }
          }
        } catch (v) {
          a = { error: v };
        } finally {
          try {
            m && !m.done && (o = E.return) && o.call(E);
          } finally {
            if (a) throw a.error;
          }
        }
      }
      if (l)
        throw new sp(l);
    }
  }, e.prototype.add = function(r) {
    var t;
    if (r && r !== this)
      if (this.closed)
        bg(r);
      else {
        if (r instanceof e) {
          if (r.closed || r._hasParent(this))
            return;
          r._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(r);
      }
  }, e.prototype._hasParent = function(r) {
    var t = this._parentage;
    return t === r || Array.isArray(t) && t.includes(r);
  }, e.prototype._addParent = function(r) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(r), t) : t ? [t, r] : r;
  }, e.prototype._removeParent = function(r) {
    var t = this._parentage;
    t === r ? this._parentage = null : Array.isArray(t) && Hp(t, r);
  }, e.prototype.remove = function(r) {
    var t = this._finalizers;
    t && Hp(t, r), r instanceof e && r._removeParent(this);
  }, e.EMPTY = function() {
    var r = new e();
    return r.closed = !0, r;
  }(), e;
}(), M8 = Sc.EMPTY;
function P8(e) {
  return e instanceof Sc || e && "closed" in e && hr(e.remove) && hr(e.add) && hr(e.unsubscribe);
}
function bg(e) {
  hr(e) ? e() : e.unsubscribe();
}
var fue = {
  Promise: void 0
}, due = {
  setTimeout: function(e, r) {
    for (var t = [], a = 2; a < arguments.length; a++)
      t[a - 2] = arguments[a];
    return setTimeout.apply(void 0, wp([e, r], bp(t)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function b8(e) {
  due.setTimeout(function() {
    throw e;
  });
}
function wg() {
}
function U2(e) {
  e();
}
var bh = function(e) {
  sl(r, e);
  function r(t) {
    var a = e.call(this) || this;
    return a.isStopped = !1, t ? (a.destination = t, P8(t) && t.add(a)) : a.destination = _ue, a;
  }
  return r.create = function(t, a, o) {
    return new Vp(t, a, o);
  }, r.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, r.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, r.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, r.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, r.prototype._next = function(t) {
    this.destination.next(t);
  }, r.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, r.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, r;
}(Sc), pue = function() {
  function e(r) {
    this.partialObserver = r;
  }
  return e.prototype.next = function(r) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(r);
      } catch (a) {
        M2(a);
      }
  }, e.prototype.error = function(r) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(r);
      } catch (a) {
        M2(a);
      }
    else
      M2(r);
  }, e.prototype.complete = function() {
    var r = this.partialObserver;
    if (r.complete)
      try {
        r.complete();
      } catch (t) {
        M2(t);
      }
  }, e;
}(), Vp = function(e) {
  sl(r, e);
  function r(t, a, o) {
    var l = e.call(this) || this, c;
    return hr(t) || !t ? c = {
      next: t != null ? t : void 0,
      error: a != null ? a : void 0,
      complete: o != null ? o : void 0
    } : c = t, l.destination = new pue(c), l;
  }
  return r;
}(bh);
function M2(e) {
  b8(e);
}
function hue(e) {
  throw e;
}
var _ue = {
  closed: !0,
  next: wg,
  error: hue,
  complete: wg
}, wh = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function mue(e) {
  return e;
}
function Eue(e) {
  return e.length === 0 ? mue : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(a, o) {
      return o(a);
    }, t);
  };
}
var $n = function() {
  function e(r) {
    r && (this._subscribe = r);
  }
  return e.prototype.lift = function(r) {
    var t = new e();
    return t.source = this, t.operator = r, t;
  }, e.prototype.subscribe = function(r, t, a) {
    var o = this, l = Sue(r) ? r : new Vp(r, t, a);
    return U2(function() {
      var c = o, u = c.operator, p = c.source;
      l.add(u ? u.call(l, p) : p ? o._subscribe(l) : o._trySubscribe(l));
    }), l;
  }, e.prototype._trySubscribe = function(r) {
    try {
      return this._subscribe(r);
    } catch (t) {
      r.error(t);
    }
  }, e.prototype.forEach = function(r, t) {
    var a = this;
    return t = Hg(t), new t(function(o, l) {
      var c = new Vp({
        next: function(u) {
          try {
            r(u);
          } catch (p) {
            l(p), c.unsubscribe();
          }
        },
        error: l,
        complete: o
      });
      a.subscribe(c);
    });
  }, e.prototype._subscribe = function(r) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(r);
  }, e.prototype[wh] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var r = [], t = 0; t < arguments.length; t++)
      r[t] = arguments[t];
    return Eue(r)(this);
  }, e.prototype.toPromise = function(r) {
    var t = this;
    return r = Hg(r), new r(function(a, o) {
      var l;
      t.subscribe(function(c) {
        return l = c;
      }, function(c) {
        return o(c);
      }, function() {
        return a(l);
      });
    });
  }, e.create = function(r) {
    return new e(r);
  }, e;
}();
function Hg(e) {
  var r;
  return (r = e != null ? e : fue.Promise) !== null && r !== void 0 ? r : Promise;
}
function Cue(e) {
  return e && hr(e.next) && hr(e.error) && hr(e.complete);
}
function Sue(e) {
  return e && e instanceof bh || Cue(e) && P8(e);
}
function Iue(e) {
  return hr(e == null ? void 0 : e.lift);
}
function ll(e) {
  return function(r) {
    if (Iue(r))
      return r.lift(function(t) {
        try {
          return e(t, this);
        } catch (a) {
          this.error(a);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function $s(e, r, t, a, o) {
  return new vue(e, r, t, a, o);
}
var vue = function(e) {
  sl(r, e);
  function r(t, a, o, l, c, u) {
    var p = e.call(this, t) || this;
    return p.onFinalize = c, p.shouldUnsubscribe = u, p._next = a ? function(f) {
      try {
        a(f);
      } catch (h) {
        t.error(h);
      }
    } : e.prototype._next, p._error = l ? function(f) {
      try {
        l(f);
      } catch (h) {
        t.error(h);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, p._complete = o ? function() {
      try {
        o();
      } catch (f) {
        t.error(f);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, p;
  }
  return r.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var a = this.closed;
      e.prototype.unsubscribe.call(this), !a && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, r;
}(bh), gue = L8(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), w8 = function(e) {
  sl(r, e);
  function r() {
    var t = e.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return r.prototype.lift = function(t) {
    var a = new Vg(this, this);
    return a.operator = t, a;
  }, r.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new gue();
  }, r.prototype.next = function(t) {
    var a = this;
    U2(function() {
      var o, l;
      if (a._throwIfClosed(), !a.isStopped) {
        a.currentObservers || (a.currentObservers = Array.from(a.observers));
        try {
          for (var c = wo(a.currentObservers), u = c.next(); !u.done; u = c.next()) {
            var p = u.value;
            p.next(t);
          }
        } catch (f) {
          o = { error: f };
        } finally {
          try {
            u && !u.done && (l = c.return) && l.call(c);
          } finally {
            if (o) throw o.error;
          }
        }
      }
    });
  }, r.prototype.error = function(t) {
    var a = this;
    U2(function() {
      if (a._throwIfClosed(), !a.isStopped) {
        a.hasError = a.isStopped = !0, a.thrownError = t;
        for (var o = a.observers; o.length; )
          o.shift().error(t);
      }
    });
  }, r.prototype.complete = function() {
    var t = this;
    U2(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var a = t.observers; a.length; )
          a.shift().complete();
      }
    });
  }, r.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(r.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), r.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, t);
  }, r.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, r.prototype._innerSubscribe = function(t) {
    var a = this, o = this, l = o.hasError, c = o.isStopped, u = o.observers;
    return l || c ? M8 : (this.currentObservers = null, u.push(t), new Sc(function() {
      a.currentObservers = null, Hp(u, t);
    }));
  }, r.prototype._checkFinalizedStatuses = function(t) {
    var a = this, o = a.hasError, l = a.thrownError, c = a.isStopped;
    o ? t.error(l) : c && t.complete();
  }, r.prototype.asObservable = function() {
    var t = new $n();
    return t.source = this, t;
  }, r.create = function(t, a) {
    return new Vg(t, a);
  }, r;
}($n), Vg = function(e) {
  sl(r, e);
  function r(t, a) {
    var o = e.call(this) || this;
    return o.destination = t, o.source = a, o;
  }
  return r.prototype.next = function(t) {
    var a, o;
    (o = (a = this.destination) === null || a === void 0 ? void 0 : a.next) === null || o === void 0 || o.call(a, t);
  }, r.prototype.error = function(t) {
    var a, o;
    (o = (a = this.destination) === null || a === void 0 ? void 0 : a.error) === null || o === void 0 || o.call(a, t);
  }, r.prototype.complete = function() {
    var t, a;
    (a = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || a === void 0 || a.call(t);
  }, r.prototype._subscribe = function(t) {
    var a, o;
    return (o = (a = this.source) === null || a === void 0 ? void 0 : a.subscribe(t)) !== null && o !== void 0 ? o : M8;
  }, r;
}(w8), H8 = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function V8(e) {
  return hr(e == null ? void 0 : e.then);
}
function k8(e) {
  return hr(e[wh]);
}
function F8(e) {
  return Symbol.asyncIterator && hr(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function U8(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Rue() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var x8 = Rue();
function B8(e) {
  return hr(e == null ? void 0 : e[x8]);
}
function $8(e) {
  return cue(this, arguments, function() {
    var t, a, o, l;
    return N8(this, function(c) {
      switch (c.label) {
        case 0:
          t = e.getReader(), c.label = 1;
        case 1:
          c.trys.push([1, , 9, 10]), c.label = 2;
        case 2:
          return [4, Mo(t.read())];
        case 3:
          return a = c.sent(), o = a.value, l = a.done, l ? [4, Mo(void 0)] : [3, 5];
        case 4:
          return [2, c.sent()];
        case 5:
          return [4, Mo(o)];
        case 6:
          return [4, c.sent()];
        case 7:
          return c.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function G8(e) {
  return hr(e == null ? void 0 : e.getReader);
}
function Go(e) {
  if (e instanceof $n)
    return e;
  if (e != null) {
    if (k8(e))
      return Due(e);
    if (H8(e))
      return Aue(e);
    if (V8(e))
      return Tue(e);
    if (F8(e))
      return Z8(e);
    if (B8(e))
      return Oue(e);
    if (G8(e))
      return yue(e);
  }
  throw U8(e);
}
function Due(e) {
  return new $n(function(r) {
    var t = e[wh]();
    if (hr(t.subscribe))
      return t.subscribe(r);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Aue(e) {
  return new $n(function(r) {
    for (var t = 0; t < e.length && !r.closed; t++)
      r.next(e[t]);
    r.complete();
  });
}
function Tue(e) {
  return new $n(function(r) {
    e.then(function(t) {
      r.closed || (r.next(t), r.complete());
    }, function(t) {
      return r.error(t);
    }).then(null, b8);
  });
}
function Oue(e) {
  return new $n(function(r) {
    var t, a;
    try {
      for (var o = wo(e), l = o.next(); !l.done; l = o.next()) {
        var c = l.value;
        if (r.next(c), r.closed)
          return;
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        l && !l.done && (a = o.return) && a.call(o);
      } finally {
        if (t) throw t.error;
      }
    }
    r.complete();
  });
}
function Z8(e) {
  return new $n(function(r) {
    Nue(e, r).catch(function(t) {
      return r.error(t);
    });
  });
}
function yue(e) {
  return Z8($8(e));
}
function Nue(e, r) {
  var t, a, o, l;
  return lue(this, void 0, void 0, function() {
    var c, u;
    return N8(this, function(p) {
      switch (p.label) {
        case 0:
          p.trys.push([0, 5, 6, 11]), t = uue(e), p.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (a = p.sent(), !!a.done) return [3, 4];
          if (c = a.value, r.next(c), r.closed)
            return [2];
          p.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return u = p.sent(), o = { error: u }, [3, 11];
        case 6:
          return p.trys.push([6, , 9, 10]), a && !a.done && (l = t.return) ? [4, l.call(t)] : [3, 8];
        case 7:
          p.sent(), p.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (o) throw o.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return r.complete(), [2];
      }
    });
  });
}
function Pa(e, r, t, a, o) {
  a === void 0 && (a = 0), o === void 0 && (o = !1);
  var l = r.schedule(function() {
    t(), o ? e.add(this.schedule(null, a)) : this.unsubscribe();
  }, a);
  if (e.add(l), !o)
    return l;
}
function j8(e, r) {
  return r === void 0 && (r = 0), ll(function(t, a) {
    t.subscribe($s(a, function(o) {
      return Pa(a, e, function() {
        return a.next(o);
      }, r);
    }, function() {
      return Pa(a, e, function() {
        return a.complete();
      }, r);
    }, function(o) {
      return Pa(a, e, function() {
        return a.error(o);
      }, r);
    }));
  });
}
function z8(e, r) {
  return r === void 0 && (r = 0), ll(function(t, a) {
    a.add(e.schedule(function() {
      return t.subscribe(a);
    }, r));
  });
}
function Lue(e, r) {
  return Go(e).pipe(z8(r), j8(r));
}
function Mue(e, r) {
  return Go(e).pipe(z8(r), j8(r));
}
function Pue(e, r) {
  return new $n(function(t) {
    var a = 0;
    return r.schedule(function() {
      a === e.length ? t.complete() : (t.next(e[a++]), t.closed || this.schedule());
    });
  });
}
function bue(e, r) {
  return new $n(function(t) {
    var a;
    return Pa(t, r, function() {
      a = e[x8](), Pa(t, r, function() {
        var o, l, c;
        try {
          o = a.next(), l = o.value, c = o.done;
        } catch (u) {
          t.error(u);
          return;
        }
        c ? t.complete() : t.next(l);
      }, 0, !0);
    }), function() {
      return hr(a == null ? void 0 : a.return) && a.return();
    };
  });
}
function q8(e, r) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new $n(function(t) {
    Pa(t, r, function() {
      var a = e[Symbol.asyncIterator]();
      Pa(t, r, function() {
        a.next().then(function(o) {
          o.done ? t.complete() : t.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function wue(e, r) {
  return q8($8(e), r);
}
function Hue(e, r) {
  if (e != null) {
    if (k8(e))
      return Lue(e, r);
    if (H8(e))
      return Pue(e, r);
    if (V8(e))
      return Mue(e, r);
    if (F8(e))
      return q8(e, r);
    if (B8(e))
      return bue(e, r);
    if (G8(e))
      return wue(e, r);
  }
  throw U8(e);
}
function kg(e, r) {
  return r ? Hue(e, r) : Go(e);
}
function Vue(e, r) {
  return ll(function(t, a) {
    var o = 0;
    t.subscribe($s(a, function(l) {
      a.next(e.call(r, l, o++));
    }));
  });
}
function kue(e, r, t, a, o, l, c, u) {
  var p = [], f = 0, h = 0, C = !1, E = function() {
    C && !p.length && !f && r.complete();
  }, m = function(v) {
    return f < a ? S(v) : p.push(v);
  }, S = function(v) {
    f++;
    var g = !1;
    Go(t(v, h++)).subscribe($s(r, function(O) {
      r.next(O);
    }, function() {
      g = !0;
    }, void 0, function() {
      if (g)
        try {
          f--;
          for (var O = function() {
            var D = p.shift();
            c || S(D);
          }; p.length && f < a; )
            O();
          E();
        } catch (D) {
          r.error(D);
        }
    }));
  };
  return e.subscribe($s(r, m, function() {
    C = !0, E();
  })), function() {
  };
}
function kp(e, r, t) {
  return t === void 0 && (t = 1 / 0), hr(r) ? kp(function(a, o) {
    return Vue(function(l, c) {
      return r(a, l, o, c);
    })(Go(e(a, o)));
  }, t) : (typeof r == "number" && (t = r), ll(function(a, o) {
    return kue(a, o, e, t);
  }));
}
function W8(e) {
  return ll(function(r, t) {
    var a = null, o = !1, l;
    a = r.subscribe($s(t, void 0, void 0, function(c) {
      l = Go(e(c, W8(e)(r))), a ? (a.unsubscribe(), a = null, l.subscribe(t)) : o = !0;
    })), o && (a.unsubscribe(), a = null, l.subscribe(t));
  });
}
function Fue(e, r) {
  return hr(r) ? kp(e, r, 1) : kp(e, 1);
}
function Uue(e, r, t) {
  return (r = xue(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function xue(e) {
  var r = Bue(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Bue(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class $ue {
  constructor() {
    Uue(this, "taskSubject", new w8()), this.taskSubject.pipe(Fue((r) => kg(r()).pipe(W8((t) => kg(Promise.reject(t)))))).subscribe();
  }
  addTask(r) {
    return new Promise((t, a) => {
      this.taskSubject.next(() => Oe(this, null, function* () {
        try {
          const o = yield r();
          t(o);
        } catch (o) {
          a(o);
        }
      }));
    });
  }
}
const Gue = "text/plain", Zue = "us-ascii", lp = (e, r) => r.some((t) => t instanceof RegExp ? t.test(e) : t === e), jue = /* @__PURE__ */ new Set([
  "https:",
  "http:",
  "file:"
]), zue = (e) => {
  try {
    const { protocol: r } = new URL(e);
    return r.endsWith(":") && !r.includes(".") && !jue.has(r);
  } catch (r) {
    return !1;
  }
}, que = (e, { stripHash: r }) => {
  var C, E;
  const t = new RegExp("^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$").exec(e);
  if (!t)
    throw new Error(`Invalid URL: ${e}`);
  let { type: a, data: o, hash: l } = t.groups;
  const c = a.split(";");
  l = r ? "" : l;
  let u = !1;
  c[c.length - 1] === "base64" && (c.pop(), u = !0);
  const p = (E = (C = c.shift()) == null ? void 0 : C.toLowerCase()) != null ? E : "", h = [
    ...c.map((m) => {
      let [S, v = ""] = m.split("=").map((g) => g.trim());
      return S === "charset" && (v = v.toLowerCase(), v === Zue) ? "" : `${S}${v ? `=${v}` : ""}`;
    }).filter(Boolean)
  ];
  return u && h.push("base64"), (h.length > 0 || p && p !== Gue) && h.unshift(p), `data:${h.join(";")},${u ? o.trim() : o}${l ? `#${l}` : ""}`;
};
function Wue(e, r) {
  if (r = ke({
    defaultProtocol: "http",
    normalizeProtocol: !0,
    forceHttp: !1,
    forceHttps: !1,
    stripAuthentication: !0,
    stripHash: !1,
    stripTextFragment: !0,
    stripWWW: !0,
    removeQueryParameters: [/^utm_\w+/i],
    removeTrailingSlash: !0,
    removeSingleSlash: !0,
    removeDirectoryIndex: !1,
    removeExplicitPort: !1,
    sortQueryParameters: !0
  }, r), typeof r.defaultProtocol == "string" && !r.defaultProtocol.endsWith(":") && (r.defaultProtocol = `${r.defaultProtocol}:`), e = e.trim(), /^data:/i.test(e))
    return que(e, r);
  if (zue(e))
    return e;
  const t = e.startsWith("//");
  !t && /^\.*\//.test(e) || (e = e.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, r.defaultProtocol));
  const o = new URL(e);
  if (r.forceHttp && r.forceHttps)
    throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
  if (r.forceHttp && o.protocol === "https:" && (o.protocol = "http:"), r.forceHttps && o.protocol === "http:" && (o.protocol = "https:"), r.stripAuthentication && (o.username = "", o.password = ""), r.stripHash ? o.hash = "" : r.stripTextFragment && (o.hash = o.hash.replace(/#?:~:text.*?$/i, "")), o.pathname) {
    const c = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g;
    let u = 0, p = "";
    for (; ; ) {
      const h = c.exec(o.pathname);
      if (!h)
        break;
      const C = h[0], E = h.index, m = o.pathname.slice(u, E);
      p += m.replace(/\/{2,}/g, "/"), p += C, u = E + C.length;
    }
    const f = o.pathname.slice(u, o.pathname.length);
    p += f.replace(/\/{2,}/g, "/"), o.pathname = p;
  }
  if (o.pathname)
    try {
      o.pathname = decodeURI(o.pathname).replace(/\\/g, "%5C");
    } catch (c) {
    }
  if (r.removeDirectoryIndex === !0 && (r.removeDirectoryIndex = [/^index\.[a-z]+$/]), Array.isArray(r.removeDirectoryIndex) && r.removeDirectoryIndex.length > 0) {
    let c = o.pathname.split("/");
    const u = c[c.length - 1];
    lp(u, r.removeDirectoryIndex) && (c = c.slice(0, -1), o.pathname = c.slice(1).join("/") + "/");
  }
  if (o.hostname && (o.hostname = o.hostname.replace(/\.$/, ""), r.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(o.hostname) && (o.hostname = o.hostname.replace(/^www\./, ""))), Array.isArray(r.removeQueryParameters))
    for (const c of [...o.searchParams.keys()])
      lp(c, r.removeQueryParameters) && o.searchParams.delete(c);
  if (!Array.isArray(r.keepQueryParameters) && r.removeQueryParameters === !0 && (o.search = ""), Array.isArray(r.keepQueryParameters) && r.keepQueryParameters.length > 0)
    for (const c of [...o.searchParams.keys()])
      lp(c, r.keepQueryParameters) || o.searchParams.delete(c);
  if (r.sortQueryParameters) {
    o.searchParams.sort();
    try {
      o.search = decodeURIComponent(o.search);
    } catch (c) {
    }
  }
  r.removeTrailingSlash && (o.pathname = o.pathname.replace(/\/$/, "")), r.removeExplicitPort && o.port && (o.port = "");
  const l = e;
  return e = o.toString(), !r.removeSingleSlash && o.pathname === "/" && !l.endsWith("/") && o.hash === "" && (e = e.replace(/\/$/, "")), (r.removeTrailingSlash || o.pathname === "/") && o.hash === "" && r.removeSingleSlash && (e = e.replace(/\/$/, "")), t && !r.normalizeProtocol && (e = e.replace(/^http:\/\//, "//")), r.stripProtocol && (e = e.replace(/^(?:https?:)?\/\//, "")), e;
}
function Fg(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function ta(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Fg(Object(t), !0).forEach(function(a) {
      Pr(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fg(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function Pr(e, r, t) {
  return (r = Yue(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Yue(e) {
  var r = Kue(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Kue(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const cp = Gr.create("wasm"), Sr = Gr.create("main");
class Xue {
  constructor() {
    Pr(this, "_worker", null), Pr(this, "_initializeListener", null), Pr(this, "_processingListener", null), Pr(this, "_queueService", new $ue()), Pr(this, "_initProcess", null), Pr(this, "version", {
      component: "8.3.2456".trim()
    }), Pr(this, "onFinalize", null), Pr(this, "isPrepared", !1), Pr(this, "isInitialized", !1), Pr(this, "isProcessing", !1), Pr(this, "initData", null), Pr(this, "recognizerProcessParam", {
      processParam: {}
    }), Pr(this, "imageProcessParam", {
      processParam: {}
    }), Pr(this, "recognizeListener", null), Pr(this, "workerPath", "https://wasm.regulaforensics.com/document/release/8.3/barcodemrz/f526ea12-07843559c");
  }
  get processingListener() {
    return this._processingListener;
  }
  set processingListener(r) {
    this._processingListener = r, r && r({
      isProcessing: this.isProcessing
    });
  }
  get initializeListener() {
    return this._initializeListener;
  }
  set initializeListener(r) {
    this._initializeListener = r, r && r({
      isInitialized: this.isInitialized
    });
  }
  createProcessImageRequest(r, t) {
    const a = r.map((o, l) => ({
      data: o,
      light: 6,
      pageIdx: l
    }));
    return ta(ta({}, t), {}, {
      imagesList: a
    });
  }
  prepareImageData(r) {
    return r.map((t) => t instanceof ImageData ? {
      width: t.width,
      height: t.height,
      data: t.data.buffer
    } : {
      data: t
    });
  }
  sendMessage(r) {
    return this._queueService.addTask(() => new Promise((t, a) => {
      if (!this._worker)
        return Sr("Worker is missing)"), a("Worker is missing");
      this._worker.onmessage = (o) => {
        if (o.data.target === un.custom) {
          const {
            method: l,
            response: c,
            code: u
          } = o.data.data, p = c && "reject_message" in c ? c.reject_message : "";
          if (u === up.ok || u === up.badLicense && !p)
            Sr("Method ".concat(l, ": { code: ").concat(u, " } ")), t(c);
          else {
            const f = ay[u] || u, h = "Method ".concat(l, ": ").concat(f).concat(p ? " Reject message: ".concat(p) : "");
            Sr(h), a(h);
          }
        }
        o.data.target === un.stdout && cp(JSON.stringify(o.data.content)), o.data.target === un.stderr && (cp(JSON.stringify(o.data.content)), a(o.data.content));
      }, this._worker.onerror = (o) => {
        cp(JSON.stringify(o.message)), a(o);
      }, Sr("Send message to worker: { target: ".concat(r.target, ", method: ").concat(r.method, " }")), this._worker.postMessage(ta(ta({}, r), {}, {
        preMain: !0
      }), "data" in r && r.data ? r.data.map((o) => o.data) : []);
    }));
  }
  prepare(r) {
    return Oe(this, null, function* () {
      var t;
      Sr("Preparing the service");
      {
        const a = this.workerPath === "https://wasm.regulaforensics.com/document/release/8.3/barcodemrz/f526ea12-07843559c", o = Wue(r ? vb(r, "PROD") : this.workerPath);
        let c = yield (yield fetch("".concat(o, "/").concat(iy))).text();
        !a && !r && (c = Ib(c, o));
        const u = new Blob([c], {
          type: "text/plain"
        }), p = URL.createObjectURL(u);
        this._worker = new Worker(p), URL.revokeObjectURL(p);
      }
      (t = this._worker) === null || t === void 0 || t.postMessage({
        method: gn.prepare,
        target: un.gl,
        preMain: !0,
        op: "setPrefetched"
      }), yield this.sendMessage({
        method: gn.prepare,
        target: un.init,
        URL: document.URL
      }), this.isPrepared = !0, Sr("Service prepared");
    });
  }
  initialize(r) {
    return Oe(this, null, function* () {
      return this._initProcess || (this._initProcess = this.doInitialize(r), this._initProcess.catch(() => {
        this._initProcess = null;
      })), this._initProcess;
    });
  }
  doInitialize(r) {
    return Oe(this, null, function* () {
      var t, a;
      this.isPrepared || (yield this.prepare(r == null ? void 0 : r.module)), Sr("Initializing the service");
      const {
        scenario: o,
        license: l
      } = yield this.sendMessage({
        target: un.custom,
        method: gn.initialize,
        request: {
          systemInfo: {
            userID: BR(AR),
            hostName: (t = document.location) === null || t === void 0 ? void 0 : t.origin,
            license: r == null ? void 0 : r.license
          }
        }
      });
      return this.initData = {
        scenario: o,
        license: l
      }, this.isInitialized = !0, (a = this._initializeListener) === null || a === void 0 || a.call(this, {
        isInitialized: this.isInitialized
      }), Sr("Service initialized: ".concat(JSON.stringify({
        scenario: o,
        license: l
      }))), this.initData;
    });
  }
  doProcess(r, t, a) {
    return Oe(this, null, function* () {
      var o, l;
      Sr("Process method ".concat(r, " started")), this.isProcessing = !0, (o = this._processingListener) === null || o === void 0 || o.call(this, {
        isProcessing: this.isProcessing
      });
      const c = yield this.sendMessage({
        target: un.custom,
        method: r,
        request: t,
        data: a
      });
      return this.isProcessing = !1, (l = this._processingListener) === null || l === void 0 || l.call(this, {
        isProcessing: this.isProcessing
      }), Sr("Process method ".concat(r, " finished")), new Np(c);
    });
  }
  processImageBase64(r, t) {
    return Oe(this, null, function* () {
      return this.doProcess(gn.processImage, this.createProcessImageRequest(r, t));
    });
  }
  process(r, t) {
    return Oe(this, null, function* () {
      var a;
      const o = this.prepareImageData(r), l = yield this.doProcess(gn.process, t || this.recognizerProcessParam, o);
      return (a = this.recognizeListener) === null || a === void 0 || a.call(this, l), l;
    });
  }
  processImage(r, t) {
    return Oe(this, null, function* () {
      const a = this.prepareImageData(r);
      return this.doProcess(gn.processImage, t || this.imageProcessParam, a);
    });
  }
  startNewPage() {
    return Oe(this, null, function* () {
      Sr("Starting new page"), yield this.sendMessage({
        target: un.custom,
        method: gn.startNewPage
      });
    });
  }
  startNewDocument(r, t) {
    return Oe(this, null, function* () {
      return Sr("Starting new document"), yield this.sendMessage({
        target: un.custom,
        method: gn.startNewDocument,
        request: ta(ta({}, t || this.recognizerProcessParam), {}, {
          metadata: r
        })
      });
    });
  }
  createBackendTransaction(r, t) {
    return Oe(this, null, function* () {
      return Sr("Create backend transaction"), yield this.sendMessage({
        target: un.custom,
        method: gn.createBackendTransaction,
        request: ta(ta({}, t || this.recognizerProcessParam), {}, {
          metadata: r
        })
      });
    });
  }
  finalizePackage() {
    return Oe(this, null, function* () {
      try {
        var r;
        Sr("Finalize package");
        const a = yield this.sendMessage({
          target: un.custom,
          method: gn.finalizePackage
        });
        return (r = this.onFinalize) === null || r === void 0 || r.call(this, a), a;
      } catch (a) {
        var t;
        return (t = this.onFinalize) === null || t === void 0 || t.call(this, {
          tag: "",
          transactionId: ""
        }), Promise.reject(a);
      }
    });
  }
  addDataToPackage(r, t) {
    return Oe(this, null, function* () {
      Sr("Add data to package"), yield this.sendMessage({
        target: un.custom,
        method: gn.addDataToPackage,
        request: t,
        data: [{
          data: r.buffer
        }]
      }), Sr("Data added to package");
    });
  }
  shutdown() {
    Sr("Shutdown service"), this._worker && (this._worker.terminate(), Sr("Worker terminated")), this.isPrepared = !1, this.isInitialized = !1, this.isProcessing = !1, this._initProcess = null;
  }
}
function cn(e, r, t) {
  return (r = Que(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Que(e) {
  var r = Jue(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Jue(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class S0e {
  constructor(r) {
    cn(this, "_streamData", null), cn(this, "_documentReaderService", new Xue()), cn(this, "_canvas", document.createElement("canvas")), cn(this, "_cameraInfo", null), cn(this, "_sortedDevices", null), cn(this, "_devices", null), cn(this, "_videoEventListener", null), cn(this, "_frameListener", null), cn(this, "_pageIdx", 0), cn(this, "_streamParam", {
      cameraMode: fn.environment,
      preferredCameraId: "",
      resolution: ui.HD
    }), cn(this, "isProcessing", !1), cn(this, "isInitialized", !1), cn(this, "videoElement", null), this.videoElement = r || null, this._documentReaderService.recognizerProcessParam = ly, this._documentReaderService.imageProcessParam = cy;
  }
  get recognizeListener() {
    return this._documentReaderService.recognizeListener;
  }
  set recognizeListener(r) {
    this._documentReaderService.recognizeListener = r;
  }
  get streamParam() {
    return this._streamParam;
  }
  set streamParam(r) {
    this._streamParam = $r(this._streamParam, r);
  }
  get recognizerProcessParam() {
    return this._documentReaderService.recognizerProcessParam;
  }
  set recognizerProcessParam(r) {
    this._documentReaderService.recognizerProcessParam = $r(this._documentReaderService.recognizerProcessParam, r);
  }
  get imageProcessParam() {
    return this._documentReaderService.imageProcessParam;
  }
  set imageProcessParam(r) {
    this._documentReaderService.imageProcessParam = $r(this._documentReaderService.imageProcessParam, r);
  }
  get workerPath() {
    return this._documentReaderService.workerPath;
  }
  set workerPath(r) {
    this._documentReaderService.workerPath = r;
  }
  startStream() {
    return new Promise((r, t) => {
      Oe(this, null, function* () {
        try {
          if (this._devices || (this._devices = yield VR()), this._sortedDevices || (this._sortedDevices = yield kR(this._devices), this._devices.isCameraAllowed = !0), this._cameraInfo = FR(this._streamParam.cameraMode, this._sortedDevices, this._streamParam.preferredCameraId), this._streamData = yield new Promise((o, l) => {
            Oe(this, null, function* () {
              const u = Kt.isFirefox ? RR : 0;
              yield xR(u);
              try {
                if (!this._cameraInfo) return;
                const p = yield UR({
                  width: this._streamParam.resolution.width || ui.HD.width,
                  height: this._streamParam.resolution.height || ui.HD.height
                }, this._cameraInfo, this._streamParam.preferredCameraId);
                o(p);
              } catch (p) {
                l(p);
              }
            });
          }), this._cameraInfo = this._streamData.camera, this._streamData.stream && this.videoElement)
            this.videoElement.srcObject = this._streamData.stream, this._videoEventListener = () => {
              this.videoElement && (this._canvas.width = this.videoElement.videoWidth, this._canvas.height = this.videoElement.videoHeight, r());
            }, this.videoElement.addEventListener("loadeddata", this._videoEventListener);
          else {
            const o = DR[this._streamData.status] || rr.CAMERA_UNKNOWN_ERROR;
            t(new $t(o));
          }
        } catch (o) {
          if (o instanceof Error && o.name === gR)
            return t(new $t(rr.CAMERA_PERMISSION_DENIED, o));
          t(new $t(rr.CAMERA_UNKNOWN_ERROR, o));
        }
      });
    });
  }
  stopStream() {
    var r;
    this._videoEventListener && this.videoElement && (this.videoElement.removeEventListener("play", this._videoEventListener), this._videoEventListener = null), (r = this._streamData) !== null && r !== void 0 && r.stream && (hp(this._streamData.stream), this._streamData = null);
  }
  startRecognizeProcess() {
    return Oe(this, null, function* () {
      for (this.isProcessing = !0; this.isProcessing; ) {
        if (!this.videoElement) return;
        const {
          imageData: r
        } = oc(this.videoElement, ba.UINT), t = yield this._documentReaderService.process(r);
        this._frameListener ? this._frameListener(t) : this.stopRecognizeProcess();
      }
    });
  }
  stopRecognizeProcess() {
    this.isProcessing = !1;
  }
  startNewPage() {
    return Oe(this, null, function* () {
      this._pageIdx++, yield this._documentReaderService.startNewPage();
    });
  }
  startNewDocument() {
    return Oe(this, null, function* () {
      yield this._documentReaderService.startNewDocument();
    });
  }
  switchCamera() {
    return Oe(this, null, function* () {
      this._cameraInfo && (this.stopRecognizeProcess(), this.stopStream(), this._sortedDevices && (this._streamParam.preferredCameraId = ph(this._sortedDevices, this._cameraInfo.deviceId), yield this.startStream(), yield this.startRecognizeProcess()));
    });
  }
  startRecognition(r) {
    return Oe(this, null, function* () {
      return yield this.startNewDocument(), this._streamData || (yield this.startStream()), new Promise((t) => {
        this._frameListener = (a) => {
          const o = $D(a.rawResponse, this._pageIdx, this._documentReaderService.recognizerProcessParam.processParam.multipageProcessing), l = () => {
            this.stopRecognition(), t(a);
          }, c = () => Oe(this, null, function* () {
            yield this.startNewPage(), yield this.startRecognizeProcess();
          });
          if (o === it.START_NEXT_PAGE && r)
            return this.stopRecognizeProcess(), r({
              data: a,
              startNextPage: c,
              finishRecognition: l
            });
          if (ch[o])
            return l();
          if (!this.isProcessing && !this._devices && !this._cameraInfo)
            return t(null);
        }, this.startRecognizeProcess();
      });
    });
  }
  processImage(r) {
    return Oe(this, null, function* () {
      const t = yield BD(r);
      if (t.reduce((o, l) => o + l.width * l.height, 0) > mR)
        return Promise.reject(new $t(rr.FILE_SIZE));
      {
        const o = t.map((l) => {
          let {
            data: c
          } = l;
          return c;
        });
        return yield this._documentReaderService.processImage(o);
      }
    });
  }
  stopRecognition() {
    this._pageIdx = 0, this._cameraInfo = null, this._devices = null, this._sortedDevices = null, this.stopRecognizeProcess(), this.stopStream();
  }
  initialize(r) {
    return Oe(this, null, function* () {
      const t = yield this._documentReaderService.initialize({
        license: r == null ? void 0 : r.license
      });
      return this.isInitialized = this._documentReaderService.isInitialized, t;
    });
  }
  shutdown() {
    this.isProcessing = !1, this.isInitialized = !1, this._documentReaderService.shutdown();
  }
}
function I0e() {
  return Oe(this, null, function* () {
    const e = window.customElements.get("document-reader"), r = window.customElements.get("camera-snapshot"), t = window.customElements.get("fullscreen-container");
    e || window.customElements.define("document-reader", Gce), r || window.customElements.define("camera-snapshot", nue), t || window.customElements.define("fullscreen-container", sue);
    const a = window.customElements.whenDefined("document-reader"), o = window.customElements.whenDefined("camera-snapshot"), l = window.customElements.whenDefined("fullscreen-container");
    yield Promise.all([a, o, l]);
  });
}
export {
  L6 as Authenticity,
  pr as AuthenticityResultType,
  lM as BarCodeModuleType,
  cM as BarcodeType,
  fn as CameraFacingMode,
  ra as CaptureMode,
  uM as CheckDiagnose,
  Mi as CheckResult,
  q1 as Configuration,
  fM as Critical,
  dM as DocumentFormat,
  xD as DocumentReaderApi,
  nue as DocumentReaderCaptureWebComponent,
  S0e as DocumentReaderProcessor,
  Xue as DocumentReaderService,
  Gce as DocumentReaderWebComponent,
  pM as DocumentType,
  hM as DocumentTypeRecognitionResult,
  rr as ErrorTypes,
  pt as EventActions,
  KM as FiberChecks,
  _R as FrameLineCap,
  Ns as FrameShapeType,
  sue as FullScreenContainer,
  _M as GraphicFieldType,
  XM as IdentChecks,
  V2 as ImageQualityCheckType,
  jO as ImageQualityChecks,
  qM as ImagesExt,
  WM as ImagesFieldWrapper,
  mM as InputBarcodeType,
  EM as InputImageQualityChecks,
  ZO as InternalScenarios,
  Dp as LCID,
  Ap as Light,
  CM as LogLevel,
  Gr as Logger,
  _b as LowLvlResponse,
  SM as MRZFormat,
  IM as MeasureSystem,
  dp as MirrorType,
  P2 as ModuleType,
  vM as MrzDetectModeEnum,
  JM as OCRSecurityTextChecks,
  gM as ParsingErrorCodes,
  RM as ParsingNotificationCodes,
  Np as ProcessResult,
  j2 as ProcessingStatus,
  DM as RFIDErrorCodes,
  AM as RFIDPKDResourceType,
  Np as Response,
  Li as ResponseCode,
  An as Result,
  TM as RfidAChip,
  OM as RfidAccessControlProcedureType,
  yM as RfidApplicationType,
  NM as RfidAuthenticationProcedureType,
  LM as RfidBaudRate,
  MM as RfidCertificateOrigin,
  PM as RfidCertificateType,
  bM as RfidDataFileType,
  wM as RfidLocation,
  HM as RfidPasswordType,
  VM as RfidTerminalType,
  kM as RfidType,
  vD as Scenario,
  eP as SecurityFeatureChecks,
  FM as SecurityFeatureType,
  k2 as Source,
  jM as TextExt,
  ZM as TextFieldExt,
  UM as TextFieldType,
  xM as TextPostProcessing,
  x2 as TransactionStateStatus,
  BM as VerificationResult,
  $M as Visibility,
  I0e as defineComponents,
  mb as instanceOfProcessRequest,
  Eb as requestToBaseRequest
};
